import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | undefined | null;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Mixed: { input: any; output: any; }
  Time: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

export enum Accounting_Account_Type {
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  Proforma = 'PROFORMA'
}

export enum Accounting_Centre_Type {
  Expense = 'EXPENSE',
  Invoice = 'INVOICE'
}

export type AccountingAccount = {
  __typename?: 'AccountingAccount';
  account_number: Scalars['String']['output'];
  accounting_type?: Maybe<Accounting_Account_Type>;
  budget_categories?: Maybe<Array<AccountingAccountBudgetCategory>>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AccountingAccountBudgetCategory = {
  __typename?: 'AccountingAccountBudgetCategory';
  accounting_account_id: Scalars['ID']['output'];
  budget_category_id: Scalars['ID']['output'];
  budget_category_type: Scalars['String']['output'];
};

export type AccountingCentre = {
  __typename?: 'AccountingCentre';
  centre: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Accounting_Centre_Type;
};

export type AccountingVatClassification = {
  __typename?: 'AccountingVatClassification';
  centre: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Accounting_Centre_Type;
  vatRate?: Maybe<VatRate>;
  vat_rate_id?: Maybe<Scalars['ID']['output']>;
};

export type AmountToConvert = {
  amount_in_currency: Scalars['BigInt']['input'];
  identifier: Scalars['String']['input'];
  unit_price?: InputMaybe<Scalars['BigInt']['input']>;
};

export type AssignableFile = {
  __typename?: 'AssignableFile';
  created_at: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  mime_type: Scalars['String']['output'];
  model_id?: Maybe<Scalars['ID']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  public_id: Scalars['String']['output'];
  size: Scalars['String']['output'];
  urls: AssignableFileUrlPair;
};

export type AssignableFileUrlPair = {
  __typename?: 'AssignableFileUrlPair';
  original?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  viewable?: Maybe<Scalars['String']['output']>;
};

export type AssignmentArray = {
  brand_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  client_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractor_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AttachedOutgoingProformaInvoicePivot = {
  __typename?: 'AttachedOutgoingProformaInvoicePivot';
  amount_in_currency: Scalars['BigInt']['output'];
  invoice: OutgoingProformaInvoice;
};

export type AttachedProofOfPaymentPivot = {
  __typename?: 'AttachedProofOfPaymentPivot';
  amount_in_currency: Scalars['BigInt']['output'];
  invoice: OutgoingInvoice;
};

export type Attendee = {
  __typename?: 'Attendee';
  timeTrackingWorkType?: Maybe<TimeTrackingWorkType>;
  user: User;
};

export type AutocompleteCompanyData = {
  __typename?: 'AutocompleteCompanyData';
  results: Array<AutocompleteCompanyDataResult>;
  suggestions: Array<Scalars['String']['output']>;
};

export type AutocompleteCompanyDataResult = {
  __typename?: 'AutocompleteCompanyDataResult';
  cancelled: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  national_id?: Maybe<Scalars['String']['output']>;
};

export type Bank = {
  __typename?: 'Bank';
  api_id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
};

export type BankAccountConverter = {
  __typename?: 'BankAccountConverter';
  iban?: Maybe<Scalars['String']['output']>;
};

export type BankAccountMove = {
  __typename?: 'BankAccountMove';
  amount: Scalars['BigInt']['output'];
  balance: Scalars['BigInt']['output'];
  bank_account_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  currency_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  documents?: Maybe<Array<BankAccountMoveDocument>>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ks?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  ss?: Maybe<Scalars['String']['output']>;
  status: BankAccountMoveStatusEnum;
  type: BankAccountMoveTypeEnum;
  vs?: Maybe<Scalars['String']['output']>;
};

export type BankAccountMoveDocument = {
  __typename?: 'BankAccountMoveDocument';
  amount: Scalars['BigInt']['output'];
  amount_in_move_currency: Scalars['BigInt']['output'];
  bankAccountMove?: Maybe<BankAccountMove>;
  bank_account_move_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  document_currency: Currency;
  document_id: Scalars['String']['output'];
  document_no: Scalars['String']['output'];
  document_type: BankDocumentTypeEnum;
  exchange_rate: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
};

export type BankAccountMoveDocumentInput = {
  amount: Scalars['BigInt']['input'];
  amount_in_move_currency: Scalars['BigInt']['input'];
  date: Scalars['Date']['input'];
  document_id: Scalars['ID']['input'];
  document_type: BankDocumentTypeEnum;
  exchange_rate: Scalars['BigInt']['input'];
};

/** A paginated list of BankAccountMove items. */
export type BankAccountMovePaginator = {
  __typename?: 'BankAccountMovePaginator';
  /** A list of BankAccountMove items. */
  data: Array<BankAccountMove>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BankAccountMoveQueryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BankAccountMoveWhereConditions>;
};

export enum BankAccountMoveStatusEnum {
  Excluded = 'EXCLUDED',
  ManualPaired = 'MANUAL_PAIRED',
  NotPaired = 'NOT_PAIRED',
  Paired = 'PAIRED'
}

export type BankAccountMoveToDocumentInput = {
  amount: Scalars['BigInt']['input'];
  amount_in_move_currency: Scalars['BigInt']['input'];
  bank_account_move_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
};

export enum BankAccountMoveTypeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type BankAccountMoveWhereConditions = {
  AND?: InputMaybe<Array<BankAccountMoveWhereConditions>>;
  OR?: InputMaybe<Array<BankAccountMoveWhereConditions>>;
  column?: InputMaybe<BankAccountWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BankAccountSetting = {
  __typename?: 'BankAccountSetting';
  account_holder_name?: Maybe<Scalars['String']['output']>;
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type BankAccountSettingInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  iban: Scalars['String']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export enum BankAccountWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  AmountType = 'AMOUNT_TYPE',
  BankAccountId = 'BANK_ACCOUNT_ID',
  Status = 'STATUS'
}

export enum BankDocumentTypeEnum {
  Expense = 'EXPENSE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE'
}

export type BillingEntity = {
  __typename?: 'BillingEntity';
  applies_vat: Scalars['Boolean']['output'];
  brands: Array<Brand>;
  city: Scalars['String']['output'];
  country: Country;
  created_at: Scalars['DateTime']['output'];
  defaultCurrency: Currency;
  disable_email_notification: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_name: Scalars['String']['output'];
  invoice_email?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  legal_name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  payment_due: Scalars['BigInt']['output'];
  registration_no?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  tax_no?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  workspaceBankAccount?: Maybe<WorkspaceBankAccount>;
  workspaceCompany: WorkspaceCompany;
  zip: Scalars['String']['output'];
};

export type BillingEntityOrderByClause = {
  column: BillingEntityOrderByColumnEnum;
  order: SortOrder;
};

export enum BillingEntityOrderByColumnEnum {
  Id = 'ID'
}

/** A paginated list of BillingEntity items. */
export type BillingEntityPaginator = {
  __typename?: 'BillingEntityPaginator';
  /** A list of BillingEntity items. */
  data: Array<BillingEntity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BillingEntityQueryArgs = {
  orderBy?: InputMaybe<Array<BillingEntityOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BrandsWhereConditions>;
};

export enum BillingItemTypEnum {
  BudgetItem = 'BUDGET_ITEM',
  Category = 'CATEGORY'
}

export type BillingPlanBudget = {
  __typename?: 'BillingPlanBudget';
  billingPlanBudgetItem?: Maybe<Array<BillingPlanBudgetItem>>;
  billing_item_type: BillingItemTypEnum;
  budget_item_id?: Maybe<Scalars['ID']['output']>;
  budget_item_type: BudgetItemTypeEnum;
  category: BillingPlanBudgetItemCategory;
  id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type BillingPlanBudgetCache = {
  __typename?: 'BillingPlanBudgetCache';
  billing_plan_invoice_id?: Maybe<Scalars['ID']['output']>;
  brand: Brand;
  created_at: Scalars['DateTime']['output'];
  date_of_supply: Scalars['Date']['output'];
  due_date: Scalars['Date']['output'];
  email_sent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoice_no?: Maybe<Scalars['String']['output']>;
  invoiced_amount: Scalars['BigInt']['output'];
  issue_date: Scalars['Date']['output'];
  message?: Maybe<Scalars['String']['output']>;
  paid_amount: Scalars['BigInt']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  planned_amount: Scalars['BigInt']['output'];
  project: Project;
  request_for_invoicing_id?: Maybe<Scalars['ID']['output']>;
  status: BillingPlanBudgetCacheStatusEnum;
  type: BillingPlanBudgetItemInvoiceTypeEnum;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of BillingPlanBudgetCache items. */
export type BillingPlanBudgetCachePaginator = {
  __typename?: 'BillingPlanBudgetCachePaginator';
  /** A list of BillingPlanBudgetCache items. */
  data: Array<BillingPlanBudgetCache>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BillingPlanBudgetCacheStatusEnum {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  ManuallyCreated = 'MANUALLY_CREATED',
  Pending = 'PENDING'
}

export type BillingPlanBudgetInvoice = {
  __typename?: 'BillingPlanBudgetInvoice';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  invoice_id: Scalars['ID']['output'];
  invoice_type: BillingPlanBudgetInvoiceTypeEnum;
};

export enum BillingPlanBudgetInvoiceTypeEnum {
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING'
}

export type BillingPlanBudgetItem = {
  __typename?: 'BillingPlanBudgetItem';
  accounting_account_id?: Maybe<Scalars['ID']['output']>;
  accounting_centre_id?: Maybe<Scalars['ID']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  invoice_type?: Maybe<BillingPlanBudgetItemInvoiceTypeEnum>;
  months: Array<BillingPlanMonth>;
};

export type BillingPlanBudgetItemCategory = {
  __typename?: 'BillingPlanBudgetItemCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BillingPlanBudgetItemInput = {
  accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_centre_id?: InputMaybe<Scalars['ID']['input']>;
  billingPlanMonths: Array<BillingPlanMonthInput>;
  day?: InputMaybe<Scalars['Int']['input']>;
  invoice_type?: InputMaybe<BillingPlanBudgetItemInvoiceTypeEnum>;
};

export enum BillingPlanBudgetItemInvoiceTypeEnum {
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING'
}

export type BillingPlanByMonths = {
  __typename?: 'BillingPlanByMonths';
  balance: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  items: Array<BillingPlanItem>;
  period: Scalars['String']['output'];
  planned_amount: Scalars['BigInt']['output'];
  status: BillingPlanMonthStatusEnum;
};

export type BillingPlanCacheOrderByClause = {
  column: BillingPlanCacheOrderByColumnEnum;
  order: SortOrder;
};

export enum BillingPlanCacheOrderByColumnEnum {
  Amount = 'AMOUNT',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  InvoicedAmount = 'INVOICED_AMOUNT',
  IssueDate = 'ISSUE_DATE',
  PaidAt = 'PAID_AT',
  PlannedAmount = 'PLANNED_AMOUNT',
  ProjectTitle = 'PROJECT_TITLE',
  Status = 'STATUS',
  Type = 'TYPE'
}

export type BillingPlanCacheOverviewQueryArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<BillingPlanCacheOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BillingPlanCacheOverviewWhereConditions>;
};

export type BillingPlanCacheOverviewSummary = {
  __typename?: 'BillingPlanCacheOverviewSummary';
  invoiced_amount: Scalars['BigInt']['output'];
  planned_amount: Scalars['BigInt']['output'];
  projects: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
};

export enum BillingPlanCacheOverviewWhereColumn {
  BrandId = 'BRAND_ID',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  IssueDate = 'ISSUE_DATE',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectId = 'PROJECT_ID',
  ProjectMangerId = 'PROJECT_MANGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID',
  Type = 'TYPE'
}

export type BillingPlanCacheOverviewWhereConditions = {
  AND?: InputMaybe<Array<BillingPlanCacheOverviewWhereConditions>>;
  OR?: InputMaybe<Array<BillingPlanCacheOverviewWhereConditions>>;
  column?: InputMaybe<BillingPlanCacheOverviewWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BillingPlanInvoice = {
  __typename?: 'BillingPlanInvoice';
  amount: Scalars['BigInt']['output'];
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  proformaInvoice?: Maybe<OutgoingProformaInvoice>;
};

export type BillingPlanItem = {
  __typename?: 'BillingPlanItem';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type BillingPlanItemInput = {
  amount: Scalars['BigInt']['input'];
  date: Scalars['Date']['input'];
};

export type BillingPlanMonth = {
  __typename?: 'BillingPlanMonth';
  billingPlanInvoice?: Maybe<Array<Maybe<BillingPlanBudgetInvoice>>>;
  date: Scalars['Date']['output'];
  value: Scalars['BigInt']['output'];
};

export type BillingPlanMonthInput = {
  date: Scalars['Date']['input'];
  value: Scalars['BigInt']['input'];
};

export type BillingPlanMonthStat = {
  __typename?: 'BillingPlanMonthStat';
  balance: Scalars['BigInt']['output'];
  current_balance: Scalars['BigInt']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  invoices: Array<BillingPlanInvoice>;
  items: Array<BillingPlanItem>;
  key: Scalars['String']['output'];
  period: Scalars['String']['output'];
  planned_amount: Scalars['BigInt']['output'];
  project: Project;
  status: BillingPlanMonthStatusEnum;
};

/** A paginated list of BillingPlanMonthStat items. */
export type BillingPlanMonthStatPaginator = {
  __typename?: 'BillingPlanMonthStatPaginator';
  /** A list of BillingPlanMonthStat items. */
  data: Array<BillingPlanMonthStat>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BillingPlanMonthStatusEnum {
  Invoiced = 'INVOICED',
  PartiallyInvoiced = 'PARTIALLY_INVOICED',
  Uninvoiced = 'UNINVOICED'
}

export enum BillingPlanNotificationTypeEnum {
  ProjectBudgetChanged = 'PROJECT_BUDGET_CHANGED',
  ProjectDatesChanged = 'PROJECT_DATES_CHANGED'
}

export type BillingPlanNotifications = {
  __typename?: 'BillingPlanNotifications';
  project_budget_changed: Scalars['Boolean']['output'];
  project_dates_changed: Scalars['Boolean']['output'];
};

export type BillingPlanOrderByClause = {
  column: BillingPlanOrderByColumnEnum;
  order: SortOrder;
};

export enum BillingPlanOrderByColumnEnum {
  Balance = 'BALANCE',
  BrandName = 'BRAND_NAME',
  FirstDayOfSupply = 'FIRST_DAY_OF_SUPPLY',
  InvoicedAmount = 'INVOICED_AMOUNT',
  PlannedAmount = 'PLANNED_AMOUNT',
  ProjectTitle = 'PROJECT_TITLE'
}

export type BillingPlanOverviewQueryArgs = {
  month: Scalars['BigInt']['input'];
  orderBy?: InputMaybe<Array<BillingPlanOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BillingPlanOverviewWhereConditions>;
  year: Scalars['BigInt']['input'];
};

export type BillingPlanOverviewSummary = {
  __typename?: 'BillingPlanOverviewSummary';
  invoiced_amount: Scalars['BigInt']['output'];
  planned_amount: Scalars['BigInt']['output'];
  projects: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export enum BillingPlanOverviewWhereColumn {
  BrandId = 'BRAND_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type BillingPlanOverviewWhereConditions = {
  AND?: InputMaybe<Array<BillingPlanOverviewWhereConditions>>;
  OR?: InputMaybe<Array<BillingPlanOverviewWhereConditions>>;
  column?: InputMaybe<BillingPlanOverviewWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BillingPlanStats = {
  __typename?: 'BillingPlanStats';
  current_month_balance: Scalars['BigInt']['output'];
  current_month_invoiced: Scalars['BigInt']['output'];
  current_month_planned: Scalars['BigInt']['output'];
  show_invoice_date_approaching_warning: Scalars['Boolean']['output'];
};

export type BooleanResult = {
  __typename?: 'BooleanResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  calculated_average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  client: Client;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contacts: Array<Contact>;
  contracts?: Maybe<ContractPaginator>;
  created_at: Scalars['DateTime']['output'];
  creditAccounts?: Maybe<Array<BrandCreditAccount>>;
  defaultBillingEntity?: Maybe<BillingEntity>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  externalLinks: Array<ExternalLink>;
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  numeric_code?: Maybe<Scalars['String']['output']>;
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  otherResponsiblePersons: Array<User>;
  pipedriveCustomFieldValues: Array<PipedriveCustomFieldValue>;
  projects: Array<Project>;
  responsiblePerson?: Maybe<User>;
  stats: BrandStats;
  timeTrackingRates: Array<TimeTrackingRate>;
  updated_at: Scalars['DateTime']['output'];
  users: Array<User>;
};


export type BrandContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandProjectsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  proBonoProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandCreditAccount = {
  __typename?: 'BrandCreditAccount';
  brand: Brand;
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  credits: Array<BrandCreditAccountCreditStats>;
  debits: Array<BrandCreditAccountDebitStats>;
  expenseBudgetCategories?: Maybe<Array<ExpenseBudgetCategory>>;
  id: Scalars['ID']['output'];
  ourWorkBudgetCategories?: Maybe<Array<OurWorkBudgetCategory>>;
  stats: BrandCreditAccountStats;
  team: Team;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BrandCreditAccountCreditStats = {
  __typename?: 'BrandCreditAccountCreditStats';
  credit: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  originatesBrandCreditAccount?: Maybe<BrandCreditAccount>;
  outgoingInvoice?: Maybe<OutgoingInvoice>;
};

export type BrandCreditAccountDebitStats = {
  __typename?: 'BrandCreditAccountDebitStats';
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  id: Scalars['ID']['output'];
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
  performed_at: Scalars['Date']['output'];
};

export type BrandCreditAccountOrderByClause = {
  column: BrandCreditAccountOrderByColumnEnum;
  order: SortOrder;
};

export enum BrandCreditAccountOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  Id = 'ID',
  RemainingCredit = 'REMAINING_CREDIT',
  Title = 'TITLE',
  TotalCredit = 'TOTAL_CREDIT',
  TotalDebit = 'TOTAL_DEBIT'
}

/** A paginated list of BrandCreditAccount items. */
export type BrandCreditAccountPaginator = {
  __typename?: 'BrandCreditAccountPaginator';
  /** A list of BrandCreditAccount items. */
  data: Array<BrandCreditAccount>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BrandCreditAccountStats = {
  __typename?: 'BrandCreditAccountStats';
  id: Scalars['ID']['output'];
  remaining_credit: Scalars['BigInt']['output'];
  total_credit: Scalars['BigInt']['output'];
  total_debit: Scalars['BigInt']['output'];
};

export enum BrandCreditAccountStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type BrandCreditAccountsSummary = {
  __typename?: 'BrandCreditAccountsSummary';
  brand_credit_accounts: Scalars['BigInt']['output'];
  remaining_credit: Scalars['BigInt']['output'];
  total_credit: Scalars['BigInt']['output'];
  total_debit: Scalars['BigInt']['output'];
};

export enum BrandCreditAccountsWhereColumn {
  BrandId = 'BRAND_ID',
  CreatedAt = 'CREATED_AT',
  ExpenseBudgetCategoryId = 'EXPENSE_BUDGET_CATEGORY_ID',
  OurWorkBudgetCategoryId = 'OUR_WORK_BUDGET_CATEGORY_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type BrandCreditAccountsWhereConditions = {
  AND?: InputMaybe<Array<BrandCreditAccountsWhereConditions>>;
  OR?: InputMaybe<Array<BrandCreditAccountsWhereConditions>>;
  column?: InputMaybe<BrandCreditAccountsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BrandOrderByClause = {
  column: BrandOrderByColumnEnum;
  order: SortOrder;
};

export enum BrandOrderByColumnEnum {
  ActiveProjects = 'ACTIVE_PROJECTS',
  BrandName = 'BRAND_NAME',
  ClientName = 'CLIENT_NAME'
}

/** A paginated list of Brand items. */
export type BrandPaginator = {
  __typename?: 'BrandPaginator';
  /** A list of Brand items. */
  data: Array<Brand>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BrandQueryArgs = {
  orderBy?: InputMaybe<Array<BrandOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BrandsWhereConditions>;
};

export type BrandRevenue = {
  __typename?: 'BrandRevenue';
  paginatorInfo: PaginatorInfo;
  result: Array<BrandWithRevenueResult>;
};

export enum BrandRevenueGroupByEnum {
  Client = 'CLIENT',
  None = 'NONE'
}

export type BrandRevenueOrderByClause = {
  column: BrandRevenueOrderByColumnEnum;
  order: SortOrder;
};

export enum BrandRevenueOrderByColumnEnum {
  BrandName = 'BRAND_NAME'
}

export type BrandRevenueQueryArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  groupBy: BrandRevenueGroupByEnum;
  orderBy?: InputMaybe<Array<BrandRevenueOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  where?: InputMaybe<BrandRevenueWhereConditions>;
};

export type BrandRevenueShare = {
  __typename?: 'BrandRevenueShare';
  name: Scalars['String']['output'];
  value: Scalars['BigInt']['output'];
};

export type BrandRevenueSummary = {
  __typename?: 'BrandRevenueSummary';
  brand_profit_share?: Maybe<Array<BrandRevenueShare>>;
  brand_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  client_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  expense_revenue_for_date_range: Array<ExpenseRevenueByCategory>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range_percentage: Scalars['BigInt']['output'];
  profit_top_clients?: Maybe<Array<TopClient>>;
  projectIds: Array<Scalars['ID']['output']>;
  projects: Scalars['BigInt']['output'];
  revenue_top_clients?: Maybe<Array<TopClient>>;
  total_invoiced: Scalars['BigInt']['output'];
};

export enum BrandRevenueWhereColumn {
  BrandId = 'BRAND_ID',
  CategoryId = 'CATEGORY_ID',
  ClientId = 'CLIENT_ID',
  ProjectId = 'PROJECT_ID'
}

export type BrandRevenueWhereConditions = {
  AND?: InputMaybe<Array<BrandRevenueWhereConditions>>;
  OR?: InputMaybe<Array<BrandRevenueWhereConditions>>;
  column?: InputMaybe<BrandRevenueWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BrandSimple = {
  __typename?: 'BrandSimple';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  defaultBillingEntity?: Maybe<BillingEntity>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numeric_code?: Maybe<Scalars['String']['output']>;
};

export type BrandStats = {
  __typename?: 'BrandStats';
  active_projects: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
};

export type BrandWithRevenue = {
  __typename?: 'BrandWithRevenue';
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  filtered_profit_share: Scalars['BigInt']['output'];
  filtered_revenue_share: Scalars['BigInt']['output'];
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_profit_share: Scalars['BigInt']['output'];
  total_revenue_share: Scalars['BigInt']['output'];
};

export type BrandWithRevenueResult = {
  __typename?: 'BrandWithRevenueResult';
  brands?: Maybe<Array<BrandWithRevenue>>;
  expensesStructured: Array<ExpenseStructuredBudgetItemWithRevenue>;
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  filtered_profit_share: Scalars['BigInt']['output'];
  filtered_revenue_share: Scalars['BigInt']['output'];
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_profit_share: Scalars['BigInt']['output'];
  total_revenue_share: Scalars['BigInt']['output'];
};

export type BrandsSummary = {
  __typename?: 'BrandsSummary';
  brandIds: Array<Scalars['ID']['output']>;
};

export enum BrandsWhereColumn {
  ClientId = 'CLIENT_ID',
  ContactId = 'CONTACT_ID',
  Id = 'ID',
  ResponsiblePersonUserId = 'RESPONSIBLE_PERSON_USER_ID',
  Status = 'STATUS'
}

export type BrandsWhereConditions = {
  AND?: InputMaybe<Array<BrandsWhereConditions>>;
  OR?: InputMaybe<Array<BrandsWhereConditions>>;
  column?: InputMaybe<BrandsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Budget = {
  __typename?: 'Budget';
  account_manager?: Maybe<Scalars['String']['output']>;
  assignment_date?: Maybe<Scalars['Date']['output']>;
  brand?: Maybe<Brand>;
  client_approved?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internally_approved?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['BigInt']['output']>;
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['ID']['output']>;
  quotes?: Maybe<Array<Quote>>;
  status: BudgetStatusEnum;
  temporaryBrand?: Maybe<TemporaryBrand>;
  temporaryProject?: Maybe<TemporaryProject>;
  temporary_project_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<BudgetTypeEnum>;
  updated_at: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type BudgetArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<Array<BudgetOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  where?: InputMaybe<BudgetWhereConditions>;
};

export type BudgetCategory = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortcut: Scalars['String']['output'];
};

export type BudgetExportOptionsInput = {
  add_billing_plan?: InputMaybe<Scalars['Boolean']['input']>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  billing_plan_exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  disclaimer?: InputMaybe<Array<InputMaybe<BudgetPdfDisclaimerInput>>>;
  expense_show_commission?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_description?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_discount?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_quantity?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_unit?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_vat_in_items?: InputMaybe<Scalars['Boolean']['input']>;
  hide_title_page?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  our_work_description?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_positions?: InputMaybe<BudgetPdfExportOurWorkPositionsEnum>;
  our_work_show_commission?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_show_discount?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_vat_in_items?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_view?: InputMaybe<BudgetPdfExportOurWorkViewEnum>;
  save_for_brand?: InputMaybe<Scalars['Boolean']['input']>;
  save_for_workspace?: InputMaybe<Scalars['Boolean']['input']>;
  show_client_and_brand?: InputMaybe<Scalars['Boolean']['input']>;
  show_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  show_client_name?: InputMaybe<Scalars['Boolean']['input']>;
  show_disclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  show_hours?: InputMaybe<Scalars['Boolean']['input']>;
  show_project_name_full?: InputMaybe<Scalars['Boolean']['input']>;
  show_summary?: InputMaybe<Scalars['Boolean']['input']>;
  show_title_page_with_vat?: InputMaybe<Scalars['Boolean']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
  title_page_with_vat?: InputMaybe<Scalars['Boolean']['input']>;
  use_client_name_from_billing_entity?: InputMaybe<Scalars['Boolean']['input']>;
  valid_until?: InputMaybe<Scalars['Date']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
};

export type BudgetGroup = {
  __typename?: 'BudgetGroup';
  budget_name?: Maybe<Scalars['String']['output']>;
  budget_number?: Maybe<Scalars['ID']['output']>;
  budgets?: Maybe<Array<Maybe<Budget>>>;
  client_id?: Maybe<Scalars['ID']['output']>;
  project_id?: Maybe<Scalars['ID']['output']>;
  temporary_client_id?: Maybe<Scalars['ID']['output']>;
  temporary_project_id?: Maybe<Scalars['ID']['output']>;
};

/** Why a budget item requested for deletion is still kept in the project. */
export enum BudgetItemDeletionBlockerEnum {
  Credit = 'CREDIT',
  ExpenseItems = 'EXPENSE_ITEMS',
  ProformaInvoice = 'PROFORMA_INVOICE',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING',
  Tasks = 'TASKS',
  TimeTracking = 'TIME_TRACKING'
}

export type BudgetItemForExpenseInterface = {
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  payment_status: ExpenseInvoiceStatusEnum;
  project: Project;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BudgetItemInterface = {
  category: BudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount?: Maybe<CreditAccount>;
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  project: Project;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BudgetItemPlannedExpense = {
  __typename?: 'BudgetItemPlannedExpense';
  budget_item_id: Scalars['ID']['output'];
  budget_item_type: Scalars['String']['output'];
  budgeted_amount: Scalars['BigInt']['output'];
  client_amount: Scalars['BigInt']['output'];
  contractor?: Maybe<Contractor>;
  created_at: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  usedExpenses: Array<BudgetItemPlannedExpenseUsed>;
};

export type BudgetItemPlannedExpenseInput = {
  budgeted_amount: Scalars['BigInt']['input'];
  client_amount: Scalars['BigInt']['input'];
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BudgetItemPlannedExpenseUsed = {
  __typename?: 'BudgetItemPlannedExpenseUsed';
  created_at: Scalars['DateTime']['output'];
  expenseItem: ExpenseItem;
  id: Scalars['ID']['output'];
  plannedExpense: BudgetItemPlannedExpense;
  updated_at: Scalars['DateTime']['output'];
  used_amount: Scalars['BigInt']['output'];
};

export enum BudgetItemTypeEnum {
  ExpenseBudgetItem = 'EXPENSE_BUDGET_ITEM',
  OurWorkBudgetItem = 'OUR_WORK_BUDGET_ITEM'
}

export type BudgetOrderByClause = {
  column: BudgetOrderByColumnEnum;
  order: SortOrder;
};

export enum BudgetOrderByColumnEnum {
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT'
}

export type BudgetPaginator = {
  __typename?: 'BudgetPaginator';
  allIds: Array<Scalars['Int']['output']>;
  data?: Maybe<Array<BudgetGroup>>;
  paginatorInfo: PaginatorInfo;
};

export type BudgetPdfDisclaimer = {
  __typename?: 'BudgetPdfDisclaimer';
  disclaimer?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type BudgetPdfDisclaimerInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export enum BudgetPdfExportOurWorkPositionsEnum {
  Columns = 'COLUMNS',
  Hide = 'HIDE',
  Rows = 'ROWS'
}

export enum BudgetPdfExportOurWorkViewEnum {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type BudgetPdfSettings = {
  __typename?: 'BudgetPdfSettings';
  add_billing_plan?: Maybe<Scalars['Boolean']['output']>;
  billing_entity_id?: Maybe<Scalars['ID']['output']>;
  billing_plan_exchange_rate?: Maybe<Scalars['BigInt']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  disclaimer?: Maybe<Array<Maybe<BudgetPdfDisclaimer>>>;
  expense_show_commission?: Maybe<Scalars['Boolean']['output']>;
  expense_show_description?: Maybe<Scalars['Boolean']['output']>;
  expense_show_discount?: Maybe<Scalars['Boolean']['output']>;
  expense_show_quantity?: Maybe<Scalars['Boolean']['output']>;
  expense_show_unit?: Maybe<Scalars['Boolean']['output']>;
  expense_show_vat_in_items?: Maybe<Scalars['Boolean']['output']>;
  hide_title_page?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  our_work_description?: Maybe<Scalars['Boolean']['output']>;
  our_work_positions?: Maybe<BudgetPdfExportOurWorkPositionsEnum>;
  our_work_show_commission?: Maybe<Scalars['Boolean']['output']>;
  our_work_show_discount?: Maybe<Scalars['Boolean']['output']>;
  our_work_vat_in_items?: Maybe<Scalars['Boolean']['output']>;
  our_work_view?: Maybe<BudgetPdfExportOurWorkViewEnum>;
  show_client_and_brand?: Maybe<Scalars['Boolean']['output']>;
  show_client_details?: Maybe<Scalars['Boolean']['output']>;
  show_client_name?: Maybe<Scalars['Boolean']['output']>;
  show_disclaimer?: Maybe<Scalars['Boolean']['output']>;
  show_hours?: Maybe<Scalars['Boolean']['output']>;
  show_project_name_full?: Maybe<Scalars['Boolean']['output']>;
  show_summary?: Maybe<Scalars['Boolean']['output']>;
  signature?: Maybe<Scalars['Boolean']['output']>;
  title_page_with_vat?: Maybe<Scalars['Boolean']['output']>;
  use_client_name_from_billing_entity?: Maybe<Scalars['Boolean']['output']>;
  valid_until?: Maybe<Scalars['Date']['output']>;
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id: Scalars['ID']['output'];
};

export type BudgetPosition = {
  __typename?: 'BudgetPosition';
  budgeted_amount?: Maybe<Scalars['BigInt']['output']>;
  budgeted_time?: Maybe<Scalars['BigInt']['output']>;
  invoiced_amount?: Maybe<Scalars['BigInt']['output']>;
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  time_tracking_work_type_id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  total_invoiced_amount?: Maybe<Scalars['BigInt']['output']>;
  total_invoiced_time?: Maybe<Scalars['BigInt']['output']>;
  tracked_amount?: Maybe<Scalars['BigInt']['output']>;
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
  uninvoiced_amount?: Maybe<Scalars['BigInt']['output']>;
  uninvoiced_time?: Maybe<Scalars['BigInt']['output']>;
  unit_amount?: Maybe<Scalars['BigInt']['output']>;
};

export type BudgetPositionsInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  unit_amount?: InputMaybe<Scalars['BigInt']['input']>;
};

export enum BudgetStatusEnum {
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  Draft = 'DRAFT',
  Final = 'FINAL',
  SentToClient = 'SENT_TO_CLIENT'
}

export enum BudgetTypeEnum {
  ActiveAssigned = 'ACTIVE_ASSIGNED',
  Archived = 'ARCHIVED',
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export enum BudgetWhereColumn {
  AccountManager = 'ACCOUNT_MANAGER',
  BrandId = 'BRAND_ID',
  ClientApproved = 'CLIENT_APPROVED',
  Date = 'DATE',
  InternallyApproved = 'INTERNALLY_APPROVED',
  ProjectId = 'PROJECT_ID',
  Type = 'TYPE'
}

export type BudgetWhereConditions = {
  AND?: InputMaybe<Array<BudgetWhereConditions>>;
  OR?: InputMaybe<Array<BudgetWhereConditions>>;
  column?: InputMaybe<BudgetWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BudgetovacBrandPositionsSet = {
  __typename?: 'BudgetovacBrandPositionsSet';
  brand?: Maybe<Brand>;
  budgetovacPositionSets: Array<BudgetovacPositionsSet>;
  client_id?: Maybe<Scalars['ID']['output']>;
};

export type BudgetovacPosition = {
  __typename?: 'BudgetovacPosition';
  alias: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  department_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type BudgetovacPositionPrice = {
  __typename?: 'BudgetovacPositionPrice';
  alias: Scalars['String']['output'];
  department_id?: Maybe<Scalars['ID']['output']>;
  department_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position_id: Scalars['ID']['output'];
  price: Scalars['String']['output'];
};

export type BudgetovacPositionPriceInput = {
  alias: Scalars['String']['input'];
  department_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  position_id: Scalars['ID']['input'];
  price: Scalars['String']['input'];
};

export type BudgetovacPositionsSet = {
  __typename?: 'BudgetovacPositionsSet';
  active: Scalars['Boolean']['output'];
  client_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency_code: Scalars['String']['output'];
  external_production_commission?: Maybe<Scalars['Float']['output']>;
  extras_commission?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  internal_production_commission?: Maybe<Scalars['Float']['output']>;
  media_budget_commission?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  positions_prices: Array<BudgetovacPositionPrice>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type BulkActionResponse = {
  __typename?: 'BulkActionResponse';
  failed: Scalars['BigInt']['output'];
  successful: Scalars['BigInt']['output'];
  total: Scalars['BigInt']['output'];
};

export type BulkEditTaskInput = {
  add_task_positions?: InputMaybe<Array<TaskPositionInput>>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  delete_old_positions: Scalars['Boolean']['input'];
  description?: InputMaybe<TaskDescriptionInput>;
  from?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  parent_task_id?: InputMaybe<Scalars['ID']['input']>;
  position_mapping?: InputMaybe<Array<PositionMappingInput>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type BulkUpdateProjectsInput = {
  scopes?: InputMaybe<Array<UserScopeEnum>>;
};

export enum BusinessFormEnum {
  Company = 'COMPANY',
  Person = 'PERSON'
}

export type CalendarEventParticipant = {
  __typename?: 'CalendarEventParticipant';
  display_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response_status?: Maybe<Scalars['String']['output']>;
};

export enum CalendarSyncDirectionEnum {
  Bidirectional = 'BIDIRECTIONAL',
  FromCalendar = 'FROM_CALENDAR',
  ToCalendar = 'TO_CALENDAR'
}

export enum CalendarTypeEnum {
  Google = 'GOOGLE',
  Outlook = 'OUTLOOK'
}

export type CapacityAllocation = {
  __typename?: 'CapacityAllocation';
  attendees: Array<Attendee>;
  calendarParticipants: Array<CalendarEventParticipant>;
  capacityAllocationItems: Array<CapacityAllocationItem>;
  create_task_positions: Scalars['Boolean']['output'];
  createdBy: User;
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['Date']['output']>;
  deadline_time?: Maybe<Scalars['Time']['output']>;
  deleted_items: Scalars['Boolean']['output'];
  from_date: Scalars['Date']['output'];
  from_time?: Maybe<Scalars['Time']['output']>;
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  repetition_settings?: Maybe<RepetitionSettings>;
  task?: Maybe<Task>;
  teams?: Maybe<Array<TeamAttendee>>;
  timeOffType?: Maybe<TimeOffType>;
  time_off_duration_type?: Maybe<TimeOffDurationTypeEnum>;
  title?: Maybe<Scalars['String']['output']>;
  to_date: Scalars['Date']['output'];
  to_time?: Maybe<Scalars['Time']['output']>;
  total_time: Scalars['BigInt']['output'];
  total_time_per_day?: Maybe<Scalars['BigInt']['output']>;
  type: CapacityAllocationTypeEnum;
};

export type CapacityAllocationAttendee = {
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type CapacityAllocationItem = {
  __typename?: 'CapacityAllocationItem';
  capacityAllocation: CapacityAllocation;
  completed: Scalars['Boolean']['output'];
  createdBy: User;
  date: Scalars['Date']['output'];
  duration_changed: Scalars['Boolean']['output'];
  eventLink?: Maybe<Scalars['String']['output']>;
  from_time?: Maybe<Scalars['Time']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  meetLink?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /**
   * Aggregates over the whole capacity allocation series this item belongs to.
   * Replaces fetching capacityAllocation.capacityAllocationItems just to reduce over it.
   */
  seriesSummary: CapacityAllocationSeriesSummary;
  stats?: Maybe<CapacityAllocationItemStats>;
  teams?: Maybe<Array<TeamAttendee>>;
  timeOffType?: Maybe<TimeOffType>;
  timeTrackingWorkType?: Maybe<TimeTrackingWorkType>;
  time_off_duration_type?: Maybe<TimeOffDurationTypeEnum>;
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  to_time?: Maybe<Scalars['Time']['output']>;
  total_time: Scalars['BigInt']['output'];
  type: CapacityAllocationTypeEnum;
  user: User;
  userItems: Array<CapacityAllocationItem>;
  userStats?: Maybe<CapacityAllocationUserItemStats>;
};


export type CapacityAllocationItemSeriesSummaryArgs = {
  today: Scalars['Date']['input'];
};

export type CapacityAllocationItemStats = {
  __typename?: 'CapacityAllocationItemStats';
  brand_id?: Maybe<Scalars['ID']['output']>;
  capacity_allocation_created_by_id?: Maybe<Scalars['ID']['output']>;
  capacity_allocation_id: Scalars['ID']['output'];
  capacity_allocation_item_id: Scalars['ID']['output'];
  client_id?: Maybe<Scalars['ID']['output']>;
  create_task_positions?: Maybe<Scalars['Boolean']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  deadline_time?: Maybe<Scalars['Time']['output']>;
  items_count: Scalars['Int']['output'];
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  our_work_budget_item_title?: Maybe<Scalars['String']['output']>;
  project_code?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['ID']['output']>;
  project_title?: Maybe<Scalars['String']['output']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  task_id?: Maybe<Scalars['ID']['output']>;
  task_name?: Maybe<Scalars['String']['output']>;
  task_status_background_color?: Maybe<Scalars['String']['output']>;
  task_status_foreground_color?: Maybe<Scalars['String']['output']>;
  task_status_id?: Maybe<Scalars['ID']['output']>;
  task_status_name?: Maybe<Scalars['String']['output']>;
  task_status_system_status?: Maybe<TaskSystemStatusEnum>;
  time_off_type_affects_planning_capacity?: Maybe<Scalars['Boolean']['output']>;
  time_off_type_id?: Maybe<Scalars['ID']['output']>;
  time_off_type_name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tracking_enabled?: Maybe<Scalars['Boolean']['output']>;
  tracking_enabled_from?: Maybe<Scalars['Date']['output']>;
  tracking_enabled_to?: Maybe<Scalars['Date']['output']>;
};

export type CapacityAllocationRepetitionSettings = {
  days?: InputMaybe<Array<InputMaybe<RepetitionSettingsDaysEnum>>>;
  end: Scalars['Date']['input'];
  every: Scalars['Int']['input'];
  include_holidays?: InputMaybe<Scalars['Boolean']['input']>;
  startType?: InputMaybe<TimeOffDurationTypeEnum>;
  toType?: InputMaybe<TimeOffDurationTypeEnum>;
};

export enum CapacityAllocationRepetitionTypeEnum {
  Custom = 'CUSTOM',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CapacityAllocationSeriesSummary = {
  __typename?: 'CapacityAllocationSeriesSummary';
  /** Any item in the series has duration_changed = true. */
  any_duration_changed: Scalars['Boolean']['output'];
  /**
   * Per user, the count of completed items from today onwards.
   * Users with a count of zero are omitted.
   */
  futureCompletedPerUser: Array<CapacityAllocationUserCompletedCount>;
  /** SUM(total_time) of items from today onwards that are not completed. */
  future_open_total_time: Scalars['BigInt']['output'];
  /**
   * COUNT of items on the opened item's date that are not completed.
   * Not filtered by today - the caller keeps that guard.
   */
  same_day_open_count: Scalars['Int']['output'];
  /**
   * SUM(total_time) of items on the opened item's date that are not completed.
   * Not filtered by today - the caller keeps that guard.
   */
  same_day_open_total_time: Scalars['BigInt']['output'];
};

export enum CapacityAllocationTypeEnum {
  HomeOffice = 'HOME_OFFICE',
  Imported = 'IMPORTED',
  Meeting = 'MEETING',
  Task = 'TASK',
  TimeOff = 'TIME_OFF',
  WeekendWork = 'WEEKEND_WORK'
}

export type CapacityAllocationUserCompletedCount = {
  __typename?: 'CapacityAllocationUserCompletedCount';
  count: Scalars['Int']['output'];
  user_id: Scalars['ID']['output'];
};

export type CapacityAllocationUserItemStats = {
  __typename?: 'CapacityAllocationUserItemStats';
  capacity_allocation_item_id: Scalars['ID']['output'];
  has_running_timer: Scalars['Boolean']['output'];
  tracked_time_for_item?: Maybe<Scalars['BigInt']['output']>;
};

export enum CapacityAllocationWorkStatus {
  TimeOff = 'TIME_OFF',
  Unavailable = 'UNAVAILABLE',
  WithoutCapacity = 'WITHOUT_CAPACITY',
  Working = 'WORKING'
}

export type Client = {
  __typename?: 'Client';
  billingEntities: Array<BillingEntity>;
  brands: Array<Brand>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  contracts?: Maybe<ContractPaginator>;
  created_at: Scalars['DateTime']['output'];
  currencyExchangeRates: Array<CurrencyExchangeRate>;
  currencyExchangeRatesStructured: Array<CurrencyExchangeRateStructured>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  otherResponsiblePersons: Array<User>;
  responsiblePerson?: Maybe<User>;
  updated_at: Scalars['DateTime']['output'];
  workspaceCompany: WorkspaceCompany;
};


export type ClientBrandsArgs = {
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientCurrencyExchangeRatesArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientOrderByClause = {
  column: ClientOrderByColumnEnum;
  order: SortOrder;
};

export enum ClientOrderByColumnEnum {
  ClientName = 'CLIENT_NAME'
}

/** A paginated list of Client items. */
export type ClientPaginator = {
  __typename?: 'ClientPaginator';
  /** A list of Client items. */
  data: Array<Client>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClientQueryArgs = {
  orderBy?: InputMaybe<Array<ClientOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ClientsWhereConditions>;
};

export type ClientSimple = {
  __typename?: 'ClientSimple';
  brands: Array<BrandSimple>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


export type ClientSimpleBrandsArgs = {
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClientsWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContactId = 'CONTACT_ID',
  ResponsiblePersonUserId = 'RESPONSIBLE_PERSON_USER_ID'
}

export type ClientsWhereConditions = {
  AND?: InputMaybe<Array<ClientsWhereConditions>>;
  OR?: InputMaybe<Array<ClientsWhereConditions>>;
  column?: InputMaybe<ClientsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum CommissionUnit {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export type CompanyBankAccount = {
  __typename?: 'CompanyBankAccount';
  iban?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
};

export type CompanyData = {
  __typename?: 'CompanyData';
  applies_vat: Scalars['Boolean']['output'];
  bankAccounts: Array<CompanyBankAccount>;
  cancelled: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  legal_name?: Maybe<Scalars['String']['output']>;
  registration_no?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  city: Scalars['String']['output'];
  country_id: Scalars['BigInt']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  title: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type CompleteCapacityAllocationUserInput = {
  complete: Scalars['Boolean']['input'];
  existingTimeTrackingItems?: InputMaybe<Array<UpdateTimeTrackingItemInput>>;
  id: Scalars['ID']['input'];
  newTimeTrackingItem?: InputMaybe<CreateTimeTrackingItemInput>;
};

export type ConnectToMcpInput = {
  token: Scalars['String']['input'];
};

export type ConnectToMcpPayload = {
  __typename?: 'ConnectToMcpPayload';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveCustomFieldValues: Array<PipedriveCustomFieldValue>;
  updated_at: Scalars['DateTime']['output'];
};

export type Contract = Document & {
  __typename?: 'Contract';
  brands?: Maybe<Array<Maybe<Brand>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  contractors?: Maybe<Array<Maybe<Contractor>>>;
  created_at: Scalars['DateTime']['output'];
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  title: Scalars['String']['output'];
  type: ContractTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  urls: MediaUrlList;
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type ContractOrderByClause = {
  column: ContractOrderByColumnEnum;
  order: SortOrder;
};

export enum ContractOrderByColumnEnum {
  Title = 'TITLE',
  ValidFrom = 'VALID_FROM',
  ValidTo = 'VALID_TO'
}

/** A paginated list of Contract items. */
export type ContractPaginator = {
  __typename?: 'ContractPaginator';
  /** A list of Contract items. */
  data: Array<Contract>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContractQueryArgs = {
  orderBy?: InputMaybe<Array<ContractOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContractsWhereConditions>;
};

export type ContractSimple = {
  __typename?: 'ContractSimple';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum ContractTypeEnum {
  CopyrightTreaty = 'COPYRIGHT_TREATY',
  MasterAgreement = 'MASTER_AGREEMENT',
  Nda = 'NDA',
  Other = 'OTHER',
  WorksContract = 'WORKS_CONTRACT'
}

export type Contractor = {
  __typename?: 'Contractor';
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_account_code?: Maybe<Scalars['String']['output']>;
  business_form?: Maybe<BusinessFormEnum>;
  city?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<ContractPaginator>;
  contractsNonPaginated?: Maybe<Array<Contract>>;
  country?: Maybe<Country>;
  created_at: Scalars['DateTime']['output'];
  defaultAccountingAccount?: Maybe<AccountingAccount>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_vat_payer?: Maybe<Scalars['Boolean']['output']>;
  legal_name: Scalars['String']['output'];
  national_id?: Maybe<Scalars['String']['output']>;
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  registration_no?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type ContractorContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ContractorOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractorBasic = {
  __typename?: 'ContractorBasic';
  id: Scalars['ID']['output'];
  legal_name: Scalars['String']['output'];
};

export type ContractorBasicQueryArgs = {
  orderBy?: InputMaybe<Array<ContractorOrderByClause>>;
  search: Scalars['String']['input'];
};

export type ContractorOrderByClause = {
  column: ContractorOrderByColumnEnum;
  order: SortOrder;
};

export enum ContractorOrderByColumnEnum {
  Iban = 'IBAN',
  Id = 'ID',
  IsVatPayer = 'IS_VAT_PAYER',
  LegalName = 'LEGAL_NAME',
  RegistrationNo = 'REGISTRATION_NO'
}

/** A paginated list of Contractor items. */
export type ContractorPaginator = {
  __typename?: 'ContractorPaginator';
  /** A list of Contractor items. */
  data: Array<Contractor>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContractorQueryArgs = {
  orderBy?: InputMaybe<Array<ContractorOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContractorsWhereConditions>;
};

export type ContractorSimple = {
  __typename?: 'ContractorSimple';
  id: Scalars['ID']['output'];
  legal_name: Scalars['String']['output'];
};

export type ContractorsBasic = {
  __typename?: 'ContractorsBasic';
  contractorsList: Array<ContractorBasic>;
};

export type ContractorsSummary = {
  __typename?: 'ContractorsSummary';
  contractorIds: Array<Scalars['ID']['output']>;
};

export enum ContractorsWhereColumn {
  IsVatPayer = 'IS_VAT_PAYER'
}

export type ContractorsWhereConditions = {
  AND?: InputMaybe<Array<ContractorsWhereConditions>>;
  OR?: InputMaybe<Array<ContractorsWhereConditions>>;
  column?: InputMaybe<ContractorsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ContractsSummary = {
  __typename?: 'ContractsSummary';
  contractIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum ContractsWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  ProjectId = 'PROJECT_ID',
  Type = 'TYPE',
  ValidFrom = 'VALID_FROM',
  ValidTo = 'VALID_TO'
}

export type ContractsWhereConditions = {
  AND?: InputMaybe<Array<ContractsWhereConditions>>;
  OR?: InputMaybe<Array<ContractsWhereConditions>>;
  column?: InputMaybe<ContractsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ConvertedAmount = {
  __typename?: 'ConvertedAmount';
  amount: Scalars['BigInt']['output'];
  exchange_rate: Scalars['BigInt']['output'];
};

export type ConvertedAmountWithIdentifier = {
  __typename?: 'ConvertedAmountWithIdentifier';
  amount: Scalars['BigInt']['output'];
  identifier: Scalars['String']['output'];
  unit_price?: Maybe<Scalars['BigInt']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CountrySimple = {
  __typename?: 'CountrySimple';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CreateBillingEntityInput = {
  applies_vat: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  client_id: Scalars['ID']['input'];
  country_id: Scalars['ID']['input'];
  default_currency_id: Scalars['ID']['input'];
  disable_email_notification: Scalars['Boolean']['input'];
  internal_name: Scalars['String']['input'];
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  legal_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  payment_due?: InputMaybe<Scalars['BigInt']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  zip: Scalars['String']['input'];
};

export type CreateBrandCreditAccountInput = {
  brand_id: Scalars['ID']['input'];
  expense_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  our_work_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateBrandInput = {
  client_id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  default_billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  numeric_code?: InputMaybe<Scalars['String']['input']>;
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBudgetItemPlannedExpensesInput = {
  budget_item_id: Scalars['ID']['input'];
  budget_item_type: ExpenseBudgetItemTypeEnum;
  planned_expenses: Array<BudgetItemPlannedExpenseInput>;
};

export type CreateBudgetovacPositionInput = {
  department_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateBudgetovacPositionsSetInput = {
  active: Scalars['Boolean']['input'];
  client_id?: InputMaybe<Scalars['Int']['input']>;
  currency_code: Scalars['String']['input'];
  external_production_commission?: InputMaybe<Scalars['Float']['input']>;
  extras_commission?: InputMaybe<Scalars['Float']['input']>;
  internal_production_commission?: InputMaybe<Scalars['Float']['input']>;
  media_budget_commission?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  positions_prices: Array<BudgetovacPositionPriceInput>;
};

export type CreateCapacityAllocationInput = {
  attendees?: InputMaybe<Array<CapacityAllocationAttendee>>;
  create_task_positions: Scalars['Boolean']['input'];
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  deadline_time?: InputMaybe<Scalars['Time']['input']>;
  from_date: Scalars['Date']['input'];
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  repetition_settings?: InputMaybe<CapacityAllocationRepetitionSettings>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['Date']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  total_time_per_day?: InputMaybe<Scalars['BigInt']['input']>;
  type: CapacityAllocationTypeEnum;
};

export type CreateClientInput = {
  name: Scalars['String']['input'];
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
};

export type CreateContactInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title: Scalars['String']['input'];
  type: ContractTypeEnum;
  valid_from: Scalars['Date']['input'];
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateContractorInput = {
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  legal_name: Scalars['String']['input'];
  national_id?: InputMaybe<Scalars['String']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCurrencyExchangeRateInput = {
  client_id: Scalars['ID']['input'];
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateEmailTemplateInput = {
  content: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  type: EmailTemplateTypeEnum;
};

export type CreateExchangeRateSettingsInput = {
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateExpenseInput = {
  amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  constant_symbol?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  document_number?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  expense_items?: InputMaybe<Array<ExpenseItemInput>>;
  expense_no?: InputMaybe<Scalars['String']['input']>;
  expense_vat_items?: InputMaybe<Array<ExpenseVatItemInput>>;
  files?: InputMaybe<Array<FileInput>>;
  fond_contractor_id?: InputMaybe<Scalars['ID']['input']>;
  for_approval: Scalars['Boolean']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id?: InputMaybe<Scalars['ID']['input']>;
  is_draft: Scalars['Boolean']['input'];
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  national_id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['Date']['input']>;
  payment_type_id?: InputMaybe<Scalars['ID']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  /** IDs of related expenses to link (bidirectional relationship) */
  related_expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  specific_symbol?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  total_amount_includes_vat?: InputMaybe<Scalars['Boolean']['input']>;
  total_amount_with_vat_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  type: ExpenseTypeEnum;
  user_created_date: Scalars['Date']['input'];
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigInt']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalLinkInput = {
  link: Scalars['String']['input'];
  model_id: Scalars['ID']['input'];
  model_type: ExternalLinkType;
  title: Scalars['String']['input'];
};

export type CreateGlobalCreditAccountInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateInvoiceFromBillingPlanInput = {
  issue_date: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
};

export type CreateOrderInput = {
  brand_id: Scalars['ID']['input'];
  date_of_order?: InputMaybe<Scalars['Date']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  purchase_order_no: Scalars['String']['input'];
};

export type CreateOtherDocumentInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title: Scalars['String']['input'];
};

export type CreateProjectFromPipedriveInput = {
  creator_user_id: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  org_id: Scalars['Int']['input'];
  person_id: Scalars['Int']['input'];
  stage_id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateProjectFromTemplateInput = {
  billable: Scalars['Boolean']['input'];
  brand_id: Scalars['ID']['input'];
  category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  other_project_manager_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_manager_id: Scalars['ID']['input'];
  rate_card_exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  rate_card_id?: InputMaybe<Scalars['ID']['input']>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  start_date: Scalars['Date']['input'];
  team_id: Scalars['ID']['input'];
  template_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: ProjectTypeEnum;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProjectInput = {
  billable: Scalars['Boolean']['input'];
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  budget_id?: InputMaybe<Scalars['ID']['input']>;
  category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  is_template: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  other_project_manager_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_manager_id: Scalars['ID']['input'];
  rate_card_exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  rate_card_id?: InputMaybe<Scalars['ID']['input']>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  start_date: Scalars['Date']['input'];
  team_id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: ProjectTypeEnum;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input pre vytvorenie Time Billing */
export type CreateProjectTimeBillingInput = {
  components?: InputMaybe<Array<TimeBillingComponentInput>>;
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  final_total_amount?: InputMaybe<Scalars['BigInt']['input']>;
  final_total_note?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['ID']['input'];
  source_ids?: InputMaybe<Array<TimeBillingSourceInput>>;
  timeTrackingItemIds: Array<Scalars['BigInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_rows?: InputMaybe<Array<TimeBillingUserRowInput>>;
};

export type CreateRequestForInvoicingInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  brand_ids: Array<Scalars['ID']['input']>;
  client_id: Scalars['ID']['input'];
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  credit_note_outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits: Array<ExpenseBudgetSplitInput>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_ids: Array<Scalars['ID']['input']>;
  our_work_budget_splits: Array<OurWorkBudgetSplitInput>;
  outgoing_proforma_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits: Array<PrepaymentSplitInput>;
  project_ids: Array<Scalars['ID']['input']>;
  proof_of_payments_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  status: RequestForInvoicingStatusEnum;
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  timeMaterialsInvoiceData?: InputMaybe<TimeMaterialsInputData>;
  total_in_words?: InputMaybe<Scalars['String']['input']>;
  type: RequestForInvoicingTypeEnum;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type CreateScopedTaskInput = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateScopedUserInput = {
  brands: Array<Scalars['ID']['input']>;
  codename?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['Upload']['input']>;
  scope: UserScopeEnum;
  scope_access: UserScopeAccessEnum;
  tasks: Array<Scalars['ID']['input']>;
};

export type CreateSequenceInput = {
  format: Scalars['BigInt']['input'];
  types: Array<SequenceTypesEnum>;
};

export type CreateTaskCommentInput = {
  body: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  in_reply_to_id?: InputMaybe<Scalars['ID']['input']>;
  mentioned_assignees?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<UserScopeEnum>;
  task_id: Scalars['ID']['input'];
};

export type CreateTaskInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  create_capacity_allocations?: InputMaybe<Scalars['Boolean']['input']>;
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  days_to_deadline?: InputMaybe<Scalars['Int']['input']>;
  days_to_from?: InputMaybe<Scalars['Int']['input']>;
  days_to_to?: InputMaybe<Scalars['Int']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  default_planned_time?: InputMaybe<Scalars['BigInt']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  is_template: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  positions?: InputMaybe<Array<TaskPositionInput>>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
  task_template_group_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateTimeTrackingItemInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};

export type CreateTimeTrackingWorkTypeInput = {
  alias: Scalars['String']['input'];
  default_rate: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreateUpdateExpenseContractorInput = {
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractor_id: Scalars['ID']['input'];
  country_id?: InputMaybe<Scalars['ID']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  expense_id?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  national_id?: InputMaybe<Scalars['String']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  codename?: InputMaybe<Scalars['String']['input']>;
  default_work_type_id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  hex_color: Scalars['String']['input'];
  internal_hourly_rate: Scalars['BigInt']['input'];
  last_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  plannable: Scalars['Boolean']['input'];
  plannable_capacity: Scalars['BigInt']['input'];
  role_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  show_in_utilization: Scalars['Boolean']['input'];
  team_id: Scalars['ID']['input'];
};

export type CreateVatRateInput = {
  amount: Scalars['BigInt']['input'];
  type: VatRateTypeEnum;
};

export type CreateWorkspaceSmtpSettingsInput = {
  active?: Scalars['Boolean']['input'];
  smtp_encryption?: InputMaybe<Scalars['String']['input']>;
  smtp_from_address?: InputMaybe<Scalars['String']['input']>;
  smtp_from_name?: InputMaybe<Scalars['String']['input']>;
  smtp_host?: InputMaybe<Scalars['String']['input']>;
  smtp_password?: InputMaybe<Scalars['String']['input']>;
  smtp_port?: InputMaybe<Scalars['Int']['input']>;
  smtp_username?: InputMaybe<Scalars['String']['input']>;
};

export type CreditAccount = {
  __typename?: 'CreditAccount';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  team?: Maybe<Team>;
  updated_at: Scalars['DateTime']['output'];
};

export type CreditAccountQueryArgs = {
  orderBy?: InputMaybe<Array<BrandCreditAccountOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BrandCreditAccountsWhereConditions>;
};

export type CreditStats = {
  credit: Scalars['BigInt']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  denomination: Scalars['BigInt']['output'];
  exchange_rate?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
};

export type CurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  exchange_rate: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  valid_from?: Maybe<Scalars['Date']['output']>;
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type CurrencyExchangeRateStructured = {
  __typename?: 'CurrencyExchangeRateStructured';
  currency: Currency;
  exchangeRates: Array<CurrencyExchangeRate>;
};

export type CurrencyInput = {
  code: Scalars['String']['input'];
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
};

export type DateIntegerDataPoint = {
  __typename?: 'DateIntegerDataPoint';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
};

export type DateRange = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DefaultCurrency = {
  __typename?: 'DefaultCurrency';
  code: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type DeleteCapacityAllocationForDayInput = {
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteCapacityAllocationInput = {
  decline_for_user_id?: InputMaybe<Scalars['ID']['input']>;
  deleting_from_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteCapacityAllocationItemInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTimeTrackingWorkTypeInput = {
  alias: Scalars['String']['input'];
};

export type DisconnectFromMcpInput = {
  /** Id of the McpToken to revoke, so only that one client loses access. */
  id: Scalars['ID']['input'];
};

export type Document = {
  brands?: Maybe<Array<Maybe<Brand>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  contractors?: Maybe<Array<Maybe<Contractor>>>;
  created_at: Scalars['DateTime']['output'];
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type DocumentExport = {
  __typename?: 'DocumentExport';
  created_at: Scalars['DateTime']['output'];
  exported_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model_id: Scalars['ID']['output'];
  model_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum DocumentLimitTypeEnum {
  Expense = 'EXPENSE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  ProformaOutgoingInvoice = 'PROFORMA_OUTGOING_INVOICE'
}

export enum EmailLogTypeEnum {
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingInvoicePaymentReminder = 'OUTGOING_INVOICE_PAYMENT_REMINDER'
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  type: EmailTemplateTypeEnum;
};

export enum EmailTemplateTypeEnum {
  ExpenseCreated = 'EXPENSE_CREATED',
  InvoiceSendThankYou = 'INVOICE_SEND_THANK_YOU',
  NewRfiSubmitted = 'NEW_RFI_SUBMITTED',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingInvoiceAfterDueDate = 'OUTGOING_INVOICE_AFTER_DUE_DATE',
  OutgoingInvoiceBeforeDueDateReminder = 'OUTGOING_INVOICE_BEFORE_DUE_DATE_REMINDER',
  OutgoingInvoicePaymentReminder = 'OUTGOING_INVOICE_PAYMENT_REMINDER',
  OutgoingInvoiceResend = 'OUTGOING_INVOICE_RESEND',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  OutgoingProformaInvoiceBeforeDueDateReminder = 'OUTGOING_PROFORMA_INVOICE_BEFORE_DUE_DATE_REMINDER',
  Quote = 'QUOTE',
  RunningTimeReminder = 'RUNNING_TIME_REMINDER'
}

export enum ExchangeRateSource {
  Auto = 'AUTO',
  Budget = 'BUDGET',
  Client = 'CLIENT',
  Custom = 'CUSTOM',
  Workspace = 'WORKSPACE'
}

export type Expense = {
  __typename?: 'Expense';
  abraflexi_exported?: Maybe<Scalars['Boolean']['output']>;
  accountMoves?: Maybe<Array<BankAccountMoveDocument>>;
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_account_code?: Maybe<Scalars['String']['output']>;
  business_form?: Maybe<BusinessFormEnum>;
  city?: Maybe<Scalars['String']['output']>;
  constant_symbol?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractor?: Maybe<Contractor>;
  country?: Maybe<Country>;
  country_id?: Maybe<Scalars['ID']['output']>;
  created_by_user_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  defaultAccountingAccount?: Maybe<AccountingAccount>;
  /** Export history for this expense */
  documentExports: Array<DocumentExport>;
  document_number?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  emailData?: Maybe<ExpenseEmailData>;
  exchange_rate?: Maybe<Scalars['BigInt']['output']>;
  expenseItems: Array<ExpenseItem>;
  expenseItemsStructured: Array<StructuredExpenseItemsItem>;
  expenseVatItems: Array<ExpenseVatItem>;
  expense_documents: Array<AssignableFile>;
  expense_no?: Maybe<Scalars['String']['output']>;
  fond_contractor_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the 2% fond expense after it was created */
  fond_expense_id?: Maybe<Scalars['ID']['output']>;
  for_approval: Scalars['Boolean']['output'];
  has_master_agreement?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  internal_number?: Maybe<Scalars['String']['output']>;
  invoice_order_sequence_id?: Maybe<Scalars['ID']['output']>;
  invoice_status: ExpenseInvoiceStatusEnum;
  is_draft: Scalars['Boolean']['output'];
  issue_date?: Maybe<Scalars['Date']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  lockedDocument?: Maybe<LockDocument>;
  modelLock?: Maybe<ModelLock>;
  national_id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paid_at?: Maybe<Scalars['Date']['output']>;
  payment_status: PaymentStatusEnum;
  payment_type?: Maybe<PaymentType>;
  projectTimeBilling?: Maybe<ProjectTimeBilling>;
  projects: Array<Project>;
  registration_no?: Maybe<Scalars['String']['output']>;
  /** Related expenses (bidirectional - includes both directions of the relationship) */
  relatedExpenses: Array<Expense>;
  specific_symbol?: Maybe<Scalars['String']['output']>;
  stats: ExpenseStats;
  status: ExpenseStatusEnum;
  street?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  total_amount_includes_vat: Scalars['Boolean']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  type: ExpenseTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  user_created_date: Scalars['Date']['output'];
  variable_symbol?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id?: Maybe<Scalars['ID']['output']>;
  xero_exported?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ExpenseBudgetCategory = BudgetCategory & {
  __typename?: 'ExpenseBudgetCategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortcut: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseBudgetCategoryTopProject = {
  __typename?: 'ExpenseBudgetCategoryTopProject';
  expense_budget_item_id: Scalars['ID']['output'];
  value: Scalars['BigInt']['output'];
};

export type ExpenseBudgetItem = BudgetItemForExpenseInterface & BudgetItemInterface & {
  __typename?: 'ExpenseBudgetItem';
  category: ExpenseBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount?: Maybe<CreditAccount>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empty unless requested for deletion. */
  deletion_blockers: Array<BudgetItemDeletionBlockerEnum>;
  expenseStats: Array<ExpenseBudgetItemExpenseStats>;
  globalPrepaymentStats: Array<ExpenseBudgetItemGlobalPrepaymentStats>;
  id: Scalars['ID']['output'];
  invoiceStats: Array<ExpenseBudgetItemInvoiceStats>;
  item_code?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outgoingProformaInvoiceStats: Array<OurWorkBudgetItemProformaStats>;
  payment_status: ExpenseInvoiceStatusEnum;
  plannedExpenses: Array<BudgetItemPlannedExpense>;
  prepaymentStats: Array<ExpenseBudgetItemPrepaymentStats>;
  project: Project;
  requested_for_deletion_at?: Maybe<Scalars['DateTime']['output']>;
  stats: ExpenseBudgetItemStats;
  title: Scalars['String']['output'];
  type: ExpenseBudgetItemType;
  updated_at: Scalars['DateTime']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseBudgetItemExpenseStats = {
  __typename?: 'ExpenseBudgetItemExpenseStats';
  amount: Scalars['BigInt']['output'];
  contractor?: Maybe<Contractor>;
  date?: Maybe<Scalars['Date']['output']>;
  expense: Expense;
  id: Scalars['ID']['output'];
};

export type ExpenseBudgetItemGlobalPrepaymentStats = {
  __typename?: 'ExpenseBudgetItemGlobalPrepaymentStats';
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  expenseBudgetItem: ExpenseBudgetItem;
  globalCreditAccount: GlobalCreditAccount;
  id: Scalars['String']['output'];
};

export type ExpenseBudgetItemInput = {
  commission: Scalars['BigInt']['input'];
  commission_unit: CommissionUnit;
  expense_budget_category_id: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  total_budget: Scalars['BigInt']['input'];
};

export type ExpenseBudgetItemInvoiceStats = {
  __typename?: 'ExpenseBudgetItemInvoiceStats';
  credit: Scalars['BigInt']['output'];
  expenseBudgetItem: ExpenseBudgetItem;
  id: Scalars['String']['output'];
  outgoingInvoice: OutgoingInvoice;
};

export type ExpenseBudgetItemPrepaymentStats = {
  __typename?: 'ExpenseBudgetItemPrepaymentStats';
  brandCreditAccount: BrandCreditAccount;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  expenseBudgetItem: ExpenseBudgetItem;
  id: Scalars['String']['output'];
};

export type ExpenseBudgetItemSimple = {
  __typename?: 'ExpenseBudgetItemSimple';
  category: ExpenseBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  payment_status: ExpenseInvoiceStatusEnum;
  project: ProjectSimple;
  stats: ExpenseBudgetItemStatsSimple;
  title: Scalars['String']['output'];
  type: ExpenseBudgetItemType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseBudgetItemStats = CreditStats & ExpenseStatsInterface & {
  __typename?: 'ExpenseBudgetItemStats';
  budget_exceeded: Scalars['BigInt']['output'];
  client_price: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  credit_direct: Scalars['BigInt']['output'];
  credit_from_prepayments: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission_relative_computed: Scalars['String']['output'];
  /** @deprecated No longer supported */
  planned_commission_relative_input_by_user?: Maybe<Scalars['BigInt']['output']>;
  planned_expenses: Scalars['BigInt']['output'];
  planned_profit: Scalars['BigInt']['output'];
  planned_profit_percent: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  real_commission: Scalars['BigInt']['output'];
  real_commission_relative: Scalars['String']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

/** the minimum necessary for someone who doesnt have access to the whole project. planned_expenses and real_expenses are needed in Expense form */
export type ExpenseBudgetItemStatsSimple = {
  __typename?: 'ExpenseBudgetItemStatsSimple';
  planned_expenses: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export enum ExpenseBudgetItemType {
  Other = 'OTHER',
  Regular = 'REGULAR'
}

export enum ExpenseBudgetItemTypeEnum {
  ExpenseBudgetItem = 'EXPENSE_BUDGET_ITEM',
  OurWorkBudgetItem = 'OUR_WORK_BUDGET_ITEM'
}

export type ExpenseBudgetItemWithRevenue = {
  __typename?: 'ExpenseBudgetItemWithRevenue';
  billings_for_date_range?: Maybe<Scalars['BigInt']['output']>;
  expenseBudgetItem: ExpenseBudgetItem;
  profit_for_date_range?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseBudgetItemWithStatus = {
  __typename?: 'ExpenseBudgetItemWithStatus';
  payment_status: ExpenseInvoiceStatusEnum;
  title: Scalars['String']['output'];
};

export type ExpenseBudgetSplitInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  expense_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExpenseEmailData = {
  __typename?: 'ExpenseEmailData';
  from: Scalars['String']['output'];
  message_id: Scalars['String']['output'];
  received_at: Scalars['Date']['output'];
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum ExpenseInvoiceStatusEnum {
  Invoiced = 'INVOICED',
  InvoicedAndPaid = 'INVOICED_AND_PAID',
  NonInvoiceable = 'NON_INVOICEABLE',
  NotInvoiced = 'NOT_INVOICED',
  ProBono = 'PRO_BONO'
}

export type ExpenseItem = {
  __typename?: 'ExpenseItem';
  accountingAccount?: Maybe<AccountingAccount>;
  accounting_centre_id?: Maybe<Scalars['ID']['output']>;
  accounting_vat_classification_id?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['BigInt']['output'];
  amount_in_currency: Scalars['BigInt']['output'];
  amount_in_percent?: Maybe<Scalars['BigInt']['output']>;
  approvals: Array<ExpenseItemApproval>;
  approved: Scalars['Boolean']['output'];
  brand_id?: Maybe<Scalars['ID']['output']>;
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id: Scalars['ID']['output'];
  budget_item_type: ExpenseBudgetItemTypeEnum;
  custom_cost_ratio?: Maybe<Scalars['String']['output']>;
  description?: Maybe<ExpenseItemDesciption>;
  expense: Expense;
  expense_item_description_id?: Maybe<Scalars['ID']['output']>;
  globalCreditAccount?: Maybe<GlobalCreditAccount>;
  id: Scalars['ID']['output'];
  mandatory_id?: Maybe<Scalars['ID']['output']>;
  positions?: Maybe<Array<ExpenseItemPosition>>;
  project_id?: Maybe<Scalars['ID']['output']>;
  tag_ids?: Maybe<Array<Scalars['ID']['output']>>;
  timeBillings: Array<ProjectTimeBilling>;
  vatRate?: Maybe<VatRate>;
  vat_amount_in_currency?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseItemApproval = {
  __typename?: 'ExpenseItemApproval';
  approved: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type ExpenseItemDesciption = {
  __typename?: 'ExpenseItemDesciption';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ExpenseItemForProject = {
  __typename?: 'ExpenseItemForProject';
  amount: Scalars['BigInt']['output'];
  amount_in_currency: Scalars['BigInt']['output'];
  created_at: Scalars['Date']['output'];
  legal_name: Scalars['String']['output'];
};

export type ExpenseItemInput = {
  accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_centre_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_vat_classification_id?: InputMaybe<Scalars['ID']['input']>;
  amount_in_currency: Scalars['BigInt']['input'];
  amount_in_percent?: InputMaybe<Scalars['BigInt']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_type?: InputMaybe<ExpenseBudgetItemTypeEnum>;
  custom_cost_ratio?: InputMaybe<Scalars['String']['input']>;
  expense_item_description_id?: InputMaybe<Scalars['ID']['input']>;
  global_credit_account_id?: InputMaybe<Scalars['ID']['input']>;
  global_credit_account_title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mandatory_id?: InputMaybe<Scalars['ID']['input']>;
  planned_expense_usages?: InputMaybe<Array<PlannedExpenseUsageInput>>;
  positions?: InputMaybe<Array<InputMaybe<ExpenseItemPositionInput>>>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vat_amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  vat_rate_id?: InputMaybe<Scalars['ID']['input']>;
};

/** A paginated list of ExpenseItem items. */
export type ExpenseItemPaginator = {
  __typename?: 'ExpenseItemPaginator';
  /** A list of ExpenseItem items. */
  data: Array<ExpenseItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ExpenseItemPosition = {
  __typename?: 'ExpenseItemPosition';
  report_date?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<Task>;
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseItemPositionInput = {
  report_date?: InputMaybe<Scalars['Date']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};

export type ExpenseItemsTimeBillingOrderByClause = {
  column: ExpenseItemsTimeBillingOrderByColumn;
  order: SortOrder;
};

export enum ExpenseItemsTimeBillingOrderByColumn {
  AccountingAccount = 'ACCOUNTING_ACCOUNT',
  Amount = 'AMOUNT',
  Brand = 'BRAND',
  BudgetItem = 'BUDGET_ITEM',
  ContractorName = 'CONTRACTOR_NAME',
  CostCenter = 'COST_CENTER',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Description = 'DESCRIPTION',
  DueDate = 'DUE_DATE',
  ExpenseNo = 'EXPENSE_NO',
  ExpenseNoRaw = 'EXPENSE_NO_RAW',
  Id = 'ID',
  InternalNote = 'INTERNAL_NOTE',
  LegalEntity = 'LEGAL_ENTITY',
  LockedTimeBilling = 'LOCKED_TIME_BILLING',
  Note = 'NOTE',
  PaidAt = 'PAID_AT',
  PaymentMethod = 'PAYMENT_METHOD',
  Project = 'PROJECT',
  Responsible = 'RESPONSIBLE',
  Status = 'STATUS',
  Tags = 'TAGS',
  TimeBilling = 'TIME_BILLING',
  Type = 'TYPE',
  VatClassification = 'VAT_CLASSIFICATION'
}

export type ExpenseItemsTimeBillingQueryArgs = {
  orderBy?: InputMaybe<Array<ExpenseItemsTimeBillingOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ExpenseItemsTimeBillingWhereConditions>;
};

export enum ExpenseItemsTimeBillingWhereColumn {
  AccountingAccountId = 'ACCOUNTING_ACCOUNT_ID',
  AccountingCentreId = 'ACCOUNTING_CENTRE_ID',
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  BudgetItemId = 'BUDGET_ITEM_ID',
  BudgetItemType = 'BUDGET_ITEM_TYPE',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  InvoiceStatus = 'INVOICE_STATUS',
  MandatoryId = 'MANDATORY_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Status = 'STATUS',
  TagId = 'TAG_ID',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ExpenseItemsTimeBillingWhereConditions = {
  AND?: InputMaybe<Array<ExpenseItemsTimeBillingWhereConditions>>;
  OR?: InputMaybe<Array<ExpenseItemsTimeBillingWhereConditions>>;
  column?: InputMaybe<ExpenseItemsTimeBillingWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ExpenseOrderByClause = {
  column: ExpenseOrderByColumnEnum;
  order: SortOrder;
};

export enum ExpenseOrderByColumnEnum {
  Amount = 'AMOUNT',
  Contractor = 'CONTRACTOR',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Default = 'DEFAULT',
  DueDate = 'DUE_DATE',
  ExpenseNoRaw = 'EXPENSE_NO_RAW',
  Iban = 'IBAN',
  Id = 'ID',
  PaidAt = 'PAID_AT',
  Status = 'STATUS',
  Type = 'TYPE',
  UserCreatedDate = 'USER_CREATED_DATE',
  VariableSymbol = 'VARIABLE_SYMBOL'
}

/** A paginated list of Expense items. */
export type ExpensePaginator = {
  __typename?: 'ExpensePaginator';
  /** A list of Expense items. */
  data: Array<Expense>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ExpensePaymentOrderExportType {
  PaymentOrder = 'PAYMENT_ORDER',
  QrCodesList = 'QR_CODES_LIST'
}

export type ExpensePaymentOrderResponse = {
  __typename?: 'ExpensePaymentOrderResponse';
  unprocessable_expense_ids?: Maybe<Array<Scalars['ID']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ExpensePaymentTypeEnum {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  SetOff = 'SET_OFF'
}

export type ExpenseQueryArgs = {
  orderBy?: InputMaybe<Array<ExpenseOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ExpensesWhereConditions>;
};

export type ExpenseRevenueByCategory = {
  __typename?: 'ExpenseRevenueByCategory';
  billings: Scalars['BigInt']['output'];
  category: ExpenseBudgetCategory;
  profit: Scalars['BigInt']['output'];
  profit_percentage: Scalars['BigInt']['output'];
};

export type ExpenseStats = {
  __typename?: 'ExpenseStats';
  id: Scalars['ID']['output'];
  rounding: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  total_amount_without_vat: Scalars['BigInt']['output'];
  total_amount_without_vat_in_currency: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  total_vat_in_currency: Scalars['BigInt']['output'];
};

export type ExpenseStatsInterface = {
  budget_exceeded: Scalars['BigInt']['output'];
  client_price: Scalars['BigInt']['output'];
  planned_commission: Scalars['BigInt']['output'];
  planned_expenses: Scalars['BigInt']['output'];
  planned_profit: Scalars['BigInt']['output'];
  planned_profit_percent: Scalars['BigInt']['output'];
  real_commission: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export enum ExpenseStatusEnum {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  ForApproval = 'FOR_APPROVAL',
  ForFinancialApproval = 'FOR_FINANCIAL_APPROVAL',
  Imported = 'IMPORTED'
}

export type ExpenseStructuredBudgetItem = {
  __typename?: 'ExpenseStructuredBudgetItem';
  budgetItems: Array<ExpenseBudgetItem>;
  budget_category_id: Scalars['ID']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profit: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_without_other: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type ExpenseStructuredBudgetItemWithRevenue = {
  __typename?: 'ExpenseStructuredBudgetItemWithRevenue';
  budgetItems: Array<ExpenseBudgetItemWithRevenue>;
  expenseBudgetCategory: ExpenseBudgetCategory;
};

export enum ExpenseTypeEnum {
  Bill = 'BILL',
  Card = 'CARD',
  Contract = 'CONTRACT',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  Proforma = 'PROFORMA'
}

export type ExpenseVatItem = {
  __typename?: 'ExpenseVatItem';
  amount_in_currency: Scalars['BigInt']['output'];
  amount_with_vat_in_currency: Scalars['BigInt']['output'];
  vat_in_currency: Scalars['BigInt']['output'];
  vat_percent_informative: Scalars['BigInt']['output'];
};

export type ExpenseVatItemInput = {
  amount_in_currency: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  vat_in_currency: Scalars['BigInt']['input'];
  vat_percent_informative: Scalars['BigInt']['input'];
};

export type ExpensesSummary = {
  __typename?: 'ExpensesSummary';
  expenseIds?: Maybe<Array<Scalars['ID']['output']>>;
  expenses: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_vat: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_without_vat: Scalars['BigInt']['output'];
  payments_due: Scalars['BigInt']['output'];
  payments_due_vat: Scalars['BigInt']['output'];
  payments_due_without_vat: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
};

export enum ExpensesWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  Id = 'ID',
  InvoiceStatus = 'INVOICE_STATUS',
  IssueDate = 'ISSUE_DATE',
  IsExported = 'IS_EXPORTED',
  MandatoryId = 'MANDATORY_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Status = 'STATUS',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ExpensesWhereConditions = {
  AND?: InputMaybe<Array<ExpensesWhereConditions>>;
  OR?: InputMaybe<Array<ExpensesWhereConditions>>;
  column?: InputMaybe<ExpensesWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ExportSettings = {
  __typename?: 'ExportSettings';
  expenses: Scalars['Boolean']['output'];
  expenses_xml: Scalars['Boolean']['output'];
  mlggk_project_effectiveness: Scalars['Boolean']['output'];
  mrp: Scalars['Boolean']['output'];
  omega: Scalars['Boolean']['output'];
  pohoda: Scalars['Boolean']['output'];
  premier: Scalars['Boolean']['output'];
  project_effectiveness: Scalars['Boolean']['output'];
  project_progress_statistics: Scalars['Boolean']['output'];
  project_status: Scalars['Boolean']['output'];
  proluc: Scalars['Boolean']['output'];
  transakcio: Scalars['Boolean']['output'];
  triad_project_effectiveness: Scalars['Boolean']['output'];
  unpaid_outgoing_invoices: Scalars['Boolean']['output'];
  vario: Scalars['Boolean']['output'];
  xero: Scalars['Boolean']['output'];
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  model_id: Scalars['ID']['output'];
  model_type: ExternalLinkType;
  title: Scalars['String']['output'];
};

export enum ExternalLinkType {
  Brand = 'BRAND',
  Project = 'PROJECT'
}

export type FileInput = {
  file: Scalars['Upload']['input'];
  /** To replace existing file. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterTemplate = {
  __typename?: 'FilterTemplate';
  id: Scalars['ID']['output'];
  model_id?: Maybe<Scalars['ID']['output']>;
  model_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  params?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type FilterTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  model_id?: InputMaybe<Scalars['ID']['input']>;
  model_type: Scalars['String']['input'];
  name: Scalars['String']['input'];
  only_for_me?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FinanceSettings = {
  __typename?: 'FinanceSettings';
  automatically_approved_expense_items?: Maybe<Scalars['Boolean']['output']>;
  bankAccounts?: Maybe<Array<BankAccountSetting>>;
  can_transfer_credit_between_teams_without_constraints?: Maybe<Scalars['Boolean']['output']>;
  currency_id?: Maybe<Scalars['BigInt']['output']>;
  default_vat_rate_id?: Maybe<Scalars['BigInt']['output']>;
  invoicing_more_teams?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguagesEnum>;
  outgoing_invoice_drafts_only?: Maybe<Scalars['Boolean']['output']>;
  registration_no: Scalars['String']['output'];
  show_contact_person?: Maybe<Scalars['Boolean']['output']>;
  show_full_bank_account_information?: Maybe<Scalars['Boolean']['output']>;
  show_project_codes?: Maybe<Scalars['Boolean']['output']>;
  tax_no: Scalars['String']['output'];
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  vat_no: Scalars['String']['output'];
};

export type FondContractorSimple = {
  __typename?: 'FondContractorSimple';
  contractor_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  legal_name: Scalars['String']['output'];
};

export type GetTimeTrackingItemsPaginator = {
  __typename?: 'GetTimeTrackingItemsPaginator';
  data: Array<TimeTrackingReport>;
  paginatorInfo: PaginatorInfo;
};

export type GetTimeTrackingItemsSummary = {
  __typename?: 'GetTimeTrackingItemsSummary';
  amount: Scalars['BigInt']['output'];
  ids: Array<Scalars['ID']['output']>;
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_seconds: Scalars['BigInt']['output'];
  overserviced_amount: Scalars['BigInt']['output'];
  overserviced_seconds: Scalars['BigInt']['output'];
  tracked_time: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_seconds: Scalars['BigInt']['output'];
};

export type GlobalCreditAccount = {
  __typename?: 'GlobalCreditAccount';
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  credits: Array<GlobalCreditAccountCreditStats>;
  debits: Array<GlobalCreditAccountDebitStats>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  stats: GlobalCreditAccountStats;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type GlobalCreditAccountCreditStats = {
  __typename?: 'GlobalCreditAccountCreditStats';
  credit: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  expense?: Maybe<Expense>;
  id: Scalars['ID']['output'];
  originatesGlobalCreditAccount?: Maybe<GlobalCreditAccount>;
};

export type GlobalCreditAccountDebitStats = {
  __typename?: 'GlobalCreditAccountDebitStats';
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  id: Scalars['ID']['output'];
  originatesGlobalCreditAccount?: Maybe<GlobalCreditAccount>;
  performed_at: Scalars['Date']['output'];
};

export type GlobalCreditAccountOrderByClause = {
  column: GlobalCreditAccountOrderByColumnEnum;
  order: SortOrder;
};

export enum GlobalCreditAccountOrderByColumnEnum {
  Id = 'ID',
  Title = 'TITLE'
}

/** A paginated list of GlobalCreditAccount items. */
export type GlobalCreditAccountPaginator = {
  __typename?: 'GlobalCreditAccountPaginator';
  /** A list of GlobalCreditAccount items. */
  data: Array<GlobalCreditAccount>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GlobalCreditAccountQueryArgs = {
  orderBy?: InputMaybe<Array<GlobalCreditAccountOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<GlobalCreditAccountsWhereConditions>;
};

export type GlobalCreditAccountStats = {
  __typename?: 'GlobalCreditAccountStats';
  id: Scalars['ID']['output'];
  remaining_credit: Scalars['BigInt']['output'];
  total_credit: Scalars['BigInt']['output'];
  total_debit: Scalars['BigInt']['output'];
};

export enum GlobalCreditAccountsWhereColumn {
  Id = 'ID'
}

export type GlobalCreditAccountsWhereConditions = {
  AND?: InputMaybe<Array<GlobalCreditAccountsWhereConditions>>;
  OR?: InputMaybe<Array<GlobalCreditAccountsWhereConditions>>;
  column?: InputMaybe<GlobalCreditAccountsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum ImapEncryptionEnum {
  Ssl = 'SSL'
}

export type InputAccountingAccount = {
  account_number: Scalars['String']['input'];
  accounting_type: Accounting_Account_Type;
  budget_categories?: InputMaybe<Array<InputAccountingAccountBudgetCategory>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type InputAccountingAccountBudgetCategory = {
  budget_category_id: Scalars['ID']['input'];
  budget_category_type: Scalars['String']['input'];
};

export type InputAccountingCentre = {
  centre: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: Accounting_Centre_Type;
};

export type InputAccountingVatClassification = {
  centre: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: Accounting_Centre_Type;
  vat_rate_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputUpdateWorkspaceAccountingAccountSettings = {
  accounting_accounts: Array<InputAccountingAccount>;
};

export type InputUpdateWorkspaceAccountingCentreSettings = {
  accounting_centres: Array<InputAccountingCentre>;
};

export type InputUpdateWorkspaceAccountingVatClassificationSettings = {
  accounting_vat_classifications: Array<InputAccountingVatClassification>;
};

export type InputUpdateWorkspaceAutoExpenseEmail = {
  imap_encryption: ImapEncryptionEnum;
  imap_host: Scalars['String']['input'];
  imap_password?: InputMaybe<Scalars['String']['input']>;
  imap_port: Scalars['Int']['input'];
  imap_username: Scalars['String']['input'];
  is_active: Scalars['Boolean']['input'];
};

export type InputUpdateWorkspacePipedriveIntegration = {
  settings: WorkspacePipedriveIntegrationSettingInput;
};

export type InputUpdateWorkspaceProjectSettings = {
  automate_invoicing_plan_approval: Scalars['Boolean']['input'];
  can_close_expense_budget_item_with_unapproved_expenses: Scalars['Boolean']['input'];
  create_default_task_enabled: Scalars['Boolean']['input'];
  create_default_task_only_to_our_work_category: Scalars['Boolean']['input'];
  enable_additional_brand_numeric_code: Scalars['Boolean']['input'];
  project_code_generator: ProjectCodeGeneratorEnum;
  project_code_length: Scalars['Int']['input'];
  project_code_with_year: Scalars['Boolean']['input'];
};

export type InputWorkspaceCompanySetting = {
  companies: Array<WorkspaceCompanyInput>;
};

export type InputWorkspaceFinancialSetting = {
  currencies: Array<CurrencyInput>;
  default_show_billing_accounting_on_invoices: Scalars['Boolean']['input'];
  default_show_unit_price_on_invoices: Scalars['Boolean']['input'];
  invoice_attachment_name_templates?: InputMaybe<InvoiceAttachmentNameTemplatesInput>;
  vat_rates: Array<VatRateInput>;
};

export type InputWorkspacePlanningSetting = {
  default_user_plannable_capacity: Scalars['BigInt']['input'];
  default_utilization_range_from: Scalars['Int']['input'];
  default_utilization_range_to: Scalars['Int']['input'];
  disable_home_office_in_planning: Scalars['Boolean']['input'];
  hide_planning_total_daily_capacity: Scalars['Boolean']['input'];
  planning_alphabet_user_order: Scalars['Boolean']['input'];
  planning_sort_prioritize_time_specific_items: Scalars['Boolean']['input'];
  specific_time_in_planning_enabled: Scalars['Boolean']['input'];
  start_day_of_week: StartDayOfWeekEnum;
  working_from: Scalars['Time']['input'];
  working_to: Scalars['Time']['input'];
};

export type InputWorkspaceTaskSettings = {
  show_done_tasks: Scalars['Boolean']['input'];
  task_priorities: Array<WorkspaceTaskPriorityInput>;
  task_statuses: Array<WorkspaceTaskStatusInput>;
  use_current_assignee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputWorkspaceTeamSetting = {
  copy_users_from_team_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_default: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type InputWorkspaceUserManagementSetting = {
  require_two_factor_authentication: Scalars['Boolean']['input'];
  teams: Array<InputWorkspaceTeamSetting>;
};

export type InvoiceAttachmentNameTemplates = {
  __typename?: 'InvoiceAttachmentNameTemplates';
  outgoing_invoice?: Maybe<Scalars['String']['output']>;
  outgoing_proforma?: Maybe<Scalars['String']['output']>;
  payment_receipt?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAttachmentNameTemplatesInput = {
  outgoing_invoice?: InputMaybe<Scalars['String']['input']>;
  outgoing_proforma?: InputMaybe<Scalars['String']['input']>;
  payment_receipt?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceEmailData = {
  __typename?: 'InvoiceEmailData';
  attachments?: Maybe<Array<Maybe<InvoiceEmailDataAttachment>>>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  recipients: Array<Maybe<Scalars['String']['output']>>;
  subject: Scalars['String']['output'];
};

export type InvoiceEmailDataAttachment = {
  __typename?: 'InvoiceEmailDataAttachment';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type InvoiceItemInput = {
  accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_centre_id?: InputMaybe<Scalars['ID']['input']>;
  amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  unit_price: Scalars['BigInt']['input'];
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
};

export type InvoicePaymentMethod = {
  __typename?: 'InvoicePaymentMethod';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_name?: Maybe<InvoicePaymentMethodEnum>;
};

export enum InvoicePaymentMethodEnum {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  SetOff = 'SET_OFF'
}

export type InvoiceSequenceData = {
  __typename?: 'InvoiceSequenceData';
  document_no: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum LanguagesEnum {
  Cz = 'CZ',
  En = 'EN',
  Sk = 'SK'
}

export type LatestExpenseInternalNumberPerType = {
  __typename?: 'LatestExpenseInternalNumberPerType';
  internal_number?: Maybe<Scalars['String']['output']>;
  type: ExpenseTypeEnum;
};

export type LockDocument = {
  __typename?: 'LockDocument';
  document_id: Scalars['ID']['output'];
  document_type: LockDocumentTypeEnum;
  locked_to: Scalars['DateTime']['output'];
  user: User;
};

export enum LockDocumentTypeEnum {
  Expense = 'EXPENSE'
}

export enum MailTypeEnum {
  Google = 'google',
  Microsoft = 'microsoft',
  Smtp = 'smtp'
}

export type MapQuestAddress = {
  __typename?: 'MapQuestAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Country>;
  country_code: Scalars['String']['output'];
  country_id?: Maybe<Scalars['ID']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/**
 * One paired MCP client. Backed by the workspace API access issued to it, so
 * revoking it here revokes the token that client authenticates with.
 */
export type McpToken = {
  __typename?: 'McpToken';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mcp_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type MediaUrlList = {
  __typename?: 'MediaUrlList';
  download?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
};

export type ModelLock = {
  __typename?: 'ModelLock';
  deletedByUser?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_locked: Scalars['Boolean']['output'];
  lockedByUser: User;
  locked_at: Scalars['DateTime']['output'];
};

export enum ModelLockLockableTypeEnum {
  Expense = 'EXPENSE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE'
}

export type ModuleSettings = {
  __typename?: 'ModuleSettings';
  billing_plan: Scalars['Boolean']['output'];
  budgetovac: Scalars['Boolean']['output'];
  clients: Scalars['Boolean']['output'];
  contractors: Scalars['Boolean']['output'];
  documents: Scalars['Boolean']['output'];
  expenses: Scalars['Boolean']['output'];
  invoices: Scalars['Boolean']['output'];
  planovac: Scalars['Boolean']['output'];
  projects: Scalars['Boolean']['output'];
  reports: Scalars['Boolean']['output'];
  time_billing: Scalars['Boolean']['output'];
  time_tracking: Scalars['Boolean']['output'];
};

export type MoveCapacityAllocationItemInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  from_user_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  new_time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  to_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveTaskOnBoardInput = {
  /** Place the card after this task. Omit with before_task_id to put it at the top. */
  after_task_id?: InputMaybe<Scalars['ID']['input']>;
  /** Place the card before this task. */
  before_task_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Board context: tab + group by, e.g. "my:TASK_STATUS". Must contain the group by —
   * without it the order lands in the wrong board and shuffles cards in other groupings.
   */
  board_key: Scalars['String']['input'];
  group_by: TaskBoardGroupByEnum;
  /** Target column. Null or "unassigned" = the empty-value column. */
  group_value?: InputMaybe<Scalars['ID']['input']>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Source assignee column when group_by is ASSIGNEE. Assignee columns only reorder,
   * a move into another assignee's column is rejected.
   */
  source_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  /**
   * With neither after_task_id nor before_task_id, puts the card at the bottom of the column
   * instead of the top — the client may not have the last cards loaded.
   */
  to_bottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  UpdateCapacityAllocationForDay: CapacityAllocation;
  UpdateWorkspaceNotifications: Array<WorkspaceNotification>;
  addBankAccountMovesToDocument?: Maybe<Scalars['Boolean']['output']>;
  addDocumentsToAccountMove: BankAccountMove;
  addManualAccountMove: BankAccountMove;
  /** permission: timeTracking.create.all/team/own + timeTracking.update.all/team/own */
  addRowToWeekTimeReport: WeeklyTimeReportRow;
  /**
   * Add one position (assignee with work type and planned time), keeping the others.
   * permission: task.update.all/own for given task
   */
  addTaskAssignee: Task;
  /** permission: task.read.all/own for given task */
  addTaskFiles: Task;
  /** permission: task.read.all/own for both tasks */
  addTaskLink?: Maybe<TaskLink>;
  /** permission: brand.archive */
  archiveBrand: Brand;
  /** permission: project.archive.all/team/own */
  archiveProject: Project;
  archiveProjectsBulk: BulkActionResponse;
  budgetCreatedEvent: Scalars['Boolean']['output'];
  budgetInternalApprove: Budget;
  /** permission: brand.archive */
  bulkArchiveBrand: BulkActionResponse;
  /** permission: brand.delete */
  bulkDeleteBrand: BulkActionResponse;
  /** permission: expense.delete.all/team/own for given expenses */
  bulkDeleteExpenses: BulkActionResponse;
  /** permission: task.delete.all/own for every given task */
  bulkDeleteTasks: Scalars['Boolean']['output'];
  /**
   * Bulk delete time tracking items (cannot delete locked items)
   * permission: timeTracking.delete.all/team
   */
  bulkDeleteTimeTrackingItems: BulkActionResponse;
  /**
   * permission: for every given task, what each changed field needs on its own
   * (task.update_status, task.update_current_assignee, task.read for the priority,
   * task.update for the rest); with duplicate_task task.create.all and task.read
   */
  bulkEditTasks: Scalars['Boolean']['output'];
  bulkLockModel: BulkActionResponse;
  bulkStar: BulkActionResponse;
  bulkStarProjects: BulkActionResponse;
  bulkUnlockModel: BulkActionResponse;
  bulkUnstar: BulkActionResponse;
  bulkUnstarProjects: BulkActionResponse;
  bulkUpdateProjects: BulkActionResponse;
  changeBudgetAssignedAt: Budget;
  changeOutgoingInvoiceDates?: Maybe<Scalars['Boolean']['output']>;
  changeOutgoingProformaInvoiceDates?: Maybe<Scalars['Boolean']['output']>;
  changeRateCardOnProject?: Maybe<Project>;
  /** permission: expense.create && expense.read.all/team/own for given expense */
  cloneExpense: Expense;
  /** permission: wip.close.all/team/own */
  closeWip: WorkInProgressProjectStat;
  /** permission: wip.close.all/team/own */
  closeWipBulk: BulkActionResponse;
  /** Complete capacity allocation user item */
  completeCapacityAllocationItem: CapacityAllocationItem;
  /** permission: project.budget.completeExpenseBudgetItem.all/team/own */
  completeExpenseBudgetItem: ExpenseBudgetItem;
  /** permission: project.budget.completeExpenseBudgetItem.all/team/own */
  completeExpenseBudgetItemBulk: Array<ExpenseBudgetItem>;
  connectToMcp: ConnectToMcpPayload;
  copyCapacityAllocationItem: CapacityAllocationItem;
  /** permission: assignableFile.create */
  createAssignableFile: AssignableFile;
  /** permission: client.create */
  createBillingEntity: BillingEntity;
  /** permission: billingPlan.create */
  createBillingPlan: Array<BillingPlanByMonths>;
  /** permission: brand.create, brand.updateManagers */
  createBrand: Brand;
  /** permission: brandCreditAccount.create */
  createBrandCreditAccount: BrandCreditAccount;
  createBudgetItemPlannedExpenses: Array<BudgetItemPlannedExpense>;
  createBudgetItemPlannedExpensesBulk: Array<Array<BudgetItemPlannedExpense>>;
  /** permission: BigIntegration.budgetovac */
  createBudgetovacPosition: BudgetovacPosition;
  /** permission: BigIntegration.budgetovac */
  createBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** Create capacity allocation - meeting or task. */
  createCapacityAllocation: CapacityAllocation;
  /** permission: client.create, client.updateManagers */
  createClient: Client;
  /** permission: client.update or brand.update, depending on if the contact belongs to client or brand */
  createContact: Contact;
  /** permission: contract.create */
  createContract: Contract;
  /** permission: contractor.create */
  createContractor: Contractor;
  /** permission: client.update */
  createCurrencyExchangeRate: CurrencyExchangeRate;
  createEmailTemplate: EmailTemplate;
  /** permission: workspaceSetting.edit */
  createExchangeRateForWorkspace: CurrencyExchangeRate;
  /** permission: expense.create */
  createExpense: Expense;
  createExpenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  createExpenseItemDescription?: Maybe<ExpenseItemDesciption>;
  createExternalLink: ExternalLink;
  createFilterTemplate: FilterTemplate;
  /** permission: brandCreditAccount.create */
  createGlobalCreditAccount: GlobalCreditAccount;
  createInvoiceFromBillingPlan: RequestForInvoicing;
  /** permission: timeTracking.create.all/team/own + timeTracking.update.all/team/own */
  createOrUpdateTrackedTimeForDay: Scalars['Boolean']['output'];
  /** permission: order.create */
  createOrder: Order;
  /** permission: otherDocument.create */
  createOtherDocument: OtherDocument;
  createOurWorkBudgetItem?: Maybe<OurWorkBudgetItemOverview>;
  /** permission: outgoingInvoice.create */
  createOutgoingInvoice: OutgoingInvoice;
  /** permission: outgoingInvoice.create */
  createOutgoingProformaInvoice: OutgoingProformaInvoice;
  /** permission: project.create.all/team/own */
  createProject: Project;
  /** permission: projectCategory.create */
  createProjectCategory: ProjectCategory;
  createProjectFromPipedrive?: Maybe<Project>;
  /**
   * permission: project.create.all/team/own
   * Create a new project from a project template.
   */
  createProjectFromTemplate: Project;
  /**
   * Vytvorenie nového Time Billing
   * permission: project.update.all/own/team
   */
  createProjectTimeBilling: ProjectTimeBilling;
  createProjectTimeBreakdown: ProjectTimeBreakdown;
  createQuote: Quote;
  /** permission: requestForInvoicing.create.all/own/team */
  createRequestForInvoicing: RequestForInvoicing;
  /** permission: task.create.scoped */
  createScopedTask: Task;
  /** permission: user.create */
  createScopedUser: User;
  createSequence: Sequence;
  createTag?: Maybe<Tag>;
  /** permission: task.create.all/own */
  createTask: Task;
  /** permission: task.read for given task */
  createTaskComment: TaskComment;
  createTaskTemplateGroup: TaskTemplateGroup;
  createTasksFromTaskTemplateGroup: Scalars['Boolean']['output'];
  /** permission: timeTracking.create.all/team/own */
  createTimeTrackingItem: TimeTrackingItem;
  /** permission: BigIntegration.budgetovac */
  createTimeTrackingWorkType: TimeTrackingWorkType;
  /** permission: expense.create */
  createUpdateExpenseContractor: Expense;
  /** permission: user.create */
  createUser: User;
  createVatRate: VatRate;
  createWorkspaceSmtpSettings: WorkspaceSmtpSettings;
  /** permission: assignableFile.delete all/own */
  deleteAssignableFile?: Maybe<BooleanResult>;
  /** permission: client.delete */
  deleteBillingEntity: BillingEntity;
  /** permission: brand.delete */
  deleteBrand: Brand;
  /** permission: brandCreditAccount.delete.all/team.own for given ID */
  deleteBrandCreditAccount: BrandCreditAccount;
  /** permission: BigIntegration.budgetovac */
  deleteBudgetovacPosition: BudgetovacPosition;
  /** permission: BigIntegration.budgetovac */
  deleteBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** Delete capacity allocation - meeting or task. */
  deleteCapacityAllocation: CapacityAllocation;
  /** Delete capacity allocation - meeting or task. */
  deleteCapacityAllocationForDay: CapacityAllocation;
  /** Delete capacity allocation item - meeting or task. */
  deleteCapacityAllocationItem: CapacityAllocationItem;
  /** permission: client.delete */
  deleteClient: Client;
  /** permission: client.update or brand.update, depending on if the contact belongs to client or brand */
  deleteContact: Contact;
  /** permission: contract.delete */
  deleteContract: Contract;
  /** permission: contractor.delete */
  deleteContractor: Contractor;
  /** permission: contractor.delete */
  deleteContractorsBulk: BulkActionResponse;
  /** permission: workspaceSetting.edit */
  deleteExchangeRateForWorkspace: CurrencyExchangeRate;
  /** permission: expense.delete.all/team/own for given expense */
  deleteExpense: Expense;
  deleteExpenseItemDescription?: Maybe<Scalars['Boolean']['output']>;
  /** permission: assignableFile.delete all/own */
  deleteExternalLink?: Maybe<Scalars['Boolean']['output']>;
  deleteFilterTemplate: Scalars['Boolean']['output'];
  /** permission: brandCreditAccount.delete.all/team.own for given ID */
  deleteGlobalCreditAccount: Scalars['Boolean']['output'];
  /** permission: order.delete */
  deleteOrder: Order;
  /** permission: otherDocument.delete */
  deleteOtherDocument: OtherDocument;
  /** permission: outgoingInvoice.delete.all/team/own for given OI */
  deleteOutgoingInvoice: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.delete.all/team/own for given OI */
  deleteOutgoingProformaInvoice: Scalars['Boolean']['output'];
  /** permission: project.delete.all/team/own */
  deleteProject: Project;
  /** permission: projectCategory.delete */
  deleteProjectCategory: ProjectCategory;
  /**
   * Zmazanie Time Billing
   * Blokované ak je locked
   * permission: project.update.all/own/team + unlocked
   */
  deleteProjectTimeBilling: Scalars['Boolean']['output'];
  deleteProjectTimeBreakdown: Scalars['Boolean']['output'];
  /** permission: project.delete.all/team/own */
  deleteProjectsBulk: BulkActionResponse;
  deleteQuote: Scalars['Boolean']['output'];
  /** permission: requestForInvoicing.delete.all/own/team */
  deleteRequestForInvoicing: RequestForInvoicing;
  /** permission: requestForInvoicing.delete.all/own/team */
  deleteRequestsForInvoicingBulk: BulkActionResponse;
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  /** permission: task.delete.all/own for given task */
  deleteTask: Task;
  /** permission: taskComment.delete.all/own and task.read for given comment's task */
  deleteTaskComment: TaskComment;
  /** permission: task.read.all/own for given task */
  deleteTaskLink: TaskLink;
  deleteTaskTemplateGroup: Scalars['Boolean']['output'];
  /** permission: timeTracking.delete.all/team/own */
  deleteTimeTrackingItem: TimeTrackingItem;
  /** permission: BigIntegration.budgetovac */
  deleteTimeTrackingWorkType: TimeTrackingWorkType;
  deleteUploadedFile: Scalars['Boolean']['output'];
  /** permission: user.delete */
  deleteUser: User;
  /** permission: user.profile.update */
  disableTwoFactorAuthentication: User;
  disconnectFromMcp: ConnectToMcpPayload;
  /** permission: project.duplicate.all/team/own */
  duplicateProject: Project;
  /** permission: task.create */
  duplicateTask: Task;
  /** permission: task.read.all/own for given task */
  editTaskWatchers: Task;
  excludeBankAccountMove: BankAccountMove;
  findAddressForExpense?: Maybe<MapQuestAddress>;
  /** permission: project.finish.all/team/own */
  finishProject: Project;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  invoiceProject?: Maybe<RequestForInvoicing>;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  invoiceProjectByCurrentMonthBillingPlan?: Maybe<RequestForInvoicing>;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  invoiceProjectsBulk?: Maybe<RequestForInvoicing>;
  /** isDateBeforeLastPlanningUpdate */
  isDateBeforeLastPlanningUpdate: Scalars['Boolean']['output'];
  /** permission: task.read.all/own for given task */
  lastSeen?: Maybe<Task>;
  lockBillingPlanForProject?: Maybe<Project>;
  lockDocument: LockDocument;
  lockModel: ModelLock;
  /**
   * Zamknutie Time Billing
   * permission: project.update.all/own/team
   */
  lockProjectTimeBilling: ProjectTimeBilling;
  /** permission: wip.lock.all/team/own */
  lockWip: WorkInProgressProjectStat;
  /** permission: wip.lock.all/team/own */
  lockWipBulk: BulkActionResponse;
  /** permission: quote.manualApprove */
  manualApproveQuote: Quote;
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  /** permission: expense.markAsPaid */
  markExpenseAsPaid: Expense;
  /** permission: expense.markAsPaid */
  markExpenseAsPaidBulk: BulkActionResponse;
  /** permission: expense.markAsPaid */
  markExpenseAsUnpaid: Expense;
  markNotificationAsRead: Notification;
  markNotificationAsUnread: Notification;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingInvoiceAsPaid: OutgoingInvoice;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingInvoiceAsPaidBulk: BulkActionResponse;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingInvoiceAsUnpaid: OutgoingInvoice;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingProformaInvoiceAsPaid: OutgoingProformaInvoice;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingProformaInvoiceAsUnpaid: OutgoingProformaInvoice;
  markTaskAndCommunicationNotificationAsRead: Scalars['Boolean']['output'];
  markTaskAndCommunicationNotificationAsUnread: Scalars['Boolean']['output'];
  /** Move capacity allocation item */
  moveCapacityAllocationItem: CapacityAllocationItem;
  /**
   * Move a card on the board: change the grouped value and/or rewrite board_order.
   * permission: task.read.all/own; extra checks inside by group_by
   */
  moveTaskOnBoard: Task;
  /** permission: timeTracking.update.all/team */
  moveTimeTrackingItemsToTask: BulkActionResponse;
  /** permission: timeTracking.update.all/team */
  moveTimeTrackingItemsToWorkType: BulkActionResponse;
  /** permission: wip.open.all/team/own */
  openWip: WorkInProgressProjectStat;
  /** permission: wip.open.all/team/own */
  openWipBulk: BulkActionResponse;
  /** permission: project.pin.all/team/own */
  pinProject: Project;
  pinProjectsBulk: BulkActionResponse;
  previewQuote: Quote;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  proformaInvoiceProject?: Maybe<RequestForInvoicing>;
  /** permission: user.updateWorkData */
  reassignActiveProjectsAndOwnedInvoices: Scalars['Boolean']['output'];
  /** permission: project.finish.all/team/own for given project */
  redistributeProjectCredit: Project;
  /** permission: timeTracking.create.all/team/own + timeTracking.update.all/team/own */
  removeRowFromWeekTimeReport?: Maybe<WeeklyTimeReportRow>;
  /** permission: task.read.all/own for given task */
  removeTaskFiles: Task;
  /** Update capacity allocation user item */
  reopenCapacityAllocationItem: CapacityAllocationItem;
  /** permission: project.budget.reopenExpenseBudgetItem.all/team/own */
  reopenExpenseBudgetItem: ExpenseBudgetItem;
  /** permission: project.reopen.all/team/own */
  reopenProject: Project;
  /** Reorder capacity allocation user items */
  reorderCapacityAllocationItems?: Maybe<Array<CapacityAllocationItem>>;
  /** permission: billingPlan.update */
  resetBillingPlanNotifications: Project;
  returnCreditFromExpenseBudgetItem: Scalars['Boolean']['output'];
  returnCreditFromOurWorkBudgetItem: Scalars['Boolean']['output'];
  returnGlobalCreditFromExpenseItem: Scalars['Boolean']['output'];
  saveQuote: Quote;
  /** permission: user.updateAllfredData */
  scheduleUserActivation: User;
  /** permission: user.updateAllfredData */
  scheduleUserArchival: User;
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingInvoice: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingInvoiceBulk: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingProformaInvoice: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingProformaInvoiceBulk: Scalars['Boolean']['output'];
  sendQuote: Quote;
  sendTestEmail: SmtpTestResult;
  /** permission: BigIntegration.budgetovac */
  setActiveBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** permission: user.profile.update */
  setUserProfilePlanningRanges: UserProfile;
  /** permission: user.profile.update */
  setUserProfileRates: UserProfile;
  star: Star;
  starProject: Star;
  /** permission: timeTracking.timer.use.all/team/own */
  startTimer: Scalars['Boolean']['output'];
  /** permission: timeTracking.timer.use.all/team/own */
  stopTimer: Scalars['Boolean']['output'];
  stopTimerForCapacityAllocationItem: CapacityAllocationItem;
  /** permission: wip.submit.all/team/own */
  submitProgress: SubmitProgressResult;
  /** permission: wip.submit.all/team/own */
  submitProgressBulk: Array<OurWorkBudgetItem>;
  /** permission: requestForInvoicing.update.all/own/team */
  submitRequestForInvoicing: RequestForInvoicing;
  /** permission: requestForInvoicing.update.all/own/team */
  submitRequestsForInvoicingBulk: BulkActionResponse;
  subscribeToPushNotifications: Scalars['Boolean']['output'];
  syncBudgetOnProjectWithBudgetovac?: Maybe<Scalars['Boolean']['output']>;
  syncPositionsWithBudgetovac?: Maybe<Scalars['Boolean']['output']>;
  testSmtpConnection: SmtpTestResult;
  testWorkspaceAutoExpenseEmail: Scalars['String']['output'];
  /** permission: task.read for given comment's task */
  toggleTaskCommentReaction?: Maybe<Array<TaskCommentReaction>>;
  transferCredit: Scalars['Boolean']['output'];
  transferGlobalCredit: Scalars['Boolean']['output'];
  /** permission: brand.archive */
  unarchiveBrand: Brand;
  /** permission: project.archive.all/team/own */
  unarchiveProject: Project;
  unarchiveProjectsBulk: BulkActionResponse;
  unassignBudgetOnProjectWithBudgetovac?: Maybe<Scalars['Boolean']['output']>;
  unlockDocument: LockDocument;
  unlockModel: Scalars['Boolean']['output'];
  /**
   * Odomknutie Time Billing
   * permission: CFO alebo ADMIN rola
   */
  unlockProjectTimeBilling: ProjectTimeBilling;
  /**
   * Unlock time tracking items
   * permission: timeTracking.update.all/team
   */
  unlockTimeTrackingItems: BulkActionResponse;
  /** permission: wip.unlock.all/team/own */
  unlockWip: WorkInProgressProjectStat;
  /** permission: wip.unlock.all/team/own */
  unlockWipBulk: BulkActionResponse;
  /** permission: project.pin.all/team/own */
  unpinProject: Project;
  unpinProjectsBulk: BulkActionResponse;
  unstar: Scalars['Boolean']['output'];
  unstarProject: Scalars['Boolean']['output'];
  unsubscribeFromPushNotifications: Scalars['Boolean']['output'];
  /** permission: client.update */
  updateBillingEntity: BillingEntity;
  /** permission: billingPlan.update */
  updateBillingPlan: Array<BillingPlanByMonths>;
  /** permission: brand.update, brand.updateManagers */
  updateBrand: Brand;
  /** permission: brandCreditAccount.update.all/team/own for given ID */
  updateBrandCreditAccount: BrandCreditAccount;
  /** permission: BigIntegration.budgetovac */
  updateBudgetovacPosition: BudgetovacPosition;
  /** permission: BigIntegration.budgetovac */
  updateBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** Update capacity allocation - meeting or task. */
  updateCapacityAllocation: CapacityAllocation;
  /** Update capacity allocation item - meeting or task. */
  updateCapacityAllocationItem: CapacityAllocationItem;
  /** permission: client.update, client.updateManagers */
  updateClient: Client;
  updateCompanySettings: CompanySettings;
  /** permission: client.update or brand.update, depending on if the contact belongs to client or brand */
  updateContact: Contact;
  /** permission: contract.update */
  updateContract: Contract;
  /** permission: contractor.update */
  updateContractor: Contractor;
  /** permission: client.update */
  updateCurrencyExchangeRate: CurrencyExchangeRate;
  updateEmailTemplate: EmailTemplate;
  /** permission: workspaceSetting.edit */
  updateExchangeRateForWorkspace: CurrencyExchangeRate;
  /** permission: expense.update.all/team/own for given expense */
  updateExpense: Expense;
  /** permission: project.budget.update.all/team/own */
  updateExpenseBudgetItemNote: ExpenseBudgetItem;
  updateExpenseItemDescription?: Maybe<ExpenseItemDesciption>;
  updateExternalLink: ExternalLink;
  updateFinanceSettings: FinanceSettings;
  /** permission: brandCreditAccount.update.all/team/own for given ID */
  updateGlobalCreditAccount: GlobalCreditAccount;
  updateNotificationSetting: NotificationSetting;
  updateNotificationSettings: NotificationSettings;
  /** permission: order.update */
  updateOrder: Order;
  /** permission: otherDocument.update */
  updateOtherDocument: OtherDocument;
  /** permission: project.budget.update.all/team/own */
  updateOurWorkBudgetItemNote: OurWorkBudgetItem;
  /** permission: project.budget.update.all/team/own */
  updateOurWorkBudgetItems: Array<OurWorkBudgetItem>;
  /** permission: outgoingInvoice.update.all/team/own for given OI */
  updateOutgoingInvoice: OutgoingInvoice;
  /** permission: outgoingInvoice.updateInvoiceNumber for given OI */
  updateOutgoingInvoiceNumber: OutgoingInvoice;
  /** permission: outgoingInvoice.update.all/team/own for given OI */
  updateOutgoingProformaInvoice: OutgoingProformaInvoice;
  /** permission: user.profile.update */
  updatePassword: User;
  updatePaymentSettings: NotificationSettings;
  updatePlanningSettings: WorkspaceSettings;
  /** isDateBeforeLastPlanningUpdate */
  updatePlanningUsersOrder: Scalars['Boolean']['output'];
  /** permission: project.update.all/team/own */
  updateProject: Project;
  updateProjectBillingPlanBudget: Array<BillingPlanBudget>;
  updateProjectBillingPlanSettings: Project;
  /** permission: project.budget.update.all/team/own */
  updateProjectBudget: Project;
  /** permission: projectCategory.update */
  updateProjectCategory: ProjectCategory;
  updateProjectSettings: ProjectSettings;
  updateProjectStage?: Maybe<Project>;
  /**
   * Update existujúceho Time Billing
   * Blokované ak je locked
   * permission: project.update.all/own/team + unlocked
   */
  updateProjectTimeBilling: ProjectTimeBilling;
  updateProjectTimeBreakdown: ProjectTimeBreakdown;
  /** permission: requestForInvoicing.update.all/own/team */
  updateRequestForInvoicing: RequestForInvoicing;
  /** permission: task.update.all/own for given task */
  updateScopedTask: Task;
  updateSequence: Sequence;
  updateTag?: Maybe<Tag>;
  /** permission: task.update.all/own for given task */
  updateTask: Task;
  /**
   * Replace all task positions (assignees with work type and planned time).
   * permission: task.update.all/own for given task
   */
  updateTaskAssignees: Task;
  /**
   * Mark the task billable or non-billable.
   * permission: task.update.all/own for given task
   */
  updateTaskBillable: Task;
  /**
   * Upsert current user's board settings for the given board_key.
   * Merge semantics: provided non-null fields overwrite, null fields stay unchanged.
   * permission: none, own settings only (authenticated user)
   */
  updateTaskBoardSettings: TaskBoardSettings;
  /** permission: taskComment.update.all/own and task.read for given comment's task */
  updateTaskComment: TaskComment;
  /** permission: task.update_current_assignee.all/own for given task */
  updateTaskCurrentAssignee: Task;
  /**
   * Set or clear the task deadline.
   * permission: task.update.all/own for given task
   */
  updateTaskDeadline: Task;
  /**
   * permission: task.update.all/own or task.update.scoped for given task,
   * or task.read.all/own when only checklist items are ticked
   */
  updateTaskDescription: Task;
  /**
   * Set the task duration; a null date leaves that side open.
   * permission: task.update.all/own for given task
   */
  updateTaskDuration: Task;
  /** permission: task.read.all/own for given task */
  updateTaskPriority: Task;
  /** permission: task.update_status.all/own for given task */
  updateTaskStatus: Task;
  updateTaskTemplateGroup: TaskTemplateGroup;
  /** permission: timeTracking.update.all/team/own */
  updateTimeTrackingItem: TimeTrackingItem;
  /** permission: timeTracking.update.all/team */
  updateTimeTrackingItemsBillable: BulkActionResponse;
  /** permission: brand.update */
  updateTimeTrackingRatesForBrand: Brand;
  /** permission: project.update.all/team/own */
  updateTimeTrackingRatesForProject: Project;
  /** permission: project.update.all/team/own */
  updateTimeTrackingSettingsForProject: Project;
  /** permission: BigIntegration.budgetovac */
  updateTimeTrackingWorkType: TimeTrackingWorkType;
  updateTimeTrackingWorkTypeInTracking: Scalars['Boolean']['output'];
  updateUser: User;
  updateUserPassword: User;
  updateVatRate: VatRate;
  updateWorkspaceAccountingAccountSettings: WorkspaceAccountingAccountSettings;
  updateWorkspaceAccountingCentreSettings: WorkspaceAccountingCentreSettings;
  updateWorkspaceAccountingVatClassificationSettings: WorkspaceAccountingVatClassificationSettings;
  updateWorkspaceAutoExpenseEmail?: Maybe<WorkspaceAutoExpenseEmailSettings>;
  updateWorkspaceCompanies: Array<WorkspaceCompanySetting>;
  updateWorkspaceFinancialSettings: WorkspaceFinancialSetting;
  updateWorkspacePipedriveIntegration: WorkspacePipedriveIntegration;
  updateWorkspacePlanningSettings: WorkspacePlanningSettings;
  updateWorkspaceProjectSettings: WorkspaceProjectSettings;
  updateWorkspaceSmtpSettings: WorkspaceSmtpSettings;
  updateWorkspaceTaskSettings: WorkspaceTaskSettings;
  updateWorkspaceUserManagementSettings: WorkspaceUserManagementSetting;
  validateCreateTimeTrackingItem: Scalars['Boolean']['output'];
};


export type MutationUpdateCapacityAllocationForDayArgs = {
  input: UpdateCapacityAllocationForDayInput;
};


export type MutationUpdateWorkspaceNotificationsArgs = {
  input?: InputMaybe<UpdateWorkspaceNotifications>;
};


export type MutationAddBankAccountMovesToDocumentArgs = {
  bank_account_moves: Array<BankAccountMoveToDocumentInput>;
  date: Scalars['Date']['input'];
  document_id: Scalars['ID']['input'];
  document_type: BankDocumentTypeEnum;
};


export type MutationAddDocumentsToAccountMoveArgs = {
  bank_account_move_id: Scalars['ID']['input'];
  documents: Array<BankAccountMoveDocumentInput>;
};


export type MutationAddManualAccountMoveArgs = {
  amount: Scalars['BigInt']['input'];
  currency_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  note: Scalars['String']['input'];
};


export type MutationAddRowToWeekTimeReportArgs = {
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddTaskAssigneeArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  position: TaskPositionInput;
  task_id: Scalars['ID']['input'];
};


export type MutationAddTaskFilesArgs = {
  files: Array<Scalars['String']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationAddTaskLinkArgs = {
  link_type_id: Scalars['ID']['input'];
  linked_task_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationArchiveBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationBudgetCreatedEventArgs = {
  budget_id: Scalars['ID']['input'];
};


export type MutationBudgetInternalApproveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBulkArchiveBrandArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteBrandArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteExpensesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteTasksArgs = {
  task_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteTimeTrackingItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkEditTasksArgs = {
  data: BulkEditTaskInput;
  duplicate_task: Scalars['Boolean']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkLockModelArgs = {
  lockable_ids: Array<Scalars['ID']['input']>;
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationBulkStarArgs = {
  starable_ids: Array<Scalars['ID']['input']>;
  starable_type: StarsStarableTypeEnum;
};


export type MutationBulkStarProjectsArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUnlockModelArgs = {
  lockable_ids: Array<Scalars['ID']['input']>;
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationBulkUnstarArgs = {
  starable_ids: Array<Scalars['ID']['input']>;
  starable_type: StarsStarableTypeEnum;
};


export type MutationBulkUnstarProjectsArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUpdateProjectsArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: BulkUpdateProjectsInput;
};


export type MutationChangeBudgetAssignedAtArgs = {
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
};


export type MutationChangeOutgoingInvoiceDatesArgs = {
  date_of_supply: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationChangeOutgoingProformaInvoiceDatesArgs = {
  due_date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationChangeRateCardOnProjectArgs = {
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  project_id: Scalars['ID']['input'];
  rate_card_id: Scalars['ID']['input'];
};


export type MutationCloneExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationCompleteCapacityAllocationItemArgs = {
  input: CompleteCapacityAllocationUserInput;
};


export type MutationCompleteExpenseBudgetItemArgs = {
  completed_at?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCompleteExpenseBudgetItemBulkArgs = {
  completed_at?: InputMaybe<Scalars['Date']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationConnectToMcpArgs = {
  input: ConnectToMcpInput;
};


export type MutationCopyCapacityAllocationItemArgs = {
  input: MoveCapacityAllocationItemInput;
};


export type MutationCreateAssignableFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationCreateBillingEntityArgs = {
  input: CreateBillingEntityInput;
};


export type MutationCreateBillingPlanArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationCreateBrandArgs = {
  input: CreateBrandInput;
};


export type MutationCreateBrandCreditAccountArgs = {
  input: CreateBrandCreditAccountInput;
};


export type MutationCreateBudgetItemPlannedExpensesArgs = {
  input: CreateBudgetItemPlannedExpensesInput;
};


export type MutationCreateBudgetItemPlannedExpensesBulkArgs = {
  items: Array<CreateBudgetItemPlannedExpensesInput>;
};


export type MutationCreateBudgetovacPositionArgs = {
  input: CreateBudgetovacPositionInput;
};


export type MutationCreateBudgetovacPositionsSetArgs = {
  input: CreateBudgetovacPositionsSetInput;
};


export type MutationCreateCapacityAllocationArgs = {
  input: CreateCapacityAllocationInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContractArgs = {
  input?: InputMaybe<CreateContractInput>;
};


export type MutationCreateContractorArgs = {
  input: CreateContractorInput;
};


export type MutationCreateCurrencyExchangeRateArgs = {
  input: CreateCurrencyExchangeRateInput;
};


export type MutationCreateEmailTemplateArgs = {
  input?: InputMaybe<CreateEmailTemplateInput>;
};


export type MutationCreateExchangeRateForWorkspaceArgs = {
  input: CreateExchangeRateSettingsInput;
};


export type MutationCreateExpenseArgs = {
  input: CreateExpenseInput;
};


export type MutationCreateExpenseBudgetItemArgs = {
  expense_budget_category_id: Scalars['ID']['input'];
  project_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateExpenseItemDescriptionArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateExternalLinkArgs = {
  input: CreateExternalLinkInput;
};


export type MutationCreateFilterTemplateArgs = {
  input: FilterTemplateInput;
};


export type MutationCreateGlobalCreditAccountArgs = {
  input: CreateGlobalCreditAccountInput;
};


export type MutationCreateInvoiceFromBillingPlanArgs = {
  input?: InputMaybe<CreateInvoiceFromBillingPlanInput>;
};


export type MutationCreateOrUpdateTrackedTimeForDayArgs = {
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time: Scalars['BigInt']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<CreateOrderInput>;
};


export type MutationCreateOtherDocumentArgs = {
  input?: InputMaybe<CreateOtherDocumentInput>;
};


export type MutationCreateOurWorkBudgetItemArgs = {
  project_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateOutgoingInvoiceArgs = {
  invoice_no?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  request_for_invoicing_id: Scalars['ID']['input'];
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationCreateOutgoingProformaInvoiceArgs = {
  invoice_no: Scalars['ID']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  request_for_invoicing_id: Scalars['ID']['input'];
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectCategoryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateProjectFromPipedriveArgs = {
  input: CreateProjectFromPipedriveInput;
};


export type MutationCreateProjectFromTemplateArgs = {
  input: CreateProjectFromTemplateInput;
};


export type MutationCreateProjectTimeBillingArgs = {
  input: CreateProjectTimeBillingInput;
};


export type MutationCreateProjectTimeBreakdownArgs = {
  budgeted: Scalars['Int']['input'];
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  our_work_budget_item_id: Scalars['ID']['input'];
  project_id: Scalars['ID']['input'];
};


export type MutationCreateQuoteArgs = {
  budget_ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationCreateRequestForInvoicingArgs = {
  input: CreateRequestForInvoicingInput;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationCreateScopedTaskArgs = {
  input: CreateScopedTaskInput;
};


export type MutationCreateScopedUserArgs = {
  input: CreateScopedUserInput;
};


export type MutationCreateSequenceArgs = {
  input?: InputMaybe<CreateSequenceInput>;
};


export type MutationCreateTagArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationCreateTaskTemplateGroupArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTasksFromTaskTemplateGroupArgs = {
  our_work_budget_item_ids: Array<Scalars['ID']['input']>;
  task_template_group_id: Scalars['ID']['input'];
};


export type MutationCreateTimeTrackingItemArgs = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date?: InputMaybe<Scalars['Date']['input']>;
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTimeTrackingWorkTypeArgs = {
  input: CreateTimeTrackingWorkTypeInput;
};


export type MutationCreateUpdateExpenseContractorArgs = {
  input: CreateUpdateExpenseContractorInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVatRateArgs = {
  input?: InputMaybe<CreateVatRateInput>;
};


export type MutationCreateWorkspaceSmtpSettingsArgs = {
  input: CreateWorkspaceSmtpSettingsInput;
};


export type MutationDeleteAssignableFileArgs = {
  public_id: Scalars['String']['input'];
};


export type MutationDeleteBillingEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBudgetovacPositionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBudgetovacPositionsSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCapacityAllocationArgs = {
  input: DeleteCapacityAllocationInput;
};


export type MutationDeleteCapacityAllocationForDayArgs = {
  input: DeleteCapacityAllocationForDayInput;
};


export type MutationDeleteCapacityAllocationItemArgs = {
  input: DeleteCapacityAllocationItemInput;
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractorsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteExchangeRateForWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExpenseItemDescriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExternalLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFilterTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGlobalCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOtherDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOutgoingInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOutgoingProformaInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectTimeBreakdownArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRequestForInvoicingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRequestsForInvoicingBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskLinkArgs = {
  task_link_id: Scalars['ID']['input'];
};


export type MutationDeleteTaskTemplateGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeTrackingItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeTrackingWorkTypeArgs = {
  input: DeleteTimeTrackingWorkTypeInput;
};


export type MutationDeleteUploadedFileArgs = {
  assignable_file_id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableTwoFactorAuthenticationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisconnectFromMcpArgs = {
  input: DisconnectFromMcpInput;
};


export type MutationDuplicateProjectArgs = {
  id: Scalars['ID']['input'];
  with_task_attachments?: Scalars['Boolean']['input'];
  with_task_comments?: Scalars['Boolean']['input'];
  with_task_description?: Scalars['Boolean']['input'];
  with_tasks?: Scalars['Boolean']['input'];
};


export type MutationDuplicateTaskArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  task_input?: InputMaybe<CreateTaskInput>;
  with_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  with_comments?: InputMaybe<Scalars['Boolean']['input']>;
  with_description?: InputMaybe<Scalars['Boolean']['input']>;
  with_links?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEditTaskWatchersArgs = {
  task_id: Scalars['ID']['input'];
  user_ids: Array<Scalars['ID']['input']>;
};


export type MutationExcludeBankAccountMoveArgs = {
  bank_account_move_id: Scalars['ID']['input'];
};


export type MutationFindAddressForExpenseArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFinishProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInvoiceProjectArgs = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  expense_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  invoice_type?: InputMaybe<RequestForInvoicingTypeEnum>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInvoiceProjectByCurrentMonthBillingPlanArgs = {
  id: Scalars['ID']['input'];
  invoice_type: RequestForInvoicingTypeEnum;
};


export type MutationInvoiceProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
  invoice_type?: InputMaybe<RequestForInvoicingTypeEnum>;
};


export type MutationIsDateBeforeLastPlanningUpdateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationLastSeenArgs = {
  task_comment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLockBillingPlanForProjectArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationLockDocumentArgs = {
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
};


export type MutationLockModelArgs = {
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationLockProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLockWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLockWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationManualApproveQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkAllNotificationsAsReadArgs = {
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>>>;
};


export type MutationMarkExpenseAsPaidArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMarkExpenseAsPaidBulkArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Array<Scalars['ID']['input']>;
};


export type MutationMarkExpenseAsUnpaidArgs = {
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkOutgoingInvoiceAsPaidArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMarkOutgoingInvoiceAsPaidBulkArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Array<Scalars['ID']['input']>;
};


export type MutationMarkOutgoingInvoiceAsUnpaidArgs = {
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
};


export type MutationMarkOutgoingProformaInvoiceAsPaidArgs = {
  create_summary_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMarkOutgoingProformaInvoiceAsUnpaidArgs = {
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
};


export type MutationMarkTaskAndCommunicationNotificationAsReadArgs = {
  task_id: Scalars['ID']['input'];
};


export type MutationMarkTaskAndCommunicationNotificationAsUnreadArgs = {
  task_id: Scalars['ID']['input'];
};


export type MutationMoveCapacityAllocationItemArgs = {
  input: MoveCapacityAllocationItemInput;
};


export type MutationMoveTaskOnBoardArgs = {
  input: MoveTaskOnBoardInput;
};


export type MutationMoveTimeTrackingItemsToTaskArgs = {
  task_id: Scalars['ID']['input'];
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
  time_tracking_work_type_mapping: Array<TimeTrackingWorkTypeMapping>;
};


export type MutationMoveTimeTrackingItemsToWorkTypeArgs = {
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
  time_tracking_work_type_id: Scalars['ID']['input'];
};


export type MutationOpenWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpenWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationPinProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationPreviewQuoteArgs = {
  input: QuoteInput;
};


export type MutationProformaInvoiceProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReassignActiveProjectsAndOwnedInvoicesArgs = {
  from_user_id: Scalars['ID']['input'];
  to_user_id: Scalars['ID']['input'];
};


export type MutationRedistributeProjectCreditArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationRemoveRowFromWeekTimeReportArgs = {
  first_date_of_week: Scalars['Date']['input'];
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveTaskFilesArgs = {
  files: Array<Scalars['String']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationReopenCapacityAllocationItemArgs = {
  input: ReopenCapacityAllocationItemInput;
};


export type MutationReopenExpenseBudgetItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReopenProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderCapacityAllocationItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationResetBillingPlanNotificationsArgs = {
  project_id: Scalars['ID']['input'];
  types: Array<BillingPlanNotificationTypeEnum>;
};


export type MutationReturnCreditFromExpenseBudgetItemArgs = {
  amount: Scalars['BigInt']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
};


export type MutationReturnCreditFromOurWorkBudgetItemArgs = {
  amount: Scalars['BigInt']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
  our_work_budget_item_id: Scalars['ID']['input'];
};


export type MutationReturnGlobalCreditFromExpenseItemArgs = {
  amount: Scalars['BigInt']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
  global_credit_account_id: Scalars['ID']['input'];
};


export type MutationSaveQuoteArgs = {
  input: QuoteInput;
};


export type MutationScheduleUserActivationArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationScheduleUserArchivalArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  project_manager_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendOutgoingInvoiceArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendOutgoingInvoiceBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationSendOutgoingProformaInvoiceArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendOutgoingProformaInvoiceBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationSendQuoteArgs = {
  input: QuoteSendInput;
};


export type MutationSendTestEmailArgs = {
  input: CreateWorkspaceSmtpSettingsInput;
};


export type MutationSetActiveBudgetovacPositionsSetArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetUserProfilePlanningRangesArgs = {
  planningRanges: Array<PlanningRangeInput>;
  user_id: Scalars['ID']['input'];
};


export type MutationSetUserProfileRatesArgs = {
  rates: Array<UserProfileRateInput>;
  user_id: Scalars['ID']['input'];
};


export type MutationStarArgs = {
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
};


export type MutationStarProjectArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_id: Scalars['ID']['input'];
};


export type MutationStartTimerArgs = {
  time_tracking_item_id: Scalars['ID']['input'];
};


export type MutationStopTimerArgs = {
  time_tracking_item_id: Scalars['ID']['input'];
};


export type MutationStopTimerForCapacityAllocationItemArgs = {
  input: StopTimerForCapacityAllocationItemInput;
};


export type MutationSubmitProgressArgs = {
  input: SubmitProgressInput;
};


export type MutationSubmitProgressBulkArgs = {
  input: SubmitProgressBulkInput;
};


export type MutationSubmitRequestForInvoicingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitRequestsForInvoicingBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationSubscribeToPushNotificationsArgs = {
  endpoint: Scalars['String']['input'];
  keys: PushNotificationSubscriptionKeys;
};


export type MutationSyncBudgetOnProjectWithBudgetovacArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationTestSmtpConnectionArgs = {
  input: TestSmtpConnectionInput;
};


export type MutationToggleTaskCommentReactionArgs = {
  input: ToggleTaskCommentReactionInput;
};


export type MutationTransferCreditArgs = {
  amount: Scalars['BigInt']['input'];
  from_credit_account_id: Scalars['ID']['input'];
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  performed_at?: InputMaybe<Scalars['DateTime']['input']>;
  to_credit_account_id: Scalars['ID']['input'];
};


export type MutationTransferGlobalCreditArgs = {
  amount: Scalars['BigInt']['input'];
  from_credit_account_id: Scalars['ID']['input'];
  performed_at?: InputMaybe<Scalars['DateTime']['input']>;
  to_credit_account_id: Scalars['ID']['input'];
};


export type MutationUnarchiveBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationUnassignBudgetOnProjectWithBudgetovacArgs = {
  budget_id: Scalars['ID']['input'];
  project_id: Scalars['ID']['input'];
};


export type MutationUnlockDocumentArgs = {
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
};


export type MutationUnlockModelArgs = {
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationUnlockProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlockTimeTrackingItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUnlockWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlockWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationUnpinProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpinProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationUnstarArgs = {
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
};


export type MutationUnstarProjectArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_id: Scalars['ID']['input'];
};


export type MutationUnsubscribeFromPushNotificationsArgs = {
  endpoint: Scalars['String']['input'];
};


export type MutationUpdateBillingEntityArgs = {
  input: UpdateBillingEntityInput;
};


export type MutationUpdateBillingPlanArgs = {
  input: UpdateBillingPlanInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandInput;
};


export type MutationUpdateBrandCreditAccountArgs = {
  input: UpdateBrandCreditAccountInput;
};


export type MutationUpdateBudgetovacPositionArgs = {
  input: UpdateBudgetovacPositionInput;
};


export type MutationUpdateBudgetovacPositionsSetArgs = {
  input: UpdateBudgetovacPositionsSetInput;
};


export type MutationUpdateCapacityAllocationArgs = {
  input: UpdateCapacityAllocationInput;
};


export type MutationUpdateCapacityAllocationItemArgs = {
  input: UpdateCapacityAllocationItemInput;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateCompanySettingsArgs = {
  input?: InputMaybe<UpdateCompanySettingsInput>;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateContractArgs = {
  input?: InputMaybe<UpdateContractInput>;
};


export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


export type MutationUpdateCurrencyExchangeRateArgs = {
  input: UpdateCurrencyExchangeRateInput;
};


export type MutationUpdateEmailTemplateArgs = {
  input?: InputMaybe<UpdateEmailTemplateInput>;
};


export type MutationUpdateExchangeRateForWorkspaceArgs = {
  input: UpdateExchangeRateSettingsInput;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateExpenseBudgetItemNoteArgs = {
  expense_budget_item_id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateExpenseItemDescriptionArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateExternalLinkArgs = {
  input: UpdateExternalLinkInput;
};


export type MutationUpdateFinanceSettingsArgs = {
  input?: InputMaybe<UpdateFinanceSettingsInput>;
};


export type MutationUpdateGlobalCreditAccountArgs = {
  input: UpdateGlobalCreditAccountInput;
};


export type MutationUpdateNotificationSettingArgs = {
  input: NotificationSettingInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input?: InputMaybe<UpdateNotificationSettingsInput>;
};


export type MutationUpdateOrderArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOtherDocumentArgs = {
  input?: InputMaybe<UpdateOtherDocumentInput>;
};


export type MutationUpdateOurWorkBudgetItemNoteArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_item_id: Scalars['ID']['input'];
};


export type MutationUpdateOurWorkBudgetItemsArgs = {
  budget_items: Array<UpdateBudgetItem>;
};


export type MutationUpdateOutgoingInvoiceArgs = {
  input?: InputMaybe<UpdateOutgoingInvoiceInput>;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationUpdateOutgoingInvoiceNumberArgs = {
  force?: Scalars['Boolean']['input'];
  input?: InputMaybe<UpdateOutgoingInvoiceNumberInput>;
};


export type MutationUpdateOutgoingProformaInvoiceArgs = {
  input?: InputMaybe<UpdateOutgoingProformaInvoiceInput>;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePaymentSettingsArgs = {
  input?: InputMaybe<UpdatePaymentSettingsInput>;
};


export type MutationUpdatePlanningSettingsArgs = {
  input: UpdatePlanningSettings;
};


export type MutationUpdatePlanningUsersOrderArgs = {
  model_id?: InputMaybe<Scalars['ID']['input']>;
  type: PlanningOrderTypeEnum;
  user_ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
  propagate_billable?: Scalars['Boolean']['input'];
};


export type MutationUpdateProjectBillingPlanBudgetArgs = {
  input?: InputMaybe<UpdateProjectBillingPlanBudgetInput>;
};


export type MutationUpdateProjectBillingPlanSettingsArgs = {
  input?: InputMaybe<UpdateProjectBillingPlanSettingsInput>;
};


export type MutationUpdateProjectBudgetArgs = {
  input: UpdateProjectBudgetInput;
};


export type MutationUpdateProjectCategoryArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectSettingsArgs = {
  input?: InputMaybe<UpdateProjectSettingsInput>;
};


export type MutationUpdateProjectStageArgs = {
  project_id: Scalars['ID']['input'];
  project_stage_id: Scalars['ID']['input'];
};


export type MutationUpdateProjectTimeBillingArgs = {
  input: UpdateProjectTimeBillingInput;
};


export type MutationUpdateProjectTimeBreakdownArgs = {
  budgeted: Scalars['Int']['input'];
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateRequestForInvoicingArgs = {
  input: UpdateRequestForInvoicingInput;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationUpdateScopedTaskArgs = {
  input: UpdateScopedTaskInput;
};


export type MutationUpdateSequenceArgs = {
  input?: InputMaybe<UpdateSequenceInput>;
};


export type MutationUpdateTagArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
  propagate_billable?: Scalars['Boolean']['input'];
};


export type MutationUpdateTaskAssigneesArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  positions: Array<TaskPositionInput>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskBillableArgs = {
  billable: Scalars['Boolean']['input'];
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  propagate_billable?: InputMaybe<Scalars['Boolean']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskBoardSettingsArgs = {
  input: UpdateTaskBoardSettingsInput;
};


export type MutationUpdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationUpdateTaskCurrentAssigneeArgs = {
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskDeadlineArgs = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskDescriptionArgs = {
  input: UpdateTaskDescriptionInput;
};


export type MutationUpdateTaskDurationArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateTaskPriorityArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  priority_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskStatusArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  status_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskTemplateGroupArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateTimeTrackingItemArgs = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};


export type MutationUpdateTimeTrackingItemsBillableArgs = {
  billable: Scalars['Boolean']['input'];
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateTimeTrackingRatesForBrandArgs = {
  input: UpdateTimeTrackingRatesForBrandInput;
};


export type MutationUpdateTimeTrackingRatesForProjectArgs = {
  input: UpdateTimeTrackingRatesForProjectInput;
};


export type MutationUpdateTimeTrackingSettingsForProjectArgs = {
  input: UpdateTimeTrackingSettingsInput;
};


export type MutationUpdateTimeTrackingWorkTypeArgs = {
  input: UpdateTimeTrackingWorkTypeInput;
};


export type MutationUpdateTimeTrackingWorkTypeInTrackingArgs = {
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  new_time_tracking_work_type_id: Scalars['ID']['input'];
  old_time_tracking_work_type_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type MutationUpdateVatRateArgs = {
  input?: InputMaybe<UpdateVatRateInput>;
};


export type MutationUpdateWorkspaceAccountingAccountSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAccountingAccountSettings>;
};


export type MutationUpdateWorkspaceAccountingCentreSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAccountingCentreSettings>;
};


export type MutationUpdateWorkspaceAccountingVatClassificationSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAccountingVatClassificationSettings>;
};


export type MutationUpdateWorkspaceAutoExpenseEmailArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAutoExpenseEmail>;
};


export type MutationUpdateWorkspaceCompaniesArgs = {
  input?: InputMaybe<InputWorkspaceCompanySetting>;
};


export type MutationUpdateWorkspaceFinancialSettingsArgs = {
  input?: InputMaybe<InputWorkspaceFinancialSetting>;
};


export type MutationUpdateWorkspacePipedriveIntegrationArgs = {
  input?: InputMaybe<InputUpdateWorkspacePipedriveIntegration>;
};


export type MutationUpdateWorkspacePlanningSettingsArgs = {
  input?: InputMaybe<InputWorkspacePlanningSetting>;
};


export type MutationUpdateWorkspaceProjectSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceProjectSettings>;
};


export type MutationUpdateWorkspaceSmtpSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkspaceSmtpSettingsInput;
};


export type MutationUpdateWorkspaceTaskSettingsArgs = {
  input?: InputMaybe<InputWorkspaceTaskSettings>;
};


export type MutationUpdateWorkspaceUserManagementSettingsArgs = {
  input?: InputMaybe<InputWorkspaceUserManagementSetting>;
};


export type MutationValidateCreateTimeTrackingItemArgs = {
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  object_id?: Maybe<Scalars['ID']['output']>;
  read_at?: Maybe<Scalars['DateTime']['output']>;
  type: NotificationType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationGroup {
  ActionRequired = 'ACTION_REQUIRED',
  Default = 'DEFAULT',
  TaskCommunication = 'TASK_COMMUNICATION'
}

/** A paginated list of Notification items. */
export type NotificationPaginator = {
  __typename?: 'NotificationPaginator';
  /** A list of Notification items. */
  data: Array<Notification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type NotificationPerTask = {
  __typename?: 'NotificationPerTask';
  notifications: Array<Notification>;
  task: Task;
};

export enum NotificationRoleEnum {
  Cfo = 'CFO',
  Financier = 'FINANCIER',
  ManagingDirector = 'MANAGING_DIRECTOR',
  ProjectManager = 'PROJECT_MANAGER',
  TeamLeader = 'TEAM_LEADER'
}

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  database_enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mail_enabled: Scalars['Boolean']['output'];
  roles_to_notify?: Maybe<Array<NotificationRoleEnum>>;
  threshold?: Maybe<Scalars['BigInt']['output']>;
  type: NotificationType;
};

export type NotificationSettingInput = {
  database_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mail_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  roles_to_notify?: InputMaybe<Array<NotificationRoleEnum>>;
  threshold?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  email_footer?: Maybe<Scalars['String']['output']>;
  from_email?: Maybe<Scalars['String']['output']>;
  notification_email?: Maybe<Scalars['String']['output']>;
};

export enum NotificationThresholdTypeEnum {
  Amount = 'AMOUNT',
  Days = 'DAYS',
  Hours = 'HOURS',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export enum NotificationType {
  ApprovedExpenseItemChanged = 'APPROVED_EXPENSE_ITEM_CHANGED',
  BillingDateApproaching = 'BILLING_DATE_APPROACHING',
  BillingPlanMustBeChecked = 'BILLING_PLAN_MUST_BE_CHECKED',
  BrandCreditAccountCreated = 'BRAND_CREDIT_ACCOUNT_CREATED',
  BudgetCreated = 'BUDGET_CREATED',
  BudgetExceededByThreshold = 'BUDGET_EXCEEDED_BY_THRESHOLD',
  BudgetExceededByThresholdFirstAlert = 'BUDGET_EXCEEDED_BY_THRESHOLD_FIRST_ALERT',
  BudgetExceededByThresholdSecondAlert = 'BUDGET_EXCEEDED_BY_THRESHOLD_SECOND_ALERT',
  BudgetInternallyApproved = 'BUDGET_INTERNALLY_APPROVED',
  ChangingProjectToProBono = 'CHANGING_PROJECT_TO_PRO_BONO',
  ExpenseAddedOnBrand = 'EXPENSE_ADDED_ON_BRAND',
  ExpenseAddedOnProject = 'EXPENSE_ADDED_ON_PROJECT',
  ExpenseItemApprovalRequested = 'EXPENSE_ITEM_APPROVAL_REQUESTED',
  ExpenseItemApproved = 'EXPENSE_ITEM_APPROVED',
  ExpenseItemUnapproved = 'EXPENSE_ITEM_UNAPPROVED',
  ExpenseUpdatedOnBrand = 'EXPENSE_UPDATED_ON_BRAND',
  ExpenseUpdatedOnProject = 'EXPENSE_UPDATED_ON_PROJECT',
  InvoiceReadyToBeSent = 'INVOICE_READY_TO_BE_SENT',
  NewExpensesToApprove = 'NEW_EXPENSES_TO_APPROVE',
  NewExpenseToApprove = 'NEW_EXPENSE_TO_APPROVE',
  NewRfisToApprove = 'NEW_RFIS_TO_APPROVE',
  NewRfiSubmitted = 'NEW_RFI_SUBMITTED',
  OwbiSpentTimeExceededGivenPercentageOfTotalTime = 'OWBI_SPENT_TIME_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_TIME',
  ProjectAssignedToUser = 'PROJECT_ASSIGNED_TO_USER',
  ProjectCanBeFinished = 'PROJECT_CAN_BE_FINISHED',
  ProjectCreatedFromPipedrive = 'PROJECT_CREATED_FROM_PIPEDRIVE',
  ProjectEndsInThresholdDays = 'PROJECT_ENDS_IN_THRESHOLD_DAYS',
  ProjectWithUnapprovedBudget = 'PROJECT_WITH_UNAPPROVED_BUDGET',
  QuoteStatusChanged = 'QUOTE_STATUS_CHANGED',
  RealExpensesExceededThresholdOnExpenseBudgetItemTypeOther = 'REAL_EXPENSES_EXCEEDED_THRESHOLD_ON_EXPENSE_BUDGET_ITEM_TYPE_OTHER',
  RealExpensesExceededThresholdOnExpenseBudgetItemTypeOtherFirstAlert = 'REAL_EXPENSES_EXCEEDED_THRESHOLD_ON_EXPENSE_BUDGET_ITEM_TYPE_OTHER_FIRST_ALERT',
  RealExpensesExceededThresholdOnExpenseBudgetItemTypeOtherSecondAlert = 'REAL_EXPENSES_EXCEEDED_THRESHOLD_ON_EXPENSE_BUDGET_ITEM_TYPE_OTHER_SECOND_ALERT',
  RealExpensesExceededTotalBudgetOnExpenseBudgetItem = 'REAL_EXPENSES_EXCEEDED_TOTAL_BUDGET_ON_EXPENSE_BUDGET_ITEM',
  RealExpensesExceededTotalBudgetOnExpenseBudgetItemFirstAlert = 'REAL_EXPENSES_EXCEEDED_TOTAL_BUDGET_ON_EXPENSE_BUDGET_ITEM_FIRST_ALERT',
  RealExpensesExceededTotalBudgetOnExpenseBudgetItemSecondAlert = 'REAL_EXPENSES_EXCEEDED_TOTAL_BUDGET_ON_EXPENSE_BUDGET_ITEM_SECOND_ALERT',
  SpentBudgetExceededByThresholdOnProjectWithUnapprovedBudget = 'SPENT_BUDGET_EXCEEDED_BY_THRESHOLD_ON_PROJECT_WITH_UNAPPROVED_BUDGET',
  SpentBudgetExceededByThresholdOnZeroBudgetProject = 'SPENT_BUDGET_EXCEEDED_BY_THRESHOLD_ON_ZERO_BUDGET_PROJECT',
  SpentBudgetExceededGivenPercentageOfTotalBudget = 'SPENT_BUDGET_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_BUDGET',
  SpentBudgetExceededGivenPercentageOfTotalBudgetFirstAlert = 'SPENT_BUDGET_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_BUDGET_FIRST_ALERT',
  SpentBudgetExceededGivenPercentageOfTotalBudgetSecondAlert = 'SPENT_BUDGET_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_BUDGET_SECOND_ALERT',
  TaskAssignedToUser = 'TASK_ASSIGNED_TO_USER',
  TaskAssignedToUserForWatcher = 'TASK_ASSIGNED_TO_USER_FOR_WATCHER',
  TaskAttachmentAdded = 'TASK_ATTACHMENT_ADDED',
  TaskAttachmentAddedForProjectManager = 'TASK_ATTACHMENT_ADDED_FOR_PROJECT_MANAGER',
  TaskAttachmentAddedForTaskAssignee = 'TASK_ATTACHMENT_ADDED_FOR_TASK_ASSIGNEE',
  TaskAttachmentAddedForTaskCreator = 'TASK_ATTACHMENT_ADDED_FOR_TASK_CREATOR',
  TaskAttachmentAddedForTaskWatcher = 'TASK_ATTACHMENT_ADDED_FOR_TASK_WATCHER',
  TaskCommentAdded = 'TASK_COMMENT_ADDED',
  TaskCommentAddedForProjectManager = 'TASK_COMMENT_ADDED_FOR_PROJECT_MANAGER',
  TaskCommentAddedForTaskAssignee = 'TASK_COMMENT_ADDED_FOR_TASK_ASSIGNEE',
  TaskCommentAddedForTaskCreator = 'TASK_COMMENT_ADDED_FOR_TASK_CREATOR',
  TaskCommentAddedForTaskWatcher = 'TASK_COMMENT_ADDED_FOR_TASK_WATCHER',
  TaskCommentMentionedUser = 'TASK_COMMENT_MENTIONED_USER',
  TaskCreatedFromClientUser = 'TASK_CREATED_FROM_CLIENT_USER',
  TaskDeadlineApproaching = 'TASK_DEADLINE_APPROACHING',
  TaskLinkCreated = 'TASK_LINK_CREATED',
  TaskLinkDeleted = 'TASK_LINK_DELETED',
  TaskMentionedUser = 'TASK_MENTIONED_USER',
  TaskPriorityChanged = 'TASK_PRIORITY_CHANGED',
  TaskPriorityChangedForProjectManager = 'TASK_PRIORITY_CHANGED_FOR_PROJECT_MANAGER',
  TaskPriorityChangedForTaskAssignee = 'TASK_PRIORITY_CHANGED_FOR_TASK_ASSIGNEE',
  TaskPriorityChangedForTaskCreator = 'TASK_PRIORITY_CHANGED_FOR_TASK_CREATOR',
  TaskPriorityChangedForTaskWatcher = 'TASK_PRIORITY_CHANGED_FOR_TASK_WATCHER',
  TaskSpentTimeExceededGivenPercentageOfTotalTime = 'TASK_SPENT_TIME_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_TIME',
  TaskStatusChanged = 'TASK_STATUS_CHANGED',
  TaskStatusChangedForProjectManager = 'TASK_STATUS_CHANGED_FOR_PROJECT_MANAGER',
  TaskStatusChangedForTaskAssignee = 'TASK_STATUS_CHANGED_FOR_TASK_ASSIGNEE',
  TaskStatusChangedForTaskCreator = 'TASK_STATUS_CHANGED_FOR_TASK_CREATOR',
  TaskStatusChangedForTaskWatcher = 'TASK_STATUS_CHANGED_FOR_TASK_WATCHER',
  TimerAutostop = 'TIMER_AUTOSTOP'
}

/**
 * OCR extracted expense data from an attachment file.
 * Used to prefill expense form on frontend.
 */
export type OcrExpenseData = {
  __typename?: 'OCRExpenseData';
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_account_code?: Maybe<Scalars['String']['output']>;
  business_form?: Maybe<BusinessFormEnum>;
  city?: Maybe<Scalars['String']['output']>;
  constant_symbol?: Maybe<Scalars['String']['output']>;
  contractor_id?: Maybe<Scalars['ID']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  document_number?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  expense_items?: Maybe<Array<OcrExpenseItemData>>;
  for_approval?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['Date']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  registration_no?: Maybe<Scalars['String']['output']>;
  specific_symbol?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  total_amount_includes_vat?: Maybe<Scalars['Boolean']['output']>;
  total_amount_with_vat_in_currency?: Maybe<Scalars['BigInt']['output']>;
  type?: Maybe<ExpenseTypeEnum>;
  variable_symbol?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OcrExpenseItemData = {
  __typename?: 'OCRExpenseItemData';
  amount?: Maybe<Scalars['Float']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  vat_rate?: Maybe<Scalars['BigInt']['output']>;
};

/** Jednotliva polozka OI budget split pre Time Billing listing */
export type OiBudgetItemForTimeBilling = {
  __typename?: 'OIBudgetItemForTimeBilling';
  amount: Scalars['BigInt']['output'];
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id: Scalars['ID']['output'];
  budget_item_type: BudgetItemTypeEnum;
  outgoingInvoice: OutgoingInvoice;
  outgoing_invoice_id: Scalars['ID']['output'];
};

export type OiBudgetItemsForTimeBillingPaginator = {
  __typename?: 'OIBudgetItemsForTimeBillingPaginator';
  data: Array<OiBudgetItemForTimeBilling>;
  paginatorInfo: PaginatorInfo;
};

export type OiBudgetItemsTimeBillingOrderByClause = {
  column: OiBudgetItemsTimeBillingOrderByColumn;
  order: SortOrder;
};

export enum OiBudgetItemsTimeBillingOrderByColumn {
  Amount = 'AMOUNT',
  BillingAddress = 'BILLING_ADDRESS',
  Brand = 'BRAND',
  BudgetItem = 'BUDGET_ITEM',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Description = 'DESCRIPTION',
  DueDate = 'DUE_DATE',
  InternalNote = 'INTERNAL_NOTE',
  InvoiceNo = 'INVOICE_NO',
  IssueDate = 'ISSUE_DATE',
  LegalEntity = 'LEGAL_ENTITY',
  LockedTimeBilling = 'LOCKED_TIME_BILLING',
  Note = 'NOTE',
  PaidAt = 'PAID_AT',
  PaymentMethod = 'PAYMENT_METHOD',
  Project = 'PROJECT',
  TimeBilling = 'TIME_BILLING'
}

export type OiBudgetItemsTimeBillingQueryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OiBudgetItemsTimeBillingOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OiBudgetItemsTimeBillingWhereConditions>;
};

export enum OiBudgetItemsTimeBillingWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  BudgetItemId = 'BUDGET_ITEM_ID',
  BudgetItemType = 'BUDGET_ITEM_TYPE',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  IssueDate = 'ISSUE_DATE',
  OwnerId = 'OWNER_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectCategory = 'PROJECT_CATEGORY',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type OiBudgetItemsTimeBillingWhereConditions = {
  AND?: InputMaybe<Array<OiBudgetItemsTimeBillingWhereConditions>>;
  OR?: InputMaybe<Array<OiBudgetItemsTimeBillingWhereConditions>>;
  column?: InputMaybe<OiBudgetItemsTimeBillingWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OiProformaQueryArgs = {
  orderBy?: InputMaybe<Array<OutgoingProformaInvoiceOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OiProformaWhereConditions>;
};

export enum OiProformaWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  IssueDate = 'ISSUE_DATE',
  IsExported = 'IS_EXPORTED',
  OwnerId = 'OWNER_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type OiProformaWhereConditions = {
  AND?: InputMaybe<Array<OiProformaWhereConditions>>;
  OR?: InputMaybe<Array<OiProformaWhereConditions>>;
  column?: InputMaybe<OiProformaWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OiQueryArgs = {
  orderBy?: InputMaybe<Array<OutgoingInvoiceOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OiWhereConditions>;
};

export enum OiWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  IssueDate = 'ISSUE_DATE',
  IsExported = 'IS_EXPORTED',
  OwnerId = 'OWNER_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectCategory = 'PROJECT_CATEGORY',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type OiWhereConditions = {
  AND?: InputMaybe<Array<OiWhereConditions>>;
  OR?: InputMaybe<Array<OiWhereConditions>>;
  column?: InputMaybe<OiWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Order = {
  __typename?: 'Order';
  brand: Brand;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  date_of_order?: Maybe<Scalars['Date']['output']>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  outgoingInvoices: Array<OutgoingInvoice>;
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  purchase_order_no?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  urls: MediaUrlList;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OrderOrderByClause = {
  column: OrderOrderByColumnEnum;
  order: SortOrder;
};

export enum OrderOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  DateOfOrder = 'DATE_OF_ORDER',
  PurchaseOrderNo = 'PURCHASE_ORDER_NO'
}

/** A paginated list of Order items. */
export type OrderPaginator = {
  __typename?: 'OrderPaginator';
  /** A list of Order items. */
  data: Array<Order>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OrderQueryArgs = {
  orderBy?: InputMaybe<Array<OrderOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrdersWhereConditions>;
};

export type OrderSimple = {
  __typename?: 'OrderSimple';
  id: Scalars['ID']['output'];
  purchase_order_no?: Maybe<Scalars['String']['output']>;
};

export type OrdersSummary = {
  __typename?: 'OrdersSummary';
  orderIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum OrdersWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  DateOfOrder = 'DATE_OF_ORDER',
  ProjectId = 'PROJECT_ID'
}

export type OrdersWhereConditions = {
  AND?: InputMaybe<Array<OrdersWhereConditions>>;
  OR?: InputMaybe<Array<OrdersWhereConditions>>;
  column?: InputMaybe<OrdersWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OtherDocument = Document & {
  __typename?: 'OtherDocument';
  brands?: Maybe<Array<Maybe<Brand>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  contractors?: Maybe<Array<Maybe<Contractor>>>;
  created_at: Scalars['DateTime']['output'];
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  urls: MediaUrlList;
};

export type OtherDocumentOrderByClause = {
  column: OtherDocumentOrderByColumnEnum;
  order: SortOrder;
};

export enum OtherDocumentOrderByColumnEnum {
  Title = 'TITLE'
}

/** A paginated list of OtherDocument items. */
export type OtherDocumentPaginator = {
  __typename?: 'OtherDocumentPaginator';
  /** A list of OtherDocument items. */
  data: Array<OtherDocument>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OtherDocumentQueryArgs = {
  orderBy?: InputMaybe<Array<OtherDocumentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OtherDocumentsWhereConditions>;
};

export type OtherDocumentsSummary = {
  __typename?: 'OtherDocumentsSummary';
  otherDocumentIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum OtherDocumentsWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  ProjectId = 'PROJECT_ID'
}

export type OtherDocumentsWhereConditions = {
  AND?: InputMaybe<Array<OtherDocumentsWhereConditions>>;
  OR?: InputMaybe<Array<OtherDocumentsWhereConditions>>;
  column?: InputMaybe<OtherDocumentsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OtherPeopleTracked = {
  __typename?: 'OtherPeopleTracked';
  time_tracking_work_type_id: Scalars['ID']['output'];
  tracked_time: Scalars['BigInt']['output'];
  user: User;
};

export type OurWorkBudgetCategory = BudgetCategory & {
  __typename?: 'OurWorkBudgetCategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  new_budget_creation_enabled: Scalars['Boolean']['output'];
  shortcut: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OurWorkBudgetItem = BudgetItemForExpenseInterface & BudgetItemInterface & {
  __typename?: 'OurWorkBudgetItem';
  availableTimeTrackingWorkTypes?: Maybe<Array<TimeTrackingRate>>;
  budget_positions: Array<BudgetPosition>;
  category: OurWorkBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  /** @deprecated No longer supported */
  currentWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  deadline?: Maybe<Scalars['Date']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empty unless requested for deletion. */
  deletion_blockers: Array<BudgetItemDeletionBlockerEnum>;
  expenseStats: Array<OurWorkBudgetItemExpenseStats>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceStats: Array<OurWorkBudgetItemInvoiceStats>;
  item_code?: Maybe<Scalars['String']['output']>;
  lastWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  outgoingProformaInvoiceStats: Array<OurWorkBudgetItemProformaStats>;
  payment_status: ExpenseInvoiceStatusEnum;
  plannedExpenses: Array<BudgetItemPlannedExpense>;
  prepaymentStats: Array<OurWorkBudgetItemPrepaymentStats>;
  project: Project;
  requested_for_deletion_at?: Maybe<Scalars['DateTime']['output']>;
  stats: OurWorkBudgetItemStats;
  tasks: Array<Task>;
  timeTrackingSettings: TimeTrackingBudgetItem;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
};

export type OurWorkBudgetItemExpenseStats = {
  __typename?: 'OurWorkBudgetItemExpenseStats';
  amount: Scalars['BigInt']['output'];
  expense: Expense;
  expense_item_amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<TimeTrackingWorkType>;
  report_date?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<Task>;
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
};

export type OurWorkBudgetItemForPlanovac = {
  __typename?: 'OurWorkBudgetItemForPlanovac';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  timeTrackingSettings: TimeTrackingBudgetItemForPlanovac;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OurWorkBudgetItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  our_work_budget_category_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  total_budget: Scalars['BigInt']['input'];
};

export type OurWorkBudgetItemInvoiceStats = {
  __typename?: 'OurWorkBudgetItemInvoiceStats';
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
  outgoingInvoice: OutgoingInvoice;
};

export type OurWorkBudgetItemLimited = {
  __typename?: 'OurWorkBudgetItemLimited';
  availablepositions: Array<TimeTrackingWorkType>;
  category_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type OurWorkBudgetItemOverview = BudgetItemInterface & {
  __typename?: 'OurWorkBudgetItemOverview';
  budget_positions: Array<BudgetPosition>;
  category: OurWorkBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  /** @deprecated No longer supported */
  currentWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  deadline?: Maybe<Scalars['Date']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empty unless requested for deletion. */
  deletion_blockers: Array<BudgetItemDeletionBlockerEnum>;
  done_task_count: Scalars['Int']['output'];
  expenseStats: Array<OurWorkBudgetItemExpenseStats>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceStats: Array<OurWorkBudgetItemInvoiceStats>;
  item_code?: Maybe<Scalars['String']['output']>;
  lastWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  plannedExpenses: Array<BudgetItemPlannedExpense>;
  prepaymentStats: Array<OurWorkBudgetItemPrepaymentStats>;
  project: Project;
  requested_for_deletion_at?: Maybe<Scalars['DateTime']['output']>;
  stats: OurWorkBudgetItemStats;
  task_count: Scalars['Int']['output'];
  tasks: Array<Task>;
  timeTrackingSettings: TimeTrackingBudgetItem;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OurWorkBudgetItemPrepaymentStats = {
  __typename?: 'OurWorkBudgetItemPrepaymentStats';
  brandCreditAccount: BrandCreditAccount;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
};

export type OurWorkBudgetItemProformaStats = {
  __typename?: 'OurWorkBudgetItemProformaStats';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoice_no: Scalars['String']['output'];
};

export type OurWorkBudgetItemSimple = {
  __typename?: 'OurWorkBudgetItemSimple';
  category: OurWorkBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  project?: Maybe<ProjectSimple>;
  stats: OurWorkBudgetItemStats;
  tasks: Array<TaskSimple>;
  timeTrackingSettings: TimeTrackingBudgetItem;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OurWorkBudgetItemStats = CreditStats & OurWorkStatsInterface & {
  __typename?: 'OurWorkBudgetItemStats';
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  credit_direct: Scalars['BigInt']['output'];
  credit_from_prepayments: Scalars['BigInt']['output'];
  efficiency_percent: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  net_margin_percent: Scalars['BigInt']['output'];
  net_profit: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export type OurWorkBudgetItemWithRevenue = {
  __typename?: 'OurWorkBudgetItemWithRevenue';
  billings_for_date_range?: Maybe<Scalars['BigInt']['output']>;
  ourWorkBudgetItem: OurWorkBudgetItem;
  revenue_for_date_range?: Maybe<Scalars['BigInt']['output']>;
};

export type OurWorkBudgetSplitInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in_percent?: InputMaybe<Scalars['BigInt']['input']>;
  budget_positions?: InputMaybe<Array<BudgetPositionsInput>>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
};

export type OurWorkOverviewBudgetItem = {
  __typename?: 'OurWorkOverviewBudgetItem';
  budgetItems: Array<OurWorkBudgetItemOverview>;
  budget_category_id: Scalars['ID']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profit: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type OurWorkStatsInterface = {
  budget_exceeded: Scalars['BigInt']['output'];
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
};

export type OurWorkStructuredBudgetItem = {
  __typename?: 'OurWorkStructuredBudgetItem';
  budgetItems: Array<OurWorkBudgetItem>;
  budget_category_id: Scalars['ID']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profit: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type OurWorkTopProject = {
  __typename?: 'OurWorkTopProject';
  value: Scalars['BigInt']['output'];
};

export type OutgoingInvoice = {
  __typename?: 'OutgoingInvoice';
  abraflexi_exported?: Maybe<Scalars['Boolean']['output']>;
  accountMoves?: Maybe<Array<BankAccountMoveDocument>>;
  billingEntity: BillingEntity;
  brands: Array<Brand>;
  budget_positions: Array<BudgetPosition>;
  city: Scalars['String']['output'];
  client: Client;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  credit_note_outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  date_of_supply: Scalars['Date']['output'];
  /** Export history for this outgoing invoice */
  documentExports: Array<DocumentExport>;
  due_date: Scalars['Date']['output'];
  emailLogs: Array<OutgoingInvoiceEmailLog>;
  exchange_rate: Scalars['BigInt']['output'];
  exchange_rate_source: ExchangeRateSource;
  expenseBudgetSplits: Array<OutgoingInvoiceExpenseBudgetSplitItem>;
  filesToAttach: Array<AssignableFile>;
  has_proforma_payments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<OutgoingInvoiceItem>;
  invoicePaymentMethod?: Maybe<InvoicePaymentMethod>;
  invoicePdf?: Maybe<MediaUrlList>;
  invoiceProofOfPayments: Array<AttachedProofOfPaymentPivot>;
  invoice_no: Scalars['String']['output'];
  invoice_order_sequence_id: Scalars['ID']['output'];
  issue_date: Scalars['Date']['output'];
  legal_name: Scalars['String']['output'];
  modelLock?: Maybe<ModelLock>;
  note?: Maybe<Scalars['String']['output']>;
  old_invoice_alert_while_editing: Scalars['Boolean']['output'];
  orders: Array<Order>;
  ourWorkBudgetSplits: Array<OutgoingInvoiceOurWorkBudgetSplitItem>;
  owner: User;
  paid_at?: Maybe<Scalars['Date']['output']>;
  payment_status: PaymentStatusEnum;
  prepaymentSplits: Array<OutgoingInvoicePrepaymentSplitItem>;
  proformaInvoicesPivot: Array<AttachedOutgoingProformaInvoicePivot>;
  projectTimeBilling?: Maybe<ProjectTimeBilling>;
  projects: Array<Project>;
  registration_no?: Maybe<Scalars['String']['output']>;
  relatesToOutgoingProformaInvoice?: Maybe<OutgoingProformaInvoice>;
  request_for_invoicing_created_date?: Maybe<Scalars['Date']['output']>;
  request_for_invoicing_submit_date?: Maybe<Scalars['Date']['output']>;
  sequence?: Maybe<Sequence>;
  show_billing_accounting: Scalars['Boolean']['output'];
  show_unit_price: Scalars['Boolean']['output'];
  stats: OutgoingInvoiceStats;
  street: Scalars['String']['output'];
  summaryInvoicesForProofOfPayment?: Maybe<Array<OutgoingInvoice>>;
  tax_no?: Maybe<Scalars['String']['output']>;
  teams: Array<Team>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  timeMaterialsInvoiceData?: Maybe<TimeMaterialsInvoiceData>;
  total_in_words?: Maybe<Scalars['String']['output']>;
  type: OutgoingInvoiceTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  vat_reverse_charge: Scalars['Boolean']['output'];
  workspace_bank_account_id: Scalars['ID']['output'];
  workspace_company_id: Scalars['ID']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
  workspace_exchange_rate_source: ExchangeRateSource;
  xero_exported?: Maybe<Scalars['Boolean']['output']>;
  zip: Scalars['String']['output'];
};


export type OutgoingInvoiceEmailLogsArgs = {
  type?: InputMaybe<EmailLogTypeEnum>;
};

export type OutgoingInvoiceBudgetSplitItem = {
  amount: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OutgoingInvoiceEmailLog = {
  __typename?: 'OutgoingInvoiceEmailLog';
  accepted_delivery: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  recipientLog?: Maybe<Array<RecipientLog>>;
  recipients: Array<Recipient>;
  sent_at: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type OutgoingInvoiceExpenseBudgetSplitItem = OutgoingInvoiceBudgetSplitItem & {
  __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem';
  amount: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  expense_budget_item_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OutgoingInvoiceItem = {
  __typename?: 'OutgoingInvoiceItem';
  accounting_account_id?: Maybe<Scalars['ID']['output']>;
  accounting_centre_id?: Maybe<Scalars['ID']['output']>;
  amount_in_currency: Scalars['BigInt']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  tag_ids?: Maybe<Array<Scalars['ID']['output']>>;
  unit_price?: Maybe<Scalars['BigInt']['output']>;
  vat_in_currency: Scalars['BigInt']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
};

export type OutgoingInvoiceOrderByClause = {
  column: OutgoingInvoiceOrderByColumnEnum;
  order: SortOrder;
};

export enum OutgoingInvoiceOrderByColumnEnum {
  Amount = 'AMOUNT',
  AmountWithVat = 'AMOUNT_WITH_VAT',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  InvoiceNo = 'INVOICE_NO',
  IssueDate = 'ISSUE_DATE',
  PaymentStatus = 'PAYMENT_STATUS'
}

export type OutgoingInvoiceOurWorkBudgetSplitItem = OutgoingInvoiceBudgetSplitItem & {
  __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem';
  amount: Scalars['BigInt']['output'];
  amount_in_percent?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  our_work_budget_item_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of OutgoingInvoice items. */
export type OutgoingInvoicePaginator = {
  __typename?: 'OutgoingInvoicePaginator';
  /** A list of OutgoingInvoice items. */
  data: Array<OutgoingInvoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OutgoingInvoicePrepaymentSplitItem = {
  __typename?: 'OutgoingInvoicePrepaymentSplitItem';
  amount: Scalars['BigInt']['output'];
  amount_left: Scalars['BigInt']['output'];
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  brand_credit_account_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OutgoingInvoiceStats = {
  __typename?: 'OutgoingInvoiceStats';
  billing_amount: Scalars['BigInt']['output'];
  billing_amount_in_currency: Scalars['BigInt']['output'];
  billing_amount_vat: Scalars['BigInt']['output'];
  billing_amount_vat_in_currency: Scalars['BigInt']['output'];
  billing_amount_with_vat: Scalars['BigInt']['output'];
  billing_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  budget_splits_amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoice_exchange_rate: Scalars['BigInt']['output'];
  prepayment_splits_amount: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_by_workspace_rate: Scalars['BigInt']['output'];
  total_amount_in_currency: Scalars['BigInt']['output'];
  total_amount_in_currency_to_pay: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_amount_with_vat_by_workspace_rate: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency_to_pay: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency_to_pay_from_proforma_payments: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  total_vat_by_workspace_rate: Scalars['BigInt']['output'];
  total_vat_in_currency: Scalars['BigInt']['output'];
  total_vat_in_currency_to_pay_from_proforma_payments: Scalars['BigInt']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  workspace_exchange_rate: Scalars['BigInt']['output'];
};

export enum OutgoingInvoiceTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE',
  ProformaPayment = 'PROFORMA_PAYMENT'
}

export type OutgoingInvoicesSummary = {
  __typename?: 'OutgoingInvoicesSummary';
  billing_amount: Scalars['BigInt']['output'];
  billing_amount_vat: Scalars['BigInt']['output'];
  billing_amount_with_vat: Scalars['BigInt']['output'];
  invoices: Scalars['BigInt']['output'];
  outgoingInvoiceIds: Array<Scalars['ID']['output']>;
  outgoingInvoiceInvoiceMediaIds: Array<Scalars['ID']['output']>;
  overdue: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_vat: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_without_vat: Scalars['BigInt']['output'];
  overdue_vat: Scalars['BigInt']['output'];
  overdue_without_vat: Scalars['BigInt']['output'];
  paid_amount: Scalars['BigInt']['output'];
  payments_due: Scalars['BigInt']['output'];
  payments_due_vat: Scalars['BigInt']['output'];
  payments_due_without_vat: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  unpaid_amount: Scalars['BigInt']['output'];
};

export type OutgoingProformaInvoice = {
  __typename?: 'OutgoingProformaInvoice';
  abraflexi_exported?: Maybe<Scalars['Boolean']['output']>;
  accountMoves?: Maybe<Array<BankAccountMoveDocument>>;
  billingEntity: BillingEntity;
  brands: Array<Brand>;
  budget_positions: Array<BudgetPosition>;
  city: Scalars['String']['output'];
  client: Client;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  /** Export history for this outgoing proforma invoice */
  documentExports: Array<DocumentExport>;
  due_date: Scalars['Date']['output'];
  emailLogs: Array<OutgoingInvoiceEmailLog>;
  exchange_rate: Scalars['BigInt']['output'];
  exchange_rate_source: ExchangeRateSource;
  expenseBudgetSplits?: Maybe<Array<RequestForInvoicingExpenseBudgetSplitItem>>;
  filesToAttach: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<OutgoingInvoiceItem>;
  invoicePaymentMethod?: Maybe<InvoicePaymentMethod>;
  invoicePdf?: Maybe<MediaUrlList>;
  invoice_no: Scalars['String']['output'];
  invoice_order_sequence_id: Scalars['ID']['output'];
  issue_date: Scalars['Date']['output'];
  legal_name: Scalars['String']['output'];
  modelLock?: Maybe<ModelLock>;
  note?: Maybe<Scalars['String']['output']>;
  ourWorkBudgetSplits?: Maybe<Array<RequestForInvoicingOurWorkBudgetSplitItem>>;
  owner: User;
  paid_at?: Maybe<Scalars['Date']['output']>;
  payment_status: PaymentStatusEnum;
  prepaymentSplits?: Maybe<Array<RequestForInvoicingPrepaymentSplitItem>>;
  projects: Array<Project>;
  proofOfPayments?: Maybe<Array<OutgoingInvoice>>;
  registration_no?: Maybe<Scalars['String']['output']>;
  request_for_invoicing_created_date?: Maybe<Scalars['Date']['output']>;
  request_for_invoicing_submit_date?: Maybe<Scalars['Date']['output']>;
  show_billing_accounting: Scalars['Boolean']['output'];
  show_unit_price: Scalars['Boolean']['output'];
  stats: OutgoingProformaInvoiceStats;
  street: Scalars['String']['output'];
  summaryInvoices?: Maybe<Array<OutgoingInvoice>>;
  tax_no?: Maybe<Scalars['String']['output']>;
  teams: Array<Team>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  vat_reverse_charge: Scalars['Boolean']['output'];
  workspace_bank_account_id: Scalars['ID']['output'];
  workspace_company_id: Scalars['ID']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
  workspace_exchange_rate_source: ExchangeRateSource;
  zip: Scalars['String']['output'];
};


export type OutgoingProformaInvoiceEmailLogsArgs = {
  type?: InputMaybe<EmailLogTypeEnum>;
};

export type OutgoingProformaInvoiceOrderByClause = {
  column: OutgoingProformaInvoiceOrderByColumnEnum;
  order: SortOrder;
};

export enum OutgoingProformaInvoiceOrderByColumnEnum {
  Amount = 'AMOUNT',
  AmountWithVat = 'AMOUNT_WITH_VAT',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  InvoiceNo = 'INVOICE_NO',
  IssueDate = 'ISSUE_DATE',
  PaymentStatus = 'PAYMENT_STATUS',
  UnusedAmount = 'UNUSED_AMOUNT',
  UnusedAmountInCurrency = 'UNUSED_AMOUNT_IN_CURRENCY'
}

/** A paginated list of OutgoingProformaInvoice items. */
export type OutgoingProformaInvoicePaginator = {
  __typename?: 'OutgoingProformaInvoicePaginator';
  /** A list of OutgoingProformaInvoice items. */
  data: Array<OutgoingProformaInvoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OutgoingProformaInvoiceStats = {
  __typename?: 'OutgoingProformaInvoiceStats';
  id: Scalars['ID']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_in_currency: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  total_vat_in_currency: Scalars['BigInt']['output'];
  unused_amount: Scalars['BigInt']['output'];
  unused_amount_in_currency: Scalars['BigInt']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  workspace_exchange_rate: Scalars['BigInt']['output'];
};

export type OutgoingProformaInvoicesSummary = {
  __typename?: 'OutgoingProformaInvoicesSummary';
  invoices: Scalars['BigInt']['output'];
  outgoingInvoiceIds: Array<Scalars['ID']['output']>;
  outgoingInvoiceInvoiceMediaIds: Array<Scalars['ID']['output']>;
  overdue_by_31_to_90_days: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days: Scalars['BigInt']['output'];
  payments_due: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']['output'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export enum PaymentOrderProviderEnum {
  Abo = 'ABO',
  AboStandard = 'ABO_STANDARD',
  SepaIso = 'SEPA_ISO'
}

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  default_payment_due?: Maybe<Scalars['String']['output']>;
  domestic_payment_order_provider?: Maybe<PaymentOrderProviderEnum>;
  foreign_payment_order_provider?: Maybe<PaymentOrderProviderEnum>;
};

export enum PaymentStatusEnum {
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_name?: Maybe<ExpensePaymentTypeEnum>;
};

export type PeriodSummary = {
  __typename?: 'PeriodSummary';
  is_period_closed: Scalars['Boolean']['output'];
  is_period_locked: Scalars['Boolean']['output'];
  is_previous_period_closed?: Maybe<Scalars['Boolean']['output']>;
  is_previous_period_locked?: Maybe<Scalars['Boolean']['output']>;
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_billable: Scalars['BigInt']['output'];
  progress_change: Scalars['BigInt']['output'];
  progress_change_billable: Scalars['BigInt']['output'];
  work_spent: Scalars['BigInt']['output'];
};

export type PermissionList = {
  __typename?: 'PermissionList';
  assignableFile_create: Scalars['Boolean']['output'];
  assignableFile_delete_all: Scalars['Boolean']['output'];
  assignableFile_delete_own: Scalars['Boolean']['output'];
  bank_read_all: Scalars['Boolean']['output'];
  billingPlan_create: Scalars['Boolean']['output'];
  billingPlan_listing: Scalars['Boolean']['output'];
  billingPlan_update: Scalars['Boolean']['output'];
  brandCreditAccount_create: Scalars['Boolean']['output'];
  brandCreditAccount_delete_all: Scalars['Boolean']['output'];
  brandCreditAccount_delete_own: Scalars['Boolean']['output'];
  brandCreditAccount_delete_team: Scalars['Boolean']['output'];
  brandCreditAccount_read_all: Scalars['Boolean']['output'];
  brandCreditAccount_read_own: Scalars['Boolean']['output'];
  brandCreditAccount_read_team: Scalars['Boolean']['output'];
  brandCreditAccount_setBudgetCategories: Scalars['Boolean']['output'];
  brandCreditAccount_update_all: Scalars['Boolean']['output'];
  brandCreditAccount_update_own: Scalars['Boolean']['output'];
  brandCreditAccount_update_team: Scalars['Boolean']['output'];
  brand_archive: Scalars['Boolean']['output'];
  brand_create: Scalars['Boolean']['output'];
  brand_delete: Scalars['Boolean']['output'];
  brand_read: Scalars['Boolean']['output'];
  brand_update: Scalars['Boolean']['output'];
  brand_updateManagers: Scalars['Boolean']['output'];
  budget_read_all: Scalars['Boolean']['output'];
  budget_read_own: Scalars['Boolean']['output'];
  budget_read_team: Scalars['Boolean']['output'];
  client_create: Scalars['Boolean']['output'];
  client_delete: Scalars['Boolean']['output'];
  client_read: Scalars['Boolean']['output'];
  client_update: Scalars['Boolean']['output'];
  client_updateManagers: Scalars['Boolean']['output'];
  contract_create: Scalars['Boolean']['output'];
  contract_delete: Scalars['Boolean']['output'];
  contract_read: Scalars['Boolean']['output'];
  contract_update: Scalars['Boolean']['output'];
  contractor_create: Scalars['Boolean']['output'];
  contractor_delete: Scalars['Boolean']['output'];
  contractor_read: Scalars['Boolean']['output'];
  contractor_update: Scalars['Boolean']['output'];
  credit_prepayment: Scalars['Boolean']['output'];
  credit_transfer_betweenTeams: Scalars['Boolean']['output'];
  credit_transfer_fromBrandCreditAccount: Scalars['Boolean']['output'];
  credit_transfer_fromBudgetItem: Scalars['Boolean']['output'];
  credit_transfer_withDate: Scalars['Boolean']['output'];
  expense_accessAccountingAttributes: Scalars['Boolean']['output'];
  expense_accessImported: Scalars['Boolean']['output'];
  expense_approve: Scalars['Boolean']['output'];
  expense_canApproveBudgetItem: Scalars['Boolean']['output'];
  expense_create: Scalars['Boolean']['output'];
  expense_deleteFiles: Scalars['Boolean']['output'];
  expense_delete_all: Scalars['Boolean']['output'];
  expense_delete_own: Scalars['Boolean']['output'];
  expense_delete_team: Scalars['Boolean']['output'];
  expense_markAsPaid: Scalars['Boolean']['output'];
  expense_modelLock: Scalars['Boolean']['output'];
  expense_read_all: Scalars['Boolean']['output'];
  expense_read_excludeRestrictedTeams: Scalars['Boolean']['output'];
  expense_read_own: Scalars['Boolean']['output'];
  expense_read_team: Scalars['Boolean']['output'];
  expense_update_all: Scalars['Boolean']['output'];
  expense_update_own: Scalars['Boolean']['output'];
  expense_update_team: Scalars['Boolean']['output'];
  integration_budgetovac: Scalars['Boolean']['output'];
  integration_forecasting: Scalars['Boolean']['output'];
  notificationSetting_query: Scalars['Boolean']['output'];
  notificationSetting_update: Scalars['Boolean']['output'];
  order_create: Scalars['Boolean']['output'];
  order_delete: Scalars['Boolean']['output'];
  order_read: Scalars['Boolean']['output'];
  order_update: Scalars['Boolean']['output'];
  otherDocument_create: Scalars['Boolean']['output'];
  otherDocument_delete: Scalars['Boolean']['output'];
  otherDocument_read: Scalars['Boolean']['output'];
  otherDocument_update: Scalars['Boolean']['output'];
  outgoingInvoice_accessAccountingAttributes: Scalars['Boolean']['output'];
  outgoingInvoice_create: Scalars['Boolean']['output'];
  outgoingInvoice_delete_all: Scalars['Boolean']['output'];
  outgoingInvoice_delete_own: Scalars['Boolean']['output'];
  outgoingInvoice_delete_team: Scalars['Boolean']['output'];
  outgoingInvoice_markAsPaid: Scalars['Boolean']['output'];
  outgoingInvoice_modelLock: Scalars['Boolean']['output'];
  outgoingInvoice_read_all: Scalars['Boolean']['output'];
  outgoingInvoice_read_own: Scalars['Boolean']['output'];
  outgoingInvoice_read_team: Scalars['Boolean']['output'];
  outgoingInvoice_sendToClient: Scalars['Boolean']['output'];
  outgoingInvoice_updateInvoiceNumber: Scalars['Boolean']['output'];
  outgoingInvoice_update_all: Scalars['Boolean']['output'];
  outgoingInvoice_update_own: Scalars['Boolean']['output'];
  outgoingInvoice_update_team: Scalars['Boolean']['output'];
  planning_complete_all: Scalars['Boolean']['output'];
  planning_complete_own: Scalars['Boolean']['output'];
  planning_create_all: Scalars['Boolean']['output'];
  planning_create_own: Scalars['Boolean']['output'];
  planning_delete_all: Scalars['Boolean']['output'];
  planning_delete_own: Scalars['Boolean']['output'];
  planning_play_own: Scalars['Boolean']['output'];
  planning_read_all: Scalars['Boolean']['output'];
  planning_read_own: Scalars['Boolean']['output'];
  planning_show_daily_capacity: Scalars['Boolean']['output'];
  planning_update_all: Scalars['Boolean']['output'];
  planning_update_own: Scalars['Boolean']['output'];
  profitLossReport_query_all: Scalars['Boolean']['output'];
  projectCategory_create: Scalars['Boolean']['output'];
  projectCategory_delete: Scalars['Boolean']['output'];
  projectCategory_query: Scalars['Boolean']['output'];
  projectCategory_update: Scalars['Boolean']['output'];
  project_accessAccountingAttributes: Scalars['Boolean']['output'];
  project_archive_all: Scalars['Boolean']['output'];
  project_archive_own: Scalars['Boolean']['output'];
  project_archive_team: Scalars['Boolean']['output'];
  project_billingTime_lock: Scalars['Boolean']['output'];
  project_budget_completeExpenseBudgetItem_all: Scalars['Boolean']['output'];
  project_budget_completeExpenseBudgetItem_own: Scalars['Boolean']['output'];
  project_budget_completeExpenseBudgetItem_team: Scalars['Boolean']['output'];
  project_budget_reopenExpenseBudgetItem_all: Scalars['Boolean']['output'];
  project_budget_reopenExpenseBudgetItem_own: Scalars['Boolean']['output'];
  project_budget_reopenExpenseBudgetItem_team: Scalars['Boolean']['output'];
  project_budget_update_all: Scalars['Boolean']['output'];
  project_budget_update_own: Scalars['Boolean']['output'];
  project_budget_update_team: Scalars['Boolean']['output'];
  project_create_all: Scalars['Boolean']['output'];
  project_create_own: Scalars['Boolean']['output'];
  project_create_team: Scalars['Boolean']['output'];
  project_delete_all: Scalars['Boolean']['output'];
  project_delete_own: Scalars['Boolean']['output'];
  project_delete_team: Scalars['Boolean']['output'];
  project_duplicate_all: Scalars['Boolean']['output'];
  project_duplicate_own: Scalars['Boolean']['output'];
  project_duplicate_team: Scalars['Boolean']['output'];
  project_finish_all: Scalars['Boolean']['output'];
  project_finish_own: Scalars['Boolean']['output'];
  project_finish_team: Scalars['Boolean']['output'];
  project_lockBillingPlan: Scalars['Boolean']['output'];
  project_pin_all: Scalars['Boolean']['output'];
  project_pin_own: Scalars['Boolean']['output'];
  project_pin_team: Scalars['Boolean']['output'];
  project_read_all: Scalars['Boolean']['output'];
  project_read_excludeRestrictedTeams: Scalars['Boolean']['output'];
  project_read_own: Scalars['Boolean']['output'];
  project_read_team: Scalars['Boolean']['output'];
  project_reopen_all: Scalars['Boolean']['output'];
  project_reopen_own: Scalars['Boolean']['output'];
  project_reopen_team: Scalars['Boolean']['output'];
  project_timeTrackingReport_read_all: Scalars['Boolean']['output'];
  project_timeTrackingReport_read_own: Scalars['Boolean']['output'];
  project_timeTrackingReport_read_team: Scalars['Boolean']['output'];
  project_update_all: Scalars['Boolean']['output'];
  project_update_own: Scalars['Boolean']['output'];
  project_update_team: Scalars['Boolean']['output'];
  project_viewAllFields: Scalars['Boolean']['output'];
  quote_create_withoutInternalApproved: Scalars['Boolean']['output'];
  quote_manualApprove: Scalars['Boolean']['output'];
  requestForInvoicing_accessAccountingAttributes: Scalars['Boolean']['output'];
  requestForInvoicing_create_all: Scalars['Boolean']['output'];
  requestForInvoicing_create_own: Scalars['Boolean']['output'];
  requestForInvoicing_create_team: Scalars['Boolean']['output'];
  requestForInvoicing_delete_all: Scalars['Boolean']['output'];
  requestForInvoicing_delete_own: Scalars['Boolean']['output'];
  requestForInvoicing_delete_team: Scalars['Boolean']['output'];
  requestForInvoicing_querySubmittedCount_all: Scalars['Boolean']['output'];
  requestForInvoicing_querySubmittedCount_own: Scalars['Boolean']['output'];
  requestForInvoicing_read_all: Scalars['Boolean']['output'];
  requestForInvoicing_read_own: Scalars['Boolean']['output'];
  requestForInvoicing_read_team: Scalars['Boolean']['output'];
  requestForInvoicing_update_all: Scalars['Boolean']['output'];
  requestForInvoicing_update_own: Scalars['Boolean']['output'];
  requestForInvoicing_update_team: Scalars['Boolean']['output'];
  taskComment_create: Scalars['Boolean']['output'];
  taskComment_delete_all?: Maybe<Scalars['Boolean']['output']>;
  taskComment_delete_own: Scalars['Boolean']['output'];
  taskComment_update_all: Scalars['Boolean']['output'];
  taskComment_update_own: Scalars['Boolean']['output'];
  task_create_all: Scalars['Boolean']['output'];
  task_create_scoped: Scalars['Boolean']['output'];
  task_delete_all: Scalars['Boolean']['output'];
  task_delete_own: Scalars['Boolean']['output'];
  task_read_all: Scalars['Boolean']['output'];
  task_read_own: Scalars['Boolean']['output'];
  task_update_all: Scalars['Boolean']['output'];
  task_update_current_assignee_all: Scalars['Boolean']['output'];
  task_update_current_assignee_own: Scalars['Boolean']['output'];
  task_update_own: Scalars['Boolean']['output'];
  task_update_scoped: Scalars['Boolean']['output'];
  task_update_status_all: Scalars['Boolean']['output'];
  task_update_status_own: Scalars['Boolean']['output'];
  task_viewAllFields: Scalars['Boolean']['output'];
  timeTracking_create_all: Scalars['Boolean']['output'];
  timeTracking_create_own: Scalars['Boolean']['output'];
  timeTracking_create_team: Scalars['Boolean']['output'];
  timeTracking_delete_all: Scalars['Boolean']['output'];
  timeTracking_delete_own: Scalars['Boolean']['output'];
  timeTracking_delete_team: Scalars['Boolean']['output'];
  timeTracking_read_all: Scalars['Boolean']['output'];
  timeTracking_read_own: Scalars['Boolean']['output'];
  timeTracking_read_team: Scalars['Boolean']['output'];
  timeTracking_report_read_all: Scalars['Boolean']['output'];
  timeTracking_report_read_own: Scalars['Boolean']['output'];
  timeTracking_report_read_team: Scalars['Boolean']['output'];
  timeTracking_timer_use_all: Scalars['Boolean']['output'];
  timeTracking_timer_use_manual: Scalars['Boolean']['output'];
  timeTracking_timer_use_own: Scalars['Boolean']['output'];
  timeTracking_timer_use_team: Scalars['Boolean']['output'];
  timeTracking_update_all: Scalars['Boolean']['output'];
  timeTracking_update_own: Scalars['Boolean']['output'];
  timeTracking_update_team: Scalars['Boolean']['output'];
  timeTracking_userMonthlyReport_read: Scalars['Boolean']['output'];
  user_accessAccountingAttributes: Scalars['Boolean']['output'];
  user_create: Scalars['Boolean']['output'];
  user_delete: Scalars['Boolean']['output'];
  user_haveProjectsAssigned: Scalars['Boolean']['output'];
  user_password_update: Scalars['Boolean']['output'];
  user_profile_read: Scalars['Boolean']['output'];
  user_profile_update: Scalars['Boolean']['output'];
  user_read_all: Scalars['Boolean']['output'];
  user_read_own: Scalars['Boolean']['output'];
  user_scopeCreate: Scalars['Boolean']['output'];
  user_scope_all: Scalars['Boolean']['output'];
  user_scope_own: Scalars['Boolean']['output'];
  user_updateAllfredData: Scalars['Boolean']['output'];
  user_updatePersonalData: Scalars['Boolean']['output'];
  user_updatePlanningData: Scalars['Boolean']['output'];
  user_updateScopeUser: Scalars['Boolean']['output'];
  user_updateWorkData: Scalars['Boolean']['output'];
  user_update_all: Scalars['Boolean']['output'];
  user_update_own: Scalars['Boolean']['output'];
  utilizationReportProfit_query_all: Scalars['Boolean']['output'];
  utilizationReport_query_all: Scalars['Boolean']['output'];
  utilizationReport_query_own: Scalars['Boolean']['output'];
  utilizationReport_query_team: Scalars['Boolean']['output'];
  wip_close_all: Scalars['Boolean']['output'];
  wip_close_own: Scalars['Boolean']['output'];
  wip_close_team: Scalars['Boolean']['output'];
  wip_lock_all: Scalars['Boolean']['output'];
  wip_lock_own: Scalars['Boolean']['output'];
  wip_lock_team: Scalars['Boolean']['output'];
  wip_open_all: Scalars['Boolean']['output'];
  wip_open_own: Scalars['Boolean']['output'];
  wip_open_team: Scalars['Boolean']['output'];
  wip_read_all: Scalars['Boolean']['output'];
  wip_read_own: Scalars['Boolean']['output'];
  wip_read_team: Scalars['Boolean']['output'];
  wip_submit_all: Scalars['Boolean']['output'];
  wip_submit_own: Scalars['Boolean']['output'];
  wip_submit_team: Scalars['Boolean']['output'];
  wip_unlock_all: Scalars['Boolean']['output'];
  wip_unlock_own: Scalars['Boolean']['output'];
  wip_unlock_team: Scalars['Boolean']['output'];
  workspaceSetting_edit: Scalars['Boolean']['output'];
};

export type PipedriveCustomField = {
  __typename?: 'PipedriveCustomField';
  entity_type: Scalars['String']['output'];
  external_key: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
};

export type PipedriveCustomFieldValue = {
  __typename?: 'PipedriveCustomFieldValue';
  customField: PipedriveCustomField;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PipedriveStage = {
  __typename?: 'PipedriveStage';
  name: Scalars['String']['output'];
  pipedrive_stage_id: Scalars['ID']['output'];
};

export type PlannedExpenseUsageInput = {
  budget_item_planned_expense_id: Scalars['ID']['input'];
  used_amount: Scalars['BigInt']['input'];
};

export type PlannedExpensesBudgetItem = {
  __typename?: 'PlannedExpensesBudgetItem';
  actual_profit_amount: Scalars['BigInt']['output'];
  actual_profit_percentage: Scalars['BigInt']['output'];
  budget_item_type: PlannedExpensesBudgetItemTypeEnum;
  buy_price: Scalars['BigInt']['output'];
  category_name: Scalars['String']['output'];
  expenses_received: Scalars['BigInt']['output'];
  expenses_received_percentage: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_amount_percentage: Scalars['BigInt']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  planned_budgeted_amount: Scalars['BigInt']['output'];
  planned_budgeted_amount_percentage: Scalars['BigInt']['output'];
  planned_client_amount: Scalars['BigInt']['output'];
  planned_client_amount_percentage: Scalars['BigInt']['output'];
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percentage: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
  to_plan_buy_price: Scalars['BigInt']['output'];
  to_plan_buy_price_percentage: Scalars['BigInt']['output'];
  to_plan_client_price: Scalars['BigInt']['output'];
  to_plan_client_price_percentage: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budgeted_with_commission: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_amount_percentage: Scalars['BigInt']['output'];
};

export enum PlannedExpensesBudgetItemTypeEnum {
  Expense = 'EXPENSE',
  OurWork = 'OUR_WORK'
}

export type PlannedExpensesOrderByClause = {
  column: PlannedExpensesOrderByColumnEnum;
  order: SortOrder;
};

export enum PlannedExpensesOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  CreatedAt = 'CREATED_AT',
  ProjectCode = 'PROJECT_CODE',
  ProjectTitle = 'PROJECT_TITLE',
  TotalBudget = 'TOTAL_BUDGET',
  TotalBudgetedWithCommission = 'TOTAL_BUDGETED_WITH_COMMISSION',
  TotalBuyPrice = 'TOTAL_BUY_PRICE',
  TotalExpensesReceived = 'TOTAL_EXPENSES_RECEIVED',
  TotalInvoicedAmount = 'TOTAL_INVOICED_AMOUNT',
  TotalPlannedBudgetedAmount = 'TOTAL_PLANNED_BUDGETED_AMOUNT',
  TotalPlannedClientAmount = 'TOTAL_PLANNED_CLIENT_AMOUNT'
}

export type PlannedExpensesProject = {
  __typename?: 'PlannedExpensesProject';
  actual_profit_amount: Scalars['BigInt']['output'];
  actual_profit_percentage: Scalars['BigInt']['output'];
  budget_items: Array<PlannedExpensesBudgetItem>;
  expenses_received_percentage: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiced_amount_percentage: Scalars['BigInt']['output'];
  planned_budgeted_amount_percentage: Scalars['BigInt']['output'];
  planned_client_amount_percentage: Scalars['BigInt']['output'];
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percentage: Scalars['BigInt']['output'];
  project: Project;
  to_plan_buy_price: Scalars['BigInt']['output'];
  to_plan_buy_price_percentage: Scalars['BigInt']['output'];
  to_plan_client_price: Scalars['BigInt']['output'];
  to_plan_client_price_percentage: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budgeted_with_commission: Scalars['BigInt']['output'];
  total_buy_price: Scalars['BigInt']['output'];
  total_expenses_received: Scalars['BigInt']['output'];
  total_invoiced_amount: Scalars['BigInt']['output'];
  total_planned_budgeted_amount: Scalars['BigInt']['output'];
  total_planned_client_amount: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_amount_percentage: Scalars['BigInt']['output'];
};

/** A paginated list of PlannedExpensesProject items. */
export type PlannedExpensesProjectPaginator = {
  __typename?: 'PlannedExpensesProjectPaginator';
  /** A list of PlannedExpensesProject items. */
  data: Array<PlannedExpensesProject>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PlannedExpensesQueryArgs = {
  orderBy?: InputMaybe<Array<PlannedExpensesOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PlannedExpensesWhereConditions>;
};

export type PlannedExpensesSummary = {
  __typename?: 'PlannedExpensesSummary';
  actual_profit_amount: Scalars['BigInt']['output'];
  actual_profit_percentage: Scalars['BigInt']['output'];
  expenses_received_percentage: Scalars['BigInt']['output'];
  invoiced_amount_percentage: Scalars['BigInt']['output'];
  planned_budgeted_amount_percentage: Scalars['BigInt']['output'];
  planned_client_amount_percentage: Scalars['BigInt']['output'];
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percentage: Scalars['BigInt']['output'];
  to_plan_buy_price: Scalars['BigInt']['output'];
  to_plan_buy_price_percentage: Scalars['BigInt']['output'];
  to_plan_client_price: Scalars['BigInt']['output'];
  to_plan_client_price_percentage: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budgeted_with_commission: Scalars['BigInt']['output'];
  total_buy_price: Scalars['BigInt']['output'];
  total_expenses_received: Scalars['BigInt']['output'];
  total_invoiced_amount: Scalars['BigInt']['output'];
  total_planned_budgeted_amount: Scalars['BigInt']['output'];
  total_planned_client_amount: Scalars['BigInt']['output'];
  total_projects: Scalars['Int']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_amount_percentage: Scalars['BigInt']['output'];
};

export enum PlannedExpensesWhereColumn {
  BrandId = 'BRAND_ID',
  BudgetItemType = 'BUDGET_ITEM_TYPE',
  ClientId = 'CLIENT_ID',
  HasPlannedExpenses = 'HAS_PLANNED_EXPENSES',
  IncludeDrafts = 'INCLUDE_DRAFTS',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectType = 'PROJECT_TYPE',
  TeamId = 'TEAM_ID'
}

export type PlannedExpensesWhereConditions = {
  AND?: InputMaybe<Array<PlannedExpensesWhereConditions>>;
  OR?: InputMaybe<Array<PlannedExpensesWhereConditions>>;
  column?: InputMaybe<PlannedExpensesWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type PlanningDailyViewCapacityAllocationUserItem = {
  __typename?: 'PlanningDailyViewCapacityAllocationUserItem';
  completed: Scalars['Boolean']['output'];
  /** From CapacityAllocationUserItem */
  id: Scalars['ID']['output'];
  item: CapacityAllocationItem;
  stats?: Maybe<CapacityAllocationUserItemStats>;
  timeTrackingWorkType: TimeTrackingWorkType;
  time_tracking_work_type_id: Scalars['ID']['output'];
  user: User;
};

export type PlanningDailyViewFilters = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  page?: InputMaybe<Scalars['BigInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<PlanningDailyViewWhereCondition>;
};

export type PlanningDailyViewPaginator = {
  __typename?: 'PlanningDailyViewPaginator';
  data: Array<PlanningDailyViewUserByDay>;
  last_updated_at?: Maybe<Scalars['DateTime']['output']>;
  paginatorInfo: PaginatorInfo;
};

export type PlanningDailyViewTimeOff = {
  __typename?: 'PlanningDailyViewTimeOff';
  createdBy: User;
  created_at: Scalars['DateTime']['output'];
  duration_type: TimeOffDurationTypeEnum;
  from_date: Scalars['Date']['output'];
  from_time: Scalars['Time']['output'];
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  repetition_settings?: Maybe<RepetitionSettings>;
  teams?: Maybe<Array<TeamAttendee>>;
  timeOffType: TimeOffType;
  to_date: Scalars['Date']['output'];
  to_time: Scalars['Time']['output'];
  total_time: Scalars['BigInt']['output'];
};

export type PlanningDailyViewTimeOffItem = {
  __typename?: 'PlanningDailyViewTimeOffItem';
  assignees: Array<TimeOffAssignee>;
  date: Scalars['Date']['output'];
  duration_type?: Maybe<TimeOffDurationTypeEnum>;
  from_time?: Maybe<Scalars['Time']['output']>;
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  timeOff: PlanningDailyViewTimeOff;
  timeOffType: TimeOffType;
  to_time?: Maybe<Scalars['Time']['output']>;
  total_time: Scalars['BigInt']['output'];
  unique_id: Scalars['String']['output'];
};

export type PlanningDailyViewUnassignedTasksFilters = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  where: PlanningViewUnassignedTasksWhereConditions;
};

export type PlanningDailyViewUnassignedTasksPerDay = {
  __typename?: 'PlanningDailyViewUnassignedTasksPerDay';
  afterDeadline: Array<Task>;
  date: Scalars['Date']['output'];
  other: Array<Task>;
};

export type PlanningDailyViewUserByDay = {
  __typename?: 'PlanningDailyViewUserByDay';
  items: Array<PlanningDailyViewUserDay>;
  user: User;
};

export type PlanningDailyViewUserDay = {
  __typename?: 'PlanningDailyViewUserDay';
  /** In seconds */
  capacity: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  holiday?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<CapacityAllocationItem>>;
  total_tracked_for_date: Scalars['BigInt']['output'];
  workStatus: CapacityAllocationWorkStatus;
};

export enum PlanningDailyViewWhereColumn {
  /** AllocableTypeEnum values */
  AllocableType = 'ALLOCABLE_TYPE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedByUserId = 'CREATED_BY_USER_ID',
  /** DateRange */
  Deadline = 'DEADLINE',
  ProjectId = 'PROJECT_ID',
  TaskPriorityId = 'TASK_PRIORITY_ID',
  /** Id values */
  TaskStatusId = 'TASK_STATUS_ID',
  TeamId = 'TEAM_ID',
  TimeTrackingWorkTypeId = 'TIME_TRACKING_WORK_TYPE_ID',
  UserId = 'USER_ID'
}

export type PlanningDailyViewWhereCondition = {
  AND?: InputMaybe<Array<PlanningDailyViewWhereCondition>>;
  OR?: InputMaybe<Array<PlanningDailyViewWhereCondition>>;
  column?: InputMaybe<PlanningDailyViewWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum PlanningOrderTypeEnum {
  Default = 'DEFAULT',
  Team = 'TEAM'
}

export type PlanningRangeInput = {
  daily_capacity?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<PlanningRangeTypeEnum>;
  utilising: Scalars['Boolean']['input'];
  valid_from: Scalars['Date']['input'];
  valid_to?: InputMaybe<Scalars['Date']['input']>;
  weekly_capacities?: InputMaybe<WeeklyCapacitiesInput>;
};

export type PlanningRangeType = {
  __typename?: 'PlanningRangeType';
  value: PlanningRangeTypeEnum;
};

export enum PlanningRangeTypeEnum {
  Custom = 'CUSTOM',
  Week = 'WEEK',
  Workweek = 'WORKWEEK'
}

export type PlanningViewSetting = {
  __typename?: 'PlanningViewSetting';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PlanningViewSettingInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum PlanningViewUnassignedTasksWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedByUserId = 'CREATED_BY_USER_ID',
  /** DateRange */
  Deadline = 'DEADLINE',
  ProjectId = 'PROJECT_ID',
  TaskPriorityId = 'TASK_PRIORITY_ID',
  /** Id values */
  TaskStatusId = 'TASK_STATUS_ID'
}

export type PlanningViewUnassignedTasksWhereConditions = {
  AND?: InputMaybe<Array<PlanningViewUnassignedTasksWhereConditions>>;
  OR?: InputMaybe<Array<PlanningViewUnassignedTasksWhereConditions>>;
  column?: InputMaybe<PlanningViewUnassignedTasksWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type PositionMappingInput = {
  new_time_tracking_work_type_id: Scalars['ID']['input'];
  old_time_tracking_work_type_id: Scalars['ID']['input'];
};

export type PositionSpent = {
  __typename?: 'PositionSpent';
  spent: Scalars['Int']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
};

export type PrepaymentSplitInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  brand_credit_account_id?: InputMaybe<Scalars['ID']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input pre preview/prepočet Time Billing (bez uloženia)
 * Používa sa na real-time prepočítavanie hodnôt na frontende
 */
export type PreviewProjectTimeBillingInput = {
  components?: InputMaybe<Array<TimeBillingComponentInput>>;
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  final_total_amount?: InputMaybe<Scalars['BigInt']['input']>;
  project_id: Scalars['ID']['input'];
  sources?: InputMaybe<Array<TimeBillingSourceInput>>;
  timeTrackingItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: TimeBillingTypeEnum;
  user_rows?: InputMaybe<Array<TimeBillingUserRowPreviewInput>>;
};

export type ProfitLossReport = {
  __typename?: 'ProfitLossReport';
  columns: Array<ProfitLossReportColumn>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ProfitLossReportColumn = {
  __typename?: 'ProfitLossReportColumn';
  balance_amount: Scalars['BigInt']['output'];
  expenses_amount: Scalars['BigInt']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
};

export enum ProfitLossReportColumns {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export type ProfitLossReportGroup = {
  __typename?: 'ProfitLossReportGroup';
  columns: Array<ProfitLossReportColumn>;
  id: Scalars['ID']['output'];
  items: Array<ProfitLossReport>;
  title: Scalars['String']['output'];
};

export type ProfitLossReportGroupPaginator = {
  __typename?: 'ProfitLossReportGroupPaginator';
  data: Array<ProfitLossReportGroup>;
  paginatorInfo: PaginatorInfo;
};

export enum ProfitLossReportOrderByColumn {
  Balance = 'BALANCE',
  Expenses = 'EXPENSES',
  Invoiced = 'INVOICED'
}

export type ProfitLossReportPaginator = {
  __typename?: 'ProfitLossReportPaginator';
  data: Array<ProfitLossReport>;
  paginatorInfo: PaginatorInfo;
};

export enum ProfitLossReportRows {
  Brand = 'BRAND',
  Client = 'CLIENT',
  Project = 'PROJECT',
  Team = 'TEAM'
}

export type ProfitLossReportSummary = {
  __typename?: 'ProfitLossReportSummary';
  data: Array<ProfitLossReportColumn>;
};

export enum ProfitLossReportWhereColumn {
  BillingEntityId = 'BILLING_ENTITY_ID',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectBillable = 'PROJECT_BILLABLE',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStatus = 'PROJECT_STATUS',
  TeamId = 'TEAM_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ProfitLossReportWhereConditions = {
  AND?: InputMaybe<Array<ProfitLossReportWhereConditions>>;
  OR?: InputMaybe<Array<ProfitLossReportWhereConditions>>;
  column?: InputMaybe<ProfitLossReportWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Project = {
  __typename?: 'Project';
  archivedBy?: Maybe<User>;
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  billable: Scalars['Boolean']['output'];
  billingPlanByMonths: Array<BillingPlanByMonths>;
  billingPlanIsMissing: Scalars['Boolean']['output'];
  billingPlanItems: Array<BillingPlanItem>;
  billingPlanNotifications?: Maybe<BillingPlanNotifications>;
  billingPlanSetting?: Maybe<ProjectBillingPlanSetting>;
  brand: Brand;
  budgetovacBudget?: Maybe<ProjectBudgetPivot>;
  budgetovacBudgets?: Maybe<Array<Budget>>;
  calculated_average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  categories: Array<ProjectCategory>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contact?: Maybe<Contact>;
  contracts?: Maybe<ContractPaginator>;
  created_at: Scalars['DateTime']['output'];
  currentMonthBillingPlanOutgoingInvoice: Scalars['BigInt']['output'];
  currentMonthBillingPlanOutgoingProformaInvoice: Scalars['BigInt']['output'];
  currentMonthBillingPlanStats: BillingPlanStats;
  /** @deprecated No longer supported */
  currentWorkInProgressProjectStat?: Maybe<WorkInProgressProjectStat>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  expected_end_date?: Maybe<Scalars['Date']['output']>;
  expenses: Array<ExpenseBudgetItem>;
  expensesStructured: Array<ExpenseStructuredBudgetItem>;
  expensesWithoutOther: Array<ExpenseBudgetItem>;
  expensesWithoutOtherStructured: Array<ExpenseStructuredBudgetItem>;
  externalLinks: Array<ExternalLink>;
  finishedBy?: Maybe<User>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceStats: Array<ProjectInvoiceStat>;
  is_pinned: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  is_starred: Scalars['Boolean']['output'];
  is_template: Scalars['Boolean']['output'];
  lastInvoice?: Maybe<ProjectInvoiceStat>;
  lastWorkInProgressProjectStat?: Maybe<WorkInProgressProjectStat>;
  lowestPossibleDateForStartDateChange?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numeric_code?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<OrderPaginator>;
  ordersSimpleMap: Array<OrderSimple>;
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  otherProjectManagers?: Maybe<Array<User>>;
  ourWork: Array<OurWorkBudgetItem>;
  ourWorkOverview: Array<OurWorkOverviewBudgetItem>;
  ourWorkStructured: Array<OurWorkStructuredBudgetItem>;
  pipedriveCustomFieldValues: Array<PipedriveCustomFieldValue>;
  pipedrive_setup_complete?: Maybe<Scalars['Boolean']['output']>;
  prepaymentStats: Array<ProjectPrepaymentStat>;
  proformaInvoices: Array<OutgoingProformaInvoice>;
  projectManager: User;
  project_stage?: Maybe<ProjectStage>;
  rate_card_exchange_rate: Scalars['BigInt']['output'];
  rate_card_id?: Maybe<Scalars['ID']['output']>;
  scopes: Array<UserScope>;
  start_date: Scalars['Date']['output'];
  stats?: Maybe<ProjectStats>;
  statsCached?: Maybe<ProjectStats>;
  status: ProjectStatusEnum;
  team: Team;
  timeTrackingRates: Array<TimeTrackingRate>;
  title: Scalars['String']['output'];
  type: ProjectTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  users: Array<User>;
  uses_budgetovac: Scalars['Boolean']['output'];
};


export type ProjectContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectExpensesArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectExpensesWithoutOtherArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectOurWorkArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectOurWorkOverviewArgs = {
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
  withDoneTasks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectAllQueryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectsAllWhereConditions>;
};

export type ProjectBilling = {
  __typename?: 'ProjectBilling';
  automatically_invoiced: Scalars['BigInt']['output'];
  balance: Scalars['BigInt']['output'];
  billing_plan_setting?: Maybe<ProjectBillingPlanSetting>;
  billing_type: ProjectBillingTypeEnum;
  has_billing_plan: Scalars['Boolean']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  invoiced_our_work: Scalars['BigInt']['output'];
  invoiced_prepayments: Scalars['BigInt']['output'];
  items: Array<ProjectBillingItem>;
  manually_invoiced: Scalars['BigInt']['output'];
  planned_amount: Scalars['BigInt']['output'];
  planned_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  planned_our_work: Scalars['BigInt']['output'];
  planned_prepayments: Scalars['BigInt']['output'];
  project: Project;
};

export enum ProjectBillingDocumentTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  Planned = 'PLANNED',
  Prepayment = 'PREPAYMENT',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING'
}

export type ProjectBillingExpenseCategoryAmount = {
  __typename?: 'ProjectBillingExpenseCategoryAmount';
  amount: Scalars['BigInt']['output'];
  category_id: Scalars['ID']['output'];
  category_name: Scalars['String']['output'];
  category_shortcut: Scalars['String']['output'];
};

export type ProjectBillingItem = {
  __typename?: 'ProjectBillingItem';
  automatically_invoiced: Scalars['BigInt']['output'];
  balance: Scalars['BigInt']['output'];
  billingPlanBudgetCache?: Maybe<BillingPlanBudgetCache>;
  billing_item_type?: Maybe<BillingItemTypEnum>;
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  brand_credit_account_id?: Maybe<Scalars['ID']['output']>;
  brand_credit_account_title?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  delivered: Scalars['Boolean']['output'];
  due_date?: Maybe<Scalars['Date']['output']>;
  email_sent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  invoice_no?: Maybe<Scalars['String']['output']>;
  invoice_type?: Maybe<BillingPlanBudgetItemInvoiceTypeEnum>;
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  invoiced_our_work: Scalars['BigInt']['output'];
  invoiced_prepayments: Scalars['BigInt']['output'];
  issue_date?: Maybe<Scalars['Date']['output']>;
  item_type: ProjectBillingItemTypeEnum;
  manually_invoiced: Scalars['BigInt']['output'];
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  outgoingProformaInvoice?: Maybe<OutgoingProformaInvoice>;
  paid_amount: Scalars['BigInt']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  payment_status?: Maybe<PaymentStatusEnum>;
  planned_amount: Scalars['BigInt']['output'];
  planned_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  planned_our_work: Scalars['BigInt']['output'];
  planned_prepayments: Scalars['BigInt']['output'];
  requestForInvoicing?: Maybe<RequestForInvoicing>;
  status: ProjectBillingItemStatusEnum;
  type?: Maybe<ProjectBillingDocumentTypeEnum>;
  updated_at: Scalars['DateTime']['output'];
};

export enum ProjectBillingItemStatusEnum {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  ManuallyCreated = 'MANUALLY_CREATED',
  Pending = 'PENDING',
  PrepaymentUsed = 'PREPAYMENT_USED'
}

export enum ProjectBillingItemTypeEnum {
  InvoiceAutomatic = 'INVOICE_AUTOMATIC',
  InvoiceManual = 'INVOICE_MANUAL',
  PlannedFuture = 'PLANNED_FUTURE',
  PrepaymentUsage = 'PREPAYMENT_USAGE',
  SummaryManualPlanned = 'SUMMARY_MANUAL_PLANNED'
}

/** A paginated list of ProjectBilling items. */
export type ProjectBillingPaginator = {
  __typename?: 'ProjectBillingPaginator';
  /** A list of ProjectBilling items. */
  data: Array<ProjectBilling>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectBillingPlanEmailTemplate = {
  __typename?: 'ProjectBillingPlanEmailTemplate';
  content?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type ProjectBillingPlanEmailTemplateInput = {
  content: Scalars['String']['input'];
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};

export type ProjectBillingPlanSetting = {
  __typename?: 'ProjectBillingPlanSetting';
  auto_create_invoice: Scalars['Boolean']['output'];
  auto_send_invoice: Scalars['Boolean']['output'];
  auto_send_thank_you: Scalars['Boolean']['output'];
  auto_send_thank_you_template?: Maybe<ProjectBillingPlanEmailTemplate>;
  billing_entity_id?: Maybe<Scalars['ID']['output']>;
  billing_item_type: BillingItemTypEnum;
  contact_id?: Maybe<Scalars['ID']['output']>;
  create_draft_invoice: Scalars['Boolean']['output'];
  create_summary_invoice_after_payment: Scalars['Boolean']['output'];
  date_of_supply_from_issue_date?: Maybe<Scalars['Int']['output']>;
  email_template?: Maybe<ProjectBillingPlanEmailTemplate>;
  from: Scalars['Date']['output'];
  generate_invoice_items?: Maybe<ProjectBillingPlanSettingGenerateInvoiceItemsEnum>;
  internal_note?: Maybe<Scalars['String']['output']>;
  lockedByUser?: Maybe<User>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  project_id: Scalars['ID']['output'];
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  to: Scalars['Date']['output'];
  vat_rate_id?: Maybe<Scalars['ID']['output']>;
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id?: Maybe<Scalars['ID']['output']>;
};

export enum ProjectBillingPlanSettingGenerateInvoiceItemsEnum {
  BudgetItemName = 'BUDGET_ITEM_NAME',
  CategoryName = 'CATEGORY_NAME',
  ProjectName = 'PROJECT_NAME'
}

export enum ProjectBillingTypeEnum {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  None = 'NONE'
}

export type ProjectBillingsOrderByClause = {
  column: ProjectBillingsOrderByColumnEnum;
  order: SortOrder;
};

export enum ProjectBillingsOrderByColumnEnum {
  AutomaticallyInvoiced = 'AUTOMATICALLY_INVOICED',
  Balance = 'BALANCE',
  BillingType = 'BILLING_TYPE',
  BrandName = 'BRAND_NAME',
  CreatedAt = 'CREATED_AT',
  InvoicedAmount = 'INVOICED_AMOUNT',
  InvoicedOurWork = 'INVOICED_OUR_WORK',
  ManuallyInvoiced = 'MANUALLY_INVOICED',
  PlannedAmount = 'PLANNED_AMOUNT',
  PlannedOurWork = 'PLANNED_OUR_WORK',
  ProjectCode = 'PROJECT_CODE',
  ProjectTitle = 'PROJECT_TITLE'
}

export type ProjectBillingsQueryArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<ProjectBillingsOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectBillingsWhereConditions>;
  with_prepayment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectBillingsSummary = {
  __typename?: 'ProjectBillingsSummary';
  projects_with_automatic_billing: Scalars['Int']['output'];
  projects_with_manual_billing: Scalars['Int']['output'];
  projects_without_billing: Scalars['Int']['output'];
  total_automatically_invoiced: Scalars['BigInt']['output'];
  total_balance: Scalars['BigInt']['output'];
  total_draft_invoices: Scalars['Int']['output'];
  total_failed_invoices: Scalars['Int']['output'];
  total_invoiced_amount: Scalars['BigInt']['output'];
  total_invoiced_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  total_invoiced_our_work: Scalars['BigInt']['output'];
  total_invoiced_prepayments: Scalars['BigInt']['output'];
  total_issued_invoices: Scalars['Int']['output'];
  total_manually_invoiced: Scalars['BigInt']['output'];
  total_paid_amount: Scalars['BigInt']['output'];
  total_planned_amount: Scalars['BigInt']['output'];
  total_planned_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  total_planned_invoices: Scalars['Int']['output'];
  total_planned_our_work: Scalars['BigInt']['output'];
  total_planned_prepayments: Scalars['BigInt']['output'];
  total_prepayment_usages: Scalars['Int']['output'];
  total_projects: Scalars['Int']['output'];
  total_unpaid_amount: Scalars['BigInt']['output'];
};

export enum ProjectBillingsWhereColumn {
  BalanceFrom = 'BALANCE_FROM',
  BalanceTo = 'BALANCE_TO',
  BillingItemType = 'BILLING_ITEM_TYPE',
  BillingType = 'BILLING_TYPE',
  BrandId = 'BRAND_ID',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DateOfSupplyFrom = 'DATE_OF_SUPPLY_FROM',
  DateOfSupplyTo = 'DATE_OF_SUPPLY_TO',
  DueDate = 'DUE_DATE',
  DueDateFrom = 'DUE_DATE_FROM',
  DueDateTo = 'DUE_DATE_TO',
  HasBillingPlan = 'HAS_BILLING_PLAN',
  HasDraftInvoices = 'HAS_DRAFT_INVOICES',
  HasFailedInvoices = 'HAS_FAILED_INVOICES',
  HasInvoiceInDateRange = 'HAS_INVOICE_IN_DATE_RANGE',
  HasPlannedInDateRange = 'HAS_PLANNED_IN_DATE_RANGE',
  HasUnpaidInvoices = 'HAS_UNPAID_INVOICES',
  InvoicedAmountFrom = 'INVOICED_AMOUNT_FROM',
  InvoicedAmountTo = 'INVOICED_AMOUNT_TO',
  InvoiceType = 'INVOICE_TYPE',
  IssueDate = 'ISSUE_DATE',
  IssueDateFrom = 'ISSUE_DATE_FROM',
  IssueDateTo = 'ISSUE_DATE_TO',
  IsDraft = 'IS_DRAFT',
  IsFinal = 'IS_FINAL',
  ItemStatus = 'ITEM_STATUS',
  PaidAt = 'PAID_AT',
  PaidAtFrom = 'PAID_AT_FROM',
  PaidAtTo = 'PAID_AT_TO',
  PaymentStatus = 'PAYMENT_STATUS',
  PlannedAmountFrom = 'PLANNED_AMOUNT_FROM',
  PlannedAmountTo = 'PLANNED_AMOUNT_TO',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectCode = 'PROJECT_CODE',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectTitle = 'PROJECT_TITLE',
  ProjectType = 'PROJECT_TYPE',
  TeamId = 'TEAM_ID',
  Type = 'TYPE',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ProjectBillingsWhereConditions = {
  AND?: InputMaybe<Array<ProjectBillingsWhereConditions>>;
  OR?: InputMaybe<Array<ProjectBillingsWhereConditions>>;
  column?: InputMaybe<ProjectBillingsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ProjectBudgetPivot = {
  __typename?: 'ProjectBudgetPivot';
  budget_id?: Maybe<Scalars['ID']['output']>;
  client_approved?: Maybe<Scalars['Boolean']['output']>;
  internally_approved?: Maybe<Scalars['Boolean']['output']>;
  newer_final_version_available: Scalars['Boolean']['output'];
};

export type ProjectCategory = {
  __typename?: 'ProjectCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ProjectCodeGeneratorEnum {
  NumberPerBrand = 'NUMBER_PER_BRAND',
  NumberPerWorkspace = 'NUMBER_PER_WORKSPACE'
}

export type ProjectDatesForBudgetChange = {
  __typename?: 'ProjectDatesForBudgetChange';
  defaultDateForBudgetChange: Scalars['Date']['output'];
  lowestPossibleDateForBudgetChange: Scalars['Date']['output'];
};

export type ProjectExpenseStats = CreditStats & ExpenseStatsInterface & {
  __typename?: 'ProjectExpenseStats';
  all_items_completed: Scalars['Boolean']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  client_price: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission_relative_computed: Scalars['String']['output'];
  planned_expenses: Scalars['BigInt']['output'];
  planned_profit: Scalars['BigInt']['output'];
  planned_profit_percent: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  real_commission: Scalars['BigInt']['output'];
  real_commission_relative: Scalars['String']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export type ProjectFinishSummary = {
  __typename?: 'ProjectFinishSummary';
  can_be_finished_without_further_changes: Scalars['Boolean']['output'];
  can_redistribute_credit_automatically: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incomplete_expense_budget_items: Array<ExpenseBudgetItem>;
  incomplete_our_work_budget_items: Array<OurWorkBudgetItem>;
  overinvoiced_expense_budget_items: Array<ExpenseBudgetItem>;
  overinvoiced_for_project: Scalars['Boolean']['output'];
  overinvoiced_our_work_budget_items: Array<OurWorkBudgetItem>;
  project_already_finished: Scalars['Boolean']['output'];
  underinvoiced_expense_budget_items: Array<ExpenseBudgetItem>;
  underinvoiced_for_project: Scalars['Boolean']['output'];
  underinvoiced_our_work_budget_items: Array<OurWorkBudgetItem>;
};

export type ProjectForExpense = {
  __typename?: 'ProjectForExpense';
  brand: BrandSimple;
  code: Scalars['String']['output'];
  expenses: Array<ExpenseBudgetItemSimple>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ourWorkBudgetItems?: Maybe<Array<OurWorkBudgetItemSimple>>;
  team: Team;
  title: Scalars['String']['output'];
};

export type ProjectForPlanovac = {
  __typename?: 'ProjectForPlanovac';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  brand: BrandSimple;
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ourWork: Array<OurWorkBudgetItem>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};


export type ProjectForPlanovacOurWorkArgs = {
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A paginated list of ProjectForPlanovac items. */
export type ProjectForPlanovacPaginator = {
  __typename?: 'ProjectForPlanovacPaginator';
  /** A list of ProjectForPlanovac items. */
  data: Array<ProjectForPlanovac>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectForTask = {
  __typename?: 'ProjectForTask';
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  code: Scalars['String']['output'];
  expected_end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  ourWork: Array<OurWorkBudgetItemSimple>;
  start_date: Scalars['Date']['output'];
  title: Scalars['String']['output'];
};

export type ProjectGraph = {
  __typename?: 'ProjectGraph';
  spentBudgetData: Array<DateIntegerDataPoint>;
  totalBudgetData: Array<DateIntegerDataPoint>;
  wipData: Array<DateIntegerDataPoint>;
};

export type ProjectInvoiceStat = {
  __typename?: 'ProjectInvoiceStat';
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  outgoingInvoice: OutgoingInvoice;
  outgoing_invoice_date: Scalars['Date']['output'];
};

export enum ProjectInvoicedStatusEnum {
  Invoiced = 'INVOICED',
  PartiallyInvoiced = 'PARTIALLY_INVOICED',
  Uninvoiced = 'UNINVOICED'
}

export type ProjectLimited = {
  __typename?: 'ProjectLimited';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ourWork: Array<OurWorkBudgetItemLimited>;
  title: Scalars['String']['output'];
};

/** A paginated list of ProjectLimited items. */
export type ProjectLimitedPaginator = {
  __typename?: 'ProjectLimitedPaginator';
  /** A list of ProjectLimited items. */
  data: Array<ProjectLimited>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectLimitedQueryArgs = {
  orderBy?: InputMaybe<Array<ProjectOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectsLimitedWhereConditions>;
};

export type ProjectOrderByClause = {
  column: ProjectOrderByColumnEnum;
  order: SortOrder;
};

export enum ProjectOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  BudgetExceeded = 'BUDGET_EXCEEDED',
  ClientName = 'CLIENT_NAME',
  CreatedAt = 'CREATED_AT',
  CreditBalance = 'CREDIT_BALANCE',
  FinishedAt = 'FINISHED_AT',
  OtherProjectManager = 'OTHER_PROJECT_MANAGER',
  Pinned = 'PINNED',
  ProjectCode = 'PROJECT_CODE',
  ProjectManager = 'PROJECT_MANAGER',
  ProjectNote = 'PROJECT_NOTE',
  ProjectTitle = 'PROJECT_TITLE',
  RealExpenses = 'REAL_EXPENSES',
  SpentOurWork = 'SPENT_OUR_WORK',
  TotalBudget = 'TOTAL_BUDGET',
  TotalCredit = 'TOTAL_CREDIT'
}

export type ProjectOurWorkStats = CreditStats & OurWorkStatsInterface & {
  __typename?: 'ProjectOurWorkStats';
  all_items_completed: Scalars['Boolean']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  efficiency_percent: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  net_margin_percent: Scalars['BigInt']['output'];
  net_profit: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  planned_budget: Scalars['BigInt']['output'];
  planned_time: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

/** A paginated list of Project items. */
export type ProjectPaginator = {
  __typename?: 'ProjectPaginator';
  /** A list of Project items. */
  data: Array<Project>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectPrepaymentStat = {
  __typename?: 'ProjectPrepaymentStat';
  brandCreditAccount: BrandCreditAccount;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  id: Scalars['String']['output'];
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
};

export type ProjectQueryArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectsWhereConditions>;
};

export type ProjectRateCard = {
  __typename?: 'ProjectRateCard';
  currency_iso?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
};

export type ProjectRevenue = {
  __typename?: 'ProjectRevenue';
  paginatorInfo: PaginatorInfo;
  projects: Array<ProjectWithRevenueItem>;
};

export type ProjectRevenueBillingsByExpenseCategory = {
  __typename?: 'ProjectRevenueBillingsByExpenseCategory';
  billings?: Maybe<Scalars['BigInt']['output']>;
  expense_budget_category_id: Scalars['ID']['output'];
};

export type ProjectRevenueOrderByClause = {
  column: ProjectRevenueOrderByColumnEnum;
  order: SortOrder;
};

export enum ProjectRevenueOrderByColumnEnum {
  FinishedAt = 'FINISHED_AT'
}

export type ProjectRevenueProfitByExpenseCategory = {
  __typename?: 'ProjectRevenueProfitByExpenseCategory';
  expense_budget_category_id: Scalars['ID']['output'];
  profit?: Maybe<Scalars['BigInt']['output']>;
};

export type ProjectRevenueQueryArgs = {
  exclude_presale: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<ProjectRevenueOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<ProjectRevenueWhereConditions>;
};

export type ProjectRevenueSummary = {
  __typename?: 'ProjectRevenueSummary';
  brand_profit_share?: Maybe<Array<BrandRevenueShare>>;
  brand_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  client_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  expense_revenue_for_date_range: Array<ExpenseRevenueByCategory>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range_percentage: Scalars['BigInt']['output'];
  profit_top_projects?: Maybe<Array<TopProject>>;
  projectIds: Array<Scalars['ID']['output']>;
  projects: Scalars['BigInt']['output'];
  revenue_top_projects?: Maybe<Array<TopProject>>;
  total_invoiced: Scalars['BigInt']['output'];
};

export enum ProjectRevenueWhereColumn {
  BrandId = 'BRAND_ID',
  CategoryId = 'CATEGORY_ID',
  ClientId = 'CLIENT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type ProjectRevenueWhereConditions = {
  AND?: InputMaybe<Array<ProjectRevenueWhereConditions>>;
  OR?: InputMaybe<Array<ProjectRevenueWhereConditions>>;
  column?: InputMaybe<ProjectRevenueWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  create_default_task_enabled?: Maybe<Scalars['Boolean']['output']>;
  default_task_priority_id?: Maybe<Scalars['BigInt']['output']>;
  default_task_status_id?: Maybe<Scalars['BigInt']['output']>;
  project_code_generator?: Maybe<ProjectCodeGeneratorEnum>;
  project_code_length?: Maybe<Scalars['BigInt']['output']>;
  project_code_with_year?: Maybe<Scalars['Boolean']['output']>;
};

export type ProjectSimple = {
  __typename?: 'ProjectSimple';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  billable: Scalars['Boolean']['output'];
  brand: BrandSimple;
  brand_id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  numeric_code?: Maybe<Scalars['String']['output']>;
  project_manager_id?: Maybe<Scalars['ID']['output']>;
  team_id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: ProjectTypeEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of ProjectSimple items. */
export type ProjectSimplePaginator = {
  __typename?: 'ProjectSimplePaginator';
  /** A list of ProjectSimple items. */
  data: Array<ProjectSimple>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectStage = {
  __typename?: 'ProjectStage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_name?: Maybe<Scalars['String']['output']>;
};

export type ProjectStarOptions = {
  with_my_tasks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectStats = {
  __typename?: 'ProjectStats';
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  credit_direct: Scalars['BigInt']['output'];
  credit_from_prepayments: Scalars['BigInt']['output'];
  credit_from_unused_prepayments: Scalars['BigInt']['output'];
  expenses: ProjectExpenseStats;
  gross_income: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  invoiced_status: ProjectInvoicedStatusEnum;
  net_margin_percent: Scalars['BigInt']['output'];
  net_profit: Scalars['BigInt']['output'];
  ourWork: ProjectOurWorkStats;
  outgoing_invoice_amount: Scalars['BigInt']['output'];
  outgoing_invoice_paid: Scalars['BigInt']['output'];
  outgoing_invoice_unpaid: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_amount: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_paid: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_settled: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_unpaid: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_unsettled: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  planned_commission: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
  unused_sum_from_proformas: Scalars['BigInt']['output'];
};

export enum ProjectStatusEnum {
  Active = 'active',
  Archived = 'archived',
  Finished = 'finished'
}

/** Hlavný typ pre uložený Time Billing */
export type ProjectTimeBilling = {
  __typename?: 'ProjectTimeBilling';
  components: Array<ProjectTimeBillingComponent>;
  computed_total_amount: Scalars['BigInt']['output'];
  createdByUser: User;
  created_at: Scalars['DateTime']['output'];
  date_from: Scalars['Date']['output'];
  date_to: Scalars['Date']['output'];
  distributions: Array<ProjectTimeBillingDistribution>;
  final_total_amount: Scalars['BigInt']['output'];
  final_total_note?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_locked: Scalars['Boolean']['output'];
  lockedByUser?: Maybe<User>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  /** Title, or the billed period when there is no title */
  name: Scalars['String']['output'];
  project: Project;
  sources: Array<ProjectTimeBillingSource>;
  title?: Maybe<Scalars['String']['output']>;
  total_expense: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_our_work: Scalars['BigInt']['output'];
  total_prepayment: Scalars['BigInt']['output'];
  type: TimeBillingTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  userRows: Array<ProjectTimeBillingUserRow>;
};

/** Komponent sumy (invoiced, prepayment, our_work, expense) */
export type ProjectTimeBillingComponent = {
  __typename?: 'ProjectTimeBillingComponent';
  amount: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: TimeBillingComponentKeyEnum;
  source?: Maybe<ProjectTimeBillingSource>;
  updated_at: Scalars['DateTime']['output'];
  use_in_total: Scalars['Boolean']['output'];
};

/** Preview komponentu (pre compute query) */
export type ProjectTimeBillingComponentPreview = {
  __typename?: 'ProjectTimeBillingComponentPreview';
  amount: Scalars['BigInt']['output'];
  key: TimeBillingComponentKeyEnum;
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type?: Maybe<TimeBillingSourceTypeEnum>;
  use_in_total: Scalars['Boolean']['output'];
};

/** Výstup pre compute query (preview bez uloženia) */
export type ProjectTimeBillingComputed = {
  __typename?: 'ProjectTimeBillingComputed';
  components: Array<ProjectTimeBillingComponentPreview>;
  computed_total_amount: Scalars['BigInt']['output'];
  date_from: Scalars['Date']['output'];
  date_to: Scalars['Date']['output'];
  distributions: Array<ProjectTimeBillingDistributionPreview>;
  project_id: Scalars['ID']['output'];
  sources: Array<ProjectTimeBillingSourcePreview>;
  total_expense: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_our_work: Scalars['BigInt']['output'];
  total_prepayment: Scalars['BigInt']['output'];
  total_spent: Scalars['BigInt']['output'];
  total_tracked_time: Scalars['Int']['output'];
  userRows: Array<ProjectTimeBillingUserRowPreview>;
};

/** Distribúcia trackingu pre Time Billing (FIFO rozdelenie) */
export type ProjectTimeBillingDistribution = {
  __typename?: 'ProjectTimeBillingDistribution';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiced_seconds: Scalars['Int']['output'];
  overserviced_seconds: Scalars['Int']['output'];
  projectTimeBilling: ProjectTimeBilling;
  timeTrackingItem: TimeTrackingItem;
  time_tracking_item_id: Scalars['ID']['output'];
  total_seconds: Scalars['Int']['output'];
  uninvoiced_seconds: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProjectTimeBillingDistributionPreview = {
  __typename?: 'ProjectTimeBillingDistributionPreview';
  invoiced_seconds: Scalars['Int']['output'];
  overserviced_seconds: Scalars['Int']['output'];
  timeTrackingItem: TimeTrackingItem;
  time_tracking_item_id: Scalars['ID']['output'];
  uninvoiced_seconds: Scalars['Int']['output'];
};

/** Order by klauzula pre listing */
export type ProjectTimeBillingOrderByClause = {
  column: ProjectTimeBillingOrderByColumn;
  order: SortOrder;
};

export enum ProjectTimeBillingOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DateFrom = 'DATE_FROM',
  DateTo = 'DATE_TO',
  FinalTotalAmount = 'FINAL_TOTAL_AMOUNT',
  LockedAt = 'LOCKED_AT',
  Title = 'TITLE'
}

/** A paginated list of ProjectTimeBilling items. */
export type ProjectTimeBillingPaginator = {
  __typename?: 'ProjectTimeBillingPaginator';
  /** A list of ProjectTimeBilling items. */
  data: Array<ProjectTimeBilling>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Zdroj pre Time Billing (expense_item alebo oi_budget_item) */
export type ProjectTimeBillingSource = {
  __typename?: 'ProjectTimeBillingSource';
  amount: Scalars['BigInt']['output'];
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id?: Maybe<Scalars['ID']['output']>;
  budget_item_type?: Maybe<BudgetItemTypeEnum>;
  components: Array<ProjectTimeBillingComponent>;
  created_at: Scalars['DateTime']['output'];
  expense?: Maybe<Expense>;
  expenseItem?: Maybe<ExpenseItem>;
  id: Scalars['ID']['output'];
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type: TimeBillingSourceTypeEnum;
};

/** Preview zdroja (pre compute query) */
export type ProjectTimeBillingSourcePreview = {
  __typename?: 'ProjectTimeBillingSourcePreview';
  amount: Scalars['BigInt']['output'];
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id?: Maybe<Scalars['ID']['output']>;
  budget_item_type?: Maybe<BudgetItemTypeEnum>;
  expense?: Maybe<Expense>;
  expenseItem?: Maybe<ExpenseItem>;
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type: TimeBillingSourceTypeEnum;
};

/**
 * Riadok usera v Time Billing tabuľke.
 * Pre Work Expense záznamy (time tracking bez usera) je user null.
 */
export type ProjectTimeBillingUserRow = {
  __typename?: 'ProjectTimeBillingUserRow';
  amount: Scalars['BigInt']['output'];
  client_rate: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  effective_hourly_rate: Scalars['BigInt']['output'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiced_time: Scalars['Int']['output'];
  overserviced_time: Scalars['Int']['output'];
  position?: Maybe<TimeTrackingWorkType>;
  spent: Scalars['BigInt']['output'];
  team?: Maybe<Team>;
  tracked_hours: Scalars['Float']['output'];
  tracked_time: Scalars['Int']['output'];
  uninvoiced_time: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/**
 * Preview user row (pre compute query).
 * Pre Work Expense záznamy (time tracking bez usera) je user_id a user null.
 */
export type ProjectTimeBillingUserRowPreview = {
  __typename?: 'ProjectTimeBillingUserRowPreview';
  amount: Scalars['BigInt']['output'];
  client_rate: Scalars['BigInt']['output'];
  effective_hourly_rate: Scalars['BigInt']['output'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['output'];
  invoiced_time: Scalars['Int']['output'];
  overserviced_time: Scalars['Int']['output'];
  position?: Maybe<TimeTrackingWorkType>;
  spent: Scalars['BigInt']['output'];
  team?: Maybe<Team>;
  team_id?: Maybe<Scalars['ID']['output']>;
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  tracked_hours: Scalars['Float']['output'];
  tracked_time: Scalars['Int']['output'];
  uninvoiced_time: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ProjectTimeBreakdown = {
  __typename?: 'ProjectTimeBreakdown';
  budgeted: Scalars['Int']['output'];
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
  project: Project;
};

export type ProjectTimeBreakdownDetail = {
  __typename?: 'ProjectTimeBreakdownDetail';
  budgeted: Scalars['BigInt']['output'];
  budgeted_time: Scalars['Float']['output'];
  date_from?: Maybe<Scalars['Date']['output']>;
  date_to?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  personal_expenses: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  tracked_amount: Scalars['BigInt']['output'];
  tracked_time: Scalars['Float']['output'];
};

export type ProjectTimeBreakdownResponse = {
  __typename?: 'ProjectTimeBreakdownResponse';
  budgeted: Scalars['BigInt']['output'];
  budgeted_time: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  personal_expenses: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  time_breakdown: Array<ProjectTimeBreakdownDetail>;
  title: Scalars['String']['output'];
  tracked_amount: Scalars['BigInt']['output'];
  tracked_time: Scalars['Float']['output'];
};

export enum ProjectTypeEnum {
  FixedPrice = 'FIXED_PRICE',
  TimeMaterials = 'TIME_MATERIALS'
}

export type ProjectWithRevenue = {
  __typename?: 'ProjectWithRevenue';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  billable: Scalars['Boolean']['output'];
  brand: Brand;
  code: Scalars['String']['output'];
  expensesStructured: Array<ExpenseStructuredBudgetItemWithRevenue>;
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  projectManager: User;
  status: ProjectStatusEnum;
  title: Scalars['String']['output'];
  total_invoiced: Scalars['BigInt']['output'];
};

export type ProjectWithRevenueItem = {
  __typename?: 'ProjectWithRevenueItem';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  billable: Scalars['Boolean']['output'];
  brand: Brand;
  code: Scalars['String']['output'];
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  filtered_profit_share: Scalars['BigInt']['output'];
  filtered_revenue_share: Scalars['BigInt']['output'];
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  projectManager: User;
  status: ProjectStatusEnum;
  title: Scalars['String']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_profit_share: Scalars['BigInt']['output'];
  total_revenue_share: Scalars['BigInt']['output'];
};

export enum ProjectsAllWhereColumn {
  /** options: true, false */
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT',
  FinishedAt = 'FINISHED_AT',
  Id = 'ID',
  /**
   * options: true, false
   * @deprecated No longer supported
   */
  IsProBono = 'IS_PRO_BONO',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type ProjectsAllWhereConditions = {
  AND?: InputMaybe<Array<ProjectsAllWhereConditions>>;
  OR?: InputMaybe<Array<ProjectsAllWhereConditions>>;
  column?: InputMaybe<ProjectsAllWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum ProjectsLimitedWhereColumn {
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  Id = 'ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type ProjectsLimitedWhereConditions = {
  AND?: InputMaybe<Array<ProjectsLimitedWhereConditions>>;
  OR?: InputMaybe<Array<ProjectsLimitedWhereConditions>>;
  column?: InputMaybe<ProjectsLimitedWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ProjectsSummary = {
  __typename?: 'ProjectsSummary';
  budget_exceeded_expenses: Scalars['BigInt']['output'];
  budget_exceeded_our_work: Scalars['BigInt']['output'];
  budget_exceeded_total: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  expenses_credit_balance: Scalars['BigInt']['output'];
  expenses_credit_proforma_balance: Scalars['BigInt']['output'];
  gross_income: Scalars['BigInt']['output'];
  net_margin_percent?: Maybe<Scalars['BigInt']['output']>;
  net_profit: Scalars['BigInt']['output'];
  our_work_credit_balance: Scalars['BigInt']['output'];
  our_work_credit_proforma_balance: Scalars['BigInt']['output'];
  our_work_efficiency: Scalars['BigInt']['output'];
  our_work_spent_budget: Scalars['BigInt']['output'];
  our_work_total_budget: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  proforma_uninvoiced: Scalars['BigInt']['output'];
  projectIds: Array<Scalars['ID']['output']>;
  projects: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export enum ProjectsWhereColumn {
  ActiveInTimeframe = 'ACTIVE_IN_TIMEFRAME',
  /** options: true, false */
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  /** options: true, false */
  ApprovedInternally = 'APPROVED_INTERNALLY',
  /** options: true, false */
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  CategoryId = 'CATEGORY_ID',
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT',
  ExpectedEndDate = 'EXPECTED_END_DATE',
  FinishedAt = 'FINISHED_AT',
  Id = 'ID',
  InvoicedStatus = 'INVOICED_STATUS',
  /**
   * options: true, false
   * @deprecated No longer supported
   */
  IsProBono = 'IS_PRO_BONO',
  IsTemplate = 'IS_TEMPLATE',
  /** options: true, false */
  NewerFinalVersionOfBudgetAvailable = 'NEWER_FINAL_VERSION_OF_BUDGET_AVAILABLE',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  /** options: pinned, active, my_active, finished, archived, finished_archived */
  QuickFilter = 'QUICK_FILTER',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TeamId = 'TEAM_ID',
  TotalBudget = 'TOTAL_BUDGET',
  Type = 'type'
}

export type ProjectsWhereConditions = {
  AND?: InputMaybe<Array<ProjectsWhereConditions>>;
  OR?: InputMaybe<Array<ProjectsWhereConditions>>;
  column?: InputMaybe<ProjectsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type PushNotificationSubscriptionKeys = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  EmailTemplates: Array<EmailTemplate>;
  /** permission: outgoingInvoice.read.all/own/team */
  ExpenseAttachmentsExport?: Maybe<Scalars['String']['output']>;
  GetQuote: Quote;
  GetQuoteEmailData: QuoteEmailData;
  GetUsersAllocatedTime?: Maybe<Array<UserAllocatedTime>>;
  GetUsersAllocationConflicts?: Maybe<Array<UserAllocationConflicts>>;
  WorkspaceNotifications: Array<WorkspaceNotification>;
  /** permission: outgoingInvoice.read.all/own/team */
  abraFlexiOIExport?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  abraFlexiOutgoingProformaInvoicesExport?: Maybe<Scalars['String']['output']>;
  accountingAccountsSimpleMap: Array<AccountingAccount>;
  accountingCentres: Array<AccountingCentre>;
  /** permission: task.read.all/own */
  availableTaskPositionsHoursByOurWorkBudget?: Maybe<Array<TaskPositionHour>>;
  bankAccountConverter: BankAccountConverter;
  bankAccountMoves?: Maybe<BankAccountMovePaginator>;
  bankAccounts?: Maybe<Array<BankAccount>>;
  banksQuery?: Maybe<Array<Bank>>;
  billingEntities?: Maybe<BillingEntityPaginator>;
  billingPlanBudget: Array<BillingPlanBudget>;
  /** permission: billingPlan.listing */
  billingPlanCacheOverview?: Maybe<BillingPlanBudgetCachePaginator>;
  /** permission: billingPlan.listing */
  billingPlanCacheOverviewSummary: BillingPlanCacheOverviewSummary;
  /** permission: billingPlan.listing */
  billingPlanOverview?: Maybe<BillingPlanMonthStatPaginator>;
  /** permission: billingPlan.listing */
  billingPlanOverviewSummary: BillingPlanOverviewSummary;
  /** permission: brand.read */
  brand?: Maybe<Brand>;
  /** permission: brandCreditAccount.read.all/team/own for given ID */
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  /** permission: brandCreditAccount.read.all/team/own */
  brandCreditAccounts?: Maybe<BrandCreditAccountPaginator>;
  /** permission: brandCreditAccount.read.all/team/own */
  brandCreditAccountsSummary: BrandCreditAccountsSummary;
  brandRevenue: BrandRevenue;
  /** permission: project.read.all/team/own */
  brandRevenueSummary: BrandRevenueSummary;
  /** permission: brand.read */
  brands?: Maybe<BrandPaginator>;
  /** permission: brand.read */
  brandsForClient: Array<Brand>;
  brandsSimpleMap: Array<BrandSimple>;
  /** permission: brand.read */
  brandsSummary: BrandsSummary;
  budgetItemPlannedExpenses: Array<BudgetItemPlannedExpense>;
  budgetovacPosition?: Maybe<BudgetovacPosition>;
  budgetovacPositions: Array<BudgetovacPosition>;
  budgetovacPositionsSet?: Maybe<BudgetovacPositionsSet>;
  budgetovacPositionsSets: Array<BudgetovacBrandPositionsSet>;
  budgets: BudgetPaginator;
  budgetsExport: Scalars['String']['output'];
  budgetsForProject?: Maybe<Array<BudgetGroup>>;
  bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates: Array<ConvertedAmountWithIdentifier>;
  bulkConvertAmountToWorkspaceCurrencyUsingUserExchangeRates: Array<ConvertedAmountWithIdentifier>;
  /** permission: outgoingInvoice.read.all/own/team */
  bulkDownloadOutgoingInvoices?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  bulkDownloadOutgoingProformaInvoices?: Maybe<Scalars['String']['output']>;
  /** Capacity allocation detail. */
  capacityAllocationDetail?: Maybe<CapacityAllocation>;
  /** Capacity allocation item detail. */
  capacityAllocationItemDetailQuery?: Maybe<CapacityAllocationItem>;
  capacityAllocationItemList: Array<CapacityAllocationItem>;
  capacityAllocationItemTimeTrackingItems: Array<TimeTrackingItem>;
  /** permission: outgoingInvoice.accessAccountingAttributes */
  cfExport: Scalars['String']['output'];
  checkIfCreditAccountsBelongToTheSameTeam: Scalars['Boolean']['output'];
  checkInvoiceNumberExist?: Maybe<Scalars['Boolean']['output']>;
  checkTimeTrackingItemsLocked: Array<Scalars['ID']['output']>;
  /** permission: client.read */
  client?: Maybe<Client>;
  clientExchangeRatesForBudgetovac: Array<CurrencyExchangeRate>;
  /** permission: outgoingInvoice.read.all/own/team */
  clientOIExport: Scalars['String']['output'];
  /** permission: client.read */
  clients?: Maybe<ClientPaginator>;
  clientsSimpleMap: Array<ClientSimple>;
  /** permission: task.read.all/own for given task */
  commentHistory: Array<TaskComment>;
  companySettings?: Maybe<CompanySettings>;
  contacts: Array<Contact>;
  /** permission: contract.read */
  contract?: Maybe<Contract>;
  /** permission: contractor.read */
  contractor?: Maybe<Contractor>;
  /** permission: contractor.read */
  contractors?: Maybe<ContractorPaginator>;
  /** permission: contractor.read */
  contractorsBasic: ContractorsBasic;
  contractorsSimpleMap: Array<ContractorSimple>;
  /** permission: contractor.read */
  contractorsSummary: ContractorsSummary;
  /** permission: contract.read */
  contracts?: Maybe<ContractPaginator>;
  /** permission: contract.read */
  contractsExport: Scalars['String']['output'];
  contractsSimpleMap?: Maybe<Array<ContractSimple>>;
  /** permission: contract.read */
  contractsSummary: ContractsSummary;
  convertAmountToWorkspaceCurrencyUsingExchangeRate?: Maybe<ConvertedAmount>;
  countrySimpleMap: Array<CountrySimple>;
  /**
   * Compute/Preview Time Billing pre dané obdobie (BEZ uloženia)
   * Vráti vypočítané hodnoty, ktoré môže používateľ upraviť pred uložením
   * permission: project.read.all/own/team
   */
  createDataForProjectTimeBilling: ProjectTimeBillingComputed;
  creditAccount?: Maybe<CreditAccount>;
  currencies?: Maybe<Array<Currency>>;
  currency?: Maybe<Currency>;
  defaultCurrencies?: Maybe<Array<Maybe<DefaultCurrency>>>;
  /** permission: expense.read.all/team/own for given expense */
  expense: Expense;
  expenseAbraFlexiExport: Scalars['String']['output'];
  expenseBudgetCategories?: Maybe<Array<ExpenseBudgetCategory>>;
  /** permission: project.read.all/team/own */
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  /** permission: project.read.all/team/own */
  expenseBudgetItemsByItemCode: Array<ExpenseBudgetItemSimple>;
  expenseBudgetItemsSimpleMap: Array<ExpenseBudgetItemSimple>;
  /** permission: project.read.all/team/own */
  expenseBudgetItemsWithStatus: Array<ExpenseBudgetItemWithStatus>;
  expenseExport: Scalars['String']['output'];
  expenseItemDescriptions?: Maybe<Array<Maybe<ExpenseItemDesciption>>>;
  /** permission: expense.read.all/team/own */
  expenseItemsForProject?: Maybe<Array<ExpenseItemForProject>>;
  /**
   * Paginovany listing expense items pre Time Billing.
   * Vracia individualne expense_items s projektovymi datami a filtrami.
   * permission: expense.read.all/team/own
   */
  expenseItemsForTimeBilling?: Maybe<ExpenseItemPaginator>;
  /**
   * Summary (count + amount) pre expense items for Time Billing.
   * permission: expense.read.all/team/own
   */
  expenseItemsForTimeBillingSummary: TimeBillingSummary;
  expensePremierExport: Scalars['String']['output'];
  /** permission: expense.accessAccountingAttributes */
  expenseSummaryExportBulk: Scalars['String']['output'];
  /** permission: expense.accessAccountingAttributes */
  expenseSummaryExportSimple: Scalars['String']['output'];
  /** permission: expense.accessAccountingAttributes */
  expenseXMLExport: Scalars['String']['output'];
  expenseXeroExport: Scalars['String']['output'];
  /** permission: expense.read.all/team/own */
  expenses?: Maybe<ExpensePaginator>;
  /** permission: expense.read.all/team/own */
  expensesSummary: ExpensesSummary;
  /** permission: billingPlan.listing */
  exportBillingPlan: Scalars['String']['output'];
  externalLinks: Array<ExternalLink>;
  /**
   * Extracts expense data from an attachment file using OCR/AI.
   * Returns data in format compatible with CreateExpenseInput for form prefill.
   * permission: expense.create
   */
  fetchOCRExpenseData?: Maybe<OcrExpenseData>;
  filterTemplates: Array<FilterTemplate>;
  financeSettings?: Maybe<FinanceSettings>;
  /** permission: outgoingInvoice.read.all/own/team */
  financialOIExport?: Maybe<Scalars['String']['output']>;
  fondContractorsSimpleMap: Array<FondContractorSimple>;
  /** permission: expense.accessAccountingAttributes */
  generateExpensePaymentOrder: ExpensePaymentOrderResponse;
  getAccessTokenForThirdParty?: Maybe<Scalars['String']['output']>;
  /** permission: project.read.all/team/own */
  getActiveProjectBudgetExceededCount: Scalars['BigInt']['output'];
  getAutocompleteForCompanyData: AutocompleteCompanyData;
  getAvailableProjectsForBulkMovingTimeTrackingItems: Array<ProjectSimple>;
  getAvailableWorkTypesForBulkMovingTimeTrackingItems: Array<TimeTrackingWorkType>;
  getBillingPlanBudgetPdf: Scalars['String']['output'];
  getBudgetQuotes: QuotesPaginator;
  getCompanyDataByRegistrationNo?: Maybe<CompanyData>;
  /** permission: expense.read.all/team/own */
  getDuplicateExpensesIDs: Array<Scalars['ID']['output']>;
  getInvoiceEmailData?: Maybe<InvoiceEmailData>;
  /** permission: expense.accessAccountingAttributes */
  getLatestExpenseInternalNumberPerType: Array<LatestExpenseInternalNumberPerType>;
  getModelLock?: Maybe<ModelLock>;
  getNewInvoiceNumber: Array<InvoiceSequenceData>;
  getNextNumericalBrandCode: Scalars['String']['output'];
  /** Permission list of the currently authenticated User or ApiClient. */
  getPermissions: PermissionList;
  getPipedriveStages?: Maybe<Array<PipedriveStage>>;
  getProformaInvoiceEmailData?: Maybe<InvoiceEmailData>;
  /** permission: project.read.all/team/own */
  getProjectCanBeFinishedSummary: ProjectFinishSummary;
  /** permission: requestForInvoicing.read.all/own/team */
  getSubmittedRfiCount: Scalars['BigInt']['output'];
  getTags?: Maybe<Array<Tag>>;
  /**
   * permission: timeTracking.report.read.all/team/own
   * Paginated time tracking items with billing info (hourly_rate, amount)
   */
  getTimeTrackingItems: GetTimeTrackingItemsPaginator;
  /**
   * permission: timeTracking.report.read.all/team/own
   * Summary (all ids, totals for times and amounts) for the getTimeTrackingItems query
   */
  getTimeTrackingItemsSummary: GetTimeTrackingItemsSummary;
  getTotalInWords: Scalars['String']['output'];
  getUnmatchedWorkTypesForTaskMove: TaskMoveUnmatchedData;
  globalCreditAccount?: Maybe<GlobalCreditAccount>;
  globalCreditAccounts?: Maybe<GlobalCreditAccountPaginator>;
  hasTaskPermission: Scalars['Boolean']['output'];
  invoicePaymentMethods: Array<InvoicePaymentMethod>;
  isUserInTask: Scalars['Boolean']['output'];
  languagesForInvoicePdf: Array<Scalars['String']['output']>;
  lowestDateWithOpenProgress?: Maybe<Scalars['Date']['output']>;
  me?: Maybe<User>;
  /** permission: project.read.all/team/own */
  mlggkProjectsEffectivenessExport: Scalars['String']['output'];
  /** permission: outgoingInvoice.accessAccountingAttributes */
  mrpOIExport: Scalars['String']['output'];
  /** permission: outgoingInvoice.read.all/own/team */
  notPaidOIExport: Scalars['String']['output'];
  notificationSettings: Array<NotificationSetting>;
  notificationWorkspaceSettings?: Maybe<NotificationSettings>;
  notifications?: Maybe<NotificationPaginator>;
  /**
   * Paginovany listing OI budget items pre Time Billing.
   * Vracia kombinacie outgoing_invoice + budget_item (OurWork + Expense) so sumou.
   * permission: outgoingInvoice.read.all/own/team
   */
  oiBudgetItemsForTimeBilling: OiBudgetItemsForTimeBillingPaginator;
  /**
   * Summary (count + amount) pre OI budget items for Time Billing.
   * permission: outgoingInvoice.read.all/own/team
   */
  oiBudgetItemsForTimeBillingSummary: TimeBillingSummary;
  omegaExpenseExport?: Maybe<Scalars['String']['output']>;
  omegaExport?: Maybe<Scalars['String']['output']>;
  omegaProformaExport?: Maybe<Scalars['String']['output']>;
  /** permission: order.read */
  order?: Maybe<Order>;
  /** permission: order.read */
  orders?: Maybe<OrderPaginator>;
  /** permission: order.read */
  ordersSummary: OrdersSummary;
  /** permission: order.read */
  ordersWithPdf: Array<Order>;
  /** permission: otherDocument.read */
  otherDocument?: Maybe<OtherDocument>;
  /** permission: otherDocument.read */
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  /** permission: otherDocument.read */
  otherDocumentsSummary: OtherDocumentsSummary;
  /** permission: otherDocument.read */
  otherDocumentsWithPdf: Array<OtherDocument>;
  ourWorkBudgetCategories?: Maybe<Array<OurWorkBudgetCategory>>;
  /** permission: project.read.all/team/own */
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
  /** permission: project.read.all/team/own */
  ourWorkBudgetItemsByItemCode: Array<OurWorkBudgetItemSimple>;
  ourWorkBudgetItemsSimpleMap: Array<OurWorkBudgetItemSimple>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingInvoices?: Maybe<OutgoingInvoicePaginator>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingInvoicesSummary: OutgoingInvoicesSummary;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingProformaInvoice?: Maybe<OutgoingProformaInvoice>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingProformaInvoices?: Maybe<OutgoingProformaInvoicePaginator>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingProformaInvoicesSummary: OutgoingProformaInvoicesSummary;
  paymentSettings?: Maybe<PaymentSettings>;
  paymentTypes: Array<PaymentType>;
  /**
   * Listing projektov s prehladom planovanych nakladov (planned expenses)
   * Pre kazdy projekt zobrazuje budget items (Our Work + Expense) s agregovanymu sumami
   * z budget_item_planned_expenses + stats views
   *
   * permission: project.read.all/own/team
   */
  plannedExpensesOverview?: Maybe<PlannedExpensesProjectPaginator>;
  /**
   * Sumarizacia pre planned expenses overview (celkove statistiky napriec filtrovanymi projektami)
   *
   * permission: project.read.all/own/team
   */
  plannedExpensesOverviewSummary: PlannedExpensesSummary;
  planningDailyViewPeople: PlanningDailyViewPaginator;
  planningDailyViewUnassignedTasks: Array<PlanningDailyViewUnassignedTasksPerDay>;
  /** permission: outgoingInvoice.read.all/own/team */
  pohodaExpenseExport?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  pohodaOIExport?: Maybe<Scalars['String']['output']>;
  pohodaOPIExport?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  premierOIExport?: Maybe<Scalars['String']['output']>;
  premierProformaOIExport?: Maybe<Scalars['String']['output']>;
  prepareTaskDataForBulkActions: TaskBulkActionsData;
  /**
   * Preview/Prepočet Time Billing z poskytnutých dát (BEZ uloženia)
   * Používa sa na real-time prepočítavanie hodnôt počas editácie
   * permission: project.read.all/own/team
   */
  previewProjectTimeBilling: ProjectTimeBillingComputed;
  profitLossReport: ProfitLossReportGroupPaginator;
  profitLossReportSummary: ProfitLossReportSummary;
  /** permission: project.read.all/team/own */
  project?: Maybe<Project>;
  /**
   * Detail jedného projektu s billing plánom
   *
   * permission: project.read.all/own/team
   */
  projectBilling: ProjectBilling;
  /**
   * Listing projektov s billing plánmi a faktúrami
   * Zobrazuje plánované faktúry z BillingPlanBudgetCache + skutočné faktúry
   * Pre manuálne billing plány zobrazuje len existujúce faktúry + summary riadok
   *
   * Parameter with_prepayment:
   * - false (default): Zobrazí len faktúry, invoiced_amount je celková suma faktúry
   * - true: Pridá samostatné riadky pre prepayment čerpania a zníži invoiced_amount o použité prepayments
   *
   * permission: project.read.all/own/team AND outgoingInvoice.read.all/own/team
   */
  projectBillings?: Maybe<ProjectBillingPaginator>;
  /**
   * Export projektových factúr do Excelu
   *
   * permission: project.read.all/own/team AND outgoingInvoice.read.all/own/team
   */
  projectBillingsExport: Scalars['String']['output'];
  /**
   * Štatistiky pre project billings
   *
   * permission: project.read.all/own/team
   */
  projectBillingsSummary: ProjectBillingsSummary;
  projectCategories: Array<ProjectCategory>;
  projectDatesForBudgetChange: ProjectDatesForBudgetChange;
  /** the minimum necessary data for someone who doesnt have access to the whole project but has to an expense */
  projectForExpense: ProjectForExpense;
  projectForTask: ProjectForTask;
  /** permission: project.read.all/team/own */
  projectGraph: ProjectGraph;
  projectHasTimeTrackedForPositions: Array<TimeTrackingWorkType>;
  projectLimited?: Maybe<ProjectLimited>;
  projectManagerSimpleMap: Array<UserSimple>;
  /** permission: wip.read.all/team/own */
  projectProgressStatisticsExport: Scalars['String']['output'];
  projectRateCard: Array<Maybe<ProjectRateCard>>;
  /** permission: project.read.all/team/own */
  projectRevenue: ProjectRevenue;
  projectRevenueDetail: ProjectWithRevenue;
  /** permission: project.read.all/team/own */
  projectRevenueSummary: ProjectRevenueSummary;
  projectSettings?: Maybe<ProjectSettings>;
  projectStages: Array<ProjectStage>;
  /**
   * Detail Time Billing podľa ID
   * permission: project.read.all/own/team (cez project)
   */
  projectTimeBilling?: Maybe<ProjectTimeBilling>;
  /**
   * Zoznam Time Billings pre projekt
   * permission: project.read.all/own/team
   */
  projectTimeBillings?: Maybe<ProjectTimeBillingPaginator>;
  projectTimeBreakdowns: Array<ProjectTimeBreakdownResponse>;
  /** permission: wip.read.all/team/own */
  projectWipExport: Scalars['String']['output'];
  /** permission: project.read.all/team/own */
  projects?: Maybe<ProjectPaginator>;
  projectsAll?: Maybe<ProjectSimplePaginator>;
  /** permission: project.read.all/team/own */
  projectsCommissionExport: Scalars['String']['output'];
  /** permission: project.read.all/team/own */
  projectsEffectivenessExport: Scalars['String']['output'];
  /** permission: project.read.all/team/own */
  projectsForPlanovac?: Maybe<ProjectForPlanovacPaginator>;
  projectsLimited?: Maybe<ProjectLimitedPaginator>;
  /** permission: project.read.all/team/own */
  projectsProfitExport: Scalars['String']['output'];
  projectsSimpleMap: Array<ProjectSimple>;
  /** permission: project.read.all/team/own */
  projectsSummary: ProjectsSummary;
  /** permission: wip.read.all/team/own */
  projectsWithPeriods?: Maybe<WorkInProgressProjectStatPaginator>;
  /** permission: outgoingInvoice.read.all/own/team */
  prolucOIExport?: Maybe<Scalars['String']['output']>;
  /** permission: requestForInvoicing.read.all/own/team */
  requestForInvoicing?: Maybe<RequestForInvoicing>;
  /** permission: requestForInvoicing.read.all/own/team */
  requestsForInvoicing?: Maybe<RequestForInvoicingPaginator>;
  /** permission: requestForInvoicing.read.all/own/team */
  requestsForInvoicingSummary: RequestsForInvoicingSummary;
  responsiblePersonsSimpleMap: Array<UserSimple>;
  roles: Array<Role>;
  runningTimer?: Maybe<Timer>;
  sequenceSettings?: Maybe<Array<Sequence>>;
  /** permission: task.read.all/own for given task */
  task: Task;
  taskAndCommunicationNotifications: TaskAndCommunicationNotificationsPaginator;
  /**
   * Card counts per board column for the same filters as `tasks`, one page of columns at a time.
   * DONE statuses collapse into the `complete` column, which is returned only with `include_complete`.
   * With `group_values`, only those columns are returned (e.g. source and target after a move) and
   * `first`/`page`/`include_complete` are ignored; `unassigned` and `complete` are valid values.
   * Columns list every workspace user and time totals, so scoped users are left out.
   * permission: task.read.all/own + task.viewAllFields
   */
  taskBoardColumnCounts: TaskBoardColumnCountPaginator;
  /**
   * Current user's board settings for the given board_key. Null when none saved yet.
   * permission: none, own settings only (authenticated user)
   */
  taskBoardSettings?: Maybe<TaskBoardSettings>;
  taskCommentFiles: Array<AssignableFile>;
  /** permission: task.read.all/own for given task */
  taskComments?: Maybe<TaskCommentPaginator>;
  taskIds?: Maybe<Array<Scalars['ID']['output']>>;
  taskLinkTypes: Array<TaskLinkType>;
  /** permission: task.read.all/own for given task */
  taskPositionStat: Array<TaskPositionStat>;
  taskPriorities: Array<TaskPriority>;
  taskStatuses: Array<TaskStatus>;
  taskTemplateGroup: TaskTemplateGroup;
  taskTemplateGroups: Array<Maybe<TaskTemplateGroup>>;
  /** permission: task.read.all/own */
  tasks?: Maybe<TaskPaginator>;
  tasksSimpleMap: Array<TaskSimple>;
  teamSimpleMap: Array<Team>;
  timeMaterialsInvoiceData: TimeMaterialsDataForInvoicing;
  /** All available time off types. */
  timeOffTypesQuery?: Maybe<Array<TimeOffType>>;
  /** Time offs export. */
  timeOffsExport: Scalars['String']['output'];
  timeTrackingItem: TimeTrackingItem;
  /** permission: timeTracking.read.all/team/own */
  timeTrackingItems: Array<TimeTrackingItem>;
  /** permission: timeTracking.read.all */
  timeTrackingItemsPaginated?: Maybe<TimeTrackingItemPaginator>;
  /**
   * Distinct work types the given time tracking items are tracked on.
   * permission: timeTracking.read.all/team/own
   */
  timeTrackingItemsWorkTypes: Array<TimeTrackingWorkType>;
  /** use me for time tracking modal, no permissions needed */
  timeTrackingOptionsForProject: TimeTrackingOptionsForProject;
  /** permission: project.timeTrackingReport.read.all/team/own */
  timeTrackingProjectReport?: Maybe<Array<Maybe<TimeTrackingProjectReport>>>;
  /**
   * permission: timeTracking.report.read.all/team/own
   * orderBy radí položky vnútri skupín (items), nie skupiny samotné.
   */
  timeTrackingReport: TimeTrackingReportPaginator;
  /** permission: timeTracking.report.read.all/team/own */
  timeTrackingReportExport: Scalars['String']['output'];
  timeTrackingReportExportPdf: Scalars['String']['output'];
  /** permission: timeTracking.report.read.all/team/own */
  timeTrackingReportSummary: TimeTrackingReportSummary;
  /** permission: timeTracking.read.all/team/own */
  timeTrackingSummaryPerDay?: Maybe<Array<TimeTrackingSummaryPerDay>>;
  timeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  transakcioExpenseExport?: Maybe<Scalars['String']['output']>;
  /** permission: project.read.all/team/own */
  triadProjectsEffectivenessExport: Scalars['String']['output'];
  unreadNotificationsCount: Scalars['BigInt']['output'];
  /** permission: outgoingInvoice.read.all/own/team */
  unusedPaidOutgoingProformaInvoices: Array<OutgoingProformaInvoice>;
  updateWorkspacePlanningSettings: WorkspacePlanningSettings;
  /** permission: user.read.all/user.read.own */
  user?: Maybe<User>;
  /** permission: timeTracking.report.read.all/team/own */
  userEffectivenessReportExport: Scalars['String']['output'];
  userMonthlyReport: UserMonthlyReportPaginator;
  /** permission: timeTracking.userMonthlyReport.read */
  userMonthlyReportExport: Scalars['String']['output'];
  userSimpleMap: Array<UserSimple>;
  /** permission: user.read.all */
  users?: Maybe<UserPaginator>;
  /** permission: user.read */
  usersForPlanovac: Array<UserForPlanovac>;
  /** permission: user.read.all */
  usersSummary: UsersSummary;
  /** permission: utilizationReport.query.all */
  utilizationReport: UtilizationReportPaginator;
  /** permission: utilizationReport.query.all */
  utilizationReportExport: Scalars['String']['output'];
  /** permission: utilizationReport.query.all */
  utilizationReportGroups: UtilizationReportGroupPaginator;
  /** permission: utilizationReport.query.all */
  utilizationReportSummary: UtilizationReport;
  /** permission: utilizationReport.query.all */
  utilizationTaskReport: Array<UtilizationTaskReport>;
  /** permission: utilizationReport.query.all */
  utilizationUserReport?: Maybe<UtilizationUserReport>;
  varioExpenseExport?: Maybe<Scalars['String']['output']>;
  varioOIExport?: Maybe<Scalars['String']['output']>;
  vatRates?: Maybe<Array<VatRate>>;
  verifyAccessTokenFromThirdParty?: Maybe<SingleSignOnData>;
  /** permission: timeTracking.read.all/team/own */
  weekTimeReport: WeekTimeReport;
  wipForBudgetAndPeriod?: Maybe<WorkInProgressItemStat>;
  wipPeriodsMap: Array<WipPeriod>;
  /** permission: wip.read.all/team/own */
  wipProjectsPeriodSummary: PeriodSummary;
  workspaceAccountingAccountSetting: WorkspaceAccountingAccountSettings;
  workspaceAccountingCentreSetting: WorkspaceAccountingCentreSettings;
  workspaceAccountingVatClassificationSetting: WorkspaceAccountingVatClassificationSettings;
  workspaceAutoExpenseEmailSettings?: Maybe<WorkspaceAutoExpenseEmailSettings>;
  workspaceCompaniesSettings: Array<WorkspaceCompanySetting>;
  workspaceExchangeRatesForBudgetovac: Array<CurrencyExchangeRate>;
  workspaceFinancialSettings: WorkspaceFinancialSetting;
  workspacePipedriveIntegration: WorkspacePipedriveIntegration;
  workspaceProjectSettings: WorkspaceProjectSettings;
  workspaceSettings?: Maybe<WorkspaceSettings>;
  workspaceSmtpSettings?: Maybe<WorkspaceSmtpSettings>;
  workspaceTaskSettings: WorkspaceTaskSettings;
  workspaceUserManagementSetting: WorkspaceUserManagementSetting;
  /** permission: outgoingInvoice.read.all/own/team */
  xeroOIExport?: Maybe<Scalars['String']['output']>;
};


export type QueryExpenseAttachmentsExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuoteEmailDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUsersAllocatedTimeArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  types: Array<CapacityAllocationTypeEnum>;
  user_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetUsersAllocationConflictsArgs = {
  from: Scalars['Date']['input'];
  from_time?: InputMaybe<Scalars['Time']['input']>;
  repetition_settings?: InputMaybe<Array<InputMaybe<RepetitionSettingsDaysEnum>>>;
  to: Scalars['Date']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  types: Array<CapacityAllocationTypeEnum>;
  user_ids: Array<Scalars['ID']['input']>;
};


export type QueryAbraFlexiOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  outgoing_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAbraFlexiOutgoingProformaInvoicesExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAccountingAccountsSimpleMapArgs = {
  type?: InputMaybe<Accounting_Account_Type>;
};


export type QueryAccountingCentresArgs = {
  type?: InputMaybe<Accounting_Centre_Type>;
};


export type QueryAvailableTaskPositionsHoursByOurWorkBudgetArgs = {
  our_work_budget_item_id: Scalars['ID']['input'];
};


export type QueryBankAccountConverterArgs = {
  account_code?: InputMaybe<Scalars['String']['input']>;
  account_number: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
};


export type QueryBankAccountMovesArgs = {
  filters?: InputMaybe<BankAccountMoveQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingEntitiesArgs = {
  filters?: InputMaybe<BillingEntityQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlanBudgetArgs = {
  billing_item_type: BillingItemTypEnum;
  project_id: Scalars['ID']['input'];
};


export type QueryBillingPlanCacheOverviewArgs = {
  filters: BillingPlanCacheOverviewQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlanCacheOverviewSummaryArgs = {
  filters: BillingPlanCacheOverviewQueryArgs;
};


export type QueryBillingPlanOverviewArgs = {
  filters: BillingPlanOverviewQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlanOverviewSummaryArgs = {
  filters: BillingPlanOverviewQueryArgs;
};


export type QueryBrandArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandCreditAccountsArgs = {
  filters?: InputMaybe<CreditAccountQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandCreditAccountsSummaryArgs = {
  filters?: InputMaybe<CreditAccountQueryArgs>;
};


export type QueryBrandRevenueArgs = {
  filters?: InputMaybe<BrandRevenueQueryArgs>;
};


export type QueryBrandRevenueSummaryArgs = {
  filters?: InputMaybe<BrandRevenueQueryArgs>;
};


export type QueryBrandsArgs = {
  filters?: InputMaybe<BrandQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandsForClientArgs = {
  client_id: Scalars['ID']['input'];
};


export type QueryBrandsSummaryArgs = {
  filters?: InputMaybe<BrandQueryArgs>;
};


export type QueryBudgetItemPlannedExpensesArgs = {
  budget_item_id: Scalars['ID']['input'];
  budget_item_type: ExpenseBudgetItemTypeEnum;
};


export type QueryBudgetovacPositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetovacPositionsSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetovacPositionsSetsArgs = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBudgetsArgs = {
  filters?: InputMaybe<BudgetArgs>;
};


export type QueryBudgetsExportArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  options?: InputMaybe<BudgetExportOptionsInput>;
};


export type QueryBudgetsForProjectArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryBulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRatesArgs = {
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  items: Array<AmountToConvert>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBulkConvertAmountToWorkspaceCurrencyUsingUserExchangeRatesArgs = {
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  items: Array<AmountToConvert>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBulkDownloadOutgoingInvoicesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryBulkDownloadOutgoingProformaInvoicesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCapacityAllocationDetailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCapacityAllocationItemDetailQueryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCapacityAllocationItemListArgs = {
  date: Scalars['Date']['input'];
  task_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};


export type QueryCapacityAllocationItemTimeTrackingItemsArgs = {
  id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryCfExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCheckIfCreditAccountsBelongToTheSameTeamArgs = {
  credit_account_ids: Array<Scalars['ID']['input']>;
};


export type QueryCheckInvoiceNumberExistArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  document_id?: InputMaybe<Scalars['ID']['input']>;
  document_no?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  workspace_company_id: Scalars['ID']['input'];
};


export type QueryCheckTimeTrackingItemsLockedArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientExchangeRatesForBudgetovacArgs = {
  client_id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryClientOiExportArgs = {
  filters?: InputMaybe<OiQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryClientsArgs = {
  filters?: InputMaybe<ClientQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientsSimpleMapArgs = {
  deleted_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCommentHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  orderBy?: InputMaybe<Array<QueryContactsOrderByOrderByClause>>;
};


export type QueryContractArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractorsArgs = {
  filters?: InputMaybe<ContractorQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractorsBasicArgs = {
  filters?: InputMaybe<ContractorBasicQueryArgs>;
};


export type QueryContractorsSummaryArgs = {
  filters?: InputMaybe<ContractorQueryArgs>;
};


export type QueryContractsArgs = {
  filters?: InputMaybe<ContractQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractsExportArgs = {
  filters?: InputMaybe<ContractQueryArgs>;
};


export type QueryContractsSimpleMapArgs = {
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractsSummaryArgs = {
  filters?: InputMaybe<ContractQueryArgs>;
};


export type QueryConvertAmountToWorkspaceCurrencyUsingExchangeRateArgs = {
  amount_in_currency: Scalars['BigInt']['input'];
  client_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  type: ExchangeRateSource;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCreateDataForProjectTimeBillingArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
};


export type QueryCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseAbraFlexiExportArgs = {
  expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpenseBudgetCategoriesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryExpenseBudgetItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExpenseBudgetItemsByItemCodeArgs = {
  item_code: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExpenseBudgetItemsSimpleMapArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryExpenseBudgetItemsWithStatusArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryExpenseExportArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpenseItemsForProjectArgs = {
  budget_item_id: Scalars['ID']['input'];
};


export type QueryExpenseItemsForTimeBillingArgs = {
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpenseItemsForTimeBillingSummaryArgs = {
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
};


export type QueryExpensePremierExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryExpenseSummaryExportBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryExpenseSummaryExportSimpleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseXmlExportArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpenseXeroExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpensesArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpensesSummaryArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
};


export type QueryExportBillingPlanArgs = {
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
};


export type QueryExternalLinksArgs = {
  model_type?: InputMaybe<ExternalLinkType>;
};


export type QueryFetchOcrExpenseDataArgs = {
  file: Scalars['Upload']['input'];
};


export type QueryFilterTemplatesArgs = {
  model_id?: InputMaybe<Scalars['ID']['input']>;
  model_type: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFinancialOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGenerateExpensePaymentOrderArgs = {
  date: Scalars['Date']['input'];
  expense_ids: Array<Scalars['ID']['input']>;
  payment_type_id: Scalars['ID']['input'];
  type: ExpensePaymentOrderExportType;
};


export type QueryGetAccessTokenForThirdPartyArgs = {
  appName?: InputMaybe<ThirdPartyEnum>;
};


export type QueryGetAutocompleteForCompanyDataArgs = {
  country_id: Scalars['ID']['input'];
  input: Scalars['String']['input'];
};


export type QueryGetAvailableProjectsForBulkMovingTimeTrackingItemsArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetAvailableWorkTypesForBulkMovingTimeTrackingItemsArgs = {
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetBillingPlanBudgetPdfArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryGetBudgetQuotesArgs = {
  filters?: InputMaybe<QuotesArgs>;
};


export type QueryGetCompanyDataByRegistrationNoArgs = {
  country_id: Scalars['ID']['input'];
  registration_no: Scalars['String']['input'];
};


export type QueryGetDuplicateExpensesIDsArgs = {
  contractor_id: Scalars['ID']['input'];
  document_number: Scalars['String']['input'];
  exclude_expense_id?: InputMaybe<Scalars['ID']['input']>;
  variable_symbol: Scalars['String']['input'];
};


export type QueryGetInvoiceEmailDataArgs = {
  outgoing_invoice_id: Scalars['ID']['input'];
};


export type QueryGetModelLockArgs = {
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
};


export type QueryGetNewInvoiceNumberArgs = {
  date: Scalars['Date']['input'];
  document_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_order_sequence_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  workspace_company_id: Scalars['ID']['input'];
};


export type QueryGetProformaInvoiceEmailDataArgs = {
  outgoing_proforma_invoice_id: Scalars['ID']['input'];
};


export type QueryGetProjectCanBeFinishedSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTagsArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTimeTrackingItemsArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryGetTimeTrackingItemsSummaryArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryGetTotalInWordsArgs = {
  amount: Scalars['BigInt']['input'];
  language: Scalars['String']['input'];
};


export type QueryGetUnmatchedWorkTypesForTaskMoveArgs = {
  new_project_id: Scalars['ID']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};


export type QueryGlobalCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalCreditAccountsArgs = {
  filters?: InputMaybe<GlobalCreditAccountQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHasTaskPermissionArgs = {
  task_id: Scalars['ID']['input'];
  type: TaskPermissionTypeEnum;
};


export type QueryIsUserInTaskArgs = {
  task_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryMlggkProjectsEffectivenessExportArgs = {
  dateOfSupply?: InputMaybe<DateRange>;
  filters?: InputMaybe<ProjectQueryArgs>;
  finishedAt?: InputMaybe<DateRange>;
  startDate?: InputMaybe<DateRange>;
};


export type QueryMrpOiExportArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryNotPaidOiExportArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<OiQueryArgs>;
};


export type QueryNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
};


export type QueryOiBudgetItemsForTimeBillingArgs = {
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
};


export type QueryOiBudgetItemsForTimeBillingSummaryArgs = {
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
};


export type QueryOmegaExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryOmegaExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryOmegaProformaExportArgs = {
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrdersArgs = {
  filters?: InputMaybe<OrderQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrdersSummaryArgs = {
  filters?: InputMaybe<OrderQueryArgs>;
};


export type QueryOrdersWithPdfArgs = {
  brand_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOtherDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOtherDocumentsArgs = {
  filters?: InputMaybe<OtherDocumentQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOtherDocumentsSummaryArgs = {
  filters?: InputMaybe<OtherDocumentQueryArgs>;
};


export type QueryOtherDocumentsWithPdfArgs = {
  brand_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOurWorkBudgetCategoriesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryOurWorkBudgetItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOurWorkBudgetItemsByItemCodeArgs = {
  item_code: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOurWorkBudgetItemsSimpleMapArgs = {
  open?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOutgoingInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutgoingInvoicesArgs = {
  filters?: InputMaybe<OiQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutgoingInvoicesSummaryArgs = {
  filters?: InputMaybe<OiQueryArgs>;
};


export type QueryOutgoingProformaInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutgoingProformaInvoicesArgs = {
  filters?: InputMaybe<OiProformaQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutgoingProformaInvoicesSummaryArgs = {
  filters?: InputMaybe<OiProformaQueryArgs>;
};


export type QueryPlannedExpensesOverviewArgs = {
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlannedExpensesOverviewSummaryArgs = {
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
};


export type QueryPlanningDailyViewPeopleArgs = {
  filters: PlanningDailyViewFilters;
};


export type QueryPlanningDailyViewUnassignedTasksArgs = {
  filters: PlanningDailyViewUnassignedTasksFilters;
};


export type QueryPohodaExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryPohodaOiExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPohodaOpiExportArgs = {
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPremierOiExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPremierProformaOiExportArgs = {
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPrepareTaskDataForBulkActionsArgs = {
  destination_budget_item_id: Scalars['ID']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};


export type QueryPreviewProjectTimeBillingArgs = {
  input: PreviewProjectTimeBillingInput;
};


export type QueryProfitLossReportArgs = {
  columns?: InputMaybe<ProfitLossReportColumns>;
  first?: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  include_draft_expenses?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['BigInt']['input'];
  rows: ProfitLossReportRows;
  to: Scalars['Date']['input'];
  where?: InputMaybe<ProfitLossReportWhereConditions>;
};


export type QueryProfitLossReportSummaryArgs = {
  columns?: InputMaybe<ProfitLossReportColumns>;
  from: Scalars['Date']['input'];
  include_draft_expenses?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<ProfitLossReportWhereConditions>;
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectBillingArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
  with_prepayment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectBillingsArgs = {
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectBillingsExportArgs = {
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
};


export type QueryProjectBillingsSummaryArgs = {
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
};


export type QueryProjectDatesForBudgetChangeArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryProjectForExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectForTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectGraphArgs = {
  our_work_budget_item_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_id: Scalars['ID']['input'];
};


export type QueryProjectHasTimeTrackedForPositionsArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryProjectLimitedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectManagerSimpleMapArgs = {
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectProgressStatisticsExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  wip_period_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProjectRateCardArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectRevenueArgs = {
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
};


export type QueryProjectRevenueDetailArgs = {
  from: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};


export type QueryProjectRevenueSummaryArgs = {
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
};


export type QueryProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectTimeBillingsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryProjectTimeBillingsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['ID']['input'];
};


export type QueryProjectTimeBreakdownsArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryProjectWipExportArgs = {
  period_id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  filters?: InputMaybe<ProjectQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsAllArgs = {
  filters?: InputMaybe<ProjectAllQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsCommissionExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryProjectsEffectivenessExportArgs = {
  dateOfSupply?: InputMaybe<DateRange>;
  filters?: InputMaybe<ProjectQueryArgs>;
  finishedAt?: InputMaybe<DateRange>;
  startDate?: InputMaybe<DateRange>;
};


export type QueryProjectsForPlanovacArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryProjectsLimitedArgs = {
  filters?: InputMaybe<ProjectLimitedQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsProfitExportArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryProjectsSimpleMapArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  deleted_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  my_projects?: InputMaybe<Scalars['Boolean']['input']>;
  orIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatusEnum>;
  type?: InputMaybe<ProjectTypeEnum>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  withFinished?: InputMaybe<Scalars['Boolean']['input']>;
  withProBono?: InputMaybe<Scalars['Boolean']['input']>;
  with_templates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectsSummaryArgs = {
  filters?: InputMaybe<ProjectQueryArgs>;
};


export type QueryProjectsWithPeriodsArgs = {
  filters?: InputMaybe<WipQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProlucOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryRequestForInvoicingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRequestsForInvoicingArgs = {
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRequestsForInvoicingSummaryArgs = {
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
};


export type QueryRunningTimerArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskAndCommunicationNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTaskBoardColumnCountsArgs = {
  filters?: InputMaybe<TaskQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: TaskBoardGroupByEnum;
  group_values?: InputMaybe<Array<Scalars['ID']['input']>>;
  include_complete?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskBoardSettingsArgs = {
  board_key: Scalars['String']['input'];
};


export type QueryTaskCommentFilesArgs = {
  scope?: InputMaybe<UserScopeEnum>;
  task_id: Scalars['ID']['input'];
};


export type QueryTaskCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last_comment_ID?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeEnum>;
  task_id: Scalars['ID']['input'];
};


export type QueryTaskIdsArgs = {
  filters?: InputMaybe<TaskQueryArgs>;
};


export type QueryTaskPositionStatArgs = {
  task_id: Scalars['ID']['input'];
};


export type QueryTaskTemplateGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  filters?: InputMaybe<TaskQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTasksSimpleMapArgs = {
  our_work_budget_item_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  parent_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamSimpleMapArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeMaterialsInvoiceDataArgs = {
  filters?: InputMaybe<TimeMaterialsQueryArgs>;
  from: Scalars['Date']['input'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  project_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};


export type QueryTimeOffsExportArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryTimeTrackingItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTimeTrackingItemsArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  without_capacity_allocation_item?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeTrackingItemsPaginatedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tracked_from?: InputMaybe<Scalars['Date']['input']>;
  tracked_to?: InputMaybe<Scalars['Date']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeTrackingItemsWorkTypesArgs = {
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type QueryTimeTrackingOptionsForProjectArgs = {
  date: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
};


export type QueryTimeTrackingProjectReportArgs = {
  filters?: InputMaybe<TimeTrackingProjectReportQueryArgs>;
};


export type QueryTimeTrackingReportArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  groupBy?: InputMaybe<TimeTrackingReportGroupBy>;
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingReportExportArgs = {
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingReportExportPdfArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  report_type: TimeTrackingReportExportType;
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingReportSummaryArgs = {
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingSummaryPerDayArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryTransakcioExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryTriadProjectsEffectivenessExportArgs = {
  filters?: InputMaybe<ProjectQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryUnreadNotificationsCountArgs = {
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>>>;
};


export type QueryUnusedPaidOutgoingProformaInvoicesArgs = {
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  project_ids: Array<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserEffectivenessReportExportArgs = {
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryUserMonthlyReportArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  month: Scalars['BigInt']['input'];
  orderBy?: InputMaybe<UserMonthlyReportOrderByClause>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  year: Scalars['BigInt']['input'];
};


export type QueryUserMonthlyReportExportArgs = {
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
};


export type QueryUserSimpleMapArgs = {
  mentions?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPlannable?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<UsersWhereConditions>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersForPlanovacArgs = {
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersSummaryArgs = {
  filters?: InputMaybe<UserQueryArgs>;
};


export type QueryUtilizationReportArgs = {
  dataSource: UtilizationReportDataSource;
  first?: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause>>;
  page?: Scalars['BigInt']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationReportExportArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationReportGroupsArgs = {
  dataSource: UtilizationReportDataSource;
  first?: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  groupBy: UtilizationReportGroupBy;
  groupOrderBy?: InputMaybe<Array<UtilizationReportGroupOrderByClause>>;
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause>>;
  page?: Scalars['BigInt']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationReportSummaryArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationTaskReportArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUtilizationUserReportArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryVarioExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryVarioOiExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryVerifyAccessTokenFromThirdPartyArgs = {
  appName?: InputMaybe<ThirdPartyEnum>;
};


export type QueryWeekTimeReportArgs = {
  from: Scalars['Date']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWipForBudgetAndPeriodArgs = {
  our_work_budget_item_id: Scalars['ID']['input'];
  period_id: Scalars['ID']['input'];
};


export type QueryWipPeriodsMapArgs = {
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWipProjectsPeriodSummaryArgs = {
  filters?: InputMaybe<WipQueryArgs>;
};


export type QueryWorkspaceExchangeRatesForBudgetovacArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryXeroOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

/** Allowed column names for Query.contacts.orderBy. */
export enum QueryContactsOrderByColumn {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.contacts.orderBy. */
export type QueryContactsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryContactsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.projectTimeBillings.orderBy. */
export enum QueryProjectTimeBillingsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DateFrom = 'DATE_FROM',
  DateTo = 'DATE_TO',
  FinalTotalAmount = 'FINAL_TOTAL_AMOUNT',
  LockedAt = 'LOCKED_AT'
}

/** Order by clause for Query.projectTimeBillings.orderBy. */
export type QueryProjectTimeBillingsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryProjectTimeBillingsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type Quote = {
  __typename?: 'Quote';
  Client?: Maybe<Client>;
  budgets: Array<Budget>;
  client_approval_date?: Maybe<Scalars['Date']['output']>;
  createdBy: User;
  currency: Currency;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  sent_to_client_date?: Maybe<Scalars['Date']['output']>;
  settings: BudgetPdfSettings;
  status: QuoteStatus;
  total_amount: Scalars['BigInt']['output'];
  url: Scalars['String']['output'];
};

export type QuoteAttachment = {
  __typename?: 'QuoteAttachment';
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuoteEmailData = {
  __typename?: 'QuoteEmailData';
  attachments?: Maybe<Array<QuoteAttachment>>;
  content: Scalars['String']['output'];
  primary_recipient?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject: Scalars['String']['output'];
};

export enum QuoteStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  ManualApproved = 'MANUAL_APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type QuotesArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<Array<BudgetOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  where?: InputMaybe<BudgetWhereConditions>;
};

export type QuotesPaginator = {
  __typename?: 'QuotesPaginator';
  data?: Maybe<Array<Quote>>;
  paginatorInfo: PaginatorInfo;
};

export type Recipient = {
  __typename?: 'Recipient';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RecipientLog = {
  __typename?: 'RecipientLog';
  recipient: Scalars['String']['output'];
  status: RecipientLogStatus;
};

export enum RecipientLogStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Sent = 'SENT',
  Waiting = 'WAITING'
}

export type ReopenCapacityAllocationItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type RepetitionSettings = {
  __typename?: 'RepetitionSettings';
  days?: Maybe<Array<Maybe<RepetitionSettingsDaysEnum>>>;
  end: Scalars['String']['output'];
  every: Scalars['Int']['output'];
  include_holidays?: Maybe<Scalars['Boolean']['output']>;
  startType?: Maybe<TimeOffDurationTypeEnum>;
  toType?: Maybe<TimeOffDurationTypeEnum>;
};

export enum RepetitionSettingsDaysEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type RequestForInvoicing = {
  __typename?: 'RequestForInvoicing';
  billingEntity?: Maybe<BillingEntity>;
  brands: Array<Brand>;
  budget_positions: Array<BudgetPosition>;
  client: Client;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  credit_note_outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  /** For PM/ACC: Requested date of invoicing, for FM: Date of supply */
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  exchange_rate: Scalars['BigInt']['output'];
  exchange_rate_source: ExchangeRateSource;
  expenseBudgetSplits: Array<RequestForInvoicingExpenseBudgetSplitItem>;
  filesToAttach: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<OutgoingInvoiceItem>;
  invoicePaymentMethod?: Maybe<InvoicePaymentMethod>;
  issue_date?: Maybe<Scalars['Date']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  ourWorkBudgetSplits: Array<RequestForInvoicingOurWorkBudgetSplitItem>;
  owner?: Maybe<User>;
  prepaymentSplits: Array<RequestForInvoicingPrepaymentSplitItem>;
  proformaInvoices: Array<OutgoingProformaInvoice>;
  projects: Array<Project>;
  proofOfPayments: Array<OutgoingInvoice>;
  show_billing_accounting: Scalars['Boolean']['output'];
  show_unit_price: Scalars['Boolean']['output'];
  stats: RequestForInvoicingStats;
  status: RequestForInvoicingStatusEnum;
  submit_date?: Maybe<Scalars['Date']['output']>;
  teams: Array<Team>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  timeMaterialsInvoiceData?: Maybe<TimeMaterialsInvoiceData>;
  total_in_words?: Maybe<Scalars['String']['output']>;
  type: RequestForInvoicingTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  vat_reverse_charge: Scalars['Boolean']['output'];
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id: Scalars['ID']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type RequestForInvoicingBudgetSplitItem = {
  amount?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RequestForInvoicingExpenseBudgetSplitItem = RequestForInvoicingBudgetSplitItem & {
  __typename?: 'RequestForInvoicingExpenseBudgetSplitItem';
  amount?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  expense_budget_item_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type RequestForInvoicingOrderByClause = {
  column: RequestForInvoicingOrderByColumnEnum;
  order: SortOrder;
};

export enum RequestForInvoicingOrderByColumnEnum {
  Amount = 'AMOUNT',
  AmountWithVat = 'AMOUNT_WITH_VAT',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Id = 'ID',
  Status = 'STATUS'
}

export type RequestForInvoicingOurWorkBudgetSplitItem = RequestForInvoicingBudgetSplitItem & {
  __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem';
  amount?: Maybe<Scalars['BigInt']['output']>;
  amount_in_percent?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of RequestForInvoicing items. */
export type RequestForInvoicingPaginator = {
  __typename?: 'RequestForInvoicingPaginator';
  /** A list of RequestForInvoicing items. */
  data: Array<RequestForInvoicing>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RequestForInvoicingPrepaymentSplitItem = {
  __typename?: 'RequestForInvoicingPrepaymentSplitItem';
  amount?: Maybe<Scalars['BigInt']['output']>;
  brand_credit_account_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RequestForInvoicingQueryArgs = {
  orderBy?: InputMaybe<Array<RequestForInvoicingOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RequestsForInvoicingWhereConditions>;
};

export type RequestForInvoicingStats = {
  __typename?: 'RequestForInvoicingStats';
  budget_splits_amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
};

export enum RequestForInvoicingStatusEnum {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

export enum RequestForInvoicingTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE',
  Proforma = 'PROFORMA'
}

export type RequestsForInvoicingSummary = {
  __typename?: 'RequestsForInvoicingSummary';
  requestForInvoicingIds: Array<Scalars['ID']['output']>;
};

export enum RequestsForInvoicingWhereColumn {
  BrandId = 'BRAND_ID',
  CreatedAt = 'CREATED_AT',
  OwnerId = 'OWNER_ID',
  Status = 'STATUS',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type RequestsForInvoicingWhereConditions = {
  AND?: InputMaybe<Array<RequestsForInvoicingWhereConditions>>;
  OR?: InputMaybe<Array<RequestsForInvoicingWhereConditions>>;
  column?: InputMaybe<RequestsForInvoicingWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Role = {
  __typename?: 'Role';
  documentLimits?: Maybe<Array<RoleDocumentLimit>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RoleDocumentLimit = {
  __typename?: 'RoleDocumentLimit';
  document_type: DocumentLimitTypeEnum;
  limit: Scalars['BigInt']['output'];
};

/** The available SQL operators that are used to filter query results. */
export enum SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
}

export type Sequence = {
  __typename?: 'Sequence';
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  next_invoice_no: Scalars['String']['output'];
  types: Array<Maybe<SequenceTypesEnum>>;
};

export enum SequenceTypesEnum {
  CreditNote = 'CREDIT_NOTE',
  ExpenseAll = 'EXPENSE_ALL',
  ExpenseBill = 'EXPENSE_BILL',
  ExpenseCard = 'EXPENSE_CARD',
  ExpenseContract = 'EXPENSE_CONTRACT',
  ExpenseInvoice = 'EXPENSE_INVOICE',
  ExpenseOther = 'EXPENSE_OTHER',
  ExpensePaymentReceipt = 'EXPENSE_PAYMENT_RECEIPT',
  ExpenseProforma = 'EXPENSE_PROFORMA',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  Proforma = 'PROFORMA',
  ProformaPayment = 'PROFORMA_PAYMENT'
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
};

export type SingleSignOnData = {
  __typename?: 'SingleSignOnData';
  email?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
};

export type SmtpTestResult = {
  __typename?: 'SmtpTestResult';
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Star = {
  __typename?: 'Star';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  starable: Starable;
  starable_id: Scalars['ID']['output'];
  starable_type: StarsStarableTypeEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type Starable = Project | Task;

export enum StarsStarableTypeEnum {
  Project = 'PROJECT',
  Task = 'TASK'
}

export enum StartDayOfWeekEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type StructuredExpenseItemsItem = {
  __typename?: 'StructuredExpenseItemsItem';
  brand?: Maybe<Brand>;
  expense_items: Array<ExpenseItem>;
  total_amount: Scalars['BigInt']['output'];
};

export type SubmitProgressBulkInput = {
  ids: Array<Scalars['ID']['input']>;
  progress: Scalars['BigInt']['input'];
};

export type SubmitProgressInput = {
  id: Scalars['ID']['input'];
  progress: Scalars['BigInt']['input'];
};

export type SubmitProgressResult = {
  __typename?: 'SubmitProgressResult';
  changedWorkInProgressItemStats: Array<WorkInProgressItemStat>;
  lastWorkInProgressProjectStat: WorkInProgressProjectStat;
};

export type Tag = {
  __typename?: 'Tag';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type Task = {
  __typename?: 'Task';
  attachments_download_url: Scalars['String']['output'];
  billable: Scalars['Boolean']['output'];
  clientCommentCount: Scalars['BigInt']['output'];
  cloudUrl?: Maybe<Scalars['String']['output']>;
  commentCount: Scalars['BigInt']['output'];
  commentFiles: Array<AssignableFile>;
  createdBy?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currentAssignee?: Maybe<User>;
  days_to_deadline?: Maybe<Scalars['Int']['output']>;
  days_to_from?: Maybe<Scalars['Int']['output']>;
  days_to_to?: Maybe<Scalars['Int']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  default_planned_time?: Maybe<Scalars['BigInt']['output']>;
  description?: Maybe<TaskDescription>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  from?: Maybe<Scalars['Date']['output']>;
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_starred: Scalars['Boolean']['output'];
  is_template: Scalars['Boolean']['output'];
  linkedTasks?: Maybe<Array<TaskLink>>;
  name: Scalars['String']['output'];
  otherPeopleTracked?: Maybe<Array<OtherPeopleTracked>>;
  otherPeopleTrackedTotal: Scalars['BigInt']['output'];
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
  parent?: Maybe<Task>;
  partnerCommentCount: Scalars['BigInt']['output'];
  planned_time: Scalars['BigInt']['output'];
  positions: Array<TaskPosition>;
  positionsSpent: Array<Maybe<PositionSpent>>;
  priority: TaskPriority;
  revision: Scalars['String']['output'];
  scopedCommentCount: Scalars['BigInt']['output'];
  scopes: Array<UserScope>;
  stats?: Maybe<TaskStats>;
  status: TaskStatus;
  subtasks?: Maybe<Array<Task>>;
  taskWatchers: Array<Maybe<TaskWatcher>>;
  task_template_group_id?: Maybe<Scalars['ID']['output']>;
  teams: Array<Team>;
  timeTrackingItems: Array<TimeTrackingItem>;
  to?: Maybe<Scalars['Date']['output']>;
  unreadCommentsCount: Scalars['BigInt']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  users: Array<User>;
};

export type TaskAndCommunicationNotificationsPaginator = {
  __typename?: 'TaskAndCommunicationNotificationsPaginator';
  data: Array<NotificationPerTask>;
  paginatorInfo: PaginatorInfo;
};

export type TaskBoardColumnCount = {
  __typename?: 'TaskBoardColumnCount';
  group_label?: Maybe<Scalars['String']['output']>;
  group_value?: Maybe<Scalars['ID']['output']>;
  planned_time: Scalars['BigInt']['output'];
  spent_time: Scalars['BigInt']['output'];
  total: Scalars['Int']['output'];
};

export type TaskBoardColumnCountPaginator = {
  __typename?: 'TaskBoardColumnCountPaginator';
  data: Array<TaskBoardColumnCount>;
  paginatorInfo: PaginatorInfo;
};

export enum TaskBoardGroupByEnum {
  Assignee = 'ASSIGNEE',
  CurrentAssignee = 'CURRENT_ASSIGNEE',
  TaskPriority = 'TASK_PRIORITY',
  TaskStatus = 'TASK_STATUS'
}

/** Per-user board settings keyed by board_key (tab + group by, e.g. "my:TASK_STATUS"). */
export type TaskBoardSettings = {
  __typename?: 'TaskBoardSettings';
  board_key: Scalars['String']['output'];
  collapsed_columns: Array<Scalars['String']['output']>;
  column_order: Array<Scalars['String']['output']>;
  hidden_columns: Array<Scalars['String']['output']>;
  sort?: Maybe<TaskBoardSort>;
};

export type TaskBoardSort = {
  __typename?: 'TaskBoardSort';
  column: Scalars['String']['output'];
  direction: SortOrder;
};

export type TaskBoardSortInput = {
  column: Scalars['String']['input'];
  direction: SortOrder;
};

export type TaskBulkActionsData = {
  __typename?: 'TaskBulkActionsData';
  available_positions: Array<TimeTrackingWorkType>;
  has_subtasks: Scalars['Boolean']['output'];
  unavailable_positions: Array<TimeTrackingWorkType>;
};

export type TaskComment = {
  __typename?: 'TaskComment';
  body: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  files: Array<AssignableFile>;
  has_edits?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  in_reply_to?: Maybe<TaskComment>;
  mentioned_user_ids?: Maybe<Array<Scalars['ID']['output']>>;
  reactions?: Maybe<Array<Maybe<TaskCommentReaction>>>;
  task: Task;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

/** A paginated list of TaskComment items. */
export type TaskCommentPaginator = {
  __typename?: 'TaskCommentPaginator';
  /** A list of TaskComment items. */
  data: Array<TaskComment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TaskCommentReaction = {
  __typename?: 'TaskCommentReaction';
  emoji_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  task_comment_id: Scalars['ID']['output'];
  user: User;
};

export type TaskDescription = {
  __typename?: 'TaskDescription';
  body?: Maybe<Scalars['String']['output']>;
  mentioned_assignees?: Maybe<Scalars['Boolean']['output']>;
  mentioned_team_ids?: Maybe<Array<Scalars['ID']['output']>>;
  mentioned_user_ids?: Maybe<Array<Scalars['ID']['output']>>;
};

export type TaskDescriptionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  mentioned_assignees?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TaskLink = {
  __typename?: 'TaskLink';
  id: Scalars['ID']['output'];
  link_type?: Maybe<TaskLinkType>;
  link_type_id: Scalars['ID']['output'];
  linked_task: Task;
  linked_task_id: Scalars['ID']['output'];
  task_id: Scalars['ID']['output'];
};

export type TaskLinkType = {
  __typename?: 'TaskLinkType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TaskMoveUnmatchedData = {
  __typename?: 'TaskMoveUnmatchedData';
  has_time_tracking_entries: Scalars['Boolean']['output'];
  target_available_work_types: Array<TimeTrackingWorkType>;
  unmatched_work_types: Array<TimeTrackingWorkType>;
};

export type TaskOrderByClause = {
  /** Board context: tab + group by, e.g. "my:TASK_STATUS". Required when column is BOARD_ORDER. */
  board_key?: InputMaybe<Scalars['String']['input']>;
  column: TaskOrderByColumnEnum;
  order: SortOrder;
};

export enum TaskOrderByColumnEnum {
  BoardOrder = 'BOARD_ORDER',
  BudgetItemTitle = 'BUDGET_ITEM_TITLE',
  CreatedAt = 'CREATED_AT',
  Deadline = 'DEADLINE',
  From = 'FROM',
  Id = 'ID',
  IsStarred = 'IS_STARRED',
  /** Tasks the current user has a running timer on first (ASC). */
  IsTracking = 'IS_TRACKING',
  ProjectTitle = 'PROJECT_TITLE',
  TaskName = 'TASK_NAME',
  TaskPriority = 'TASK_PRIORITY',
  TaskStatus = 'TASK_STATUS',
  Title = 'TITLE',
  To = 'TO',
  UpdatedAt = 'UPDATED_AT'
}

/** A paginated list of Task items. */
export type TaskPaginator = {
  __typename?: 'TaskPaginator';
  /** A list of Task items. */
  data: Array<Task>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TaskPermissionTypeEnum {
  Delete = 'DELETE',
  Update = 'UPDATE',
  UpdateCurrentAssignee = 'UPDATE_CURRENT_ASSIGNEE',
  UpdateScoped = 'UPDATE_SCOPED',
  UpdateStatus = 'UPDATE_STATUS'
}

export type TaskPosition = {
  __typename?: 'TaskPosition';
  id: Scalars['ID']['output'];
  planned_time: Scalars['BigInt']['output'];
  spent_time: Scalars['BigInt']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
  user?: Maybe<User>;
};

export type TaskPositionHour = {
  __typename?: 'TaskPositionHour';
  planned_time: Scalars['BigInt']['output'];
  time_tracking_work_type_id: Scalars['ID']['output'];
};

export type TaskPositionInput = {
  planned_time: Scalars['BigInt']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskPositionStat = {
  __typename?: 'TaskPositionStat';
  planned_time: Scalars['BigInt']['output'];
  spent_time: Scalars['BigInt']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
  user?: Maybe<User>;
};

export type TaskPriority = {
  __typename?: 'TaskPriority';
  /** Shown instead of the system priority icon. */
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_priority?: Maybe<TaskSystemPriorityEnum>;
};

export type TaskQueryArgs = {
  orderBy?: InputMaybe<Array<TaskOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TaskWhereConditions>;
};

export type TaskSimple = {
  __typename?: 'TaskSimple';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Task>;
  planned_time: Scalars['BigInt']['output'];
  positions: Array<TaskPosition>;
  priority: TaskPriority;
  status: TaskStatus;
  subtasks?: Maybe<Array<Task>>;
  to?: Maybe<Scalars['Date']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TaskStats = {
  __typename?: 'TaskStats';
  allocated_time: Scalars['Int']['output'];
  history_spent_time: Scalars['Int']['output'];
  left_to_allocate: Scalars['Int']['output'];
  planned_time: Scalars['Int']['output'];
  spent_time: Scalars['Int']['output'];
};

export type TaskStatus = {
  __typename?: 'TaskStatus';
  background_color: Scalars['String']['output'];
  foreground_color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_status?: Maybe<TaskSystemStatusEnum>;
};

export enum TaskSystemPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export enum TaskSystemStatusEnum {
  Done = 'DONE',
  New = 'NEW'
}

export type TaskTemplateGroup = {
  __typename?: 'TaskTemplateGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tasks?: Maybe<Array<Task>>;
};

export type TaskWatcher = {
  __typename?: 'TaskWatcher';
  task_id: Scalars['ID']['output'];
  user: User;
  user_id: Scalars['ID']['output'];
};

export enum TaskWhereColumn {
  AfterDeadline = 'AFTER_DEADLINE',
  AfterEndDate = 'AFTER_END_DATE',
  AssigneeId = 'ASSIGNEE_ID',
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedByUserId = 'CREATED_BY_USER_ID',
  CurrentAssigneeId = 'CURRENT_ASSIGNEE_ID',
  Deadline = 'DEADLINE',
  From = 'FROM',
  HideDone = 'HIDE_DONE',
  Id = 'ID',
  IsTemplate = 'IS_TEMPLATE',
  MyCreatedTasks = 'MY_CREATED_TASKS',
  MyCurrentTasks = 'MY_CURRENT_TASKS',
  MyTasks = 'MY_TASKS',
  MyWatchedTasks = 'MY_WATCHED_TASKS',
  OnlyParent = 'ONLY_PARENT',
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  ParentId = 'PARENT_ID',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectTeamLeaderId = 'PROJECT_TEAM_LEADER_ID',
  QuickFilter = 'QUICK_FILTER',
  StarredTasks = 'STARRED_TASKS',
  TaskPriorityId = 'TASK_PRIORITY_ID',
  TaskStatusId = 'TASK_STATUS_ID',
  TaskTemplateGroupId = 'TASK_TEMPLATE_GROUP_ID',
  TeamId = 'TEAM_ID',
  TimeTrackingWorkTypeId = 'TIME_TRACKING_WORK_TYPE_ID',
  To = 'TO',
  UserId = 'USER_ID'
}

export type TaskWhereConditions = {
  AND?: InputMaybe<Array<TaskWhereConditions>>;
  OR?: InputMaybe<Array<TaskWhereConditions>>;
  column?: InputMaybe<TaskWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Team = {
  __typename?: 'Team';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expense_cost_centre_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  user_count: Scalars['Int']['output'];
};

export type TeamAttendee = {
  __typename?: 'TeamAttendee';
  team: Team;
};

export type TemporaryBrand = {
  __typename?: 'TemporaryBrand';
  name?: Maybe<Scalars['String']['output']>;
};

export type TemporaryProject = {
  __typename?: 'TemporaryProject';
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TestSmtpConnectionInput = {
  smtp_encryption: Scalars['String']['input'];
  smtp_host: Scalars['String']['input'];
  smtp_password: Scalars['String']['input'];
  smtp_port: Scalars['Int']['input'];
  smtp_username: Scalars['String']['input'];
};

export enum ThirdPartyEnum {
  Budgetovac = 'BUDGETOVAC',
  Planovac = 'PLANOVAC'
}

/** Component input */
export type TimeBillingComponentInput = {
  amount: Scalars['BigInt']['input'];
  key: TimeBillingComponentKeyEnum;
  source_id?: InputMaybe<Scalars['ID']['input']>;
  source_type?: InputMaybe<TimeBillingSourceTypeEnum>;
  use_in_total: Scalars['Boolean']['input'];
};

export enum TimeBillingComponentKeyEnum {
  ExpensesEbi = 'EXPENSES_EBI',
  ExpensesOwbi = 'EXPENSES_OWBI',
  InvoicedExpenses = 'INVOICED_EXPENSES',
  InvoicedOurwork = 'INVOICED_OURWORK',
  Prepayment = 'PREPAYMENT'
}

/**
 * Source input - pre expense_item: source_id je expense_items.id
 * Pre oi_budget_item: outgoing_invoice_id + budget_item_id + budget_item_type
 */
export type TimeBillingSourceInput = {
  budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_type?: InputMaybe<BudgetItemTypeEnum>;
  include: Scalars['Boolean']['input'];
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  source_id?: InputMaybe<Scalars['ID']['input']>;
  source_type: TimeBillingSourceTypeEnum;
};

export enum TimeBillingSourceTypeEnum {
  ExpenseItem = 'EXPENSE_ITEM',
  OiBudgetItem = 'OI_BUDGET_ITEM'
}

/** Summary pre Time Billing listings (count + amount) */
export type TimeBillingSummary = {
  __typename?: 'TimeBillingSummary';
  allIds: Array<Scalars['ID']['output']>;
  amount: Scalars['BigInt']['output'];
  count: Scalars['Int']['output'];
};

export enum TimeBillingTypeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

/**
 * User row input (pre manual mode).
 * Pre Work Expense záznamy je user_id null.
 */
export type TimeBillingUserRowInput = {
  amount: Scalars['BigInt']['input'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['input'];
  invoiced_time: Scalars['Int']['input'];
  overserviced_time: Scalars['Int']['input'];
  team_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * User row input pre preview (obsahuje všetky polia potrebné na prepočet).
 * Pre Work Expense záznamy je user_id null.
 */
export type TimeBillingUserRowPreviewInput = {
  amount: Scalars['BigInt']['input'];
  client_rate: Scalars['BigInt']['input'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['input'];
  invoiced_time: Scalars['Int']['input'];
  overserviced_time: Scalars['Int']['input'];
  team_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  tracked_time: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeMaterialsBudgetItemInvoiceData = {
  __typename?: 'TimeMaterialsBudgetItemInvoiceData';
  amount?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
};

export type TimeMaterialsBudgetItems = {
  __typename?: 'TimeMaterialsBudgetItems';
  amount: Scalars['BigInt']['output'];
  budget_category_id: Scalars['ID']['output'];
  data?: Maybe<Array<Maybe<TimeMaterialsBudgetItemInvoiceData>>>;
  default_commission?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  invoiced: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
};

export type TimeMaterialsCommissionData = {
  __typename?: 'TimeMaterialsCommissionData';
  commission: Scalars['BigInt']['output'];
  expense_budget_item_id: Scalars['ID']['output'];
};

export type TimeMaterialsDataForInvoicing = {
  __typename?: 'TimeMaterialsDataForInvoicing';
  expenseBudgetItems: Array<TimeMaterialsBudgetItems>;
  ourWorkBudgetItems: Array<TimeMaterialsBudgetItems>;
  project: Project;
};

export type TimeMaterialsInvoiceData = {
  __typename?: 'TimeMaterialsInvoiceData';
  commission_data?: Maybe<Array<TimeMaterialsCommissionData>>;
  expense_ids?: Maybe<Array<Scalars['ID']['output']>>;
  from: Scalars['Date']['output'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  ids?: Maybe<Array<Scalars['ID']['output']>>;
  project_id: Scalars['ID']['output'];
  to: Scalars['Date']['output'];
};

export enum TimeMaterialsInvoiceDataGroupByEnum {
  Date = 'DATE',
  Month = 'MONTH',
  Position = 'POSITION',
  Task = 'TASK',
  User = 'USER',
  Week = 'WEEK'
}

export type TimeOffAssignee = {
  __typename?: 'TimeOffAssignee';
  user?: Maybe<User>;
};

export enum TimeOffDurationTypeEnum {
  AllDay = 'ALL_DAY',
  Custom = 'CUSTOM',
  FirstHalfOfDay = 'FIRST_HALF_OF_DAY',
  SecondHalfOfDay = 'SECOND_HALF_OF_DAY'
}

export type TimeOffType = {
  __typename?: 'TimeOffType';
  affects_planning_capacity: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['BigInt']['output'];
};

/** Billing status pre Time Tracking items */
export enum TimeTrackingBillingStatusEnum {
  Invoiced = 'INVOICED',
  Overserviced = 'OVERSERVICED',
  Uninvoiced = 'UNINVOICED'
}

export type TimeTrackingBudgetItem = {
  __typename?: 'TimeTrackingBudgetItem';
  id: Scalars['ID']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
  timeTrackingItems?: Maybe<Array<Maybe<TimeTrackingItem>>>;
  tracking_enabled: Scalars['Boolean']['output'];
  tracking_enabled_from?: Maybe<Scalars['Date']['output']>;
  tracking_enabled_to?: Maybe<Scalars['Date']['output']>;
};

export type TimeTrackingBudgetItemForPlanovac = {
  __typename?: 'TimeTrackingBudgetItemForPlanovac';
  id: Scalars['ID']['output'];
  tracking_enabled_from?: Maybe<Scalars['Date']['output']>;
  tracking_enabled_to?: Maybe<Scalars['Date']['output']>;
};

export type TimeTrackingBudgetItemSimpleMap = {
  __typename?: 'TimeTrackingBudgetItemSimpleMap';
  available_time_tracking_work_types: Array<TimeTrackingWorkType>;
  budget_title: Scalars['String']['output'];
  project_code: Scalars['String']['output'];
  project_id: Scalars['ID']['output'];
  project_title: Scalars['String']['output'];
  time_tracking_budget_item_id: Scalars['ID']['output'];
};

export type TimeTrackingItem = {
  __typename?: 'TimeTrackingItem';
  auto_stopped: Scalars['Boolean']['output'];
  billable: Scalars['Boolean']['output'];
  capacityAllocationItem?: Maybe<CapacityAllocationItem>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  has_running_timer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_hourly_rate?: Maybe<Scalars['BigInt']['output']>;
  is_locked: Scalars['Boolean']['output'];
  lockedByUser?: Maybe<User>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  project: Project;
  specific_time_from?: Maybe<Scalars['Time']['output']>;
  specific_time_to?: Maybe<Scalars['Time']['output']>;
  task: Task;
  timeBilling?: Maybe<ProjectTimeBilling>;
  timeBillingDistributions: Array<ProjectTimeBillingDistribution>;
  timeTrackingBudgetItem: TimeTrackingBudgetItem;
  timeTrackingWorkType: TimeTrackingWorkType;
  tracked_for_date: Scalars['Date']['output'];
  /** Tracked time in seconds */
  tracked_time: Scalars['BigInt']['output'];
  tracked_time_with_running_timer: Scalars['BigInt']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type TimeTrackingItemOrderByClause = {
  column: TimeTrackingItemOrderByColumnEnum;
  order: SortOrder;
};

export enum TimeTrackingItemOrderByColumnEnum {
  Amount = 'AMOUNT',
  Billable = 'BILLABLE',
  Brand = 'BRAND',
  Client = 'CLIENT',
  Date = 'DATE',
  HourlyRate = 'HOURLY_RATE',
  InvoicedTime = 'INVOICED_TIME',
  LockedAt = 'LOCKED_AT',
  LockedByUser = 'LOCKED_BY_USER',
  Note = 'NOTE',
  OurWorkBudgetItem = 'OUR_WORK_BUDGET_ITEM',
  OverservicedTime = 'OVERSERVICED_TIME',
  Project = 'PROJECT',
  ProjectCode = 'PROJECT_CODE',
  ProjectTimeBilling = 'PROJECT_TIME_BILLING',
  ProjectTimeBillingProject = 'PROJECT_TIME_BILLING_PROJECT',
  Task = 'TASK',
  Team = 'TEAM',
  TrackedHours = 'TRACKED_HOURS',
  UninvoicedTime = 'UNINVOICED_TIME',
  User = 'USER',
  WorkType = 'WORK_TYPE'
}

/** A paginated list of TimeTrackingItem items. */
export type TimeTrackingItemPaginator = {
  __typename?: 'TimeTrackingItemPaginator';
  /** A list of TimeTrackingItem items. */
  data: Array<TimeTrackingItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TimeTrackingOptionsForProject = {
  __typename?: 'TimeTrackingOptionsForProject';
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  ourWork: Array<OurWorkBudgetItemSimple>;
};

export type TimeTrackingProjectReport = {
  __typename?: 'TimeTrackingProjectReport';
  amount: Scalars['Float']['output'];
  billable_all: Scalars['Boolean']['output'];
  group_amount: Scalars['BigInt']['output'];
  group_tracked_time: Scalars['BigInt']['output'];
  hourly_rate?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  internal_hourly_rate?: Maybe<Scalars['Float']['output']>;
  invoiced_amount: Scalars['Float']['output'];
  invoiced_personal_profitability?: Maybe<Scalars['Float']['output']>;
  invoiced_seconds?: Maybe<Scalars['BigInt']['output']>;
  /** our_work_budget_item_id available only when grouping by our_work_budget_item_title */
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  /** our_work_budget_item_title available only when grouping by our_work_budget_item_title */
  our_work_budget_item_title?: Maybe<Scalars['String']['output']>;
  overserviced_seconds?: Maybe<Scalars['BigInt']['output']>;
  personal_expense?: Maybe<Scalars['Float']['output']>;
  personal_profitability?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['ID']['output']>;
  /** time_tracking_work_type_id not available when grouping by our_work_budget_item_title */
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  /** time_tracking_work_type_title not available when grouping by our_work_budget_item_title */
  time_tracking_work_type_title?: Maybe<Scalars['String']['output']>;
  tracked_time: Scalars['BigInt']['output'];
  uninvoiced_seconds?: Maybe<Scalars['BigInt']['output']>;
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type TimeTrackingProjectReportOrderByClause = {
  column: TimeTrackingProjectReportOrderByColumnEnum;
  order: SortOrder;
};

export enum TimeTrackingProjectReportOrderByColumnEnum {
  OurWorkBudgetItemTitle = 'OUR_WORK_BUDGET_ITEM_TITLE',
  UserFullName = 'USER_FULL_NAME',
  WorkType = 'WORK_TYPE'
}

export type TimeTrackingProjectReportQueryArgs = {
  orderBy: Array<TimeTrackingProjectReportOrderByClause>;
  project_id: Scalars['ID']['input'];
  where?: InputMaybe<TimeTrackingProjectReportsWhereConditions>;
};

export enum TimeTrackingProjectReportsWhereColumn {
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  TrackedForDate = 'TRACKED_FOR_DATE'
}

export type TimeTrackingProjectReportsWhereConditions = {
  AND?: InputMaybe<Array<TimeTrackingProjectReportsWhereConditions>>;
  OR?: InputMaybe<Array<TimeTrackingProjectReportsWhereConditions>>;
  column?: InputMaybe<TimeTrackingProjectReportsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type TimeTrackingRate = {
  __typename?: 'TimeTrackingRate';
  budget?: Maybe<Budget>;
  id: Scalars['ID']['output'];
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  rate: Scalars['BigInt']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
};

export type TimeTrackingReport = {
  __typename?: 'TimeTrackingReport';
  amount?: Maybe<Scalars['BigInt']['output']>;
  billable: Scalars['Boolean']['output'];
  brand_id: Scalars['ID']['output'];
  brand_name: Scalars['String']['output'];
  client_id?: Maybe<Scalars['ID']['output']>;
  client_name: Scalars['String']['output'];
  hourly_rate?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  invoiced_seconds: Scalars['BigInt']['output'];
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  locked_by_user_first_name?: Maybe<Scalars['String']['output']>;
  locked_by_user_id?: Maybe<Scalars['ID']['output']>;
  locked_by_user_last_name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  our_work_budget_item_title: Scalars['String']['output'];
  overserviced_seconds: Scalars['BigInt']['output'];
  project_code: Scalars['String']['output'];
  project_id: Scalars['ID']['output'];
  project_time_billing_id?: Maybe<Scalars['ID']['output']>;
  project_time_billing_is_locked?: Maybe<Scalars['Boolean']['output']>;
  project_time_billing_name?: Maybe<Scalars['String']['output']>;
  project_time_billing_project_id?: Maybe<Scalars['ID']['output']>;
  project_time_billing_project_name?: Maybe<Scalars['String']['output']>;
  project_title: Scalars['String']['output'];
  task_id: Scalars['ID']['output'];
  task_name: Scalars['String']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
  time_tracking_work_type_id: Scalars['ID']['output'];
  time_tracking_work_type_title: Scalars['String']['output'];
  tracked_for_date: Scalars['Date']['output'];
  tracked_time: Scalars['BigInt']['output'];
  uninvoiced_seconds: Scalars['BigInt']['output'];
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export enum TimeTrackingReportExportType {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type TimeTrackingReportGroup = {
  __typename?: 'TimeTrackingReportGroup';
  groupBy?: Maybe<Scalars['String']['output']>;
  items: Array<TimeTrackingReport>;
  trackedTime: Scalars['BigInt']['output'];
};

export enum TimeTrackingReportGroupBy {
  Brand = 'BRAND',
  BudgetItem = 'BUDGET_ITEM',
  Date = 'DATE',
  Project = 'PROJECT',
  Task = 'TASK',
  User = 'USER',
  WorkType = 'WORK_TYPE'
}

export type TimeTrackingReportPaginator = {
  __typename?: 'TimeTrackingReportPaginator';
  data: Array<TimeTrackingReportGroup>;
  paginatorInfo: PaginatorInfo;
};

export type TimeTrackingReportSummary = {
  __typename?: 'TimeTrackingReportSummary';
  ids: Array<Scalars['ID']['output']>;
  /** Sum of (tracked_time / 3600) * hourly_rate */
  total_amount: Scalars['BigInt']['output'];
  /** Sum of invoiced_seconds from distributions */
  total_invoiced_time: Scalars['BigInt']['output'];
  total_items: Scalars['BigInt']['output'];
  /** Sum of overserviced_seconds from distributions */
  total_overserviced_time: Scalars['BigInt']['output'];
  /** total_tracked_time in seconds */
  total_tracked_time: Scalars['BigInt']['output'];
  /** Sum of uninvoiced_seconds from distributions */
  total_uninvoiced_time: Scalars['BigInt']['output'];
};

export enum TimeTrackingReportsWhereColumn {
  Billable = 'BILLABLE',
  BillingStatus = 'BILLING_STATUS',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  HasTimeBilling = 'HAS_TIME_BILLING',
  Id = 'ID',
  IsLocked = 'IS_LOCKED',
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Status = 'STATUS',
  TaskId = 'TASK_ID',
  TeamId = 'TEAM_ID',
  TrackedForDate = 'TRACKED_FOR_DATE',
  UserId = 'USER_ID',
  WorkTypeId = 'WORK_TYPE_ID'
}

export type TimeTrackingReportsWhereConditions = {
  AND?: InputMaybe<Array<TimeTrackingReportsWhereConditions>>;
  OR?: InputMaybe<Array<TimeTrackingReportsWhereConditions>>;
  column?: InputMaybe<TimeTrackingReportsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type TimeTrackingSummaryPerDay = {
  __typename?: 'TimeTrackingSummaryPerDay';
  auto_stopped: Scalars['Boolean']['output'];
  date: Scalars['Date']['output'];
  tracked_time: Scalars['BigInt']['output'];
};

export type TimeTrackingWorkType = {
  __typename?: 'TimeTrackingWorkType';
  alias: Scalars['String']['output'];
  default_rate: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type TimeTrackingWorkTypeMapping = {
  from_time_tracking_work_type_id: Scalars['ID']['input'];
  to_time_tracking_work_type_id: Scalars['ID']['input'];
};

export type Timer = {
  __typename?: 'Timer';
  ends_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  starts_at: Scalars['DateTime']['output'];
  timeTrackingItem?: Maybe<TimeTrackingItem>;
};

export type ToggleTaskCommentReactionInput = {
  emoji_id: Scalars['String']['input'];
  task_comment_id: Scalars['ID']['input'];
};

export type TopBrand = {
  __typename?: 'TopBrand';
  name: Scalars['String']['output'];
  value: Scalars['BigInt']['output'];
};

export type TopClient = {
  __typename?: 'TopClient';
  brands: Array<TopBrand>;
  name: Scalars['String']['output'];
  total_value: Scalars['BigInt']['output'];
};

export type TopProject = {
  __typename?: 'TopProject';
  expense_budget_categories?: Maybe<Array<Maybe<ExpenseBudgetCategoryTopProject>>>;
  our_work: OurWorkTopProject;
  title: Scalars['String']['output'];
  total_value: Scalars['BigInt']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdateBillingEntityInput = {
  applies_vat: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
  default_currency_id: Scalars['ID']['input'];
  disable_email_notification: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  internal_name: Scalars['String']['input'];
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  legal_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  payment_due?: InputMaybe<Scalars['BigInt']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  zip: Scalars['String']['input'];
};

export type UpdateBillingPlanInput = {
  items: Array<BillingPlanItemInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateBrandCreditAccountInput = {
  expense_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  our_work_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateBrandInput = {
  code: Scalars['String']['input'];
  default_billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  numeric_code?: InputMaybe<Scalars['String']['input']>;
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
  update_project_codes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateBudgetItem = {
  deadline?: InputMaybe<Scalars['Date']['input']>;
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateBudgetovacPositionInput = {
  department_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateBudgetovacPositionsSetInput = {
  active: Scalars['Boolean']['input'];
  client_id?: InputMaybe<Scalars['Int']['input']>;
  currency_code: Scalars['String']['input'];
  external_production_commission?: InputMaybe<Scalars['Float']['input']>;
  extras_commission?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  internal_production_commission?: InputMaybe<Scalars['Float']['input']>;
  media_budget_commission?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  positions_prices: Array<BudgetovacPositionPriceInput>;
};

export type UpdateCapacityAllocationForDayInput = {
  attendees?: InputMaybe<Array<CapacityAllocationAttendee>>;
  capacity_allocation_id: Scalars['ID']['input'];
  create_task_positions: Scalars['Boolean']['input'];
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  deadline_time?: InputMaybe<Scalars['Time']['input']>;
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  total_time_per_day?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<CapacityAllocationTypeEnum>;
  updating_from_item_id: Scalars['ID']['input'];
};

export type UpdateCapacityAllocationInput = {
  accept_for_user_id?: InputMaybe<Scalars['ID']['input']>;
  attendees?: InputMaybe<Array<CapacityAllocationAttendee>>;
  create_task_positions: Scalars['Boolean']['input'];
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  deadline_time?: InputMaybe<Scalars['Time']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  repetition?: InputMaybe<CapacityAllocationRepetitionTypeEnum>;
  repetition_settings?: InputMaybe<CapacityAllocationRepetitionSettings>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  total_time_per_day?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<CapacityAllocationTypeEnum>;
  updating_item_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCapacityAllocationItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  create_task_positions?: InputMaybe<Scalars['Boolean']['input']>;
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<CapacityAllocationTypeEnum>;
  user_id: Scalars['ID']['input'];
};

export type UpdateClientInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
};

export type UpdateCompanySettingsInput = {
  city: Scalars['String']['input'];
  country_id: Scalars['BigInt']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  title: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type UpdateContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContractTypeEnum>;
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
  valid_to_indefinite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContractorInput = {
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legal_name: Scalars['String']['input'];
  national_id?: InputMaybe<Scalars['String']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrencyExchangeRateInput = {
  exchange_rate: Scalars['BigInt']['input'];
  id: Scalars['ID']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateEmailTemplateInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  type: EmailTemplateTypeEnum;
};

export type UpdateExchangeRateSettingsInput = {
  exchange_rate: Scalars['BigInt']['input'];
  id: Scalars['ID']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateExpenseInput = {
  amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  constant_symbol?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  document_number?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  expense_items?: InputMaybe<Array<ExpenseItemInput>>;
  expense_no?: InputMaybe<Scalars['String']['input']>;
  expense_vat_items?: InputMaybe<Array<ExpenseVatItemInput>>;
  files?: InputMaybe<Array<FileInput>>;
  for_approval: Scalars['Boolean']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id?: InputMaybe<Scalars['ID']['input']>;
  is_draft: Scalars['Boolean']['input'];
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  national_id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['Date']['input']>;
  payment_type_id?: InputMaybe<Scalars['ID']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  /** IDs of related expenses to link (bidirectional relationship) */
  related_expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  specific_symbol?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  total_amount_includes_vat?: InputMaybe<Scalars['Boolean']['input']>;
  total_amount_with_vat_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  type: ExpenseTypeEnum;
  user_created_date: Scalars['Date']['input'];
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigInt']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalLinkInput = {
  id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  model_id: Scalars['ID']['input'];
  model_type: ExternalLinkType;
  title: Scalars['String']['input'];
};

export type UpdateFinanceSettingsInput = {
  automatically_approved_expense_items?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccounts?: InputMaybe<Array<BankAccountSettingInput>>;
  can_transfer_credit_between_teams_without_constraints?: InputMaybe<Scalars['Boolean']['input']>;
  currency_id?: InputMaybe<Scalars['BigInt']['input']>;
  default_vat_rate_id?: InputMaybe<Scalars['BigInt']['input']>;
  invoicing_more_teams?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguagesEnum>;
  outgoing_invoice_drafts_only?: InputMaybe<Scalars['Boolean']['input']>;
  registration_no: Scalars['String']['input'];
  show_contact_person?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_bank_account_information?: InputMaybe<Scalars['Boolean']['input']>;
  show_project_codes?: InputMaybe<Scalars['Boolean']['input']>;
  tax_no: Scalars['String']['input'];
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  vat_no: Scalars['String']['input'];
};

export type UpdateGlobalCreditAccountInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateNotificationSettingsInput = {
  email_footer?: InputMaybe<Scalars['String']['input']>;
  from_email?: InputMaybe<Scalars['String']['input']>;
  notification_email?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  date_of_order?: InputMaybe<Scalars['Date']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  purchase_order_no?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOtherDocumentInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutgoingInvoiceInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id: Scalars['ID']['input'];
  brand_ids: Array<Scalars['ID']['input']>;
  client_id: Scalars['ID']['input'];
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  credit_note_outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits: Array<ExpenseBudgetSplitInput>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_no: Scalars['String']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  order_ids: Array<Scalars['ID']['input']>;
  our_work_budget_splits: Array<OurWorkBudgetSplitInput>;
  outgoing_proforma_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits: Array<PrepaymentSplitInput>;
  project_ids: Array<Scalars['ID']['input']>;
  proof_of_payments_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  refresh_billing_entity?: InputMaybe<Scalars['Boolean']['input']>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  timeMaterialsInvoiceData?: InputMaybe<TimeMaterialsInputData>;
  total_in_words?: InputMaybe<Scalars['String']['input']>;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id: Scalars['ID']['input'];
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type UpdateOutgoingInvoiceNumberInput = {
  id: Scalars['ID']['input'];
  invoice_no: Scalars['String']['input'];
  next_invoice_no?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutgoingProformaInvoiceInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id: Scalars['ID']['input'];
  contact_id: Scalars['ID']['input'];
  currency_id: Scalars['ID']['input'];
  due_date: Scalars['Date']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits?: InputMaybe<Array<ExpenseBudgetSplitInput>>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_no: Scalars['ID']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_splits?: InputMaybe<Array<OurWorkBudgetSplitInput>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits?: InputMaybe<Array<PrepaymentSplitInput>>;
  project_ids: Array<Scalars['ID']['input']>;
  refresh_billing_entity?: InputMaybe<Scalars['Boolean']['input']>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id: Scalars['ID']['input'];
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type UpdatePasswordInput = {
  new_password: Scalars['String']['input'];
  old_password: Scalars['String']['input'];
};

export type UpdatePaymentSettingsInput = {
  default_payment_due?: InputMaybe<Scalars['String']['input']>;
  domestic_payment_order_provider?: InputMaybe<PaymentOrderProviderEnum>;
  foreign_payment_order_provider?: InputMaybe<PaymentOrderProviderEnum>;
};

export type UpdatePlanningSettings = {
  planning_view_settings: Array<PlanningViewSettingInput>;
};

export type UpdateProjectBudgetInput = {
  budget_valid_from?: InputMaybe<Scalars['Date']['input']>;
  expenses: Array<ExpenseBudgetItemInput>;
  ourWork: Array<OurWorkBudgetItemInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateProjectInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  from_duplicate_project_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  is_template: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  other_project_manager_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_manager_id?: InputMaybe<Scalars['ID']['input']>;
  propagate_billable?: InputMaybe<Scalars['Boolean']['input']>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  team_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectTypeEnum>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateProjectSettingsInput = {
  create_default_task_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  default_task_priority_id?: InputMaybe<Scalars['BigInt']['input']>;
  default_task_status_id?: InputMaybe<Scalars['BigInt']['input']>;
  project_code_generator?: InputMaybe<ProjectCodeGeneratorEnum>;
  project_code_length?: InputMaybe<Scalars['BigInt']['input']>;
  project_code_with_year?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input pre update Time Billing */
export type UpdateProjectTimeBillingInput = {
  components?: InputMaybe<Array<TimeBillingComponentInput>>;
  final_total_amount?: InputMaybe<Scalars['BigInt']['input']>;
  final_total_note?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recompute?: InputMaybe<Scalars['Boolean']['input']>;
  source_ids?: InputMaybe<Array<TimeBillingSourceInput>>;
  timeTrackingItemIds: Array<Scalars['BigInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TimeBillingTypeEnum>;
  user_rows?: InputMaybe<Array<TimeBillingUserRowInput>>;
};

export type UpdateRequestForInvoicingInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  brand_ids: Array<Scalars['ID']['input']>;
  client_id: Scalars['ID']['input'];
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  credit_note_outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits: Array<ExpenseBudgetSplitInput>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_ids: Array<Scalars['ID']['input']>;
  our_work_budget_splits: Array<OurWorkBudgetSplitInput>;
  outgoing_proforma_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits: Array<PrepaymentSplitInput>;
  project_ids: Array<Scalars['ID']['input']>;
  proof_of_payments_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  status: RequestForInvoicingStatusEnum;
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  timeMaterialsInvoiceData?: InputMaybe<TimeMaterialsInputData>;
  total_in_words?: InputMaybe<Scalars['String']['input']>;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type UpdateScopedTaskInput = {
  addFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  removeFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSequenceInput = {
  amount: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  type: Array<SequenceTypesEnum>;
};

export type UpdateTaskBoardSettingsInput = {
  /** Board context: tab + group by, e.g. "my:TASK_STATUS". */
  board_key: Scalars['String']['input'];
  /** Null = leave unchanged. Pass [] to clear. */
  collapsed_columns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null = leave unchanged. Pass [] to clear. */
  column_order?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null = leave unchanged. Pass [] to clear. */
  hidden_columns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null = leave unchanged. */
  sort?: InputMaybe<TaskBoardSortInput>;
};

export type UpdateTaskCommentInput = {
  body: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  mentioned_assignees?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTaskDescriptionInput = {
  addFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<TaskDescriptionInput>;
  id: Scalars['ID']['input'];
  removeFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTaskInput = {
  addFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  create_capacity_allocations?: InputMaybe<Scalars['Boolean']['input']>;
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  days_to_deadline?: InputMaybe<Scalars['Int']['input']>;
  days_to_from?: InputMaybe<Scalars['Int']['input']>;
  days_to_to?: InputMaybe<Scalars['Int']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  default_planned_time?: InputMaybe<Scalars['BigInt']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  from?: InputMaybe<Scalars['Date']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  is_template: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  position_mapping?: InputMaybe<Array<PositionMappingInput>>;
  positions?: InputMaybe<Array<TaskPositionInput>>;
  removeFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
  task_template_group_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateTimeTrackingBudgetItemInput = {
  our_work_budget_item_id: Scalars['ID']['input'];
  tracking_enabled: Scalars['Boolean']['input'];
  tracking_enabled_from?: InputMaybe<Scalars['Date']['input']>;
  tracking_enabled_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateTimeTrackingItemInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UpdateTimeTrackingRateInput = {
  rate: Scalars['BigInt']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
};

export type UpdateTimeTrackingRatesForBrandInput = {
  average_rate?: InputMaybe<Scalars['BigInt']['input']>;
  brand_id: Scalars['ID']['input'];
  time_tracking_rates_per_work_type?: InputMaybe<Array<UpdateTimeTrackingRateInput>>;
};

export type UpdateTimeTrackingRatesForProjectInput = {
  average_rate?: InputMaybe<Scalars['BigInt']['input']>;
  force_update?: InputMaybe<Scalars['Boolean']['input']>;
  project_id: Scalars['ID']['input'];
  time_tracking_rates_per_work_type?: InputMaybe<Array<UpdateTimeTrackingRateInput>>;
};

export type UpdateTimeTrackingSettingsInput = {
  our_work_budget_items: Array<UpdateTimeTrackingBudgetItemInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateTimeTrackingWorkTypeInput = {
  default_rate: Scalars['Float']['input'];
  new_alias: Scalars['String']['input'];
  old_alias: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdateUserInput = {
  brand_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  calendar_sync_allocation_types?: InputMaybe<Array<InputMaybe<CapacityAllocationTypeEnum>>>;
  calendar_sync_direction?: InputMaybe<CalendarSyncDirectionEnum>;
  codename?: InputMaybe<Scalars['String']['input']>;
  default_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  hex_color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  muted_mail_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  plannable?: InputMaybe<Scalars['Boolean']['input']>;
  role_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope_access?: InputMaybe<UserScopeAccessEnum>;
  scope_project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope_task_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  task_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserPasswordInput = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};

export type UpdateVatRateInput = {
  amount: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  type: VatRateTypeEnum;
};

export type UpdateWorkspaceSmtpSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  microsoft_shared_mailbox?: InputMaybe<Scalars['String']['input']>;
  smtp_encryption?: InputMaybe<Scalars['String']['input']>;
  smtp_from_address?: InputMaybe<Scalars['String']['input']>;
  smtp_from_name?: InputMaybe<Scalars['String']['input']>;
  smtp_host?: InputMaybe<Scalars['String']['input']>;
  smtp_password?: InputMaybe<Scalars['String']['input']>;
  smtp_port?: InputMaybe<Scalars['Int']['input']>;
  smtp_username?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  PMActiveProjectsCount: Scalars['BigInt']['output'];
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  brands: Array<Brand>;
  calendar_integrations?: Maybe<Array<Maybe<CalendarTypeEnum>>>;
  calendar_sync_allocation_types?: Maybe<Array<Maybe<CapacityAllocationTypeEnum>>>;
  calendar_sync_direction?: Maybe<CalendarSyncDirectionEnum>;
  codename?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  display_name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  enabled_two_factor_authentication: Scalars['Boolean']['output'];
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  last_name: Scalars['String']['output'];
  /**
   * Please only call me on user or me query, nothing that returns list of users
   * @deprecated No longer supported
   */
  mainPMActiveProjectsCount: Scalars['BigInt']['output'];
  mcpTokens: Array<McpToken>;
  mcp_connected: Scalars['Boolean']['output'];
  muted_mail_notifications: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ownedOICount: Scalars['BigInt']['output'];
  permissions: PermissionList;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  projects: Array<Project>;
  roles: Array<Role>;
  scope?: Maybe<UserScope>;
  scope_access?: Maybe<UserScopeAccessEnum>;
  statusRanges: Array<UserStatusRange>;
  tasks: Array<Task>;
  team?: Maybe<Team>;
  updated_at: Scalars['DateTime']['output'];
};

export type UserAllocatedTime = {
  __typename?: 'UserAllocatedTime';
  dates?: Maybe<Array<UserAllocatedTimeDate>>;
  user_id: Scalars['ID']['output'];
};

export type UserAllocatedTimeData = {
  __typename?: 'UserAllocatedTimeData';
  from_time?: Maybe<Scalars['Time']['output']>;
  to_time?: Maybe<Scalars['Time']['output']>;
  type: CapacityAllocationTypeEnum;
  value: Scalars['BigInt']['output'];
};

export type UserAllocatedTimeDate = {
  __typename?: 'UserAllocatedTimeDate';
  data?: Maybe<Array<UserAllocatedTimeData>>;
  date: Scalars['Date']['output'];
  planned_capacity: Scalars['BigInt']['output'];
};

export type UserAllocationConflicts = {
  __typename?: 'UserAllocationConflicts';
  conflict: Scalars['Boolean']['output'];
  user_id: Scalars['ID']['output'];
};

/** Triadsk use this type for vacation api */
export type UserForPlanovac = {
  __typename?: 'UserForPlanovac';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  can_update_users: Scalars['Boolean']['output'];
  codename?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  default_work_type_id: Scalars['ID']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  profile: UserProfile;
  team_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserMonthlyReport = {
  __typename?: 'UserMonthlyReport';
  id: Scalars['ID']['output'];
  total_tracked_time: Scalars['BigInt']['output'];
  tracked_time_per_team: Array<UserMonthlyReportPerTeam>;
  user_full_name: Scalars['String']['output'];
  user_image?: Maybe<Scalars['String']['output']>;
};

export type UserMonthlyReportOrderByClause = {
  column: UserMonthlyReportOrderByColumnEnum;
  order: SortOrder;
  team_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserMonthlyReportOrderByColumnEnum {
  TrackedTimeByTeam = 'TRACKED_TIME_BY_TEAM',
  TrackedTimePercentageByTeam = 'TRACKED_TIME_PERCENTAGE_BY_TEAM',
  UserFullName = 'USER_FULL_NAME',
  UserTotalTrackedTime = 'USER_TOTAL_TRACKED_TIME'
}

export type UserMonthlyReportPaginator = {
  __typename?: 'UserMonthlyReportPaginator';
  data: Array<UserMonthlyReport>;
  paginatorInfo: PaginatorInfo;
  teams: Array<Team>;
};

export type UserMonthlyReportPerTeam = {
  __typename?: 'UserMonthlyReportPerTeam';
  team_id: Scalars['ID']['output'];
  tracked_time: Scalars['BigInt']['output'];
  tracked_time_percentage: Scalars['String']['output'];
};

export type UserOrderByClause = {
  column: UserOrderByColumnEnum;
  order: SortOrder;
};

export enum UserOrderByColumnEnum {
  Email = 'EMAIL',
  FullName = 'FULL_NAME',
  TeamName = 'TEAM_NAME'
}

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  defaultWorktype: TimeTrackingWorkType;
  from_default_utilization_range: Scalars['Boolean']['output'];
  hex_color: Scalars['String']['output'];
  plannable: Scalars['Boolean']['output'];
  planningRanges: Array<UserProfilePlanningRange>;
  rates: Array<UserProfileRate>;
  utilization_range_from: Scalars['BigInt']['output'];
  utilization_range_to: Scalars['BigInt']['output'];
};

export type UserProfilePlanningRange = {
  __typename?: 'UserProfilePlanningRange';
  daily_capacity?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  type: PlanningRangeType;
  utilising: Scalars['Boolean']['output'];
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
  weekly_capacities?: Maybe<WeeklyCapacities>;
};

export type UserProfileRate = {
  __typename?: 'UserProfileRate';
  id: Scalars['ID']['output'];
  rate: Scalars['BigInt']['output'];
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type UserProfileRateInput = {
  rate: Scalars['BigInt']['input'];
  valid_from: Scalars['Date']['input'];
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UserQueryArgs = {
  orderBy?: InputMaybe<Array<UserOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UsersWhereConditions>;
};

export type UserScope = {
  __typename?: 'UserScope';
  value: UserScopeEnum;
};

export enum UserScopeAccessEnum {
  All = 'ALL',
  Assigned = 'ASSIGNED'
}

export enum UserScopeEnum {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  Partner = 'PARTNER'
}

export type UserSimple = {
  __typename?: 'UserSimple';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  codename?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  profile?: Maybe<UserProfile>;
  team_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserStatusRange = {
  __typename?: 'UserStatusRange';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectManager?: Maybe<User>;
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type UsersSummary = {
  __typename?: 'UsersSummary';
  userIds: Array<Scalars['ID']['output']>;
};

export enum UsersWhereColumn {
  BrandId = 'BRAND_ID',
  RoleId = 'ROLE_ID',
  Scope = 'SCOPE',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type UsersWhereConditions = {
  AND?: InputMaybe<Array<UsersWhereConditions>>;
  OR?: InputMaybe<Array<UsersWhereConditions>>;
  column?: InputMaybe<UsersWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type UtilizationReport = {
  __typename?: 'UtilizationReport';
  allocated_amount_billable?: Maybe<Scalars['Int']['output']>;
  allocated_expenses?: Maybe<Scalars['Int']['output']>;
  allocated_time?: Maybe<Scalars['Int']['output']>;
  allocated_time_billable?: Maybe<Scalars['Int']['output']>;
  available_time: Scalars['Int']['output'];
  budgeted_amount_billable?: Maybe<Scalars['Int']['output']>;
  budgeted_expenses?: Maybe<Scalars['Int']['output']>;
  budgeted_profit_amount?: Maybe<Scalars['Int']['output']>;
  budgeted_time?: Maybe<Scalars['Int']['output']>;
  budgeted_time_billable?: Maybe<Scalars['Int']['output']>;
  combined_amount_billable?: Maybe<Scalars['Int']['output']>;
  combined_expenses?: Maybe<Scalars['Int']['output']>;
  combined_profit_amount?: Maybe<Scalars['Int']['output']>;
  combined_time?: Maybe<Scalars['Int']['output']>;
  combined_time_billable?: Maybe<Scalars['Int']['output']>;
  internal_cost?: Maybe<Scalars['Int']['output']>;
  overtime: Scalars['Int']['output'];
  remaining_time: Scalars['Int']['output'];
  time_off: Scalars['Int']['output'];
  total_time: Scalars['Int']['output'];
  tracked_amount_billable?: Maybe<Scalars['Int']['output']>;
  tracked_expenses?: Maybe<Scalars['Int']['output']>;
  tracked_time?: Maybe<Scalars['Int']['output']>;
  tracked_time_billable?: Maybe<Scalars['Int']['output']>;
  utilization_percentage?: Maybe<Scalars['Int']['output']>;
  utilization_percentage_billable?: Maybe<Scalars['Int']['output']>;
};

export enum UtilizationReportDataSource {
  Combined = 'COMBINED',
  Planning = 'PLANNING',
  TaskPositions = 'TASK_POSITIONS',
  TimeTracking = 'TIME_TRACKING'
}

export type UtilizationReportGroup = {
  __typename?: 'UtilizationReportGroup';
  group_title: Scalars['String']['output'];
  items: Array<UtilizationUserReport>;
  report: UtilizationReport;
};

export enum UtilizationReportGroupBy {
  Month = 'MONTH',
  Team = 'TEAM',
  Week = 'WEEK',
  WorkType = 'WORK_TYPE'
}

export type UtilizationReportGroupOrderByClause = {
  column: UtilizationReportGroupOrderByColumn;
  order?: SortOrder;
};

export enum UtilizationReportGroupOrderByColumn {
  AllocatedTime = 'ALLOCATED_TIME',
  AllocatedTimeBillable = 'ALLOCATED_TIME_BILLABLE',
  AvailableTime = 'AVAILABLE_TIME',
  BudgetedTime = 'BUDGETED_TIME',
  BudgetedTimeBillable = 'BUDGETED_TIME_BILLABLE',
  CombinedTimeBillable = 'COMBINED_TIME_BILLABLE',
  CombinedTiMe = 'COMBINED_TiME',
  Group = 'GROUP',
  TrackedTime = 'TRACKED_TIME',
  TrackedTimeBillable = 'TRACKED_TIME_BILLABLE',
  UtilizationPercentage = 'UTILIZATION_PERCENTAGE',
  UtilizationPercentageBillable = 'UTILIZATION_PERCENTAGE_BILLABLE'
}

export type UtilizationReportGroupPaginator = {
  __typename?: 'UtilizationReportGroupPaginator';
  data: Array<UtilizationReportGroup>;
  paginatorInfo: PaginatorInfo;
};

export type UtilizationReportOrderByClause = {
  column: UtilizationReportOrderByColumn;
  order?: SortOrder;
};

export enum UtilizationReportOrderByColumn {
  AllocatedTime = 'ALLOCATED_TIME',
  AllocatedTimeBillable = 'ALLOCATED_TIME_BILLABLE',
  AvailableTime = 'AVAILABLE_TIME',
  BudgetedTime = 'BUDGETED_TIME',
  BudgetedTimeBillable = 'BUDGETED_TIME_BILLABLE',
  CombinedTimeBillable = 'COMBINED_TIME_BILLABLE',
  CombinedTiMe = 'COMBINED_TiME',
  TeamName = 'TEAM_NAME',
  TrackedTime = 'TRACKED_TIME',
  TrackedTimeBillable = 'TRACKED_TIME_BILLABLE',
  UtilizationPercentage = 'UTILIZATION_PERCENTAGE',
  UtilizationPercentageBillable = 'UTILIZATION_PERCENTAGE_BILLABLE',
  WorkTypeTitle = 'WORK_TYPE_TITLE'
}

export type UtilizationReportPaginator = {
  __typename?: 'UtilizationReportPaginator';
  data: Array<UtilizationUserReport>;
  paginatorInfo: PaginatorInfo;
};

export enum UtilizationReportWhereColumn {
  TeamId = 'TEAM_ID',
  UserId = 'USER_ID',
  WorkTypeId = 'WORK_TYPE_ID'
}

export type UtilizationReportWhereConditions = {
  AND?: InputMaybe<Array<UtilizationReportWhereConditions>>;
  OR?: InputMaybe<Array<UtilizationReportWhereConditions>>;
  column?: InputMaybe<UtilizationReportWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type UtilizationTaskReport = {
  __typename?: 'UtilizationTaskReport';
  allocated_amount?: Maybe<Scalars['Int']['output']>;
  allocated_in_range_amount?: Maybe<Scalars['Int']['output']>;
  allocated_time?: Maybe<Scalars['Int']['output']>;
  allocated_time_in_range?: Maybe<Scalars['Int']['output']>;
  allocated_time_in_range_percent?: Maybe<Scalars['Int']['output']>;
  allocated_time_percent?: Maybe<Scalars['Int']['output']>;
  budgeted_time: Scalars['Int']['output'];
  budgeted_time_in_range?: Maybe<Scalars['Int']['output']>;
  over_budget_amount?: Maybe<Scalars['Int']['output']>;
  over_budget_time?: Maybe<Scalars['Int']['output']>;
  over_budget_time_in_percent?: Maybe<Scalars['Int']['output']>;
  remaining_amount?: Maybe<Scalars['Int']['output']>;
  remaining_time: Scalars['Int']['output'];
  remaining_time_in_percent?: Maybe<Scalars['Int']['output']>;
  remaining_time_in_range?: Maybe<Scalars['Int']['output']>;
  task: Task;
  total_task_budget_amount?: Maybe<Scalars['Int']['output']>;
  total_task_budget_in_range?: Maybe<Scalars['Int']['output']>;
  tracked_amount?: Maybe<Scalars['Int']['output']>;
  tracked_in_range_amount?: Maybe<Scalars['Int']['output']>;
  tracked_time?: Maybe<Scalars['Int']['output']>;
  tracked_time_in_range?: Maybe<Scalars['Int']['output']>;
  tracked_time_in_range_percent?: Maybe<Scalars['Int']['output']>;
  tracked_time_percent?: Maybe<Scalars['Int']['output']>;
};

export type UtilizationUserReport = {
  __typename?: 'UtilizationUserReport';
  report: UtilizationReport;
  user: User;
};

export type VatRate = {
  __typename?: 'VatRate';
  amount: Scalars['BigInt']['output'];
  default: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type?: Maybe<VatRateTypeEnum>;
};

export type VatRateInput = {
  amount: Scalars['BigInt']['input'];
  default: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum VatRateTypeEnum {
  High = 'HIGH',
  Low = 'LOW',
  None = 'NONE',
  Third = 'THIRD'
}

export type WeekTimeReport = {
  __typename?: 'WeekTimeReport';
  dailyTotals: Array<WeeklyTimeReportTotalsPerDay>;
  rows: Array<WeeklyTimeReportRow>;
  suggestions: Array<Task>;
};

export type WeeklyCapacities = {
  __typename?: 'WeeklyCapacities';
  friday: Scalars['BigInt']['output'];
  monday: Scalars['BigInt']['output'];
  saturday: Scalars['BigInt']['output'];
  sunday: Scalars['BigInt']['output'];
  thursday: Scalars['BigInt']['output'];
  tuesday: Scalars['BigInt']['output'];
  wednesday: Scalars['BigInt']['output'];
};

export type WeeklyCapacitiesInput = {
  friday: Scalars['BigInt']['input'];
  monday: Scalars['BigInt']['input'];
  saturday: Scalars['BigInt']['input'];
  sunday: Scalars['BigInt']['input'];
  thursday: Scalars['BigInt']['input'];
  tuesday: Scalars['BigInt']['input'];
  wednesday: Scalars['BigInt']['input'];
};

export type WeeklyTimeReportRow = {
  __typename?: 'WeeklyTimeReportRow';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  task: Task;
  timeTrackingWorkType: TimeTrackingWorkType;
  trackedTime: Array<WeeklyTimeReportRowDay>;
};

export type WeeklyTimeReportRowDay = {
  __typename?: 'WeeklyTimeReportRowDay';
  date: Scalars['Date']['output'];
  tracked_time: Scalars['BigInt']['output'];
};

export type WeeklyTimeReportTotalsPerDay = {
  __typename?: 'WeeklyTimeReportTotalsPerDay';
  date: Scalars['Date']['output'];
  total_tracked_time: Scalars['BigInt']['output'];
};

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<WhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type WipOrderByClause = {
  column: WipOrderByColumnEnum;
  order: SortOrder;
};

export enum WipOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  Progress = 'PROGRESS',
  ProgressChange = 'PROGRESS_CHANGE',
  ProjectCode = 'PROJECT_CODE',
  ProjectManager = 'PROJECT_MANAGER',
  SpentBudget = 'SPENT_BUDGET',
  SpentTime = 'SPENT_TIME',
  TotalBudget = 'TOTAL_BUDGET'
}

export type WipPeriod = {
  __typename?: 'WipPeriod';
  ends_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  is_current: Scalars['Boolean']['output'];
  starts_at: Scalars['Date']['output'];
  title: Scalars['String']['output'];
};

export type WipQueryArgs = {
  orderBy?: InputMaybe<Array<WipOrderByClause>>;
  period_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
};

export enum WipsWhereColumn {
  BrandId = 'BRAND_ID',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type WipsWhereConditions = {
  AND?: InputMaybe<Array<WipsWhereConditions>>;
  OR?: InputMaybe<Array<WipsWhereConditions>>;
  column?: InputMaybe<WipsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type WorkInProgressItemStat = {
  __typename?: 'WorkInProgressItemStat';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_closed: Scalars['Boolean']['output'];
  is_locked: Scalars['Boolean']['output'];
  our_work_budget_item_id: Scalars['ID']['output'];
  period: WipPeriod;
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percent: Scalars['BigInt']['output'];
  progress: Scalars['BigInt']['output'];
  progress_change: Scalars['BigInt']['output'];
  progress_change_percent: Scalars['BigInt']['output'];
  progress_percent: Scalars['BigInt']['output'];
  project: Project;
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  spent_time_estimate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budget_change: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
  work_in_progress_id: Scalars['ID']['output'];
};

export type WorkInProgressProjectStat = {
  __typename?: 'WorkInProgressProjectStat';
  budgetItemsStats?: Maybe<Array<WorkInProgressItemStat>>;
  id: Scalars['ID']['output'];
  is_closed: Scalars['Boolean']['output'];
  is_locked: Scalars['Boolean']['output'];
  period: WipPeriod;
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percent: Scalars['BigInt']['output'];
  progress: Scalars['BigInt']['output'];
  progress_change: Scalars['BigInt']['output'];
  progress_change_percent: Scalars['BigInt']['output'];
  progress_percent: Scalars['BigInt']['output'];
  project: Project;
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  spent_time_estimate: Scalars['Float']['output'];
  status: WorkInProgressStatusEnum;
  total_budget: Scalars['BigInt']['output'];
  total_budget_change: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
};

/** A paginated list of WorkInProgressProjectStat items. */
export type WorkInProgressProjectStatPaginator = {
  __typename?: 'WorkInProgressProjectStatPaginator';
  /** A list of WorkInProgressProjectStat items. */
  data: Array<WorkInProgressProjectStat>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum WorkInProgressStatusEnum {
  Closed = 'CLOSED',
  Locked = 'LOCKED',
  Open = 'OPEN'
}

export type WorkspaceAccountingAccount = {
  __typename?: 'WorkspaceAccountingAccount';
  account_number: Scalars['String']['output'];
  accounting_type: Accounting_Account_Type;
  budget_categories?: Maybe<Array<AccountingAccountBudgetCategory>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type WorkspaceAccountingAccountSettings = {
  __typename?: 'WorkspaceAccountingAccountSettings';
  accounting_accounts: Array<WorkspaceAccountingAccount>;
};

export type WorkspaceAccountingCentreSettings = {
  __typename?: 'WorkspaceAccountingCentreSettings';
  accounting_centres: Array<AccountingCentre>;
};

export type WorkspaceAccountingVatClassificationSettings = {
  __typename?: 'WorkspaceAccountingVatClassificationSettings';
  accounting_vat_classifications: Array<AccountingVatClassification>;
};

export type WorkspaceAutoExpenseEmailSettings = {
  __typename?: 'WorkspaceAutoExpenseEmailSettings';
  imap_encryption: ImapEncryptionEnum;
  imap_host: Scalars['String']['output'];
  imap_port: Scalars['Int']['output'];
  imap_username: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
};

export type WorkspaceBankAccount = {
  __typename?: 'WorkspaceBankAccount';
  account_holder_name?: Maybe<Scalars['String']['output']>;
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type WorkspaceCompany = {
  __typename?: 'WorkspaceCompany';
  bankAccounts: Array<WorkspaceBankAccount>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal_name: Scalars['String']['output'];
  invoicePdfSettings?: Maybe<WorkspaceCompanyInvoicePdfSettings>;
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registration_no?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceCompanyBankAccountSettingInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkspaceCompanyInput = {
  bank_accounts: Array<WorkspaceCompanyBankAccountSettingInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  deleted: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  internal_name: Scalars['String']['input'];
  is_default: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pdfSettings?: InputMaybe<WorkspaceInvoicePdfSettingsInput>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  sequences: Array<WorkspaceSequenceSettingInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type WorkspaceCompanyInvoicePdfSettings = {
  __typename?: 'WorkspaceCompanyInvoicePdfSettings';
  text_on_invoice?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceCompanySetting = {
  __typename?: 'WorkspaceCompanySetting';
  bank_accounts: Array<WorkspaceBankAccount>;
  city?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_name: Scalars['String']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pdfSettings: WorkspaceInvoicePdfSettings;
  registration_no?: Maybe<Scalars['String']['output']>;
  sequences: Array<WorkspaceSequence>;
  street?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceFinancialSetting = {
  __typename?: 'WorkspaceFinancialSetting';
  currencies: Array<Currency>;
  default_show_billing_accounting_on_invoices: Scalars['Boolean']['output'];
  default_show_unit_price_on_invoices: Scalars['Boolean']['output'];
  invoice_attachment_name_templates?: Maybe<InvoiceAttachmentNameTemplates>;
  vat_rates: Array<VatRate>;
};

export type WorkspaceInvoicePdfSettings = {
  __typename?: 'WorkspaceInvoicePdfSettings';
  footer?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_assignable_file?: Maybe<AssignableFile>;
  show_amount_in_words: Scalars['Boolean']['output'];
  show_contact_person: Scalars['Boolean']['output'];
  show_date_of_supply: Scalars['Boolean']['output'];
  show_full_bank_account_information: Scalars['Boolean']['output'];
  show_payment_type: Scalars['Boolean']['output'];
  show_project_codes: Scalars['Boolean']['output'];
  show_tax_no: Scalars['Boolean']['output'];
  show_variable_symbol: Scalars['Boolean']['output'];
  stamp?: Maybe<Scalars['String']['output']>;
  stamp_assignable_file?: Maybe<AssignableFile>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceInvoicePdfSettingsInput = {
  logo_assignable_file_id?: InputMaybe<Scalars['ID']['input']>;
  stamp_assignable_file_id?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkspaceNotification = {
  __typename?: 'WorkspaceNotification';
  database_enabled: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mail_enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roles_to_notify?: Maybe<Array<Scalars['String']['output']>>;
  threshold?: Maybe<Scalars['BigInt']['output']>;
  threshold_type: NotificationThresholdTypeEnum;
  to_roles: Scalars['Boolean']['output'];
};

export type WorkspaceNotificationInput = {
  database_enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  mail_enabled: Scalars['Boolean']['input'];
  roles_to_notify?: InputMaybe<Array<Scalars['String']['input']>>;
  threshold?: InputMaybe<Scalars['BigInt']['input']>;
};

export type WorkspacePipedriveIntegration = {
  __typename?: 'WorkspacePipedriveIntegration';
  initialization_url: Scalars['String']['output'];
  settings?: Maybe<WorkspacePipedriveSettings>;
};

export type WorkspacePipedriveIntegrationSettingInput = {
  pipedrive_stage_id: Scalars['ID']['input'];
  project_billable: Scalars['Boolean']['input'];
  project_stage_id: Scalars['ID']['input'];
};

export type WorkspacePipedriveSettings = {
  __typename?: 'WorkspacePipedriveSettings';
  pipedrive_stage_id?: Maybe<Scalars['ID']['output']>;
  project_billable?: Maybe<Scalars['Boolean']['output']>;
  project_stage_id?: Maybe<Scalars['ID']['output']>;
};

export type WorkspacePlanningSettings = {
  __typename?: 'WorkspacePlanningSettings';
  default_user_plannable_capacity: Scalars['BigInt']['output'];
  default_utilization_range_from: Scalars['Int']['output'];
  default_utilization_range_to: Scalars['Int']['output'];
  disable_home_office_in_planning: Scalars['Boolean']['output'];
  hide_planning_total_daily_capacity: Scalars['Boolean']['output'];
  planning_alphabet_user_order: Scalars['Boolean']['output'];
  planning_sort_prioritize_time_specific_items: Scalars['Boolean']['output'];
  specific_time_in_planning_enabled: Scalars['Boolean']['output'];
  start_day_of_week: StartDayOfWeekEnum;
  working_from: Scalars['Time']['output'];
  working_to: Scalars['Time']['output'];
};

export type WorkspaceProjectSettings = {
  __typename?: 'WorkspaceProjectSettings';
  automate_invoicing_plan_approval: Scalars['Boolean']['output'];
  can_close_expense_budget_item_with_unapproved_expenses: Scalars['Boolean']['output'];
  create_default_task_enabled: Scalars['Boolean']['output'];
  create_default_task_only_to_our_work_category: Scalars['Boolean']['output'];
  enable_additional_brand_numeric_code: Scalars['Boolean']['output'];
  our_work_budget_categories_count: Scalars['BigInt']['output'];
  project_code_generator: ProjectCodeGeneratorEnum;
  project_code_length: Scalars['Int']['output'];
  project_code_with_year: Scalars['Boolean']['output'];
  project_count: Scalars['BigInt']['output'];
};

export type WorkspaceSequence = {
  __typename?: 'WorkspaceSequence';
  format: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  next_number: Scalars['Int']['output'];
  types: Array<SequenceTypesEnum>;
};

export type WorkspaceSequenceSettingInput = {
  format: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  next_number: Scalars['Int']['input'];
  types: Array<SequenceTypesEnum>;
};

export type WorkspaceSettings = {
  __typename?: 'WorkspaceSettings';
  auto_complete_allocation_types?: Maybe<Array<Maybe<CapacityAllocationTypeEnum>>>;
  auto_deadline_in_tasks: Scalars['Boolean']['output'];
  automate_invoicing_plan_approval: Scalars['Boolean']['output'];
  automatically_approved_expense_items: Scalars['Boolean']['output'];
  bank_api_active: Scalars['Boolean']['output'];
  bmail_activated: Scalars['Boolean']['output'];
  brand_template_id?: Maybe<Scalars['ID']['output']>;
  budget_pdf_export_settings?: Maybe<BudgetPdfSettings>;
  budget_xlsx_languages?: Maybe<Array<Scalars['String']['output']>>;
  can_close_expense_budget_item_with_unapproved_expenses: Scalars['Boolean']['output'];
  can_skip_invoice_date_validations: Scalars['Boolean']['output'];
  can_transfer_credit_between_teams_without_constraints: Scalars['Boolean']['output'];
  can_transfer_credit_with_date_without_constraints: Scalars['Boolean']['output'];
  companies: Array<WorkspaceCompany>;
  contractor_fields_extra_validation: Scalars['Boolean']['output'];
  country: Country;
  create_quote_only_after_approved_budgets: Scalars['Boolean']['output'];
  currency: Currency;
  currencyExchangeRatesStructured: Array<CurrencyExchangeRateStructured>;
  defaultVatRate: VatRate;
  default_payment_due: Scalars['BigInt']['output'];
  default_show_billing_accounting_on_invoices: Scalars['Boolean']['output'];
  default_show_unit_price_on_invoices: Scalars['Boolean']['output'];
  default_task_priority_id: Scalars['BigInt']['output'];
  default_task_status_id: Scalars['BigInt']['output'];
  default_user_plannable_capacity: Scalars['BigInt']['output'];
  default_utilization_range_from: Scalars['Int']['output'];
  default_utilization_range_to: Scalars['Int']['output'];
  disable_home_office_in_planning: Scalars['Boolean']['output'];
  enable_additional_brand_numeric_code: Scalars['Boolean']['output'];
  enable_allocation_meeting_play: Scalars['Boolean']['output'];
  enable_bank: Scalars['Boolean']['output'];
  enable_calendar_integration: Scalars['Boolean']['output'];
  enable_contractor_full_bank_account_data: Scalars['Boolean']['output'];
  enable_expense_email_import: Scalars['Boolean']['output'];
  exchange_rate_denomination: Scalars['BigInt']['output'];
  expense_auto_cost_centre_by_team: Scalars['Boolean']['output'];
  expense_effectix_custom_cost_ratio: Scalars['Boolean']['output'];
  expense_identification_fields_required: Scalars['Boolean']['output'];
  exportSettings: ExportSettings;
  financial_amount_by_percent: Scalars['Boolean']['output'];
  generate_numerical_brand_codes: Scalars['Boolean']['output'];
  google_email_integration_enabled: Scalars['Boolean']['output'];
  hide_expense_summary: Scalars['Boolean']['output'];
  hide_planning_total_daily_capacity: Scalars['Boolean']['output'];
  highlight_overtime_in_tasks: Scalars['Boolean']['output'];
  invoice_attachment_name_templates?: Maybe<InvoiceAttachmentNameTemplates>;
  invoicing_more_teams: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  moduleSettings: ModuleSettings;
  notification_email?: Maybe<Scalars['String']['output']>;
  notification_emails_enabled: Scalars['Boolean']['output'];
  only_from_calendar_integration: Scalars['Boolean']['output'];
  partner_access_enabled: Scalars['Boolean']['output'];
  pipedrive_enabled: Scalars['Boolean']['output'];
  planned_expenses_show_client_price: Scalars['Boolean']['output'];
  planning_alphabet_user_order: Scalars['Boolean']['output'];
  planning_sort_prioritize_time_specific_items: Scalars['Boolean']['output'];
  planning_view_settings?: Maybe<Array<PlanningViewSetting>>;
  prevent_saving_duplicated_expenses: Scalars['Boolean']['output'];
  require_already_paid_subfields_for_drafts: Scalars['Boolean']['output'];
  require_project_category: Scalars['Boolean']['output'];
  require_two_factor_authentication: Scalars['Boolean']['output'];
  setup_completed?: Maybe<Scalars['Boolean']['output']>;
  show_accounting_vat_classification: Scalars['Boolean']['output'];
  show_amounts_in_time_tracking_report: Scalars['Boolean']['output'];
  show_done_tasks: Scalars['Boolean']['output'];
  show_expense_item_vat_rate: Scalars['Boolean']['output'];
  show_mcp_settings: Scalars['Boolean']['output'];
  show_smtp_settings: Scalars['Boolean']['output'];
  smtpSettings?: Maybe<WorkspaceSmtpSettings>;
  specific_time_in_planning_enabled: Scalars['Boolean']['output'];
  start_day_of_week: StartDayOfWeekEnum;
  time_tracking_rate_length: Scalars['BigInt']['output'];
  time_tracking_rate_type: Scalars['String']['output'];
  time_tracking_running_timers_timeout: Scalars['BigInt']['output'];
  timetastic_integration: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  transfer_credit_directly_from_invoice: Scalars['Boolean']['output'];
  trial_from?: Maybe<Scalars['Date']['output']>;
  unpaid_banner_message?: Maybe<Scalars['String']['output']>;
  use_current_assignee: Scalars['Boolean']['output'];
  vapid_public_key: Scalars['String']['output'];
  working_from: Scalars['Time']['output'];
  working_to: Scalars['Time']['output'];
  xero_enabled: Scalars['Boolean']['output'];
};

export type WorkspaceSmtpSettings = {
  __typename?: 'WorkspaceSmtpSettings';
  active: Scalars['Boolean']['output'];
  google_auth_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_google_connected: Scalars['Boolean']['output'];
  is_microsoft_connected: Scalars['Boolean']['output'];
  mail_type?: Maybe<MailTypeEnum>;
  microsoft_auth_url?: Maybe<Scalars['String']['output']>;
  microsoft_shared_mailbox?: Maybe<Scalars['String']['output']>;
  smtp_encryption?: Maybe<Scalars['String']['output']>;
  smtp_from_address?: Maybe<Scalars['String']['output']>;
  smtp_from_name?: Maybe<Scalars['String']['output']>;
  smtp_host?: Maybe<Scalars['String']['output']>;
  smtp_password?: Maybe<Scalars['String']['output']>;
  smtp_port?: Maybe<Scalars['Int']['output']>;
  smtp_username?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceTaskPriority = {
  __typename?: 'WorkspaceTaskPriority';
  default: Scalars['Boolean']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  system_priority?: Maybe<TaskSystemPriorityEnum>;
};

export type WorkspaceTaskPriorityInput = {
  default: Scalars['Boolean']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  system_priority?: InputMaybe<TaskSystemPriorityEnum>;
};

export type WorkspaceTaskSettings = {
  __typename?: 'WorkspaceTaskSettings';
  show_done_tasks: Scalars['Boolean']['output'];
  task_priorities: Array<WorkspaceTaskPriority>;
  task_statuses: Array<WorkspaceTaskStatus>;
  use_current_assignee: Scalars['Boolean']['output'];
};

export type WorkspaceTaskStatus = {
  __typename?: 'WorkspaceTaskStatus';
  background_color: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  done: Scalars['Boolean']['output'];
  foreground_color: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type WorkspaceTaskStatusInput = {
  background_color: Scalars['String']['input'];
  default: Scalars['Boolean']['input'];
  done: Scalars['Boolean']['input'];
  foreground_color: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type WorkspaceUserManagementSetting = {
  __typename?: 'WorkspaceUserManagementSetting';
  require_two_factor_authentication: Scalars['Boolean']['output'];
  teams: Array<Team>;
};

export type LockProjectInput = {
  orderBy?: InputMaybe<Array<WipOrderByClause>>;
  period_id: Scalars['ID']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
};

export type QuoteInput = {
  id: Scalars['ID']['input'];
  settings: BudgetExportOptionsInput;
};

export type QuoteSendInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  other_recipients: Array<InputMaybe<Scalars['String']['input']>>;
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};

export type StopTimerForCapacityAllocationItemInput = {
  capacity_allocation_item_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type TimeMaterialsCommissionInputData = {
  commission: Scalars['BigInt']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
};

export type TimeMaterialsInputData = {
  commission_data?: InputMaybe<Array<InputMaybe<TimeMaterialsCommissionInputData>>>;
  expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['Date']['input'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};

export type TimeMaterialsInvoiceWhereConditions = {
  AND?: InputMaybe<Array<TimeMaterialsInvoiceWhereConditions>>;
  OR?: InputMaybe<Array<TimeMaterialsInvoiceWhereConditions>>;
  column?: InputMaybe<TimeTrackingItemWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type TimeMaterialsQueryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TimeMaterialsInvoiceWhereConditions>;
};

export enum TimeTrackingItemWhereColumn {
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  TaskId = 'TASK_ID',
  TimeTrackingWorkTypeId = 'TIME_TRACKING_WORK_TYPE_ID',
  UserId = 'USER_ID'
}

export type UpdateBillingPlanBudgetInput = {
  billingPlanBudgetItem: Array<BillingPlanBudgetItemInput>;
  billing_item_type: BillingItemTypEnum;
  budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_type: BudgetItemTypeEnum;
  category_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProjectBillingPlanBudgetInput = {
  billingPlanBudgets: Array<UpdateBillingPlanBudgetInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateProjectBillingPlanSettingsInput = {
  auto_create_invoice: Scalars['Boolean']['input'];
  auto_send_invoice: Scalars['Boolean']['input'];
  auto_send_thank_you: Scalars['Boolean']['input'];
  auto_send_thank_you_template?: InputMaybe<ProjectBillingPlanEmailTemplateInput>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  billing_item_type: BillingItemTypEnum;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  create_draft_invoice: Scalars['Boolean']['input'];
  create_summary_invoice_after_payment: Scalars['Boolean']['input'];
  date_of_supply_from_issue_date?: InputMaybe<Scalars['Int']['input']>;
  email_template: ProjectBillingPlanEmailTemplateInput;
  from: Scalars['Date']['input'];
  generate_invoice_items?: InputMaybe<ProjectBillingPlanSettingGenerateInvoiceItemsEnum>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['ID']['input']>;
  project_id: Scalars['ID']['input'];
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
  vat_rate_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkspaceNotifications = {
  notifications: Array<WorkspaceNotificationInput>;
};

export type SubscribeToPushNotificationsMutationVariables = Exact<{
  endpoint: Scalars['String']['input'];
  keys: PushNotificationSubscriptionKeys;
}>;


export type SubscribeToPushNotificationsMutation = { __typename?: 'Mutation', subscribeToPushNotifications: boolean };

export type UnsubscribeToPushNotificationsMutationVariables = Exact<{
  endpoint: Scalars['String']['input'];
}>;


export type UnsubscribeToPushNotificationsMutation = { __typename?: 'Mutation', unsubscribeFromPushNotifications: boolean };

export type AddManualAccountMoveMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  currencyId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  date: Scalars['Date']['input'];
}>;


export type AddManualAccountMoveMutation = { __typename?: 'Mutation', addManualAccountMove: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } };

export type BankAccountsForPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type BankAccountsForPaymentsQuery = { __typename?: 'Query', bankAccounts?: Array<{ __typename?: 'BankAccount', id: string, workspace_bank_account_id?: string | undefined | null, iban: string, name: string }> | undefined | null };

export type AddDocumentsToAccountMoveMutationVariables = Exact<{
  bankAccountMoveId: Scalars['ID']['input'];
  documents: Array<BankAccountMoveDocumentInput> | BankAccountMoveDocumentInput;
}>;


export type AddDocumentsToAccountMoveMutation = { __typename?: 'Mutation', addDocumentsToAccountMove: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } };

export type ExpensesForPaymentMatchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type ExpensesForPaymentMatchQuery = { __typename?: 'Query', expenses?: { __typename?: 'ExpensePaginator', data: Array<{ __typename?: 'Expense', id: string, expense_no?: string | undefined | null, type: ExpenseTypeEnum, invoice_status: ExpenseInvoiceStatusEnum, paid_at?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, has_master_agreement?: boolean | undefined | null, workspace_company_id?: string | undefined | null, variable_symbol?: string | undefined | null, iban?: string | undefined | null, exchange_rate?: number | undefined | null, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string }>, stats: { __typename?: 'ExpenseStats', total_amount: number, total_amount_without_vat_in_currency: number, total_amount_with_vat_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount: number }> | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type InvoicesForPaymentMatchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OiQueryArgs>;
}>;


export type InvoicesForPaymentMatchQuery = { __typename?: 'Query', outgoingInvoices?: { __typename?: 'OutgoingInvoicePaginator', data: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, type: OutgoingInvoiceTypeEnum, paid_at?: string | undefined | null, exchange_rate: number, issue_date: string, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, billingEntity: { __typename?: 'BillingEntity', legal_name: string, street: string, city: string }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_with_vat_in_currency: number, billing_amount_in_currency: number, billing_amount_with_vat_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount: number }> | undefined | null, relatesToOutgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null } | undefined | null } | undefined | null, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProformasForPaymentMatchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OiProformaQueryArgs>;
}>;


export type ProformasForPaymentMatchQuery = { __typename?: 'Query', outgoingProformaInvoices?: { __typename?: 'OutgoingProformaInvoicePaginator', data: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, abraflexi_exported?: boolean | undefined | null, paid_at?: string | undefined | null, exchange_rate: number, issue_date: string, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, billingEntity: { __typename?: 'BillingEntity', legal_name: string, street: string, city: string }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount_with_vat_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount: number }> | undefined | null, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null } | undefined | null }> | undefined | null, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type MatchPaymentModalFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MatchPaymentModalFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }> };

export type AccountMoveFragment = { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null };

export type ExcludeAccountMoveMutationVariables = Exact<{
  accountMoveId: Scalars['ID']['input'];
}>;


export type ExcludeAccountMoveMutation = { __typename?: 'Mutation', excludeBankAccountMove: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } };

export type BankAccountMovesQueryVariables = Exact<{
  filters?: InputMaybe<BankAccountMoveQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BankAccountMovesQuery = { __typename?: 'Query', bankAccountMoves?: { __typename?: 'BankAccountMovePaginator', data: Array<{ __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type BillingEntityModalFragment = { __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, applies_vat: boolean, payment_due: number, invoice_email?: string | undefined | null, note?: string | undefined | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | undefined | null };

export type CreateBillingEntityMutationVariables = Exact<{
  input: CreateBillingEntityInput;
}>;


export type CreateBillingEntityMutation = { __typename?: 'Mutation', createBillingEntity: { __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, applies_vat: boolean, payment_due: number, invoice_email?: string | undefined | null, note?: string | undefined | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | undefined | null } };

export type UpdateBillingEntityMutationVariables = Exact<{
  input: UpdateBillingEntityInput;
}>;


export type UpdateBillingEntityMutation = { __typename?: 'Mutation', updateBillingEntity: { __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, applies_vat: boolean, payment_due: number, invoice_email?: string | undefined | null, note?: string | undefined | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | undefined | null } };

export type OptionsForBillingEntityQueryVariables = Exact<{ [key: string]: never; }>;


export type OptionsForBillingEntityQuery = { __typename?: 'Query', languagesForInvoicePdf: Array<string>, countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string }> };

export type BrandModalFragment = { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null };

export type CreateBrandMutationVariables = Exact<{
  input: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null } };

export type UpdateBrandMutationVariables = Exact<{
  input: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null } };

export type GetNextNumericalBrandCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextNumericalBrandCodeQuery = { __typename?: 'Query', getNextNumericalBrandCode: string };

export type ClientOptionsForModalBrandQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientOptionsForModalBrandQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }> };

export type BillingEntityOptionsForModalBrandQueryVariables = Exact<{
  client_id: Scalars['ID']['input'];
}>;


export type BillingEntityOptionsForModalBrandQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string }>, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string } } | undefined | null };

export type GetBrandForCreditAccountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBrandForCreditAccountsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, client: { __typename?: 'Client', id: string, name: string } } | undefined | null };

export type UpdateTimeTrackingRatesForBrandMutationVariables = Exact<{
  input: UpdateTimeTrackingRatesForBrandInput;
}>;


export type UpdateTimeTrackingRatesForBrandMutation = { __typename?: 'Mutation', updateTimeTrackingRatesForBrand: { __typename?: 'Brand', id: string, average_time_tracking_rate?: number | undefined | null, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }> } };

export type BrandDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BrandDetailQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }>, brand?: { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | undefined | null, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, archived_at?: string | undefined | null, average_time_tracking_rate?: number | undefined | null, calculated_average_time_tracking_rate?: number | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, responsiblePerson?: { __typename?: 'User', id: string } | undefined | null, otherResponsiblePersons: Array<{ __typename?: 'User', id: string }>, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | undefined | null, customField: { __typename?: 'PipedriveCustomField', label?: string | undefined | null } }>, client: { __typename?: 'Client', id: string, name: string, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string }>, responsiblePerson?: { __typename?: 'User', id: string } | undefined | null, otherResponsiblePersons: Array<{ __typename?: 'User', id: string }> }, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, email: string, scope_access?: UserScopeAccessEnum | undefined | null, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, phone?: string | undefined | null, email?: string | undefined | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | undefined | null, customField: { __typename?: 'PipedriveCustomField', label?: string | undefined | null } }> }>, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }> } | undefined | null, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }> };

export type GetBrandForDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBrandForDocumentsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, client: { __typename?: 'Client', id: string, name: string } } | undefined | null };

export type GetBrandsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BrandQueryArgs>;
}>;


export type GetBrandsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }>, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null }>, brandsSummary: { __typename?: 'BrandsSummary', brandIds: Array<string> }, brands?: { __typename?: 'BrandPaginator', data: Array<{ __typename?: 'Brand', id: string, name: string, code: string, archived_at?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, client: { __typename?: 'Client', id: string, name: string }, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null }>, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string }> | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | undefined | null, customField: { __typename?: 'PipedriveCustomField', label?: string | undefined | null } }>, stats: { __typename?: 'BrandStats', active_projects: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand: { __typename?: 'Brand', id: string } };

export type ArchiveBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveBrandMutation = { __typename?: 'Mutation', archiveBrand: { __typename?: 'Brand', id: string } };

export type UnarchiveBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveBrandMutation = { __typename?: 'Mutation', unarchiveBrand: { __typename?: 'Brand', id: string } };

export type BudgetPdfSettingsFragment = { __typename?: 'BudgetPdfSettings', show_hours?: boolean | undefined | null, show_disclaimer?: boolean | undefined | null, signature?: boolean | undefined | null, show_summary?: boolean | undefined | null, show_client_name?: boolean | undefined | null, show_client_details?: boolean | undefined | null, language?: string | undefined | null, our_work_show_commission?: boolean | undefined | null, title_page_with_vat?: boolean | undefined | null, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, hide_title_page?: boolean | undefined | null, add_billing_plan?: boolean | undefined | null, billing_plan_exchange_rate?: number | undefined | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | undefined | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | undefined | null, our_work_description?: boolean | undefined | null, our_work_vat_in_items?: boolean | undefined | null, our_work_show_discount?: boolean | undefined | null, expense_show_commission?: boolean | undefined | null, expense_show_quantity?: boolean | undefined | null, expense_show_unit?: boolean | undefined | null, expense_show_discount?: boolean | undefined | null, expense_show_description?: boolean | undefined | null, expense_show_vat_in_items?: boolean | undefined | null, show_client_and_brand?: boolean | undefined | null, show_project_name_full?: boolean | undefined | null, use_client_name_from_billing_entity?: boolean | undefined | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | undefined | null, disclaimer?: string | undefined | null } | undefined | null> | undefined | null };

export type PreviewQuoteMutationVariables = Exact<{
  input: QuoteInput;
}>;


export type PreviewQuoteMutation = { __typename?: 'Mutation', previewQuote: { __typename?: 'Quote', url: string } };

export type SaveQuoteMutationVariables = Exact<{
  input: QuoteInput;
}>;


export type SaveQuoteMutation = { __typename?: 'Mutation', saveQuote: { __typename?: 'Quote', id: string, url: string } };

export type GetQuoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQuoteQuery = { __typename?: 'Query', GetQuote: { __typename?: 'Quote', id: string, url: string, number: string, status: QuoteStatus, total_amount: number, sent_to_client_date?: string | undefined | null, client_approval_date?: string | undefined | null, settings: { __typename?: 'BudgetPdfSettings', date?: string | undefined | null, valid_until?: string | undefined | null, show_hours?: boolean | undefined | null, show_disclaimer?: boolean | undefined | null, signature?: boolean | undefined | null, show_summary?: boolean | undefined | null, show_client_name?: boolean | undefined | null, show_client_details?: boolean | undefined | null, language?: string | undefined | null, our_work_show_commission?: boolean | undefined | null, title_page_with_vat?: boolean | undefined | null, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, hide_title_page?: boolean | undefined | null, add_billing_plan?: boolean | undefined | null, billing_plan_exchange_rate?: number | undefined | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | undefined | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | undefined | null, our_work_description?: boolean | undefined | null, our_work_vat_in_items?: boolean | undefined | null, our_work_show_discount?: boolean | undefined | null, expense_show_commission?: boolean | undefined | null, expense_show_quantity?: boolean | undefined | null, expense_show_unit?: boolean | undefined | null, expense_show_discount?: boolean | undefined | null, expense_show_description?: boolean | undefined | null, expense_show_vat_in_items?: boolean | undefined | null, show_client_and_brand?: boolean | undefined | null, show_project_name_full?: boolean | undefined | null, use_client_name_from_billing_entity?: boolean | undefined | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | undefined | null, disclaimer?: string | undefined | null } | undefined | null> | undefined | null }, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, budgets: Array<{ __typename?: 'Budget', id: string, account_manager?: string | undefined | null, assignment_date?: string | undefined | null, status: BudgetStatusEnum, client_approved?: boolean | undefined | null, price?: number | undefined | null, project?: { __typename?: 'Project', id: string, title: string } | undefined | null, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null } | undefined | null }>, Client?: { __typename?: 'Client', billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string, street: string, city: string, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, deleted: boolean } }> } | undefined | null } };

export type BudgetGroupFragment = { __typename?: 'BudgetGroup', budget_name?: string | undefined | null, budget_number?: string | undefined | null, budgets?: Array<{ __typename?: 'Budget', id: string, project_id?: string | undefined | null, description?: string | undefined | null, account_manager?: string | undefined | null, assignment_date?: string | undefined | null, status: BudgetStatusEnum, internally_approved?: boolean | undefined | null, client_approved?: boolean | undefined | null, is_active?: boolean | undefined | null, version?: number | undefined | null, price?: number | undefined | null, temporary_project_id?: string | undefined | null, created_at: string, updated_at: string, project?: { __typename?: 'Project', id: string, title: string } | undefined | null, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | undefined | null } | undefined | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | undefined | null, is_archived?: boolean | undefined | null } | undefined | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | undefined | null, quotes?: Array<{ __typename?: 'Quote', id: string, url: string, number: string }> | undefined | null } | undefined | null> | undefined | null };

export type CreateQuoteMutationVariables = Exact<{
  budget_ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'Quote', id: string, url: string } };

export type BudgetsExportQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  options?: InputMaybe<BudgetExportOptionsInput>;
}>;


export type BudgetsExportQuery = { __typename?: 'Query', budgetsExport: string };

export type BudgetsFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetsFilterOptionsQuery = { __typename?: 'Query', brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type GetBudgetsQueryVariables = Exact<{
  filters?: InputMaybe<BudgetArgs>;
}>;


export type GetBudgetsQuery = { __typename?: 'Query', budgets: { __typename?: 'BudgetPaginator', allIds: Array<number>, data?: Array<{ __typename?: 'BudgetGroup', budget_name?: string | undefined | null, budget_number?: string | undefined | null, budgets?: Array<{ __typename?: 'Budget', id: string, project_id?: string | undefined | null, description?: string | undefined | null, account_manager?: string | undefined | null, assignment_date?: string | undefined | null, status: BudgetStatusEnum, internally_approved?: boolean | undefined | null, client_approved?: boolean | undefined | null, is_active?: boolean | undefined | null, version?: number | undefined | null, price?: number | undefined | null, temporary_project_id?: string | undefined | null, created_at: string, updated_at: string, project?: { __typename?: 'Project', id: string, title: string } | undefined | null, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | undefined | null } | undefined | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | undefined | null, is_archived?: boolean | undefined | null } | undefined | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | undefined | null, quotes?: Array<{ __typename?: 'Quote', id: string, url: string, number: string }> | undefined | null } | undefined | null> | undefined | null }> | undefined | null, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type BudgetovacPositionsSetFragment = { __typename?: 'BudgetovacPositionsSet', id: string, name: string, active: boolean, client_id?: number | undefined | null, currency_code: string, internal_production_commission?: number | undefined | null, external_production_commission?: number | undefined | null, media_budget_commission?: number | undefined | null, extras_commission?: number | undefined | null, positions_prices: Array<{ __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | undefined | null, department_name?: string | undefined | null, name: string, position_id: string, price: string }> };

export type BudgetovacPositionPriceFragment = { __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | undefined | null, department_name?: string | undefined | null, name: string, position_id: string, price: string };

export type CreateBudgetovacPositionsSetMutationVariables = Exact<{
  input: CreateBudgetovacPositionsSetInput;
}>;


export type CreateBudgetovacPositionsSetMutation = { __typename?: 'Mutation', createBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type UpdateBudgetovacPositionsSetMutationVariables = Exact<{
  input: UpdateBudgetovacPositionsSetInput;
}>;


export type UpdateBudgetovacPositionsSetMutation = { __typename?: 'Mutation', updateBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type DeleteBudgetovacPositionsSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBudgetovacPositionsSetMutation = { __typename?: 'Mutation', deleteBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type SetActiveBudgetovacPositionsSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type SetActiveBudgetovacPositionsSetMutation = { __typename?: 'Mutation', setActiveBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type BudgetovacPositionsSetsQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type BudgetovacPositionsSetsQuery = { __typename?: 'Query', budgetovacPositionsSets: Array<{ __typename?: 'BudgetovacBrandPositionsSet', client_id?: string | undefined | null, brand?: { __typename?: 'Brand', code: string, name: string } | undefined | null, budgetovacPositionSets: Array<{ __typename?: 'BudgetovacPositionsSet', id: string, name: string, active: boolean, client_id?: number | undefined | null, currency_code: string, internal_production_commission?: number | undefined | null, external_production_commission?: number | undefined | null, media_budget_commission?: number | undefined | null, extras_commission?: number | undefined | null, positions_prices: Array<{ __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | undefined | null, department_name?: string | undefined | null, name: string, position_id: string, price: string }> }> }> };

export type BudgetovacPositionsSetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BudgetovacPositionsSetQuery = { __typename?: 'Query', budgetovacPositionsSet?: { __typename?: 'BudgetovacPositionsSet', id: string, name: string, active: boolean, client_id?: number | undefined | null, currency_code: string, internal_production_commission?: number | undefined | null, external_production_commission?: number | undefined | null, media_budget_commission?: number | undefined | null, extras_commission?: number | undefined | null, positions_prices: Array<{ __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | undefined | null, department_name?: string | undefined | null, name: string, position_id: string, price: string }> } | undefined | null };

export type BudgetovacPositionsSetModalDependenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetovacPositionsSetModalDependenciesQuery = { __typename?: 'Query', budgetovacPositions: Array<{ __typename?: 'BudgetovacPosition', alias: string, price: number, is_default: boolean, id: string, name: string, department_id?: string | undefined | null }>, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }> };

export type BudgetovacPositionFragment = { __typename?: 'BudgetovacPosition', id: string, name: string, department_id?: string | undefined | null };

export type CreateBudgetovacPositionMutationVariables = Exact<{
  input: CreateBudgetovacPositionInput;
}>;


export type CreateBudgetovacPositionMutation = { __typename?: 'Mutation', createBudgetovacPosition: { __typename?: 'BudgetovacPosition', alias: string, price: number, is_default: boolean, id: string, name: string, department_id?: string | undefined | null } };

export type UpdateBudgetovacPositionMutationVariables = Exact<{
  input: UpdateBudgetovacPositionInput;
}>;


export type UpdateBudgetovacPositionMutation = { __typename?: 'Mutation', updateBudgetovacPosition: { __typename?: 'BudgetovacPosition', id: string } };

export type DeleteBudgetovacPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBudgetovacPositionMutation = { __typename?: 'Mutation', deleteBudgetovacPosition: { __typename?: 'BudgetovacPosition', id: string } };

export type BudgetovacPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetovacPositionsQuery = { __typename?: 'Query', budgetovacPositions: Array<{ __typename?: 'BudgetovacPosition', id: string, name: string, department_id?: string | undefined | null }> };

export type BudgetovacDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetovacDepartmentsQuery = { __typename?: 'Query', ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null };

export type DeleteQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote: boolean };

export type ManualApproveQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ManualApproveQuoteMutation = { __typename?: 'Mutation', manualApproveQuote: { __typename?: 'Quote', id: string, status: QuoteStatus, client_approval_date?: string | undefined | null } };

export type GetBudgetQuotesQueryVariables = Exact<{
  filters?: InputMaybe<QuotesArgs>;
}>;


export type GetBudgetQuotesQuery = { __typename?: 'Query', getBudgetQuotes: { __typename?: 'QuotesPaginator', data?: Array<{ __typename?: 'Quote', id: string, url: string, number: string, status: QuoteStatus, client_approval_date?: string | undefined | null, sent_to_client_date?: string | undefined | null, settings: { __typename?: 'BudgetPdfSettings', date?: string | undefined | null }, budgets: Array<{ __typename?: 'Budget', id: string, project_id?: string | undefined | null, description?: string | undefined | null, account_manager?: string | undefined | null, assignment_date?: string | undefined | null, status: BudgetStatusEnum, internally_approved?: boolean | undefined | null, client_approved?: boolean | undefined | null, is_active?: boolean | undefined | null, version?: number | undefined | null, price?: number | undefined | null, temporary_project_id?: string | undefined | null, created_at: string, updated_at: string, project?: { __typename?: 'Project', id: string, title: string } | undefined | null, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | undefined | null } | undefined | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | undefined | null, is_archived?: boolean | undefined | null } | undefined | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | undefined | null }> }> | undefined | null, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, brands: Array<{ __typename?: 'Brand', id: string }> } | undefined | null };

export type DeleteBillingEntityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBillingEntityMutation = { __typename?: 'Mutation', deleteBillingEntity: { __typename?: 'BillingEntity', id: string } };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: { __typename?: 'Contact', id: string } };

export type UpdateClientMutationVariables = Exact<{
  input: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, country?: { __typename?: 'Country', id: string } | undefined | null } } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: { __typename?: 'Client', id: string } };

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, country?: { __typename?: 'Country', id: string } | undefined | null } } };

export type ClientDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientDetailQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, country?: { __typename?: 'Country', id: string } | undefined | null }, responsiblePerson?: { __typename?: 'User', id: string } | undefined | null, otherResponsiblePersons: Array<{ __typename?: 'User', id: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string, archived_at?: string | undefined | null, code: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | undefined | null, customField: { __typename?: 'PipedriveCustomField', label?: string | undefined | null } }> }>, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, applies_vat: boolean, payment_due: number, invoice_email?: string | undefined | null, note?: string | undefined | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | undefined | null }>, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, email?: string | undefined | null, phone?: string | undefined | null }>, currencyExchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> } | undefined | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string }> | undefined | null, countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string }> };

export type ClientFilterOptionsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<QueryContactsOrderByOrderByClause> | QueryContactsOrderByOrderByClause>;
}>;


export type ClientFilterOptionsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null }>, responsiblePersonsSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }> };

export type GetClientsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<ClientQueryArgs>;
}>;


export type GetClientsQuery = { __typename?: 'Query', clients?: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, country?: { __typename?: 'Country', id: string } | undefined | null }, brands: Array<{ __typename?: 'Brand', id: string, name: string, projects: Array<{ __typename?: 'Project', id: string }> }>, responsiblePerson?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, contacts: Array<{ __typename?: 'Contact', first_name?: string | undefined | null, last_name?: string | undefined | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type AbraFlexiOiExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AbraFlexiOiExportQuery = { __typename?: 'Query', abraFlexiOIExport?: string | undefined | null };

export type AbraFlexiOutgoingProformaInvoicesExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AbraFlexiOutgoingProformaInvoicesExportQuery = { __typename?: 'Query', abraFlexiOutgoingProformaInvoicesExport?: string | undefined | null };

export type ExpenseAbraFlexiExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseAbraFlexiExportQuery = { __typename?: 'Query', expenseAbraFlexiExport: string };

export type DocumentExportFragment = { __typename?: 'DocumentExport', type: string, exported_at: string };

export type FinancialOiExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type FinancialOiExportQuery = { __typename?: 'Query', financialOIExport?: string | undefined | null };

export type ExpenseXeroExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseXeroExportQuery = { __typename?: 'Query', expenseXeroExport: string };

export type OutgoingInvoiceXeroExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type OutgoingInvoiceXeroExportQuery = { __typename?: 'Query', xeroOIExport?: string | undefined | null };

export type ContractorModelFragment = { __typename?: 'Contractor', id: string, legal_name: string, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, is_vat_payer?: boolean | undefined | null, business_form?: BusinessFormEnum | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null };

export type ContractorDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractorDetailQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, is_vat_payer?: boolean | undefined | null, business_form?: BusinessFormEnum | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null } | undefined | null };

export type CreateContractorMutationVariables = Exact<{
  input: CreateContractorInput;
}>;


export type CreateContractorMutation = { __typename?: 'Mutation', createContractor: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, is_vat_payer?: boolean | undefined | null, business_form?: BusinessFormEnum | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null } };

export type UpdateContractorMutationVariables = Exact<{
  input: UpdateContractorInput;
}>;


export type UpdateContractorMutation = { __typename?: 'Mutation', updateContractor: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, is_vat_payer?: boolean | undefined | null, business_form?: BusinessFormEnum | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null } };

export type ModalContractorDependenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ModalContractorDependenciesQuery = { __typename?: 'Query', countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string, code: string }>, accountingAccountsSimpleMap: Array<{ __typename?: 'AccountingAccount', id: string, title: string, account_number: string }> };

export type CompanyDataAutocompleteQueryVariables = Exact<{
  input: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
}>;


export type CompanyDataAutocompleteQuery = { __typename?: 'Query', getAutocompleteForCompanyData: { __typename?: 'AutocompleteCompanyData', suggestions: Array<string>, results: Array<{ __typename?: 'AutocompleteCompanyDataResult', legal_name?: string | undefined | null, city?: string | undefined | null, national_id?: string | undefined | null, cancelled: boolean }> } };

export type CompanyDataByRegistrationNoQueryVariables = Exact<{
  registration_no: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
}>;


export type CompanyDataByRegistrationNoQuery = { __typename?: 'Query', getCompanyDataByRegistrationNo?: { __typename?: 'CompanyData', legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, applies_vat: boolean, cancelled: boolean, bankAccounts: Array<{ __typename?: 'CompanyBankAccount', iban?: string | undefined | null, swift?: string | undefined | null }>, country?: { __typename?: 'Country', id: string, name: string, code: string, created_at?: string | undefined | null, updated_at?: string | undefined | null } | undefined | null } | undefined | null };

export type BankAccountConverterQueryVariables = Exact<{
  country_id: Scalars['ID']['input'];
  account_number: Scalars['String']['input'];
  account_code?: InputMaybe<Scalars['String']['input']>;
}>;


export type BankAccountConverterQuery = { __typename?: 'Query', bankAccountConverter: { __typename?: 'BankAccountConverter', iban?: string | undefined | null } };

export type GetContractorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ContractorQueryArgs>;
}>;


export type GetContractorsQuery = { __typename?: 'Query', contractorsSummary: { __typename?: 'ContractorsSummary', contractorIds: Array<string> }, contractors?: { __typename?: 'ContractorPaginator', data: Array<{ __typename?: 'Contractor', id: string, iban?: string | undefined | null, registration_no?: string | undefined | null, legal_name: string, is_vat_payer?: boolean | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type DeleteContractorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractorMutation = { __typename?: 'Mutation', deleteContractor: { __typename?: 'Contractor', id: string } };

export type DeleteContractorsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteContractorsBulkMutation = { __typename?: 'Mutation', deleteContractorsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type GetCreditAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCreditAccountQuery = { __typename?: 'Query', brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, team: { __typename?: 'Team', id: string, name: string }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, credits: Array<{ __typename?: 'BrandCreditAccountCreditStats', id: string, credit: number, date: string, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string } | undefined | null, originatesBrandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null }>, debits: Array<{ __typename?: 'BrandCreditAccountDebitStats', id: string, credit: number, performed_at: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, code: string } } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, code: string } } | undefined | null, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null }>, stats: { __typename?: 'BrandCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number } } | undefined | null };

export type GetCreditAccountOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditAccountOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type UpdateCreditAccountMutationVariables = Exact<{
  input: UpdateBrandCreditAccountInput;
}>;


export type UpdateCreditAccountMutation = { __typename?: 'Mutation', updateBrandCreditAccount: { __typename?: 'BrandCreditAccount', id: string } };

export type CreateCreditAccountMutationVariables = Exact<{
  input: CreateBrandCreditAccountInput;
}>;


export type CreateCreditAccountMutation = { __typename?: 'Mutation', createBrandCreditAccount: { __typename?: 'BrandCreditAccount', id: string } };

export type GlobalCreditAccountDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GlobalCreditAccountDetailQuery = { __typename?: 'Query', globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, note?: string | undefined | null, created_at: string, updated_at: string, credits: Array<{ __typename?: 'GlobalCreditAccountCreditStats', id: string, credit: number, date: string, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null } | undefined | null, originatesGlobalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string } | undefined | null }>, debits: Array<{ __typename?: 'GlobalCreditAccountDebitStats', id: string, credit: number, performed_at: string, credit_account_operation_id: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null }>, creditAccount: { __typename?: 'CreditAccount', id: string, created_at: string, updated_at: string, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, stats: { __typename?: 'GlobalCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number } } | undefined | null };

export type GlobalCreditAccountFragment = { __typename?: 'GlobalCreditAccount', id: string, title: string, note?: string | undefined | null, created_at: string, updated_at: string, creditAccount: { __typename?: 'CreditAccount', id: string, created_at: string, updated_at: string, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, stats: { __typename?: 'GlobalCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number }, credits: Array<{ __typename?: 'GlobalCreditAccountCreditStats', id: string, credit: number, date: string }>, debits: Array<{ __typename?: 'GlobalCreditAccountDebitStats', id: string, credit: number, performed_at: string, credit_account_operation_id: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | undefined | null }> };

export type CreateGlobalCreditAccountMutationVariables = Exact<{
  input: CreateGlobalCreditAccountInput;
}>;


export type CreateGlobalCreditAccountMutation = { __typename?: 'Mutation', createGlobalCreditAccount: { __typename?: 'GlobalCreditAccount', id: string } };

export type UpdateGlobalCreditAccountMutationVariables = Exact<{
  input: UpdateGlobalCreditAccountInput;
}>;


export type UpdateGlobalCreditAccountMutation = { __typename?: 'Mutation', updateGlobalCreditAccount: { __typename?: 'GlobalCreditAccount', id: string } };

export type DeleteGlobalCreditAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGlobalCreditAccountMutation = { __typename?: 'Mutation', deleteGlobalCreditAccount: boolean };

export type GlobalCreditAccountsQueryVariables = Exact<{
  filters?: InputMaybe<GlobalCreditAccountQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GlobalCreditAccountsQuery = { __typename?: 'Query', globalCreditAccounts?: { __typename?: 'GlobalCreditAccountPaginator', data: Array<{ __typename?: 'GlobalCreditAccount', id: string, title: string, note?: string | undefined | null, created_at: string, updated_at: string, creditAccount: { __typename?: 'CreditAccount', id: string, created_at: string, updated_at: string, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, stats: { __typename?: 'GlobalCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number }, credits: Array<{ __typename?: 'GlobalCreditAccountCreditStats', id: string, credit: number, date: string }>, debits: Array<{ __typename?: 'GlobalCreditAccountDebitStats', id: string, credit: number, performed_at: string, credit_account_operation_id: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | undefined | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type CreditAccountsTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<CreditAccountQueryArgs>;
}>;


export type CreditAccountsTableSummaryQuery = { __typename?: 'Query', brandCreditAccountsSummary: { __typename?: 'BrandCreditAccountsSummary', brand_credit_accounts: number, total_credit: number, total_debit: number, remaining_credit: number } };

export type GetCreditAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<CreditAccountQueryArgs>;
}>;


export type GetCreditAccountsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, brandCreditAccounts?: { __typename?: 'BrandCreditAccountPaginator', data: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, brand: { __typename?: 'Brand', name: string, id: string }, team: { __typename?: 'Team', id: string, name: string }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, stats: { __typename?: 'BrandCreditAccountStats', id: string, total_credit: number, remaining_credit: number, total_debit: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type GetContractsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ContractQueryArgs>;
}>;


export type GetContractsQuery = { __typename?: 'Query', contractsSummary: { __typename?: 'ContractsSummary', contractIds?: Array<string> | undefined | null }, contracts?: { __typename?: 'ContractPaginator', data: Array<{ __typename?: 'Contract', id: string, title: string, valid_from: string, valid_to?: string | undefined | null, type: ContractTypeEnum, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, projects?: Array<{ __typename?: 'Project', id: string, title: string, code: string } | undefined | null> | undefined | null, brands?: Array<{ __typename?: 'Brand', id: string, name: string } | undefined | null> | undefined | null, contractors?: Array<{ __typename?: 'Contractor', id: string, legal_name: string } | undefined | null> | undefined | null, clients?: Array<{ __typename?: 'Client', id: string, name: string } | undefined | null> | undefined | null, urls: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, perPage: number, total: number, count: number, firstItem?: number | undefined | null, lastItem?: number | undefined | null, lastPage: number } } | undefined | null };

export type ContractsExportQueryVariables = Exact<{
  filters?: InputMaybe<ContractQueryArgs>;
}>;


export type ContractsExportQuery = { __typename?: 'Query', contractsExport: string };

export type GetDocumentDependenciesQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
  orIdIn?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetDocumentDependenciesQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand: { __typename?: 'BrandSimple', id: string } }> };

export type GetDocumentDependenciesForClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetDocumentDependenciesForClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, brands: Array<{ __typename?: 'Brand', id: string, name: string }> } | undefined | null, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand: { __typename?: 'BrandSimple', id: string } }>, contractorsSimpleMap: Array<{ __typename?: 'ContractorSimple', id: string, legal_name: string }> };

export type GetOrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OrderQueryArgs>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', ordersSummary: { __typename?: 'OrdersSummary', orderIds?: Array<string> | undefined | null }, orders?: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null, date_of_order?: string | undefined | null, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, outgoingInvoices: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string }>, projects?: Array<{ __typename?: 'Project', id: string, title: string, code: string } | undefined | null> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string }, urls: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, perPage: number, total: number, count: number, firstItem?: number | undefined | null, lastItem?: number | undefined | null, lastPage: number } } | undefined | null };

export type GetOtherDocumentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OtherDocumentQueryArgs>;
}>;


export type GetOtherDocumentsQuery = { __typename?: 'Query', otherDocumentsSummary: { __typename?: 'OtherDocumentsSummary', otherDocumentIds?: Array<string> | undefined | null }, otherDocuments?: { __typename?: 'OtherDocumentPaginator', data: Array<{ __typename?: 'OtherDocument', id: string, title: string, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, projects?: Array<{ __typename?: 'Project', id: string, title: string, code: string } | undefined | null> | undefined | null, brands?: Array<{ __typename?: 'Brand', id: string, name: string } | undefined | null> | undefined | null, contractors?: Array<{ __typename?: 'Contractor', id: string, legal_name: string } | undefined | null> | undefined | null, clients?: Array<{ __typename?: 'Client', id: string, name: string } | undefined | null> | undefined | null, urls: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type UpdateOtherDocumentMutationVariables = Exact<{
  input: UpdateOtherDocumentInput;
}>;


export type UpdateOtherDocumentMutation = { __typename?: 'Mutation', updateOtherDocument: { __typename?: 'OtherDocument', id: string } };

export type CreateOtherDocumentMutationVariables = Exact<{
  input: CreateOtherDocumentInput;
}>;


export type CreateOtherDocumentMutation = { __typename?: 'Mutation', createOtherDocument: { __typename?: 'OtherDocument', id: string } };

export type DeleteOtherDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOtherDocumentMutation = { __typename?: 'Mutation', deleteOtherDocument: { __typename?: 'OtherDocument', id: string } };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: { __typename?: 'Order', id: string } };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'Contract', id: string, title: string, type: ContractTypeEnum } };

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'Contract', id: string } };

export type DeleteContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: { __typename?: 'Contract', id: string } };

export type DeleteUploadedFileMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUploadedFileMutation = { __typename?: 'Mutation', deleteUploadedFile: boolean };

export type CreateExternalLinkMutationVariables = Exact<{
  input: CreateExternalLinkInput;
}>;


export type CreateExternalLinkMutation = { __typename?: 'Mutation', createExternalLink: { __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType } };

export type UpdateExternalLinkMutationVariables = Exact<{
  input: UpdateExternalLinkInput;
}>;


export type UpdateExternalLinkMutation = { __typename?: 'Mutation', updateExternalLink: { __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType } };

export type DeleteExternalLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExternalLinkMutation = { __typename?: 'Mutation', deleteExternalLink?: boolean | undefined | null };

export type ExternalLinkFragmentFragment = { __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType };

export type AllExternalLinksQueryVariables = Exact<{
  model_type?: InputMaybe<ExternalLinkType>;
}>;


export type AllExternalLinksQuery = { __typename?: 'Query', externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }> };

export type ProjectExternalLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectExternalLinksQuery = { __typename?: 'Query', project?: { __typename?: 'Project', externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }> } | undefined | null };

export type BrandExternalLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BrandExternalLinksQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }> } | undefined | null };

export type ExternalLinksFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalLinksFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string }>, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }> };

export type BudgetItemPlannedExpensesForCreateExpenseQueryVariables = Exact<{
  budgetItemId: Scalars['ID']['input'];
  budgetItemType: ExpenseBudgetItemTypeEnum;
}>;


export type BudgetItemPlannedExpensesForCreateExpenseQuery = { __typename?: 'Query', budgetItemPlannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }> };

export type CreateExpenseMutationVariables = Exact<{
  input: CreateExpenseInput;
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | undefined | null, constant_symbol?: string | undefined | null, specific_symbol?: string | undefined | null, internal_number?: string | undefined | null, document_number?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, total_amount_includes_vat: boolean, user_created_date: string, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, has_master_agreement?: boolean | undefined | null, fond_contractor_id?: string | undefined | null, invoice_order_sequence_id?: string | undefined | null, legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, business_form?: BusinessFormEnum | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, exchange_rate?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, updated_at: string, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null } | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null, contractor?: { __typename?: 'Contractor', id: string } | undefined | null, contract?: { __typename?: 'Contract', id: string } | undefined | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | undefined | null, project_id?: string | undefined | null, amount_in_currency: number, amount_in_percent?: number | undefined | null, mandatory_id?: string | undefined | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, expense_item_description_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, custom_cost_ratio?: string | undefined | null, vat_amount_in_currency?: number | undefined | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | undefined | null, deleted: boolean } | undefined | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: string, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | undefined | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | undefined | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | undefined | null, tracked_time?: number | undefined | null, report_date?: string | undefined | null, task?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: string } | undefined | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | undefined | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } };

export type FindAddressForExpenseMutationVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAddressForExpenseMutation = { __typename?: 'Mutation', findAddressForExpense?: { __typename?: 'MapQuestAddress', street: string, city: string, zip: string, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null } | undefined | null };

export type UpdateExpenseMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = { __typename?: 'Mutation', updateExpense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | undefined | null, constant_symbol?: string | undefined | null, specific_symbol?: string | undefined | null, internal_number?: string | undefined | null, document_number?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, total_amount_includes_vat: boolean, user_created_date: string, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, has_master_agreement?: boolean | undefined | null, fond_contractor_id?: string | undefined | null, invoice_order_sequence_id?: string | undefined | null, legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, business_form?: BusinessFormEnum | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, exchange_rate?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, updated_at: string, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null } | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null, contractor?: { __typename?: 'Contractor', id: string } | undefined | null, contract?: { __typename?: 'Contract', id: string } | undefined | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | undefined | null, project_id?: string | undefined | null, amount_in_currency: number, amount_in_percent?: number | undefined | null, mandatory_id?: string | undefined | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, expense_item_description_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, custom_cost_ratio?: string | undefined | null, vat_amount_in_currency?: number | undefined | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | undefined | null, deleted: boolean } | undefined | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: string, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | undefined | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | undefined | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | undefined | null, tracked_time?: number | undefined | null, report_date?: string | undefined | null, task?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: string } | undefined | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | undefined | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } };

export type LockDocumentMutationVariables = Exact<{
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
}>;


export type LockDocumentMutation = { __typename?: 'Mutation', lockDocument: { __typename?: 'LockDocument', document_id: string } };

export type UnlockDocumentMutationVariables = Exact<{
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
}>;


export type UnlockDocumentMutation = { __typename?: 'Mutation', unlockDocument: { __typename?: 'LockDocument', document_id: string } };

export type ExpenseItemDescriptionFragment = { __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: string | undefined | null };

export type CreateExpenseItemDescriptionMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateExpenseItemDescriptionMutation = { __typename?: 'Mutation', createExpenseItemDescription?: { __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: string | undefined | null } | undefined | null };

export type UpdateExpenseItemDescriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateExpenseItemDescriptionMutation = { __typename?: 'Mutation', updateExpenseItemDescription?: { __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: string | undefined | null } | undefined | null };

export type DeleteExpenseItemDescriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExpenseItemDescriptionMutation = { __typename?: 'Mutation', deleteExpenseItemDescription?: boolean | undefined | null };

export type OurWorkBudgetItemByCodeFragment = { __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, project?: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | undefined | null, archived_at?: string | undefined | null, finished_at?: string | undefined | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } | undefined | null };

export type ExpenseBudgetItemByCodeFragment = { __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, project: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | undefined | null, archived_at?: string | undefined | null, finished_at?: string | undefined | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } };

export type ContractForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractForCreateExpenseQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, type: ContractTypeEnum, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> } | undefined | null };

export type ContractorForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractorForCreateExpenseQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, is_vat_payer?: boolean | undefined | null, business_form?: BusinessFormEnum | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null } | undefined | null };

export type DependenciesForCreateExpenseQueryVariables = Exact<{ [key: string]: never; }>;


export type DependenciesForCreateExpenseQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, code: string, denomination: number }> | undefined | null, vatRates?: Array<{ __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | undefined | null, id: string, amount: number }> | undefined | null, fondContractorsSimpleMap: Array<{ __typename?: 'FondContractorSimple', id: string, legal_name: string }>, accountingAccountsSimpleMap: Array<{ __typename?: 'AccountingAccount', id: string, title: string, account_number: string }>, paymentTypes: Array<{ __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: string | undefined | null }>, expenseItemDescriptions?: Array<{ __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: string | undefined | null } | undefined | null> | undefined | null };

export type ExpenseForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseForCreateExpenseQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | undefined | null, constant_symbol?: string | undefined | null, specific_symbol?: string | undefined | null, internal_number?: string | undefined | null, document_number?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, total_amount_includes_vat: boolean, user_created_date: string, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, has_master_agreement?: boolean | undefined | null, fond_contractor_id?: string | undefined | null, invoice_order_sequence_id?: string | undefined | null, legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, business_form?: BusinessFormEnum | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, exchange_rate?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, updated_at: string, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null } | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null, contractor?: { __typename?: 'Contractor', id: string } | undefined | null, contract?: { __typename?: 'Contract', id: string } | undefined | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | undefined | null, project_id?: string | undefined | null, amount_in_currency: number, amount_in_percent?: number | undefined | null, mandatory_id?: string | undefined | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, expense_item_description_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, custom_cost_ratio?: string | undefined | null, vat_amount_in_currency?: number | undefined | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | undefined | null, deleted: boolean } | undefined | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: string, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | undefined | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | undefined | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | undefined | null, tracked_time?: number | undefined | null, report_date?: string | undefined | null, task?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: string } | undefined | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | undefined | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } };

export type IsExpenseLockedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsExpenseLockedQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', lockedDocument?: { __typename?: 'LockDocument', locked_to: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null } };

export type GetExpenseUpdatedAtQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseUpdatedAtQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', updated_at: string } };

export type GetExpenseBudgetItemsByItemCodeQueryVariables = Exact<{
  item_code: Scalars['String']['input'];
}>;


export type GetExpenseBudgetItemsByItemCodeQuery = { __typename?: 'Query', expenseBudgetItemsByItemCode: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, project: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | undefined | null, archived_at?: string | undefined | null, finished_at?: string | undefined | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } }> };

export type GetOurWorkBudgetItemsByItemCodeQueryVariables = Exact<{
  item_code: Scalars['String']['input'];
}>;


export type GetOurWorkBudgetItemsByItemCodeQuery = { __typename?: 'Query', ourWorkBudgetItemsByItemCode: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, project?: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | undefined | null, archived_at?: string | undefined | null, finished_at?: string | undefined | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } | undefined | null }> };

export type ProjectForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForCreateExpenseQuery = { __typename?: 'Query', projectForExpense: { __typename?: 'ProjectForExpense', id: string, title: string, code: string, finished_at?: string | undefined | null, brand: { __typename?: 'BrandSimple', id: string }, team: { __typename?: 'Team', id: string, expense_cost_centre_id?: string | undefined | null }, expenses: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, item_code?: string | undefined | null, payment_status: ExpenseInvoiceStatusEnum, type: ExpenseBudgetItemType, completed_at?: string | undefined | null, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string }, stats: { __typename?: 'ExpenseBudgetItemStatsSimple', total_budget: number, planned_expenses: number, real_expenses: number } }>, ourWorkBudgetItems?: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, item_code?: string | undefined | null, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null }, stats: { __typename?: 'OurWorkBudgetItemStats', remaining_budget: number } }> | undefined | null } };

export type ContractorSelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ContractorQueryArgs>;
}>;


export type ContractorSelectOptionsQuery = { __typename?: 'Query', contractors?: { __typename?: 'ContractorPaginator', data: Array<{ __typename?: 'Contractor', id: string, legal_name: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type BillingEntitySelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BillingEntityQueryArgs>;
}>;


export type BillingEntitySelectOptionsQuery = { __typename?: 'Query', billingEntities?: { __typename?: 'BillingEntityPaginator', data: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string, street: string, city: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type GetExpensePredictionQueryVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type GetExpensePredictionQuery = { __typename?: 'Query', fetchOCRExpenseData?: { __typename?: 'OCRExpenseData', document_number?: string | undefined | null, for_approval?: boolean | undefined | null, type?: ExpenseTypeEnum | undefined | null, variable_symbol?: string | undefined | null, constant_symbol?: string | undefined | null, specific_symbol?: string | undefined | null, total_amount_includes_vat?: boolean | undefined | null, total_amount_with_vat_in_currency?: number | undefined | null, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, currency_id?: string | undefined | null, contractor_id?: string | undefined | null, legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, country_id?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, business_form?: BusinessFormEnum | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, expense_items?: Array<{ __typename?: 'OCRExpenseItemData', amount?: number | undefined | null, approved?: boolean | undefined | null, description?: string | undefined | null, vat_rate?: number | undefined | null }> | undefined | null } | undefined | null };

export type TaskPositionsForExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskPositionsForExpenseQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, positions: Array<{ __typename?: 'TaskPosition', id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }> } };

export type ExpenseBudgetItemPlannedExpenseFieldsFragment = { __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> };

export type ExpenseFragment = { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | undefined | null, constant_symbol?: string | undefined | null, specific_symbol?: string | undefined | null, internal_number?: string | undefined | null, document_number?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, total_amount_includes_vat: boolean, user_created_date: string, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, has_master_agreement?: boolean | undefined | null, fond_contractor_id?: string | undefined | null, invoice_order_sequence_id?: string | undefined | null, legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, business_form?: BusinessFormEnum | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, exchange_rate?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, updated_at: string, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null } | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null, contractor?: { __typename?: 'Contractor', id: string } | undefined | null, contract?: { __typename?: 'Contract', id: string } | undefined | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | undefined | null, project_id?: string | undefined | null, amount_in_currency: number, amount_in_percent?: number | undefined | null, mandatory_id?: string | undefined | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, expense_item_description_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, custom_cost_ratio?: string | undefined | null, vat_amount_in_currency?: number | undefined | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | undefined | null, deleted: boolean } | undefined | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: string, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | undefined | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | undefined | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | undefined | null, tracked_time?: number | undefined | null, report_date?: string | undefined | null, task?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: string } | undefined | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | undefined | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null };

export type ExpenseItemsListItemFragment = { __typename?: 'ExpenseItem', id: string, amount: number, amount_in_currency: number, mandatory_id?: string | undefined | null, brand_id?: string | undefined | null, project_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, budget_item_type: ExpenseBudgetItemTypeEnum, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string, account_number: string } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | undefined | null, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | undefined | null, project: { __typename?: 'Project', id: string } }>, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, invoice_status: ExpenseInvoiceStatusEnum, status: ExpenseStatusEnum, type: ExpenseTypeEnum, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, payment_status: PaymentStatusEnum, note?: string | undefined | null, internal_note?: string | undefined | null, workspace_company_id?: string | undefined | null, payment_type?: { __typename?: 'PaymentType', name: string } | undefined | null, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | undefined | null, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }> } };

export type ExpenseItemsListingQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExpenseItemsListingQuery = { __typename?: 'Query', expenseItemsForTimeBilling?: { __typename?: 'ExpenseItemPaginator', data: Array<{ __typename?: 'ExpenseItem', id: string, amount: number, amount_in_currency: number, mandatory_id?: string | undefined | null, brand_id?: string | undefined | null, project_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, budget_item_type: ExpenseBudgetItemTypeEnum, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string, account_number: string } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | undefined | null, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | undefined | null, project: { __typename?: 'Project', id: string } }>, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, invoice_status: ExpenseInvoiceStatusEnum, status: ExpenseStatusEnum, type: ExpenseTypeEnum, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, payment_status: PaymentStatusEnum, note?: string | undefined | null, internal_note?: string | undefined | null, workspace_company_id?: string | undefined | null, payment_type?: { __typename?: 'PaymentType', name: string } | undefined | null, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | undefined | null, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }> } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ExpenseItemsListingSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
}>;


export type ExpenseItemsListingSummaryQuery = { __typename?: 'Query', expenseItemsForTimeBillingSummary: { __typename?: 'TimeBillingSummary', allIds: Array<string>, count: number, amount: number } };

export type ExpenseItemsListingFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseItemsListingFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, title: string }> };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: { __typename?: 'Expense', id: string } };

export type MarkExpenseAsPaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkExpenseAsPaidMutation = { __typename?: 'Mutation', markExpenseAsPaid: { __typename?: 'Expense', id: string, paid_at?: string | undefined | null } };

export type MarkExpenseAsUnpaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
}>;


export type MarkExpenseAsUnpaidMutation = { __typename?: 'Mutation', markExpenseAsUnpaid: { __typename?: 'Expense', id: string, paid_at?: string | undefined | null } };

export type MarkExpenseAsPaidBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkExpenseAsPaidBulkMutation = { __typename?: 'Mutation', markExpenseAsPaidBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type CloneExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloneExpenseMutation = { __typename?: 'Mutation', cloneExpense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | undefined | null, constant_symbol?: string | undefined | null, specific_symbol?: string | undefined | null, internal_number?: string | undefined | null, document_number?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, total_amount_includes_vat: boolean, user_created_date: string, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, has_master_agreement?: boolean | undefined | null, fond_contractor_id?: string | undefined | null, invoice_order_sequence_id?: string | undefined | null, legal_name?: string | undefined | null, street?: string | undefined | null, city?: string | undefined | null, zip?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, business_form?: BusinessFormEnum | undefined | null, national_id?: string | undefined | null, iban?: string | undefined | null, swift?: string | undefined | null, exchange_rate?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, bank_account?: string | undefined | null, bank_account_code?: string | undefined | null, updated_at: string, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null } | undefined | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | undefined | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | undefined | null, contractor?: { __typename?: 'Contractor', id: string } | undefined | null, contract?: { __typename?: 'Contract', id: string } | undefined | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | undefined | null, project_id?: string | undefined | null, amount_in_currency: number, amount_in_percent?: number | undefined | null, mandatory_id?: string | undefined | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | undefined | null, accounting_vat_classification_id?: string | undefined | null, expense_item_description_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, custom_cost_ratio?: string | undefined | null, vat_amount_in_currency?: number | undefined | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | undefined | null, deleted: boolean } | undefined | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: string, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | undefined | null, date?: string | undefined | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | undefined | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | undefined | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | undefined | null, tracked_time?: number | undefined | null, report_date?: string | undefined | null, task?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: string } | undefined | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | undefined | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } };

export type BulkDeleteExpensesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDeleteExpensesMutation = { __typename?: 'Mutation', bulkDeleteExpenses: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type GetExpensesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type GetExpensesQuery = { __typename?: 'Query', expenses?: { __typename?: 'ExpensePaginator', data: Array<{ __typename?: 'Expense', id: string, invoice_status: ExpenseInvoiceStatusEnum, status: ExpenseStatusEnum, type: ExpenseTypeEnum, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, variable_symbol?: string | undefined | null, has_master_agreement?: boolean | undefined | null, workspace_company_id?: string | undefined | null, iban?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, paid_at?: string | undefined | null, user_created_date: string, is_draft: boolean, expense_no?: string | undefined | null, exchange_rate?: number | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string }>, stats: { __typename?: 'ExpenseStats', total_amount: number, total_amount_without_vat_in_currency: number, total_amount_with_vat_in_currency: number }, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, expenseItems: Array<{ __typename?: 'ExpenseItem', mandatory_id?: string | undefined | null, approved: boolean }>, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, amount: number, amount_in_move_currency: number, exchange_rate: number, bank_account_move_id: string, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } | undefined | null }> | undefined | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ExpensesTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type ExpensesTableSummaryQuery = { __typename?: 'Query', expensesSummary: { __typename?: 'ExpensesSummary', expenseIds?: Array<string> | undefined | null, expenses: number, total_amount: number, total_vat: number, total_amount_with_vat: number, payments_due: number, payments_due_vat: number, payments_due_without_vat: number, overdue_by_less_than_30_days: number, overdue_by_less_than_30_days_vat: number, overdue_by_less_than_30_days_without_vat: number, overdue_by_31_to_90_days: number, overdue_by_31_to_90_days_vat: number, overdue_by_31_to_90_days_without_vat: number, overdue_by_91_to_365_days: number, overdue_by_91_to_365_days_vat: number, overdue_by_91_to_365_days_without_vat: number, overdue_by_more_than_365_days: number, overdue_by_more_than_365_days_vat: number, overdue_by_more_than_365_days_without_vat: number } };

export type ExpensesTableSelectedSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type ExpensesTableSelectedSummaryQuery = { __typename?: 'Query', expensesSummary: { __typename?: 'ExpensesSummary', total_amount: number, total_amount_with_vat: number } };

export type GetExpenseTimeBillingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseTimeBillingsQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, expenseItems: Array<{ __typename?: 'ExpenseItem', id: string, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> } };

export type ExportExpensesSummaryQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExportExpensesSummaryQuery = { __typename?: 'Query', expenseSummaryExportBulk: string };

export type GenerateExpensePaymentOrderQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  type: ExpensePaymentOrderExportType;
  payment_type_id: Scalars['ID']['input'];
}>;


export type GenerateExpensePaymentOrderQuery = { __typename?: 'Query', generateExpensePaymentOrder: { __typename?: 'ExpensePaymentOrderResponse', url?: string | undefined | null, unprocessable_expense_ids?: Array<string> | undefined | null } };

export type ExpenseExportQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseExportQuery = { __typename?: 'Query', expenseExport: string };

export type ExpenseXmlExportQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseXmlExportQuery = { __typename?: 'Query', expenseXMLExport: string };

export type ExpenseOmegaExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpenseOmegaExportQuery = { __typename?: 'Query', omegaExpenseExport?: string | undefined | null };

export type ExpenseAbraFlexiSelectedExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpenseAbraFlexiSelectedExportQuery = { __typename?: 'Query', expenseAbraFlexiExport: string };

export type ExpensePremierExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpensePremierExportQuery = { __typename?: 'Query', expensePremierExport: string };

export type ExpenseFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, paymentTypes: Array<{ __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | undefined | null }> };

export type PohodaExpenseExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PohodaExpenseExportQuery = { __typename?: 'Query', pohodaExpenseExport?: string | undefined | null };

export type ExpenseAttachmentsExportBulkQueryVariables = Exact<{
  selectedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpenseAttachmentsExportBulkQuery = { __typename?: 'Query', ExpenseAttachmentsExport?: string | undefined | null };

export type VarioExpenseExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type VarioExpenseExportQuery = { __typename?: 'Query', varioExpenseExport?: string | undefined | null };

export type TransakcioExpenseExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TransakcioExpenseExportQuery = { __typename?: 'Query', transakcioExpenseExport?: string | undefined | null };

export type AccountingAccountOptionPartsFragment = { __typename?: 'AccountingAccount', id: string, title: string, account_number: string };

export type AllocationsColumnHeader_UserFragment = { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', valid_from: string, valid_to?: string | undefined | null, daily_capacity?: number | undefined | null, type: { __typename?: 'PlanningRangeType', value: PlanningRangeTypeEnum }, weekly_capacities?: { __typename?: 'WeeklyCapacities', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } | undefined | null }>, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null };

export type BillingEntityOptionPartsFragment = { __typename?: 'BillingEntity', id: string, internal_name: string, street: string, city: string };

export type BrandCreditAccountOptionPartsFragment = { __typename?: 'BrandCreditAccount', id: string, title: string };

export type BrandSimpleOptionPartsFragment = { __typename?: 'BrandSimple', id: string, name: string, code: string };

export type CapacityAllocationItemFragment = { __typename?: 'CapacityAllocationItem', id: string, date: string, from_time?: string | undefined | null, to_time?: string | undefined | null, note?: string | undefined | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | undefined | null, global?: boolean | undefined | null, time_off_duration_type?: TimeOffDurationTypeEnum | undefined | null, time_tracking_work_type_id?: string | undefined | null, completed: boolean, meetLink?: string | undefined | null, eventLink?: string | undefined | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | undefined | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | undefined | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null } };

export type ClientSimpleOptionPartsFragment = { __typename?: 'ClientSimple', id: string, name: string };

export type ContactOptionPartsFragment = { __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null };

export type CountrySimpleOptionPartsFragment = { __typename?: 'CountrySimple', id: string, name: string, code: string };

export type CurrencyOptionPartsFragment = { __typename?: 'Currency', id: string, code: string, denomination: number };

export type MediaModelPartsFragment = { __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } };

export type PaginatorInfoFragment = { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number };

export type PipedriveCustomFieldFragment = { __typename?: 'PipedriveCustomFieldValue', value?: string | undefined | null, customField: { __typename?: 'PipedriveCustomField', label?: string | undefined | null } };

export type ProjectSimpleOptionPartsFragment = { __typename?: 'ProjectSimple', id: string, title: string, code: string, brand_id: string };

export type UserSimpleOptionPartsFragment = { __typename?: 'UserSimple', id: string, full_name: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null };

export type UserTooltipFragment = { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null };

export type VatRateOptionPartsFragment = { __typename?: 'VatRate', id: string, amount: number };

export type IsDateBeforeLastPlanningUpdateMutationVariables = Exact<{
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type IsDateBeforeLastPlanningUpdateMutation = { __typename?: 'Mutation', isDateBeforeLastPlanningUpdate: boolean };

export type StopTimerForCapacityAllocationItemMutationVariables = Exact<{
  input: StopTimerForCapacityAllocationItemInput;
}>;


export type StopTimerForCapacityAllocationItemMutation = { __typename?: 'Mutation', stopTimerForCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string } };

export type UpdateAllocationItemDurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  total_time: Scalars['BigInt']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  user_id: Scalars['ID']['input'];
}>;


export type UpdateAllocationItemDurationMutation = { __typename?: 'Mutation', updateCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, total_time: number, to_time?: string | undefined | null } };

export type UpdateAllocationDurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  total_time: Scalars['BigInt']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  create_task_positions: Scalars['Boolean']['input'];
}>;


export type UpdateAllocationDurationMutation = { __typename?: 'Mutation', updateCapacityAllocation: { __typename?: 'CapacityAllocation', id: string, total_time: number, to_time?: string | undefined | null } };

export type CapacityAllocationItemTimeTrackingItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
}>;


export type CapacityAllocationItemTimeTrackingItemsQuery = { __typename?: 'Query', capacityAllocationItemTimeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_time: number, note?: string | undefined | null, is_locked: boolean, billable: boolean, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, task: { __typename?: 'Task', billable: boolean, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } } | undefined | null } };

export type ContractsSimpleQueryVariables = Exact<{
  contractorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ContractsSimpleQuery = { __typename?: 'Query', contractsSimpleMap?: Array<{ __typename?: 'ContractSimple', id: string, title: string }> | undefined | null };

export type ConvertAmountQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  workspaceCompanyId?: InputMaybe<Scalars['ID']['input']>;
  amount: Scalars['BigInt']['input'];
  currencyId: Scalars['ID']['input'];
  exchangeRate?: InputMaybe<Scalars['BigInt']['input']>;
  date: Scalars['Date']['input'];
  type: ExchangeRateSource;
}>;


export type ConvertAmountQuery = { __typename?: 'Query', convertAmountToWorkspaceCurrencyUsingExchangeRate?: { __typename?: 'ConvertedAmount', amount: number } | undefined | null };

export type GetExchangeRateQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  workspaceCompanyId?: InputMaybe<Scalars['ID']['input']>;
  currencyId: Scalars['ID']['input'];
  exchangeRate?: InputMaybe<Scalars['BigInt']['input']>;
  date: Scalars['Date']['input'];
  type: ExchangeRateSource;
}>;


export type GetExchangeRateQuery = { __typename?: 'Query', convertAmountToWorkspaceCurrencyUsingExchangeRate?: { __typename?: 'ConvertedAmount', exchange_rate: number } | undefined | null };

export type GetDuplicateExpensesIDsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  variableSymbol: Scalars['String']['input'];
  excludeExpenseId?: InputMaybe<Scalars['ID']['input']>;
  documentNumber: Scalars['String']['input'];
}>;


export type GetDuplicateExpensesIDsQuery = { __typename?: 'Query', getDuplicateExpensesIDs: Array<string> };

export type LatestExpenseInternalNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestExpenseInternalNumberQuery = { __typename?: 'Query', getLatestExpenseInternalNumberPerType: Array<{ __typename?: 'LatestExpenseInternalNumberPerType', type: ExpenseTypeEnum, internal_number?: string | undefined | null }> };

export type PlanningDailyViewPeopleQueryVariables = Exact<{
  dailyViewFilters: PlanningDailyViewFilters;
}>;


export type PlanningDailyViewPeopleQuery = { __typename?: 'Query', planningDailyViewPeople: { __typename?: 'PlanningDailyViewPaginator', last_updated_at?: string | undefined | null, data: Array<{ __typename?: 'PlanningDailyViewUserByDay', user: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', valid_from: string, valid_to?: string | undefined | null, daily_capacity?: number | undefined | null, type: { __typename?: 'PlanningRangeType', value: PlanningRangeTypeEnum }, weekly_capacities?: { __typename?: 'WeeklyCapacities', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } | undefined | null }>, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, items: Array<{ __typename?: 'PlanningDailyViewUserDay', capacity: number, workStatus: CapacityAllocationWorkStatus, date: string, holiday?: string | undefined | null, total_tracked_for_date: number, items?: Array<{ __typename?: 'CapacityAllocationItem', id: string, completed: boolean, type: CapacityAllocationTypeEnum, total_time: number, from_time?: string | undefined | null, to_time?: string | undefined | null, date: string, note?: string | undefined | null, global?: boolean | undefined | null, time_tracking_work_type_id?: string | undefined | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | undefined | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }, userStats?: { __typename?: 'CapacityAllocationUserItemStats', tracked_time_for_item?: number | undefined | null, has_running_timer: boolean } | undefined | null, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | undefined | null, task_id?: string | undefined | null, task_name?: string | undefined | null, task_status_id?: string | undefined | null, task_status_name?: string | undefined | null, task_status_system_status?: TaskSystemStatusEnum | undefined | null, task_status_background_color?: string | undefined | null, task_status_foreground_color?: string | undefined | null, our_work_budget_item_id?: string | undefined | null, our_work_budget_item_title?: string | undefined | null, project_id?: string | undefined | null, project_code?: string | undefined | null, project_title?: string | undefined | null, tracking_enabled?: boolean | undefined | null, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, time_off_type_id?: string | undefined | null, time_off_type_name?: string | undefined | null, time_off_type_affects_planning_capacity?: boolean | undefined | null, deadline?: string | undefined | null, deadline_time?: string | undefined | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | undefined | null, items_count: number, title?: string | undefined | null } | undefined | null }> | undefined | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type CapacityAllocationItemStatsFragment = { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | undefined | null, task_id?: string | undefined | null, task_name?: string | undefined | null, task_status_id?: string | undefined | null, task_status_name?: string | undefined | null, task_status_system_status?: TaskSystemStatusEnum | undefined | null, task_status_background_color?: string | undefined | null, task_status_foreground_color?: string | undefined | null, our_work_budget_item_id?: string | undefined | null, our_work_budget_item_title?: string | undefined | null, project_id?: string | undefined | null, project_code?: string | undefined | null, project_title?: string | undefined | null, tracking_enabled?: boolean | undefined | null, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, time_off_type_id?: string | undefined | null, time_off_type_name?: string | undefined | null, time_off_type_affects_planning_capacity?: boolean | undefined | null, deadline?: string | undefined | null, deadline_time?: string | undefined | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | undefined | null, items_count: number, title?: string | undefined | null };

export type ProjectsSimpleQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  orIdIn?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withProBono?: InputMaybe<Scalars['Boolean']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  my_projects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectsSimpleQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, team_id: string, title: string, brand_id: string, billable: boolean, type: ProjectTypeEnum, project_manager_id?: string | undefined | null }> };

export type TrackedForDayQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type TrackedForDayQuery = { __typename?: 'Query', timeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } }> };

export type UtilizationReportExportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UtilizationReportExportQuery = { __typename?: 'Query', utilizationReportExport: string };

export type UtilizationReportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
}>;


export type UtilizationReportQuery = { __typename?: 'Query', utilizationReport: { __typename?: 'UtilizationReportPaginator', data: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type UtilizationReportFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UtilizationReportFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type UtilizationReportGroupedByQueryVariables = Exact<{
  groupBy: UtilizationReportGroupBy;
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
  groupOrderBy?: InputMaybe<Array<UtilizationReportGroupOrderByClause> | UtilizationReportGroupOrderByClause>;
}>;


export type UtilizationReportGroupedByQuery = { __typename?: 'Query', utilizationReportGroups: { __typename?: 'UtilizationReportGroupPaginator', data: Array<{ __typename?: 'UtilizationReportGroup', group_title: string, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null }, items: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type UtilizationReportStatsQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UtilizationReportStatsQuery = { __typename?: 'Query', utilizationReportSummary: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null } };

export type UtilizationUserReportDataQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  userId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UtilizationUserReportDataQuery = { __typename?: 'Query', utilizationUserReport?: { __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null } } | undefined | null, utilizationTaskReport: Array<{ __typename?: 'UtilizationTaskReport', budgeted_time: number, budgeted_time_in_range?: number | undefined | null, remaining_amount?: number | undefined | null, remaining_time: number, remaining_time_in_range?: number | undefined | null, remaining_time_in_percent?: number | undefined | null, tracked_amount?: number | undefined | null, tracked_in_range_amount?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_percent?: number | undefined | null, tracked_time_in_range?: number | undefined | null, tracked_time_in_range_percent?: number | undefined | null, allocated_amount?: number | undefined | null, allocated_in_range_amount?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_percent?: number | undefined | null, allocated_time_in_range?: number | undefined | null, allocated_time_in_range_percent?: number | undefined | null, over_budget_amount?: number | undefined | null, over_budget_time?: number | undefined | null, over_budget_time_in_percent?: number | undefined | null, total_task_budget_amount?: number | undefined | null, total_task_budget_in_range?: number | undefined | null, task: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, foreground_color: string, background_color: string }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', title: string, id: string, code: string } } | undefined | null } }> };

export type TimeMaterialsBudgetItemFragmentFragment = { __typename?: 'TimeMaterialsBudgetItems', id: string, amount: number, invoiced: number, title: string, default_commission?: number | undefined | null, budget_category_id: string, data?: Array<{ __typename?: 'TimeMaterialsBudgetItemInvoiceData', id: string, name: string, tracked_time?: number | undefined | null, amount?: number | undefined | null } | undefined | null> | undefined | null };

export type TimeAndMaterialsInvoiceDataQueryVariables = Exact<{
  project_id: Scalars['ID']['input'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  filters?: InputMaybe<TimeMaterialsQueryArgs>;
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TimeAndMaterialsInvoiceDataQuery = { __typename?: 'Query', timeMaterialsInvoiceData: { __typename?: 'TimeMaterialsDataForInvoicing', project: { __typename?: 'Project', id: string, title: string }, ourWorkBudgetItems: Array<{ __typename?: 'TimeMaterialsBudgetItems', id: string, amount: number, invoiced: number, title: string, default_commission?: number | undefined | null, budget_category_id: string, data?: Array<{ __typename?: 'TimeMaterialsBudgetItemInvoiceData', id: string, name: string, tracked_time?: number | undefined | null, amount?: number | undefined | null } | undefined | null> | undefined | null }>, expenseBudgetItems: Array<{ __typename?: 'TimeMaterialsBudgetItems', id: string, amount: number, invoiced: number, title: string, default_commission?: number | undefined | null, budget_category_id: string, data?: Array<{ __typename?: 'TimeMaterialsBudgetItemInvoiceData', id: string, name: string, tracked_time?: number | undefined | null, amount?: number | undefined | null } | undefined | null> | undefined | null }> } };

export type TimeAndMaterialsFilterOptionsQueryVariables = Exact<{
  projectId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TimeAndMaterialsFilterOptionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type OutgoingInvoiceFormPartsFragment = { __typename?: 'OutgoingInvoice', id: string, vat_percent_informative?: number | undefined | null, vat_reverse_charge: boolean, old_invoice_alert_while_editing: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, type: OutgoingInvoiceTypeEnum, invoice_order_sequence_id: string, credit_note_outgoing_invoice_id?: string | undefined | null, invoice_no: string, issue_date: string, due_date: string, date_of_supply: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | undefined | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null }>, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | undefined | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | undefined | null } }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | undefined | null, amount_in_currency: number, unit_price?: number | undefined | null, quantity: number, accounting_account_id?: string | undefined | null, accounting_centre_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, vat_percent_informative?: number | undefined | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', our_work_budget_item_id: string, amount: number, amount_in_percent?: number | undefined | null }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', expense_budget_item_id: string, amount: number }>, prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', brand_credit_account_id: string, amount: number, amount_left: number }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | undefined | null, expense_ids?: Array<string> | undefined | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: string, to: string, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | undefined | null } | undefined | null, invoiceProofOfPayments: Array<{ __typename?: 'AttachedProofOfPaymentPivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingInvoice', id: string } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null };

export type ProformaInvoiceFormPartsFragment = { __typename?: 'OutgoingProformaInvoice', id: string, vat_percent_informative?: number | undefined | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, invoice_order_sequence_id: string, invoice_no: string, issue_date: string, due_date: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | undefined | null, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | undefined | null, amount_in_currency: number, unit_price?: number | undefined | null, quantity: number, accounting_account_id?: string | undefined | null, accounting_centre_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, vat_percent_informative?: number | undefined | null }>, ourWorkBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | undefined | null, amount?: number | undefined | null, amount_in_percent?: number | undefined | null }> | undefined | null, prepaymentSplits?: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | undefined | null, amount?: number | undefined | null }> | undefined | null, expenseBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | undefined | null, amount?: number | undefined | null }> | undefined | null, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null };

export type RfiFormPartsFragment = { __typename?: 'RequestForInvoicing', id: string, vat_percent_informative?: number | undefined | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, show_unit_price: boolean, show_billing_accounting: boolean, credit_note_outgoing_invoice_id?: string | undefined | null, type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, issue_date?: string | undefined | null, due_date?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> }, brands: Array<{ __typename?: 'Brand', id: string }>, owner?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null } | undefined | null, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null, contact?: { __typename?: 'Contact', id: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | undefined | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null }>, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | undefined | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | undefined | null }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | undefined | null, amount_in_currency: number, unit_price?: number | undefined | null, quantity: number, accounting_account_id?: string | undefined | null, accounting_centre_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, vat_percent_informative?: number | undefined | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | undefined | null, amount?: number | undefined | null, amount_in_percent?: number | undefined | null }>, prepaymentSplits: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | undefined | null, amount?: number | undefined | null }>, expenseBudgetSplits: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | undefined | null, amount?: number | undefined | null }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | undefined | null, expense_ids?: Array<string> | undefined | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: string, to: string, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | undefined | null } | undefined | null, proofOfPayments: Array<{ __typename?: 'OutgoingInvoice', id: string }> };

export type TimeMaterialsInvoiceDataFragmentFragment = { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | undefined | null, expense_ids?: Array<string> | undefined | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: string, to: string, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | undefined | null };

export type BudgetPositionFragment = { __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null };

export type ProofOfPaymentFragment = { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } };

export type CreateOutgoingInvoiceMutationVariables = Exact<{
  request_for_invoicing_id: Scalars['ID']['input'];
  invoice_no?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type CreateOutgoingInvoiceMutation = { __typename?: 'Mutation', createOutgoingInvoice: { __typename?: 'OutgoingInvoice', id: string } };

export type UpdateOutgoingInvoiceMutationVariables = Exact<{
  input: UpdateOutgoingInvoiceInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type UpdateOutgoingInvoiceMutation = { __typename?: 'Mutation', updateOutgoingInvoice: { __typename?: 'OutgoingInvoice', id: string } };

export type CreateProformaInvoiceMutationVariables = Exact<{
  request_for_invoicing_id: Scalars['ID']['input'];
  invoice_no: Scalars['ID']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type CreateProformaInvoiceMutation = { __typename?: 'Mutation', createOutgoingProformaInvoice: { __typename?: 'OutgoingProformaInvoice', id: string } };

export type UpdateProformaInvoiceMutationVariables = Exact<{
  input: UpdateOutgoingProformaInvoiceInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type UpdateProformaInvoiceMutation = { __typename?: 'Mutation', updateOutgoingProformaInvoice: { __typename?: 'OutgoingProformaInvoice', id: string } };

export type CreateRequestForInvoicingMutationVariables = Exact<{
  input: CreateRequestForInvoicingInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type CreateRequestForInvoicingMutation = { __typename?: 'Mutation', createRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string, workspace_bank_account_id?: string | undefined | null } };

export type UpdateRequestForInvoicingMutationVariables = Exact<{
  input: UpdateRequestForInvoicingInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type UpdateRequestForInvoicingMutation = { __typename?: 'Mutation', updateRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string, workspace_bank_account_id?: string | undefined | null } };

export type BasicDataQueryVariables = Exact<{
  type?: InputMaybe<Accounting_Account_Type>;
}>;


export type BasicDataQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, vatRates?: Array<{ __typename?: 'VatRate', deleted: boolean, id: string, amount: number }> | undefined | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, accountingAccountsSimpleMap: Array<{ __typename?: 'AccountingAccount', id: string, title: string, account_number: string }>, accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: string | undefined | null }>, invoicePaymentMethods: Array<{ __typename?: 'InvoicePaymentMethod', id: string, name: string }> };

export type GetTotalInWordsQueryVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  language: Scalars['String']['input'];
}>;


export type GetTotalInWordsQuery = { __typename?: 'Query', getTotalInWords: string };

export type BillingEntitiesDataQueryVariables = Exact<{
  client_id: Scalars['ID']['input'];
}>;


export type BillingEntitiesDataQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> } | undefined | null };

export type BrandsDataQueryVariables = Exact<{
  brand_ids: Scalars['Mixed']['input'];
  brandCount: Scalars['Int']['input'];
}>;


export type BrandsDataQuery = { __typename?: 'Query', brands?: { __typename?: 'BrandPaginator', data: Array<{ __typename?: 'Brand', id: string, name: string, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null, client: { __typename?: 'Client', id: string, name: string, workspaceCompany: { __typename?: 'WorkspaceCompany', vat_no?: string | undefined | null, id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, invoicePdfSettings?: { __typename?: 'WorkspaceCompanyInvoicePdfSettings', text_on_invoice?: string | undefined | null } | undefined | null, country?: { __typename?: 'Country', id: string } | undefined | null } }, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null }>, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, stats: { __typename?: 'BrandCreditAccountStats', id: string, total_debit: number, remaining_credit: number } }> | undefined | null }> } | undefined | null };

export type BulkConvertAmountQueryVariables = Exact<{
  items: Array<AmountToConvert> | AmountToConvert;
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BulkConvertAmountQuery = { __typename?: 'Query', bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates: Array<{ __typename?: 'ConvertedAmountWithIdentifier', amount: number, unit_price?: number | undefined | null, identifier: string }> };

export type DocumentsDataQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brand_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DocumentsDataQuery = { __typename?: 'Query', otherDocumentsWithPdf: Array<{ __typename?: 'OtherDocument', id: string, brands?: Array<{ __typename?: 'Brand', id: string } | undefined | null> | undefined | null, projects?: Array<{ __typename?: 'Project', id: string } | undefined | null> | undefined | null, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> }>, ordersWithPdf: Array<{ __typename?: 'Order', id: string, brand: { __typename?: 'Brand', id: string }, projects?: Array<{ __typename?: 'Project', id: string } | undefined | null> | undefined | null, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> }> };

export type PdfFileFragment = { __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } };

export type OutgoingInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, vat_percent_informative?: number | undefined | null, vat_reverse_charge: boolean, old_invoice_alert_while_editing: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, type: OutgoingInvoiceTypeEnum, invoice_order_sequence_id: string, credit_note_outgoing_invoice_id?: string | undefined | null, invoice_no: string, issue_date: string, due_date: string, date_of_supply: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | undefined | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null }>, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | undefined | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | undefined | null } }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | undefined | null, amount_in_currency: number, unit_price?: number | undefined | null, quantity: number, accounting_account_id?: string | undefined | null, accounting_centre_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, vat_percent_informative?: number | undefined | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', our_work_budget_item_id: string, amount: number, amount_in_percent?: number | undefined | null }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', expense_budget_item_id: string, amount: number }>, prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', brand_credit_account_id: string, amount: number, amount_left: number }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | undefined | null, expense_ids?: Array<string> | undefined | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: string, to: string, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | undefined | null } | undefined | null, invoiceProofOfPayments: Array<{ __typename?: 'AttachedProofOfPaymentPivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingInvoice', id: string } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } | undefined | null };

export type ProformaInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProformaInvoiceQuery = { __typename?: 'Query', outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, vat_percent_informative?: number | undefined | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, invoice_order_sequence_id: string, invoice_no: string, issue_date: string, due_date: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | undefined | null, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | undefined | null, amount_in_currency: number, unit_price?: number | undefined | null, quantity: number, accounting_account_id?: string | undefined | null, accounting_centre_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, vat_percent_informative?: number | undefined | null }>, ourWorkBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | undefined | null, amount?: number | undefined | null, amount_in_percent?: number | undefined | null }> | undefined | null, prepaymentSplits?: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | undefined | null, amount?: number | undefined | null }> | undefined | null, expenseBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | undefined | null, amount?: number | undefined | null }> | undefined | null, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } | undefined | null };

export type ProjectsDataQueryVariables = Exact<{
  project_ids: Scalars['Mixed']['input'];
  projectsCount: Scalars['Int']['input'];
}>;


export type ProjectsDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, start_date: string, finished_at?: string | undefined | null, archived_at?: string | undefined | null, billable: boolean, status: ProjectStatusEnum, type: ProjectTypeEnum, projectManager: { __typename?: 'User', id: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, team: { __typename?: 'Team', id: string, name: string }, brand: { __typename?: 'Brand', id: string }, stats?: { __typename?: 'ProjectStats', id: string, credit: number, uninvoiced: number } | undefined | null, lastInvoice?: { __typename?: 'ProjectInvoiceStat', outgoing_invoice_date: string, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, type: OutgoingInvoiceTypeEnum } } | undefined | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, name: string, total_budget: number, budget_category_id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, vat_percent_informative?: number | undefined | null, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, credit: number, uninvoiced: number }, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, tasks: Array<{ __typename?: 'Task', id: string, name: string, positionsSpent: Array<{ __typename?: 'PositionSpent', spent: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', stats: { __typename?: 'OurWorkBudgetItemStats', spent_budget: number } } | undefined | null }> }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, total_budget: number, budget_category_id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, vat_percent_informative?: number | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, credit: number, uninvoiced: number, real_expenses: number, real_commission: number, real_commission_relative: string, planned_expenses: number, planned_commission: number, planned_commission_relative_computed: string } }> }>, ordersSimpleMap: Array<{ __typename?: 'OrderSimple', id: string, purchase_order_no?: string | undefined | null }> }> } | undefined | null };

export type RequestForInvoicingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RequestForInvoicingQuery = { __typename?: 'Query', requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string, vat_percent_informative?: number | undefined | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, show_unit_price: boolean, show_billing_accounting: boolean, credit_note_outgoing_invoice_id?: string | undefined | null, type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, issue_date?: string | undefined | null, due_date?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | undefined | null }> }, brands: Array<{ __typename?: 'Brand', id: string }>, owner?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null } | undefined | null, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity?: { __typename?: 'BillingEntity', id: string } | undefined | null, contact?: { __typename?: 'Contact', id: string } | undefined | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | undefined | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null }>, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | undefined | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | undefined | null }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | undefined | null, amount_in_currency: number, unit_price?: number | undefined | null, quantity: number, accounting_account_id?: string | undefined | null, accounting_centre_id?: string | undefined | null, tag_ids?: Array<string> | undefined | null, vat_percent_informative?: number | undefined | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | undefined | null, amount?: number | undefined | null, amount_in_percent?: number | undefined | null }>, prepaymentSplits: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | undefined | null, amount?: number | undefined | null }>, expenseBudgetSplits: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | undefined | null, amount?: number | undefined | null }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | undefined | null, uninvoiced_time?: number | undefined | null, invoiced_amount?: number | undefined | null, total_invoiced_amount?: number | undefined | null, total_invoiced_time?: number | undefined | null, budgeted_amount?: number | undefined | null, budgeted_time?: number | undefined | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | undefined | null, tracked_amount?: number | undefined | null, tracked_time?: number | undefined | null, unit_amount?: number | undefined | null, quantity?: number | undefined | null }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | undefined | null, expense_ids?: Array<string> | undefined | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: string, to: string, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | undefined | null } | undefined | null, proofOfPayments: Array<{ __typename?: 'OutgoingInvoice', id: string }> } | undefined | null };

export type UnusedPaidProformaInvoicesQueryVariables = Exact<{
  project_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnusedPaidProformaInvoicesQuery = { __typename?: 'Query', unusedPaidOutgoingProformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | undefined | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | undefined | null }> };

export type ProformaInvoiceOptionsFragment = { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | undefined | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | undefined | null };

export type OrdersQueryVariables = Exact<{
  filters?: InputMaybe<OrderQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type OutgoingInvoiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceDetailQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, paid_at?: string | undefined | null, exchange_rate: number, type: OutgoingInvoiceTypeEnum, invoice_no: string, issue_date: string, due_date: string, date_of_supply: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, amount: number, exchange_rate: number, date: string, document_currency: { __typename?: 'Currency', code: string, denomination: number }, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } | undefined | null }> | undefined | null, teams: Array<{ __typename?: 'Team', name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string }> | undefined | null }>, billingEntity: { __typename?: 'BillingEntity', city: string, legal_name: string, street: string, zip: string, invoice_email?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, country: { __typename?: 'Country', id: string, name: string } }, contact?: { __typename?: 'Contact', first_name?: string | undefined | null, last_name?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', id: string, description?: string | undefined | null, amount_in_currency: number, vat_percent_informative?: number | undefined | null }>, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null, urls: { __typename?: 'MediaUrlList', preview?: string | undefined | null } }>, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, relatesToOutgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } | undefined | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number, total_vat_in_currency: number, vat_percent_informative?: number | undefined | null, total_amount_with_vat_in_currency_to_pay: number, total_amount_with_vat_in_currency_to_pay_from_proforma_payments: number }, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', our_work_budget_item_id: string, amount: number, amount_in_percent?: number | undefined | null }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', expense_budget_item_id: string, amount: number }>, prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', brand_credit_account_id: string, amount: number }>, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string, team: { __typename?: 'Team', id: string, name: string }, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, credit: number, uninvoiced: number } }> }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, real_expenses: number, planned_expenses: number, credit: number, real_commission: number, real_commission_relative: string, planned_commission: number, planned_commission_relative_computed: string } }> }> }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | undefined | null } }>, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null } | undefined | null, invoiceProofOfPayments: Array<{ __typename?: 'AttachedProofOfPaymentPivot', invoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, date_from: string, date_to: string, project: { __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | undefined | null } } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null } | undefined | null };

export type ProformaInvoiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProformaInvoiceDetailQuery = { __typename?: 'Query', outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, paid_at?: string | undefined | null, exchange_rate: number, invoice_no: string, issue_date: string, due_date: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, amount: number, exchange_rate: number, date: string, document_currency: { __typename?: 'Currency', code: string, denomination: number }, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } | undefined | null }> | undefined | null, teams: Array<{ __typename?: 'Team', name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string }> | undefined | null }>, billingEntity: { __typename?: 'BillingEntity', city: string, legal_name: string, street: string, zip: string, invoice_email?: string | undefined | null, registration_no?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, country: { __typename?: 'Country', id: string, name: string } }, contact?: { __typename?: 'Contact', first_name?: string | undefined | null, last_name?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', id: string, description?: string | undefined | null, amount_in_currency: number, vat_percent_informative?: number | undefined | null }>, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number, total_vat_in_currency: number, vat_percent_informative?: number | undefined | null, unused_amount_in_currency: number, unused_amount: number }, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string, team: { __typename?: 'Team', id: string, name: string }, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, credit: number, uninvoiced: number } }> }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, real_expenses: number, planned_expenses: number, credit: number, real_commission: number, real_commission_relative: string, planned_commission: number, planned_commission_relative_computed: string } }> }> }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | undefined | null } }>, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null } | undefined | null, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string }> | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null } | undefined | null };

export type EmailDataFragment = { __typename?: 'InvoiceEmailData', id: string, recipients: Array<string | undefined | null>, subject: string, content: string, attachments?: Array<{ __typename?: 'InvoiceEmailDataAttachment', id: string, link: string, name: string, required: boolean } | undefined | null> | undefined | null };

export type EmailLogFragment = { __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null };

export type OutgoingInvoiceCorePartsFragment = { __typename?: 'OutgoingInvoice', type: OutgoingInvoiceTypeEnum, invoice_no: string, issue_date: string, due_date: string, date_of_supply: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } };

export type OutgoingInvoiceNotePartsFragment = { __typename?: 'OutgoingInvoice', note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null };

export type ProformaInvoiceCorePartsFragment = { __typename?: 'OutgoingProformaInvoice', invoice_no: string, issue_date: string, due_date: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null };

export type ProformaInvoiceNotePartsFragment = { __typename?: 'OutgoingProformaInvoice', note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null };

export type DeleteOutgoingProformaInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOutgoingProformaInvoiceMutation = { __typename?: 'Mutation', deleteOutgoingProformaInvoice: boolean };

export type MarkProformaAsPaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  create_summary_invoice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkProformaAsPaidMutation = { __typename?: 'Mutation', markOutgoingProformaInvoiceAsPaid: { __typename?: 'OutgoingProformaInvoice', id: string } };

export type MarkProformaAsUnpaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
}>;


export type MarkProformaAsUnpaidMutation = { __typename?: 'Mutation', markOutgoingProformaInvoiceAsUnpaid: { __typename?: 'OutgoingProformaInvoice', id: string, paid_at?: string | undefined | null } };

export type SendProformaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendProformaMutation = { __typename?: 'Mutation', sendOutgoingProformaInvoice: boolean };

export type SendProformaBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendProformaBulkMutation = { __typename?: 'Mutation', sendOutgoingProformaInvoiceBulk: boolean };

export type SendOutgoingProformaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SendOutgoingProformaMutation = { __typename?: 'Mutation', sendOutgoingProformaInvoice: boolean };

export type BulkDownloadProformaInvoicesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDownloadProformaInvoicesQuery = { __typename?: 'Query', bulkDownloadOutgoingProformaInvoices?: string | undefined | null };

export type GetProformaEmailDataQueryVariables = Exact<{
  proforma_invoice_id: Scalars['ID']['input'];
}>;


export type GetProformaEmailDataQuery = { __typename?: 'Query', getProformaInvoiceEmailData?: { __typename?: 'InvoiceEmailData', id: string, recipients: Array<string | undefined | null>, subject: string, content: string, attachments?: Array<{ __typename?: 'InvoiceEmailDataAttachment', id: string, link: string, name: string, required: boolean } | undefined | null> | undefined | null } | undefined | null };

export type ProformaInvoicesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProformaInvoicesOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }> };

export type ProformaInvoicesTableDataQueryVariables = Exact<{
  filters?: InputMaybe<OiProformaQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProformaInvoicesTableDataQuery = { __typename?: 'Query', outgoingProformaInvoices?: { __typename?: 'OutgoingProformaInvoicePaginator', data: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, abraflexi_exported?: boolean | undefined | null, paid_at?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, workspace_company_id: string, exchange_rate: number, invoice_no: string, issue_date: string, due_date: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, summaryInvoices?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string }> | undefined | null, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null } | undefined | null, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null } | undefined | null }> | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, owner: { __typename?: 'User', id: string }, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, amount: number, amount_in_move_currency: number, bank_account_move_id: string, exchange_rate: number, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } | undefined | null }> | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProformaInvoicesTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<OiProformaQueryArgs>;
}>;


export type ProformaInvoicesTableSummaryQuery = { __typename?: 'Query', outgoingProformaInvoicesSummary: { __typename?: 'OutgoingProformaInvoicesSummary', outgoingInvoiceIds: Array<string>, invoices: number, total_amount: number, total_amount_with_vat: number, payments_due: number, overdue_by_less_than_30_days: number, overdue_by_31_to_90_days: number, overdue_by_91_to_365_days: number, overdue_by_more_than_365_days: number } };

export type ProformaOmegaExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProformaOmegaExportQuery = { __typename?: 'Query', omegaProformaExport?: string | undefined | null };

export type ProformaPohodaExportQueryVariables = Exact<{
  outgoingProformaInvoiceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProformaPohodaExportQuery = { __typename?: 'Query', pohodaOPIExport?: string | undefined | null };

export type ProformaPremierExportQueryVariables = Exact<{
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProformaPremierExportQuery = { __typename?: 'Query', premierProformaOIExport?: string | undefined | null };

export type RequestForInvoicingCorePartsFragment = { __typename?: 'RequestForInvoicing', type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, issue_date?: string | undefined | null, due_date?: string | undefined | null, date_of_supply?: string | undefined | null };

export type RequestForInvoicingNotePartsFragment = { __typename?: 'RequestForInvoicing', note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null };

export type DeleteRequestForInvoicingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRequestForInvoicingMutation = { __typename?: 'Mutation', deleteRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string } };

export type SubmitRequestForInvoicingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubmitRequestForInvoicingMutation = { __typename?: 'Mutation', submitRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string } };

export type DeleteRequestsForInvoicingBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteRequestsForInvoicingBulkMutation = { __typename?: 'Mutation', deleteRequestsForInvoicingBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type SubmitRequestsForInvoicingBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SubmitRequestsForInvoicingBulkMutation = { __typename?: 'Mutation', submitRequestsForInvoicingBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type GetRequestsForInvoicingQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
}>;


export type GetRequestsForInvoicingQuery = { __typename?: 'Query', requestsForInvoicingSummary: { __typename?: 'RequestsForInvoicingSummary', requestForInvoicingIds: Array<string> }, requestsForInvoicing?: { __typename?: 'RequestForInvoicingPaginator', data: Array<{ __typename?: 'RequestForInvoicing', id: string, type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, date_of_supply?: string | undefined | null, created_at: string, submit_date?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, stats: { __typename?: 'RequestForInvoicingStats', total_amount: number, total_amount_with_vat: number }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, owner?: { __typename?: 'User', id: string } | undefined | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type GetRequestsForInvoicingSummaryQueryVariables = Exact<{
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
}>;


export type GetRequestsForInvoicingSummaryQuery = { __typename?: 'Query', requestsForInvoicingSummary: { __typename?: 'RequestsForInvoicingSummary', requestForInvoicingIds: Array<string> } };

export type RequestsForInvoicingFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestsForInvoicingFiltersQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, brandsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type InvoiceBudgetItemListItemFragment = { __typename?: 'OIBudgetItemForTimeBilling', outgoing_invoice_id: string, budget_item_id: string, budget_item_type: BudgetItemTypeEnum, amount: number, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, date_of_supply: string, due_date: string, paid_at?: string | undefined | null, payment_status: PaymentStatusEnum, type: OutgoingInvoiceTypeEnum, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, has_proforma_payments: boolean, workspace_company_id: string, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | undefined | null, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string }, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | undefined | null, project: { __typename?: 'Project', id: string } } | undefined | null, documentExports: Array<{ __typename?: 'DocumentExport', id: string, type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', id: string, amount: number }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', id: string, amount: number }> } };

export type OutgoingInvoiceItemsListingQueryVariables = Exact<{
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
}>;


export type OutgoingInvoiceItemsListingQuery = { __typename?: 'Query', oiBudgetItemsForTimeBilling: { __typename?: 'OIBudgetItemsForTimeBillingPaginator', data: Array<{ __typename?: 'OIBudgetItemForTimeBilling', outgoing_invoice_id: string, budget_item_id: string, budget_item_type: BudgetItemTypeEnum, amount: number, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, date_of_supply: string, due_date: string, paid_at?: string | undefined | null, payment_status: PaymentStatusEnum, type: OutgoingInvoiceTypeEnum, note?: string | undefined | null, internal_note?: string | undefined | null, text_on_invoice?: string | undefined | null, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, has_proforma_payments: boolean, workspace_company_id: string, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | undefined | null, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string }, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | undefined | null, project: { __typename?: 'Project', id: string } } | undefined | null, documentExports: Array<{ __typename?: 'DocumentExport', id: string, type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', id: string, amount: number }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', id: string, amount: number }> } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type OutgoingInvoiceItemsListingSummaryQueryVariables = Exact<{
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
}>;


export type OutgoingInvoiceItemsListingSummaryQuery = { __typename?: 'Query', oiBudgetItemsForTimeBillingSummary: { __typename?: 'TimeBillingSummary', count: number, amount: number } };

export type OutgoingInvoiceItemsListingFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OutgoingInvoiceItemsListingFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }>, expenseBudgetItemsSimpleMap: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, category: { __typename?: 'ExpenseBudgetCategory', name: string } }> };

export type MarkOutgoingInvoiceAsPaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkOutgoingInvoiceAsPaidMutation = { __typename?: 'Mutation', markOutgoingInvoiceAsPaid: { __typename?: 'OutgoingInvoice', id: string } };

export type MarkOutgoingInvoiceAsUnpaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
}>;


export type MarkOutgoingInvoiceAsUnpaidMutation = { __typename?: 'Mutation', markOutgoingInvoiceAsUnpaid: { __typename?: 'OutgoingInvoice', id: string, paid_at?: string | undefined | null } };

export type MarkOutgoingInvoiceAsPaidBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkOutgoingInvoiceAsPaidBulkMutation = { __typename?: 'Mutation', markOutgoingInvoiceAsPaidBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type SendOutgoingInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SendOutgoingInvoiceMutation = { __typename?: 'Mutation', sendOutgoingInvoice: boolean };

export type SendOutgoingInvoiceBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendOutgoingInvoiceBulkMutation = { __typename?: 'Mutation', sendOutgoingInvoiceBulk: boolean };

export type UpdateOutgoingInvoiceNumberMutationVariables = Exact<{
  input?: InputMaybe<UpdateOutgoingInvoiceNumberInput>;
}>;


export type UpdateOutgoingInvoiceNumberMutation = { __typename?: 'Mutation', updateOutgoingInvoiceNumber: { __typename?: 'OutgoingInvoice', id: string } };

export type DeleteOutgoingInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOutgoingInvoiceMutation = { __typename?: 'Mutation', deleteOutgoingInvoice: boolean };

export type GetOutgoingInvoicesFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutgoingInvoicesFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }> };

export type GetInvoiceEmailDataQueryVariables = Exact<{
  outgoing_invoice_id: Scalars['ID']['input'];
}>;


export type GetInvoiceEmailDataQuery = { __typename?: 'Query', getInvoiceEmailData?: { __typename?: 'InvoiceEmailData', id: string, recipients: Array<string | undefined | null>, subject: string, content: string, attachments?: Array<{ __typename?: 'InvoiceEmailDataAttachment', id: string, link: string, name: string, required: boolean } | undefined | null> | undefined | null } | undefined | null };

export type GetOutgoingInvoiceSuggestedNumberQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetOutgoingInvoiceSuggestedNumberQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', sequence?: { __typename?: 'Sequence', next_invoice_no: string } | undefined | null } | undefined | null };

export type GetOutgoingInvoicesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OiQueryArgs>;
}>;


export type GetOutgoingInvoicesQuery = { __typename?: 'Query', outgoingInvoices?: { __typename?: 'OutgoingInvoicePaginator', data: Array<{ __typename?: 'OutgoingInvoice', id: string, paid_at?: string | undefined | null, note?: string | undefined | null, internal_note?: string | undefined | null, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, workspace_company_id: string, exchange_rate: number, has_proforma_payments: boolean, type: OutgoingInvoiceTypeEnum, invoice_no: string, issue_date: string, due_date: string, date_of_supply: string, request_for_invoicing_created_date?: string | undefined | null, request_for_invoicing_submit_date?: string | undefined | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null } | undefined | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, relatesToOutgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | undefined | null, download?: string | undefined | null } | undefined | null } | undefined | null, owner: { __typename?: 'User', id: string, email: string }, contact?: { __typename?: 'Contact', email?: string | undefined | null } | undefined | null, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, billingEntity: { __typename?: 'BillingEntity', invoice_email?: string | undefined | null, internal_name: string, street: string, city: string }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, stats: { __typename?: 'OutgoingInvoiceStats', total_amount: number, total_amount_with_vat: number, total_amount_in_currency: number, total_amount_with_vat_in_currency: number, billing_amount: number, billing_amount_with_vat: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, amount: number, amount_in_move_currency: number, exchange_rate: number, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | undefined | null, amount: number, note: string, reference: string, vs?: string | undefined | null, ss?: string | undefined | null, ks?: string | undefined | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: string, balance: number, iban?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: string, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | undefined | null } | undefined | null }> | undefined | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | undefined | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type GetOutgoingInvoicePrepaymentSplitsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOutgoingInvoicePrepaymentSplitsQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', id: string, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null }> } | undefined | null };

export type CfExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CfExportQuery = { __typename?: 'Query', cfExport: string };

export type NotPaidOiExportQueryVariables = Exact<{
  filters?: InputMaybe<OiQueryArgs>;
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type NotPaidOiExportQuery = { __typename?: 'Query', notPaidOIExport: string };

export type ClientOiExportQueryVariables = Exact<{
  filters?: InputMaybe<OiQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ClientOiExportQuery = { __typename?: 'Query', clientOIExport: string };

export type MrpOiExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type MrpOiExportQuery = { __typename?: 'Query', mrpOIExport: string };

export type PohodaOiExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PohodaOiExportQuery = { __typename?: 'Query', pohodaOIExport?: string | undefined | null };

export type PremierOiExportQueryVariables = Exact<{
  outgoing_invoice_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PremierOiExportQuery = { __typename?: 'Query', premierOIExport?: string | undefined | null };

export type ProlucOiExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type ProlucOiExportQuery = { __typename?: 'Query', prolucOIExport?: string | undefined | null };

export type BulkDownloadOutgoingInvoicesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDownloadOutgoingInvoicesQuery = { __typename?: 'Query', bulkDownloadOutgoingInvoices?: string | undefined | null };

export type VarioOiExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type VarioOiExportQuery = { __typename?: 'Query', varioOIExport?: string | undefined | null };

export type OutgoingInvoiceOmegaExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OutgoingInvoiceOmegaExportQuery = { __typename?: 'Query', omegaExport?: string | undefined | null };

export type OutgoingInvoiceAbraFlexiExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OutgoingInvoiceAbraFlexiExportQuery = { __typename?: 'Query', abraFlexiOIExport?: string | undefined | null };

export type OutgoingInvoicesTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<OiQueryArgs>;
}>;


export type OutgoingInvoicesTableSummaryQuery = { __typename?: 'Query', outgoingInvoicesSummary: { __typename?: 'OutgoingInvoicesSummary', outgoingInvoiceIds: Array<string>, total_amount: number, total_vat: number, total_amount_with_vat: number, billing_amount: number, billing_amount_vat: number, billing_amount_with_vat: number, paid_amount: number, unpaid_amount: number, payments_due_without_vat: number, payments_due_vat: number, payments_due: number, overdue: number, overdue_vat: number, overdue_without_vat: number, overdue_by_less_than_30_days_without_vat: number, overdue_by_less_than_30_days_vat: number, overdue_by_less_than_30_days: number, overdue_by_31_to_90_days_without_vat: number, overdue_by_31_to_90_days_vat: number, overdue_by_31_to_90_days: number, overdue_by_91_to_365_days_without_vat: number, overdue_by_91_to_365_days_vat: number, overdue_by_91_to_365_days: number, overdue_by_more_than_365_days_without_vat: number, overdue_by_more_than_365_days_vat: number, overdue_by_more_than_365_days: number, invoices: number } };

export type InvoicePaymentMethodFragment = { __typename?: 'InvoicePaymentMethod', id: string, name: string };

export type ChangeOutgoingInvoiceDatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  date_of_supply: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ChangeOutgoingInvoiceDatesMutation = { __typename?: 'Mutation', changeOutgoingInvoiceDates?: boolean | undefined | null };

export type ChangeOutgoingProformaInvoiceDatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ChangeOutgoingProformaInvoiceDatesMutation = { __typename?: 'Mutation', changeOutgoingProformaInvoiceDates?: boolean | undefined | null };

export type ProjectBillingRowFragment = { __typename?: 'ProjectBilling', planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, billing_type: ProjectBillingTypeEnum, has_billing_plan: boolean, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, project: { __typename?: 'Project', id: string, code: string, title: string, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } }, items: Array<{ __typename?: 'ProjectBillingItem', id: string, planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, type?: ProjectBillingDocumentTypeEnum | undefined | null, invoice_no?: string | undefined | null, paid_at?: string | undefined | null, paid_amount: number, status: ProjectBillingItemStatusEnum, delivered: boolean, note?: string | undefined | null, item_type: ProjectBillingItemTypeEnum, invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | undefined | null, billing_item_type?: BillingItemTypEnum | undefined | null, payment_status?: PaymentStatusEnum | undefined | null, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string } | undefined | null, outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string } | undefined | null, requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null }> };

export type ProjectBillingSubRowFragment = { __typename?: 'ProjectBillingItem', id: string, planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, type?: ProjectBillingDocumentTypeEnum | undefined | null, invoice_no?: string | undefined | null, paid_at?: string | undefined | null, paid_amount: number, status: ProjectBillingItemStatusEnum, delivered: boolean, note?: string | undefined | null, item_type: ProjectBillingItemTypeEnum, invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | undefined | null, billing_item_type?: BillingItemTypEnum | undefined | null, payment_status?: PaymentStatusEnum | undefined | null, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string } | undefined | null, outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string } | undefined | null, requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null };

export type ProjectBillingsSummaryFragmentFragment = { __typename?: 'ProjectBillingsSummary', total_paid_amount: number, total_unpaid_amount: number, total_planned_amount: number, total_planned_our_work: number, total_planned_prepayments: number, total_invoiced_amount: number, total_invoiced_our_work: number, total_invoiced_prepayments: number, total_planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, total_invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }> };

export type ProjectBillingsListQueryVariables = Exact<{
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectBillingsListQuery = { __typename?: 'Query', projectBillings?: { __typename?: 'ProjectBillingPaginator', data: Array<{ __typename?: 'ProjectBilling', planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, billing_type: ProjectBillingTypeEnum, has_billing_plan: boolean, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, project: { __typename?: 'Project', id: string, code: string, title: string, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } }, items: Array<{ __typename?: 'ProjectBillingItem', id: string, planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, issue_date?: string | undefined | null, date_of_supply?: string | undefined | null, due_date?: string | undefined | null, type?: ProjectBillingDocumentTypeEnum | undefined | null, invoice_no?: string | undefined | null, paid_at?: string | undefined | null, paid_amount: number, status: ProjectBillingItemStatusEnum, delivered: boolean, note?: string | undefined | null, item_type: ProjectBillingItemTypeEnum, invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | undefined | null, billing_item_type?: BillingItemTypEnum | undefined | null, payment_status?: PaymentStatusEnum | undefined | null, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string } | undefined | null, outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string } | undefined | null, requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectBillingsSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
}>;


export type ProjectBillingsSummaryQuery = { __typename?: 'Query', projectBillingsSummary: { __typename?: 'ProjectBillingsSummary', total_paid_amount: number, total_unpaid_amount: number, total_planned_amount: number, total_planned_our_work: number, total_planned_prepayments: number, total_invoiced_amount: number, total_invoiced_our_work: number, total_invoiced_prepayments: number, total_planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, total_invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }> } };

export type ProjectBillingsFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectBillingsFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type InvoicingPlanExportBasicQueryVariables = Exact<{
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
}>;


export type InvoicingPlanExportBasicQuery = { __typename?: 'Query', exportBillingPlan: string };

export type InvoicingPlanExportDetailedQueryVariables = Exact<{
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
}>;


export type InvoicingPlanExportDetailedQuery = { __typename?: 'Query', projectBillingsExport: string };

export type CreateBillingPlanMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CreateBillingPlanMutation = { __typename?: 'Mutation', createBillingPlan: Array<{ __typename?: 'BillingPlanByMonths', id: string }> };

export type UpdateBillingPlanMutationVariables = Exact<{
  input: UpdateBillingPlanInput;
}>;


export type UpdateBillingPlanMutation = { __typename?: 'Mutation', updateBillingPlan: Array<{ __typename?: 'BillingPlanByMonths', id: string }> };

export type ProjectBillingPlanDataQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectBillingPlanDataQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, start_date: string, expected_end_date?: string | undefined | null, stats?: { __typename?: 'ProjectStats', id: string, total_budget: number } | undefined | null, billingPlanByMonths: Array<{ __typename?: 'BillingPlanByMonths', id: string, period: string, invoiced_amount: number, items: Array<{ __typename?: 'BillingPlanItem', id: string, amount: number, date: string }> }> } | undefined | null };

export type InvoicingPlanAdvancedListFragment = { __typename?: 'BillingPlanBudgetCache', id: string, type: BillingPlanBudgetItemInvoiceTypeEnum, planned_amount: number, issue_date: string, date_of_supply: string, due_date: string, invoiced_amount: number, billing_plan_invoice_id?: string | undefined | null, invoice_no?: string | undefined | null, request_for_invoicing_id?: string | undefined | null, paid_amount: number, paid_at?: string | undefined | null, email_sent: boolean, created_at: string, updated_at: string, message?: string | undefined | null, status: BillingPlanBudgetCacheStatusEnum, project: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } };

export type CreateInvoiceFromBillingPlanMutationVariables = Exact<{
  input?: InputMaybe<CreateInvoiceFromBillingPlanInput>;
}>;


export type CreateInvoiceFromBillingPlanMutation = { __typename?: 'Mutation', createInvoiceFromBillingPlan: { __typename?: 'RequestForInvoicing', id: string } };

export type InvoicingPlanFutureListQueryVariables = Exact<{
  filters: BillingPlanCacheOverviewQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InvoicingPlanFutureListQuery = { __typename?: 'Query', billingPlanCacheOverview?: { __typename?: 'BillingPlanBudgetCachePaginator', data: Array<{ __typename?: 'BillingPlanBudgetCache', id: string, type: BillingPlanBudgetItemInvoiceTypeEnum, planned_amount: number, issue_date: string, date_of_supply: string, due_date: string, invoiced_amount: number, billing_plan_invoice_id?: string | undefined | null, invoice_no?: string | undefined | null, request_for_invoicing_id?: string | undefined | null, paid_amount: number, paid_at?: string | undefined | null, email_sent: boolean, created_at: string, updated_at: string, message?: string | undefined | null, status: BillingPlanBudgetCacheStatusEnum, project: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type InvoicingPlanFutureListSummaryQueryVariables = Exact<{
  filters: BillingPlanCacheOverviewQueryArgs;
}>;


export type InvoicingPlanFutureListSummaryQuery = { __typename?: 'Query', billingPlanCacheOverviewSummary: { __typename?: 'BillingPlanCacheOverviewSummary', projects: number, planned_amount: number, invoiced_amount: number, uninvoiced_amount: number } };

export type InvoicingPlanFutureListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoicingPlanFutureListFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type NotificationFragment = { __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | undefined | null, created_at?: string | undefined | null, read_at?: string | undefined | null, url?: string | undefined | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | undefined | null, created_at?: string | undefined | null, read_at?: string | undefined | null, url?: string | undefined | null } };

export type MarkNotificationAsUnreadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationAsUnreadMutation = { __typename?: 'Mutation', markNotificationAsUnread: { __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | undefined | null, created_at?: string | undefined | null, read_at?: string | undefined | null, url?: string | undefined | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>> | InputMaybe<NotificationGroup>>;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: boolean };

export type NotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>> | InputMaybe<NotificationGroup>>;
  type?: InputMaybe<NotificationType>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationPaginator', data: Array<{ __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | undefined | null, created_at?: string | undefined | null, read_at?: string | undefined | null, url?: string | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type UnreadNotificationsCountQueryVariables = Exact<{
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>> | InputMaybe<NotificationGroup>>;
}>;


export type UnreadNotificationsCountQuery = { __typename?: 'Query', unreadNotificationsCount: number };

export type TaskNotificationsNotificationFragment = { __typename?: 'Notification', id: string, message: string, type: NotificationType, read_at?: string | undefined | null, created_at?: string | undefined | null };

export type TaskNotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TaskNotificationsQuery = { __typename?: 'Query', taskAndCommunicationNotifications: { __typename?: 'TaskAndCommunicationNotificationsPaginator', data: Array<{ __typename?: 'NotificationPerTask', task: { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }, notifications: Array<{ __typename?: 'Notification', id: string, message: string, type: NotificationType, read_at?: string | undefined | null, created_at?: string | undefined | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type TaskNotificationsForScopedUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TaskNotificationsForScopedUserQuery = { __typename?: 'Query', taskAndCommunicationNotifications: { __typename?: 'TaskAndCommunicationNotificationsPaginator', data: Array<{ __typename?: 'NotificationPerTask', task: { __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }, notifications: Array<{ __typename?: 'Notification', id: string, message: string, type: NotificationType, read_at?: string | undefined | null, created_at?: string | undefined | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type BillingPlanFragment = { __typename?: 'BillingPlanBudget', id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type: BudgetItemTypeEnum, total_budget: number, title: string, billing_item_type: BillingItemTypEnum, category: { __typename?: 'BillingPlanBudgetItemCategory', id: string, name: string }, billingPlanBudgetItem?: Array<{ __typename?: 'BillingPlanBudgetItem', invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | undefined | null, day?: number | undefined | null, accounting_centre_id?: string | undefined | null, accounting_account_id?: string | undefined | null, months: Array<{ __typename?: 'BillingPlanMonth', value: number, date: string, billingPlanInvoice?: Array<{ __typename?: 'BillingPlanBudgetInvoice', amount: number, invoice_type: BillingPlanBudgetInvoiceTypeEnum, invoice_id: string, date: string } | undefined | null> | undefined | null }> }> | undefined | null };

export type BillingPlanSettingsProjectFragment = { __typename?: 'Project', title: string, code: string, start_date: string, expected_end_date?: string | undefined | null, brand: { __typename?: 'Brand', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', invoice_email?: string | undefined | null } | undefined | null }, contact?: { __typename?: 'Contact', email?: string | undefined | null } | undefined | null, projectManager: { __typename?: 'User', email: string }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', to: string, from: string, auto_send_invoice: boolean, auto_send_thank_you: boolean, auto_create_invoice: boolean, generate_invoice_items?: ProjectBillingPlanSettingGenerateInvoiceItemsEnum | undefined | null, billing_item_type: BillingItemTypEnum, vat_rate_id?: string | undefined | null, date_of_supply_from_issue_date?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, contact_id?: string | undefined | null, text_on_invoice?: string | undefined | null, internal_note?: string | undefined | null, note?: string | undefined | null, create_draft_invoice: boolean, order_id?: string | undefined | null, create_summary_invoice_after_payment: boolean, locked_at?: string | undefined | null, email_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | undefined | null, content?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null } | undefined | null, auto_send_thank_you_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | undefined | null, content?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null } | undefined | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null };

export type UpdateProjectBillingPlanMutationVariables = Exact<{
  input?: InputMaybe<UpdateProjectBillingPlanBudgetInput>;
}>;


export type UpdateProjectBillingPlanMutation = { __typename?: 'Mutation', updateProjectBillingPlanBudget: Array<{ __typename?: 'BillingPlanBudget', id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type: BudgetItemTypeEnum, total_budget: number, title: string, billing_item_type: BillingItemTypEnum, category: { __typename?: 'BillingPlanBudgetItemCategory', id: string, name: string }, billingPlanBudgetItem?: Array<{ __typename?: 'BillingPlanBudgetItem', invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | undefined | null, day?: number | undefined | null, accounting_centre_id?: string | undefined | null, accounting_account_id?: string | undefined | null, months: Array<{ __typename?: 'BillingPlanMonth', value: number, date: string, billingPlanInvoice?: Array<{ __typename?: 'BillingPlanBudgetInvoice', amount: number, invoice_type: BillingPlanBudgetInvoiceTypeEnum, invoice_id: string, date: string } | undefined | null> | undefined | null }> }> | undefined | null }> };

export type UpdateProjectBillingPlanSettingsMutationVariables = Exact<{
  input?: InputMaybe<UpdateProjectBillingPlanSettingsInput>;
}>;


export type UpdateProjectBillingPlanSettingsMutation = { __typename?: 'Mutation', updateProjectBillingPlanSettings: { __typename?: 'Project', title: string, code: string, start_date: string, expected_end_date?: string | undefined | null, brand: { __typename?: 'Brand', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', invoice_email?: string | undefined | null } | undefined | null }, contact?: { __typename?: 'Contact', email?: string | undefined | null } | undefined | null, projectManager: { __typename?: 'User', email: string }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', to: string, from: string, auto_send_invoice: boolean, auto_send_thank_you: boolean, auto_create_invoice: boolean, generate_invoice_items?: ProjectBillingPlanSettingGenerateInvoiceItemsEnum | undefined | null, billing_item_type: BillingItemTypEnum, vat_rate_id?: string | undefined | null, date_of_supply_from_issue_date?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, contact_id?: string | undefined | null, text_on_invoice?: string | undefined | null, internal_note?: string | undefined | null, note?: string | undefined | null, create_draft_invoice: boolean, order_id?: string | undefined | null, create_summary_invoice_after_payment: boolean, locked_at?: string | undefined | null, email_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | undefined | null, content?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null } | undefined | null, auto_send_thank_you_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | undefined | null, content?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null } | undefined | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } };

export type LockProjectBillingPlanMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type LockProjectBillingPlanMutation = { __typename?: 'Mutation', lockBillingPlanForProject?: { __typename?: 'Project', billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', locked_at?: string | undefined | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } | undefined | null };

export type BillingPlanQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  billingItemType: BillingItemTypEnum;
}>;


export type BillingPlanQuery = { __typename?: 'Query', billingPlanBudget: Array<{ __typename?: 'BillingPlanBudget', id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type: BudgetItemTypeEnum, total_budget: number, title: string, billing_item_type: BillingItemTypEnum, category: { __typename?: 'BillingPlanBudgetItemCategory', id: string, name: string }, billingPlanBudgetItem?: Array<{ __typename?: 'BillingPlanBudgetItem', invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | undefined | null, day?: number | undefined | null, accounting_centre_id?: string | undefined | null, accounting_account_id?: string | undefined | null, months: Array<{ __typename?: 'BillingPlanMonth', value: number, date: string, billingPlanInvoice?: Array<{ __typename?: 'BillingPlanBudgetInvoice', amount: number, invoice_type: BillingPlanBudgetInvoiceTypeEnum, invoice_id: string, date: string } | undefined | null> | undefined | null }> }> | undefined | null }> };

export type BillingPlanOptionsQueryVariables = Exact<{
  accountingCentreType: Accounting_Centre_Type;
}>;


export type BillingPlanOptionsQuery = { __typename?: 'Query', accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: string | undefined | null }> };

export type BillingPlanSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BillingPlanSettingsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', title: string, code: string, start_date: string, expected_end_date?: string | undefined | null, brand: { __typename?: 'Brand', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, defaultBillingEntity?: { __typename?: 'BillingEntity', invoice_email?: string | undefined | null } | undefined | null }, contact?: { __typename?: 'Contact', email?: string | undefined | null } | undefined | null, projectManager: { __typename?: 'User', email: string }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', to: string, from: string, auto_send_invoice: boolean, auto_send_thank_you: boolean, auto_create_invoice: boolean, generate_invoice_items?: ProjectBillingPlanSettingGenerateInvoiceItemsEnum | undefined | null, billing_item_type: BillingItemTypEnum, vat_rate_id?: string | undefined | null, date_of_supply_from_issue_date?: number | undefined | null, workspace_company_id?: string | undefined | null, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, contact_id?: string | undefined | null, text_on_invoice?: string | undefined | null, internal_note?: string | undefined | null, note?: string | undefined | null, create_draft_invoice: boolean, order_id?: string | undefined | null, create_summary_invoice_after_payment: boolean, locked_at?: string | undefined | null, email_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | undefined | null, content?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null } | undefined | null, auto_send_thank_you_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | undefined | null, content?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null } | undefined | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } | undefined | null, EmailTemplates: Array<{ __typename?: 'EmailTemplate', id: string, type: EmailTemplateTypeEnum, subject?: string | undefined | null, content?: string | undefined | null }>, vatRates?: Array<{ __typename?: 'VatRate', id: string, amount: number, deleted: boolean, default: boolean }> | undefined | null };

export type BillingPlanIssueInvoicesOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BillingPlanIssueInvoicesOptionsQuery = { __typename?: 'Query', vatRates?: Array<{ __typename?: 'VatRate', id: string, amount: number, default: boolean }> | undefined | null, project?: { __typename?: 'Project', brand: { __typename?: 'Brand', contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, email?: string | undefined | null }>, client: { __typename?: 'Client', billingEntities: Array<{ __typename?: 'BillingEntity', id: string, street: string, city: string, internal_name: string, applies_vat: boolean, invoice_email?: string | undefined | null, defaultCurrency: { __typename?: 'Currency', id: string, code: string } }>, currencyExchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, currency: { __typename?: 'Currency', id: string, code: string } }> } }, ordersSimpleMap: Array<{ __typename?: 'OrderSimple', id: string, purchase_order_no?: string | undefined | null }> } | undefined | null };

export type IsBillingPlanLockedQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type IsBillingPlanLockedQuery = { __typename?: 'Query', project?: { __typename?: 'Project', billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', locked_at?: string | undefined | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null } | undefined | null };

export type GetBudgetExceededQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type GetBudgetExceededQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projects?: { __typename?: 'ProjectPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, perPage: number, total: number, count: number, firstItem?: number | undefined | null, lastItem?: number | undefined | null, lastPage: number }, data: Array<{ __typename?: 'Project', id: string, title: string, code: string, billable: boolean, type: ProjectTypeEnum, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } }, projectManager: { __typename?: 'User', codename?: string | undefined | null, full_name: string, id: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, expenses: Array<{ __typename?: 'ExpenseBudgetItem', title: string, id: string, stats: { __typename?: 'ExpenseBudgetItemStats', planned_expenses: number, real_expenses: number, planned_commission: number, credit: number, total_budget: number, budget_exceeded: number, real_expenses_percent: number, real_commission: number, real_commission_relative: string, planned_commission_relative_computed: string, planned_profit: number } }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', credit: number, total_budget: number, spent_budget: number, budget_exceeded: number, spent_budget_percent: number, spent_time: number, invoiced_percent: number, remaining_budget: number, remaining_time: number } }>, stats?: { __typename?: 'ProjectStats', budget_exceeded: number } | undefined | null }> } | undefined | null };

export type UpdateProjectBudgetMutationVariables = Exact<{
  input: UpdateProjectBudgetInput;
}>;


export type UpdateProjectBudgetMutation = { __typename?: 'Mutation', updateProjectBudget: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, uses_budgetovac: boolean, finished_at?: string | undefined | null, type: ProjectTypeEnum, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | undefined | null, newer_final_version_available: boolean } | undefined | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', credit: number, total_budget: number } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, real_expenses: number, real_expenses_without_other: number, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, type: ExpenseBudgetItemType, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', real_expenses: number, credit: number, total_budget: number, planned_commission: number, planned_expenses: number } }> }>, stats?: { __typename?: 'ProjectStats', total_budget: number, credit: number, planned_commission: number, ourWork: { __typename?: 'ProjectOurWorkStats', total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', planned_expenses: number } } | undefined | null } };

export type ProjectForBudgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForBudgetQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, project?: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, uses_budgetovac: boolean, finished_at?: string | undefined | null, type: ProjectTypeEnum, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | undefined | null, newer_final_version_available: boolean } | undefined | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', credit: number, total_budget: number } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, real_expenses: number, real_expenses_without_other: number, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, type: ExpenseBudgetItemType, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', real_expenses: number, credit: number, total_budget: number, planned_commission: number, planned_expenses: number } }> }>, stats?: { __typename?: 'ProjectStats', total_budget: number, credit: number, planned_commission: number, ourWork: { __typename?: 'ProjectOurWorkStats', total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', planned_expenses: number } } | undefined | null } | undefined | null, projectDatesForBudgetChange: { __typename?: 'ProjectDatesForBudgetChange', lowestPossibleDateForBudgetChange: string, defaultDateForBudgetChange: string } };

export type ProjectForBudgetsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForBudgetsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, finished_at?: string | undefined | null, uses_budgetovac: boolean, code: string, numeric_code?: string | undefined | null, title: string, billable: boolean, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | undefined | null } | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } } | undefined | null };

export type BudgetInternalApproveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BudgetInternalApproveMutation = { __typename?: 'Mutation', budgetInternalApprove: { __typename?: 'Budget', id: string } };

export type ChangeBudgetAssignedAtMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type ChangeBudgetAssignedAtMutation = { __typename?: 'Mutation', changeBudgetAssignedAt: { __typename?: 'Budget', id: string, assignment_date?: string | undefined | null } };

export type BudgetGroupsForProjectsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BudgetGroupsForProjectsQuery = { __typename?: 'Query', budgetsForProject?: Array<{ __typename?: 'BudgetGroup', budget_name?: string | undefined | null, budget_number?: string | undefined | null, budgets?: Array<{ __typename?: 'Budget', id: string, project_id?: string | undefined | null, description?: string | undefined | null, account_manager?: string | undefined | null, assignment_date?: string | undefined | null, status: BudgetStatusEnum, internally_approved?: boolean | undefined | null, client_approved?: boolean | undefined | null, is_active?: boolean | undefined | null, version?: number | undefined | null, price?: number | undefined | null, temporary_project_id?: string | undefined | null, created_at: string, updated_at: string, project?: { __typename?: 'Project', id: string, title: string } | undefined | null, brand?: { __typename?: 'Brand', id: string, name: string } | undefined | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | undefined | null } | undefined | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | undefined | null, is_archived?: boolean | undefined | null } | undefined | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | undefined | null, quotes?: Array<{ __typename?: 'Quote', id: string, url: string, number: string }> | undefined | null } | undefined | null> | undefined | null }> | undefined | null };

export type ProjectTitleQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectTitleQuery = { __typename?: 'Query', project?: { __typename?: 'Project', lowestPossibleDateForStartDateChange?: string | undefined | null, code: string, numeric_code?: string | undefined | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } } | undefined | null };

export type GetProjectBudgetExceededCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectBudgetExceededCountQuery = { __typename?: 'Query', getActiveProjectBudgetExceededCount: number };

export type GetProjectUsesBudgetovacQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectUsesBudgetovacQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, uses_budgetovac: boolean, finished_at?: string | undefined | null } | undefined | null };

export type CreateProjectFromTemplateMutationVariables = Exact<{
  input: CreateProjectFromTemplateInput;
}>;


export type CreateProjectFromTemplateMutation = { __typename?: 'Mutation', createProjectFromTemplate: { __typename?: 'Project', id: string } };

export type GetBrandContactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBrandContactsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> } | undefined | null };

export type GetPmQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPmQuery = { __typename?: 'Query', user?: { __typename?: 'User', team?: { __typename?: 'Team', id: string } | undefined | null } | undefined | null };

export type RateCardsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RateCardsQuery = { __typename?: 'Query', projectRateCard: Array<{ __typename?: 'ProjectRateCard', id: string, name: string, currency_iso?: string | undefined | null } | undefined | null> };

export type GetProjectFromTemplateQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProjectFromTemplateQuery = { __typename?: 'Query', project?: { __typename?: 'Project', title: string, type: ProjectTypeEnum, start_date: string, billable: boolean, note?: string | undefined | null, rate_card_id?: string | undefined | null, categories: Array<{ __typename?: 'ProjectCategory', id: string }>, brand: { __typename?: 'Brand', id: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, team: { __typename?: 'Team', id: string }, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null } | undefined | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string } };

export type GetProjectCreateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectCreateDataQuery = { __typename?: 'Query', lowestDateWithOpenProgress?: string | undefined | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> };

export type ProjectDetailForClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDetailForClientQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, code: string, note?: string | undefined | null, status: ProjectStatusEnum, finished_at?: string | undefined | null, archived_at?: string | undefined | null, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, type: ProjectTypeEnum, start_date: string, expected_end_date?: string | undefined | null, externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }>, finishedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null, otherProjectManagers?: Array<{ __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> | undefined | null, contact?: { __typename?: 'Contact', id: string, phone?: string | undefined | null, email?: string | undefined | null, first_name?: string | undefined | null, last_name?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, projectManager: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, team: { __typename?: 'Team', name: string }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } } | undefined | null };

export type TasksForClientQueryVariables = Exact<{
  filters?: InputMaybe<TaskQueryArgs>;
}>;


export type TasksForClientQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', data: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> } | undefined | null };

export type OurWorkOverviewFragment = { __typename?: 'OurWorkOverviewBudgetItem', id: string, name: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | undefined | null, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, hidden: boolean, order: number, note?: string | undefined | null, deadline?: string | undefined | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | undefined | null, report_date?: string | undefined | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | undefined | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | undefined | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> }> };

export type ExpenseStructuredBudgetItemFragmentFragment = { __typename?: 'ExpenseBudgetItem', id: string, item_code?: string | undefined | null, title: string, type: ExpenseBudgetItemType, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', expense: { __typename?: 'Expense', status: ExpenseStatusEnum } }>, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, client_price: number, real_expenses: number, real_commission: number, planned_expenses: number, planned_commission: number, planned_profit: number, real_expenses_percent: number, real_commission_relative: string, planned_commission_relative_computed: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, profit: number, profit_percent: number } };

export type OurWorkBudgetItemOverviewTasksFragmentFragment = { __typename?: 'OurWorkBudgetItemOverview', tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> };

export type OurWorkBudgetItemOverviewFragmentFragment = { __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | undefined | null, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, hidden: boolean, order: number, note?: string | undefined | null, deadline?: string | undefined | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | undefined | null, report_date?: string | undefined | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | undefined | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | undefined | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> };

export type ProjectDetailPlannedExpenseFieldsFragment = { __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | undefined | null, date?: string | undefined | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null };

export type ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables = Exact<{
  input: CreateBudgetItemPlannedExpensesInput;
}>;


export type ProjectDetailCreateBudgetItemPlannedExpensesMutation = { __typename?: 'Mutation', createBudgetItemPlannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | undefined | null, date?: string | undefined | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null }> };

export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables = Exact<{
  items: Array<CreateBudgetItemPlannedExpensesInput> | CreateBudgetItemPlannedExpensesInput;
}>;


export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation = { __typename?: 'Mutation', createBudgetItemPlannedExpensesBulk: Array<Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | undefined | null, date?: string | undefined | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null }>> };

export type InvoiceProjectByCurrentMonthBillingPlanMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  type: RequestForInvoicingTypeEnum;
}>;


export type InvoiceProjectByCurrentMonthBillingPlanMutation = { __typename?: 'Mutation', invoiceProjectByCurrentMonthBillingPlan?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null };

export type ResetBillingPlanNotificationsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  type: BillingPlanNotificationTypeEnum;
}>;


export type ResetBillingPlanNotificationsMutation = { __typename?: 'Mutation', resetBillingPlanNotifications: { __typename?: 'Project', id: string, billingPlanNotifications?: { __typename?: 'BillingPlanNotifications', project_budget_changed: boolean, project_dates_changed: boolean } | undefined | null } };

export type UpdateOurWorkBudgetItemsMutationVariables = Exact<{
  budgetItems: Array<UpdateBudgetItem> | UpdateBudgetItem;
}>;


export type UpdateOurWorkBudgetItemsMutation = { __typename?: 'Mutation', updateOurWorkBudgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string }> };

export type CreateExpenseBudgetItemMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  expenseBudgetCategoryId: Scalars['ID']['input'];
}>;


export type CreateExpenseBudgetItemMutation = { __typename?: 'Mutation', createExpenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, item_code?: string | undefined | null, title: string, type: ExpenseBudgetItemType, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', expense: { __typename?: 'Expense', status: ExpenseStatusEnum } }>, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, client_price: number, real_expenses: number, real_commission: number, planned_expenses: number, planned_commission: number, planned_profit: number, real_expenses_percent: number, real_commission_relative: string, planned_commission_relative_computed: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, profit: number, profit_percent: number } } | undefined | null };

export type CreateOurWorkBudgetItemMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type CreateOurWorkBudgetItemMutation = { __typename?: 'Mutation', createOurWorkBudgetItem?: { __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | undefined | null, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, hidden: boolean, order: number, note?: string | undefined | null, deadline?: string | undefined | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | undefined | null, report_date?: string | undefined | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | undefined | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | undefined | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> } | undefined | null };

export type CreateTasksFromTemplateGroupMutationVariables = Exact<{
  ourWorkBudgetItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskTemplateGroupId: Scalars['ID']['input'];
}>;


export type CreateTasksFromTemplateGroupMutation = { __typename?: 'Mutation', createTasksFromTaskTemplateGroup: boolean };

export type OurWorkOverviewForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type OurWorkOverviewForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', ourWorkOverview: Array<{ __typename?: 'OurWorkOverviewBudgetItem', id: string, name: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | undefined | null, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, hidden: boolean, order: number, note?: string | undefined | null, deadline?: string | undefined | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | undefined | null, report_date?: string | undefined | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | undefined | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | undefined | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> }> }> } | undefined | null };

export type OurWorkOverviewDoneTasksForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OurWorkOverviewDoneTasksForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', ourWorkOverview: Array<{ __typename?: 'OurWorkOverviewBudgetItem', budgetItems: Array<{ __typename?: 'OurWorkBudgetItemOverview', id: string, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> }> }> } | undefined | null };

export type ProjectDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDetailQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | undefined | null, note?: string | undefined | null, status: ProjectStatusEnum, billable: boolean, is_pinned: boolean, is_starred: boolean, uses_budgetovac: boolean, finished_at?: string | undefined | null, archived_at?: string | undefined | null, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, billingPlanIsMissing: boolean, type: ProjectTypeEnum, start_date: string, expected_end_date?: string | undefined | null, is_template: boolean, currentMonthBillingPlanOutgoingInvoice: number, currentMonthBillingPlanOutgoingProformaInvoice: number, externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }>, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, billingPlanNotifications?: { __typename?: 'BillingPlanNotifications', project_dates_changed: boolean, project_budget_changed: boolean } | undefined | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | undefined | null, internally_approved?: boolean | undefined | null, newer_final_version_available: boolean } | undefined | null, budgetovacBudgets?: Array<{ __typename?: 'Budget', id: string, internally_approved?: boolean | undefined | null, is_active?: boolean | undefined | null }> | undefined | null, lastWorkInProgressProjectStat?: { __typename?: 'WorkInProgressProjectStat', progress_percent: number } | undefined | null, orders?: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null }> } | undefined | null, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }> | undefined | null, contact?: { __typename?: 'Contact', id: string, phone?: string | undefined | null, email?: string | undefined | null, first_name?: string | undefined | null, last_name?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, team: { __typename?: 'Team', id: string, name: string }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, statsCached?: { __typename?: 'ProjectStats', total_budget: number, invoiceable: number, uninvoiced: number, credit: number, credit_balance: number, credit_direct: number, credit_from_prepayments: number, unused_sum_from_proformas: number, over_invoiced: number, net_profit: number, net_margin_percent: number, gross_income: number, outgoing_invoice_amount: number, outgoing_invoice_paid: number, outgoing_proforma_invoice_amount: number, outgoing_proforma_invoice_paid: number, outgoing_proforma_invoice_settled: number, outgoing_proforma_invoice_unsettled: number, credit_from_unused_prepayments: number, ourWork: { __typename?: 'ProjectOurWorkStats', spent_time: number, remaining_time: number, total_time: number, total_budget: number, spent_budget: number, spent_budget_percent: number, remaining_budget: number, credit: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, all_items_completed: boolean, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenses: { __typename?: 'ProjectExpenseStats', total_budget: number, planned_expenses: number, planned_commission: number, planned_profit: number, planned_commission_relative_computed: string, real_expenses: number, real_commission: number, real_expenses_percent: number, real_commission_relative: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, all_items_completed: boolean } } | undefined | null, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budget_category_id: string, name: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, item_code?: string | undefined | null, title: string, type: ExpenseBudgetItemType, completed_at?: string | undefined | null, requested_for_deletion_at?: string | undefined | null, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', expense: { __typename?: 'Expense', status: ExpenseStatusEnum } }>, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, client_price: number, real_expenses: number, real_commission: number, planned_expenses: number, planned_commission: number, planned_profit: number, real_expenses_percent: number, real_commission_relative: string, planned_commission_relative_computed: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, profit: number, profit_percent: number } }> }>, invoiceStats: Array<{ __typename?: 'ProjectInvoiceStat', id: string }>, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string }>, prepaymentStats: Array<{ __typename?: 'ProjectPrepaymentStat', id: string }>, currentMonthBillingPlanStats: { __typename?: 'BillingPlanStats', current_month_planned: number, show_invoice_date_approaching_warning: boolean }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', project_id: string } | undefined | null, billingPlanByMonths: Array<{ __typename?: 'BillingPlanByMonths', id: string }>, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | undefined | null } | undefined | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | undefined | null, customField: { __typename?: 'PipedriveCustomField', label?: string | undefined | null } }> } | undefined | null };

export type ProjectGraphQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  ourWorkBudgetItemIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProjectGraphQuery = { __typename?: 'Query', projectGraph: { __typename?: 'ProjectGraph', totalBudgetData: Array<{ __typename?: 'DateIntegerDataPoint', date: string, amount: number }>, spentBudgetData: Array<{ __typename?: 'DateIntegerDataPoint', date: string, amount: number }> } };

export type ProjectDetailBudgetItemPlannedExpensesQueryVariables = Exact<{
  budgetItemId: Scalars['ID']['input'];
  budgetItemType: ExpenseBudgetItemTypeEnum;
}>;


export type ProjectDetailBudgetItemPlannedExpensesQuery = { __typename?: 'Query', budgetItemPlannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | undefined | null, date?: string | undefined | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null }> };

export type ProjectDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDocumentsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', code: string, numeric_code?: string | undefined | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } } | undefined | null };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
  propagate_billable: Scalars['Boolean']['input'];
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string } };

export type GetProjectEditDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectEditDataQuery = { __typename?: 'Query', lowestDateWithOpenProgress?: string | undefined | null, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, project?: { __typename?: 'Project', title: string, code: string, note?: string | undefined | null, start_date: string, expected_end_date?: string | undefined | null, billable: boolean, type: ProjectTypeEnum, finished_at?: string | undefined | null, uses_budgetovac: boolean, lowestPossibleDateForStartDateChange?: string | undefined | null, rate_card_id?: string | undefined | null, is_template: boolean, users: Array<{ __typename?: 'User', id: string }>, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, team: { __typename?: 'Team', id: string, name: string }, brand: { __typename?: 'Brand', id: string, name: string }, contact?: { __typename?: 'Contact', id: string } | undefined | null, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, tasks: Array<{ __typename?: 'Task', id: string }> }> }> } | undefined | null };

export type ClientsProjectListTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ClientsProjectListTableDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, users: Array<{ __typename?: 'User', full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, stats?: { __typename?: 'ProjectStats', invoiced_percent: number } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ClientsProjectListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientsProjectListFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | undefined | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type CloseWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloseWipMutation = { __typename?: 'Mutation', closeWip: { __typename?: 'WorkInProgressProjectStat', is_closed: boolean } };

export type CloseWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type CloseWipBulkMutation = { __typename?: 'Mutation', closeWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type LockWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LockWipMutation = { __typename?: 'Mutation', lockWip: { __typename?: 'WorkInProgressProjectStat', is_locked: boolean } };

export type LockWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type LockWipBulkMutation = { __typename?: 'Mutation', lockWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type OpenWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpenWipMutation = { __typename?: 'Mutation', openWip: { __typename?: 'WorkInProgressProjectStat', is_closed: boolean } };

export type OpenWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type OpenWipBulkMutation = { __typename?: 'Mutation', openWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type WipItemStatAffectedValuesFragment = { __typename?: 'WorkInProgressItemStat', progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number };

export type SubmitProgressMutationVariables = Exact<{
  input: SubmitProgressInput;
}>;


export type SubmitProgressMutation = { __typename?: 'Mutation', submitProgress: { __typename?: 'SubmitProgressResult', changedWorkInProgressItemStats: Array<{ __typename?: 'WorkInProgressItemStat', our_work_budget_item_id: string, work_in_progress_id: string, progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number }>, lastWorkInProgressProjectStat: { __typename?: 'WorkInProgressProjectStat', progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number } } };

export type SubmitProgressBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  progress: Scalars['BigInt']['input'];
}>;


export type SubmitProgressBulkMutation = { __typename?: 'Mutation', submitProgressBulk: Array<{ __typename?: 'OurWorkBudgetItem', id: string, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', id: string, work_in_progress_id: string, progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number } | undefined | null }> };

export type UnlockWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockWipMutation = { __typename?: 'Mutation', unlockWip: { __typename?: 'WorkInProgressProjectStat', is_locked: boolean } };

export type UnlockWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type UnlockWipBulkMutation = { __typename?: 'Mutation', unlockWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type ProjectProgressStatisticsExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  wip_period_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProjectProgressStatisticsExportQuery = { __typename?: 'Query', projectProgressStatisticsExport: string };

export type ProjectWipExportQueryVariables = Exact<{
  period_id: Scalars['ID']['input'];
}>;


export type ProjectWipExportQuery = { __typename?: 'Query', projectWipExport: string };

export type ProjectsCommissionExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ProjectsCommissionExportQuery = { __typename?: 'Query', projectsCommissionExport: string };

export type ProjectsWipFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsWipFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, roles: Array<{ __typename?: 'Role', id: string, name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, wipPeriodsMap: Array<{ __typename?: 'WipPeriod', id: string, title: string, starts_at: string, ends_at?: string | undefined | null, is_current: boolean }> };

export type ProjectsWipSummaryQueryVariables = Exact<{
  filters?: InputMaybe<WipQueryArgs>;
}>;


export type ProjectsWipSummaryQuery = { __typename?: 'Query', wipProjectsPeriodSummary: { __typename?: 'PeriodSummary', progress_change: number, progress_change_billable: number, profit_estimate: number, is_period_closed: boolean, is_period_locked: boolean, is_previous_period_closed?: boolean | undefined | null } };

export type ProjectsWipTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<WipQueryArgs>;
}>;


export type ProjectsWipTableDataQuery = { __typename?: 'Query', projectsWithPeriods?: { __typename?: 'WorkInProgressProjectStatPaginator', data: Array<{ __typename?: 'WorkInProgressProjectStat', id: string, total_budget: number, total_budget_change: number, spent_budget: number, spent_budget_percent: number, spent_time: number, remaining_budget: number, remaining_time: number, progress_percent: number, progress_change: number, progress_change_percent: number, profit_estimate: number, profit_estimate_percent: number, is_locked: boolean, is_closed: boolean, project: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, categories: Array<{ __typename?: 'ProjectCategory', name: string }> }, budgetItemsStats?: Array<{ __typename?: 'WorkInProgressItemStat', our_work_budget_item_id: string, work_in_progress_id: string, title: string, total_budget: number, spent_budget: number, spent_budget_percent: number, spent_time: number, remaining_budget: number, remaining_time: number, progress_percent: number, progress_change: number, progress_change_percent: number, profit_estimate: number, profit_estimate_percent: number, total_budget_change: number, is_locked: boolean, is_closed: boolean, deleted: boolean }> | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectsEffectivenessExportQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  startDate?: InputMaybe<DateRange>;
  finishedAt?: InputMaybe<DateRange>;
  dateOfSupply?: InputMaybe<DateRange>;
}>;


export type ProjectsEffectivenessExportQuery = { __typename?: 'Query', projectsEffectivenessExport: string };

export type MlggkProjectsEffectivenessExportQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  startDate?: InputMaybe<DateRange>;
  finishedAt?: InputMaybe<DateRange>;
  dateOfSupply?: InputMaybe<DateRange>;
}>;


export type MlggkProjectsEffectivenessExportQuery = { __typename?: 'Query', mlggkProjectsEffectivenessExport: string };

export type TriadProjectsEffectivenessExportQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type TriadProjectsEffectivenessExportQuery = { __typename?: 'Query', triadProjectsEffectivenessExport: string };

export type StarProjectMutationVariables = Exact<{
  project_id: Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type StarProjectMutation = { __typename?: 'Mutation', starProject: { __typename?: 'Star', id: string, starable_id: string, starable_type: StarsStarableTypeEnum, created_at: string, updated_at?: string | undefined | null } };

export type UnstarProjectMutationVariables = Exact<{
  project_id: Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type UnstarProjectMutation = { __typename?: 'Mutation', unstarProject: boolean };

export type BulkStarProjectsMutationVariables = Exact<{
  project_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type BulkStarProjectsMutation = { __typename?: 'Mutation', bulkStarProjects: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type BulkUnstarProjectsMutationVariables = Exact<{
  project_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type BulkUnstarProjectsMutation = { __typename?: 'Mutation', bulkUnstarProjects: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type FinishedProjectListTableDataSimpleQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type FinishedProjectListTableDataSimpleQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, is_pinned: boolean, is_starred: boolean, billable: boolean, is_template: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type FinishedProjectListTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type FinishedProjectListTableDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, note?: string | undefined | null, billable: boolean, is_pinned: boolean, is_starred: boolean, type: ProjectTypeEnum, finished_at?: string | undefined | null, archived_at?: string | undefined | null, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, is_template: boolean, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, stats: { __typename?: 'OurWorkBudgetItemStats', invoiced_percent: number, efficiency_percent: number, remaining_budget: number, net_margin_percent: number, net_profit: number } }>, expenses: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, category: { __typename?: 'ExpenseBudgetCategory', name: string }, stats: { __typename?: 'ExpenseBudgetItemStats', profit: number, profit_percent: number, invoiced_percent: number } }>, statsCached?: { __typename?: 'ProjectStats', id: string, profit: number, credit: number, unused_sum_from_proformas: number, net_profit: number, net_margin_percent: number, invoiced_percent: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, efficiency_percent: number, remaining_budget: number } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectListFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | undefined | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type ProjectListTableDataSimpleQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectListTableDataSimpleQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | undefined | null, is_pinned: boolean, is_starred: boolean, billable: boolean, is_template: boolean, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | undefined | null } | undefined | null, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectSubrowsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectSubrowsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number, progress: number, spent_time_estimate: number } | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, total_budget: number, spent_budget_percent: number, spent_budget: number, spent_time: number, budget_exceeded: number, credit_balance: number, invoiced_percent: number } }> } | undefined | null };

export type ProjectsSubrowsForPageQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectsSubrowsForPageQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number, progress: number, spent_time_estimate: number } | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, total_budget: number, spent_budget_percent: number, spent_budget: number, spent_time: number, budget_exceeded: number, credit_balance: number, invoiced_percent: number } }> }> } | undefined | null };

export type ProjectListTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectListTableDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | undefined | null, note?: string | undefined | null, billable: boolean, is_pinned: boolean, is_starred: boolean, type: ProjectTypeEnum, finished_at?: string | undefined | null, archived_at?: string | undefined | null, billingPlanIsMissing: boolean, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, is_template: boolean, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | undefined | null } | undefined | null, lastWorkInProgressProjectStat?: { __typename?: 'WorkInProgressProjectStat', progress_percent: number, progress: number, spent_time_estimate: number } | undefined | null, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | undefined | null, internally_approved?: boolean | undefined | null, newer_final_version_available: boolean } | undefined | null, budgetovacBudgets?: Array<{ __typename?: 'Budget', id: string, internally_approved?: boolean | undefined | null, is_active?: boolean | undefined | null }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string }>, ourWorkOverview: Array<{ __typename?: 'OurWorkOverviewBudgetItem', id: string, name: string, budget_exceeded: number }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, budget_exceeded: number }>, statsCached?: { __typename?: 'ProjectStats', id: string, budget_exceeded: number, credit_balance: number, invoiced_percent: number, total_budget: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, total_budget: number, spent_budget: number, spent_time: number, spent_budget_percent: number }, expenses: { __typename?: 'ProjectExpenseStats', id: string, all_items_completed: boolean, planned_expenses: number, planned_commission: number, planned_commission_relative_computed: string, real_expenses: number, real_commission: number, real_commission_relative: string } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectListTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectListTableSummaryQuery = { __typename?: 'Query', projectsSummary: { __typename?: 'ProjectsSummary', total_budget: number, our_work_total_budget: number, our_work_spent_budget: number, our_work_credit_balance: number, our_work_credit_proforma_balance: number, expenses_credit_balance: number, expenses_credit_proforma_balance: number, uninvoiced: number, proforma_uninvoiced: number, projectIds: Array<string>, real_expenses: number } };

export type FinishedProjectListTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type FinishedProjectListTableSummaryQuery = { __typename?: 'Query', projectsSummary: { __typename?: 'ProjectsSummary', projectIds: Array<string>, profit: number, net_profit: number, gross_income: number, net_margin_percent?: number | undefined | null, our_work_efficiency: number, credit: number } };

export type PlannedExpensesProjectFragment = { __typename?: 'PlannedExpensesProject', id: string, uninvoiced_amount: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, total_planned_budgeted_amount: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }, budget_items: Array<{ __typename?: 'PlannedExpensesBudgetItem', id: string, title: string, item_code?: string | undefined | null, category_name: string, buy_price: number, uninvoiced_amount: number, planned_client_amount: number, planned_budgeted_amount: number, expenses_received: number, expenses_received_percentage: number, invoiced_amount: number, invoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_budget: number, total_budgeted_with_commission: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number }> };

export type PlannedExpensesBudgetItemFragment = { __typename?: 'PlannedExpensesBudgetItem', id: string, title: string, item_code?: string | undefined | null, category_name: string, buy_price: number, uninvoiced_amount: number, planned_client_amount: number, planned_budgeted_amount: number, expenses_received: number, expenses_received_percentage: number, invoiced_amount: number, invoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_budget: number, total_budgeted_with_commission: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number };

export type PlannedExpensesSummaryFragment = { __typename?: 'PlannedExpensesSummary', uninvoiced_amount: number, uninvoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, planned_client_amount_percentage: number, total_planned_budgeted_amount: number, planned_budgeted_amount_percentage: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number };

export type PlannedExpensesOverviewQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
}>;


export type PlannedExpensesOverviewQuery = { __typename?: 'Query', plannedExpensesOverview?: { __typename?: 'PlannedExpensesProjectPaginator', data: Array<{ __typename?: 'PlannedExpensesProject', id: string, uninvoiced_amount: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, total_planned_budgeted_amount: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }, budget_items: Array<{ __typename?: 'PlannedExpensesBudgetItem', id: string, title: string, item_code?: string | undefined | null, category_name: string, buy_price: number, uninvoiced_amount: number, planned_client_amount: number, planned_budgeted_amount: number, expenses_received: number, expenses_received_percentage: number, invoiced_amount: number, invoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_budget: number, total_budgeted_with_commission: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type PlannedExpensesOverviewSummaryQueryVariables = Exact<{
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
}>;


export type PlannedExpensesOverviewSummaryQuery = { __typename?: 'Query', plannedExpensesOverviewSummary: { __typename?: 'PlannedExpensesSummary', uninvoiced_amount: number, uninvoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, planned_client_amount_percentage: number, total_planned_budgeted_amount: number, planned_budgeted_amount_percentage: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number } };

export type PlannedExpensesFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlannedExpensesFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, codename?: string | undefined | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, projectStages: Array<{ __typename?: 'ProjectStage', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }> };

export type GetProjectSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectSettingsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, uses_budgetovac: boolean, finished_at?: string | undefined | null, average_time_tracking_rate?: number | undefined | null, calculated_average_time_tracking_rate?: number | undefined | null, rate_card_id?: string | undefined | null, rate_card_exchange_rate: number, type: ProjectTypeEnum, code: string, numeric_code?: string | undefined | null, title: string, billable: boolean, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean } }>, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | undefined | null } | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } } | undefined | null };

export type UpdateTimeTrackingSettingsForProjectMutationVariables = Exact<{
  input: UpdateTimeTrackingSettingsInput;
}>;


export type UpdateTimeTrackingSettingsForProjectMutation = { __typename?: 'Mutation', updateTimeTrackingSettingsForProject: { __typename?: 'Project', ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean } }> } };

export type UpdateTimeTrackingRatesForProjectMutationVariables = Exact<{
  input: UpdateTimeTrackingRatesForProjectInput;
}>;


export type UpdateTimeTrackingRatesForProjectMutation = { __typename?: 'Mutation', updateTimeTrackingRatesForProject: { __typename?: 'Project', average_time_tracking_rate?: number | undefined | null, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }> } };

export type ChangeRateCardOnProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  rateCardId: Scalars['ID']['input'];
  exchangeRate?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type ChangeRateCardOnProjectMutation = { __typename?: 'Mutation', changeRateCardOnProject?: { __typename?: 'Project', rate_card_id?: string | undefined | null } | undefined | null };

export type DistributionModalTableItemFragment = { __typename?: 'TimeTrackingReport', id: string, tracked_for_date: string, user_full_name?: string | undefined | null, user_id?: string | undefined | null, task_name: string, task_id: string, our_work_budget_item_title: string, note?: string | undefined | null, tracked_time: number, billable: boolean, hourly_rate?: number | undefined | null, amount?: number | undefined | null };

export type DistributionModalTableDataQueryVariables = Exact<{
  first: Scalars['BigInt']['input'];
  page?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause> | TimeTrackingItemOrderByClause>;
}>;


export type DistributionModalTableDataQuery = { __typename?: 'Query', getTimeTrackingItems: { __typename?: 'GetTimeTrackingItemsPaginator', data: Array<{ __typename?: 'TimeTrackingReport', id: string, tracked_for_date: string, user_full_name?: string | undefined | null, user_id?: string | undefined | null, task_name: string, task_id: string, our_work_budget_item_title: string, note?: string | undefined | null, tracked_time: number, billable: boolean, hourly_rate?: number | undefined | null, amount?: number | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type DistributionModalFilterOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  userSimpleWhere?: InputMaybe<UsersWhereConditions>;
}>;


export type DistributionModalFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> };

export type TimeBillingExpenseItemsForModalQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TimeBillingExpenseItemsForModalQuery = { __typename?: 'Query', expenseItemsForTimeBilling?: { __typename?: 'ExpenseItemPaginator', data: Array<{ __typename?: 'ExpenseItem', id: string, amount: number, budget_item_type: ExpenseBudgetItemTypeEnum, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null }, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type TimeBillingOiBudgetItemsForModalQueryVariables = Exact<{
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
}>;


export type TimeBillingOiBudgetItemsForModalQuery = { __typename?: 'Query', oiBudgetItemsForTimeBilling: { __typename?: 'OIBudgetItemsForTimeBillingPaginator', data: Array<{ __typename?: 'OIBudgetItemForTimeBilling', outgoing_invoice_id: string, budget_item_id: string, budget_item_type: BudgetItemTypeEnum, amount: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } }, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type TimeBillingSourcesEditModalFilterOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type TimeBillingSourcesEditModalFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }>, expenseBudgetItemsSimpleMap: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, category: { __typename?: 'ExpenseBudgetCategory', name: string } }> };

export type ProjectTimeBillingUserRowPreviewFragment = { __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | undefined | null, time_tracking_work_type_id?: string | undefined | null, team_id?: string | undefined | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null };

export type ProjectTimeBillingUserRowFragment = { __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null };

export type ProjectTimeBillingSourcePreviewFragment = { __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null };

export type ProjectTimeBillingSourceFragment = { __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null };

export type ProjectTimeBillingComponentPreviewFragment = { __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | undefined | null, source_type?: TimeBillingSourceTypeEnum | undefined | null };

export type ProjectTimeBillingComponentFragment = { __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean };

export type ProjectTimeBillingComputedFragment = { __typename?: 'ProjectTimeBillingComputed', date_from: string, date_to: string, computed_total_amount: number, sources: Array<{ __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | undefined | null, source_type?: TimeBillingSourceTypeEnum | undefined | null }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | undefined | null, time_tracking_work_type_id?: string | undefined | null, team_id?: string | undefined | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string }> };

export type ProjectTimeBillingListItemFragment = { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } };

export type ProjectTimeBillingDistributionPreviewFragment = { __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, timeTrackingItem: { __typename?: 'TimeTrackingItem', tracked_for_date: string, tracked_time: number, note?: string | undefined | null, billable: boolean, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, task: { __typename?: 'Task', id: string, name: string } } };

export type ProjectTimeBillingDetailFragment = { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } };

export type CreateProjectTimeBillingMutationVariables = Exact<{
  input: CreateProjectTimeBillingInput;
}>;


export type CreateProjectTimeBillingMutation = { __typename?: 'Mutation', createProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type UpdateProjectTimeBillingMutationVariables = Exact<{
  input: UpdateProjectTimeBillingInput;
}>;


export type UpdateProjectTimeBillingMutation = { __typename?: 'Mutation', updateProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type LockProjectTimeBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LockProjectTimeBillingMutation = { __typename?: 'Mutation', lockProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type UnlockProjectTimeBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockProjectTimeBillingMutation = { __typename?: 'Mutation', unlockProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type DeleteProjectTimeBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectTimeBillingMutation = { __typename?: 'Mutation', deleteProjectTimeBilling: boolean };

export type CreateDataForProjectTimeBillingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type CreateDataForProjectTimeBillingQuery = { __typename?: 'Query', createDataForProjectTimeBilling: { __typename?: 'ProjectTimeBillingComputed', date_from: string, date_to: string, computed_total_amount: number, sources: Array<{ __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | undefined | null, source_type?: TimeBillingSourceTypeEnum | undefined | null }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | undefined | null, time_tracking_work_type_id?: string | undefined | null, team_id?: string | undefined | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string }> } };

export type ProjectTimeBillingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryProjectTimeBillingsOrderByOrderByClause> | QueryProjectTimeBillingsOrderByOrderByClause>;
}>;


export type ProjectTimeBillingsQuery = { __typename?: 'Query', projectTimeBillings?: { __typename?: 'ProjectTimeBillingPaginator', data: Array<{ __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, total: number, hasMorePages: boolean } } | undefined | null };

export type ProjectTimeBillingDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectTimeBillingDetailQuery = { __typename?: 'Query', projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, title?: string | undefined | null, date_from: string, date_to: string, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | undefined | null, is_locked: boolean, locked_at?: string | undefined | null, created_at: string, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } | undefined | null };

export type PreviewProjectTimeBillingQueryVariables = Exact<{
  input: PreviewProjectTimeBillingInput;
}>;


export type PreviewProjectTimeBillingQuery = { __typename?: 'Query', previewProjectTimeBilling: { __typename?: 'ProjectTimeBillingComputed', date_from: string, date_to: string, computed_total_amount: number, sources: Array<{ __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | undefined | null, outgoing_invoice_id?: string | undefined | null, budget_item_id?: string | undefined | null, budget_item_type?: BudgetItemTypeEnum | undefined | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null } | undefined | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, document_number?: string | undefined | null, date_of_supply?: string | undefined | null, note?: string | undefined | null, contractor?: { __typename?: 'Contractor', legal_name: string } | undefined | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | undefined | null } | undefined | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: string, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | undefined | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | undefined | null, source_type?: TimeBillingSourceTypeEnum | undefined | null }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | undefined | null, time_tracking_work_type_id?: string | undefined | null, team_id?: string | undefined | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } | undefined | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string }> } };

export type UpdateProjectTimeBreakdownItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  budgeted: Scalars['Int']['input'];
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateProjectTimeBreakdownItemMutation = { __typename?: 'Mutation', updateProjectTimeBreakdown: { __typename?: 'ProjectTimeBreakdown', id: string } };

export type TimeTrackingProjectReportQueryVariables = Exact<{
  filters?: InputMaybe<TimeTrackingProjectReportQueryArgs>;
}>;


export type TimeTrackingProjectReportQuery = { __typename?: 'Query', timeTrackingProjectReport?: Array<{ __typename?: 'TimeTrackingProjectReport', user_id?: string | undefined | null, team_id?: string | undefined | null, user_full_name?: string | undefined | null, tracked_time: number, amount: number, invoiced_amount: number, time_tracking_work_type_title?: string | undefined | null, group_tracked_time: number, group_amount: number, our_work_budget_item_title?: string | undefined | null, hourly_rate?: number | undefined | null, internal_hourly_rate?: number | undefined | null, image?: string | undefined | null, time_tracking_work_type_id?: string | undefined | null, our_work_budget_item_id?: string | undefined | null, personal_expense?: number | undefined | null, personal_profitability?: number | undefined | null, invoiced_personal_profitability?: number | undefined | null, billable_all: boolean, invoiced_seconds?: number | undefined | null, overserviced_seconds?: number | undefined | null, uninvoiced_seconds?: number | undefined | null } | undefined | null> | undefined | null };

export type ProjectOurWorkItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectOurWorkItemsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', uses_budgetovac: boolean, start_date: string, finished_at?: string | undefined | null, expected_end_date?: string | undefined | null, code: string, numeric_code?: string | undefined | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string }> } | undefined | null };

export type ProjectTimeBreakdownQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectTimeBreakdownQuery = { __typename?: 'Query', projectTimeBreakdowns: Array<{ __typename?: 'ProjectTimeBreakdownResponse', id: string, title: string, tracked_time: number, tracked_amount: number, budgeted: number, budgeted_time: number, personal_expenses: number, profit: number, time_breakdown: Array<{ __typename?: 'ProjectTimeBreakdownDetail', id: string, date_from?: string | undefined | null, date_to?: string | undefined | null, tracked_time: number, tracked_amount: number, budgeted: number, budgeted_time: number, personal_expenses: number, profit: number }> }> };

export type BrandTableDataFragment = { __typename?: 'BrandWithRevenueResult', id: string, name: string, gross_income_for_date_range: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null };

export type BrandReportOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandReportOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type BrandProfitAndRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitAndRevenueSummaryQuery = { __typename?: 'Query', brandRevenueSummary: { __typename?: 'BrandRevenueSummary', our_work_revenue_for_date_range: number, our_work_billings_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null } };

export type BrandProfitAndRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitAndRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, brandRevenue: { __typename?: 'BrandRevenue', result: Array<{ __typename?: 'BrandWithRevenueResult', gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, id: string, name: string, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | undefined | null }>, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | undefined | null }>, brands?: Array<{ __typename?: 'BrandWithRevenue', id: string, name: string, gross_income_for_date_range: number, gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | undefined | null }>, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | undefined | null }> }> | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type BrandProfitSummaryQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitSummaryQuery = { __typename?: 'Query', brandRevenueSummary: { __typename?: 'BrandRevenueSummary', our_work_revenue_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, profit_top_clients?: Array<{ __typename?: 'TopClient', name: string, total_value: number, brands: Array<{ __typename?: 'TopBrand', name: string, value: number }> }> | undefined | null } };

export type BrandProfitTableDataQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, brandRevenue: { __typename?: 'BrandRevenue', result: Array<{ __typename?: 'BrandWithRevenueResult', gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, id: string, name: string, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | undefined | null }>, brands?: Array<{ __typename?: 'BrandWithRevenue', id: string, name: string, gross_income_for_date_range: number, gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | undefined | null }> }> | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type BrandRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandRevenueSummaryQuery = { __typename?: 'Query', brandRevenueSummary: { __typename?: 'BrandRevenueSummary', our_work_billings_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, revenue_top_clients?: Array<{ __typename?: 'TopClient', name: string, total_value: number, brands: Array<{ __typename?: 'TopBrand', name: string, value: number }> }> | undefined | null } };

export type BrandRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, brandRevenue: { __typename?: 'BrandRevenue', result: Array<{ __typename?: 'BrandWithRevenueResult', total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, id: string, name: string, gross_income_for_date_range: number, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | undefined | null }>, brands?: Array<{ __typename?: 'BrandWithRevenue', id: string, name: string, gross_income_for_date_range: number, total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | undefined | null }> }> | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type ProfitAndLossReportColumnFragment = { __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number };

export type ProfitAndLossReportQueryVariables = Exact<{
  where?: InputMaybe<ProfitLossReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  rows: ProfitLossReportRows;
  columns?: InputMaybe<ProfitLossReportColumns>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  includeDraftExpenses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfitAndLossReportQuery = { __typename?: 'Query', profitLossReport: { __typename?: 'ProfitLossReportGroupPaginator', data: Array<{ __typename?: 'ProfitLossReportGroup', id: string, title: string, columns: Array<{ __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number }>, items: Array<{ __typename?: 'ProfitLossReport', id: string, title: string, columns: Array<{ __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number }> }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type ProfitAndLossReportSummaryQueryVariables = Exact<{
  where?: InputMaybe<ProfitLossReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  columns?: InputMaybe<ProfitLossReportColumns>;
  includeDraftExpenses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfitAndLossReportSummaryQuery = { __typename?: 'Query', profitLossReportSummary: { __typename?: 'ProfitLossReportSummary', data: Array<{ __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number }> } };

export type ProfitAndLossFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfitAndLossFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type ProjectTableDataFragment = { __typename?: 'ProjectWithRevenueItem', id: string, title: string, code: string, note?: string | undefined | null, finished_at?: string | undefined | null, archived_at?: string | undefined | null, status: ProjectStatusEnum, gross_income_for_date_range: number, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } };

export type UpdateProjectNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  isTemplate: Scalars['Boolean']['input'];
}>;


export type UpdateProjectNoteMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, note?: string | undefined | null } };

export type UpdateOwbiNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOwbiNoteMutation = { __typename?: 'Mutation', updateOurWorkBudgetItemNote: { __typename?: 'OurWorkBudgetItem', id: string, note?: string | undefined | null } };

export type UpdateExbiNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateExbiNoteMutation = { __typename?: 'Mutation', updateExpenseBudgetItemNote: { __typename?: 'ExpenseBudgetItem', id: string, note?: string | undefined | null } };

export type ProjectReportOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectReportOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type ProjectRevenueDetailQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type ProjectRevenueDetailQuery = { __typename?: 'Query', projectRevenueDetail: { __typename?: 'ProjectWithRevenue', ourWork: Array<{ __typename?: 'OurWorkBudgetItemWithRevenue', billings_for_date_range?: number | undefined | null, revenue_for_date_range?: number | undefined | null, ourWorkBudgetItem: { __typename?: 'OurWorkBudgetItem', id: string, title: string, note?: string | undefined | null, stats: { __typename?: 'OurWorkBudgetItemStats', net_profit: number, net_margin_percent: number } } }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItemWithRevenue', expenseBudgetCategory: { __typename?: 'ExpenseBudgetCategory', id: string, name: string }, budgetItems: Array<{ __typename?: 'ExpenseBudgetItemWithRevenue', billings_for_date_range?: number | undefined | null, profit_for_date_range?: number | undefined | null, expenseBudgetItem: { __typename?: 'ExpenseBudgetItem', completed_at?: string | undefined | null, id: string, type: ExpenseBudgetItemType, title: string, note?: string | undefined | null, category: { __typename?: 'ExpenseBudgetCategory', name: string }, stats: { __typename?: 'ExpenseBudgetItemStats', credit: number, profit: number, profit_percent: number, real_expenses: number } } }> }> } };

export type ProjectsReportExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type ProjectsReportExportQuery = { __typename?: 'Query', projectsProfitExport: string };

export type ProjectProfitAndRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitAndRevenueSummaryQuery = { __typename?: 'Query', projectRevenueSummary: { __typename?: 'ProjectRevenueSummary', our_work_revenue_for_date_range: number, our_work_billings_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null } };

export type ProjectProfitAndRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitAndRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, projectRevenue: { __typename?: 'ProjectRevenue', projects: Array<{ __typename?: 'ProjectWithRevenueItem', gross_profit_for_date_range: number, filtered_profit_share: number, total_profit_share: number, our_work_revenue_for_date_range: number, total_invoiced: number, our_work_billings_for_date_range: number, total_revenue_share: number, filtered_revenue_share: number, id: string, title: string, code: string, note?: string | undefined | null, finished_at?: string | undefined | null, archived_at?: string | undefined | null, status: ProjectStatusEnum, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | undefined | null }>, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | undefined | null }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type ProjectProfitSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitSummaryQuery = { __typename?: 'Query', projectRevenueSummary: { __typename?: 'ProjectRevenueSummary', our_work_revenue_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, profit_top_projects?: Array<{ __typename?: 'TopProject', title: string, total_value: number, our_work: { __typename?: 'OurWorkTopProject', value: number }, expense_budget_categories?: Array<{ __typename?: 'ExpenseBudgetCategoryTopProject', value: number, expense_budget_item_id: string } | undefined | null> | undefined | null }> | undefined | null } };

export type ProjectProfitTableDataQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, projectRevenue: { __typename?: 'ProjectRevenue', projects: Array<{ __typename?: 'ProjectWithRevenueItem', gross_profit_for_date_range: number, filtered_profit_share: number, total_profit_share: number, our_work_revenue_for_date_range: number, id: string, title: string, code: string, note?: string | undefined | null, finished_at?: string | undefined | null, archived_at?: string | undefined | null, status: ProjectStatusEnum, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | undefined | null }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type ProjectRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectRevenueSummaryQuery = { __typename?: 'Query', projectRevenueSummary: { __typename?: 'ProjectRevenueSummary', our_work_billings_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | undefined | null, revenue_top_projects?: Array<{ __typename?: 'TopProject', title: string, total_value: number, our_work: { __typename?: 'OurWorkTopProject', value: number }, expense_budget_categories?: Array<{ __typename?: 'ExpenseBudgetCategoryTopProject', value: number, expense_budget_item_id: string } | undefined | null> | undefined | null }> | undefined | null } };

export type ProjectRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, projectRevenue: { __typename?: 'ProjectRevenue', projects: Array<{ __typename?: 'ProjectWithRevenueItem', total_invoiced: number, total_revenue_share: number, filtered_revenue_share: number, our_work_billings_for_date_range: number, id: string, title: string, code: string, note?: string | undefined | null, finished_at?: string | undefined | null, archived_at?: string | undefined | null, status: ProjectStatusEnum, gross_income_for_date_range: number, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | undefined | null }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, projectManager: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type ProjectsAllQueryVariables = Exact<{
  filters?: InputMaybe<ProjectAllQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectsAllQuery = { __typename?: 'Query', projectsAll?: { __typename?: 'ProjectSimplePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }> } | undefined | null };

export type UserMonthlyReportDataQueryVariables = Exact<{
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
  first?: InputMaybe<Scalars['BigInt']['input']>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<UserMonthlyReportOrderByClause>;
}>;


export type UserMonthlyReportDataQuery = { __typename?: 'Query', userMonthlyReport: { __typename?: 'UserMonthlyReportPaginator', teams: Array<{ __typename?: 'Team', id: string, name: string, is_default: boolean, user_count: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'UserMonthlyReport', id: string, user_full_name: string, user_image?: string | undefined | null, total_tracked_time: number, tracked_time_per_team: Array<{ __typename?: 'UserMonthlyReportPerTeam', team_id: string, tracked_time: number, tracked_time_percentage: string }> }> } };

export type UserMonthlyReportExportQueryVariables = Exact<{
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
}>;


export type UserMonthlyReportExportQuery = { __typename?: 'Query', userMonthlyReportExport: string };

export type UserProfitReportFragment = { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, internal_cost?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null, combined_profit_amount?: number | undefined | null, budgeted_profit_amount?: number | undefined | null };

export type UserProfitUserFragment = { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null };

export type UserProfitReportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
}>;


export type UserProfitReportQuery = { __typename?: 'Query', utilizationReport: { __typename?: 'UtilizationReportPaginator', data: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, internal_cost?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null, combined_profit_amount?: number | undefined | null, budgeted_profit_amount?: number | undefined | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type UserProfitReportGroupedByQueryVariables = Exact<{
  groupBy: UtilizationReportGroupBy;
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
  groupOrderBy?: InputMaybe<Array<UtilizationReportGroupOrderByClause> | UtilizationReportGroupOrderByClause>;
}>;


export type UserProfitReportGroupedByQuery = { __typename?: 'Query', utilizationReportGroups: { __typename?: 'UtilizationReportGroupPaginator', data: Array<{ __typename?: 'UtilizationReportGroup', group_title: string, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, internal_cost?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null, combined_profit_amount?: number | undefined | null, budgeted_profit_amount?: number | undefined | null }, items: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | undefined | null, team?: { __typename?: 'Team', name: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, internal_cost?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null, combined_profit_amount?: number | undefined | null, budgeted_profit_amount?: number | undefined | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } };

export type UserProfitReportStatsQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UserProfitReportStatsQuery = { __typename?: 'Query', utilizationReportSummary: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | undefined | null, combined_time_billable?: number | undefined | null, budgeted_time?: number | undefined | null, budgeted_time_billable?: number | undefined | null, allocated_time?: number | undefined | null, allocated_time_billable?: number | undefined | null, tracked_time?: number | undefined | null, tracked_time_billable?: number | undefined | null, utilization_percentage?: number | undefined | null, utilization_percentage_billable?: number | undefined | null, internal_cost?: number | undefined | null, combined_amount_billable?: number | undefined | null, budgeted_amount_billable?: number | undefined | null, combined_profit_amount?: number | undefined | null, budgeted_profit_amount?: number | undefined | null } };

export type UserProfitReportExportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UserProfitReportExportQuery = { __typename?: 'Query', utilizationReportExport: string };

export type TaskUserFragment = { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null };

export type TaskPositionUserFragment = { __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } };

export type TaskBaseFragment = { __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, is_starred: boolean, billable: boolean, is_template: boolean, task_template_group_id?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, currentAssignee?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } } | undefined | null };

export type TaskScheduleFragment = { __typename?: 'Task', id: string, from?: string | undefined | null, to?: string | undefined | null, deadline?: string | undefined | null };

export type UpdateTaskCurrentAssigneeMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateTaskCurrentAssigneeMutation = { __typename?: 'Mutation', updateTaskCurrentAssignee: { __typename?: 'Task', id: string, currentAssignee?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }> } };

export type UpdateTaskAssigneesMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  positions: Array<TaskPositionInput> | TaskPositionInput;
}>;


export type UpdateTaskAssigneesMutation = { __typename?: 'Mutation', updateTaskAssignees: { __typename?: 'Task', id: string, currentAssignee?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null } };

export type UpdateTaskDeadlineMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateTaskDeadlineMutation = { __typename?: 'Mutation', updateTaskDeadline: { __typename?: 'Task', id: string, from?: string | undefined | null, to?: string | undefined | null, deadline?: string | undefined | null } };

export type UpdateTaskDurationMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateTaskDurationMutation = { __typename?: 'Mutation', updateTaskDuration: { __typename?: 'Task', id: string, from?: string | undefined | null, to?: string | undefined | null, deadline?: string | undefined | null } };

export type UpdateTaskBillableMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  billable: Scalars['Boolean']['input'];
  propagateBillable: Scalars['Boolean']['input'];
}>;


export type UpdateTaskBillableMutation = { __typename?: 'Mutation', updateTaskBillable: { __typename?: 'Task', id: string, billable: boolean } };

export type AddTaskAssigneeMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  position: TaskPositionInput;
}>;


export type AddTaskAssigneeMutation = { __typename?: 'Mutation', addTaskAssignee: { __typename?: 'Task', id: string, currentAssignee?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null } };

export type BoardTaskUserFragment = { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null };

export type BoardTaskFragment = { __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, is_starred: boolean, is_template: boolean, billable: boolean, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, currentAssignee?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null } | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, spent_time: number, user?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } } | undefined | null };

export type BoardSettingsFragment = { __typename?: 'TaskBoardSettings', board_key: string, hidden_columns: Array<string>, collapsed_columns: Array<string>, column_order: Array<string>, sort?: { __typename?: 'TaskBoardSort', column: string, direction: SortOrder } | undefined | null };

export type UpdateTaskBoardSettingsMutationVariables = Exact<{
  input: UpdateTaskBoardSettingsInput;
}>;


export type UpdateTaskBoardSettingsMutation = { __typename?: 'Mutation', updateTaskBoardSettings: { __typename?: 'TaskBoardSettings', board_key: string, hidden_columns: Array<string>, collapsed_columns: Array<string>, column_order: Array<string>, sort?: { __typename?: 'TaskBoardSort', column: string, direction: SortOrder } | undefined | null } };

export type MoveTaskOnBoardMutationVariables = Exact<{
  input: MoveTaskOnBoardInput;
}>;


export type MoveTaskOnBoardMutation = { __typename?: 'Mutation', moveTaskOnBoard: { __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, is_starred: boolean, billable: boolean, is_template: boolean, task_template_group_id?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, currentAssignee?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } } | undefined | null } };

export type TaskBoardColumnCountsQueryVariables = Exact<{
  filters: TaskQueryArgs;
  groupBy: TaskBoardGroupByEnum;
  groupValues?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeComplete?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TaskBoardColumnCountsQuery = { __typename?: 'Query', taskBoardColumnCounts: { __typename?: 'TaskBoardColumnCountPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TaskBoardColumnCount', group_value?: string | undefined | null, group_label?: string | undefined | null, total: number, spent_time: number, planned_time: number }> } };

export type TaskBoardColumnTasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TaskBoardColumnTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, is_starred: boolean, billable: boolean, is_template: boolean, task_template_group_id?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, currentAssignee?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, users: Array<{ __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | undefined | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } } | undefined | null }> } | undefined | null };

export type TaskBoardSettingsQueryVariables = Exact<{
  boardKey: Scalars['String']['input'];
}>;


export type TaskBoardSettingsQuery = { __typename?: 'Query', taskBoardSettings?: { __typename?: 'TaskBoardSettings', board_key: string, hidden_columns: Array<string>, collapsed_columns: Array<string>, column_order: Array<string>, sort?: { __typename?: 'TaskBoardSort', column: string, direction: SortOrder } | undefined | null } | undefined | null };

export type ListingClientTaskBaseFragment = { __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null };

export type ListingClientTaskFragment = { __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null };

export type ListingInternalTaskBaseFragment = { __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null };

export type ListingInternalTaskFragment = { __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null };

export type BulkTasksDeleteMutationVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkTasksDeleteMutation = { __typename?: 'Mutation', bulkDeleteTasks: boolean };

export type BulkTasksEditMutationVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  duplicateTasks: Scalars['Boolean']['input'];
  data: BulkEditTaskInput;
}>;


export type BulkTasksEditMutation = { __typename?: 'Mutation', bulkEditTasks: boolean };

export type ListingClientTasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingClientTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> } | undefined | null };

export type ListingInternalTasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingInternalTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | undefined | null, from?: string | undefined | null, to?: string | undefined | null, created_at?: string | undefined | null, deadline?: string | undefined | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> } | undefined | null };

export type AllTaskIdsQueryVariables = Exact<{
  filters: TaskQueryArgs;
}>;


export type AllTaskIdsQuery = { __typename?: 'Query', taskIds?: Array<string> | undefined | null };

export type PrepareTaskDataForBulkActionsQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  destinationBudgetItemId: Scalars['ID']['input'];
}>;


export type PrepareTaskDataForBulkActionsQuery = { __typename?: 'Query', prepareTaskDataForBulkActions: { __typename?: 'TaskBulkActionsData', has_subtasks: boolean, available_positions: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, unavailable_positions: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type BulkTasksOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BulkTasksOptionsQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', name: string, id: string }> };

export type TaskBasicInfoFragment = { __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null };

export type TaskExtendedInfoFragment = { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null }> | undefined | null };

export type TasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> } | undefined | null };

export type TasksForScopedUsersQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksForScopedUsersQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null }> } | undefined | null };

export type TasksFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TasksFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }>, taskPriorities: Array<{ __typename?: 'TaskPriority', name: string, id: string }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }> };

export type BudgetItemsFilterOptionsQueryVariables = Exact<{
  project_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BudgetItemsFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, item_code?: string | undefined | null }> };

export type CreateCapacityAllocationMutationVariables = Exact<{
  input: CreateCapacityAllocationInput;
}>;


export type CreateCapacityAllocationMutation = { __typename?: 'Mutation', createCapacityAllocation: { __typename?: 'CapacityAllocation', id: string } };

export type UpdateCapacityAllocationMutationVariables = Exact<{
  input: UpdateCapacityAllocationInput;
}>;


export type UpdateCapacityAllocationMutation = { __typename?: 'Mutation', updateCapacityAllocation: { __typename?: 'CapacityAllocation', id: string } };

export type UpdateCapacityAllocationForDayMutationVariables = Exact<{
  input: UpdateCapacityAllocationForDayInput;
}>;


export type UpdateCapacityAllocationForDayMutation = { __typename?: 'Mutation', UpdateCapacityAllocationForDay: { __typename?: 'CapacityAllocation', id: string } };

export type UpdateCapacityAllocationItemMutationVariables = Exact<{
  input: UpdateCapacityAllocationItemInput;
}>;


export type UpdateCapacityAllocationItemMutation = { __typename?: 'Mutation', updateCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string } };

export type CopyCapacityAllocationItemMutationVariables = Exact<{
  input: MoveCapacityAllocationItemInput;
}>;


export type CopyCapacityAllocationItemMutation = { __typename?: 'Mutation', copyCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, date: string, from_time?: string | undefined | null, to_time?: string | undefined | null, note?: string | undefined | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | undefined | null, global?: boolean | undefined | null, time_off_duration_type?: TimeOffDurationTypeEnum | undefined | null, time_tracking_work_type_id?: string | undefined | null, completed: boolean, meetLink?: string | undefined | null, eventLink?: string | undefined | null, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | undefined | null, task_id?: string | undefined | null, task_name?: string | undefined | null, task_status_id?: string | undefined | null, task_status_name?: string | undefined | null, task_status_system_status?: TaskSystemStatusEnum | undefined | null, task_status_background_color?: string | undefined | null, task_status_foreground_color?: string | undefined | null, our_work_budget_item_id?: string | undefined | null, our_work_budget_item_title?: string | undefined | null, project_id?: string | undefined | null, project_code?: string | undefined | null, project_title?: string | undefined | null, tracking_enabled?: boolean | undefined | null, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, time_off_type_id?: string | undefined | null, time_off_type_name?: string | undefined | null, time_off_type_affects_planning_capacity?: boolean | undefined | null, deadline?: string | undefined | null, deadline_time?: string | undefined | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | undefined | null, items_count: number, title?: string | undefined | null } | undefined | null, userItems: Array<{ __typename?: 'CapacityAllocationItem', id: string, date: string, from_time?: string | undefined | null, to_time?: string | undefined | null, note?: string | undefined | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | undefined | null, global?: boolean | undefined | null, time_off_duration_type?: TimeOffDurationTypeEnum | undefined | null, time_tracking_work_type_id?: string | undefined | null, completed: boolean, meetLink?: string | undefined | null, eventLink?: string | undefined | null, capacityAllocation: { __typename?: 'CapacityAllocation', id: string }, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | undefined | null, task_id?: string | undefined | null, task_name?: string | undefined | null, task_status_id?: string | undefined | null, task_status_name?: string | undefined | null, task_status_system_status?: TaskSystemStatusEnum | undefined | null, task_status_background_color?: string | undefined | null, task_status_foreground_color?: string | undefined | null, our_work_budget_item_id?: string | undefined | null, our_work_budget_item_title?: string | undefined | null, project_id?: string | undefined | null, project_code?: string | undefined | null, project_title?: string | undefined | null, tracking_enabled?: boolean | undefined | null, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, time_off_type_id?: string | undefined | null, time_off_type_name?: string | undefined | null, time_off_type_affects_planning_capacity?: boolean | undefined | null, deadline?: string | undefined | null, deadline_time?: string | undefined | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | undefined | null, items_count: number, title?: string | undefined | null } | undefined | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | undefined | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | undefined | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null } }>, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | undefined | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | undefined | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null } } };

export type MoveCapacityAllocationItemMutationVariables = Exact<{
  input: MoveCapacityAllocationItemInput;
}>;


export type MoveCapacityAllocationItemMutation = { __typename?: 'Mutation', moveCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, userItems: Array<{ __typename?: 'CapacityAllocationItem', id: string, date: string, from_time?: string | undefined | null, to_time?: string | undefined | null, note?: string | undefined | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | undefined | null, global?: boolean | undefined | null, time_off_duration_type?: TimeOffDurationTypeEnum | undefined | null, time_tracking_work_type_id?: string | undefined | null, completed: boolean, meetLink?: string | undefined | null, eventLink?: string | undefined | null, capacityAllocation: { __typename?: 'CapacityAllocation', id: string }, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | undefined | null, task_id?: string | undefined | null, task_name?: string | undefined | null, task_status_id?: string | undefined | null, task_status_name?: string | undefined | null, task_status_system_status?: TaskSystemStatusEnum | undefined | null, task_status_background_color?: string | undefined | null, task_status_foreground_color?: string | undefined | null, our_work_budget_item_id?: string | undefined | null, our_work_budget_item_title?: string | undefined | null, project_id?: string | undefined | null, project_code?: string | undefined | null, project_title?: string | undefined | null, tracking_enabled?: boolean | undefined | null, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, time_off_type_id?: string | undefined | null, time_off_type_name?: string | undefined | null, time_off_type_affects_planning_capacity?: boolean | undefined | null, deadline?: string | undefined | null, deadline_time?: string | undefined | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | undefined | null, items_count: number, title?: string | undefined | null } | undefined | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | undefined | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | undefined | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null } }>, timeTrackingWorkType?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | undefined | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } } };

export type ReorderCapacityAllocationUserItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderCapacityAllocationUserItemsMutation = { __typename?: 'Mutation', reorderCapacityAllocationItems?: Array<{ __typename?: 'CapacityAllocationItem', id: string }> | undefined | null };

export type ValidateCreateTimeTrackingItemMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ValidateCreateTimeTrackingItemMutation = { __typename?: 'Mutation', validateCreateTimeTrackingItem: boolean };

export type UpdateTimeTrackingWorkTypeInTrackingMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  old_time_tracking_work_type_id: Scalars['ID']['input'];
  new_time_tracking_work_type_id: Scalars['ID']['input'];
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateTimeTrackingWorkTypeInTrackingMutation = { __typename?: 'Mutation', updateTimeTrackingWorkTypeInTracking: boolean };

export type UpdatePlanningUsersOrderMutationVariables = Exact<{
  user_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type: PlanningOrderTypeEnum;
  model_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePlanningUsersOrderMutation = { __typename?: 'Mutation', updatePlanningUsersOrder: boolean };

export type GetAllocationModalOptionsQueryVariables = Exact<{
  where?: InputMaybe<UsersWhereConditions>;
}>;


export type GetAllocationModalOptionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null, team_id?: string | undefined | null, profile?: { __typename?: 'UserProfile', plannable: boolean } | undefined | null }> };

export type GetTaskPositionsQueryVariables = Exact<{
  task_id: Scalars['ID']['input'];
}>;


export type GetTaskPositionsQuery = { __typename?: 'Query', task: { __typename?: 'Task', ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } } | undefined | null } };

export type IsUserInTaskQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type IsUserInTaskQuery = { __typename?: 'Query', isUserInTask: boolean };

export type ModalCapacityAllocationTaskOptionsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type ModalCapacityAllocationTaskOptionsQuery = { __typename?: 'Query', task: { __typename?: 'Task', from?: string | undefined | null, to?: string | undefined | null, planned_time: number, deadline?: string | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, history_spent_time: number, allocated_time: number, left_to_allocate: number } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', id: string } | undefined | null }> } };

export type ModalCapacityAllocationProjectOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ModalCapacityAllocationProjectOptionsQuery = { __typename?: 'Query', projectForTask: { __typename?: 'ProjectForTask', id: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type PlanningFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlanningFilterOptionsQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type ProjectTemplateFragment = { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, note?: string | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, statsCached?: { __typename?: 'ProjectStats', id: string, total_budget: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', id: string, planned_expenses: number } } | undefined | null };

export type ProjectTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectTemplatesQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, billable: boolean, note?: string | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, statsCached?: { __typename?: 'ProjectStats', id: string, total_budget: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', id: string, planned_expenses: number } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectTemplatesFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectTemplatesFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | undefined | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type TaskGroupTemplateFragment = { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null };

export type CreateTaskGroupTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTaskGroupTemplateMutation = { __typename?: 'Mutation', createTaskTemplateGroup: { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null } };

export type UpdateTaskGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTaskGroupTemplateMutation = { __typename?: 'Mutation', updateTaskTemplateGroup: { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null } };

export type DeleteTaskGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskGroupTemplateMutation = { __typename?: 'Mutation', deleteTaskTemplateGroup: boolean };

export type TaskGroupTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskGroupTemplatesQuery = { __typename?: 'Query', taskTemplateGroups: Array<{ __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null } | undefined | null> };

export type TaskGroupTemplatesSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskGroupTemplatesSimpleQuery = { __typename?: 'Query', taskTemplateGroups: Array<{ __typename?: 'TaskTemplateGroup', id: string, name: string } | undefined | null> };

export type TaskGroupTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskGroupTemplateQuery = { __typename?: 'Query', taskTemplateGroup: { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: string | undefined | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null, parent?: { __typename?: 'Task', id: string } | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | undefined | null } };

export type TimeTrackingReportItemFragment = { __typename?: 'TimeTrackingReport', id: string, tracked_time: number, tracked_for_date: string, brand_id: string, brand_name: string, client_name: string, project_id: string, project_title: string, project_code: string, project_time_billing_id?: string | undefined | null, project_time_billing_project_id?: string | undefined | null, project_time_billing_name?: string | undefined | null, project_time_billing_project_name?: string | undefined | null, project_time_billing_is_locked?: boolean | undefined | null, our_work_budget_item_title: string, time_tracking_work_type_title: string, time_tracking_work_type_id: string, team_name?: string | undefined | null, task_id: string, task_name: string, user_full_name?: string | undefined | null, note?: string | undefined | null, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount?: number | undefined | null, hourly_rate?: number | undefined | null, locked_at?: string | undefined | null, locked_by_user_first_name?: string | undefined | null, locked_by_user_last_name?: string | undefined | null };

export type MoveTimeTrackingItemsToWorkTypeMutationVariables = Exact<{
  item_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  work_type_id: Scalars['ID']['input'];
}>;


export type MoveTimeTrackingItemsToWorkTypeMutation = { __typename?: 'Mutation', moveTimeTrackingItemsToWorkType: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type MoveTimeTrackingItemsToTaskMutationVariables = Exact<{
  item_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_mapping: Array<TimeTrackingWorkTypeMapping> | TimeTrackingWorkTypeMapping;
}>;


export type MoveTimeTrackingItemsToTaskMutation = { __typename?: 'Mutation', moveTimeTrackingItemsToTask: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UnlockTimeTrackingItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnlockTimeTrackingItemsMutation = { __typename?: 'Mutation', unlockTimeTrackingItems: { __typename?: 'BulkActionResponse', total: number, failed: number, successful: number } };

export type BulkDeleteTimeTrackingItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDeleteTimeTrackingItemsMutation = { __typename?: 'Mutation', bulkDeleteTimeTrackingItems: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UpdateTimeTrackingItemsBillableMutationVariables = Exact<{
  timeTrackingItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  billable: Scalars['Boolean']['input'];
}>;


export type UpdateTimeTrackingItemsBillableMutation = { __typename?: 'Mutation', updateTimeTrackingItemsBillable: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type TimeTrackingReportSummaryQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingReportSummaryQuery = { __typename?: 'Query', getTimeTrackingItemsSummary: { __typename?: 'GetTimeTrackingItemsSummary', ids: Array<string>, tracked_time: number } };

export type TimeTrackingReportSelectedSummaryQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingReportSelectedSummaryQuery = { __typename?: 'Query', getTimeTrackingItemsSummary: { __typename?: 'GetTimeTrackingItemsSummary', tracked_time: number, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount: number, invoiced_amount: number, overserviced_amount: number, uninvoiced_amount: number } };

export type TimeTrackingReportGroupedByQueryVariables = Exact<{
  groupBy?: InputMaybe<TimeTrackingReportGroupBy>;
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  first?: InputMaybe<Scalars['BigInt']['input']>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause> | TimeTrackingItemOrderByClause>;
}>;


export type TimeTrackingReportGroupedByQuery = { __typename?: 'Query', timeTrackingReport: { __typename?: 'TimeTrackingReportPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TimeTrackingReportGroup', groupBy?: string | undefined | null, trackedTime: number, items: Array<{ __typename?: 'TimeTrackingReport', id: string, tracked_time: number, tracked_for_date: string, brand_id: string, brand_name: string, client_name: string, project_id: string, project_title: string, project_code: string, project_time_billing_id?: string | undefined | null, project_time_billing_project_id?: string | undefined | null, project_time_billing_name?: string | undefined | null, project_time_billing_project_name?: string | undefined | null, project_time_billing_is_locked?: boolean | undefined | null, our_work_budget_item_title: string, time_tracking_work_type_title: string, time_tracking_work_type_id: string, team_name?: string | undefined | null, task_id: string, task_name: string, user_full_name?: string | undefined | null, note?: string | undefined | null, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount?: number | undefined | null, hourly_rate?: number | undefined | null, locked_at?: string | undefined | null, locked_by_user_first_name?: string | undefined | null, locked_by_user_last_name?: string | undefined | null }> }> } };

export type TimeTrackingUngroupedItemsQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  first?: InputMaybe<Scalars['BigInt']['input']>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause> | TimeTrackingItemOrderByClause>;
}>;


export type TimeTrackingUngroupedItemsQuery = { __typename?: 'Query', getTimeTrackingItems: { __typename?: 'GetTimeTrackingItemsPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TimeTrackingReport', id: string, tracked_time: number, tracked_for_date: string, brand_id: string, brand_name: string, client_name: string, project_id: string, project_title: string, project_code: string, project_time_billing_id?: string | undefined | null, project_time_billing_project_id?: string | undefined | null, project_time_billing_name?: string | undefined | null, project_time_billing_project_name?: string | undefined | null, project_time_billing_is_locked?: boolean | undefined | null, our_work_budget_item_title: string, time_tracking_work_type_title: string, time_tracking_work_type_id: string, team_name?: string | undefined | null, task_id: string, task_name: string, user_full_name?: string | undefined | null, note?: string | undefined | null, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount?: number | undefined | null, hourly_rate?: number | undefined | null, locked_at?: string | undefined | null, locked_by_user_first_name?: string | undefined | null, locked_by_user_last_name?: string | undefined | null }> } };

export type TimeTrackingReportExportQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
}>;


export type TimeTrackingReportExportQuery = { __typename?: 'Query', timeTrackingReportExport: string };

export type TimeTrackingEffectivenessReportExportQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
}>;


export type TimeTrackingEffectivenessReportExportQuery = { __typename?: 'Query', userEffectivenessReportExport: string };

export type TimeTrackingTimeOffsExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingTimeOffsExportQuery = { __typename?: 'Query', timeOffsExport: string };

export type TimeTrackingReportExportPdfQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  type: TimeTrackingReportExportType;
}>;


export type TimeTrackingReportExportPdfQuery = { __typename?: 'Query', timeTrackingReportExportPdf: string };

export type GetTasksSimpleMapOptionsQueryVariables = Exact<{
  our_work_budget_item_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  parent_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetTasksSimpleMapOptionsQuery = { __typename?: 'Query', tasksSimpleMap: Array<{ __typename?: 'TaskSimple', id: string, name: string, parent?: { __typename?: 'Task', id: string } | undefined | null }> };

export type GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables = Exact<{
  project_id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetOurWorkBudgetItemsSimpleMapOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, project?: { __typename?: 'ProjectSimple', id: string } | undefined | null, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } }> };

export type TimeTrackingReportOptionsQueryVariables = Exact<{
  userSimpleWhere?: InputMaybe<UsersWhereConditions>;
}>;


export type TimeTrackingReportOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand_id: string, archived_at?: string | undefined | null, finished_at?: string | undefined | null }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, full_name: string, team_id?: string | undefined | null, codename?: string | undefined | null, archived_at?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type GetProjectsWithPositionsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProjectsWithPositionsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', projects: Array<{ __typename?: 'Project', id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> }> } | undefined | null };

export type AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery = { __typename?: 'Query', getAvailableWorkTypesForBulkMovingTimeTrackingItems: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type TimeTrackingItemsWorkTypesQueryVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TimeTrackingItemsWorkTypesQuery = { __typename?: 'Query', timeTrackingItemsWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type CheckTimeTrackingItemsLockedQueryVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckTimeTrackingItemsLockedQuery = { __typename?: 'Query', checkTimeTrackingItemsLocked: Array<string> };

export type AddRowToWeekTimeReportMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddRowToWeekTimeReportMutation = { __typename?: 'Mutation', addRowToWeekTimeReport: { __typename?: 'WeeklyTimeReportRow', task: { __typename?: 'Task', id: string } } };

export type CreateOrUpdateTrackedTimeForDayMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  tracked_for_date: Scalars['Date']['input'];
  tracked_time: Scalars['BigInt']['input'];
}>;


export type CreateOrUpdateTrackedTimeForDayMutation = { __typename?: 'Mutation', createOrUpdateTrackedTimeForDay: boolean };

export type CreateTimeTrackingItemMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  specificTimeFrom?: InputMaybe<Scalars['Time']['input']>;
  specificTimeTo?: InputMaybe<Scalars['Time']['input']>;
}>;


export type CreateTimeTrackingItemMutation = { __typename?: 'Mutation', createTimeTrackingItem: { __typename?: 'TimeTrackingItem', id: string } };

export type DeleteTimeTrackingItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTimeTrackingItemMutation = { __typename?: 'Mutation', deleteTimeTrackingItem: { __typename?: 'TimeTrackingItem', id: string } };

export type RemoveRowFromWeekTimeReportMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  first_date_of_week: Scalars['Date']['input'];
}>;


export type RemoveRowFromWeekTimeReportMutation = { __typename?: 'Mutation', removeRowFromWeekTimeReport?: { __typename?: 'WeeklyTimeReportRow', task: { __typename?: 'Task', id: string } } | undefined | null };

export type StartTimerMutationVariables = Exact<{
  time_tracking_item_id: Scalars['ID']['input'];
}>;


export type StartTimerMutation = { __typename?: 'Mutation', startTimer: boolean };

export type StopTimerMutationVariables = Exact<{
  time_tracking_item_id: Scalars['ID']['input'];
}>;


export type StopTimerMutation = { __typename?: 'Mutation', stopTimer: boolean };

export type UpdateTimeTrackingItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
  specificTimeFrom?: InputMaybe<Scalars['Time']['input']>;
  specificTimeTo?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTimeTrackingItemMutation = { __typename?: 'Mutation', updateTimeTrackingItem: { __typename?: 'TimeTrackingItem', id: string } };

export type TimeTrackingEntryFragment = { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } };

export type TimeTrackingBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackingBrandsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }> };

export type TimeTrackingItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TimeTrackingItemQuery = { __typename?: 'Query', timeTrackingItem: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } };

export type TimeTrackingItemsQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingItemsQuery = { __typename?: 'Query', timeTrackingSummaryPerDay?: Array<{ __typename?: 'TimeTrackingSummaryPerDay', date: string, tracked_time: number, auto_stopped: boolean }> | undefined | null, timeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } }>, runningTimer?: { __typename?: 'Timer', id: string, timeTrackingItem?: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string } | undefined | null } | undefined | null };

export type TimeTrackingOptionsForProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type TimeTrackingOptionsForProjectQuery = { __typename?: 'Query', timeTrackingOptionsForProject: { __typename?: 'TimeTrackingOptionsForProject', ourWork: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null }, category: { __typename?: 'OurWorkBudgetCategory', name: string }, tasks: Array<{ __typename?: 'TaskSimple', id: string, name: string, positions: Array<{ __typename?: 'TaskPosition', timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string }, user?: { __typename?: 'User', id: string } | undefined | null }> }> }>, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type TimeTrackingProjectsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TimeTrackingProjectsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', billable: boolean, id: string, title: string, code: string, brand_id: string }> };

export type TimeTrackingUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackingUsersQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, codename?: string | undefined | null, full_name: string, team_id?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> };

export type WeekTimeReportQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
}>;


export type WeekTimeReportQuery = { __typename?: 'Query', weekTimeReport: { __typename?: 'WeekTimeReport', rows: Array<{ __typename?: 'WeeklyTimeReportRow', task: { __typename?: 'Task', id: string, name: string, billable: boolean, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, trackedTime: Array<{ __typename?: 'WeeklyTimeReportRowDay', date: string, tracked_time: number }> }>, dailyTotals: Array<{ __typename?: 'WeeklyTimeReportTotalsPerDay', date: string, total_tracked_time: number }> } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', id: string } };

export type GetUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<UserQueryArgs>;
}>;


export type GetUsersQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }>, usersSummary: { __typename?: 'UsersSummary', userIds: Array<string> }, users?: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, codename?: string | undefined | null, email: string, phone?: string | undefined | null, note?: string | undefined | null, archived_at?: string | undefined | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, team?: { __typename?: 'Team', id: string, name: string } | undefined | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, profile?: { __typename?: 'UserProfile', hex_color: string, plannable: boolean, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } } | undefined | null, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type ProjectManagerOptionsForUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectManagerOptionsForUsersQuery = { __typename?: 'Query', projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null }> };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string } };

export type ScheduleUserArchivalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  project_manager_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ScheduleUserArchivalMutation = { __typename?: 'Mutation', scheduleUserArchival: { __typename?: 'User', id: string } };

export type ScheduleUserActivationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ScheduleUserActivationMutation = { __typename?: 'Mutation', scheduleUserActivation: { __typename?: 'User', id: string } };

export type ReassignActiveProjectsAndOwnedInvoicesMutationVariables = Exact<{
  fromUser: Scalars['ID']['input'];
  toUser: Scalars['ID']['input'];
}>;


export type ReassignActiveProjectsAndOwnedInvoicesMutation = { __typename?: 'Mutation', reassignActiveProjectsAndOwnedInvoices: boolean };

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'User', id: string } };

export type UserForEditBasicFragment = { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, codename?: string | undefined | null, created_at: string, email: string, phone?: string | undefined | null, note?: string | undefined | null, archived_at?: string | undefined | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, mcp_connected: boolean, muted_mail_notifications: boolean, calendar_integrations?: Array<CalendarTypeEnum | undefined | null> | undefined | null, calendar_sync_direction?: CalendarSyncDirectionEnum | undefined | null, calendar_sync_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, statusRanges: Array<{ __typename?: 'UserStatusRange', id: string, valid_from: string, valid_to?: string | undefined | null, active: boolean, projectManager?: { __typename?: 'User', id: string } | undefined | null }>, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean }, mcpTokens: Array<{ __typename?: 'McpToken', id: string, mcp_name?: string | undefined | null, created_at: string }>, team?: { __typename?: 'Team', id: string, name: string } | undefined | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, tasks: Array<{ __typename?: 'Task', id: string }> };

export type GetScopedUserForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScopedUserForEditQuery = { __typename?: 'Query', user?: { __typename?: 'User', scope_access?: UserScopeAccessEnum | undefined | null, id: string, first_name: string, last_name: string, full_name: string, codename?: string | undefined | null, created_at: string, email: string, phone?: string | undefined | null, note?: string | undefined | null, archived_at?: string | undefined | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, mcp_connected: boolean, muted_mail_notifications: boolean, calendar_integrations?: Array<CalendarTypeEnum | undefined | null> | undefined | null, calendar_sync_direction?: CalendarSyncDirectionEnum | undefined | null, calendar_sync_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, tasks: Array<{ __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null } }>, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, statusRanges: Array<{ __typename?: 'UserStatusRange', id: string, valid_from: string, valid_to?: string | undefined | null, active: boolean, projectManager?: { __typename?: 'User', id: string } | undefined | null }>, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean }, mcpTokens: Array<{ __typename?: 'McpToken', id: string, mcp_name?: string | undefined | null, created_at: string }>, team?: { __typename?: 'Team', id: string, name: string } | undefined | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }> } | undefined | null };

export type GetUserForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserForEditQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, codename?: string | undefined | null, created_at: string, email: string, phone?: string | undefined | null, note?: string | undefined | null, archived_at?: string | undefined | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, mcp_connected: boolean, muted_mail_notifications: boolean, calendar_integrations?: Array<CalendarTypeEnum | undefined | null> | undefined | null, calendar_sync_direction?: CalendarSyncDirectionEnum | undefined | null, calendar_sync_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, plannable: boolean, rates: Array<{ __typename?: 'UserProfileRate', id: string, valid_from: string, valid_to?: string | undefined | null, rate: number }>, planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', id: string, valid_from: string, valid_to?: string | undefined | null, utilising: boolean, daily_capacity?: number | undefined | null, type: { __typename?: 'PlanningRangeType', value: PlanningRangeTypeEnum }, weekly_capacities?: { __typename?: 'WeeklyCapacities', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } | undefined | null }>, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } } | undefined | null, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, statusRanges: Array<{ __typename?: 'UserStatusRange', id: string, valid_from: string, valid_to?: string | undefined | null, active: boolean, projectManager?: { __typename?: 'User', id: string } | undefined | null }>, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean }, mcpTokens: Array<{ __typename?: 'McpToken', id: string, mcp_name?: string | undefined | null, created_at: string }>, team?: { __typename?: 'Team', id: string, name: string } | undefined | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, tasks: Array<{ __typename?: 'Task', id: string }> } | undefined | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string } };

export type CreateScopedUserMutationVariables = Exact<{
  input: CreateScopedUserInput;
}>;


export type CreateScopedUserMutation = { __typename?: 'Mutation', createScopedUser: { __typename?: 'User', id: string } };

export type DisableTwoFactorAuthenticationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableTwoFactorAuthenticationMutation = { __typename?: 'Mutation', disableTwoFactorAuthentication: { __typename?: 'User', id: string, enabled_two_factor_authentication: boolean } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type SetUserProfileRatesMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  rates: Array<UserProfileRateInput> | UserProfileRateInput;
}>;


export type SetUserProfileRatesMutation = { __typename?: 'Mutation', setUserProfileRates: { __typename?: 'UserProfile', rates: Array<{ __typename?: 'UserProfileRate', id: string }> } };

export type ConnectToMcpMutationVariables = Exact<{
  input: ConnectToMcpInput;
}>;


export type ConnectToMcpMutation = { __typename?: 'Mutation', connectToMcp: { __typename?: 'ConnectToMcpPayload', status: string, message: string } };

export type DisconnectFromMcpMutationVariables = Exact<{
  input: DisconnectFromMcpInput;
}>;


export type DisconnectFromMcpMutation = { __typename?: 'Mutation', disconnectFromMcp: { __typename?: 'ConnectToMcpPayload', status: string, message: string } };

export type SetUserProfilePlanningRangesMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  planningRanges: Array<PlanningRangeInput> | PlanningRangeInput;
}>;


export type SetUserProfilePlanningRangesMutation = { __typename?: 'Mutation', setUserProfilePlanningRanges: { __typename?: 'UserProfile', planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', id: string }> } };

export type GetNewSequenceNumberQueryVariables = Exact<{
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  date: Scalars['Date']['input'];
  workspace_company_id: Scalars['ID']['input'];
  documentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetNewSequenceNumberQuery = { __typename?: 'Query', getNewInvoiceNumber: Array<{ __typename?: 'InvoiceSequenceData', id: string, document_no: string }> };

export type CheckSequenceNumberExistQueryVariables = Exact<{
  document_no?: InputMaybe<Scalars['String']['input']>;
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  date: Scalars['Date']['input'];
  document_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  workspace_company_id: Scalars['ID']['input'];
}>;


export type CheckSequenceNumberExistQuery = { __typename?: 'Query', checkInvoiceNumberExist?: boolean | undefined | null };

export type UpdateProjectCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectCategoryMutation = { __typename?: 'Mutation', updateProjectCategory: { __typename?: 'ProjectCategory', id: string, name: string } };

export type DeleteProjectCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectCategoryMutation = { __typename?: 'Mutation', deleteProjectCategory: { __typename?: 'ProjectCategory', id: string } };

export type CreateProjectCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProjectCategoryMutation = { __typename?: 'Mutation', createProjectCategory: { __typename?: 'ProjectCategory', id: string, name: string } };

export type GetProjectCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectCategoriesQuery = { __typename?: 'Query', projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type MarkTaskNotificationsAsUnreadMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
}>;


export type MarkTaskNotificationsAsUnreadMutation = { __typename?: 'Mutation', markTaskAndCommunicationNotificationAsUnread: boolean };

export type UpdateTaskScopesMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskScopesMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string } };

export type UpdateProjectScopesMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectScopesMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string } };

export type AttachmentFragment = { __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } };

export type CreateAssignableFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type CreateAssignableFileMutation = { __typename?: 'Mutation', createAssignableFile: { __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } } };

export type UsersSimpleMapQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  allowedScopes?: InputMaybe<Scalars['Mixed']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  mentions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersSimpleMapQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> };

export type GetDefaultUserMentionsQueryVariables = Exact<{
  where?: InputMaybe<UsersWhereConditions>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDefaultUserMentionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> };

export type UserToolTip_UserFragmentFragment = { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null };

export type UsersAllocatedTimeQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  types: Array<CapacityAllocationTypeEnum> | CapacityAllocationTypeEnum;
  user_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UsersAllocatedTimeQuery = { __typename?: 'Query', GetUsersAllocatedTime?: Array<{ __typename?: 'UserAllocatedTime', user_id: string, dates?: Array<{ __typename?: 'UserAllocatedTimeDate', date: string, planned_capacity: number, data?: Array<{ __typename?: 'UserAllocatedTimeData', from_time?: string | undefined | null, to_time?: string | undefined | null, type: CapacityAllocationTypeEnum, value: number }> | undefined | null }> | undefined | null }> | undefined | null };

export type CheckForAllocationConflictsQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  user_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  from_time?: InputMaybe<Scalars['Time']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  types: Array<CapacityAllocationTypeEnum> | CapacityAllocationTypeEnum;
  repetition_settings?: InputMaybe<Array<InputMaybe<RepetitionSettingsDaysEnum>> | InputMaybe<RepetitionSettingsDaysEnum>>;
}>;


export type CheckForAllocationConflictsQuery = { __typename?: 'Query', GetUsersAllocationConflicts?: Array<{ __typename?: 'UserAllocationConflicts', user_id: string, conflict: boolean }> | undefined | null };

export type BrandForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BrandForNavigationQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string } | undefined | null };

export type GetSubmittedRfiCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubmittedRfiCountQuery = { __typename?: 'Query', getSubmittedRfiCount: number };

export type ProjectForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForNavigationQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, code: string, finished_at?: string | undefined | null, uses_budgetovac: boolean, type: ProjectTypeEnum, is_template: boolean } | undefined | null };

export type ContractorForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractorForNavigationQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null };

export type CreditAccountForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreditAccountForNavigationQuery = { __typename?: 'Query', brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | undefined | null };

export type ExpenseForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseForNavigationQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, expense_no?: string | undefined | null, is_draft: boolean } };

export type OutgoingInvoiceForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceForNavigationQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, type: OutgoingInvoiceTypeEnum } | undefined | null };

export type ProformaInvoiceForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProformaInvoiceForNavigationQuery = { __typename?: 'Query', outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } | undefined | null };

export type GetRequestForInvoicingTypeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRequestForInvoicingTypeQuery = { __typename?: 'Query', requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string, type: RequestForInvoicingTypeEnum } | undefined | null };

export type QuoteForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteForNavigationQuery = { __typename?: 'Query', GetQuote: { __typename?: 'Quote', id: string, number: string } };

export type AccessTokenForBudgetovacQueryVariables = Exact<{
  appName?: InputMaybe<ThirdPartyEnum>;
}>;


export type AccessTokenForBudgetovacQuery = { __typename?: 'Query', getAccessTokenForThirdParty?: string | undefined | null };

export type RunningTimerQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
}>;


export type RunningTimerQuery = { __typename?: 'Query', runningTimer?: { __typename?: 'Timer', id: string, timeTrackingItem?: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null } | undefined | null };

export type AddScopedUsersToTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  user_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isTemplate: Scalars['Boolean']['input'];
}>;


export type AddScopedUsersToTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }> } };

export type CreateLinkTaskMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  link_type_id: Scalars['ID']['input'];
  linked_task_id: Scalars['ID']['input'];
}>;


export type CreateLinkTaskMutation = { __typename?: 'Mutation', addTaskLink?: { __typename?: 'TaskLink', id: string, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | undefined | null } | undefined | null }, link_type?: { __typename?: 'TaskLinkType', id: string, name: string } | undefined | null } | undefined | null };

export type CreateTaskCommentMutationVariables = Exact<{
  input: CreateTaskCommentInput;
}>;


export type CreateTaskCommentMutation = { __typename?: 'Mutation', createTaskComment: { __typename?: 'TaskComment', id: string, body: string, timestamp?: string | undefined | null, has_edits?: boolean | undefined | null, user: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null> | undefined | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }> } };

export type DeleteAssignableFileMutationVariables = Exact<{
  publicId: Scalars['String']['input'];
}>;


export type DeleteAssignableFileMutation = { __typename?: 'Mutation', deleteAssignableFile?: { __typename?: 'BooleanResult', result?: boolean | undefined | null } | undefined | null };

export type DeleteLinkTaskMutationVariables = Exact<{
  task_link_id: Scalars['ID']['input'];
}>;


export type DeleteLinkTaskMutation = { __typename?: 'Mutation', deleteTaskLink: { __typename?: 'TaskLink', id: string } };

export type DeleteTaskCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskCommentMutation = { __typename?: 'Mutation', deleteTaskComment: { __typename?: 'TaskComment', id: string } };

export type DuplicateTaskMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  task_input?: InputMaybe<CreateTaskInput>;
  with_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  with_links?: InputMaybe<Scalars['Boolean']['input']>;
  with_comments?: InputMaybe<Scalars['Boolean']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DuplicateTaskMutation = { __typename?: 'Mutation', duplicateTask: { __typename?: 'Task', revision: string, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | undefined | null, unreadCommentsCount: number, created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | undefined | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | undefined | null } | undefined | null } }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: string | undefined | null, tracking_enabled_from?: string | undefined | null }, category: { __typename?: 'OurWorkBudgetCategory', name: string } } | undefined | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null } } | undefined | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | undefined | null>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } } };

export type EditTaskWatchersMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EditTaskWatchersMutation = { __typename?: 'Mutation', editTaskWatchers: { __typename?: 'Task', taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | undefined | null> } };

export type LastSeenCommentMutationVariables = Exact<{
  comment_id: Scalars['ID']['input'];
}>;


export type LastSeenCommentMutation = { __typename?: 'Mutation', lastSeen?: { __typename?: 'Task', id: string } | undefined | null };

export type MarkTaskNotificationsAsReadMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
}>;


export type MarkTaskNotificationsAsReadMutation = { __typename?: 'Mutation', markTaskAndCommunicationNotificationAsRead: boolean };

export type ToggleTaskCommentReactionMutationVariables = Exact<{
  input: ToggleTaskCommentReactionInput;
}>;


export type ToggleTaskCommentReactionMutation = { __typename?: 'Mutation', toggleTaskCommentReaction?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } }> | undefined | null };

export type UpdateTaskCommentMutationVariables = Exact<{
  input: UpdateTaskCommentInput;
}>;


export type UpdateTaskCommentMutation = { __typename?: 'Mutation', updateTaskComment: { __typename?: 'TaskComment', id: string, body: string, timestamp?: string | undefined | null, has_edits?: boolean | undefined | null, user: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null> | undefined | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }> } };

export type UpdateTaskDescriptionMutationVariables = Exact<{
  input: UpdateTaskDescriptionInput;
}>;


export type UpdateTaskDescriptionMutation = { __typename?: 'Mutation', updateTaskDescription: { __typename?: 'Task', id: string, revision: string, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null } };

export type UpdateTaskFilesMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  files: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTaskFilesMutation = { __typename?: 'Mutation', addTaskFiles: { __typename?: 'Task', id: string, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }> } };

export type UpdateTaskPriorityMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  priority_id: Scalars['ID']['input'];
}>;


export type UpdateTaskPriorityMutation = { __typename?: 'Mutation', updateTaskPriority: { __typename?: 'Task', id: string, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } } };

export type UpdateTaskStatusMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  status_id: Scalars['ID']['input'];
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', updateTaskStatus: { __typename?: 'Task', id: string, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null } } };

export type CheckTaskRevisionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckTaskRevisionQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, revision: string } };

export type CommentFragment = { __typename?: 'TaskComment', id: string, body: string, timestamp?: string | undefined | null, has_edits?: boolean | undefined | null, user: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null> | undefined | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }> };

export type GetTaskCommunicationFilesQueryVariables = Exact<{
  task_id: Scalars['ID']['input'];
  scope?: InputMaybe<UserScopeEnum>;
}>;


export type GetTaskCommunicationFilesQuery = { __typename?: 'Query', taskCommentFiles: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }> };

export type GetTaskLinkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskLinkTypesQuery = { __typename?: 'Query', taskLinkTypes: Array<{ __typename?: 'TaskLinkType', id: string, name: string }> };

export type GetTaskLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskLinksQuery = { __typename?: 'Query', task: { __typename?: 'Task', linkedTasks?: Array<{ __typename?: 'TaskLink', link_type?: { __typename?: 'TaskLinkType', name: string } | undefined | null, linked_task: { __typename?: 'Task', name: string, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } } }> | undefined | null } };

export type TaskFragmentForScopedUserFragment = { __typename?: 'Task', created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } };

export type TaskFragmentFragment = { __typename?: 'Task', revision: string, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | undefined | null, created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | undefined | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | undefined | null } | undefined | null } }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: string | undefined | null, tracking_enabled_from?: string | undefined | null } } | undefined | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null } } | undefined | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | undefined | null>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } };

export type TaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskQuery = { __typename?: 'Query', taskPositionStat: Array<{ __typename?: 'TaskPositionStat', planned_time: number, spent_time: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, task: { __typename?: 'Task', revision: string, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | undefined | null, created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, subtasks?: Array<{ __typename?: 'Task', revision: string, cloudUrl?: string | undefined | null, driveCloudUrl?: string | undefined | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | undefined | null, created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | undefined | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | undefined | null } | undefined | null } }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: string | undefined | null, tracking_enabled_from?: string | undefined | null } } | undefined | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null } } | undefined | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | undefined | null>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } }> | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | undefined | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | undefined | null } | undefined | null } }> | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: string | undefined | null, tracking_enabled_from?: string | undefined | null } } | undefined | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null } } | undefined | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | undefined | null>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } }, taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }> };

export type TaskForScopedUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskForScopedUsersQuery = { __typename?: 'Query', task: { __typename?: 'Task', created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } }, taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }> };

export type TaskCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeEnum>;
  lastCommentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TaskCommentsQuery = { __typename?: 'Query', taskComments?: { __typename?: 'TaskCommentPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TaskComment', id: string, body: string, timestamp?: string | undefined | null, has_edits?: boolean | undefined | null, user: { __typename?: 'User', id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | undefined | null> | undefined | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }> }> } | undefined | null };

export type TaskStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskStatusesQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }> };

export type HasTaskPermissionQueryVariables = Exact<{
  task_id: Scalars['ID']['input'];
  type: TaskPermissionTypeEnum;
}>;


export type HasTaskPermissionQuery = { __typename?: 'Query', hasTaskPermission: boolean };

export type CompleteExpenseBudgetItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  completed_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CompleteExpenseBudgetItemMutation = { __typename?: 'Mutation', completeExpenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string } } };

export type EbiCompleteDataFragment = { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string } };

export type ReopenExpenseBudgetItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReopenExpenseBudgetItemMutation = { __typename?: 'Mutation', reopenExpenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: string | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string } } };

export type ReturnGlobalCreditMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
  global_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
}>;


export type ReturnGlobalCreditMutation = { __typename?: 'Mutation', returnGlobalCreditFromExpenseItem: boolean };

export type TransferGlobalCreditMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  fromCreditAccountId: Scalars['ID']['input'];
  toCreditAccountId: Scalars['ID']['input'];
  performedAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TransferGlobalCreditMutation = { __typename?: 'Mutation', transferGlobalCredit: boolean };

export type ExpenseBudgetItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseBudgetItemQuery = { __typename?: 'Query', expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, type: ExpenseBudgetItemType, title: string, completed_at?: string | undefined | null, project: { __typename?: 'Project', id: string, billable: boolean, brand: { __typename?: 'Brand', id: string } }, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', id: string, amount: number, date?: string | undefined | null, expense: { __typename?: 'Expense', id: string, status: ExpenseStatusEnum }, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | undefined | null }>, creditAccount?: { __typename?: 'CreditAccount', id: string } | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', real_expenses: number, planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string }, globalPrepaymentStats: Array<{ __typename?: 'ExpenseBudgetItemGlobalPrepaymentStats', id: string, credit: number, date: string, credit_account_operation_id: string, expenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, title: string }, globalCreditAccount: { __typename?: 'GlobalCreditAccount', id: string, title: string } }> } | undefined | null };

export type ContactFragment = { __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, email?: string | undefined | null, phone?: string | undefined | null };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, email?: string | undefined | null, phone?: string | undefined | null } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, first_name?: string | undefined | null, last_name?: string | undefined | null, email?: string | undefined | null, phone?: string | undefined | null } };

export type ExchangeRateFragment = { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } };

export type CreateCurrencyExchangeRateForClientMutationVariables = Exact<{
  input: CreateCurrencyExchangeRateInput;
}>;


export type CreateCurrencyExchangeRateForClientMutation = { __typename?: 'Mutation', createCurrencyExchangeRate: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type UpdateCurrencyExchangeRateForClientMutationVariables = Exact<{
  input: UpdateCurrencyExchangeRateInput;
}>;


export type UpdateCurrencyExchangeRateForClientMutation = { __typename?: 'Mutation', updateCurrencyExchangeRate: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type CreateCurrencyExchangeRateForWorkspaceMutationVariables = Exact<{
  input: CreateExchangeRateSettingsInput;
}>;


export type CreateCurrencyExchangeRateForWorkspaceMutation = { __typename?: 'Mutation', createExchangeRateForWorkspace: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type UpdateCurrencyExchangeRateForWorkspaceMutationVariables = Exact<{
  input: UpdateExchangeRateSettingsInput;
}>;


export type UpdateCurrencyExchangeRateForWorkspaceMutation = { __typename?: 'Mutation', updateExchangeRateForWorkspace: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type CompleteExpenseBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  completed_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CompleteExpenseBulkMutation = { __typename?: 'Mutation', completeExpenseBudgetItemBulk: Array<{ __typename?: 'ExpenseBudgetItem', id: string, completed_at?: string | undefined | null }> };

export type CompleteExpenseBulkDataFragment = { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: string | undefined | null };

export type FinishProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishProjectMutation = { __typename?: 'Mutation', finishProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, finished_at?: string | undefined | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null } };

export type FinishedProjectDataFragment = { __typename?: 'Project', id: string, status: ProjectStatusEnum, finished_at?: string | undefined | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null };

export type RedistributeProjectCreditMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RedistributeProjectCreditMutation = { __typename?: 'Mutation', redistributeProjectCredit: { __typename?: 'Project', id: string } };

export type ModalFinishProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalFinishProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, billable: boolean } | undefined | null, getProjectCanBeFinishedSummary: { __typename?: 'ProjectFinishSummary', id: string, project_already_finished: boolean, can_be_finished_without_further_changes: boolean, can_redistribute_credit_automatically: boolean, overinvoiced_for_project: boolean, underinvoiced_for_project: boolean, incomplete_expense_budget_items: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, real_expenses_percent: number, real_expenses: number, real_commission: number, real_commission_relative: string } }>, incomplete_our_work_budget_items: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, spent_time: number, spent_budget: number }, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | undefined | null }>, underinvoiced_our_work_budget_items: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, uninvoiced: number, credit: number, total_budget: number } }>, underinvoiced_expense_budget_items: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, uninvoiced: number, credit: number, total_budget: number } }>, overinvoiced_our_work_budget_items: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, credit: number, total_budget: number, over_invoiced: number } }>, overinvoiced_expense_budget_items: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, credit: number, total_budget: number, over_invoiced: number } }> } };

export type ModalGetCreditDependenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalGetCreditDependenciesQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'BrandCreditAccountStats', id: string, remaining_credit: number } }> | undefined | null } | undefined | null };

export type InvoiceProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  expense_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type InvoiceProjectMutation = { __typename?: 'Mutation', invoiceProject?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null };

export type OutgoingInvoiceOfInvoiceStatsFragment = { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: string, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }> };

export type ModalInvoicesOurWorkBiQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalInvoicesOurWorkBiQuery = { __typename?: 'Query', ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, billable: boolean, brand: { __typename?: 'Brand', id: string } }, creditAccount: { __typename?: 'CreditAccount', id: string }, invoiceStats: Array<{ __typename?: 'OurWorkBudgetItemInvoiceStats', id: string, credit: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: string, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }> } }>, outgoingProformaInvoiceStats: Array<{ __typename?: 'OurWorkBudgetItemProformaStats', id: string, amount: number, invoice_no: string, date: string }>, prepaymentStats: Array<{ __typename?: 'OurWorkBudgetItemPrepaymentStats', id: string, date: string, credit: number, credit_account_operation_id: string, brandCreditAccount: { __typename?: 'BrandCreditAccount', id: string, title: string }, ourWorkBudgetItem: { __typename?: 'OurWorkBudgetItem', id: string, title: string } }>, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, credit: number, credit_direct: number, credit_from_prepayments: number, uninvoiced: number } } | undefined | null };

export type ModalInvoicesExpenseBiQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalInvoicesExpenseBiQuery = { __typename?: 'Query', expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, billable: boolean, brand: { __typename?: 'Brand', id: string } }, creditAccount?: { __typename?: 'CreditAccount', id: string } | undefined | null, invoiceStats: Array<{ __typename?: 'ExpenseBudgetItemInvoiceStats', id: string, credit: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: string, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }> } }>, outgoingProformaInvoiceStats: Array<{ __typename?: 'OurWorkBudgetItemProformaStats', id: string, amount: number, invoice_no: string, date: string }>, prepaymentStats: Array<{ __typename?: 'ExpenseBudgetItemPrepaymentStats', id: string, date: string, credit: number, credit_account_operation_id: string, brandCreditAccount: { __typename?: 'BrandCreditAccount', id: string, title: string }, expenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, title: string } }>, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, credit: number, credit_direct: number, credit_from_prepayments: number, uninvoiced: number } } | undefined | null };

export type ModalInvoicesProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalInvoicesProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, billable: boolean, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, issue_date: string, abraflexi_exported?: boolean | undefined | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }>, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount: number } }>, invoiceStats: Array<{ __typename?: 'ProjectInvoiceStat', id: string, credit: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: string, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | undefined | null, xero_exported?: boolean | undefined | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: string, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | undefined | null }> } }>, prepaymentStats: Array<{ __typename?: 'ProjectPrepaymentStat', id: string, date: string, credit: number, brandCreditAccount: { __typename?: 'BrandCreditAccount', id: string, title: string }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string } | undefined | null, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | undefined | null }>, statsCached?: { __typename?: 'ProjectStats', id: string, credit_direct: number, credit_from_prepayments: number, unused_sum_from_proformas: number } | undefined | null } | undefined | null };

export type ModalOrderDataFragment = { __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null, date_of_order?: string | undefined | null, projects?: Array<{ __typename?: 'Project', id: string } | undefined | null> | undefined | null, brand: { __typename?: 'Brand', id: string }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null, date_of_order?: string | undefined | null, projects?: Array<{ __typename?: 'Project', id: string } | undefined | null> | undefined | null, brand: { __typename?: 'Brand', id: string }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> } };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string, purchase_order_no?: string | undefined | null, date_of_order?: string | undefined | null, projects?: Array<{ __typename?: 'Project', id: string } | undefined | null> | undefined | null, brand: { __typename?: 'Brand', id: string }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }>, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | undefined | null, original?: string | undefined | null } }> } };

export type ModalCreateOrderBrandOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ModalCreateOrderBrandOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }> };

export type ModalCreateOrderProjectOptionsQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type ModalCreateOrderProjectOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand_id: string }> };

export type ReturnCreditFromOurWorkMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  our_work_budget_item_id: Scalars['ID']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
}>;


export type ReturnCreditFromOurWorkMutation = { __typename?: 'Mutation', returnCreditFromOurWorkBudgetItem: boolean };

export type ReturnCreditFromExpenseMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
}>;


export type ReturnCreditFromExpenseMutation = { __typename?: 'Mutation', returnCreditFromExpenseBudgetItem: boolean };

export type SendQuoteMutationVariables = Exact<{
  input: QuoteSendInput;
}>;


export type SendQuoteMutation = { __typename?: 'Mutation', sendQuote: { __typename?: 'Quote', id: string } };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null } };

export type CreateScopedTaskMutationVariables = Exact<{
  input: CreateScopedTaskInput;
}>;


export type CreateScopedTaskMutation = { __typename?: 'Mutation', createScopedTask: { __typename?: 'Task', created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } } };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Task', id: string } };

export type SimpleTaskForClientFragment = { __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null };

export type SimpleTaskFragment = { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
  propagate_billable: Scalars['Boolean']['input'];
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | undefined | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, parent?: { __typename?: 'Task', id: string, name: string } | undefined | null } };

export type UpdateScopedTaskMutationVariables = Exact<{
  input: UpdateScopedTaskInput;
}>;


export type UpdateScopedTaskMutation = { __typename?: 'Mutation', updateScopedTask: { __typename?: 'Task', created_at?: string | undefined | null, from?: string | undefined | null, days_to_from?: number | undefined | null, to?: string | undefined | null, days_to_to?: number | undefined | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | undefined | null, deadline?: string | undefined | null, days_to_deadline?: number | undefined | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null }>, currentAssignee?: { __typename?: 'User', id: string } | undefined | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null, description?: { __typename?: 'TaskDescription', body?: string | undefined | null, mentioned_user_ids?: Array<string> | undefined | null, mentioned_team_ids?: Array<string> | undefined | null, mentioned_assignees?: boolean | undefined | null } | undefined | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | undefined | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null } | undefined | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | undefined | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | undefined | null, files: Array<{ __typename?: 'AssignableFile', created_at: string, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null, viewable?: string | undefined | null, original?: string | undefined | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | undefined | null } | undefined | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | undefined | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null } } };

export type AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables = Exact<{
  our_work_budget_item_id: Scalars['ID']['input'];
}>;


export type AvailableTaskPositionsHoursByOurWorkBudgetQuery = { __typename?: 'Query', availableTaskPositionsHoursByOurWorkBudget?: Array<{ __typename?: 'TaskPositionHour', time_tracking_work_type_id: string, planned_time: number }> | undefined | null };

export type GetPrioritiesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrioritiesOptionsQuery = { __typename?: 'Query', taskPriorities: Array<{ __typename?: 'TaskPriority', name: string, id: string }> };

export type GetProjectBillableQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProjectBillableQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, billable: boolean }> };

export type GetProjectOptionsQueryVariables = Exact<{
  withTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type GetStatusOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatusOptionsQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', name: string, id: string }> };

export type TimeTrackingWorkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackingWorkTypesQuery = { __typename?: 'Query', timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type GetUnmatchedWorkTypesForTaskMoveQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  newProjectId: Scalars['ID']['input'];
}>;


export type GetUnmatchedWorkTypesForTaskMoveQuery = { __typename?: 'Query', getUnmatchedWorkTypesForTaskMove: { __typename?: 'TaskMoveUnmatchedData', has_time_tracking_entries: boolean, unmatched_work_types: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, target_available_work_types: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type ModalTaskDependenciesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ModalTaskDependenciesQuery = { __typename?: 'Query', projectForTask: { __typename?: 'ProjectForTask', id: string, code: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } }> } };

export type TransferCreditMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  from_credit_account_id: Scalars['ID']['input'];
  to_credit_account_id: Scalars['ID']['input'];
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  performed_at?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TransferCreditMutation = { __typename?: 'Mutation', transferCredit: boolean };

export type GetModalTransferCreditDependenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetModalTransferCreditDependenciesQuery = { __typename?: 'Query', brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'BrandCreditAccountStats', remaining_credit: number }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string }> | undefined | null, brand: { __typename?: 'Brand', client: { __typename?: 'Client', id: string, brands: Array<{ __typename?: 'Brand', id: string, name: string, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string, billable: boolean, finished_at?: string | undefined | null }>, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string }> | undefined | null }> | undefined | null }> } } } | undefined | null };

export type GetProjectBudgetItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectBudgetItemsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'OurWorkBudgetItemStats', uninvoiced: number, credit: number }, category: { __typename?: 'OurWorkBudgetCategory', id: string, name: string } }>, expenses: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, type: ExpenseBudgetItemType, creditAccount?: { __typename?: 'CreditAccount', id: string } | undefined | null, stats: { __typename?: 'ExpenseBudgetItemStats', uninvoiced: number, credit: number }, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }> } | undefined | null };

export type CheckIfCreditAccountsBelongToTheSameTeamQueryVariables = Exact<{
  credit_account_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckIfCreditAccountsBelongToTheSameTeamQuery = { __typename?: 'Query', checkIfCreditAccountsBelongToTheSameTeam: boolean };

export type ProjectTitleFragment = { __typename?: 'Project', code: string, numeric_code?: string | undefined | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null } };

export type WipForBudgetAndPeriodQueryVariables = Exact<{
  our_work_budget_item_id: Scalars['ID']['input'];
  period_id: Scalars['ID']['input'];
}>;


export type WipForBudgetAndPeriodQuery = { __typename?: 'Query', wipForBudgetAndPeriod?: { __typename?: 'WorkInProgressItemStat', id: string, progress_percent: number, work_in_progress_id: string, is_closed: boolean, is_locked: boolean } | undefined | null };

export type WipPeriodsQueryVariables = Exact<{
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WipPeriodsQuery = { __typename?: 'Query', wipPeriodsMap: Array<{ __typename?: 'WipPeriod', id: string, title: string, starts_at: string, ends_at?: string | undefined | null, is_current: boolean }> };

export type AccessTokenForPlanovacQueryVariables = Exact<{
  appName?: InputMaybe<ThirdPartyEnum>;
}>;


export type AccessTokenForPlanovacQuery = { __typename?: 'Query', getAccessTokenForThirdParty?: string | undefined | null };

export type ArchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, archived_at?: string | undefined | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null } };

export type ArchiveProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveProjectsBulkMutation = { __typename?: 'Mutation', archiveProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UnarchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveProjectMutation = { __typename?: 'Mutation', unarchiveProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, archived_at?: string | undefined | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null } };

export type UnarchiveProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnarchiveProjectsBulkMutation = { __typename?: 'Mutation', unarchiveProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type ArchivedProjectDataFragment = { __typename?: 'Project', id: string, status: ProjectStatusEnum, archived_at?: string | undefined | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null };

export type BulkProjectUpdateMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: BulkUpdateProjectsInput;
}>;


export type BulkProjectUpdateMutation = { __typename?: 'Mutation', bulkUpdateProjects: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: string } };

export type DeleteProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteProjectsBulkMutation = { __typename?: 'Mutation', deleteProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type InvoiceProjectByTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  invoice_type: RequestForInvoicingTypeEnum;
}>;


export type InvoiceProjectByTypeMutation = { __typename?: 'Mutation', invoiceProject?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null };

export type InvoiceProjectsByTypeBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  invoice_type: RequestForInvoicingTypeEnum;
}>;


export type InvoiceProjectsByTypeBulkMutation = { __typename?: 'Mutation', invoiceProjectsBulk?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null };

export type PinProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PinProjectMutation = { __typename?: 'Mutation', pinProject: { __typename?: 'Project', id: string, is_pinned: boolean } };

export type PinProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PinProjectsBulkMutation = { __typename?: 'Mutation', pinProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UnpinProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnpinProjectMutation = { __typename?: 'Mutation', unpinProject: { __typename?: 'Project', id: string, is_pinned: boolean } };

export type UnpinProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnpinProjectsBulkMutation = { __typename?: 'Mutation', unpinProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type ProformaInvoiceProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProformaInvoiceProjectMutation = { __typename?: 'Mutation', proformaInvoiceProject?: { __typename?: 'RequestForInvoicing', id: string } | undefined | null };

export type ReopenProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReopenProjectMutation = { __typename?: 'Mutation', reopenProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, finished_at?: string | undefined | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | undefined | null } };

export type TimeTrackingPopoverItemsQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingPopoverItemsQuery = { __typename?: 'Query', timeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } }>, runningTimer?: { __typename?: 'Timer', id: string, timeTrackingItem?: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: string, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: string | undefined | null, specific_time_to?: string | undefined | null, note?: string | undefined | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | undefined | null, user?: { __typename?: 'User', id: string } | undefined | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | undefined | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } | undefined | null } | undefined | null };

export type AddAccountMovesToDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  documentType: BankDocumentTypeEnum;
  date: Scalars['Date']['input'];
  bankAccountMoves: Array<BankAccountMoveToDocumentInput> | BankAccountMoveToDocumentInput;
}>;


export type AddAccountMovesToDocumentMutation = { __typename?: 'Mutation', addBankAccountMovesToDocument?: boolean | undefined | null };

export type FilterTemplateFragmentFragment = { __typename?: 'FilterTemplate', id: string, model_id?: string | undefined | null, model_type: string, type?: string | undefined | null, name: string, params?: string | undefined | null, user_id?: string | undefined | null };

export type CreateFilterTemplateMutationVariables = Exact<{
  input: FilterTemplateInput;
}>;


export type CreateFilterTemplateMutation = { __typename?: 'Mutation', createFilterTemplate: { __typename?: 'FilterTemplate', id: string, model_id?: string | undefined | null, model_type: string, type?: string | undefined | null, name: string, params?: string | undefined | null, user_id?: string | undefined | null } };

export type DeleteFilterTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFilterTemplateMutation = { __typename?: 'Mutation', deleteFilterTemplate: boolean };

export type FilterTemplatesQueryVariables = Exact<{
  modelId?: InputMaybe<Scalars['ID']['input']>;
  modelType: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterTemplatesQuery = { __typename?: 'Query', filterTemplates: Array<{ __typename?: 'FilterTemplate', id: string, model_id?: string | undefined | null, model_type: string, type?: string | undefined | null, name: string, params?: string | undefined | null, user_id?: string | undefined | null }> };

export type WorkspaceAccountingAccountSettingsFragment = { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | undefined | null }> };

export type CostCenterFragment = { __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: string | undefined | null };

export type UpdateWorkspaceSettingsMutationVariables = Exact<{
  notifications: UpdateWorkspaceNotifications;
  tasks: InputWorkspaceTaskSettings;
  companies: InputWorkspaceCompanySetting;
  financial: InputWorkspaceFinancialSetting;
  accountingAccounts: InputUpdateWorkspaceAccountingAccountSettings;
  costCenters: InputUpdateWorkspaceAccountingCentreSettings;
  accountingVatClassifications: InputUpdateWorkspaceAccountingVatClassificationSettings;
  userManagement: InputWorkspaceUserManagementSetting;
  planningUtilization: InputWorkspacePlanningSetting;
  planningViewSettings: UpdatePlanningSettings;
  projects: InputUpdateWorkspaceProjectSettings;
  pipedrive?: InputMaybe<InputUpdateWorkspacePipedriveIntegration>;
}>;


export type UpdateWorkspaceSettingsMutation = { __typename?: 'Mutation', UpdateWorkspaceNotifications: Array<{ __typename?: 'WorkspaceNotification', id: string }>, updateWorkspaceTaskSettings: { __typename?: 'WorkspaceTaskSettings', show_done_tasks: boolean, use_current_assignee: boolean }, updateWorkspaceCompanies: Array<{ __typename?: 'WorkspaceCompanySetting', id: string }>, updateWorkspaceFinancialSettings: { __typename?: 'WorkspaceFinancialSetting', vat_rates: Array<{ __typename?: 'VatRate', id: string }> }, updateWorkspaceAccountingAccountSettings: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string }> }, updateWorkspaceAccountingCentreSettings: { __typename?: 'WorkspaceAccountingCentreSettings', accounting_centres: Array<{ __typename?: 'AccountingCentre', id: string }> }, updateWorkspaceAccountingVatClassificationSettings: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string }> }, updateWorkspaceUserManagementSettings: { __typename?: 'WorkspaceUserManagementSetting', require_two_factor_authentication: boolean }, updateWorkspacePlanningSettings: { __typename?: 'WorkspacePlanningSettings', specific_time_in_planning_enabled: boolean }, updatePlanningSettings: { __typename?: 'WorkspaceSettings', title?: string | undefined | null }, updateWorkspaceProjectSettings: { __typename?: 'WorkspaceProjectSettings', project_code_with_year: boolean }, updateWorkspacePipedriveIntegration: { __typename?: 'WorkspacePipedriveIntegration', settings?: { __typename?: 'WorkspacePipedriveSettings', pipedrive_stage_id?: string | undefined | null, project_stage_id?: string | undefined | null, project_billable?: boolean | undefined | null } | undefined | null } };

export type TestImapConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type TestImapConnectionMutation = { __typename?: 'Mutation', testWorkspaceAutoExpenseEmail: string };

export type CreateWorkspaceSmtpSettingsMutationVariables = Exact<{
  input: CreateWorkspaceSmtpSettingsInput;
}>;


export type CreateWorkspaceSmtpSettingsMutation = { __typename?: 'Mutation', createWorkspaceSmtpSettings: { __typename?: 'WorkspaceSmtpSettings', id: string, active: boolean, smtp_host?: string | undefined | null, smtp_port?: number | undefined | null, smtp_username?: string | undefined | null, smtp_encryption?: string | undefined | null, smtp_from_address?: string | undefined | null, smtp_from_name?: string | undefined | null } };

export type UpdateWorkspaceSmtpSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateWorkspaceSmtpSettingsInput;
}>;


export type UpdateWorkspaceSmtpSettingsMutation = { __typename?: 'Mutation', updateWorkspaceSmtpSettings: { __typename?: 'WorkspaceSmtpSettings', id: string, active: boolean, smtp_host?: string | undefined | null, smtp_port?: number | undefined | null, smtp_username?: string | undefined | null, smtp_encryption?: string | undefined | null, smtp_from_address?: string | undefined | null, smtp_from_name?: string | undefined | null } };

export type TestSmtpConnectionMutationVariables = Exact<{
  input: TestSmtpConnectionInput;
}>;


export type TestSmtpConnectionMutation = { __typename?: 'Mutation', testSmtpConnection: { __typename?: 'SmtpTestResult', error?: string | undefined | null, message: string, success: boolean } };

export type SendTestEmailMutationVariables = Exact<{
  input: CreateWorkspaceSmtpSettingsInput;
}>;


export type SendTestEmailMutation = { __typename?: 'Mutation', sendTestEmail: { __typename?: 'SmtpTestResult', error?: string | undefined | null, message: string, success: boolean } };

export type GlobalWorkspaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalWorkspaceSettingsQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, code: string, denomination: number }> | undefined | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string, is_default: boolean, user_count: number }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }>, workspaceAccountingAccountSetting: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | undefined | null }> }, workspaceAccountingVatClassificationSetting: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, centre: string, title: string, type: Accounting_Centre_Type, vat_rate_id?: string | undefined | null, deleted_at?: string | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | undefined | null }> }, workspaceSettings?: { __typename?: 'WorkspaceSettings', title?: string | undefined | null, setup_completed?: boolean | undefined | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: string | undefined | null, unpaid_banner_message?: string | undefined | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: string, working_to: string, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | undefined | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | undefined | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | undefined | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | undefined | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | undefined | null, show_disclaimer?: boolean | undefined | null, signature?: boolean | undefined | null, show_summary?: boolean | undefined | null, show_client_name?: boolean | undefined | null, show_client_details?: boolean | undefined | null, language?: string | undefined | null, our_work_show_commission?: boolean | undefined | null, title_page_with_vat?: boolean | undefined | null, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, hide_title_page?: boolean | undefined | null, add_billing_plan?: boolean | undefined | null, billing_plan_exchange_rate?: number | undefined | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | undefined | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | undefined | null, our_work_description?: boolean | undefined | null, our_work_vat_in_items?: boolean | undefined | null, our_work_show_discount?: boolean | undefined | null, expense_show_commission?: boolean | undefined | null, expense_show_quantity?: boolean | undefined | null, expense_show_unit?: boolean | undefined | null, expense_show_discount?: boolean | undefined | null, expense_show_description?: boolean | undefined | null, expense_show_vat_in_items?: boolean | undefined | null, show_client_and_brand?: boolean | undefined | null, show_project_name_full?: boolean | undefined | null, use_client_name_from_billing_entity?: boolean | undefined | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | undefined | null, disclaimer?: string | undefined | null } | undefined | null> | undefined | null } | undefined | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | undefined | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | undefined | null }> } | undefined | null };

export type TeamUsersQueryVariables = Exact<{
  team_id: Scalars['Mixed']['input'];
}>;


export type TeamUsersQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null }> };

export type WorkspaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceSettingsQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', name: string }>, workspaceSettings?: { __typename?: 'WorkspaceSettings', bmail_activated: boolean } | undefined | null, countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string }>, WorkspaceNotifications: Array<{ __typename?: 'WorkspaceNotification', database_enabled: boolean, description?: string | undefined | null, id: string, mail_enabled: boolean, name: string, roles_to_notify?: Array<string> | undefined | null, threshold?: number | undefined | null, threshold_type: NotificationThresholdTypeEnum, to_roles: boolean }>, workspaceTaskSettings: { __typename?: 'WorkspaceTaskSettings', show_done_tasks: boolean, use_current_assignee: boolean, task_statuses: Array<{ __typename?: 'WorkspaceTaskStatus', background_color: string, default: boolean, done: boolean, foreground_color: string, id?: string | undefined | null, name: string, order: number }>, task_priorities: Array<{ __typename?: 'WorkspaceTaskPriority', default: boolean, id?: string | undefined | null, name: string, order: number, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }> }, workspaceCompaniesSettings: Array<{ __typename?: 'WorkspaceCompanySetting', city?: string | undefined | null, country_id?: string | undefined | null, currency_id?: string | undefined | null, deleted: boolean, id: string, internal_name: string, is_default: boolean, name: string, registration_no?: string | undefined | null, street?: string | undefined | null, tax_no?: string | undefined | null, vat_no?: string | undefined | null, zip?: string | undefined | null, bank_accounts: Array<{ __typename?: 'WorkspaceBankAccount', account_holder_name?: string | undefined | null, bank_account?: string | undefined | null, bank_code?: string | undefined | null, bank_name?: string | undefined | null, bic: string, deleted: boolean, iban: string, id: string }>, sequences: Array<{ __typename?: 'WorkspaceSequence', id?: string | undefined | null, format: string, next_number: number, types: Array<SequenceTypesEnum> }>, pdfSettings: { __typename?: 'WorkspaceInvoicePdfSettings', logo_assignable_file?: { __typename?: 'AssignableFile', public_id: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | undefined | null } } | undefined | null, stamp_assignable_file?: { __typename?: 'AssignableFile', public_id: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | undefined | null } } | undefined | null } }>, workspaceFinancialSettings: { __typename?: 'WorkspaceFinancialSetting', default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, invoice_attachment_name_templates?: { __typename?: 'InvoiceAttachmentNameTemplates', outgoing_invoice?: string | undefined | null, outgoing_proforma?: string | undefined | null, payment_receipt?: string | undefined | null } | undefined | null, vat_rates: Array<{ __typename?: 'VatRate', id: string, amount: number, deleted: boolean, default: boolean }>, currencies: Array<{ __typename?: 'Currency', id: string, code: string, exchange_rate?: number | undefined | null, denomination: number }> }, defaultCurrencies?: Array<{ __typename?: 'DefaultCurrency', code: string, symbol: string } | undefined | null> | undefined | null, workspaceAccountingAccountSetting: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | undefined | null }> }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | undefined | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | undefined | null, workspaceAccountingCentreSetting: { __typename?: 'WorkspaceAccountingCentreSettings', accounting_centres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: string | undefined | null }> }, workspaceAccountingVatClassificationSetting: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, type: Accounting_Centre_Type, vat_rate_id?: string | undefined | null, centre: string, title: string, deleted_at?: string | undefined | null }> }, workspaceUserManagementSetting: { __typename?: 'WorkspaceUserManagementSetting', require_two_factor_authentication: boolean, teams: Array<{ __typename?: 'Team', id: string, name: string, deleted_at?: string | undefined | null, is_default: boolean, user_count: number }> }, updateWorkspacePlanningSettings: { __typename?: 'WorkspacePlanningSettings', working_from: string, working_to: string, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, hide_planning_total_daily_capacity: boolean, planning_alphabet_user_order: boolean, disable_home_office_in_planning: boolean, start_day_of_week: StartDayOfWeekEnum, default_utilization_range_from: number, default_utilization_range_to: number, planning_sort_prioritize_time_specific_items: boolean }, workspaceProjectSettings: { __typename?: 'WorkspaceProjectSettings', project_code_generator: ProjectCodeGeneratorEnum, project_code_length: number, project_code_with_year: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, create_default_task_enabled: boolean, create_default_task_only_to_our_work_category: boolean, our_work_budget_categories_count: number, project_count: number, automate_invoicing_plan_approval: boolean, enable_additional_brand_numeric_code: boolean }, banksQuery?: Array<{ __typename?: 'Bank', api_id: string, name: string, logo: string, url: string }> | undefined | null, workspacePipedriveIntegration: { __typename?: 'WorkspacePipedriveIntegration', initialization_url: string, settings?: { __typename?: 'WorkspacePipedriveSettings', pipedrive_stage_id?: string | undefined | null, project_stage_id?: string | undefined | null, project_billable?: boolean | undefined | null } | undefined | null }, workspaceAutoExpenseEmailSettings?: { __typename?: 'WorkspaceAutoExpenseEmailSettings', imap_host: string, imap_port: number, imap_username: string, imap_encryption: ImapEncryptionEnum, is_active: boolean } | undefined | null, workspaceSmtpSettings?: { __typename?: 'WorkspaceSmtpSettings', id: string, active: boolean, is_google_connected: boolean, is_microsoft_connected: boolean, smtp_host?: string | undefined | null, smtp_port?: number | undefined | null, smtp_username?: string | undefined | null, smtp_encryption?: string | undefined | null, smtp_from_address?: string | undefined | null, smtp_from_name?: string | undefined | null } | undefined | null };

export type TaskStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskStatsQuery = { __typename?: 'Query', task: { __typename?: 'Task', stats?: { __typename?: 'TaskStats', spent_time: number, planned_time: number } | undefined | null } };

export type WorkspaceAccountingVatClassificationSettingFragment = { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, centre: string, title: string, type: Accounting_Centre_Type, vat_rate_id?: string | undefined | null, deleted_at?: string | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | undefined | null }> };

export type WorkspaceCompanyFragment = { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, country?: { __typename?: 'Country', id: string } | undefined | null };

export type MeFragment = { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, email: string, codename?: string | undefined | null, enabled_two_factor_authentication: boolean, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string, default_rate: number } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null, roles: Array<{ __typename?: 'Role', id: string, name: string, documentLimits?: Array<{ __typename?: 'RoleDocumentLimit', document_type: DocumentLimitTypeEnum, limit: number }> | undefined | null }>, permissions: { __typename?: 'PermissionList', bank_read_all: boolean, brand_read: boolean, brand_create: boolean, brand_update: boolean, brand_delete: boolean, brand_archive: boolean, brand_updateManagers: boolean, client_read: boolean, client_create: boolean, client_update: boolean, client_delete: boolean, client_updateManagers: boolean, contractor_read: boolean, contractor_create: boolean, contractor_update: boolean, contractor_delete: boolean, user_read_all: boolean, user_read_own: boolean, user_create: boolean, user_scopeCreate: boolean, user_update_all: boolean, user_update_own: boolean, user_updatePersonalData: boolean, user_updateWorkData: boolean, user_updateScopeUser: boolean, user_updatePlanningData: boolean, user_updateAllfredData: boolean, user_delete: boolean, user_haveProjectsAssigned: boolean, user_profile_read: boolean, user_profile_update: boolean, user_password_update: boolean, user_accessAccountingAttributes: boolean, user_scope_all: boolean, user_scope_own: boolean, brandCreditAccount_read_all: boolean, brandCreditAccount_read_team: boolean, brandCreditAccount_read_own: boolean, brandCreditAccount_create: boolean, brandCreditAccount_update_all: boolean, brandCreditAccount_update_team: boolean, brandCreditAccount_update_own: boolean, brandCreditAccount_delete_all: boolean, brandCreditAccount_delete_team: boolean, brandCreditAccount_delete_own: boolean, brandCreditAccount_setBudgetCategories: boolean, credit_transfer_fromBudgetItem: boolean, credit_transfer_fromBrandCreditAccount: boolean, credit_transfer_betweenTeams: boolean, credit_transfer_withDate: boolean, credit_prepayment: boolean, contract_read: boolean, contract_create: boolean, contract_update: boolean, contract_delete: boolean, order_read: boolean, order_create: boolean, order_update: boolean, order_delete: boolean, otherDocument_read: boolean, otherDocument_create: boolean, otherDocument_update: boolean, otherDocument_delete: boolean, expense_read_all: boolean, expense_read_own: boolean, expense_read_team: boolean, expense_read_excludeRestrictedTeams: boolean, expense_create: boolean, expense_update_all: boolean, expense_update_own: boolean, expense_update_team: boolean, expense_delete_all: boolean, expense_delete_own: boolean, expense_delete_team: boolean, expense_markAsPaid: boolean, expense_deleteFiles: boolean, expense_approve: boolean, expense_accessAccountingAttributes: boolean, expense_accessImported: boolean, expense_canApproveBudgetItem: boolean, expense_modelLock: boolean, requestForInvoicing_read_all: boolean, requestForInvoicing_read_own: boolean, requestForInvoicing_read_team: boolean, requestForInvoicing_create_all: boolean, requestForInvoicing_create_own: boolean, requestForInvoicing_create_team: boolean, requestForInvoicing_update_all: boolean, requestForInvoicing_update_own: boolean, requestForInvoicing_update_team: boolean, requestForInvoicing_delete_all: boolean, requestForInvoicing_delete_own: boolean, requestForInvoicing_delete_team: boolean, requestForInvoicing_accessAccountingAttributes: boolean, requestForInvoicing_querySubmittedCount_all: boolean, requestForInvoicing_querySubmittedCount_own: boolean, outgoingInvoice_read_all: boolean, outgoingInvoice_read_own: boolean, outgoingInvoice_read_team: boolean, outgoingInvoice_create: boolean, outgoingInvoice_update_all: boolean, outgoingInvoice_update_own: boolean, outgoingInvoice_update_team: boolean, outgoingInvoice_delete_all: boolean, outgoingInvoice_delete_own: boolean, outgoingInvoice_delete_team: boolean, outgoingInvoice_accessAccountingAttributes: boolean, outgoingInvoice_markAsPaid: boolean, outgoingInvoice_sendToClient: boolean, outgoingInvoice_updateInvoiceNumber: boolean, outgoingInvoice_modelLock: boolean, project_accessAccountingAttributes: boolean, project_viewAllFields: boolean, project_read_all: boolean, project_read_own: boolean, project_read_team: boolean, project_read_excludeRestrictedTeams: boolean, project_create_all: boolean, project_create_own: boolean, project_create_team: boolean, project_update_all: boolean, project_update_own: boolean, project_update_team: boolean, project_delete_all: boolean, project_delete_own: boolean, project_delete_team: boolean, project_pin_all: boolean, project_pin_own: boolean, project_pin_team: boolean, project_finish_all: boolean, project_finish_own: boolean, project_finish_team: boolean, project_reopen_all: boolean, project_reopen_own: boolean, project_reopen_team: boolean, project_archive_all: boolean, project_archive_own: boolean, project_archive_team: boolean, project_duplicate_all: boolean, project_duplicate_own: boolean, project_duplicate_team: boolean, project_timeTrackingReport_read_all: boolean, project_timeTrackingReport_read_own: boolean, project_timeTrackingReport_read_team: boolean, project_budget_update_all: boolean, project_budget_update_own: boolean, project_budget_update_team: boolean, project_budget_completeExpenseBudgetItem_all: boolean, project_budget_completeExpenseBudgetItem_own: boolean, project_budget_completeExpenseBudgetItem_team: boolean, project_budget_reopenExpenseBudgetItem_all: boolean, project_budget_reopenExpenseBudgetItem_own: boolean, project_budget_reopenExpenseBudgetItem_team: boolean, project_lockBillingPlan: boolean, project_billingTime_lock: boolean, projectCategory_query: boolean, projectCategory_create: boolean, projectCategory_update: boolean, projectCategory_delete: boolean, wip_submit_all: boolean, wip_submit_own: boolean, wip_submit_team: boolean, wip_lock_all: boolean, wip_lock_own: boolean, wip_lock_team: boolean, wip_read_all: boolean, wip_read_own: boolean, wip_read_team: boolean, wip_unlock_all: boolean, wip_unlock_own: boolean, wip_unlock_team: boolean, wip_close_all: boolean, wip_close_own: boolean, wip_close_team: boolean, wip_open_all: boolean, wip_open_own: boolean, wip_open_team: boolean, timeTracking_read_all: boolean, timeTracking_read_own: boolean, timeTracking_read_team: boolean, timeTracking_create_all: boolean, timeTracking_create_own: boolean, timeTracking_create_team: boolean, timeTracking_update_all: boolean, timeTracking_update_own: boolean, timeTracking_update_team: boolean, timeTracking_delete_all: boolean, timeTracking_delete_own: boolean, timeTracking_delete_team: boolean, timeTracking_timer_use_all: boolean, timeTracking_timer_use_own: boolean, timeTracking_timer_use_team: boolean, timeTracking_timer_use_manual: boolean, timeTracking_report_read_all: boolean, timeTracking_report_read_team: boolean, timeTracking_report_read_own: boolean, timeTracking_userMonthlyReport_read: boolean, billingPlan_create: boolean, billingPlan_update: boolean, billingPlan_listing: boolean, integration_budgetovac: boolean, integration_forecasting: boolean, task_viewAllFields: boolean, task_read_all: boolean, task_read_own: boolean, task_create_all: boolean, task_create_scoped: boolean, task_update_all: boolean, task_update_own: boolean, task_update_scoped: boolean, task_delete_all: boolean, task_delete_own: boolean, task_update_status_own: boolean, task_update_status_all: boolean, task_update_current_assignee_own: boolean, task_update_current_assignee_all: boolean, taskComment_create: boolean, taskComment_update_own: boolean, taskComment_update_all: boolean, taskComment_delete_own: boolean, taskComment_delete_all?: boolean | undefined | null, assignableFile_create: boolean, assignableFile_delete_all: boolean, assignableFile_delete_own: boolean, planning_create_all: boolean, planning_create_own: boolean, planning_update_all: boolean, planning_update_own: boolean, planning_delete_all: boolean, planning_delete_own: boolean, planning_complete_all: boolean, planning_complete_own: boolean, planning_play_own: boolean, planning_read_all: boolean, planning_read_own: boolean, planning_show_daily_capacity: boolean, profitLossReport_query_all: boolean, workspaceSetting_edit: boolean, notificationSetting_query: boolean, notificationSetting_update: boolean, utilizationReport_query_all: boolean, utilizationReport_query_own: boolean, utilizationReport_query_team: boolean, utilizationReportProfit_query_all: boolean, budget_read_all: boolean, budget_read_own: boolean, budget_read_team: boolean, quote_create_withoutInternalApproved: boolean, quote_manualApprove: boolean } };

export type WorkspaceSettingsFragment = { __typename?: 'WorkspaceSettings', title?: string | undefined | null, setup_completed?: boolean | undefined | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: string | undefined | null, unpaid_banner_message?: string | undefined | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: string, working_to: string, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | undefined | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | undefined | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | undefined | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | undefined | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | undefined | null, show_disclaimer?: boolean | undefined | null, signature?: boolean | undefined | null, show_summary?: boolean | undefined | null, show_client_name?: boolean | undefined | null, show_client_details?: boolean | undefined | null, language?: string | undefined | null, our_work_show_commission?: boolean | undefined | null, title_page_with_vat?: boolean | undefined | null, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, hide_title_page?: boolean | undefined | null, add_billing_plan?: boolean | undefined | null, billing_plan_exchange_rate?: number | undefined | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | undefined | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | undefined | null, our_work_description?: boolean | undefined | null, our_work_vat_in_items?: boolean | undefined | null, our_work_show_discount?: boolean | undefined | null, expense_show_commission?: boolean | undefined | null, expense_show_quantity?: boolean | undefined | null, expense_show_unit?: boolean | undefined | null, expense_show_discount?: boolean | undefined | null, expense_show_description?: boolean | undefined | null, expense_show_vat_in_items?: boolean | undefined | null, show_client_and_brand?: boolean | undefined | null, show_project_name_full?: boolean | undefined | null, use_client_name_from_billing_entity?: boolean | undefined | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | undefined | null, disclaimer?: string | undefined | null } | undefined | null> | undefined | null } | undefined | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | undefined | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | undefined | null }> };

export type LoginQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | undefined | null }> | undefined | null, me?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, email: string, codename?: string | undefined | null, enabled_two_factor_authentication: boolean, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string, default_rate: number } } | undefined | null, team?: { __typename?: 'Team', id: string, name: string } | undefined | null, roles: Array<{ __typename?: 'Role', id: string, name: string, documentLimits?: Array<{ __typename?: 'RoleDocumentLimit', document_type: DocumentLimitTypeEnum, limit: number }> | undefined | null }>, permissions: { __typename?: 'PermissionList', bank_read_all: boolean, brand_read: boolean, brand_create: boolean, brand_update: boolean, brand_delete: boolean, brand_archive: boolean, brand_updateManagers: boolean, client_read: boolean, client_create: boolean, client_update: boolean, client_delete: boolean, client_updateManagers: boolean, contractor_read: boolean, contractor_create: boolean, contractor_update: boolean, contractor_delete: boolean, user_read_all: boolean, user_read_own: boolean, user_create: boolean, user_scopeCreate: boolean, user_update_all: boolean, user_update_own: boolean, user_updatePersonalData: boolean, user_updateWorkData: boolean, user_updateScopeUser: boolean, user_updatePlanningData: boolean, user_updateAllfredData: boolean, user_delete: boolean, user_haveProjectsAssigned: boolean, user_profile_read: boolean, user_profile_update: boolean, user_password_update: boolean, user_accessAccountingAttributes: boolean, user_scope_all: boolean, user_scope_own: boolean, brandCreditAccount_read_all: boolean, brandCreditAccount_read_team: boolean, brandCreditAccount_read_own: boolean, brandCreditAccount_create: boolean, brandCreditAccount_update_all: boolean, brandCreditAccount_update_team: boolean, brandCreditAccount_update_own: boolean, brandCreditAccount_delete_all: boolean, brandCreditAccount_delete_team: boolean, brandCreditAccount_delete_own: boolean, brandCreditAccount_setBudgetCategories: boolean, credit_transfer_fromBudgetItem: boolean, credit_transfer_fromBrandCreditAccount: boolean, credit_transfer_betweenTeams: boolean, credit_transfer_withDate: boolean, credit_prepayment: boolean, contract_read: boolean, contract_create: boolean, contract_update: boolean, contract_delete: boolean, order_read: boolean, order_create: boolean, order_update: boolean, order_delete: boolean, otherDocument_read: boolean, otherDocument_create: boolean, otherDocument_update: boolean, otherDocument_delete: boolean, expense_read_all: boolean, expense_read_own: boolean, expense_read_team: boolean, expense_read_excludeRestrictedTeams: boolean, expense_create: boolean, expense_update_all: boolean, expense_update_own: boolean, expense_update_team: boolean, expense_delete_all: boolean, expense_delete_own: boolean, expense_delete_team: boolean, expense_markAsPaid: boolean, expense_deleteFiles: boolean, expense_approve: boolean, expense_accessAccountingAttributes: boolean, expense_accessImported: boolean, expense_canApproveBudgetItem: boolean, expense_modelLock: boolean, requestForInvoicing_read_all: boolean, requestForInvoicing_read_own: boolean, requestForInvoicing_read_team: boolean, requestForInvoicing_create_all: boolean, requestForInvoicing_create_own: boolean, requestForInvoicing_create_team: boolean, requestForInvoicing_update_all: boolean, requestForInvoicing_update_own: boolean, requestForInvoicing_update_team: boolean, requestForInvoicing_delete_all: boolean, requestForInvoicing_delete_own: boolean, requestForInvoicing_delete_team: boolean, requestForInvoicing_accessAccountingAttributes: boolean, requestForInvoicing_querySubmittedCount_all: boolean, requestForInvoicing_querySubmittedCount_own: boolean, outgoingInvoice_read_all: boolean, outgoingInvoice_read_own: boolean, outgoingInvoice_read_team: boolean, outgoingInvoice_create: boolean, outgoingInvoice_update_all: boolean, outgoingInvoice_update_own: boolean, outgoingInvoice_update_team: boolean, outgoingInvoice_delete_all: boolean, outgoingInvoice_delete_own: boolean, outgoingInvoice_delete_team: boolean, outgoingInvoice_accessAccountingAttributes: boolean, outgoingInvoice_markAsPaid: boolean, outgoingInvoice_sendToClient: boolean, outgoingInvoice_updateInvoiceNumber: boolean, outgoingInvoice_modelLock: boolean, project_accessAccountingAttributes: boolean, project_viewAllFields: boolean, project_read_all: boolean, project_read_own: boolean, project_read_team: boolean, project_read_excludeRestrictedTeams: boolean, project_create_all: boolean, project_create_own: boolean, project_create_team: boolean, project_update_all: boolean, project_update_own: boolean, project_update_team: boolean, project_delete_all: boolean, project_delete_own: boolean, project_delete_team: boolean, project_pin_all: boolean, project_pin_own: boolean, project_pin_team: boolean, project_finish_all: boolean, project_finish_own: boolean, project_finish_team: boolean, project_reopen_all: boolean, project_reopen_own: boolean, project_reopen_team: boolean, project_archive_all: boolean, project_archive_own: boolean, project_archive_team: boolean, project_duplicate_all: boolean, project_duplicate_own: boolean, project_duplicate_team: boolean, project_timeTrackingReport_read_all: boolean, project_timeTrackingReport_read_own: boolean, project_timeTrackingReport_read_team: boolean, project_budget_update_all: boolean, project_budget_update_own: boolean, project_budget_update_team: boolean, project_budget_completeExpenseBudgetItem_all: boolean, project_budget_completeExpenseBudgetItem_own: boolean, project_budget_completeExpenseBudgetItem_team: boolean, project_budget_reopenExpenseBudgetItem_all: boolean, project_budget_reopenExpenseBudgetItem_own: boolean, project_budget_reopenExpenseBudgetItem_team: boolean, project_lockBillingPlan: boolean, project_billingTime_lock: boolean, projectCategory_query: boolean, projectCategory_create: boolean, projectCategory_update: boolean, projectCategory_delete: boolean, wip_submit_all: boolean, wip_submit_own: boolean, wip_submit_team: boolean, wip_lock_all: boolean, wip_lock_own: boolean, wip_lock_team: boolean, wip_read_all: boolean, wip_read_own: boolean, wip_read_team: boolean, wip_unlock_all: boolean, wip_unlock_own: boolean, wip_unlock_team: boolean, wip_close_all: boolean, wip_close_own: boolean, wip_close_team: boolean, wip_open_all: boolean, wip_open_own: boolean, wip_open_team: boolean, timeTracking_read_all: boolean, timeTracking_read_own: boolean, timeTracking_read_team: boolean, timeTracking_create_all: boolean, timeTracking_create_own: boolean, timeTracking_create_team: boolean, timeTracking_update_all: boolean, timeTracking_update_own: boolean, timeTracking_update_team: boolean, timeTracking_delete_all: boolean, timeTracking_delete_own: boolean, timeTracking_delete_team: boolean, timeTracking_timer_use_all: boolean, timeTracking_timer_use_own: boolean, timeTracking_timer_use_team: boolean, timeTracking_timer_use_manual: boolean, timeTracking_report_read_all: boolean, timeTracking_report_read_team: boolean, timeTracking_report_read_own: boolean, timeTracking_userMonthlyReport_read: boolean, billingPlan_create: boolean, billingPlan_update: boolean, billingPlan_listing: boolean, integration_budgetovac: boolean, integration_forecasting: boolean, task_viewAllFields: boolean, task_read_all: boolean, task_read_own: boolean, task_create_all: boolean, task_create_scoped: boolean, task_update_all: boolean, task_update_own: boolean, task_update_scoped: boolean, task_delete_all: boolean, task_delete_own: boolean, task_update_status_own: boolean, task_update_status_all: boolean, task_update_current_assignee_own: boolean, task_update_current_assignee_all: boolean, taskComment_create: boolean, taskComment_update_own: boolean, taskComment_update_all: boolean, taskComment_delete_own: boolean, taskComment_delete_all?: boolean | undefined | null, assignableFile_create: boolean, assignableFile_delete_all: boolean, assignableFile_delete_own: boolean, planning_create_all: boolean, planning_create_own: boolean, planning_update_all: boolean, planning_update_own: boolean, planning_delete_all: boolean, planning_delete_own: boolean, planning_complete_all: boolean, planning_complete_own: boolean, planning_play_own: boolean, planning_read_all: boolean, planning_read_own: boolean, planning_show_daily_capacity: boolean, profitLossReport_query_all: boolean, workspaceSetting_edit: boolean, notificationSetting_query: boolean, notificationSetting_update: boolean, utilizationReport_query_all: boolean, utilizationReport_query_own: boolean, utilizationReport_query_team: boolean, utilizationReportProfit_query_all: boolean, budget_read_all: boolean, budget_read_own: boolean, budget_read_team: boolean, quote_create_withoutInternalApproved: boolean, quote_manualApprove: boolean } } | undefined | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string, is_default: boolean, user_count: number }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | undefined | null, emoji?: string | undefined | null }>, workspaceAccountingAccountSetting: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | undefined | null }> }, workspaceSettings?: { __typename?: 'WorkspaceSettings', title?: string | undefined | null, setup_completed?: boolean | undefined | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: string | undefined | null, unpaid_banner_message?: string | undefined | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: string, working_to: string, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | undefined | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | undefined | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | undefined | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | undefined | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | undefined | null, show_disclaimer?: boolean | undefined | null, signature?: boolean | undefined | null, show_summary?: boolean | undefined | null, show_client_name?: boolean | undefined | null, show_client_details?: boolean | undefined | null, language?: string | undefined | null, our_work_show_commission?: boolean | undefined | null, title_page_with_vat?: boolean | undefined | null, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, hide_title_page?: boolean | undefined | null, add_billing_plan?: boolean | undefined | null, billing_plan_exchange_rate?: number | undefined | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | undefined | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | undefined | null, our_work_description?: boolean | undefined | null, our_work_vat_in_items?: boolean | undefined | null, our_work_show_discount?: boolean | undefined | null, expense_show_commission?: boolean | undefined | null, expense_show_quantity?: boolean | undefined | null, expense_show_unit?: boolean | undefined | null, expense_show_discount?: boolean | undefined | null, expense_show_description?: boolean | undefined | null, expense_show_vat_in_items?: boolean | undefined | null, show_client_and_brand?: boolean | undefined | null, show_project_name_full?: boolean | undefined | null, use_client_name_from_billing_entity?: boolean | undefined | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | undefined | null, disclaimer?: string | undefined | null } | undefined | null> | undefined | null } | undefined | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | undefined | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | undefined | null }> } | undefined | null, workspaceAccountingVatClassificationSetting: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, centre: string, title: string, type: Accounting_Centre_Type, vat_rate_id?: string | undefined | null, deleted_at?: string | undefined | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | undefined | null }> } };

export type ModelLockFragment = { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null };

export type LockModelMutationVariables = Exact<{
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type LockModelMutation = { __typename?: 'Mutation', lockModel: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } };

export type UnlockModelMutationVariables = Exact<{
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type UnlockModelMutation = { __typename?: 'Mutation', unlockModel: boolean };

export type BulkLockModelMutationVariables = Exact<{
  lockable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type BulkLockModelMutation = { __typename?: 'Mutation', bulkLockModel: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type BulkUnlockModelMutationVariables = Exact<{
  lockable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type BulkUnlockModelMutation = { __typename?: 'Mutation', bulkUnlockModel: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type GetModelLockQueryVariables = Exact<{
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type GetModelLockQuery = { __typename?: 'Query', getModelLock?: { __typename?: 'ModelLock', id: string, locked_at: string, deleted_at?: string | undefined | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | undefined | null } | undefined | null };

export type ProjectStageFragment = { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | undefined | null };

export type UpdateProjectStageMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  projectStageId: Scalars['ID']['input'];
}>;


export type UpdateProjectStageMutation = { __typename?: 'Mutation', updateProjectStage?: { __typename?: 'Project', id: string, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | undefined | null } | undefined | null } | undefined | null };

export type PipedriveDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PipedriveDataQuery = { __typename?: 'Query', getPipedriveStages?: Array<{ __typename?: 'PipedriveStage', pipedrive_stage_id: string, name: string }> | undefined | null, projectStages: Array<{ __typename?: 'ProjectStage', id: string, name: string, system_name?: string | undefined | null }> };

export type QuoteEmailDataQueryVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;


export type QuoteEmailDataQuery = { __typename?: 'Query', GetQuoteEmailData: { __typename?: 'QuoteEmailData', primary_recipient?: string | undefined | null, recipients?: Array<string | undefined | null> | undefined | null, subject: string, content: string, attachments?: Array<{ __typename?: 'QuoteAttachment', name: string, link: string }> | undefined | null } };

export type StarFragment = { __typename?: 'Star', id: string, starable_id: string, starable_type: StarsStarableTypeEnum, created_at: string, updated_at?: string | undefined | null };

export type StarMutationVariables = Exact<{
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type StarMutation = { __typename?: 'Mutation', star: { __typename?: 'Star', id: string, starable_id: string, starable_type: StarsStarableTypeEnum, created_at: string, updated_at?: string | undefined | null } };

export type UnstarMutationVariables = Exact<{
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type UnstarMutation = { __typename?: 'Mutation', unstar: boolean };

export type BulkStarMutationVariables = Exact<{
  starable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type BulkStarMutation = { __typename?: 'Mutation', bulkStar: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type BulkUnstarMutationVariables = Exact<{
  starable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type BulkUnstarMutation = { __typename?: 'Mutation', bulkUnstar: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type TagFragment = { __typename?: 'Tag', id: string, title: string };

export type CreateTagMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'Tag', id: string, title: string } | undefined | null };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'Tag', id: string, title: string } | undefined | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: boolean | undefined | null };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', getTags?: Array<{ __typename?: 'Tag', id: string, title: string }> | undefined | null };

export type AllocationItemsSelectOptionsQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  task_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllocationItemsSelectOptionsQuery = { __typename?: 'Query', capacityAllocationItemList: Array<{ __typename?: 'CapacityAllocationItem', id: string, from_time?: string | undefined | null, to_time?: string | undefined | null, total_time: number, note?: string | undefined | null, capacityAllocation: { __typename?: 'CapacityAllocation', task?: { __typename?: 'Task', name: string } | undefined | null } }> };

export type CapacityAllocationUserItemDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  today: Scalars['Date']['input'];
}>;


export type CapacityAllocationUserItemDetailQuery = { __typename?: 'Query', capacityAllocationItemDetailQuery?: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, time_tracking_work_type_id?: string | undefined | null, duration_changed: boolean, date: string, from_time?: string | undefined | null, to_time?: string | undefined | null, note?: string | undefined | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | undefined | null, global?: boolean | undefined | null, time_off_duration_type?: TimeOffDurationTypeEnum | undefined | null, meetLink?: string | undefined | null, eventLink?: string | undefined | null, seriesSummary: { __typename?: 'CapacityAllocationSeriesSummary', any_duration_changed: boolean, future_open_total_time: number, same_day_open_count: number, same_day_open_total_time: number, futureCompletedPerUser: Array<{ __typename?: 'CapacityAllocationUserCompletedCount', user_id: string, count: number }> }, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }, userStats?: { __typename?: 'CapacityAllocationUserItemStats', capacity_allocation_item_id: string, tracked_time_for_item?: number | undefined | null, has_running_timer: boolean } | undefined | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string, name: string } }> | undefined | null, userItems: Array<{ __typename?: 'CapacityAllocationItem', id: string, time_tracking_work_type_id?: string | undefined | null, user: { __typename?: 'User', id: string, full_name: string } }>, capacityAllocation: { __typename?: 'CapacityAllocation', id: string, deadline?: string | undefined | null, deadline_time?: string | undefined | null, location?: string | undefined | null, created_at: string, create_task_positions: boolean, from_time?: string | undefined | null, to_time?: string | undefined | null, total_time: number, from_date: string, to_date: string, total_time_per_day?: number | undefined | null, note?: string | undefined | null, title?: string | undefined | null, repetition: CapacityAllocationRepetitionTypeEnum, deleted_items: boolean, repetition_settings?: { __typename?: 'RepetitionSettings', include_holidays?: boolean | undefined | null, days?: Array<RepetitionSettingsDaysEnum | undefined | null> | undefined | null, every: number, startType?: TimeOffDurationTypeEnum | undefined | null, toType?: TimeOffDurationTypeEnum | undefined | null, end: string } | undefined | null, task?: { __typename?: 'Task', id: string, name: string, billable: boolean, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, project: { __typename?: 'Project', id: string, title: string, code: string } } | undefined | null } | undefined | null, createdBy: { __typename?: 'User', id: string }, calendarParticipants: Array<{ __typename?: 'CalendarEventParticipant', id: string, email: string, display_name?: string | undefined | null }> }, stats?: { __typename?: 'CapacityAllocationItemStats', tracking_enabled?: boolean | undefined | null, tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null } | undefined | null, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | undefined | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null } } | undefined | null };

export type BrandSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandSelectOptionsQuery = { __typename?: 'Query', brandsSimpleMap: Array<{ __typename?: 'BrandSimple', name: string, id: string }> };

export type CompleteCapacityAllocationItemMutationVariables = Exact<{
  input: CompleteCapacityAllocationUserInput;
}>;


export type CompleteCapacityAllocationItemMutation = { __typename?: 'Mutation', completeCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, user: { __typename?: 'User', id: string } } };

export type ReopenCapacityAllocationItemMutationVariables = Exact<{
  input: ReopenCapacityAllocationItemInput;
}>;


export type ReopenCapacityAllocationItemMutation = { __typename?: 'Mutation', reopenCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, user: { __typename?: 'User', id: string } } };

export type DeleteCapacityAllocationMutationVariables = Exact<{
  input: DeleteCapacityAllocationInput;
}>;


export type DeleteCapacityAllocationMutation = { __typename?: 'Mutation', deleteCapacityAllocation: { __typename?: 'CapacityAllocation', id: string } };

export type DeleteCapacityAllocationItemMutationVariables = Exact<{
  input: DeleteCapacityAllocationItemInput;
}>;


export type DeleteCapacityAllocationItemMutation = { __typename?: 'Mutation', deleteCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string } };

export type DeleteCapacityAllocationForDayMutationVariables = Exact<{
  input: DeleteCapacityAllocationForDayInput;
}>;


export type DeleteCapacityAllocationForDayMutation = { __typename?: 'Mutation', deleteCapacityAllocationForDay: { __typename?: 'CapacityAllocation', id: string } };

export type DuplicateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  with_tasks: Scalars['Boolean']['input'];
  with_task_attachments: Scalars['Boolean']['input'];
}>;


export type DuplicateProjectMutation = { __typename?: 'Mutation', duplicateProject: { __typename?: 'Project', id: string } };

export type GetWorkTypeOptionsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type GetWorkTypeOptionsQuery = { __typename?: 'Query', task: { __typename?: 'Task', ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } } | undefined | null } };

export type UpdatePlanningSettingsMutationVariables = Exact<{
  input: UpdatePlanningSettings;
}>;


export type UpdatePlanningSettingsMutation = { __typename?: 'Mutation', updatePlanningSettings: { __typename?: 'WorkspaceSettings', title?: string | undefined | null, setup_completed?: boolean | undefined | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: string | undefined | null, unpaid_banner_message?: string | undefined | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: string, working_to: string, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | undefined | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | undefined | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | undefined | null> | undefined | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | undefined | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | undefined | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: string | undefined | null, valid_to?: string | undefined | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | undefined | null, show_disclaimer?: boolean | undefined | null, signature?: boolean | undefined | null, show_summary?: boolean | undefined | null, show_client_name?: boolean | undefined | null, show_client_details?: boolean | undefined | null, language?: string | undefined | null, our_work_show_commission?: boolean | undefined | null, title_page_with_vat?: boolean | undefined | null, workspace_company_id: string, workspace_bank_account_id?: string | undefined | null, billing_entity_id?: string | undefined | null, hide_title_page?: boolean | undefined | null, add_billing_plan?: boolean | undefined | null, billing_plan_exchange_rate?: number | undefined | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | undefined | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | undefined | null, our_work_description?: boolean | undefined | null, our_work_vat_in_items?: boolean | undefined | null, our_work_show_discount?: boolean | undefined | null, expense_show_commission?: boolean | undefined | null, expense_show_quantity?: boolean | undefined | null, expense_show_unit?: boolean | undefined | null, expense_show_discount?: boolean | undefined | null, expense_show_description?: boolean | undefined | null, expense_show_vat_in_items?: boolean | undefined | null, show_client_and_brand?: boolean | undefined | null, show_project_name_full?: boolean | undefined | null, use_client_name_from_billing_entity?: boolean | undefined | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | undefined | null, disclaimer?: string | undefined | null } | undefined | null> | undefined | null } | undefined | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | undefined | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | undefined | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | undefined | null }> } };

export type PositionSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PositionSelectOptionsQuery = { __typename?: 'Query', timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }> };

export type PositionsForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type PositionsForProjectQuery = { __typename?: 'Query', projectForTask: { __typename?: 'ProjectForTask', id: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type ProjectManagersSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectManagersSelectOptionsQuery = { __typename?: 'Query', projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }> };

export type ProjectSelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectSelectOptionsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, archived_at?: string | undefined | null, finished_at?: string | undefined | null, brand: { __typename?: 'Brand', id: string, name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type RoleSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleSelectOptionsQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string }> };

export type TaskSelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TaskQueryArgs>;
}>;


export type TaskSelectOptionsQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', data: Array<{ __typename?: 'Task', id: string, name: string, billable: boolean, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | undefined | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string }, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: string | undefined | null, tracking_enabled_to?: string | undefined | null, tracking_enabled: boolean } } | undefined | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined | null, hasMorePages: boolean, lastItem?: number | undefined | null, lastPage: number, perPage: number, total: number } } | undefined | null };

export type TeamSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamSelectOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type TimeOffTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeOffTypeOptionsQuery = { __typename?: 'Query', timeOffTypesQuery?: Array<{ __typename?: 'TimeOffType', id: string, name: string }> | undefined | null };

export type UsersSelectOptionsQueryVariables = Exact<{
  onlyPlannable?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UsersWhereConditions>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UsersSelectOptionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | undefined | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | undefined | null } } | undefined | null, profile?: { __typename?: 'UserProfile', hex_color: string } | undefined | null }> };

export type BudgetItemsForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BudgetItemsForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }> }> } | undefined | null };

export const AccountMoveFragmentDoc = gql`
    fragment AccountMove on BankAccountMove {
  id
  bank_account_id
  amount
  currency {
    id
    code
    denomination
    exchange_rate
  }
  note
  reference
  vs
  ss
  ks
  status
  type
  date
  balance
  iban
  documents {
    id
    bank_account_move_id
    document_id
    document_type
    document_no
    amount
    date
    document_currency {
      id
      code
      denomination
    }
    exchange_rate
  }
}
    `;
export const BillingEntityModalFragmentDoc = gql`
    fragment BillingEntityModal on BillingEntity {
  id
  internal_name
  legal_name
  street
  city
  zip
  registration_no
  tax_no
  vat_no
  applies_vat
  payment_due
  invoice_email
  note
  language
  disable_email_notification
  country {
    id
    name
  }
  defaultCurrency {
    id
    code
  }
  workspaceCompany {
    id
    name
  }
  workspaceBankAccount {
    id
    iban
  }
}
    `;
export const BrandModalFragmentDoc = gql`
    fragment BrandModal on Brand {
  id
  name
  code
  numeric_code
  image {
    urls {
      thumbnail
    }
  }
  defaultBillingEntity {
    id
  }
}
    `;
export const BudgetGroupFragmentDoc = gql`
    fragment BudgetGroup on BudgetGroup {
  budget_name
  budget_number
  budgets {
    id
    project_id
    project {
      id
      title
    }
    brand {
      id
      name
    }
    description
    account_manager
    assignment_date
    status
    internally_approved
    client_approved
    is_active
    version
    price
    temporaryBrand {
      name
    }
    temporary_project_id
    temporaryProject {
      name
      is_archived
    }
    currency {
      id
      code
      denomination
    }
    created_at
    updated_at
    quotes {
      id
      url
      number
    }
  }
}
    `;
export const BudgetovacPositionPriceFragmentDoc = gql`
    fragment BudgetovacPositionPrice on BudgetovacPositionPrice {
  alias
  department_id
  department_name
  name
  position_id
  price
}
    `;
export const BudgetovacPositionsSetFragmentDoc = gql`
    fragment BudgetovacPositionsSet on BudgetovacPositionsSet {
  id
  name
  active
  client_id
  currency_code
  internal_production_commission
  external_production_commission
  media_budget_commission
  extras_commission
  positions_prices {
    ...BudgetovacPositionPrice
  }
}
    ${BudgetovacPositionPriceFragmentDoc}`;
export const BudgetovacPositionFragmentDoc = gql`
    fragment BudgetovacPosition on BudgetovacPosition {
  id
  name
  department_id
}
    `;
export const ContractorModelFragmentDoc = gql`
    fragment ContractorModel on Contractor {
  id
  legal_name
  street
  city
  zip
  registration_no
  tax_no
  vat_no
  national_id
  iban
  swift
  is_vat_payer
  business_form
  bank_account
  bank_account_code
  country {
    id
    name
    code
  }
  defaultAccountingAccount {
    id
  }
}
    `;
export const GlobalCreditAccountFragmentDoc = gql`
    fragment GlobalCreditAccount on GlobalCreditAccount {
  id
  title
  note
  creditAccount {
    id
    team {
      id
      name
    }
    created_at
    updated_at
  }
  stats {
    id
    remaining_credit
    total_credit
    total_debit
  }
  credits {
    id
    credit
    date
  }
  debits {
    id
    credit
    performed_at
    credit_account_operation_id
    expenseBudgetItem {
      id
      title
    }
  }
  created_at
  updated_at
}
    `;
export const ExternalLinkFragmentFragmentDoc = gql`
    fragment ExternalLinkFragment on ExternalLink {
  id
  title
  link
  model_id
  model_type
}
    `;
export const ExpenseItemDescriptionFragmentDoc = gql`
    fragment ExpenseItemDescription on ExpenseItemDesciption {
  id
  title
  deleted_at
}
    `;
export const OurWorkBudgetItemByCodeFragmentDoc = gql`
    fragment OurWorkBudgetItemByCode on OurWorkBudgetItemSimple {
  id
  title
  project {
    id
    project_manager_id
    archived_at
    finished_at
    brand {
      id
      name
    }
  }
}
    `;
export const ExpenseBudgetItemByCodeFragmentDoc = gql`
    fragment ExpenseBudgetItemByCode on ExpenseBudgetItemSimple {
  id
  title
  project {
    id
    project_manager_id
    archived_at
    finished_at
    brand {
      id
      name
    }
  }
}
    `;
export const ExpenseBudgetItemPlannedExpenseFieldsFragmentDoc = gql`
    fragment ExpenseBudgetItemPlannedExpenseFields on BudgetItemPlannedExpense {
  id
  description
  date
  budgeted_amount
  client_amount
  contractor {
    id
    legal_name
  }
  usedExpenses {
    id
    used_amount
    expenseItem {
      id
    }
  }
}
    `;
export const ModelLockFragmentDoc = gql`
    fragment ModelLock on ModelLock {
  id
  locked_at
  lockedByUser {
    id
    full_name
  }
  deleted_at
  deletedByUser {
    id
    full_name
  }
  is_locked
}
    `;
export const ExpenseFragmentDoc = gql`
    fragment Expense on Expense {
  id
  expense_no
  is_draft
  for_approval
  status
  type
  variable_symbol
  constant_symbol
  specific_symbol
  internal_number
  document_number
  note
  internal_note
  total_amount_includes_vat
  user_created_date
  issue_date
  date_of_supply
  due_date
  paid_at
  payment_type {
    id
    name
    system_name
  }
  has_master_agreement
  fond_contractor_id
  invoice_order_sequence_id
  legal_name
  street
  city
  zip
  registration_no
  tax_no
  vat_no
  business_form
  national_id
  iban
  swift
  exchange_rate
  workspace_company_id
  workspace_bank_account_id
  bank_account
  bank_account_code
  country {
    id
    name
    code
  }
  defaultAccountingAccount {
    id
  }
  contractor {
    id
  }
  contract {
    id
  }
  expenseVatItems {
    amount_in_currency
    vat_in_currency
    vat_percent_informative
  }
  currency {
    id
    denomination
  }
  expenseItemsStructured {
    brand {
      id
      name
    }
    total_amount
    expense_items {
      id
      brand_id
      project_id
      amount_in_currency
      amount_in_percent
      mandatory_id
      approved
      budget_item_type
      accounting_centre_id
      accounting_vat_classification_id
      expense_item_description_id
      tag_ids
      custom_cost_ratio
      globalCreditAccount {
        id
        title
        stats {
          remaining_credit
        }
      }
      vat_amount_in_currency
      vatRate {
        id
        amount
        type
        deleted
      }
      approvals {
        id
        user {
          id
          full_name
        }
        approved
        created_at
      }
      budgetItem {
        id
        title
        payment_status
        project {
          id
          brand {
            id
          }
        }
        ... on ExpenseBudgetItem {
          plannedExpenses {
            ...ExpenseBudgetItemPlannedExpenseFields
          }
        }
        ... on OurWorkBudgetItem {
          plannedExpenses {
            ...ExpenseBudgetItemPlannedExpenseFields
          }
        }
      }
      accountingAccount {
        id
        title
      }
      positions {
        time_tracking_work_type_id
        tracked_time
        report_date
        task {
          id
          name
        }
      }
      timeBillings {
        id
        is_locked
      }
    }
  }
  stats {
    total_vat_in_currency
    total_amount_with_vat_in_currency
    total_amount
    total_vat
    total_amount_with_vat
    total_amount_without_vat
  }
  expense_documents {
    public_id
    mime_type
    size
    name
    filename
    urls {
      viewable
      original
    }
  }
  lockedDocument {
    locked_to
    user {
      id
      full_name
    }
  }
  updated_at
  emailData {
    message_id
    subject
    from
    text
    received_at
  }
  relatedExpenses {
    id
    expense_no
    contractor {
      id
      legal_name
    }
    stats {
      total_amount_with_vat_in_currency
    }
    type
  }
  projectTimeBilling {
    id
    is_locked
    project {
      id
    }
  }
  modelLock {
    ...ModelLock
  }
}
    ${ExpenseBudgetItemPlannedExpenseFieldsFragmentDoc}
${ModelLockFragmentDoc}`;
export const ExpenseItemsListItemFragmentDoc = gql`
    fragment ExpenseItemsListItem on ExpenseItem {
  id
  amount
  amount_in_currency
  mandatory_id
  brand_id
  project_id
  tag_ids
  accounting_centre_id
  accounting_vat_classification_id
  accountingAccount {
    id
    title
    account_number
  }
  vatRate {
    id
    amount
  }
  description {
    title
  }
  budgetItem {
    id
    title
  }
  budget_item_type
  timeBillings {
    id
    is_locked
    title
    project {
      id
    }
  }
  expense {
    id
    expense_no
    document_number
    invoice_status
    status
    type
    date_of_supply
    due_date
    paid_at
    payment_status
    payment_type {
      name
    }
    note
    internal_note
    workspace_company_id
    currency {
      code
      denomination
    }
    accountMoves {
      amount_in_move_currency
    }
    contractor {
      id
      legal_name
    }
    projects {
      id
      title
      code
    }
  }
}
    `;
export const AccountingAccountOptionPartsFragmentDoc = gql`
    fragment AccountingAccountOptionParts on AccountingAccount {
  id
  title
  account_number
}
    `;
export const AllocationsColumnHeader_UserFragmentDoc = gql`
    fragment AllocationsColumnHeader_User on User {
  id
  image {
    urls {
      thumbnail
    }
  }
  full_name
  profile {
    hex_color
    planningRanges {
      type {
        value
      }
      valid_from
      valid_to
      daily_capacity
      weekly_capacities {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const BrandCreditAccountOptionPartsFragmentDoc = gql`
    fragment BrandCreditAccountOptionParts on BrandCreditAccount {
  id
  title
}
    `;
export const BrandSimpleOptionPartsFragmentDoc = gql`
    fragment BrandSimpleOptionParts on BrandSimple {
  id
  name
  code
}
    `;
export const CapacityAllocationItemFragmentDoc = gql`
    fragment CapacityAllocationItem on CapacityAllocationItem {
  id
  date
  from_time
  to_time
  note
  total_time
  type
  location
  global
  teams {
    team {
      id
    }
  }
  time_off_duration_type
  time_tracking_work_type_id
  completed
  user {
    id
    full_name
    profile {
      hex_color
    }
  }
  timeOffType {
    id
    name
    affects_planning_capacity
  }
  createdBy {
    id
    full_name
    profile {
      hex_color
    }
  }
  meetLink
  eventLink
}
    `;
export const ClientSimpleOptionPartsFragmentDoc = gql`
    fragment ClientSimpleOptionParts on ClientSimple {
  id
  name
}
    `;
export const ContactOptionPartsFragmentDoc = gql`
    fragment ContactOptionParts on Contact {
  id
  first_name
  last_name
}
    `;
export const CountrySimpleOptionPartsFragmentDoc = gql`
    fragment CountrySimpleOptionParts on CountrySimple {
  id
  name
  code
}
    `;
export const CurrencyOptionPartsFragmentDoc = gql`
    fragment CurrencyOptionParts on Currency {
  id
  code
  denomination
}
    `;
export const PaginatorInfoFragmentDoc = gql`
    fragment PaginatorInfo on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const PipedriveCustomFieldFragmentDoc = gql`
    fragment PipedriveCustomField on PipedriveCustomFieldValue {
  value
  customField {
    label
  }
}
    `;
export const ProjectSimpleOptionPartsFragmentDoc = gql`
    fragment ProjectSimpleOptionParts on ProjectSimple {
  id
  title
  code
  brand_id
}
    `;
export const UserSimpleOptionPartsFragmentDoc = gql`
    fragment UserSimpleOptionParts on UserSimple {
  id
  full_name
  name
  image {
    urls {
      thumbnail
    }
  }
}
    `;
export const CapacityAllocationItemStatsFragmentDoc = gql`
    fragment CapacityAllocationItemStats on CapacityAllocationItemStats {
  capacity_allocation_id
  capacity_allocation_item_id
  capacity_allocation_created_by_id
  task_id
  task_name
  task_status_id
  task_status_name
  task_status_system_status
  task_status_background_color
  task_status_foreground_color
  our_work_budget_item_id
  our_work_budget_item_title
  project_id
  project_code
  project_title
  tracking_enabled
  tracking_enabled_from
  tracking_enabled_to
  time_off_type_id
  time_off_type_name
  time_off_type_affects_planning_capacity
  deadline
  deadline_time
  repetition
  create_task_positions
  items_count
  title
}
    `;
export const TimeMaterialsBudgetItemFragmentFragmentDoc = gql`
    fragment TimeMaterialsBudgetItemFragment on TimeMaterialsBudgetItems {
  id
  amount
  invoiced
  title
  default_commission
  budget_category_id
  data {
    id
    name
    tracked_time
    amount
  }
}
    `;
export const OutgoingInvoiceCorePartsFragmentDoc = gql`
    fragment OutgoingInvoiceCoreParts on OutgoingInvoice {
  type
  invoice_no
  issue_date
  currency {
    id
    code
    denomination
  }
  due_date
  date_of_supply
  request_for_invoicing_created_date
  request_for_invoicing_submit_date
}
    `;
export const OutgoingInvoiceNotePartsFragmentDoc = gql`
    fragment OutgoingInvoiceNoteParts on OutgoingInvoice {
  note
  internal_note
  text_on_invoice
}
    `;
export const BillingEntityOptionPartsFragmentDoc = gql`
    fragment BillingEntityOptionParts on BillingEntity {
  id
  internal_name
  street
  city
}
    `;
export const ProofOfPaymentFragmentDoc = gql`
    fragment ProofOfPayment on OutgoingInvoice {
  id
  invoice_no
  stats {
    total_amount_in_currency
    total_amount_with_vat_in_currency
  }
}
    `;
export const ProformaInvoiceOptionsFragmentDoc = gql`
    fragment ProformaInvoiceOptions on OutgoingProformaInvoice {
  id
  invoice_no
  projects {
    id
  }
  vat_percent_informative
  currency {
    id
    code
    denomination
  }
  stats {
    id
    total_amount_with_vat_in_currency
    unused_amount_in_currency
  }
  proofOfPayments {
    ...ProofOfPayment
    summaryInvoicesForProofOfPayment {
      id
    }
  }
}
    ${ProofOfPaymentFragmentDoc}`;
export const BudgetPositionFragmentDoc = gql`
    fragment BudgetPosition on BudgetPosition {
  uninvoiced_amount
  uninvoiced_time
  invoiced_amount
  total_invoiced_amount
  total_invoiced_time
  budgeted_amount
  budgeted_time
  title
  time_tracking_work_type_id
  our_work_budget_item_id
  tracked_amount
  tracked_time
  unit_amount
  quantity
}
    `;
export const TimeMaterialsInvoiceDataFragmentFragmentDoc = gql`
    fragment TimeMaterialsInvoiceDataFragment on TimeMaterialsInvoiceData {
  project_id
  ids
  expense_ids
  groupBy
  from
  to
  commission_data {
    expense_budget_item_id
    commission
  }
}
    `;
export const OutgoingInvoiceFormPartsFragmentDoc = gql`
    fragment OutgoingInvoiceFormParts on OutgoingInvoice {
  id
  ...OutgoingInvoiceCoreParts
  ...OutgoingInvoiceNoteParts
  vat_percent_informative
  vat_reverse_charge
  old_invoice_alert_while_editing
  exchange_rate
  exchange_rate_source
  workspace_exchange_rate
  workspace_exchange_rate_source
  workspace_company_id
  workspace_bank_account_id
  show_unit_price
  show_billing_accounting
  type
  invoice_order_sequence_id
  credit_note_outgoing_invoice_id
  client {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
  owner {
    id
    full_name
    codename
  }
  teams {
    id
  }
  billingEntity {
    id
  }
  contact {
    id
  }
  projects {
    id
    type
    ourWorkStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
    expensesWithoutOtherStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
  }
  currency {
    id
    denomination
  }
  invoicePaymentMethod {
    id
  }
  orders {
    id
    purchase_order_no
  }
  proformaInvoicesPivot {
    invoice {
      ...ProformaInvoiceOptions
    }
    amount_in_currency
  }
  invoiceItems {
    description
    amount_in_currency
    unit_price
    quantity
    accounting_account_id
    accounting_centre_id
    tag_ids
    vat_percent_informative
  }
  ourWorkBudgetSplits {
    our_work_budget_item_id
    amount
    amount_in_percent
  }
  expenseBudgetSplits {
    expense_budget_item_id
    amount
  }
  prepaymentSplits {
    brand_credit_account_id
    amount
    amount_left
  }
  budget_positions {
    ...BudgetPosition
  }
  brands {
    id
  }
  filesToAttach {
    public_id
  }
  timeMaterialsInvoiceData {
    ...TimeMaterialsInvoiceDataFragment
  }
  invoiceProofOfPayments {
    amount_in_currency
    invoice {
      id
    }
  }
  projectTimeBilling {
    id
    is_locked
  }
  modelLock {
    ...ModelLock
  }
}
    ${OutgoingInvoiceCorePartsFragmentDoc}
${OutgoingInvoiceNotePartsFragmentDoc}
${BillingEntityOptionPartsFragmentDoc}
${ProformaInvoiceOptionsFragmentDoc}
${BudgetPositionFragmentDoc}
${TimeMaterialsInvoiceDataFragmentFragmentDoc}
${ModelLockFragmentDoc}`;
export const ProformaInvoiceCorePartsFragmentDoc = gql`
    fragment ProformaInvoiceCoreParts on OutgoingProformaInvoice {
  invoice_no
  issue_date
  due_date
  request_for_invoicing_created_date
  request_for_invoicing_submit_date
}
    `;
export const ProformaInvoiceNotePartsFragmentDoc = gql`
    fragment ProformaInvoiceNoteParts on OutgoingProformaInvoice {
  note
  internal_note
  text_on_invoice
}
    `;
export const ProformaInvoiceFormPartsFragmentDoc = gql`
    fragment ProformaInvoiceFormParts on OutgoingProformaInvoice {
  id
  ...ProformaInvoiceCoreParts
  ...ProformaInvoiceNoteParts
  vat_percent_informative
  vat_reverse_charge
  exchange_rate
  exchange_rate_source
  workspace_exchange_rate
  workspace_exchange_rate_source
  workspace_company_id
  workspace_bank_account_id
  show_unit_price
  show_billing_accounting
  invoice_order_sequence_id
  client {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
  owner {
    id
    full_name
    codename
  }
  teams {
    id
  }
  billingEntity {
    id
  }
  contact {
    id
  }
  projects {
    id
    ourWorkStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
    expensesWithoutOtherStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
  }
  currency {
    id
    denomination
  }
  invoicePaymentMethod {
    id
  }
  invoiceItems {
    description
    amount_in_currency
    unit_price
    quantity
    accounting_account_id
    accounting_centre_id
    tag_ids
    vat_percent_informative
  }
  ourWorkBudgetSplits {
    our_work_budget_item_id
    amount
    amount_in_percent
  }
  prepaymentSplits {
    brand_credit_account_id
    amount
  }
  expenseBudgetSplits {
    expense_budget_item_id
    amount
  }
  budget_positions {
    ...BudgetPosition
  }
  brands {
    id
  }
  filesToAttach {
    public_id
  }
  modelLock {
    ...ModelLock
  }
}
    ${ProformaInvoiceCorePartsFragmentDoc}
${ProformaInvoiceNotePartsFragmentDoc}
${BillingEntityOptionPartsFragmentDoc}
${BudgetPositionFragmentDoc}
${ModelLockFragmentDoc}`;
export const RequestForInvoicingCorePartsFragmentDoc = gql`
    fragment RequestForInvoicingCoreParts on RequestForInvoicing {
  type
  status
  issue_date
  due_date
  date_of_supply
}
    `;
export const RequestForInvoicingNotePartsFragmentDoc = gql`
    fragment RequestForInvoicingNoteParts on RequestForInvoicing {
  note
  internal_note
  text_on_invoice
}
    `;
export const RfiFormPartsFragmentDoc = gql`
    fragment RFIFormParts on RequestForInvoicing {
  id
  ...RequestForInvoicingCoreParts
  ...RequestForInvoicingNoteParts
  vat_percent_informative
  vat_reverse_charge
  exchange_rate
  exchange_rate_source
  workspace_exchange_rate
  workspace_exchange_rate_source
  workspace_company_id
  workspace_bank_account_id
  show_unit_price
  show_billing_accounting
  credit_note_outgoing_invoice_id
  client {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
  brands {
    id
  }
  owner {
    id
    full_name
    codename
  }
  teams {
    id
  }
  billingEntity {
    id
  }
  contact {
    id
  }
  projects {
    id
    type
    ourWorkStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
    expensesWithoutOtherStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
  }
  currency {
    id
    denomination
  }
  invoicePaymentMethod {
    id
  }
  orders {
    id
    purchase_order_no
  }
  proformaInvoices {
    ...ProformaInvoiceOptions
  }
  invoiceItems {
    description
    amount_in_currency
    unit_price
    quantity
    accounting_account_id
    accounting_centre_id
    tag_ids
    vat_percent_informative
  }
  ourWorkBudgetSplits {
    our_work_budget_item_id
    amount
    amount_in_percent
  }
  prepaymentSplits {
    brand_credit_account_id
    amount
  }
  expenseBudgetSplits {
    expense_budget_item_id
    amount
  }
  budget_positions {
    ...BudgetPosition
  }
  filesToAttach {
    public_id
  }
  timeMaterialsInvoiceData {
    ...TimeMaterialsInvoiceDataFragment
  }
  proofOfPayments {
    id
  }
}
    ${RequestForInvoicingCorePartsFragmentDoc}
${RequestForInvoicingNotePartsFragmentDoc}
${BillingEntityOptionPartsFragmentDoc}
${ProformaInvoiceOptionsFragmentDoc}
${BudgetPositionFragmentDoc}
${TimeMaterialsInvoiceDataFragmentFragmentDoc}`;
export const PdfFileFragmentDoc = gql`
    fragment PdfFile on AssignableFile {
  public_id
  mime_type
  size
  name
  filename
  urls {
    viewable
    original
  }
}
    `;
export const EmailDataFragmentDoc = gql`
    fragment EmailData on InvoiceEmailData {
  id
  recipients
  subject
  content
  attachments {
    id
    link
    name
    required
  }
}
    `;
export const EmailLogFragmentDoc = gql`
    fragment EmailLog on OutgoingInvoiceEmailLog {
  id
  type
  accepted_delivery
  recipients {
    email
  }
  recipientLog {
    recipient
    status
  }
  sent_at
}
    `;
export const InvoiceBudgetItemListItemFragmentDoc = gql`
    fragment InvoiceBudgetItemListItem on OIBudgetItemForTimeBilling {
  outgoing_invoice_id
  budget_item_id
  budget_item_type
  amount
  budgetItem {
    id
    title
  }
  outgoingInvoice {
    id
    invoice_no
    issue_date
    date_of_supply
    due_date
    paid_at
    payment_status
    type
    note
    internal_note
    text_on_invoice
    abraflexi_exported
    xero_exported
    has_proforma_payments
    proformaInvoicesPivot {
      invoice {
        id
        invoice_no
      }
    }
    currency {
      code
      denomination
    }
    accountMoves {
      amount_in_move_currency
    }
    billingEntity {
      internal_name
      street
      city
    }
    workspace_company_id
    brands {
      id
      name
    }
    projects {
      id
      title
      code
    }
    invoicePaymentMethod {
      id
      name
    }
    projectTimeBilling {
      id
      is_locked
      title
      project {
        id
      }
    }
    documentExports {
      id
      type
      exported_at
    }
    emailLogs {
      ...EmailLog
    }
    ourWorkBudgetSplits {
      id
      amount
    }
    expenseBudgetSplits {
      id
      amount
    }
  }
}
    ${EmailLogFragmentDoc}`;
export const InvoicePaymentMethodFragmentDoc = gql`
    fragment InvoicePaymentMethod on InvoicePaymentMethod {
  id
  name
}
    `;
export const UserToolTip_UserFragmentFragmentDoc = gql`
    fragment UserToolTip_UserFragment on User {
  id
  codename
  full_name
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const ProjectBillingSubRowFragmentDoc = gql`
    fragment ProjectBillingSubRow on ProjectBillingItem {
  id
  planned_amount
  planned_our_work
  planned_expense_categories {
    amount
    category_id
    category_name
  }
  planned_prepayments
  invoiced_amount
  invoiced_our_work
  invoiced_expense_categories {
    amount
    category_id
    category_name
  }
  invoiced_prepayments
  automatically_invoiced
  manually_invoiced
  balance
  issue_date
  date_of_supply
  due_date
  type
  invoice_no
  paid_at
  paid_amount
  status
  delivered
  note
  item_type
  invoice_type
  billing_item_type
  payment_status
  brandCreditAccount {
    id
    title
  }
  outgoingInvoice {
    id
  }
  outgoingProformaInvoice {
    id
  }
  requestForInvoicing {
    id
  }
}
    `;
export const ProjectBillingRowFragmentDoc = gql`
    fragment ProjectBillingRow on ProjectBilling {
  planned_amount
  planned_our_work
  planned_expense_categories {
    amount
    category_id
    category_name
  }
  planned_prepayments
  invoiced_amount
  invoiced_our_work
  invoiced_expense_categories {
    amount
    category_id
    category_name
  }
  invoiced_prepayments
  automatically_invoiced
  manually_invoiced
  balance
  billing_type
  has_billing_plan
  project {
    id
    code
    title
    projectManager {
      ...UserToolTip_UserFragment
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
  }
  items {
    ...ProjectBillingSubRow
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${ProjectBillingSubRowFragmentDoc}`;
export const ProjectBillingsSummaryFragmentFragmentDoc = gql`
    fragment ProjectBillingsSummaryFragment on ProjectBillingsSummary {
  total_paid_amount
  total_unpaid_amount
  total_planned_amount
  total_planned_our_work
  total_planned_expense_categories {
    amount
    category_id
    category_name
  }
  total_planned_prepayments
  total_invoiced_amount
  total_invoiced_our_work
  total_invoiced_expense_categories {
    amount
    category_id
    category_name
  }
  total_invoiced_prepayments
}
    `;
export const UserTooltipFragmentDoc = gql`
    fragment UserTooltip on User {
  id
  codename
  image {
    urls {
      thumbnail
    }
  }
  full_name
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const InvoicingPlanAdvancedListFragmentDoc = gql`
    fragment InvoicingPlanAdvancedList on BillingPlanBudgetCache {
  id
  type
  project {
    id
    title
    code
    billable
    projectManager {
      ...UserTooltip
    }
  }
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
  planned_amount
  issue_date
  date_of_supply
  due_date
  invoiced_amount
  billing_plan_invoice_id
  invoice_no
  request_for_invoicing_id
  paid_amount
  paid_at
  email_sent
  created_at
  updated_at
  message
  status
}
    ${UserTooltipFragmentDoc}`;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  type
  message
  object_id
  created_at
  read_at
  url
}
    `;
export const TaskNotificationsNotificationFragmentDoc = gql`
    fragment TaskNotificationsNotification on Notification {
  id
  message
  type
  read_at
  created_at
}
    `;
export const BillingPlanFragmentDoc = gql`
    fragment BillingPlan on BillingPlanBudget {
  id
  budget_item_id
  budget_item_type
  total_budget
  category {
    id
    name
  }
  title
  total_budget
  billing_item_type
  billingPlanBudgetItem {
    invoice_type
    day
    accounting_centre_id
    accounting_account_id
    months {
      value
      date
      billingPlanInvoice {
        amount
        invoice_type
        invoice_id
        date
      }
    }
  }
}
    `;
export const BillingPlanSettingsProjectFragmentDoc = gql`
    fragment BillingPlanSettingsProject on Project {
  title
  code
  start_date
  expected_end_date
  brand {
    image {
      urls {
        thumbnail
      }
    }
  }
  contact {
    email
  }
  brand {
    defaultBillingEntity {
      invoice_email
    }
  }
  projectManager {
    email
  }
  billingPlanSetting {
    to
    from
    auto_send_invoice
    auto_send_thank_you
    auto_create_invoice
    generate_invoice_items
    billing_item_type
    vat_rate_id
    date_of_supply_from_issue_date
    email_template {
      subject
      content
      recipients
    }
    auto_send_thank_you_template {
      subject
      content
      recipients
    }
    workspace_company_id
    workspace_bank_account_id
    billing_entity_id
    contact_id
    text_on_invoice
    internal_note
    note
    create_draft_invoice
    order_id
    create_summary_invoice_after_payment
    locked_at
    lockedByUser {
      id
      full_name
    }
  }
}
    `;
export const SimpleTaskForClientFragmentDoc = gql`
    fragment SimpleTaskForClient on Task {
  id
  name
  scopedCommentCount
  is_template
  is_starred
  task_template_group_id
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  deadline
  days_to_deadline
  priority {
    id
    name
    system_priority
    emoji
  }
  positions {
    user {
      ...UserToolTip_UserFragment
      first_name
      last_name
    }
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    project {
      id
      code
      title
      uses_budgetovac
      brand {
        name
        client {
          name
        }
      }
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}`;
export const SimpleTaskFragmentDoc = gql`
    fragment SimpleTask on Task {
  ...SimpleTaskForClient
  billable
  commentCount
  unreadCommentsCount
  stats {
    planned_time
    spent_time
  }
  scopes {
    value
  }
  ourWorkBudgetItem {
    title
    category {
      name
    }
    timeTrackingSettings {
      tracking_enabled_from
      tracking_enabled_to
      tracking_enabled
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}`;
export const OurWorkBudgetItemOverviewTasksFragmentFragmentDoc = gql`
    fragment OurWorkBudgetItemOverviewTasksFragment on OurWorkBudgetItemOverview {
  tasks {
    ...SimpleTask
    subtasks {
      ...SimpleTask
    }
  }
}
    ${SimpleTaskFragmentDoc}`;
export const OurWorkBudgetItemOverviewFragmentFragmentDoc = gql`
    fragment OurWorkBudgetItemOverviewFragment on OurWorkBudgetItemOverview {
  id
  title
  item_code
  completed_at
  requested_for_deletion_at
  plannedExpenses {
    id
  }
  hidden
  order
  note
  deadline
  done_task_count
  task_count
  lastWorkInProgressItemStat {
    work_in_progress_id
    progress_percent
  }
  stats {
    total_budget
    total_time
    spent_budget
    spent_time
    remaining_time
    remaining_budget
    credit
    invoiced_percent
    spent_budget_percent
    credit_balance
    invoiceable
    uninvoiced
    net_profit
    net_margin_percent
    efficiency_percent
  }
  expenseStats {
    id
    task {
      id
      name
    }
    tracked_time
    report_date
    expense_item_amount
    expense {
      id
      expense_no
    }
    position {
      title
    }
  }
  ...OurWorkBudgetItemOverviewTasksFragment
}
    ${OurWorkBudgetItemOverviewTasksFragmentFragmentDoc}`;
export const OurWorkOverviewFragmentDoc = gql`
    fragment OurWorkOverview on OurWorkOverviewBudgetItem {
  id
  name
  total_budget
  credit
  budgetItems {
    ...OurWorkBudgetItemOverviewFragment
  }
}
    ${OurWorkBudgetItemOverviewFragmentFragmentDoc}`;
export const ExpenseStructuredBudgetItemFragmentFragmentDoc = gql`
    fragment ExpenseStructuredBudgetItemFragment on ExpenseBudgetItem {
  id
  item_code
  title
  type
  completed_at
  requested_for_deletion_at
  plannedExpenses {
    id
  }
  expenseStats {
    expense {
      status
    }
  }
  stats {
    total_budget
    client_price
    real_expenses
    real_commission
    planned_expenses
    planned_commission
    planned_profit
    real_expenses_percent
    real_commission_relative
    planned_commission_relative_computed
    credit
    credit_balance
    invoiced_percent
    invoiceable
    uninvoiced
    profit
    profit_percent
  }
}
    `;
export const ProjectDetailPlannedExpenseFieldsFragmentDoc = gql`
    fragment ProjectDetailPlannedExpenseFields on BudgetItemPlannedExpense {
  id
  budget_item_id
  budget_item_type
  description
  date
  client_amount
  budgeted_amount
  contractor {
    id
    legal_name
  }
}
    `;
export const WipItemStatAffectedValuesFragmentDoc = gql`
    fragment WipItemStatAffectedValues on WorkInProgressItemStat {
  progress
  progress_percent
  progress_change
  progress_change_percent
  spent_time_estimate
}
    `;
export const PlannedExpensesBudgetItemFragmentDoc = gql`
    fragment PlannedExpensesBudgetItem on PlannedExpensesBudgetItem {
  id
  title
  item_code
  category_name
  buy_price
  uninvoiced_amount
  planned_client_amount
  planned_budgeted_amount
  expenses_received
  expenses_received_percentage
  invoiced_amount
  invoiced_amount_percentage
  actual_profit_amount
  actual_profit_percentage
  total_budget
  total_budgeted_with_commission
  to_plan_buy_price
  to_plan_buy_price_percentage
  to_plan_client_price
  to_plan_client_price_percentage
  profit_estimate
  profit_estimate_percentage
}
    `;
export const PlannedExpensesProjectFragmentDoc = gql`
    fragment PlannedExpensesProject on PlannedExpensesProject {
  id
  project {
    id
    code
    title
    brand {
      id
      name
    }
    projectManager {
      ...UserToolTip_UserFragment
    }
  }
  uninvoiced_amount
  actual_profit_amount
  actual_profit_percentage
  total_planned_client_amount
  total_planned_budgeted_amount
  total_budget
  total_budgeted_with_commission
  total_buy_price
  total_expenses_received
  expenses_received_percentage
  total_invoiced_amount
  invoiced_amount_percentage
  to_plan_buy_price
  to_plan_buy_price_percentage
  to_plan_client_price
  to_plan_client_price_percentage
  profit_estimate
  profit_estimate_percentage
  budget_items {
    ...PlannedExpensesBudgetItem
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PlannedExpensesBudgetItemFragmentDoc}`;
export const PlannedExpensesSummaryFragmentDoc = gql`
    fragment PlannedExpensesSummary on PlannedExpensesSummary {
  uninvoiced_amount
  uninvoiced_amount_percentage
  actual_profit_amount
  actual_profit_percentage
  total_planned_client_amount
  planned_client_amount_percentage
  total_planned_budgeted_amount
  planned_budgeted_amount_percentage
  total_budget
  total_budgeted_with_commission
  total_buy_price
  total_expenses_received
  expenses_received_percentage
  total_invoiced_amount
  invoiced_amount_percentage
  to_plan_buy_price
  to_plan_buy_price_percentage
  to_plan_client_price
  to_plan_client_price_percentage
  profit_estimate
  profit_estimate_percentage
}
    `;
export const DistributionModalTableItemFragmentDoc = gql`
    fragment DistributionModalTableItem on TimeTrackingReport {
  id
  tracked_for_date
  user_full_name
  user_id
  task_name
  task_id
  our_work_budget_item_title
  note
  tracked_time
  billable
  hourly_rate
  amount
}
    `;
export const ProjectTimeBillingSourcePreviewFragmentDoc = gql`
    fragment ProjectTimeBillingSourcePreview on ProjectTimeBillingSourcePreview {
  source_type
  source_id
  outgoing_invoice_id
  budget_item_id
  budget_item_type
  amount
  expenseItem {
    id
    amount
    description {
      title
    }
    budgetItem {
      ... on OurWorkBudgetItem {
        id
        title
      }
      ... on ExpenseBudgetItem {
        id
        title
      }
    }
  }
  expense {
    id
    expense_no
    document_number
    date_of_supply
    contractor {
      legal_name
    }
    note
    emailData {
      text
    }
  }
  outgoingInvoice {
    id
    invoice_no
    issue_date
    billingEntity {
      internal_name
      street
      city
    }
  }
  budgetItem {
    ... on OurWorkBudgetItem {
      id
      title
    }
    ... on ExpenseBudgetItem {
      id
      title
    }
  }
}
    `;
export const ProjectTimeBillingComponentPreviewFragmentDoc = gql`
    fragment ProjectTimeBillingComponentPreview on ProjectTimeBillingComponentPreview {
  key
  amount
  use_in_total
  source_id
  source_type
}
    `;
export const ProjectTimeBillingUserRowPreviewFragmentDoc = gql`
    fragment ProjectTimeBillingUserRowPreview on ProjectTimeBillingUserRowPreview {
  user_id
  user {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
  time_tracking_work_type_id
  position {
    id
    title
  }
  team_id
  team {
    id
    name
  }
  tracked_time
  tracked_hours
  client_rate
  spent
  effective_hourly_rate
  amount
  invoiced_time
  overserviced_time
  effective_hourly_rate_invoiced
}
    `;
export const ProjectTimeBillingComputedFragmentDoc = gql`
    fragment ProjectTimeBillingComputed on ProjectTimeBillingComputed {
  date_from
  date_to
  computed_total_amount
  sources {
    ...ProjectTimeBillingSourcePreview
  }
  components {
    ...ProjectTimeBillingComponentPreview
  }
  userRows {
    ...ProjectTimeBillingUserRowPreview
  }
  distributions {
    time_tracking_item_id
  }
}
    ${ProjectTimeBillingSourcePreviewFragmentDoc}
${ProjectTimeBillingComponentPreviewFragmentDoc}
${ProjectTimeBillingUserRowPreviewFragmentDoc}`;
export const ProjectTimeBillingDistributionPreviewFragmentDoc = gql`
    fragment ProjectTimeBillingDistributionPreview on ProjectTimeBillingDistributionPreview {
  time_tracking_item_id
  invoiced_seconds
  overserviced_seconds
  uninvoiced_seconds
  timeTrackingItem {
    tracked_for_date
    tracked_time
    note
    billable
    user {
      id
      full_name
      image {
        urls {
          thumbnail
        }
      }
    }
    timeTrackingWorkType {
      id
      title
    }
    task {
      id
      name
    }
  }
}
    `;
export const ProjectTimeBillingListItemFragmentDoc = gql`
    fragment ProjectTimeBillingListItem on ProjectTimeBilling {
  id
  title
  date_from
  date_to
  type
  final_total_amount
  final_total_note
  is_locked
  lockedByUser {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
  locked_at
  createdByUser {
    id
    full_name
  }
  created_at
}
    `;
export const ProjectTimeBillingSourceFragmentDoc = gql`
    fragment ProjectTimeBillingSource on ProjectTimeBillingSource {
  source_type
  source_id
  outgoing_invoice_id
  budget_item_id
  budget_item_type
  amount
  expenseItem {
    id
    amount
    description {
      title
    }
    budgetItem {
      ... on OurWorkBudgetItem {
        id
        title
      }
      ... on ExpenseBudgetItem {
        id
        title
      }
    }
  }
  expense {
    id
    expense_no
    document_number
    date_of_supply
    contractor {
      legal_name
    }
    note
    emailData {
      text
    }
  }
  outgoingInvoice {
    id
    invoice_no
    issue_date
    billingEntity {
      internal_name
      street
      city
    }
  }
  budgetItem {
    ... on OurWorkBudgetItem {
      id
      title
    }
    ... on ExpenseBudgetItem {
      id
      title
    }
  }
}
    `;
export const ProjectTimeBillingComponentFragmentDoc = gql`
    fragment ProjectTimeBillingComponent on ProjectTimeBillingComponent {
  key
  amount
  use_in_total
}
    `;
export const ProjectTimeBillingUserRowFragmentDoc = gql`
    fragment ProjectTimeBillingUserRow on ProjectTimeBillingUserRow {
  id
  user {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
  position {
    id
    title
  }
  team {
    id
    name
  }
  tracked_time
  tracked_hours
  client_rate
  spent
  effective_hourly_rate
  amount
  invoiced_time
  overserviced_time
  effective_hourly_rate_invoiced
}
    `;
export const ProjectTimeBillingDetailFragmentDoc = gql`
    fragment ProjectTimeBillingDetail on ProjectTimeBilling {
  ...ProjectTimeBillingListItem
  sources {
    ...ProjectTimeBillingSource
  }
  components {
    ...ProjectTimeBillingComponent
  }
  userRows {
    ...ProjectTimeBillingUserRow
  }
  distributions {
    time_tracking_item_id
  }
}
    ${ProjectTimeBillingListItemFragmentDoc}
${ProjectTimeBillingSourceFragmentDoc}
${ProjectTimeBillingComponentFragmentDoc}
${ProjectTimeBillingUserRowFragmentDoc}`;
export const BrandTableDataFragmentDoc = gql`
    fragment BrandTableData on BrandWithRevenueResult {
  id
  name
  image {
    urls {
      thumbnail
    }
  }
  gross_income_for_date_range
}
    `;
export const ProfitAndLossReportColumnFragmentDoc = gql`
    fragment ProfitAndLossReportColumn on ProfitLossReportColumn {
  title
  expenses_amount
  invoiced_amount
  balance_amount
}
    `;
export const ProjectTableDataFragmentDoc = gql`
    fragment ProjectTableData on ProjectWithRevenueItem {
  id
  title
  code
  note
  finished_at
  archived_at
  status
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
  projectManager {
    ...UserToolTip_UserFragment
  }
  gross_income_for_date_range
}
    ${UserToolTip_UserFragmentFragmentDoc}`;
export const UserProfitReportFragmentDoc = gql`
    fragment UserProfitReport on UtilizationReport {
  total_time
  available_time
  remaining_time
  time_off
  overtime
  combined_time
  combined_time_billable
  budgeted_time
  budgeted_time_billable
  allocated_time
  allocated_time_billable
  tracked_time
  tracked_time_billable
  utilization_percentage
  utilization_percentage_billable
  internal_cost
  combined_amount_billable
  budgeted_amount_billable
  combined_profit_amount
  budgeted_profit_amount
  tracked_time_billable
}
    `;
export const UserProfitUserFragmentDoc = gql`
    fragment UserProfitUser on User {
  id
  full_name
  profile {
    hex_color
    utilization_range_from
    utilization_range_to
    defaultWorktype {
      title
    }
  }
  team {
    name
  }
  image {
    urls {
      thumbnail
    }
  }
}
    `;
export const TaskUserFragmentDoc = gql`
    fragment TaskUser on User {
  id
  codename
  first_name
  last_name
  full_name
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const TaskPositionUserFragmentDoc = gql`
    fragment TaskPositionUser on TaskPosition {
  id
  planned_time
  spent_time
  user {
    ...TaskUser
  }
  timeTrackingWorkType {
    id
    title
  }
}
    ${TaskUserFragmentDoc}`;
export const TaskBaseFragmentDoc = gql`
    fragment TaskBase on Task {
  id
  name
  deadline
  from
  to
  is_starred
  billable
  is_template
  task_template_group_id
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  priority {
    id
    name
    system_priority
    emoji
  }
  stats {
    planned_time
    spent_time
  }
  currentAssignee {
    ...TaskUser
  }
  users {
    ...TaskUser
  }
  positions {
    ...TaskPositionUser
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    title
    project {
      id
      code
      title
      uses_budgetovac
      brand {
        name
        client {
          name
        }
      }
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;
export const TaskScheduleFragmentDoc = gql`
    fragment TaskSchedule on Task {
  id
  from
  to
  deadline
}
    `;
export const BoardTaskUserFragmentDoc = gql`
    fragment BoardTaskUser on User {
  id
  first_name
  last_name
  full_name
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
}
    `;
export const BoardTaskFragmentDoc = gql`
    fragment BoardTask on Task {
  id
  name
  deadline
  is_starred
  is_template
  billable
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  priority {
    id
    name
    system_priority
    emoji
  }
  stats {
    planned_time
    spent_time
  }
  currentAssignee {
    ...BoardTaskUser
  }
  users {
    ...BoardTaskUser
  }
  positions {
    id
    spent_time
    user {
      ...BoardTaskUser
    }
    timeTrackingWorkType {
      id
      title
    }
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    title
    project {
      id
      code
      title
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    ${BoardTaskUserFragmentDoc}`;
export const BoardSettingsFragmentDoc = gql`
    fragment BoardSettings on TaskBoardSettings {
  board_key
  hidden_columns
  collapsed_columns
  column_order
  sort {
    column
    direction
  }
}
    `;
export const ListingClientTaskBaseFragmentDoc = gql`
    fragment ListingClientTaskBase on Task {
  id
  name
  is_template
  is_starred
  task_template_group_id
  from
  to
  created_at
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  deadline
  priority {
    id
    name
    system_priority
    emoji
  }
  positions {
    user {
      ...UserToolTip_UserFragment
      first_name
      last_name
    }
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    project {
      id
      code
      title
      uses_budgetovac
      brand {
        name
        client {
          name
        }
      }
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}`;
export const ListingClientTaskFragmentDoc = gql`
    fragment ListingClientTask on Task {
  ...ListingClientTaskBase
  subtasks {
    ...ListingClientTaskBase
  }
}
    ${ListingClientTaskBaseFragmentDoc}`;
export const ListingInternalTaskBaseFragmentDoc = gql`
    fragment ListingInternalTaskBase on Task {
  ...ListingClientTaskBase
  positions {
    spent_time
  }
  stats {
    planned_time
    spent_time
  }
  scopes {
    value
  }
  billable
  ourWorkBudgetItem {
    id
    title
    project {
      id
      title
      uses_budgetovac
      code
      brand {
        name
        client {
          name
        }
      }
    }
  }
  is_starred
}
    ${ListingClientTaskBaseFragmentDoc}`;
export const ListingInternalTaskFragmentDoc = gql`
    fragment ListingInternalTask on Task {
  ...ListingInternalTaskBase
  subtasks {
    ...ListingInternalTaskBase
  }
}
    ${ListingInternalTaskBaseFragmentDoc}`;
export const ProjectTemplateFragmentDoc = gql`
    fragment ProjectTemplate on Project {
  id
  title
  code
  billable
  note
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
  categories {
    id
    name
  }
  statsCached {
    id
    total_budget
    ourWork {
      id
      total_budget
    }
    expenses {
      id
      planned_expenses
    }
  }
}
    `;
export const TaskBasicInfoFragmentDoc = gql`
    fragment TaskBasicInfo on Task {
  id
  name
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  priority {
    id
    name
    system_priority
    emoji
  }
  deadline
  scopedCommentCount
  positions {
    user {
      ...UserToolTip_UserFragment
      scope {
        value
      }
    }
  }
  ourWorkBudgetItem {
    project {
      id
      title
      code
      brand {
        name
        client {
          name
        }
      }
    }
  }
  subtasks {
    ...SimpleTaskForClient
  }
  parent {
    id
  }
  is_template
  task_template_group_id
}
    ${UserToolTip_UserFragmentFragmentDoc}
${SimpleTaskForClientFragmentDoc}`;
export const TaskExtendedInfoFragmentDoc = gql`
    fragment TaskExtendedInfo on Task {
  stats {
    planned_time
    spent_time
  }
  scopes {
    value
  }
  billable
  commentCount
  unreadCommentsCount
  ourWorkBudgetItem {
    id
    title
    project {
      id
      title
      uses_budgetovac
      code
      brand {
        name
        client {
          name
        }
      }
    }
  }
  subtasks {
    ...SimpleTask
  }
}
    ${SimpleTaskFragmentDoc}`;
export const TaskGroupTemplateFragmentDoc = gql`
    fragment TaskGroupTemplate on TaskTemplateGroup {
  id
  name
  tasks {
    ...TaskBasicInfo
    ...TaskExtendedInfo
  }
}
    ${TaskBasicInfoFragmentDoc}
${TaskExtendedInfoFragmentDoc}`;
export const TimeTrackingReportItemFragmentDoc = gql`
    fragment TimeTrackingReportItem on TimeTrackingReport {
  id
  tracked_time
  tracked_for_date
  brand_id
  brand_name
  client_name
  project_id
  project_title
  project_code
  project_time_billing_id
  project_time_billing_project_id
  project_time_billing_name
  project_time_billing_project_name
  project_time_billing_is_locked
  our_work_budget_item_title
  time_tracking_work_type_title
  time_tracking_work_type_id
  team_name
  task_id
  task_name
  user_full_name
  note
  invoiced_seconds
  overserviced_seconds
  uninvoiced_seconds
  amount
  hourly_rate
  locked_at
  locked_by_user_first_name
  locked_by_user_last_name
}
    `;
export const TimeTrackingEntryFragmentDoc = gql`
    fragment TimeTrackingEntry on TimeTrackingItem {
  id
  tracked_for_date
  tracked_time
  tracked_time_with_running_timer
  specific_time_from
  specific_time_to
  note
  auto_stopped
  billable
  is_locked
  timeBilling {
    id
    name
    is_locked
    project {
      id
    }
  }
  has_running_timer
  user {
    id
  }
  capacityAllocationItem {
    id
  }
  task {
    id
    name
    ourWorkBudgetItem {
      id
      title
      project {
        id
        code
        title
        brand {
          id
          name
        }
      }
    }
  }
  timeTrackingBudgetItem {
    id
    tracking_enabled
  }
  timeTrackingWorkType {
    id
    title
  }
  project {
    id
    title
    code
    brand {
      id
      name
    }
  }
}
    `;
export const UserForEditBasicFragmentDoc = gql`
    fragment UserForEditBasic on User {
  id
  scope {
    value
  }
  first_name
  last_name
  full_name
  codename
  created_at
  image {
    urls {
      thumbnail
    }
  }
  statusRanges {
    id
    valid_from
    valid_to
    active
    projectManager {
      id
    }
  }
  email
  phone
  note
  archived_at
  PMActiveProjectsCount
  permissions {
    user_haveProjectsAssigned
  }
  enabled_two_factor_authentication
  mcp_connected
  mcpTokens {
    id
    mcp_name
    created_at
  }
  muted_mail_notifications
  calendar_integrations
  calendar_sync_direction
  calendar_sync_allocation_types
  team {
    id
    name
  }
  roles {
    id
    name
  }
  brands {
    id
    name
  }
  tasks {
    id
  }
}
    `;
export const AttachmentFragmentDoc = gql`
    fragment Attachment on AssignableFile {
  public_id
  filename
  mime_type
  urls {
    thumbnail
    viewable
    original
  }
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on TaskComment {
  id
  user {
    id
    codename
    full_name
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
      defaultWorktype {
        id
        title
      }
    }
    team {
      id
      name
    }
  }
  reactions {
    id
    user {
      id
      full_name
    }
    emoji_id
  }
  body
  timestamp
  has_edits
  files {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;
export const TaskFragmentForScopedUserFragmentDoc = gql`
    fragment TaskFragmentForScopedUser on Task {
  ...SimpleTaskForClient
  created_at
  from
  days_to_from
  to
  days_to_to
  attachments_download_url
  clientCommentCount
  partnerCommentCount
  users {
    id
    first_name
    last_name
    scope {
      value
    }
  }
  currentAssignee {
    id
  }
  createdBy {
    id
    full_name
    codename
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
      defaultWorktype {
        id
        title
      }
    }
    team {
      id
      name
    }
  }
  description {
    body
    mentioned_user_ids
    mentioned_team_ids
    mentioned_assignees
  }
  positions {
    id
    user {
      first_name
      last_name
      scope {
        value
      }
    }
  }
  ourWorkBudgetItem {
    project {
      availableTimeTrackingWorkTypes {
        id
        title
      }
      projectManager {
        id
      }
      otherProjectManagers {
        id
      }
      brand {
        id
        client {
          id
        }
      }
    }
  }
  files {
    ...Attachment
    created_at
  }
  parent {
    id
    name
    status {
      name
      system_status
    }
    ourWorkBudgetItem {
      project {
        id
        code
        title
      }
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}
${AttachmentFragmentDoc}`;
export const TaskFragmentFragmentDoc = gql`
    fragment TaskFragment on Task {
  ...TaskFragmentForScopedUser
  revision
  cloudUrl
  driveCloudUrl
  billable
  scopes {
    value
  }
  commentCount
  scopedCommentCount
  otherPeopleTracked {
    user {
      full_name
    }
    time_tracking_work_type_id
    tracked_time
  }
  otherPeopleTrackedTotal
  users {
    id
    first_name
    last_name
    scope {
      value
    }
  }
  createdBy {
    id
    full_name
    codename
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
      defaultWorktype {
        id
        title
      }
    }
    team {
      id
      name
    }
  }
  linkedTasks {
    id
    link_type {
      name
    }
    linked_task {
      id
      name
      commentCount
      status {
        id
        name
        background_color
        foreground_color
        system_status
      }
      priority {
        id
        name
        system_priority
        emoji
      }
      ourWorkBudgetItem {
        id
        title
        item_code
      }
    }
  }
  stats {
    planned_time
    spent_time
  }
  positions {
    timeTrackingWorkType {
      id
      title
    }
    planned_time
  }
  ourWorkBudgetItem {
    id
    title
    project {
      uses_budgetovac
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_to
      tracking_enabled_from
    }
  }
  parent {
    ourWorkBudgetItem {
      title
    }
  }
  task_template_group_id
  taskWatchers {
    user_id
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;
export const EbiCompleteDataFragmentDoc = gql`
    fragment EbiCompleteData on ExpenseBudgetItem {
  id
  completed_at
  stats {
    planned_commission
    planned_commission_relative_computed
    real_commission
    real_commission_relative
  }
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  id
  first_name
  last_name
  email
  phone
}
    `;
export const ExchangeRateFragmentDoc = gql`
    fragment ExchangeRate on CurrencyExchangeRate {
  id
  exchange_rate
  valid_from
  valid_to
  currency {
    id
    code
    denomination
  }
}
    `;
export const CompleteExpenseBulkDataFragmentDoc = gql`
    fragment CompleteExpenseBulkData on ExpenseBudgetItem {
  id
  completed_at
}
    `;
export const FinishedProjectDataFragmentDoc = gql`
    fragment FinishedProjectData on Project {
  id
  status
  finished_at
  finishedBy {
    id
    full_name
  }
}
    `;
export const DocumentExportFragmentDoc = gql`
    fragment DocumentExport on DocumentExport {
  type
  exported_at
}
    `;
export const OutgoingInvoiceOfInvoiceStatsFragmentDoc = gql`
    fragment OutgoingInvoiceOfInvoiceStats on OutgoingInvoice {
  id
  invoice_no
  date_of_supply
  type
  has_proforma_payments
  proformaInvoicesPivot {
    invoice {
      id
      invoice_no
    }
  }
  abraflexi_exported
  xero_exported
  stats {
    billing_amount
  }
  documentExports {
    ...DocumentExport
  }
  emailLogs {
    ...EmailLog
  }
}
    ${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}`;
export const MediaModelPartsFragmentDoc = gql`
    fragment MediaModelParts on AssignableFile {
  public_id
  mime_type
  size
  name
  filename
  urls {
    viewable
    original
  }
}
    `;
export const ModalOrderDataFragmentDoc = gql`
    fragment ModalOrderData on Order {
  id
  purchase_order_no
  date_of_order
  projects {
    id
  }
  brand {
    id
  }
  files {
    ...MediaModelParts
  }
  pdfFiles {
    ...MediaModelParts
  }
}
    ${MediaModelPartsFragmentDoc}`;
export const ProjectTitleFragmentDoc = gql`
    fragment ProjectTitle on Project {
  code
  numeric_code
  title
  billable
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;
export const ArchivedProjectDataFragmentDoc = gql`
    fragment ArchivedProjectData on Project {
  id
  status
  archived_at
  archivedBy {
    id
    full_name
  }
}
    `;
export const FilterTemplateFragmentFragmentDoc = gql`
    fragment FilterTemplateFragment on FilterTemplate {
  id
  model_id
  model_type
  type
  name
  params
  user_id
}
    `;
export const WorkspaceAccountingAccountSettingsFragmentDoc = gql`
    fragment WorkspaceAccountingAccountSettings on WorkspaceAccountingAccountSettings {
  accounting_accounts {
    id
    account_number
    title
    accounting_type
    budget_categories {
      accounting_account_id
      budget_category_id
      budget_category_type
    }
  }
}
    `;
export const CostCenterFragmentDoc = gql`
    fragment CostCenter on AccountingCentre {
  id
  centre
  title
  type
  deleted_at
}
    `;
export const WorkspaceAccountingVatClassificationSettingFragmentDoc = gql`
    fragment WorkspaceAccountingVatClassificationSetting on WorkspaceAccountingVatClassificationSettings {
  accounting_vat_classifications {
    id
    centre
    title
    type
    vat_rate_id
    vatRate {
      id
      amount
    }
    deleted_at
  }
}
    `;
export const MeFragmentDoc = gql`
    fragment Me on User {
  id
  first_name
  last_name
  full_name
  email
  codename
  scope {
    value
  }
  enabled_two_factor_authentication
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
      default_rate
    }
  }
  team {
    id
    name
  }
  roles {
    id
    name
    documentLimits {
      document_type
      limit
    }
  }
  permissions {
    bank_read_all
    brand_read
    brand_create
    brand_update
    brand_delete
    brand_archive
    brand_updateManagers
    client_read
    client_create
    client_update
    client_delete
    client_updateManagers
    contractor_read
    contractor_create
    contractor_update
    contractor_delete
    user_read_all
    user_read_own
    user_create
    user_scopeCreate
    user_update_all
    user_update_own
    user_updatePersonalData
    user_updateWorkData
    user_updateScopeUser
    user_updatePlanningData
    user_updateAllfredData
    user_delete
    user_haveProjectsAssigned
    user_profile_read
    user_profile_update
    user_password_update
    user_accessAccountingAttributes
    user_scope_all
    user_scope_own
    brandCreditAccount_read_all
    brandCreditAccount_read_team
    brandCreditAccount_read_own
    brandCreditAccount_create
    brandCreditAccount_update_all
    brandCreditAccount_update_team
    brandCreditAccount_update_own
    brandCreditAccount_delete_all
    brandCreditAccount_delete_team
    brandCreditAccount_delete_own
    brandCreditAccount_setBudgetCategories
    credit_transfer_fromBudgetItem
    credit_transfer_fromBrandCreditAccount
    credit_transfer_betweenTeams
    credit_transfer_withDate
    credit_prepayment
    contract_read
    contract_create
    contract_update
    contract_delete
    order_read
    order_create
    order_update
    order_delete
    otherDocument_read
    otherDocument_create
    otherDocument_update
    otherDocument_delete
    expense_read_all
    expense_read_own
    expense_read_team
    expense_read_excludeRestrictedTeams
    expense_create
    expense_update_all
    expense_update_own
    expense_update_team
    expense_delete_all
    expense_delete_own
    expense_delete_team
    expense_markAsPaid
    expense_deleteFiles
    expense_approve
    expense_accessAccountingAttributes
    expense_accessImported
    expense_canApproveBudgetItem
    expense_modelLock
    requestForInvoicing_read_all
    requestForInvoicing_read_own
    requestForInvoicing_read_team
    requestForInvoicing_create_all
    requestForInvoicing_create_own
    requestForInvoicing_create_team
    requestForInvoicing_update_all
    requestForInvoicing_update_own
    requestForInvoicing_update_team
    requestForInvoicing_delete_all
    requestForInvoicing_delete_own
    requestForInvoicing_delete_team
    requestForInvoicing_accessAccountingAttributes
    requestForInvoicing_querySubmittedCount_all
    requestForInvoicing_querySubmittedCount_own
    outgoingInvoice_read_all
    outgoingInvoice_read_own
    outgoingInvoice_read_team
    outgoingInvoice_create
    outgoingInvoice_update_all
    outgoingInvoice_update_own
    outgoingInvoice_update_team
    outgoingInvoice_delete_all
    outgoingInvoice_delete_own
    outgoingInvoice_delete_team
    outgoingInvoice_accessAccountingAttributes
    outgoingInvoice_markAsPaid
    outgoingInvoice_sendToClient
    outgoingInvoice_updateInvoiceNumber
    outgoingInvoice_modelLock
    project_accessAccountingAttributes
    project_viewAllFields
    project_read_all
    project_read_own
    project_read_team
    project_read_excludeRestrictedTeams
    project_create_all
    project_create_own
    project_create_team
    project_update_all
    project_update_own
    project_update_team
    project_delete_all
    project_delete_own
    project_delete_team
    project_pin_all
    project_pin_own
    project_pin_team
    project_finish_all
    project_finish_own
    project_finish_team
    project_reopen_all
    project_reopen_own
    project_reopen_team
    project_archive_all
    project_archive_own
    project_archive_team
    project_duplicate_all
    project_duplicate_own
    project_duplicate_team
    project_timeTrackingReport_read_all
    project_timeTrackingReport_read_own
    project_timeTrackingReport_read_team
    project_budget_update_all
    project_budget_update_own
    project_budget_update_team
    project_budget_completeExpenseBudgetItem_all
    project_budget_completeExpenseBudgetItem_own
    project_budget_completeExpenseBudgetItem_team
    project_budget_reopenExpenseBudgetItem_all
    project_budget_reopenExpenseBudgetItem_own
    project_budget_reopenExpenseBudgetItem_team
    project_lockBillingPlan
    project_billingTime_lock
    projectCategory_query
    projectCategory_create
    projectCategory_update
    projectCategory_delete
    wip_submit_all
    wip_submit_own
    wip_submit_team
    wip_lock_all
    wip_lock_own
    wip_lock_team
    wip_read_all
    wip_read_own
    wip_read_team
    wip_unlock_all
    wip_unlock_own
    wip_unlock_team
    wip_close_all
    wip_close_own
    wip_close_team
    wip_open_all
    wip_open_own
    wip_open_team
    timeTracking_read_all
    timeTracking_read_own
    timeTracking_read_team
    timeTracking_create_all
    timeTracking_create_own
    timeTracking_create_team
    timeTracking_update_all
    timeTracking_update_own
    timeTracking_update_team
    timeTracking_delete_all
    timeTracking_delete_own
    timeTracking_delete_team
    timeTracking_timer_use_all
    timeTracking_timer_use_own
    timeTracking_timer_use_team
    timeTracking_timer_use_manual
    timeTracking_report_read_all
    timeTracking_report_read_team
    timeTracking_report_read_own
    timeTracking_userMonthlyReport_read
    billingPlan_create
    billingPlan_update
    billingPlan_listing
    integration_budgetovac
    integration_forecasting
    task_viewAllFields
    task_read_all
    task_read_own
    task_create_all
    task_create_scoped
    task_update_all
    task_update_own
    task_update_scoped
    task_delete_all
    task_delete_own
    task_update_status_own
    task_update_status_all
    task_update_current_assignee_own
    task_update_current_assignee_all
    taskComment_create
    taskComment_update_own
    taskComment_update_all
    taskComment_delete_own
    taskComment_delete_all
    assignableFile_create
    assignableFile_delete_all
    assignableFile_delete_own
    planning_create_all
    planning_create_own
    planning_update_all
    planning_update_own
    planning_delete_all
    planning_delete_own
    planning_complete_all
    planning_complete_own
    planning_play_own
    planning_read_all
    planning_read_own
    planning_show_daily_capacity
    profitLossReport_query_all
    workspaceSetting_edit
    notificationSetting_query
    notificationSetting_update
    utilizationReport_query_all
    utilizationReport_query_own
    utilizationReport_query_team
    utilizationReportProfit_query_all
    budget_read_all
    budget_read_own
    budget_read_team
    quote_create_withoutInternalApproved
    quote_manualApprove
  }
}
    `;
export const VatRateOptionPartsFragmentDoc = gql`
    fragment VatRateOptionParts on VatRate {
  id
  amount
}
    `;
export const BudgetPdfSettingsFragmentDoc = gql`
    fragment BudgetPdfSettings on BudgetPdfSettings {
  show_hours
  show_disclaimer
  signature
  show_summary
  show_client_name
  show_client_details
  language
  our_work_show_commission
  title_page_with_vat
  workspace_company_id
  workspace_bank_account_id
  billing_entity_id
  hide_title_page
  add_billing_plan
  billing_plan_exchange_rate
  disclaimer {
    language
    disclaimer
  }
  our_work_positions
  our_work_view
  our_work_description
  our_work_vat_in_items
  our_work_show_discount
  expense_show_commission
  expense_show_quantity
  expense_show_unit
  expense_show_discount
  expense_show_description
  expense_show_vat_in_items
  show_client_and_brand
  show_project_name_full
  use_client_name_from_billing_entity
}
    `;
export const WorkspaceCompanyFragmentDoc = gql`
    fragment WorkspaceCompany on WorkspaceCompany {
  id
  name
  internal_name
  deleted
  currency_id
  country {
    id
  }
}
    `;
export const WorkspaceSettingsFragmentDoc = gql`
    fragment WorkspaceSettings on WorkspaceSettings {
  title
  setup_completed
  default_payment_due
  exchange_rate_denomination
  generate_numerical_brand_codes
  time_tracking_rate_type
  time_tracking_rate_length
  transfer_credit_directly_from_invoice
  require_two_factor_authentication
  invoicing_more_teams
  can_transfer_credit_with_date_without_constraints
  default_task_priority_id
  default_task_status_id
  automatically_approved_expense_items
  can_close_expense_budget_item_with_unapproved_expenses
  show_expense_item_vat_rate
  show_accounting_vat_classification
  trial_from
  unpaid_banner_message
  default_user_plannable_capacity
  specific_time_in_planning_enabled
  timetastic_integration
  working_from
  working_to
  planning_view_settings {
    name
    value
  }
  can_skip_invoice_date_validations
  show_done_tasks
  use_current_assignee
  planning_alphabet_user_order
  hide_expense_summary
  disable_home_office_in_planning
  hide_planning_total_daily_capacity
  start_day_of_week
  xero_enabled
  default_utilization_range_from
  default_utilization_range_to
  auto_deadline_in_tasks
  budget_xlsx_languages
  locale
  vapid_public_key
  default_show_unit_price_on_invoices
  default_show_billing_accounting_on_invoices
  automate_invoicing_plan_approval
  enable_bank
  bank_api_active
  enable_contractor_full_bank_account_data
  pipedrive_enabled
  expense_effectix_custom_cost_ratio
  partner_access_enabled
  enable_expense_email_import
  google_email_integration_enabled
  create_quote_only_after_approved_budgets
  show_smtp_settings
  show_mcp_settings
  brand_template_id
  enable_additional_brand_numeric_code
  show_amounts_in_time_tracking_report
  highlight_overtime_in_tasks
  enable_allocation_meeting_play
  auto_complete_allocation_types
  expense_identification_fields_required
  contractor_fields_extra_validation
  planned_expenses_show_client_price
  prevent_saving_duplicated_expenses
  financial_amount_by_percent
  enable_calendar_integration
  only_from_calendar_integration
  require_already_paid_subfields_for_drafts
  require_project_category
  country {
    id
    name
    code
  }
  currency {
    id
    denomination
    code
  }
  defaultVatRate {
    ...VatRateOptionParts
    deleted
    type
  }
  moduleSettings {
    billing_plan
    budgetovac
    clients
    contractors
    documents
    expenses
    invoices
    planovac
    projects
    reports
    time_tracking
    time_billing
  }
  exportSettings {
    expenses
    mrp
    pohoda
    premier
    proluc
    triad_project_effectiveness
    project_effectiveness
    project_progress_statistics
    project_status
    unpaid_outgoing_invoices
    mlggk_project_effectiveness
    xero
    vario
    transakcio
    omega
  }
  currencyExchangeRatesStructured {
    exchangeRates {
      id
      exchange_rate
      valid_from
      valid_to
    }
    currency {
      id
      code
      denomination
    }
  }
  budget_pdf_export_settings {
    ...BudgetPdfSettings
  }
  companies {
    ...WorkspaceCompany
    bankAccounts {
      id
      iban
      account_holder_name
      deleted
    }
  }
}
    ${VatRateOptionPartsFragmentDoc}
${BudgetPdfSettingsFragmentDoc}
${WorkspaceCompanyFragmentDoc}`;
export const ProjectStageFragmentDoc = gql`
    fragment ProjectStage on ProjectStage {
  id
  name
  system_name
}
    `;
export const StarFragmentDoc = gql`
    fragment Star on Star {
  id
  starable_id
  starable_type
  created_at
  updated_at
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  title
}
    `;
export const SubscribeToPushNotificationsDocument = gql`
    mutation SubscribeToPushNotifications($endpoint: String!, $keys: PushNotificationSubscriptionKeys!) {
  subscribeToPushNotifications(endpoint: $endpoint, keys: $keys)
}
    `;
export type SubscribeToPushNotificationsMutationFn = ApolloReactCommon.MutationFunction<SubscribeToPushNotificationsMutation, SubscribeToPushNotificationsMutationVariables>;

/**
 * __useSubscribeToPushNotificationsMutation__
 *
 * To run a mutation, you first call `useSubscribeToPushNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPushNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToPushNotificationsMutation, { data, loading, error }] = useSubscribeToPushNotificationsMutation({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useSubscribeToPushNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeToPushNotificationsMutation, SubscribeToPushNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeToPushNotificationsMutation, SubscribeToPushNotificationsMutationVariables>(SubscribeToPushNotificationsDocument, options);
      }
export type SubscribeToPushNotificationsMutationHookResult = ReturnType<typeof useSubscribeToPushNotificationsMutation>;
export type SubscribeToPushNotificationsMutationResult = ApolloReactCommon.MutationResult<SubscribeToPushNotificationsMutation>;
export type SubscribeToPushNotificationsMutationOptions = ApolloReactCommon.BaseMutationOptions<SubscribeToPushNotificationsMutation, SubscribeToPushNotificationsMutationVariables>;
export const UnsubscribeToPushNotificationsDocument = gql`
    mutation UnsubscribeToPushNotifications($endpoint: String!) {
  unsubscribeFromPushNotifications(endpoint: $endpoint)
}
    `;
export type UnsubscribeToPushNotificationsMutationFn = ApolloReactCommon.MutationFunction<UnsubscribeToPushNotificationsMutation, UnsubscribeToPushNotificationsMutationVariables>;

/**
 * __useUnsubscribeToPushNotificationsMutation__
 *
 * To run a mutation, you first call `useUnsubscribeToPushNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeToPushNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeToPushNotificationsMutation, { data, loading, error }] = useUnsubscribeToPushNotificationsMutation({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useUnsubscribeToPushNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeToPushNotificationsMutation, UnsubscribeToPushNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnsubscribeToPushNotificationsMutation, UnsubscribeToPushNotificationsMutationVariables>(UnsubscribeToPushNotificationsDocument, options);
      }
export type UnsubscribeToPushNotificationsMutationHookResult = ReturnType<typeof useUnsubscribeToPushNotificationsMutation>;
export type UnsubscribeToPushNotificationsMutationResult = ApolloReactCommon.MutationResult<UnsubscribeToPushNotificationsMutation>;
export type UnsubscribeToPushNotificationsMutationOptions = ApolloReactCommon.BaseMutationOptions<UnsubscribeToPushNotificationsMutation, UnsubscribeToPushNotificationsMutationVariables>;
export const AddManualAccountMoveDocument = gql`
    mutation AddManualAccountMove($amount: BigInt!, $currencyId: ID!, $note: String!, $date: Date!) {
  addManualAccountMove(
    amount: $amount
    currency_id: $currencyId
    note: $note
    date: $date
  ) {
    ...AccountMove
  }
}
    ${AccountMoveFragmentDoc}`;
export type AddManualAccountMoveMutationFn = ApolloReactCommon.MutationFunction<AddManualAccountMoveMutation, AddManualAccountMoveMutationVariables>;

/**
 * __useAddManualAccountMoveMutation__
 *
 * To run a mutation, you first call `useAddManualAccountMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManualAccountMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManualAccountMoveMutation, { data, loading, error }] = useAddManualAccountMoveMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      currencyId: // value for 'currencyId'
 *      note: // value for 'note'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAddManualAccountMoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddManualAccountMoveMutation, AddManualAccountMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddManualAccountMoveMutation, AddManualAccountMoveMutationVariables>(AddManualAccountMoveDocument, options);
      }
export type AddManualAccountMoveMutationHookResult = ReturnType<typeof useAddManualAccountMoveMutation>;
export type AddManualAccountMoveMutationResult = ApolloReactCommon.MutationResult<AddManualAccountMoveMutation>;
export type AddManualAccountMoveMutationOptions = ApolloReactCommon.BaseMutationOptions<AddManualAccountMoveMutation, AddManualAccountMoveMutationVariables>;
export const BankAccountsForPaymentsDocument = gql`
    query BankAccountsForPayments {
  bankAccounts {
    id
    workspace_bank_account_id
    iban
    name
  }
}
    `;

/**
 * __useBankAccountsForPaymentsQuery__
 *
 * To run a query within a React component, call `useBankAccountsForPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountsForPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountsForPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankAccountsForPaymentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>(BankAccountsForPaymentsDocument, options);
      }
export function useBankAccountsForPaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>(BankAccountsForPaymentsDocument, options);
        }
export function useBankAccountsForPaymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>(BankAccountsForPaymentsDocument, options);
        }
export type BankAccountsForPaymentsQueryHookResult = ReturnType<typeof useBankAccountsForPaymentsQuery>;
export type BankAccountsForPaymentsLazyQueryHookResult = ReturnType<typeof useBankAccountsForPaymentsLazyQuery>;
export type BankAccountsForPaymentsSuspenseQueryHookResult = ReturnType<typeof useBankAccountsForPaymentsSuspenseQuery>;
export type BankAccountsForPaymentsQueryResult = ApolloReactCommon.QueryResult<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>;
export const AddDocumentsToAccountMoveDocument = gql`
    mutation AddDocumentsToAccountMove($bankAccountMoveId: ID!, $documents: [BankAccountMoveDocumentInput!]!) {
  addDocumentsToAccountMove(
    bank_account_move_id: $bankAccountMoveId
    documents: $documents
  ) {
    ...AccountMove
  }
}
    ${AccountMoveFragmentDoc}`;
export type AddDocumentsToAccountMoveMutationFn = ApolloReactCommon.MutationFunction<AddDocumentsToAccountMoveMutation, AddDocumentsToAccountMoveMutationVariables>;

/**
 * __useAddDocumentsToAccountMoveMutation__
 *
 * To run a mutation, you first call `useAddDocumentsToAccountMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentsToAccountMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentsToAccountMoveMutation, { data, loading, error }] = useAddDocumentsToAccountMoveMutation({
 *   variables: {
 *      bankAccountMoveId: // value for 'bankAccountMoveId'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useAddDocumentsToAccountMoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDocumentsToAccountMoveMutation, AddDocumentsToAccountMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddDocumentsToAccountMoveMutation, AddDocumentsToAccountMoveMutationVariables>(AddDocumentsToAccountMoveDocument, options);
      }
export type AddDocumentsToAccountMoveMutationHookResult = ReturnType<typeof useAddDocumentsToAccountMoveMutation>;
export type AddDocumentsToAccountMoveMutationResult = ApolloReactCommon.MutationResult<AddDocumentsToAccountMoveMutation>;
export type AddDocumentsToAccountMoveMutationOptions = ApolloReactCommon.BaseMutationOptions<AddDocumentsToAccountMoveMutation, AddDocumentsToAccountMoveMutationVariables>;
export const ExpensesForPaymentMatchDocument = gql`
    query ExpensesForPaymentMatch($page: Int, $first: Int, $filters: ExpenseQueryArgs) {
  expenses(page: $page, first: $first, filters: $filters) {
    data {
      id
      expense_no
      type
      invoice_status
      paid_at
      date_of_supply
      due_date
      has_master_agreement
      contractor {
        id
        legal_name
      }
      projects {
        id
        code
        title
      }
      workspace_company_id
      variable_symbol
      iban
      exchange_rate
      stats {
        total_amount
        total_amount_without_vat_in_currency
        total_amount_with_vat_in_currency
      }
      accountMoves {
        amount
      }
      currency {
        id
        code
        denomination
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useExpensesForPaymentMatchQuery__
 *
 * To run a query within a React component, call `useExpensesForPaymentMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesForPaymentMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesForPaymentMatchQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExpensesForPaymentMatchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>(ExpensesForPaymentMatchDocument, options);
      }
export function useExpensesForPaymentMatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>(ExpensesForPaymentMatchDocument, options);
        }
export function useExpensesForPaymentMatchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>(ExpensesForPaymentMatchDocument, options);
        }
export type ExpensesForPaymentMatchQueryHookResult = ReturnType<typeof useExpensesForPaymentMatchQuery>;
export type ExpensesForPaymentMatchLazyQueryHookResult = ReturnType<typeof useExpensesForPaymentMatchLazyQuery>;
export type ExpensesForPaymentMatchSuspenseQueryHookResult = ReturnType<typeof useExpensesForPaymentMatchSuspenseQuery>;
export type ExpensesForPaymentMatchQueryResult = ApolloReactCommon.QueryResult<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>;
export const InvoicesForPaymentMatchDocument = gql`
    query InvoicesForPaymentMatch($page: Int, $first: Int, $filters: OIQueryArgs) {
  outgoingInvoices(page: $page, first: $first, filters: $filters) {
    data {
      id
      invoice_no
      abraflexi_exported
      xero_exported
      type
      paid_at
      emailLogs {
        ...EmailLog
      }
      brands {
        id
        name
      }
      billingEntity {
        legal_name
        street
        city
      }
      projects {
        id
        title
        code
      }
      currency {
        id
        code
        denomination
      }
      exchange_rate
      stats {
        total_amount_with_vat_in_currency
        billing_amount_in_currency
        billing_amount_with_vat_in_currency
      }
      accountMoves {
        amount
      }
      issue_date
      relatesToOutgoingProformaInvoice {
        invoicePdf {
          preview
        }
      }
      invoicePdf {
        preview
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${EmailLogFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useInvoicesForPaymentMatchQuery__
 *
 * To run a query within a React component, call `useInvoicesForPaymentMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesForPaymentMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesForPaymentMatchQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInvoicesForPaymentMatchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>(InvoicesForPaymentMatchDocument, options);
      }
export function useInvoicesForPaymentMatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>(InvoicesForPaymentMatchDocument, options);
        }
export function useInvoicesForPaymentMatchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>(InvoicesForPaymentMatchDocument, options);
        }
export type InvoicesForPaymentMatchQueryHookResult = ReturnType<typeof useInvoicesForPaymentMatchQuery>;
export type InvoicesForPaymentMatchLazyQueryHookResult = ReturnType<typeof useInvoicesForPaymentMatchLazyQuery>;
export type InvoicesForPaymentMatchSuspenseQueryHookResult = ReturnType<typeof useInvoicesForPaymentMatchSuspenseQuery>;
export type InvoicesForPaymentMatchQueryResult = ApolloReactCommon.QueryResult<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>;
export const ProformasForPaymentMatchDocument = gql`
    query ProformasForPaymentMatch($page: Int, $first: Int, $filters: OIProformaQueryArgs) {
  outgoingProformaInvoices(page: $page, first: $first, filters: $filters) {
    data {
      id
      invoice_no
      abraflexi_exported
      paid_at
      emailLogs {
        ...EmailLog
      }
      brands {
        id
        name
      }
      billingEntity {
        legal_name
        street
        city
      }
      projects {
        id
        title
        code
      }
      currency {
        id
        code
        denomination
      }
      exchange_rate
      stats {
        total_amount_with_vat_in_currency
      }
      accountMoves {
        amount
      }
      issue_date
      proofOfPayments {
        id
        invoice_no
        invoicePdf {
          preview
        }
      }
      invoicePdf {
        preview
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${EmailLogFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProformasForPaymentMatchQuery__
 *
 * To run a query within a React component, call `useProformasForPaymentMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformasForPaymentMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformasForPaymentMatchQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProformasForPaymentMatchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>(ProformasForPaymentMatchDocument, options);
      }
export function useProformasForPaymentMatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>(ProformasForPaymentMatchDocument, options);
        }
export function useProformasForPaymentMatchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>(ProformasForPaymentMatchDocument, options);
        }
export type ProformasForPaymentMatchQueryHookResult = ReturnType<typeof useProformasForPaymentMatchQuery>;
export type ProformasForPaymentMatchLazyQueryHookResult = ReturnType<typeof useProformasForPaymentMatchLazyQuery>;
export type ProformasForPaymentMatchSuspenseQueryHookResult = ReturnType<typeof useProformasForPaymentMatchSuspenseQuery>;
export type ProformasForPaymentMatchQueryResult = ApolloReactCommon.QueryResult<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>;
export const MatchPaymentModalFilterOptionsDocument = gql`
    query MatchPaymentModalFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
}
    `;

/**
 * __useMatchPaymentModalFilterOptionsQuery__
 *
 * To run a query within a React component, call `useMatchPaymentModalFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchPaymentModalFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchPaymentModalFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMatchPaymentModalFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>(MatchPaymentModalFilterOptionsDocument, options);
      }
export function useMatchPaymentModalFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>(MatchPaymentModalFilterOptionsDocument, options);
        }
export function useMatchPaymentModalFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>(MatchPaymentModalFilterOptionsDocument, options);
        }
export type MatchPaymentModalFilterOptionsQueryHookResult = ReturnType<typeof useMatchPaymentModalFilterOptionsQuery>;
export type MatchPaymentModalFilterOptionsLazyQueryHookResult = ReturnType<typeof useMatchPaymentModalFilterOptionsLazyQuery>;
export type MatchPaymentModalFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useMatchPaymentModalFilterOptionsSuspenseQuery>;
export type MatchPaymentModalFilterOptionsQueryResult = ApolloReactCommon.QueryResult<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>;
export const ExcludeAccountMoveDocument = gql`
    mutation ExcludeAccountMove($accountMoveId: ID!) {
  excludeBankAccountMove(bank_account_move_id: $accountMoveId) {
    ...AccountMove
  }
}
    ${AccountMoveFragmentDoc}`;
export type ExcludeAccountMoveMutationFn = ApolloReactCommon.MutationFunction<ExcludeAccountMoveMutation, ExcludeAccountMoveMutationVariables>;

/**
 * __useExcludeAccountMoveMutation__
 *
 * To run a mutation, you first call `useExcludeAccountMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeAccountMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeAccountMoveMutation, { data, loading, error }] = useExcludeAccountMoveMutation({
 *   variables: {
 *      accountMoveId: // value for 'accountMoveId'
 *   },
 * });
 */
export function useExcludeAccountMoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExcludeAccountMoveMutation, ExcludeAccountMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExcludeAccountMoveMutation, ExcludeAccountMoveMutationVariables>(ExcludeAccountMoveDocument, options);
      }
export type ExcludeAccountMoveMutationHookResult = ReturnType<typeof useExcludeAccountMoveMutation>;
export type ExcludeAccountMoveMutationResult = ApolloReactCommon.MutationResult<ExcludeAccountMoveMutation>;
export type ExcludeAccountMoveMutationOptions = ApolloReactCommon.BaseMutationOptions<ExcludeAccountMoveMutation, ExcludeAccountMoveMutationVariables>;
export const BankAccountMovesDocument = gql`
    query BankAccountMoves($filters: BankAccountMoveQueryArgs, $first: Int, $page: Int) {
  bankAccountMoves(filters: $filters, first: $first, page: $page) {
    data {
      ...AccountMove
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${AccountMoveFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useBankAccountMovesQuery__
 *
 * To run a query within a React component, call `useBankAccountMovesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountMovesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountMovesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBankAccountMovesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BankAccountMovesQuery, BankAccountMovesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BankAccountMovesQuery, BankAccountMovesQueryVariables>(BankAccountMovesDocument, options);
      }
export function useBankAccountMovesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BankAccountMovesQuery, BankAccountMovesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BankAccountMovesQuery, BankAccountMovesQueryVariables>(BankAccountMovesDocument, options);
        }
export function useBankAccountMovesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BankAccountMovesQuery, BankAccountMovesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BankAccountMovesQuery, BankAccountMovesQueryVariables>(BankAccountMovesDocument, options);
        }
export type BankAccountMovesQueryHookResult = ReturnType<typeof useBankAccountMovesQuery>;
export type BankAccountMovesLazyQueryHookResult = ReturnType<typeof useBankAccountMovesLazyQuery>;
export type BankAccountMovesSuspenseQueryHookResult = ReturnType<typeof useBankAccountMovesSuspenseQuery>;
export type BankAccountMovesQueryResult = ApolloReactCommon.QueryResult<BankAccountMovesQuery, BankAccountMovesQueryVariables>;
export const CreateBillingEntityDocument = gql`
    mutation CreateBillingEntity($input: CreateBillingEntityInput!) {
  createBillingEntity(input: $input) {
    ...BillingEntityModal
  }
}
    ${BillingEntityModalFragmentDoc}`;
export type CreateBillingEntityMutationFn = ApolloReactCommon.MutationFunction<CreateBillingEntityMutation, CreateBillingEntityMutationVariables>;

/**
 * __useCreateBillingEntityMutation__
 *
 * To run a mutation, you first call `useCreateBillingEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingEntityMutation, { data, loading, error }] = useCreateBillingEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBillingEntityMutation, CreateBillingEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBillingEntityMutation, CreateBillingEntityMutationVariables>(CreateBillingEntityDocument, options);
      }
export type CreateBillingEntityMutationHookResult = ReturnType<typeof useCreateBillingEntityMutation>;
export type CreateBillingEntityMutationResult = ApolloReactCommon.MutationResult<CreateBillingEntityMutation>;
export type CreateBillingEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBillingEntityMutation, CreateBillingEntityMutationVariables>;
export const UpdateBillingEntityDocument = gql`
    mutation UpdateBillingEntity($input: UpdateBillingEntityInput!) {
  updateBillingEntity(input: $input) {
    ...BillingEntityModal
  }
}
    ${BillingEntityModalFragmentDoc}`;
export type UpdateBillingEntityMutationFn = ApolloReactCommon.MutationFunction<UpdateBillingEntityMutation, UpdateBillingEntityMutationVariables>;

/**
 * __useUpdateBillingEntityMutation__
 *
 * To run a mutation, you first call `useUpdateBillingEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingEntityMutation, { data, loading, error }] = useUpdateBillingEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBillingEntityMutation, UpdateBillingEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBillingEntityMutation, UpdateBillingEntityMutationVariables>(UpdateBillingEntityDocument, options);
      }
export type UpdateBillingEntityMutationHookResult = ReturnType<typeof useUpdateBillingEntityMutation>;
export type UpdateBillingEntityMutationResult = ApolloReactCommon.MutationResult<UpdateBillingEntityMutation>;
export type UpdateBillingEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBillingEntityMutation, UpdateBillingEntityMutationVariables>;
export const OptionsForBillingEntityDocument = gql`
    query OptionsForBillingEntity {
  countrySimpleMap {
    id
    name
  }
  languagesForInvoicePdf
}
    `;

/**
 * __useOptionsForBillingEntityQuery__
 *
 * To run a query within a React component, call `useOptionsForBillingEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsForBillingEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsForBillingEntityQuery({
 *   variables: {
 *   },
 * });
 */
export function useOptionsForBillingEntityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>(OptionsForBillingEntityDocument, options);
      }
export function useOptionsForBillingEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>(OptionsForBillingEntityDocument, options);
        }
export function useOptionsForBillingEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>(OptionsForBillingEntityDocument, options);
        }
export type OptionsForBillingEntityQueryHookResult = ReturnType<typeof useOptionsForBillingEntityQuery>;
export type OptionsForBillingEntityLazyQueryHookResult = ReturnType<typeof useOptionsForBillingEntityLazyQuery>;
export type OptionsForBillingEntitySuspenseQueryHookResult = ReturnType<typeof useOptionsForBillingEntitySuspenseQuery>;
export type OptionsForBillingEntityQueryResult = ApolloReactCommon.QueryResult<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>;
export const CreateBrandDocument = gql`
    mutation CreateBrand($input: CreateBrandInput!) {
  createBrand(input: $input) {
    ...BrandModal
  }
}
    ${BrandModalFragmentDoc}`;
export type CreateBrandMutationFn = ApolloReactCommon.MutationFunction<CreateBrandMutation, CreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBrandMutation, CreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = ApolloReactCommon.MutationResult<CreateBrandMutation>;
export type CreateBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBrandMutation, CreateBrandMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($input: UpdateBrandInput!) {
  updateBrand(input: $input) {
    ...BrandModal
  }
}
    ${BrandModalFragmentDoc}`;
export type UpdateBrandMutationFn = ApolloReactCommon.MutationFunction<UpdateBrandMutation, UpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = ApolloReactCommon.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const GetNextNumericalBrandCodeDocument = gql`
    query GetNextNumericalBrandCode {
  getNextNumericalBrandCode
}
    `;

/**
 * __useGetNextNumericalBrandCodeQuery__
 *
 * To run a query within a React component, call `useGetNextNumericalBrandCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextNumericalBrandCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextNumericalBrandCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextNumericalBrandCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>(GetNextNumericalBrandCodeDocument, options);
      }
export function useGetNextNumericalBrandCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>(GetNextNumericalBrandCodeDocument, options);
        }
export function useGetNextNumericalBrandCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>(GetNextNumericalBrandCodeDocument, options);
        }
export type GetNextNumericalBrandCodeQueryHookResult = ReturnType<typeof useGetNextNumericalBrandCodeQuery>;
export type GetNextNumericalBrandCodeLazyQueryHookResult = ReturnType<typeof useGetNextNumericalBrandCodeLazyQuery>;
export type GetNextNumericalBrandCodeSuspenseQueryHookResult = ReturnType<typeof useGetNextNumericalBrandCodeSuspenseQuery>;
export type GetNextNumericalBrandCodeQueryResult = ApolloReactCommon.QueryResult<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>;
export const ClientOptionsForModalBrandDocument = gql`
    query ClientOptionsForModalBrand {
  clientsSimpleMap {
    id
    name
  }
}
    `;

/**
 * __useClientOptionsForModalBrandQuery__
 *
 * To run a query within a React component, call `useClientOptionsForModalBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOptionsForModalBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOptionsForModalBrandQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientOptionsForModalBrandQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>(ClientOptionsForModalBrandDocument, options);
      }
export function useClientOptionsForModalBrandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>(ClientOptionsForModalBrandDocument, options);
        }
export function useClientOptionsForModalBrandSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>(ClientOptionsForModalBrandDocument, options);
        }
export type ClientOptionsForModalBrandQueryHookResult = ReturnType<typeof useClientOptionsForModalBrandQuery>;
export type ClientOptionsForModalBrandLazyQueryHookResult = ReturnType<typeof useClientOptionsForModalBrandLazyQuery>;
export type ClientOptionsForModalBrandSuspenseQueryHookResult = ReturnType<typeof useClientOptionsForModalBrandSuspenseQuery>;
export type ClientOptionsForModalBrandQueryResult = ApolloReactCommon.QueryResult<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>;
export const BillingEntityOptionsForModalBrandDocument = gql`
    query BillingEntityOptionsForModalBrand($client_id: ID!) {
  client(id: $client_id) {
    id
    name
    billingEntities {
      id
      internal_name
    }
    workspaceCompany {
      id
    }
  }
}
    `;

/**
 * __useBillingEntityOptionsForModalBrandQuery__
 *
 * To run a query within a React component, call `useBillingEntityOptionsForModalBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingEntityOptionsForModalBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingEntityOptionsForModalBrandQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useBillingEntityOptionsForModalBrandQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables> & ({ variables: BillingEntityOptionsForModalBrandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>(BillingEntityOptionsForModalBrandDocument, options);
      }
export function useBillingEntityOptionsForModalBrandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>(BillingEntityOptionsForModalBrandDocument, options);
        }
export function useBillingEntityOptionsForModalBrandSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>(BillingEntityOptionsForModalBrandDocument, options);
        }
export type BillingEntityOptionsForModalBrandQueryHookResult = ReturnType<typeof useBillingEntityOptionsForModalBrandQuery>;
export type BillingEntityOptionsForModalBrandLazyQueryHookResult = ReturnType<typeof useBillingEntityOptionsForModalBrandLazyQuery>;
export type BillingEntityOptionsForModalBrandSuspenseQueryHookResult = ReturnType<typeof useBillingEntityOptionsForModalBrandSuspenseQuery>;
export type BillingEntityOptionsForModalBrandQueryResult = ApolloReactCommon.QueryResult<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>;
export const GetBrandForCreditAccountsDocument = gql`
    query GetBrandForCreditAccounts($id: ID!) {
  brand(id: $id) {
    id
    name
    code
    image {
      urls {
        thumbnail
      }
    }
    client {
      id
      name
    }
  }
}
    `;

/**
 * __useGetBrandForCreditAccountsQuery__
 *
 * To run a query within a React component, call `useGetBrandForCreditAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForCreditAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForCreditAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandForCreditAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables> & ({ variables: GetBrandForCreditAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>(GetBrandForCreditAccountsDocument, options);
      }
export function useGetBrandForCreditAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>(GetBrandForCreditAccountsDocument, options);
        }
export function useGetBrandForCreditAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>(GetBrandForCreditAccountsDocument, options);
        }
export type GetBrandForCreditAccountsQueryHookResult = ReturnType<typeof useGetBrandForCreditAccountsQuery>;
export type GetBrandForCreditAccountsLazyQueryHookResult = ReturnType<typeof useGetBrandForCreditAccountsLazyQuery>;
export type GetBrandForCreditAccountsSuspenseQueryHookResult = ReturnType<typeof useGetBrandForCreditAccountsSuspenseQuery>;
export type GetBrandForCreditAccountsQueryResult = ApolloReactCommon.QueryResult<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>;
export const UpdateTimeTrackingRatesForBrandDocument = gql`
    mutation UpdateTimeTrackingRatesForBrand($input: UpdateTimeTrackingRatesForBrandInput!) {
  updateTimeTrackingRatesForBrand(input: $input) {
    id
    average_time_tracking_rate
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
  }
}
    `;
export type UpdateTimeTrackingRatesForBrandMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeTrackingRatesForBrandMutation, UpdateTimeTrackingRatesForBrandMutationVariables>;

/**
 * __useUpdateTimeTrackingRatesForBrandMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingRatesForBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingRatesForBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingRatesForBrandMutation, { data, loading, error }] = useUpdateTimeTrackingRatesForBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeTrackingRatesForBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeTrackingRatesForBrandMutation, UpdateTimeTrackingRatesForBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeTrackingRatesForBrandMutation, UpdateTimeTrackingRatesForBrandMutationVariables>(UpdateTimeTrackingRatesForBrandDocument, options);
      }
export type UpdateTimeTrackingRatesForBrandMutationHookResult = ReturnType<typeof useUpdateTimeTrackingRatesForBrandMutation>;
export type UpdateTimeTrackingRatesForBrandMutationResult = ApolloReactCommon.MutationResult<UpdateTimeTrackingRatesForBrandMutation>;
export type UpdateTimeTrackingRatesForBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeTrackingRatesForBrandMutation, UpdateTimeTrackingRatesForBrandMutationVariables>;
export const BrandDetailDocument = gql`
    query BrandDetail($id: ID!) {
  clientsSimpleMap {
    id
    name
  }
  brand(id: $id) {
    id
    name
    code
    numeric_code
    cloudUrl
    driveCloudUrl
    image {
      urls {
        thumbnail
      }
    }
    archived_at
    responsiblePerson {
      id
    }
    otherResponsiblePersons {
      id
    }
    defaultBillingEntity {
      id
    }
    pipedriveCustomFieldValues {
      ...PipedriveCustomField
    }
    client {
      id
      name
      billingEntities {
        id
        internal_name
      }
      responsiblePerson {
        id
      }
      otherResponsiblePersons {
        id
      }
    }
    users {
      id
      codename
      first_name
      last_name
      full_name
      email
      scope {
        value
      }
      scope_access
    }
    contacts {
      id
      first_name
      last_name
      phone
      email
      pipedriveCustomFieldValues {
        ...PipedriveCustomField
      }
    }
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
    average_time_tracking_rate
    calculated_average_time_tracking_rate
  }
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
}
    ${PipedriveCustomFieldFragmentDoc}`;

/**
 * __useBrandDetailQuery__
 *
 * To run a query within a React component, call `useBrandDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandDetailQuery, BrandDetailQueryVariables> & ({ variables: BrandDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandDetailQuery, BrandDetailQueryVariables>(BrandDetailDocument, options);
      }
export function useBrandDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandDetailQuery, BrandDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandDetailQuery, BrandDetailQueryVariables>(BrandDetailDocument, options);
        }
export function useBrandDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandDetailQuery, BrandDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandDetailQuery, BrandDetailQueryVariables>(BrandDetailDocument, options);
        }
export type BrandDetailQueryHookResult = ReturnType<typeof useBrandDetailQuery>;
export type BrandDetailLazyQueryHookResult = ReturnType<typeof useBrandDetailLazyQuery>;
export type BrandDetailSuspenseQueryHookResult = ReturnType<typeof useBrandDetailSuspenseQuery>;
export type BrandDetailQueryResult = ApolloReactCommon.QueryResult<BrandDetailQuery, BrandDetailQueryVariables>;
export const GetBrandForDocumentsDocument = gql`
    query GetBrandForDocuments($id: ID!) {
  brand(id: $id) {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    code
    client {
      id
      name
    }
  }
}
    `;

/**
 * __useGetBrandForDocumentsQuery__
 *
 * To run a query within a React component, call `useGetBrandForDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandForDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandForDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandForDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables> & ({ variables: GetBrandForDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>(GetBrandForDocumentsDocument, options);
      }
export function useGetBrandForDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>(GetBrandForDocumentsDocument, options);
        }
export function useGetBrandForDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>(GetBrandForDocumentsDocument, options);
        }
export type GetBrandForDocumentsQueryHookResult = ReturnType<typeof useGetBrandForDocumentsQuery>;
export type GetBrandForDocumentsLazyQueryHookResult = ReturnType<typeof useGetBrandForDocumentsLazyQuery>;
export type GetBrandForDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetBrandForDocumentsSuspenseQuery>;
export type GetBrandForDocumentsQueryResult = ApolloReactCommon.QueryResult<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>;
export const GetBrandsDocument = gql`
    query GetBrands($page: Int, $first: Int, $filters: BrandQueryArgs) {
  clientsSimpleMap {
    id
    name
  }
  contacts {
    id
    first_name
    last_name
  }
  brandsSummary(filters: $filters) {
    brandIds
  }
  brands(page: $page, first: $first, filters: $filters) {
    data {
      id
      name
      code
      archived_at
      image {
        urls {
          thumbnail
        }
      }
      client {
        id
        name
      }
      contacts {
        id
        first_name
        last_name
      }
      creditAccounts {
        id
      }
      defaultBillingEntity {
        id
      }
      pipedriveCustomFieldValues {
        ...PipedriveCustomField
      }
      stats {
        active_projects
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PipedriveCustomFieldFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBrandsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
      }
export function useGetBrandsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export function useGetBrandsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>;
export type GetBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsLazyQuery>;
export type GetBrandsSuspenseQueryHookResult = ReturnType<typeof useGetBrandsSuspenseQuery>;
export type GetBrandsQueryResult = ApolloReactCommon.QueryResult<GetBrandsQuery, GetBrandsQueryVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: ID!) {
  deleteBrand(id: $id) {
    id
  }
}
    `;
export type DeleteBrandMutationFn = ApolloReactCommon.MutationFunction<DeleteBrandMutation, DeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBrandMutation, DeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = ApolloReactCommon.MutationResult<DeleteBrandMutation>;
export type DeleteBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBrandMutation, DeleteBrandMutationVariables>;
export const ArchiveBrandDocument = gql`
    mutation ArchiveBrand($id: ID!) {
  archiveBrand(id: $id) {
    id
  }
}
    `;
export type ArchiveBrandMutationFn = ApolloReactCommon.MutationFunction<ArchiveBrandMutation, ArchiveBrandMutationVariables>;

/**
 * __useArchiveBrandMutation__
 *
 * To run a mutation, you first call `useArchiveBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBrandMutation, { data, loading, error }] = useArchiveBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveBrandMutation, ArchiveBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveBrandMutation, ArchiveBrandMutationVariables>(ArchiveBrandDocument, options);
      }
export type ArchiveBrandMutationHookResult = ReturnType<typeof useArchiveBrandMutation>;
export type ArchiveBrandMutationResult = ApolloReactCommon.MutationResult<ArchiveBrandMutation>;
export type ArchiveBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveBrandMutation, ArchiveBrandMutationVariables>;
export const UnarchiveBrandDocument = gql`
    mutation UnarchiveBrand($id: ID!) {
  unarchiveBrand(id: $id) {
    id
  }
}
    `;
export type UnarchiveBrandMutationFn = ApolloReactCommon.MutationFunction<UnarchiveBrandMutation, UnarchiveBrandMutationVariables>;

/**
 * __useUnarchiveBrandMutation__
 *
 * To run a mutation, you first call `useUnarchiveBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveBrandMutation, { data, loading, error }] = useUnarchiveBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnarchiveBrandMutation, UnarchiveBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnarchiveBrandMutation, UnarchiveBrandMutationVariables>(UnarchiveBrandDocument, options);
      }
export type UnarchiveBrandMutationHookResult = ReturnType<typeof useUnarchiveBrandMutation>;
export type UnarchiveBrandMutationResult = ApolloReactCommon.MutationResult<UnarchiveBrandMutation>;
export type UnarchiveBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<UnarchiveBrandMutation, UnarchiveBrandMutationVariables>;
export const PreviewQuoteDocument = gql`
    mutation PreviewQuote($input: quoteInput!) {
  previewQuote(input: $input) {
    url
  }
}
    `;
export type PreviewQuoteMutationFn = ApolloReactCommon.MutationFunction<PreviewQuoteMutation, PreviewQuoteMutationVariables>;

/**
 * __usePreviewQuoteMutation__
 *
 * To run a mutation, you first call `usePreviewQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewQuoteMutation, { data, loading, error }] = usePreviewQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PreviewQuoteMutation, PreviewQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PreviewQuoteMutation, PreviewQuoteMutationVariables>(PreviewQuoteDocument, options);
      }
export type PreviewQuoteMutationHookResult = ReturnType<typeof usePreviewQuoteMutation>;
export type PreviewQuoteMutationResult = ApolloReactCommon.MutationResult<PreviewQuoteMutation>;
export type PreviewQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<PreviewQuoteMutation, PreviewQuoteMutationVariables>;
export const SaveQuoteDocument = gql`
    mutation SaveQuote($input: quoteInput!) {
  saveQuote(input: $input) {
    id
    url
  }
}
    `;
export type SaveQuoteMutationFn = ApolloReactCommon.MutationFunction<SaveQuoteMutation, SaveQuoteMutationVariables>;

/**
 * __useSaveQuoteMutation__
 *
 * To run a mutation, you first call `useSaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuoteMutation, { data, loading, error }] = useSaveQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveQuoteMutation, SaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveQuoteMutation, SaveQuoteMutationVariables>(SaveQuoteDocument, options);
      }
export type SaveQuoteMutationHookResult = ReturnType<typeof useSaveQuoteMutation>;
export type SaveQuoteMutationResult = ApolloReactCommon.MutationResult<SaveQuoteMutation>;
export type SaveQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveQuoteMutation, SaveQuoteMutationVariables>;
export const GetQuoteDocument = gql`
    query GetQuote($id: ID!) {
  GetQuote(id: $id) {
    id
    settings {
      ...BudgetPdfSettings
      date
      valid_until
    }
    url
    number
    status
    total_amount
    currency {
      id
      code
      denomination
      exchange_rate
    }
    budgets {
      id
      project {
        id
        title
      }
      brand {
        id
        name
      }
      account_manager
      assignment_date
      status
      client_approved
      price
      currency {
        id
        code
        denomination
        exchange_rate
      }
    }
    sent_to_client_date
    client_approval_date
    Client {
      billingEntities {
        id
        internal_name
        street
        city
        workspaceCompany {
          id
          deleted
        }
      }
    }
  }
}
    ${BudgetPdfSettingsFragmentDoc}`;

/**
 * __useGetQuoteQuery__
 *
 * To run a query within a React component, call `useGetQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables> & ({ variables: GetQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
      }
export function useGetQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
        }
export function useGetQuoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
        }
export type GetQuoteQueryHookResult = ReturnType<typeof useGetQuoteQuery>;
export type GetQuoteLazyQueryHookResult = ReturnType<typeof useGetQuoteLazyQuery>;
export type GetQuoteSuspenseQueryHookResult = ReturnType<typeof useGetQuoteSuspenseQuery>;
export type GetQuoteQueryResult = ApolloReactCommon.QueryResult<GetQuoteQuery, GetQuoteQueryVariables>;
export const CreateQuoteDocument = gql`
    mutation CreateQuote($budget_ids: [ID]!) {
  createQuote(budget_ids: $budget_ids) {
    id
    url
  }
}
    `;
export type CreateQuoteMutationFn = ApolloReactCommon.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      budget_ids: // value for 'budget_ids'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, options);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = ApolloReactCommon.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const BudgetsExportDocument = gql`
    query BudgetsExport($ids: [ID], $options: BudgetExportOptionsInput) {
  budgetsExport(ids: $ids, options: $options)
}
    `;

/**
 * __useBudgetsExportQuery__
 *
 * To run a query within a React component, call `useBudgetsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetsExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useBudgetsExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetsExportQuery, BudgetsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetsExportQuery, BudgetsExportQueryVariables>(BudgetsExportDocument, options);
      }
export function useBudgetsExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetsExportQuery, BudgetsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetsExportQuery, BudgetsExportQueryVariables>(BudgetsExportDocument, options);
        }
export function useBudgetsExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetsExportQuery, BudgetsExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetsExportQuery, BudgetsExportQueryVariables>(BudgetsExportDocument, options);
        }
export type BudgetsExportQueryHookResult = ReturnType<typeof useBudgetsExportQuery>;
export type BudgetsExportLazyQueryHookResult = ReturnType<typeof useBudgetsExportLazyQuery>;
export type BudgetsExportSuspenseQueryHookResult = ReturnType<typeof useBudgetsExportSuspenseQuery>;
export type BudgetsExportQueryResult = ApolloReactCommon.QueryResult<BudgetsExportQuery, BudgetsExportQueryVariables>;
export const BudgetsFilterOptionsDocument = gql`
    query BudgetsFilterOptions {
  brandsSimpleMap {
    id
    name
  }
  projectsSimpleMap {
    id
    title
    code
  }
}
    `;

/**
 * __useBudgetsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useBudgetsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetsFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetsFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>(BudgetsFilterOptionsDocument, options);
      }
export function useBudgetsFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>(BudgetsFilterOptionsDocument, options);
        }
export function useBudgetsFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>(BudgetsFilterOptionsDocument, options);
        }
export type BudgetsFilterOptionsQueryHookResult = ReturnType<typeof useBudgetsFilterOptionsQuery>;
export type BudgetsFilterOptionsLazyQueryHookResult = ReturnType<typeof useBudgetsFilterOptionsLazyQuery>;
export type BudgetsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useBudgetsFilterOptionsSuspenseQuery>;
export type BudgetsFilterOptionsQueryResult = ApolloReactCommon.QueryResult<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>;
export const GetBudgetsDocument = gql`
    query GetBudgets($filters: BudgetArgs) {
  budgets(filters: $filters) {
    data {
      ...BudgetGroup
    }
    allIds
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BudgetGroupFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGetBudgetsQuery__
 *
 * To run a query within a React component, call `useGetBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBudgetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
      }
export function useGetBudgetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
        }
export function useGetBudgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
        }
export type GetBudgetsQueryHookResult = ReturnType<typeof useGetBudgetsQuery>;
export type GetBudgetsLazyQueryHookResult = ReturnType<typeof useGetBudgetsLazyQuery>;
export type GetBudgetsSuspenseQueryHookResult = ReturnType<typeof useGetBudgetsSuspenseQuery>;
export type GetBudgetsQueryResult = ApolloReactCommon.QueryResult<GetBudgetsQuery, GetBudgetsQueryVariables>;
export const CreateBudgetovacPositionsSetDocument = gql`
    mutation CreateBudgetovacPositionsSet($input: CreateBudgetovacPositionsSetInput!) {
  createBudgetovacPositionsSet(input: $input) {
    id
  }
}
    `;
export type CreateBudgetovacPositionsSetMutationFn = ApolloReactCommon.MutationFunction<CreateBudgetovacPositionsSetMutation, CreateBudgetovacPositionsSetMutationVariables>;

/**
 * __useCreateBudgetovacPositionsSetMutation__
 *
 * To run a mutation, you first call `useCreateBudgetovacPositionsSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetovacPositionsSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetovacPositionsSetMutation, { data, loading, error }] = useCreateBudgetovacPositionsSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBudgetovacPositionsSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBudgetovacPositionsSetMutation, CreateBudgetovacPositionsSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBudgetovacPositionsSetMutation, CreateBudgetovacPositionsSetMutationVariables>(CreateBudgetovacPositionsSetDocument, options);
      }
export type CreateBudgetovacPositionsSetMutationHookResult = ReturnType<typeof useCreateBudgetovacPositionsSetMutation>;
export type CreateBudgetovacPositionsSetMutationResult = ApolloReactCommon.MutationResult<CreateBudgetovacPositionsSetMutation>;
export type CreateBudgetovacPositionsSetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBudgetovacPositionsSetMutation, CreateBudgetovacPositionsSetMutationVariables>;
export const UpdateBudgetovacPositionsSetDocument = gql`
    mutation UpdateBudgetovacPositionsSet($input: UpdateBudgetovacPositionsSetInput!) {
  updateBudgetovacPositionsSet(input: $input) {
    id
  }
}
    `;
export type UpdateBudgetovacPositionsSetMutationFn = ApolloReactCommon.MutationFunction<UpdateBudgetovacPositionsSetMutation, UpdateBudgetovacPositionsSetMutationVariables>;

/**
 * __useUpdateBudgetovacPositionsSetMutation__
 *
 * To run a mutation, you first call `useUpdateBudgetovacPositionsSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudgetovacPositionsSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudgetovacPositionsSetMutation, { data, loading, error }] = useUpdateBudgetovacPositionsSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBudgetovacPositionsSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBudgetovacPositionsSetMutation, UpdateBudgetovacPositionsSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBudgetovacPositionsSetMutation, UpdateBudgetovacPositionsSetMutationVariables>(UpdateBudgetovacPositionsSetDocument, options);
      }
export type UpdateBudgetovacPositionsSetMutationHookResult = ReturnType<typeof useUpdateBudgetovacPositionsSetMutation>;
export type UpdateBudgetovacPositionsSetMutationResult = ApolloReactCommon.MutationResult<UpdateBudgetovacPositionsSetMutation>;
export type UpdateBudgetovacPositionsSetMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBudgetovacPositionsSetMutation, UpdateBudgetovacPositionsSetMutationVariables>;
export const DeleteBudgetovacPositionsSetDocument = gql`
    mutation DeleteBudgetovacPositionsSet($id: ID!) {
  deleteBudgetovacPositionsSet(id: $id) {
    id
  }
}
    `;
export type DeleteBudgetovacPositionsSetMutationFn = ApolloReactCommon.MutationFunction<DeleteBudgetovacPositionsSetMutation, DeleteBudgetovacPositionsSetMutationVariables>;

/**
 * __useDeleteBudgetovacPositionsSetMutation__
 *
 * To run a mutation, you first call `useDeleteBudgetovacPositionsSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBudgetovacPositionsSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBudgetovacPositionsSetMutation, { data, loading, error }] = useDeleteBudgetovacPositionsSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBudgetovacPositionsSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBudgetovacPositionsSetMutation, DeleteBudgetovacPositionsSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBudgetovacPositionsSetMutation, DeleteBudgetovacPositionsSetMutationVariables>(DeleteBudgetovacPositionsSetDocument, options);
      }
export type DeleteBudgetovacPositionsSetMutationHookResult = ReturnType<typeof useDeleteBudgetovacPositionsSetMutation>;
export type DeleteBudgetovacPositionsSetMutationResult = ApolloReactCommon.MutationResult<DeleteBudgetovacPositionsSetMutation>;
export type DeleteBudgetovacPositionsSetMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBudgetovacPositionsSetMutation, DeleteBudgetovacPositionsSetMutationVariables>;
export const SetActiveBudgetovacPositionsSetDocument = gql`
    mutation SetActiveBudgetovacPositionsSet($id: ID!, $active: Boolean!) {
  setActiveBudgetovacPositionsSet(id: $id, active: $active) {
    id
  }
}
    `;
export type SetActiveBudgetovacPositionsSetMutationFn = ApolloReactCommon.MutationFunction<SetActiveBudgetovacPositionsSetMutation, SetActiveBudgetovacPositionsSetMutationVariables>;

/**
 * __useSetActiveBudgetovacPositionsSetMutation__
 *
 * To run a mutation, you first call `useSetActiveBudgetovacPositionsSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveBudgetovacPositionsSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveBudgetovacPositionsSetMutation, { data, loading, error }] = useSetActiveBudgetovacPositionsSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetActiveBudgetovacPositionsSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetActiveBudgetovacPositionsSetMutation, SetActiveBudgetovacPositionsSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetActiveBudgetovacPositionsSetMutation, SetActiveBudgetovacPositionsSetMutationVariables>(SetActiveBudgetovacPositionsSetDocument, options);
      }
export type SetActiveBudgetovacPositionsSetMutationHookResult = ReturnType<typeof useSetActiveBudgetovacPositionsSetMutation>;
export type SetActiveBudgetovacPositionsSetMutationResult = ApolloReactCommon.MutationResult<SetActiveBudgetovacPositionsSetMutation>;
export type SetActiveBudgetovacPositionsSetMutationOptions = ApolloReactCommon.BaseMutationOptions<SetActiveBudgetovacPositionsSetMutation, SetActiveBudgetovacPositionsSetMutationVariables>;
export const BudgetovacPositionsSetsDocument = gql`
    query BudgetovacPositionsSets($client_id: ID, $search: String) {
  budgetovacPositionsSets(client_id: $client_id, search: $search) {
    client_id
    brand {
      code
      name
    }
    budgetovacPositionSets {
      ...BudgetovacPositionsSet
    }
  }
}
    ${BudgetovacPositionsSetFragmentDoc}`;

/**
 * __useBudgetovacPositionsSetsQuery__
 *
 * To run a query within a React component, call `useBudgetovacPositionsSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetovacPositionsSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetovacPositionsSetsQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBudgetovacPositionsSetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>(BudgetovacPositionsSetsDocument, options);
      }
export function useBudgetovacPositionsSetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>(BudgetovacPositionsSetsDocument, options);
        }
export function useBudgetovacPositionsSetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>(BudgetovacPositionsSetsDocument, options);
        }
export type BudgetovacPositionsSetsQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetsQuery>;
export type BudgetovacPositionsSetsLazyQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetsLazyQuery>;
export type BudgetovacPositionsSetsSuspenseQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetsSuspenseQuery>;
export type BudgetovacPositionsSetsQueryResult = ApolloReactCommon.QueryResult<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>;
export const BudgetovacPositionsSetDocument = gql`
    query BudgetovacPositionsSet($id: ID!) {
  budgetovacPositionsSet(id: $id) {
    ...BudgetovacPositionsSet
  }
}
    ${BudgetovacPositionsSetFragmentDoc}`;

/**
 * __useBudgetovacPositionsSetQuery__
 *
 * To run a query within a React component, call `useBudgetovacPositionsSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetovacPositionsSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetovacPositionsSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBudgetovacPositionsSetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables> & ({ variables: BudgetovacPositionsSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>(BudgetovacPositionsSetDocument, options);
      }
export function useBudgetovacPositionsSetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>(BudgetovacPositionsSetDocument, options);
        }
export function useBudgetovacPositionsSetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>(BudgetovacPositionsSetDocument, options);
        }
export type BudgetovacPositionsSetQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetQuery>;
export type BudgetovacPositionsSetLazyQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetLazyQuery>;
export type BudgetovacPositionsSetSuspenseQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetSuspenseQuery>;
export type BudgetovacPositionsSetQueryResult = ApolloReactCommon.QueryResult<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>;
export const BudgetovacPositionsSetModalDependenciesDocument = gql`
    query BudgetovacPositionsSetModalDependencies {
  budgetovacPositions {
    ...BudgetovacPosition
    alias
    price
    is_default
  }
  ourWorkBudgetCategories {
    id
    name
  }
  brandsSimpleMap {
    id
    name
  }
}
    ${BudgetovacPositionFragmentDoc}`;

/**
 * __useBudgetovacPositionsSetModalDependenciesQuery__
 *
 * To run a query within a React component, call `useBudgetovacPositionsSetModalDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetovacPositionsSetModalDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetovacPositionsSetModalDependenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetovacPositionsSetModalDependenciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>(BudgetovacPositionsSetModalDependenciesDocument, options);
      }
export function useBudgetovacPositionsSetModalDependenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>(BudgetovacPositionsSetModalDependenciesDocument, options);
        }
export function useBudgetovacPositionsSetModalDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>(BudgetovacPositionsSetModalDependenciesDocument, options);
        }
export type BudgetovacPositionsSetModalDependenciesQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetModalDependenciesQuery>;
export type BudgetovacPositionsSetModalDependenciesLazyQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetModalDependenciesLazyQuery>;
export type BudgetovacPositionsSetModalDependenciesSuspenseQueryHookResult = ReturnType<typeof useBudgetovacPositionsSetModalDependenciesSuspenseQuery>;
export type BudgetovacPositionsSetModalDependenciesQueryResult = ApolloReactCommon.QueryResult<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>;
export const CreateBudgetovacPositionDocument = gql`
    mutation CreateBudgetovacPosition($input: CreateBudgetovacPositionInput!) {
  createBudgetovacPosition(input: $input) {
    ...BudgetovacPosition
    alias
    price
    is_default
  }
}
    ${BudgetovacPositionFragmentDoc}`;
export type CreateBudgetovacPositionMutationFn = ApolloReactCommon.MutationFunction<CreateBudgetovacPositionMutation, CreateBudgetovacPositionMutationVariables>;

/**
 * __useCreateBudgetovacPositionMutation__
 *
 * To run a mutation, you first call `useCreateBudgetovacPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetovacPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetovacPositionMutation, { data, loading, error }] = useCreateBudgetovacPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBudgetovacPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBudgetovacPositionMutation, CreateBudgetovacPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBudgetovacPositionMutation, CreateBudgetovacPositionMutationVariables>(CreateBudgetovacPositionDocument, options);
      }
export type CreateBudgetovacPositionMutationHookResult = ReturnType<typeof useCreateBudgetovacPositionMutation>;
export type CreateBudgetovacPositionMutationResult = ApolloReactCommon.MutationResult<CreateBudgetovacPositionMutation>;
export type CreateBudgetovacPositionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBudgetovacPositionMutation, CreateBudgetovacPositionMutationVariables>;
export const UpdateBudgetovacPositionDocument = gql`
    mutation UpdateBudgetovacPosition($input: UpdateBudgetovacPositionInput!) {
  updateBudgetovacPosition(input: $input) {
    id
  }
}
    `;
export type UpdateBudgetovacPositionMutationFn = ApolloReactCommon.MutationFunction<UpdateBudgetovacPositionMutation, UpdateBudgetovacPositionMutationVariables>;

/**
 * __useUpdateBudgetovacPositionMutation__
 *
 * To run a mutation, you first call `useUpdateBudgetovacPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudgetovacPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudgetovacPositionMutation, { data, loading, error }] = useUpdateBudgetovacPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBudgetovacPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBudgetovacPositionMutation, UpdateBudgetovacPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBudgetovacPositionMutation, UpdateBudgetovacPositionMutationVariables>(UpdateBudgetovacPositionDocument, options);
      }
export type UpdateBudgetovacPositionMutationHookResult = ReturnType<typeof useUpdateBudgetovacPositionMutation>;
export type UpdateBudgetovacPositionMutationResult = ApolloReactCommon.MutationResult<UpdateBudgetovacPositionMutation>;
export type UpdateBudgetovacPositionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBudgetovacPositionMutation, UpdateBudgetovacPositionMutationVariables>;
export const DeleteBudgetovacPositionDocument = gql`
    mutation DeleteBudgetovacPosition($id: ID!) {
  deleteBudgetovacPosition(id: $id) {
    id
  }
}
    `;
export type DeleteBudgetovacPositionMutationFn = ApolloReactCommon.MutationFunction<DeleteBudgetovacPositionMutation, DeleteBudgetovacPositionMutationVariables>;

/**
 * __useDeleteBudgetovacPositionMutation__
 *
 * To run a mutation, you first call `useDeleteBudgetovacPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBudgetovacPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBudgetovacPositionMutation, { data, loading, error }] = useDeleteBudgetovacPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBudgetovacPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBudgetovacPositionMutation, DeleteBudgetovacPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBudgetovacPositionMutation, DeleteBudgetovacPositionMutationVariables>(DeleteBudgetovacPositionDocument, options);
      }
export type DeleteBudgetovacPositionMutationHookResult = ReturnType<typeof useDeleteBudgetovacPositionMutation>;
export type DeleteBudgetovacPositionMutationResult = ApolloReactCommon.MutationResult<DeleteBudgetovacPositionMutation>;
export type DeleteBudgetovacPositionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBudgetovacPositionMutation, DeleteBudgetovacPositionMutationVariables>;
export const BudgetovacPositionsDocument = gql`
    query BudgetovacPositions {
  budgetovacPositions {
    ...BudgetovacPosition
  }
}
    ${BudgetovacPositionFragmentDoc}`;

/**
 * __useBudgetovacPositionsQuery__
 *
 * To run a query within a React component, call `useBudgetovacPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetovacPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetovacPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetovacPositionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>(BudgetovacPositionsDocument, options);
      }
export function useBudgetovacPositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>(BudgetovacPositionsDocument, options);
        }
export function useBudgetovacPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>(BudgetovacPositionsDocument, options);
        }
export type BudgetovacPositionsQueryHookResult = ReturnType<typeof useBudgetovacPositionsQuery>;
export type BudgetovacPositionsLazyQueryHookResult = ReturnType<typeof useBudgetovacPositionsLazyQuery>;
export type BudgetovacPositionsSuspenseQueryHookResult = ReturnType<typeof useBudgetovacPositionsSuspenseQuery>;
export type BudgetovacPositionsQueryResult = ApolloReactCommon.QueryResult<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>;
export const BudgetovacDepartmentsDocument = gql`
    query BudgetovacDepartments {
  ourWorkBudgetCategories {
    id
    name
  }
}
    `;

/**
 * __useBudgetovacDepartmentsQuery__
 *
 * To run a query within a React component, call `useBudgetovacDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetovacDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetovacDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetovacDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>(BudgetovacDepartmentsDocument, options);
      }
export function useBudgetovacDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>(BudgetovacDepartmentsDocument, options);
        }
export function useBudgetovacDepartmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>(BudgetovacDepartmentsDocument, options);
        }
export type BudgetovacDepartmentsQueryHookResult = ReturnType<typeof useBudgetovacDepartmentsQuery>;
export type BudgetovacDepartmentsLazyQueryHookResult = ReturnType<typeof useBudgetovacDepartmentsLazyQuery>;
export type BudgetovacDepartmentsSuspenseQueryHookResult = ReturnType<typeof useBudgetovacDepartmentsSuspenseQuery>;
export type BudgetovacDepartmentsQueryResult = ApolloReactCommon.QueryResult<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>;
export const DeleteQuoteDocument = gql`
    mutation DeleteQuote($id: ID!) {
  deleteQuote(id: $id)
}
    `;
export type DeleteQuoteMutationFn = ApolloReactCommon.MutationFunction<DeleteQuoteMutation, DeleteQuoteMutationVariables>;

/**
 * __useDeleteQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMutation, { data, loading, error }] = useDeleteQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument, options);
      }
export type DeleteQuoteMutationHookResult = ReturnType<typeof useDeleteQuoteMutation>;
export type DeleteQuoteMutationResult = ApolloReactCommon.MutationResult<DeleteQuoteMutation>;
export type DeleteQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export const ManualApproveQuoteDocument = gql`
    mutation ManualApproveQuote($id: ID!) {
  manualApproveQuote(id: $id) {
    id
    status
    client_approval_date
  }
}
    `;
export type ManualApproveQuoteMutationFn = ApolloReactCommon.MutationFunction<ManualApproveQuoteMutation, ManualApproveQuoteMutationVariables>;

/**
 * __useManualApproveQuoteMutation__
 *
 * To run a mutation, you first call `useManualApproveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualApproveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualApproveQuoteMutation, { data, loading, error }] = useManualApproveQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManualApproveQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ManualApproveQuoteMutation, ManualApproveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ManualApproveQuoteMutation, ManualApproveQuoteMutationVariables>(ManualApproveQuoteDocument, options);
      }
export type ManualApproveQuoteMutationHookResult = ReturnType<typeof useManualApproveQuoteMutation>;
export type ManualApproveQuoteMutationResult = ApolloReactCommon.MutationResult<ManualApproveQuoteMutation>;
export type ManualApproveQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<ManualApproveQuoteMutation, ManualApproveQuoteMutationVariables>;
export const GetBudgetQuotesDocument = gql`
    query GetBudgetQuotes($filters: QuotesArgs) {
  getBudgetQuotes(filters: $filters) {
    data {
      id
      settings {
        date
      }
      budgets {
        id
        project_id
        project {
          id
          title
        }
        brand {
          id
          name
        }
        description
        account_manager
        assignment_date
        status
        internally_approved
        client_approved
        is_active
        version
        price
        temporaryBrand {
          name
        }
        temporary_project_id
        temporaryProject {
          name
          is_archived
        }
        currency {
          id
          code
          denomination
        }
        created_at
        updated_at
      }
      url
      number
      status
      client_approval_date
      sent_to_client_date
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useGetBudgetQuotesQuery__
 *
 * To run a query within a React component, call `useGetBudgetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetQuotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBudgetQuotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>(GetBudgetQuotesDocument, options);
      }
export function useGetBudgetQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>(GetBudgetQuotesDocument, options);
        }
export function useGetBudgetQuotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>(GetBudgetQuotesDocument, options);
        }
export type GetBudgetQuotesQueryHookResult = ReturnType<typeof useGetBudgetQuotesQuery>;
export type GetBudgetQuotesLazyQueryHookResult = ReturnType<typeof useGetBudgetQuotesLazyQuery>;
export type GetBudgetQuotesSuspenseQueryHookResult = ReturnType<typeof useGetBudgetQuotesSuspenseQuery>;
export type GetBudgetQuotesQueryResult = ApolloReactCommon.QueryResult<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($id: ID!) {
  client(id: $id) {
    name
    image {
      urls {
        thumbnail
      }
    }
    brands {
      id
    }
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export function useGetClientSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = ApolloReactCommon.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const DeleteBillingEntityDocument = gql`
    mutation DeleteBillingEntity($id: ID!) {
  deleteBillingEntity(id: $id) {
    id
  }
}
    `;
export type DeleteBillingEntityMutationFn = ApolloReactCommon.MutationFunction<DeleteBillingEntityMutation, DeleteBillingEntityMutationVariables>;

/**
 * __useDeleteBillingEntityMutation__
 *
 * To run a mutation, you first call `useDeleteBillingEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillingEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillingEntityMutation, { data, loading, error }] = useDeleteBillingEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillingEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBillingEntityMutation, DeleteBillingEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBillingEntityMutation, DeleteBillingEntityMutationVariables>(DeleteBillingEntityDocument, options);
      }
export type DeleteBillingEntityMutationHookResult = ReturnType<typeof useDeleteBillingEntityMutation>;
export type DeleteBillingEntityMutationResult = ApolloReactCommon.MutationResult<DeleteBillingEntityMutation>;
export type DeleteBillingEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBillingEntityMutation, DeleteBillingEntityMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: ID!) {
  deleteContact(id: $id) {
    id
  }
}
    `;
export type DeleteContactMutationFn = ApolloReactCommon.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = ApolloReactCommon.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($input: UpdateClientInput!) {
  updateClient(input: $input) {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    workspaceCompany {
      ...WorkspaceCompany
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}`;
export type UpdateClientMutationFn = ApolloReactCommon.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = ApolloReactCommon.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($id: ID!) {
  deleteClient(id: $id) {
    id
  }
}
    `;
export type DeleteClientMutationFn = ApolloReactCommon.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = ApolloReactCommon.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    workspaceCompany {
      ...WorkspaceCompany
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}`;
export type CreateClientMutationFn = ApolloReactCommon.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = ApolloReactCommon.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const ClientDetailDocument = gql`
    query ClientDetail($id: ID!) {
  client(id: $id) {
    id
    name
    cloudUrl
    driveCloudUrl
    image {
      urls {
        thumbnail
      }
    }
    workspaceCompany {
      ...WorkspaceCompany
    }
    responsiblePerson {
      id
    }
    otherResponsiblePersons {
      id
    }
    brands {
      id
      name
      archived_at
      image {
        urls {
          thumbnail
        }
      }
      code
      defaultBillingEntity {
        id
      }
      pipedriveCustomFieldValues {
        ...PipedriveCustomField
      }
    }
    billingEntities {
      ...BillingEntityModal
    }
    contacts {
      id
      first_name
      last_name
      email
      phone
    }
    currencyExchangeRates(onlyActive: true) {
      id
      exchange_rate
      currency {
        id
        code
        denomination
      }
    }
    currencyExchangeRatesStructured {
      exchangeRates {
        id
        exchange_rate
        valid_from
        valid_to
      }
      currency {
        id
        code
        denomination
      }
    }
  }
  currencies {
    id
    code
  }
  countrySimpleMap {
    id
    name
  }
}
    ${WorkspaceCompanyFragmentDoc}
${PipedriveCustomFieldFragmentDoc}
${BillingEntityModalFragmentDoc}`;

/**
 * __useClientDetailQuery__
 *
 * To run a query within a React component, call `useClientDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClientDetailQuery, ClientDetailQueryVariables> & ({ variables: ClientDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientDetailQuery, ClientDetailQueryVariables>(ClientDetailDocument, options);
      }
export function useClientDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientDetailQuery, ClientDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientDetailQuery, ClientDetailQueryVariables>(ClientDetailDocument, options);
        }
export function useClientDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientDetailQuery, ClientDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientDetailQuery, ClientDetailQueryVariables>(ClientDetailDocument, options);
        }
export type ClientDetailQueryHookResult = ReturnType<typeof useClientDetailQuery>;
export type ClientDetailLazyQueryHookResult = ReturnType<typeof useClientDetailLazyQuery>;
export type ClientDetailSuspenseQueryHookResult = ReturnType<typeof useClientDetailSuspenseQuery>;
export type ClientDetailQueryResult = ApolloReactCommon.QueryResult<ClientDetailQuery, ClientDetailQueryVariables>;
export const ClientFilterOptionsDocument = gql`
    query ClientFilterOptions($orderBy: [QueryContactsOrderByOrderByClause!]) {
  contacts(orderBy: $orderBy) {
    id
    first_name
    last_name
  }
  responsiblePersonsSimpleMap {
    id
    full_name
  }
  brandsSimpleMap {
    id
    name
  }
}
    `;

/**
 * __useClientFilterOptionsQuery__
 *
 * To run a query within a React component, call `useClientFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFilterOptionsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useClientFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>(ClientFilterOptionsDocument, options);
      }
export function useClientFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>(ClientFilterOptionsDocument, options);
        }
export function useClientFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>(ClientFilterOptionsDocument, options);
        }
export type ClientFilterOptionsQueryHookResult = ReturnType<typeof useClientFilterOptionsQuery>;
export type ClientFilterOptionsLazyQueryHookResult = ReturnType<typeof useClientFilterOptionsLazyQuery>;
export type ClientFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useClientFilterOptionsSuspenseQuery>;
export type ClientFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>;
export const GetClientsDocument = gql`
    query GetClients($page: Int, $first: Int, $onlyActive: Boolean, $filters: ClientQueryArgs) {
  clients(first: $first, page: $page, filters: $filters) {
    data {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
      workspaceCompany {
        ...WorkspaceCompany
      }
      brands {
        id
        name
        projects(onlyActive: $onlyActive) {
          id
        }
      }
      responsiblePerson {
        id
        full_name
        image {
          urls {
            thumbnail
          }
        }
      }
      contacts {
        first_name
        last_name
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      onlyActive: // value for 'onlyActive'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export function useGetClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = ApolloReactCommon.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const AbraFlexiOiExportDocument = gql`
    query AbraFlexiOIExport($from: Date, $to: Date) {
  abraFlexiOIExport(from: $from, to: $to)
}
    `;

/**
 * __useAbraFlexiOiExportQuery__
 *
 * To run a query within a React component, call `useAbraFlexiOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbraFlexiOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbraFlexiOiExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAbraFlexiOiExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>(AbraFlexiOiExportDocument, options);
      }
export function useAbraFlexiOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>(AbraFlexiOiExportDocument, options);
        }
export function useAbraFlexiOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>(AbraFlexiOiExportDocument, options);
        }
export type AbraFlexiOiExportQueryHookResult = ReturnType<typeof useAbraFlexiOiExportQuery>;
export type AbraFlexiOiExportLazyQueryHookResult = ReturnType<typeof useAbraFlexiOiExportLazyQuery>;
export type AbraFlexiOiExportSuspenseQueryHookResult = ReturnType<typeof useAbraFlexiOiExportSuspenseQuery>;
export type AbraFlexiOiExportQueryResult = ApolloReactCommon.QueryResult<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>;
export const AbraFlexiOutgoingProformaInvoicesExportDocument = gql`
    query AbraFlexiOutgoingProformaInvoicesExport($from: Date, $to: Date) {
  abraFlexiOutgoingProformaInvoicesExport(from: $from, to: $to)
}
    `;

/**
 * __useAbraFlexiOutgoingProformaInvoicesExportQuery__
 *
 * To run a query within a React component, call `useAbraFlexiOutgoingProformaInvoicesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbraFlexiOutgoingProformaInvoicesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbraFlexiOutgoingProformaInvoicesExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAbraFlexiOutgoingProformaInvoicesExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>(AbraFlexiOutgoingProformaInvoicesExportDocument, options);
      }
export function useAbraFlexiOutgoingProformaInvoicesExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>(AbraFlexiOutgoingProformaInvoicesExportDocument, options);
        }
export function useAbraFlexiOutgoingProformaInvoicesExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>(AbraFlexiOutgoingProformaInvoicesExportDocument, options);
        }
export type AbraFlexiOutgoingProformaInvoicesExportQueryHookResult = ReturnType<typeof useAbraFlexiOutgoingProformaInvoicesExportQuery>;
export type AbraFlexiOutgoingProformaInvoicesExportLazyQueryHookResult = ReturnType<typeof useAbraFlexiOutgoingProformaInvoicesExportLazyQuery>;
export type AbraFlexiOutgoingProformaInvoicesExportSuspenseQueryHookResult = ReturnType<typeof useAbraFlexiOutgoingProformaInvoicesExportSuspenseQuery>;
export type AbraFlexiOutgoingProformaInvoicesExportQueryResult = ApolloReactCommon.QueryResult<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>;
export const ExpenseAbraFlexiExportDocument = gql`
    query ExpenseAbraFlexiExport($from: Date, $to: Date) {
  expenseAbraFlexiExport(from: $from, to: $to)
}
    `;

/**
 * __useExpenseAbraFlexiExportQuery__
 *
 * To run a query within a React component, call `useExpenseAbraFlexiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseAbraFlexiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseAbraFlexiExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExpenseAbraFlexiExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>(ExpenseAbraFlexiExportDocument, options);
      }
export function useExpenseAbraFlexiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>(ExpenseAbraFlexiExportDocument, options);
        }
export function useExpenseAbraFlexiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>(ExpenseAbraFlexiExportDocument, options);
        }
export type ExpenseAbraFlexiExportQueryHookResult = ReturnType<typeof useExpenseAbraFlexiExportQuery>;
export type ExpenseAbraFlexiExportLazyQueryHookResult = ReturnType<typeof useExpenseAbraFlexiExportLazyQuery>;
export type ExpenseAbraFlexiExportSuspenseQueryHookResult = ReturnType<typeof useExpenseAbraFlexiExportSuspenseQuery>;
export type ExpenseAbraFlexiExportQueryResult = ApolloReactCommon.QueryResult<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>;
export const FinancialOiExportDocument = gql`
    query financialOIExport($from: Date, $to: Date) {
  financialOIExport(from: $from, to: $to)
}
    `;

/**
 * __useFinancialOiExportQuery__
 *
 * To run a query within a React component, call `useFinancialOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialOiExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useFinancialOiExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FinancialOiExportQuery, FinancialOiExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancialOiExportQuery, FinancialOiExportQueryVariables>(FinancialOiExportDocument, options);
      }
export function useFinancialOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancialOiExportQuery, FinancialOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancialOiExportQuery, FinancialOiExportQueryVariables>(FinancialOiExportDocument, options);
        }
export function useFinancialOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancialOiExportQuery, FinancialOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinancialOiExportQuery, FinancialOiExportQueryVariables>(FinancialOiExportDocument, options);
        }
export type FinancialOiExportQueryHookResult = ReturnType<typeof useFinancialOiExportQuery>;
export type FinancialOiExportLazyQueryHookResult = ReturnType<typeof useFinancialOiExportLazyQuery>;
export type FinancialOiExportSuspenseQueryHookResult = ReturnType<typeof useFinancialOiExportSuspenseQuery>;
export type FinancialOiExportQueryResult = ApolloReactCommon.QueryResult<FinancialOiExportQuery, FinancialOiExportQueryVariables>;
export const ExpenseXeroExportDocument = gql`
    query ExpenseXeroExport($from: Date, $to: Date) {
  expenseXeroExport(from: $from, to: $to)
}
    `;

/**
 * __useExpenseXeroExportQuery__
 *
 * To run a query within a React component, call `useExpenseXeroExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseXeroExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseXeroExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExpenseXeroExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>(ExpenseXeroExportDocument, options);
      }
export function useExpenseXeroExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>(ExpenseXeroExportDocument, options);
        }
export function useExpenseXeroExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>(ExpenseXeroExportDocument, options);
        }
export type ExpenseXeroExportQueryHookResult = ReturnType<typeof useExpenseXeroExportQuery>;
export type ExpenseXeroExportLazyQueryHookResult = ReturnType<typeof useExpenseXeroExportLazyQuery>;
export type ExpenseXeroExportSuspenseQueryHookResult = ReturnType<typeof useExpenseXeroExportSuspenseQuery>;
export type ExpenseXeroExportQueryResult = ApolloReactCommon.QueryResult<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>;
export const OutgoingInvoiceXeroExportDocument = gql`
    query OutgoingInvoiceXeroExport($from: Date, $to: Date) {
  xeroOIExport(from: $from, to: $to)
}
    `;

/**
 * __useOutgoingInvoiceXeroExportQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceXeroExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceXeroExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceXeroExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useOutgoingInvoiceXeroExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>(OutgoingInvoiceXeroExportDocument, options);
      }
export function useOutgoingInvoiceXeroExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>(OutgoingInvoiceXeroExportDocument, options);
        }
export function useOutgoingInvoiceXeroExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>(OutgoingInvoiceXeroExportDocument, options);
        }
export type OutgoingInvoiceXeroExportQueryHookResult = ReturnType<typeof useOutgoingInvoiceXeroExportQuery>;
export type OutgoingInvoiceXeroExportLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceXeroExportLazyQuery>;
export type OutgoingInvoiceXeroExportSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceXeroExportSuspenseQuery>;
export type OutgoingInvoiceXeroExportQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>;
export const ContractorDetailDocument = gql`
    query ContractorDetail($id: ID!) {
  contractor(id: $id) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;

/**
 * __useContractorDetailQuery__
 *
 * To run a query within a React component, call `useContractorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractorDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContractorDetailQuery, ContractorDetailQueryVariables> & ({ variables: ContractorDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractorDetailQuery, ContractorDetailQueryVariables>(ContractorDetailDocument, options);
      }
export function useContractorDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractorDetailQuery, ContractorDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractorDetailQuery, ContractorDetailQueryVariables>(ContractorDetailDocument, options);
        }
export function useContractorDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractorDetailQuery, ContractorDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractorDetailQuery, ContractorDetailQueryVariables>(ContractorDetailDocument, options);
        }
export type ContractorDetailQueryHookResult = ReturnType<typeof useContractorDetailQuery>;
export type ContractorDetailLazyQueryHookResult = ReturnType<typeof useContractorDetailLazyQuery>;
export type ContractorDetailSuspenseQueryHookResult = ReturnType<typeof useContractorDetailSuspenseQuery>;
export type ContractorDetailQueryResult = ApolloReactCommon.QueryResult<ContractorDetailQuery, ContractorDetailQueryVariables>;
export const CreateContractorDocument = gql`
    mutation CreateContractor($input: CreateContractorInput!) {
  createContractor(input: $input) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;
export type CreateContractorMutationFn = ApolloReactCommon.MutationFunction<CreateContractorMutation, CreateContractorMutationVariables>;

/**
 * __useCreateContractorMutation__
 *
 * To run a mutation, you first call `useCreateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractorMutation, { data, loading, error }] = useCreateContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContractorMutation, CreateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContractorMutation, CreateContractorMutationVariables>(CreateContractorDocument, options);
      }
export type CreateContractorMutationHookResult = ReturnType<typeof useCreateContractorMutation>;
export type CreateContractorMutationResult = ApolloReactCommon.MutationResult<CreateContractorMutation>;
export type CreateContractorMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContractorMutation, CreateContractorMutationVariables>;
export const UpdateContractorDocument = gql`
    mutation UpdateContractor($input: UpdateContractorInput!) {
  updateContractor(input: $input) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;
export type UpdateContractorMutationFn = ApolloReactCommon.MutationFunction<UpdateContractorMutation, UpdateContractorMutationVariables>;

/**
 * __useUpdateContractorMutation__
 *
 * To run a mutation, you first call `useUpdateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorMutation, { data, loading, error }] = useUpdateContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractorMutation, UpdateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractorMutation, UpdateContractorMutationVariables>(UpdateContractorDocument, options);
      }
export type UpdateContractorMutationHookResult = ReturnType<typeof useUpdateContractorMutation>;
export type UpdateContractorMutationResult = ApolloReactCommon.MutationResult<UpdateContractorMutation>;
export type UpdateContractorMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractorMutation, UpdateContractorMutationVariables>;
export const ModalContractorDependenciesDocument = gql`
    query ModalContractorDependencies {
  countrySimpleMap {
    ...CountrySimpleOptionParts
  }
  accountingAccountsSimpleMap {
    ...AccountingAccountOptionParts
  }
}
    ${CountrySimpleOptionPartsFragmentDoc}
${AccountingAccountOptionPartsFragmentDoc}`;

/**
 * __useModalContractorDependenciesQuery__
 *
 * To run a query within a React component, call `useModalContractorDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalContractorDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalContractorDependenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useModalContractorDependenciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>(ModalContractorDependenciesDocument, options);
      }
export function useModalContractorDependenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>(ModalContractorDependenciesDocument, options);
        }
export function useModalContractorDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>(ModalContractorDependenciesDocument, options);
        }
export type ModalContractorDependenciesQueryHookResult = ReturnType<typeof useModalContractorDependenciesQuery>;
export type ModalContractorDependenciesLazyQueryHookResult = ReturnType<typeof useModalContractorDependenciesLazyQuery>;
export type ModalContractorDependenciesSuspenseQueryHookResult = ReturnType<typeof useModalContractorDependenciesSuspenseQuery>;
export type ModalContractorDependenciesQueryResult = ApolloReactCommon.QueryResult<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>;
export const CompanyDataAutocompleteDocument = gql`
    query CompanyDataAutocomplete($input: String!, $country_id: ID!) {
  getAutocompleteForCompanyData(input: $input, country_id: $country_id) {
    results {
      legal_name
      city
      national_id
      cancelled
    }
    suggestions
  }
}
    `;

/**
 * __useCompanyDataAutocompleteQuery__
 *
 * To run a query within a React component, call `useCompanyDataAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDataAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDataAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *      country_id: // value for 'country_id'
 *   },
 * });
 */
export function useCompanyDataAutocompleteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables> & ({ variables: CompanyDataAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>(CompanyDataAutocompleteDocument, options);
      }
export function useCompanyDataAutocompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>(CompanyDataAutocompleteDocument, options);
        }
export function useCompanyDataAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>(CompanyDataAutocompleteDocument, options);
        }
export type CompanyDataAutocompleteQueryHookResult = ReturnType<typeof useCompanyDataAutocompleteQuery>;
export type CompanyDataAutocompleteLazyQueryHookResult = ReturnType<typeof useCompanyDataAutocompleteLazyQuery>;
export type CompanyDataAutocompleteSuspenseQueryHookResult = ReturnType<typeof useCompanyDataAutocompleteSuspenseQuery>;
export type CompanyDataAutocompleteQueryResult = ApolloReactCommon.QueryResult<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>;
export const CompanyDataByRegistrationNoDocument = gql`
    query CompanyDataByRegistrationNo($registration_no: String!, $country_id: ID!) {
  getCompanyDataByRegistrationNo(
    registration_no: $registration_no
    country_id: $country_id
  ) {
    legal_name
    street
    city
    zip
    registration_no
    tax_no
    vat_no
    applies_vat
    bankAccounts {
      iban
      swift
    }
    country {
      id
      name
      code
      created_at
      updated_at
    }
    cancelled
  }
}
    `;

/**
 * __useCompanyDataByRegistrationNoQuery__
 *
 * To run a query within a React component, call `useCompanyDataByRegistrationNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDataByRegistrationNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDataByRegistrationNoQuery({
 *   variables: {
 *      registration_no: // value for 'registration_no'
 *      country_id: // value for 'country_id'
 *   },
 * });
 */
export function useCompanyDataByRegistrationNoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables> & ({ variables: CompanyDataByRegistrationNoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>(CompanyDataByRegistrationNoDocument, options);
      }
export function useCompanyDataByRegistrationNoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>(CompanyDataByRegistrationNoDocument, options);
        }
export function useCompanyDataByRegistrationNoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>(CompanyDataByRegistrationNoDocument, options);
        }
export type CompanyDataByRegistrationNoQueryHookResult = ReturnType<typeof useCompanyDataByRegistrationNoQuery>;
export type CompanyDataByRegistrationNoLazyQueryHookResult = ReturnType<typeof useCompanyDataByRegistrationNoLazyQuery>;
export type CompanyDataByRegistrationNoSuspenseQueryHookResult = ReturnType<typeof useCompanyDataByRegistrationNoSuspenseQuery>;
export type CompanyDataByRegistrationNoQueryResult = ApolloReactCommon.QueryResult<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>;
export const BankAccountConverterDocument = gql`
    query BankAccountConverter($country_id: ID!, $account_number: String!, $account_code: String) {
  bankAccountConverter(
    country_id: $country_id
    account_number: $account_number
    account_code: $account_code
  ) {
    iban
  }
}
    `;

/**
 * __useBankAccountConverterQuery__
 *
 * To run a query within a React component, call `useBankAccountConverterQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountConverterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountConverterQuery({
 *   variables: {
 *      country_id: // value for 'country_id'
 *      account_number: // value for 'account_number'
 *      account_code: // value for 'account_code'
 *   },
 * });
 */
export function useBankAccountConverterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BankAccountConverterQuery, BankAccountConverterQueryVariables> & ({ variables: BankAccountConverterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BankAccountConverterQuery, BankAccountConverterQueryVariables>(BankAccountConverterDocument, options);
      }
export function useBankAccountConverterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BankAccountConverterQuery, BankAccountConverterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BankAccountConverterQuery, BankAccountConverterQueryVariables>(BankAccountConverterDocument, options);
        }
export function useBankAccountConverterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BankAccountConverterQuery, BankAccountConverterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BankAccountConverterQuery, BankAccountConverterQueryVariables>(BankAccountConverterDocument, options);
        }
export type BankAccountConverterQueryHookResult = ReturnType<typeof useBankAccountConverterQuery>;
export type BankAccountConverterLazyQueryHookResult = ReturnType<typeof useBankAccountConverterLazyQuery>;
export type BankAccountConverterSuspenseQueryHookResult = ReturnType<typeof useBankAccountConverterSuspenseQuery>;
export type BankAccountConverterQueryResult = ApolloReactCommon.QueryResult<BankAccountConverterQuery, BankAccountConverterQueryVariables>;
export const GetContractorsDocument = gql`
    query GetContractors($page: Int, $first: Int, $filters: ContractorQueryArgs) {
  contractorsSummary(filters: $filters) {
    contractorIds
  }
  contractors(page: $page, first: $first, filters: $filters) {
    data {
      id
      iban
      registration_no
      legal_name
      is_vat_payer
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useGetContractorsQuery__
 *
 * To run a query within a React component, call `useGetContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetContractorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractorsQuery, GetContractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractorsQuery, GetContractorsQueryVariables>(GetContractorsDocument, options);
      }
export function useGetContractorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractorsQuery, GetContractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractorsQuery, GetContractorsQueryVariables>(GetContractorsDocument, options);
        }
export function useGetContractorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContractorsQuery, GetContractorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContractorsQuery, GetContractorsQueryVariables>(GetContractorsDocument, options);
        }
export type GetContractorsQueryHookResult = ReturnType<typeof useGetContractorsQuery>;
export type GetContractorsLazyQueryHookResult = ReturnType<typeof useGetContractorsLazyQuery>;
export type GetContractorsSuspenseQueryHookResult = ReturnType<typeof useGetContractorsSuspenseQuery>;
export type GetContractorsQueryResult = ApolloReactCommon.QueryResult<GetContractorsQuery, GetContractorsQueryVariables>;
export const DeleteContractorDocument = gql`
    mutation DeleteContractor($id: ID!) {
  deleteContractor(id: $id) {
    id
  }
}
    `;
export type DeleteContractorMutationFn = ApolloReactCommon.MutationFunction<DeleteContractorMutation, DeleteContractorMutationVariables>;

/**
 * __useDeleteContractorMutation__
 *
 * To run a mutation, you first call `useDeleteContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractorMutation, { data, loading, error }] = useDeleteContractorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContractorMutation, DeleteContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContractorMutation, DeleteContractorMutationVariables>(DeleteContractorDocument, options);
      }
export type DeleteContractorMutationHookResult = ReturnType<typeof useDeleteContractorMutation>;
export type DeleteContractorMutationResult = ApolloReactCommon.MutationResult<DeleteContractorMutation>;
export type DeleteContractorMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContractorMutation, DeleteContractorMutationVariables>;
export const DeleteContractorsBulkDocument = gql`
    mutation DeleteContractorsBulk($id: [ID!]!) {
  deleteContractorsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type DeleteContractorsBulkMutationFn = ApolloReactCommon.MutationFunction<DeleteContractorsBulkMutation, DeleteContractorsBulkMutationVariables>;

/**
 * __useDeleteContractorsBulkMutation__
 *
 * To run a mutation, you first call `useDeleteContractorsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractorsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractorsBulkMutation, { data, loading, error }] = useDeleteContractorsBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractorsBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContractorsBulkMutation, DeleteContractorsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContractorsBulkMutation, DeleteContractorsBulkMutationVariables>(DeleteContractorsBulkDocument, options);
      }
export type DeleteContractorsBulkMutationHookResult = ReturnType<typeof useDeleteContractorsBulkMutation>;
export type DeleteContractorsBulkMutationResult = ApolloReactCommon.MutationResult<DeleteContractorsBulkMutation>;
export type DeleteContractorsBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContractorsBulkMutation, DeleteContractorsBulkMutationVariables>;
export const GetCreditAccountDocument = gql`
    query GetCreditAccount($id: ID!) {
  brandCreditAccount(id: $id) {
    id
    title
    creditAccount {
      id
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    team {
      id
      name
    }
    ourWorkBudgetCategories {
      id
      name
    }
    expenseBudgetCategories {
      id
      name
    }
    credits {
      id
      credit
      date
      outgoingInvoice {
        id
        invoice_no
      }
      originatesBrandCreditAccount {
        id
        title
      }
    }
    debits {
      id
      credit
      performed_at
      expenseBudgetItem {
        id
        title
        project {
          id
          title
          code
        }
      }
      ourWorkBudgetItem {
        id
        title
        project {
          id
          title
          code
        }
      }
      brandCreditAccount {
        id
        title
      }
    }
    stats {
      id
      remaining_credit
      total_credit
      total_debit
    }
  }
}
    `;

/**
 * __useGetCreditAccountQuery__
 *
 * To run a query within a React component, call `useGetCreditAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreditAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCreditAccountQuery, GetCreditAccountQueryVariables> & ({ variables: GetCreditAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditAccountQuery, GetCreditAccountQueryVariables>(GetCreditAccountDocument, options);
      }
export function useGetCreditAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditAccountQuery, GetCreditAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditAccountQuery, GetCreditAccountQueryVariables>(GetCreditAccountDocument, options);
        }
export function useGetCreditAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditAccountQuery, GetCreditAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditAccountQuery, GetCreditAccountQueryVariables>(GetCreditAccountDocument, options);
        }
export type GetCreditAccountQueryHookResult = ReturnType<typeof useGetCreditAccountQuery>;
export type GetCreditAccountLazyQueryHookResult = ReturnType<typeof useGetCreditAccountLazyQuery>;
export type GetCreditAccountSuspenseQueryHookResult = ReturnType<typeof useGetCreditAccountSuspenseQuery>;
export type GetCreditAccountQueryResult = ApolloReactCommon.QueryResult<GetCreditAccountQuery, GetCreditAccountQueryVariables>;
export const GetCreditAccountOptionsDocument = gql`
    query GetCreditAccountOptions {
  clientsSimpleMap {
    id
    brands {
      id
      name
    }
  }
  ourWorkBudgetCategories {
    id
    name
  }
  expenseBudgetCategories {
    id
    name
  }
  teamSimpleMap {
    id
    name
  }
}
    `;

/**
 * __useGetCreditAccountOptionsQuery__
 *
 * To run a query within a React component, call `useGetCreditAccountOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAccountOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAccountOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditAccountOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>(GetCreditAccountOptionsDocument, options);
      }
export function useGetCreditAccountOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>(GetCreditAccountOptionsDocument, options);
        }
export function useGetCreditAccountOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>(GetCreditAccountOptionsDocument, options);
        }
export type GetCreditAccountOptionsQueryHookResult = ReturnType<typeof useGetCreditAccountOptionsQuery>;
export type GetCreditAccountOptionsLazyQueryHookResult = ReturnType<typeof useGetCreditAccountOptionsLazyQuery>;
export type GetCreditAccountOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCreditAccountOptionsSuspenseQuery>;
export type GetCreditAccountOptionsQueryResult = ApolloReactCommon.QueryResult<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>;
export const UpdateCreditAccountDocument = gql`
    mutation UpdateCreditAccount($input: UpdateBrandCreditAccountInput!) {
  updateBrandCreditAccount(input: $input) {
    id
  }
}
    `;
export type UpdateCreditAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateCreditAccountMutation, UpdateCreditAccountMutationVariables>;

/**
 * __useUpdateCreditAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditAccountMutation, { data, loading, error }] = useUpdateCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreditAccountMutation, UpdateCreditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreditAccountMutation, UpdateCreditAccountMutationVariables>(UpdateCreditAccountDocument, options);
      }
export type UpdateCreditAccountMutationHookResult = ReturnType<typeof useUpdateCreditAccountMutation>;
export type UpdateCreditAccountMutationResult = ApolloReactCommon.MutationResult<UpdateCreditAccountMutation>;
export type UpdateCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCreditAccountMutation, UpdateCreditAccountMutationVariables>;
export const CreateCreditAccountDocument = gql`
    mutation CreateCreditAccount($input: CreateBrandCreditAccountInput!) {
  createBrandCreditAccount(input: $input) {
    id
  }
}
    `;
export type CreateCreditAccountMutationFn = ApolloReactCommon.MutationFunction<CreateCreditAccountMutation, CreateCreditAccountMutationVariables>;

/**
 * __useCreateCreditAccountMutation__
 *
 * To run a mutation, you first call `useCreateCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditAccountMutation, { data, loading, error }] = useCreateCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCreditAccountMutation, CreateCreditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCreditAccountMutation, CreateCreditAccountMutationVariables>(CreateCreditAccountDocument, options);
      }
export type CreateCreditAccountMutationHookResult = ReturnType<typeof useCreateCreditAccountMutation>;
export type CreateCreditAccountMutationResult = ApolloReactCommon.MutationResult<CreateCreditAccountMutation>;
export type CreateCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCreditAccountMutation, CreateCreditAccountMutationVariables>;
export const GlobalCreditAccountDetailDocument = gql`
    query GlobalCreditAccountDetail($id: ID!) {
  globalCreditAccount(id: $id) {
    ...GlobalCreditAccount
    credits {
      expense {
        id
        expense_no
      }
      originatesGlobalCreditAccount {
        id
        title
      }
    }
    debits {
      expenseBudgetItem {
        id
        project {
          id
          code
          title
        }
      }
    }
  }
}
    ${GlobalCreditAccountFragmentDoc}`;

/**
 * __useGlobalCreditAccountDetailQuery__
 *
 * To run a query within a React component, call `useGlobalCreditAccountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalCreditAccountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalCreditAccountDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGlobalCreditAccountDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables> & ({ variables: GlobalCreditAccountDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>(GlobalCreditAccountDetailDocument, options);
      }
export function useGlobalCreditAccountDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>(GlobalCreditAccountDetailDocument, options);
        }
export function useGlobalCreditAccountDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>(GlobalCreditAccountDetailDocument, options);
        }
export type GlobalCreditAccountDetailQueryHookResult = ReturnType<typeof useGlobalCreditAccountDetailQuery>;
export type GlobalCreditAccountDetailLazyQueryHookResult = ReturnType<typeof useGlobalCreditAccountDetailLazyQuery>;
export type GlobalCreditAccountDetailSuspenseQueryHookResult = ReturnType<typeof useGlobalCreditAccountDetailSuspenseQuery>;
export type GlobalCreditAccountDetailQueryResult = ApolloReactCommon.QueryResult<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>;
export const CreateGlobalCreditAccountDocument = gql`
    mutation CreateGlobalCreditAccount($input: CreateGlobalCreditAccountInput!) {
  createGlobalCreditAccount(input: $input) {
    id
  }
}
    `;
export type CreateGlobalCreditAccountMutationFn = ApolloReactCommon.MutationFunction<CreateGlobalCreditAccountMutation, CreateGlobalCreditAccountMutationVariables>;

/**
 * __useCreateGlobalCreditAccountMutation__
 *
 * To run a mutation, you first call `useCreateGlobalCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalCreditAccountMutation, { data, loading, error }] = useCreateGlobalCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGlobalCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGlobalCreditAccountMutation, CreateGlobalCreditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGlobalCreditAccountMutation, CreateGlobalCreditAccountMutationVariables>(CreateGlobalCreditAccountDocument, options);
      }
export type CreateGlobalCreditAccountMutationHookResult = ReturnType<typeof useCreateGlobalCreditAccountMutation>;
export type CreateGlobalCreditAccountMutationResult = ApolloReactCommon.MutationResult<CreateGlobalCreditAccountMutation>;
export type CreateGlobalCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGlobalCreditAccountMutation, CreateGlobalCreditAccountMutationVariables>;
export const UpdateGlobalCreditAccountDocument = gql`
    mutation UpdateGlobalCreditAccount($input: UpdateGlobalCreditAccountInput!) {
  updateGlobalCreditAccount(input: $input) {
    id
  }
}
    `;
export type UpdateGlobalCreditAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateGlobalCreditAccountMutation, UpdateGlobalCreditAccountMutationVariables>;

/**
 * __useUpdateGlobalCreditAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalCreditAccountMutation, { data, loading, error }] = useUpdateGlobalCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGlobalCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGlobalCreditAccountMutation, UpdateGlobalCreditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGlobalCreditAccountMutation, UpdateGlobalCreditAccountMutationVariables>(UpdateGlobalCreditAccountDocument, options);
      }
export type UpdateGlobalCreditAccountMutationHookResult = ReturnType<typeof useUpdateGlobalCreditAccountMutation>;
export type UpdateGlobalCreditAccountMutationResult = ApolloReactCommon.MutationResult<UpdateGlobalCreditAccountMutation>;
export type UpdateGlobalCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGlobalCreditAccountMutation, UpdateGlobalCreditAccountMutationVariables>;
export const DeleteGlobalCreditAccountDocument = gql`
    mutation DeleteGlobalCreditAccount($id: ID!) {
  deleteGlobalCreditAccount(id: $id)
}
    `;
export type DeleteGlobalCreditAccountMutationFn = ApolloReactCommon.MutationFunction<DeleteGlobalCreditAccountMutation, DeleteGlobalCreditAccountMutationVariables>;

/**
 * __useDeleteGlobalCreditAccountMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalCreditAccountMutation, { data, loading, error }] = useDeleteGlobalCreditAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGlobalCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGlobalCreditAccountMutation, DeleteGlobalCreditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGlobalCreditAccountMutation, DeleteGlobalCreditAccountMutationVariables>(DeleteGlobalCreditAccountDocument, options);
      }
export type DeleteGlobalCreditAccountMutationHookResult = ReturnType<typeof useDeleteGlobalCreditAccountMutation>;
export type DeleteGlobalCreditAccountMutationResult = ApolloReactCommon.MutationResult<DeleteGlobalCreditAccountMutation>;
export type DeleteGlobalCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGlobalCreditAccountMutation, DeleteGlobalCreditAccountMutationVariables>;
export const GlobalCreditAccountsDocument = gql`
    query GlobalCreditAccounts($filters: GlobalCreditAccountQueryArgs, $first: Int, $page: Int) {
  globalCreditAccounts(filters: $filters, first: $first, page: $page) {
    data {
      ...GlobalCreditAccount
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${GlobalCreditAccountFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGlobalCreditAccountsQuery__
 *
 * To run a query within a React component, call `useGlobalCreditAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalCreditAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalCreditAccountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGlobalCreditAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>(GlobalCreditAccountsDocument, options);
      }
export function useGlobalCreditAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>(GlobalCreditAccountsDocument, options);
        }
export function useGlobalCreditAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>(GlobalCreditAccountsDocument, options);
        }
export type GlobalCreditAccountsQueryHookResult = ReturnType<typeof useGlobalCreditAccountsQuery>;
export type GlobalCreditAccountsLazyQueryHookResult = ReturnType<typeof useGlobalCreditAccountsLazyQuery>;
export type GlobalCreditAccountsSuspenseQueryHookResult = ReturnType<typeof useGlobalCreditAccountsSuspenseQuery>;
export type GlobalCreditAccountsQueryResult = ApolloReactCommon.QueryResult<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>;
export const CreditAccountsTableSummaryDocument = gql`
    query CreditAccountsTableSummary($filters: CreditAccountQueryArgs) {
  brandCreditAccountsSummary(filters: $filters) {
    brand_credit_accounts
    total_credit
    total_debit
    remaining_credit
  }
}
    `;

/**
 * __useCreditAccountsTableSummaryQuery__
 *
 * To run a query within a React component, call `useCreditAccountsTableSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditAccountsTableSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditAccountsTableSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreditAccountsTableSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>(CreditAccountsTableSummaryDocument, options);
      }
export function useCreditAccountsTableSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>(CreditAccountsTableSummaryDocument, options);
        }
export function useCreditAccountsTableSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>(CreditAccountsTableSummaryDocument, options);
        }
export type CreditAccountsTableSummaryQueryHookResult = ReturnType<typeof useCreditAccountsTableSummaryQuery>;
export type CreditAccountsTableSummaryLazyQueryHookResult = ReturnType<typeof useCreditAccountsTableSummaryLazyQuery>;
export type CreditAccountsTableSummarySuspenseQueryHookResult = ReturnType<typeof useCreditAccountsTableSummarySuspenseQuery>;
export type CreditAccountsTableSummaryQueryResult = ApolloReactCommon.QueryResult<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>;
export const GetCreditAccountsDocument = gql`
    query GetCreditAccounts($page: Int, $first: Int, $filters: CreditAccountQueryArgs) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  teamSimpleMap {
    id
    name
  }
  ourWorkBudgetCategories {
    id
    name
  }
  expenseBudgetCategories {
    id
    name
  }
  brandCreditAccounts(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      brand {
        name
        id
      }
      team {
        id
        name
      }
      ourWorkBudgetCategories {
        id
        name
      }
      expenseBudgetCategories {
        id
        name
      }
      stats {
        id
        total_credit
        remaining_credit
        total_debit
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useGetCreditAccountsQuery__
 *
 * To run a query within a React component, call `useGetCreditAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAccountsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCreditAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>(GetCreditAccountsDocument, options);
      }
export function useGetCreditAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>(GetCreditAccountsDocument, options);
        }
export function useGetCreditAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>(GetCreditAccountsDocument, options);
        }
export type GetCreditAccountsQueryHookResult = ReturnType<typeof useGetCreditAccountsQuery>;
export type GetCreditAccountsLazyQueryHookResult = ReturnType<typeof useGetCreditAccountsLazyQuery>;
export type GetCreditAccountsSuspenseQueryHookResult = ReturnType<typeof useGetCreditAccountsSuspenseQuery>;
export type GetCreditAccountsQueryResult = ApolloReactCommon.QueryResult<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>;
export const GetContractsDocument = gql`
    query GetContracts($page: Int, $first: Int, $filters: ContractQueryArgs) {
  contractsSummary(filters: $filters) {
    contractIds
  }
  contracts(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      valid_from
      valid_to
      type
      cloudUrl
      driveCloudUrl
      projects {
        id
        title
        code
      }
      brands {
        id
        name
      }
      contractors {
        id
        legal_name
      }
      clients {
        id
        name
      }
      urls {
        preview
        download
      }
      files {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
    }
    paginatorInfo {
      hasMorePages
      currentPage
      perPage
      total
      count
      firstItem
      lastItem
      lastPage
    }
  }
}
    `;

/**
 * __useGetContractsQuery__
 *
 * To run a query within a React component, call `useGetContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetContractsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
      }
export function useGetContractsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
        }
export function useGetContractsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
        }
export type GetContractsQueryHookResult = ReturnType<typeof useGetContractsQuery>;
export type GetContractsLazyQueryHookResult = ReturnType<typeof useGetContractsLazyQuery>;
export type GetContractsSuspenseQueryHookResult = ReturnType<typeof useGetContractsSuspenseQuery>;
export type GetContractsQueryResult = ApolloReactCommon.QueryResult<GetContractsQuery, GetContractsQueryVariables>;
export const ContractsExportDocument = gql`
    query contractsExport($filters: ContractQueryArgs) {
  contractsExport(filters: $filters)
}
    `;

/**
 * __useContractsExportQuery__
 *
 * To run a query within a React component, call `useContractsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useContractsExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContractsExportQuery, ContractsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractsExportQuery, ContractsExportQueryVariables>(ContractsExportDocument, options);
      }
export function useContractsExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractsExportQuery, ContractsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractsExportQuery, ContractsExportQueryVariables>(ContractsExportDocument, options);
        }
export function useContractsExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractsExportQuery, ContractsExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractsExportQuery, ContractsExportQueryVariables>(ContractsExportDocument, options);
        }
export type ContractsExportQueryHookResult = ReturnType<typeof useContractsExportQuery>;
export type ContractsExportLazyQueryHookResult = ReturnType<typeof useContractsExportLazyQuery>;
export type ContractsExportSuspenseQueryHookResult = ReturnType<typeof useContractsExportSuspenseQuery>;
export type ContractsExportQueryResult = ApolloReactCommon.QueryResult<ContractsExportQuery, ContractsExportQueryVariables>;
export const GetDocumentDependenciesDocument = gql`
    query GetDocumentDependencies($brandId: ID, $orIdIn: [ID!]) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap(brand_id: $brandId, orIdIn: $orIdIn) {
    id
    title
    code
    brand {
      id
    }
  }
}
    `;

/**
 * __useGetDocumentDependenciesQuery__
 *
 * To run a query within a React component, call `useGetDocumentDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDependenciesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      orIdIn: // value for 'orIdIn'
 *   },
 * });
 */
export function useGetDocumentDependenciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>(GetDocumentDependenciesDocument, options);
      }
export function useGetDocumentDependenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>(GetDocumentDependenciesDocument, options);
        }
export function useGetDocumentDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>(GetDocumentDependenciesDocument, options);
        }
export type GetDocumentDependenciesQueryHookResult = ReturnType<typeof useGetDocumentDependenciesQuery>;
export type GetDocumentDependenciesLazyQueryHookResult = ReturnType<typeof useGetDocumentDependenciesLazyQuery>;
export type GetDocumentDependenciesSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDependenciesSuspenseQuery>;
export type GetDocumentDependenciesQueryResult = ApolloReactCommon.QueryResult<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>;
export const GetDocumentDependenciesForClientDocument = gql`
    query GetDocumentDependenciesForClient($clientId: ID!) {
  client(id: $clientId) {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap(client_id: $clientId) {
    id
    title
    code
    brand {
      id
    }
  }
  contractorsSimpleMap {
    id
    legal_name
  }
}
    `;

/**
 * __useGetDocumentDependenciesForClientQuery__
 *
 * To run a query within a React component, call `useGetDocumentDependenciesForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDependenciesForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDependenciesForClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetDocumentDependenciesForClientQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables> & ({ variables: GetDocumentDependenciesForClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>(GetDocumentDependenciesForClientDocument, options);
      }
export function useGetDocumentDependenciesForClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>(GetDocumentDependenciesForClientDocument, options);
        }
export function useGetDocumentDependenciesForClientSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>(GetDocumentDependenciesForClientDocument, options);
        }
export type GetDocumentDependenciesForClientQueryHookResult = ReturnType<typeof useGetDocumentDependenciesForClientQuery>;
export type GetDocumentDependenciesForClientLazyQueryHookResult = ReturnType<typeof useGetDocumentDependenciesForClientLazyQuery>;
export type GetDocumentDependenciesForClientSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDependenciesForClientSuspenseQuery>;
export type GetDocumentDependenciesForClientQueryResult = ApolloReactCommon.QueryResult<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($page: Int, $first: Int, $filters: OrderQueryArgs) {
  ordersSummary(filters: $filters) {
    orderIds
  }
  orders(page: $page, first: $first, filters: $filters) {
    data {
      id
      purchase_order_no
      date_of_order
      cloudUrl
      driveCloudUrl
      outgoingInvoices {
        id
        invoice_no
      }
      projects {
        id
        title
        code
      }
      brand {
        id
        name
      }
      urls {
        preview
        download
      }
      files {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
    }
    paginatorInfo {
      hasMorePages
      currentPage
      perPage
      total
      count
      firstItem
      lastItem
      lastPage
    }
  }
}
    `;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export function useGetOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSuspenseQuery>;
export type GetOrdersQueryResult = ApolloReactCommon.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetOtherDocumentsDocument = gql`
    query GetOtherDocuments($page: Int, $first: Int, $filters: OtherDocumentQueryArgs) {
  otherDocumentsSummary(filters: $filters) {
    otherDocumentIds
  }
  otherDocuments(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      cloudUrl
      driveCloudUrl
      projects {
        id
        title
        code
      }
      brands {
        id
        name
      }
      contractors {
        id
        legal_name
      }
      clients {
        id
        name
      }
      urls {
        preview
        download
      }
      files {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useGetOtherDocumentsQuery__
 *
 * To run a query within a React component, call `useGetOtherDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherDocumentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOtherDocumentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>(GetOtherDocumentsDocument, options);
      }
export function useGetOtherDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>(GetOtherDocumentsDocument, options);
        }
export function useGetOtherDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>(GetOtherDocumentsDocument, options);
        }
export type GetOtherDocumentsQueryHookResult = ReturnType<typeof useGetOtherDocumentsQuery>;
export type GetOtherDocumentsLazyQueryHookResult = ReturnType<typeof useGetOtherDocumentsLazyQuery>;
export type GetOtherDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetOtherDocumentsSuspenseQuery>;
export type GetOtherDocumentsQueryResult = ApolloReactCommon.QueryResult<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>;
export const UpdateOtherDocumentDocument = gql`
    mutation UpdateOtherDocument($input: UpdateOtherDocumentInput!) {
  updateOtherDocument(input: $input) {
    id
  }
}
    `;
export type UpdateOtherDocumentMutationFn = ApolloReactCommon.MutationFunction<UpdateOtherDocumentMutation, UpdateOtherDocumentMutationVariables>;

/**
 * __useUpdateOtherDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateOtherDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOtherDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOtherDocumentMutation, { data, loading, error }] = useUpdateOtherDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOtherDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOtherDocumentMutation, UpdateOtherDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOtherDocumentMutation, UpdateOtherDocumentMutationVariables>(UpdateOtherDocumentDocument, options);
      }
export type UpdateOtherDocumentMutationHookResult = ReturnType<typeof useUpdateOtherDocumentMutation>;
export type UpdateOtherDocumentMutationResult = ApolloReactCommon.MutationResult<UpdateOtherDocumentMutation>;
export type UpdateOtherDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOtherDocumentMutation, UpdateOtherDocumentMutationVariables>;
export const CreateOtherDocumentDocument = gql`
    mutation CreateOtherDocument($input: CreateOtherDocumentInput!) {
  createOtherDocument(input: $input) {
    id
  }
}
    `;
export type CreateOtherDocumentMutationFn = ApolloReactCommon.MutationFunction<CreateOtherDocumentMutation, CreateOtherDocumentMutationVariables>;

/**
 * __useCreateOtherDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOtherDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtherDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtherDocumentMutation, { data, loading, error }] = useCreateOtherDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOtherDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOtherDocumentMutation, CreateOtherDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOtherDocumentMutation, CreateOtherDocumentMutationVariables>(CreateOtherDocumentDocument, options);
      }
export type CreateOtherDocumentMutationHookResult = ReturnType<typeof useCreateOtherDocumentMutation>;
export type CreateOtherDocumentMutationResult = ApolloReactCommon.MutationResult<CreateOtherDocumentMutation>;
export type CreateOtherDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOtherDocumentMutation, CreateOtherDocumentMutationVariables>;
export const DeleteOtherDocumentDocument = gql`
    mutation DeleteOtherDocument($id: ID!) {
  deleteOtherDocument(id: $id) {
    id
  }
}
    `;
export type DeleteOtherDocumentMutationFn = ApolloReactCommon.MutationFunction<DeleteOtherDocumentMutation, DeleteOtherDocumentMutationVariables>;

/**
 * __useDeleteOtherDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteOtherDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOtherDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOtherDocumentMutation, { data, loading, error }] = useDeleteOtherDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOtherDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOtherDocumentMutation, DeleteOtherDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOtherDocumentMutation, DeleteOtherDocumentMutationVariables>(DeleteOtherDocumentDocument, options);
      }
export type DeleteOtherDocumentMutationHookResult = ReturnType<typeof useDeleteOtherDocumentMutation>;
export type DeleteOtherDocumentMutationResult = ApolloReactCommon.MutationResult<DeleteOtherDocumentMutation>;
export type DeleteOtherDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOtherDocumentMutation, DeleteOtherDocumentMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: ID!) {
  deleteOrder(id: $id) {
    id
  }
}
    `;
export type DeleteOrderMutationFn = ApolloReactCommon.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = ApolloReactCommon.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const CreateContractDocument = gql`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
    title
    type
  }
}
    `;
export type CreateContractMutationFn = ApolloReactCommon.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = ApolloReactCommon.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const UpdateContractDocument = gql`
    mutation UpdateContract($input: UpdateContractInput!) {
  updateContract(input: $input) {
    id
  }
}
    `;
export type UpdateContractMutationFn = ApolloReactCommon.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = ApolloReactCommon.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const DeleteContractDocument = gql`
    mutation DeleteContract($id: ID!) {
  deleteContract(id: $id) {
    id
  }
}
    `;
export type DeleteContractMutationFn = ApolloReactCommon.MutationFunction<DeleteContractMutation, DeleteContractMutationVariables>;

/**
 * __useDeleteContractMutation__
 *
 * To run a mutation, you first call `useDeleteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractMutation, { data, loading, error }] = useDeleteContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContractMutation, DeleteContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContractMutation, DeleteContractMutationVariables>(DeleteContractDocument, options);
      }
export type DeleteContractMutationHookResult = ReturnType<typeof useDeleteContractMutation>;
export type DeleteContractMutationResult = ApolloReactCommon.MutationResult<DeleteContractMutation>;
export type DeleteContractMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContractMutation, DeleteContractMutationVariables>;
export const DeleteUploadedFileDocument = gql`
    mutation DeleteUploadedFile($id: String!) {
  deleteUploadedFile(assignable_file_id: $id)
}
    `;
export type DeleteUploadedFileMutationFn = ApolloReactCommon.MutationFunction<DeleteUploadedFileMutation, DeleteUploadedFileMutationVariables>;

/**
 * __useDeleteUploadedFileMutation__
 *
 * To run a mutation, you first call `useDeleteUploadedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadedFileMutation, { data, loading, error }] = useDeleteUploadedFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUploadedFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUploadedFileMutation, DeleteUploadedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUploadedFileMutation, DeleteUploadedFileMutationVariables>(DeleteUploadedFileDocument, options);
      }
export type DeleteUploadedFileMutationHookResult = ReturnType<typeof useDeleteUploadedFileMutation>;
export type DeleteUploadedFileMutationResult = ApolloReactCommon.MutationResult<DeleteUploadedFileMutation>;
export type DeleteUploadedFileMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUploadedFileMutation, DeleteUploadedFileMutationVariables>;
export const CreateExternalLinkDocument = gql`
    mutation CreateExternalLink($input: CreateExternalLinkInput!) {
  createExternalLink(input: $input) {
    ...ExternalLinkFragment
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;
export type CreateExternalLinkMutationFn = ApolloReactCommon.MutationFunction<CreateExternalLinkMutation, CreateExternalLinkMutationVariables>;

/**
 * __useCreateExternalLinkMutation__
 *
 * To run a mutation, you first call `useCreateExternalLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalLinkMutation, { data, loading, error }] = useCreateExternalLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExternalLinkMutation, CreateExternalLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExternalLinkMutation, CreateExternalLinkMutationVariables>(CreateExternalLinkDocument, options);
      }
export type CreateExternalLinkMutationHookResult = ReturnType<typeof useCreateExternalLinkMutation>;
export type CreateExternalLinkMutationResult = ApolloReactCommon.MutationResult<CreateExternalLinkMutation>;
export type CreateExternalLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExternalLinkMutation, CreateExternalLinkMutationVariables>;
export const UpdateExternalLinkDocument = gql`
    mutation UpdateExternalLink($input: UpdateExternalLinkInput!) {
  updateExternalLink(input: $input) {
    ...ExternalLinkFragment
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;
export type UpdateExternalLinkMutationFn = ApolloReactCommon.MutationFunction<UpdateExternalLinkMutation, UpdateExternalLinkMutationVariables>;

/**
 * __useUpdateExternalLinkMutation__
 *
 * To run a mutation, you first call `useUpdateExternalLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalLinkMutation, { data, loading, error }] = useUpdateExternalLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExternalLinkMutation, UpdateExternalLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExternalLinkMutation, UpdateExternalLinkMutationVariables>(UpdateExternalLinkDocument, options);
      }
export type UpdateExternalLinkMutationHookResult = ReturnType<typeof useUpdateExternalLinkMutation>;
export type UpdateExternalLinkMutationResult = ApolloReactCommon.MutationResult<UpdateExternalLinkMutation>;
export type UpdateExternalLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExternalLinkMutation, UpdateExternalLinkMutationVariables>;
export const DeleteExternalLinkDocument = gql`
    mutation DeleteExternalLink($id: ID!) {
  deleteExternalLink(id: $id)
}
    `;
export type DeleteExternalLinkMutationFn = ApolloReactCommon.MutationFunction<DeleteExternalLinkMutation, DeleteExternalLinkMutationVariables>;

/**
 * __useDeleteExternalLinkMutation__
 *
 * To run a mutation, you first call `useDeleteExternalLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalLinkMutation, { data, loading, error }] = useDeleteExternalLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExternalLinkMutation, DeleteExternalLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteExternalLinkMutation, DeleteExternalLinkMutationVariables>(DeleteExternalLinkDocument, options);
      }
export type DeleteExternalLinkMutationHookResult = ReturnType<typeof useDeleteExternalLinkMutation>;
export type DeleteExternalLinkMutationResult = ApolloReactCommon.MutationResult<DeleteExternalLinkMutation>;
export type DeleteExternalLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteExternalLinkMutation, DeleteExternalLinkMutationVariables>;
export const AllExternalLinksDocument = gql`
    query AllExternalLinks($model_type: ExternalLinkType) {
  externalLinks(model_type: $model_type) {
    ...ExternalLinkFragment
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useAllExternalLinksQuery__
 *
 * To run a query within a React component, call `useAllExternalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExternalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllExternalLinksQuery({
 *   variables: {
 *      model_type: // value for 'model_type'
 *   },
 * });
 */
export function useAllExternalLinksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllExternalLinksQuery, AllExternalLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllExternalLinksQuery, AllExternalLinksQueryVariables>(AllExternalLinksDocument, options);
      }
export function useAllExternalLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllExternalLinksQuery, AllExternalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllExternalLinksQuery, AllExternalLinksQueryVariables>(AllExternalLinksDocument, options);
        }
export function useAllExternalLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllExternalLinksQuery, AllExternalLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllExternalLinksQuery, AllExternalLinksQueryVariables>(AllExternalLinksDocument, options);
        }
export type AllExternalLinksQueryHookResult = ReturnType<typeof useAllExternalLinksQuery>;
export type AllExternalLinksLazyQueryHookResult = ReturnType<typeof useAllExternalLinksLazyQuery>;
export type AllExternalLinksSuspenseQueryHookResult = ReturnType<typeof useAllExternalLinksSuspenseQuery>;
export type AllExternalLinksQueryResult = ApolloReactCommon.QueryResult<AllExternalLinksQuery, AllExternalLinksQueryVariables>;
export const ProjectExternalLinksDocument = gql`
    query ProjectExternalLinks($id: ID!) {
  project(id: $id) {
    externalLinks {
      ...ExternalLinkFragment
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useProjectExternalLinksQuery__
 *
 * To run a query within a React component, call `useProjectExternalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectExternalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectExternalLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectExternalLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables> & ({ variables: ProjectExternalLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>(ProjectExternalLinksDocument, options);
      }
export function useProjectExternalLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>(ProjectExternalLinksDocument, options);
        }
export function useProjectExternalLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>(ProjectExternalLinksDocument, options);
        }
export type ProjectExternalLinksQueryHookResult = ReturnType<typeof useProjectExternalLinksQuery>;
export type ProjectExternalLinksLazyQueryHookResult = ReturnType<typeof useProjectExternalLinksLazyQuery>;
export type ProjectExternalLinksSuspenseQueryHookResult = ReturnType<typeof useProjectExternalLinksSuspenseQuery>;
export type ProjectExternalLinksQueryResult = ApolloReactCommon.QueryResult<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>;
export const BrandExternalLinksDocument = gql`
    query BrandExternalLinks($id: ID!) {
  brand(id: $id) {
    externalLinks {
      ...ExternalLinkFragment
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useBrandExternalLinksQuery__
 *
 * To run a query within a React component, call `useBrandExternalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandExternalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandExternalLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandExternalLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandExternalLinksQuery, BrandExternalLinksQueryVariables> & ({ variables: BrandExternalLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>(BrandExternalLinksDocument, options);
      }
export function useBrandExternalLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>(BrandExternalLinksDocument, options);
        }
export function useBrandExternalLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>(BrandExternalLinksDocument, options);
        }
export type BrandExternalLinksQueryHookResult = ReturnType<typeof useBrandExternalLinksQuery>;
export type BrandExternalLinksLazyQueryHookResult = ReturnType<typeof useBrandExternalLinksLazyQuery>;
export type BrandExternalLinksSuspenseQueryHookResult = ReturnType<typeof useBrandExternalLinksSuspenseQuery>;
export type BrandExternalLinksQueryResult = ApolloReactCommon.QueryResult<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>;
export const ExternalLinksFilterOptionsDocument = gql`
    query ExternalLinksFilterOptions {
  projectsSimpleMap {
    id
    title
  }
  brandsSimpleMap {
    id
    name
  }
}
    `;

/**
 * __useExternalLinksFilterOptionsQuery__
 *
 * To run a query within a React component, call `useExternalLinksFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalLinksFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalLinksFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalLinksFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>(ExternalLinksFilterOptionsDocument, options);
      }
export function useExternalLinksFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>(ExternalLinksFilterOptionsDocument, options);
        }
export function useExternalLinksFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>(ExternalLinksFilterOptionsDocument, options);
        }
export type ExternalLinksFilterOptionsQueryHookResult = ReturnType<typeof useExternalLinksFilterOptionsQuery>;
export type ExternalLinksFilterOptionsLazyQueryHookResult = ReturnType<typeof useExternalLinksFilterOptionsLazyQuery>;
export type ExternalLinksFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useExternalLinksFilterOptionsSuspenseQuery>;
export type ExternalLinksFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>;
export const BudgetItemPlannedExpensesForCreateExpenseDocument = gql`
    query BudgetItemPlannedExpensesForCreateExpense($budgetItemId: ID!, $budgetItemType: ExpenseBudgetItemTypeEnum!) {
  budgetItemPlannedExpenses(
    budget_item_id: $budgetItemId
    budget_item_type: $budgetItemType
  ) {
    id
    description
    date
    budgeted_amount
    client_amount
    contractor {
      id
      legal_name
    }
    usedExpenses {
      id
      used_amount
      expenseItem {
        id
      }
    }
  }
}
    `;

/**
 * __useBudgetItemPlannedExpensesForCreateExpenseQuery__
 *
 * To run a query within a React component, call `useBudgetItemPlannedExpensesForCreateExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetItemPlannedExpensesForCreateExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetItemPlannedExpensesForCreateExpenseQuery({
 *   variables: {
 *      budgetItemId: // value for 'budgetItemId'
 *      budgetItemType: // value for 'budgetItemType'
 *   },
 * });
 */
export function useBudgetItemPlannedExpensesForCreateExpenseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables> & ({ variables: BudgetItemPlannedExpensesForCreateExpenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>(BudgetItemPlannedExpensesForCreateExpenseDocument, options);
      }
export function useBudgetItemPlannedExpensesForCreateExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>(BudgetItemPlannedExpensesForCreateExpenseDocument, options);
        }
export function useBudgetItemPlannedExpensesForCreateExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>(BudgetItemPlannedExpensesForCreateExpenseDocument, options);
        }
export type BudgetItemPlannedExpensesForCreateExpenseQueryHookResult = ReturnType<typeof useBudgetItemPlannedExpensesForCreateExpenseQuery>;
export type BudgetItemPlannedExpensesForCreateExpenseLazyQueryHookResult = ReturnType<typeof useBudgetItemPlannedExpensesForCreateExpenseLazyQuery>;
export type BudgetItemPlannedExpensesForCreateExpenseSuspenseQueryHookResult = ReturnType<typeof useBudgetItemPlannedExpensesForCreateExpenseSuspenseQuery>;
export type BudgetItemPlannedExpensesForCreateExpenseQueryResult = ApolloReactCommon.QueryResult<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>;
export const CreateExpenseDocument = gql`
    mutation CreateExpense($input: CreateExpenseInput!) {
  createExpense(input: $input) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;
export type CreateExpenseMutationFn = ApolloReactCommon.MutationFunction<CreateExpenseMutation, CreateExpenseMutationVariables>;

/**
 * __useCreateExpenseMutation__
 *
 * To run a mutation, you first call `useCreateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseMutation, { data, loading, error }] = useCreateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExpenseMutation, CreateExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument, options);
      }
export type CreateExpenseMutationHookResult = ReturnType<typeof useCreateExpenseMutation>;
export type CreateExpenseMutationResult = ApolloReactCommon.MutationResult<CreateExpenseMutation>;
export type CreateExpenseMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExpenseMutation, CreateExpenseMutationVariables>;
export const FindAddressForExpenseDocument = gql`
    mutation FindAddressForExpense($search: String) {
  findAddressForExpense(search: $search) {
    street
    city
    zip
    country {
      id
      name
      code
    }
  }
}
    `;
export type FindAddressForExpenseMutationFn = ApolloReactCommon.MutationFunction<FindAddressForExpenseMutation, FindAddressForExpenseMutationVariables>;

/**
 * __useFindAddressForExpenseMutation__
 *
 * To run a mutation, you first call `useFindAddressForExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindAddressForExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findAddressForExpenseMutation, { data, loading, error }] = useFindAddressForExpenseMutation({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFindAddressForExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FindAddressForExpenseMutation, FindAddressForExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FindAddressForExpenseMutation, FindAddressForExpenseMutationVariables>(FindAddressForExpenseDocument, options);
      }
export type FindAddressForExpenseMutationHookResult = ReturnType<typeof useFindAddressForExpenseMutation>;
export type FindAddressForExpenseMutationResult = ApolloReactCommon.MutationResult<FindAddressForExpenseMutation>;
export type FindAddressForExpenseMutationOptions = ApolloReactCommon.BaseMutationOptions<FindAddressForExpenseMutation, FindAddressForExpenseMutationVariables>;
export const UpdateExpenseDocument = gql`
    mutation UpdateExpense($input: UpdateExpenseInput!) {
  updateExpense(input: $input) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;
export type UpdateExpenseMutationFn = ApolloReactCommon.MutationFunction<UpdateExpenseMutation, UpdateExpenseMutationVariables>;

/**
 * __useUpdateExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseMutation, { data, loading, error }] = useUpdateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExpenseMutation, UpdateExpenseMutationVariables>(UpdateExpenseDocument, options);
      }
export type UpdateExpenseMutationHookResult = ReturnType<typeof useUpdateExpenseMutation>;
export type UpdateExpenseMutationResult = ApolloReactCommon.MutationResult<UpdateExpenseMutation>;
export type UpdateExpenseMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>;
export const LockDocumentDocument = gql`
    mutation LockDocument($document_id: ID!, $document_type: LockDocumentTypeEnum!) {
  lockDocument(document_id: $document_id, document_type: $document_type) {
    document_id
  }
}
    `;
export type LockDocumentMutationFn = ApolloReactCommon.MutationFunction<LockDocumentMutation, LockDocumentMutationVariables>;

/**
 * __useLockDocumentMutation__
 *
 * To run a mutation, you first call `useLockDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockDocumentMutation, { data, loading, error }] = useLockDocumentMutation({
 *   variables: {
 *      document_id: // value for 'document_id'
 *      document_type: // value for 'document_type'
 *   },
 * });
 */
export function useLockDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LockDocumentMutation, LockDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LockDocumentMutation, LockDocumentMutationVariables>(LockDocumentDocument, options);
      }
export type LockDocumentMutationHookResult = ReturnType<typeof useLockDocumentMutation>;
export type LockDocumentMutationResult = ApolloReactCommon.MutationResult<LockDocumentMutation>;
export type LockDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<LockDocumentMutation, LockDocumentMutationVariables>;
export const UnlockDocumentDocument = gql`
    mutation UnlockDocument($document_id: ID!, $document_type: LockDocumentTypeEnum!) {
  unlockDocument(document_id: $document_id, document_type: $document_type) {
    document_id
  }
}
    `;
export type UnlockDocumentMutationFn = ApolloReactCommon.MutationFunction<UnlockDocumentMutation, UnlockDocumentMutationVariables>;

/**
 * __useUnlockDocumentMutation__
 *
 * To run a mutation, you first call `useUnlockDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockDocumentMutation, { data, loading, error }] = useUnlockDocumentMutation({
 *   variables: {
 *      document_id: // value for 'document_id'
 *      document_type: // value for 'document_type'
 *   },
 * });
 */
export function useUnlockDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlockDocumentMutation, UnlockDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlockDocumentMutation, UnlockDocumentMutationVariables>(UnlockDocumentDocument, options);
      }
export type UnlockDocumentMutationHookResult = ReturnType<typeof useUnlockDocumentMutation>;
export type UnlockDocumentMutationResult = ApolloReactCommon.MutationResult<UnlockDocumentMutation>;
export type UnlockDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlockDocumentMutation, UnlockDocumentMutationVariables>;
export const CreateExpenseItemDescriptionDocument = gql`
    mutation CreateExpenseItemDescription($title: String!) {
  createExpenseItemDescription(title: $title) {
    ...ExpenseItemDescription
  }
}
    ${ExpenseItemDescriptionFragmentDoc}`;
export type CreateExpenseItemDescriptionMutationFn = ApolloReactCommon.MutationFunction<CreateExpenseItemDescriptionMutation, CreateExpenseItemDescriptionMutationVariables>;

/**
 * __useCreateExpenseItemDescriptionMutation__
 *
 * To run a mutation, you first call `useCreateExpenseItemDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseItemDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseItemDescriptionMutation, { data, loading, error }] = useCreateExpenseItemDescriptionMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateExpenseItemDescriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExpenseItemDescriptionMutation, CreateExpenseItemDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExpenseItemDescriptionMutation, CreateExpenseItemDescriptionMutationVariables>(CreateExpenseItemDescriptionDocument, options);
      }
export type CreateExpenseItemDescriptionMutationHookResult = ReturnType<typeof useCreateExpenseItemDescriptionMutation>;
export type CreateExpenseItemDescriptionMutationResult = ApolloReactCommon.MutationResult<CreateExpenseItemDescriptionMutation>;
export type CreateExpenseItemDescriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExpenseItemDescriptionMutation, CreateExpenseItemDescriptionMutationVariables>;
export const UpdateExpenseItemDescriptionDocument = gql`
    mutation UpdateExpenseItemDescription($id: ID!, $title: String!) {
  updateExpenseItemDescription(id: $id, title: $title) {
    ...ExpenseItemDescription
  }
}
    ${ExpenseItemDescriptionFragmentDoc}`;
export type UpdateExpenseItemDescriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateExpenseItemDescriptionMutation, UpdateExpenseItemDescriptionMutationVariables>;

/**
 * __useUpdateExpenseItemDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseItemDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseItemDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseItemDescriptionMutation, { data, loading, error }] = useUpdateExpenseItemDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateExpenseItemDescriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExpenseItemDescriptionMutation, UpdateExpenseItemDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExpenseItemDescriptionMutation, UpdateExpenseItemDescriptionMutationVariables>(UpdateExpenseItemDescriptionDocument, options);
      }
export type UpdateExpenseItemDescriptionMutationHookResult = ReturnType<typeof useUpdateExpenseItemDescriptionMutation>;
export type UpdateExpenseItemDescriptionMutationResult = ApolloReactCommon.MutationResult<UpdateExpenseItemDescriptionMutation>;
export type UpdateExpenseItemDescriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExpenseItemDescriptionMutation, UpdateExpenseItemDescriptionMutationVariables>;
export const DeleteExpenseItemDescriptionDocument = gql`
    mutation DeleteExpenseItemDescription($id: ID!) {
  deleteExpenseItemDescription(id: $id)
}
    `;
export type DeleteExpenseItemDescriptionMutationFn = ApolloReactCommon.MutationFunction<DeleteExpenseItemDescriptionMutation, DeleteExpenseItemDescriptionMutationVariables>;

/**
 * __useDeleteExpenseItemDescriptionMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseItemDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseItemDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpenseItemDescriptionMutation, { data, loading, error }] = useDeleteExpenseItemDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpenseItemDescriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExpenseItemDescriptionMutation, DeleteExpenseItemDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteExpenseItemDescriptionMutation, DeleteExpenseItemDescriptionMutationVariables>(DeleteExpenseItemDescriptionDocument, options);
      }
export type DeleteExpenseItemDescriptionMutationHookResult = ReturnType<typeof useDeleteExpenseItemDescriptionMutation>;
export type DeleteExpenseItemDescriptionMutationResult = ApolloReactCommon.MutationResult<DeleteExpenseItemDescriptionMutation>;
export type DeleteExpenseItemDescriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteExpenseItemDescriptionMutation, DeleteExpenseItemDescriptionMutationVariables>;
export const ContractForCreateExpenseDocument = gql`
    query ContractForCreateExpense($id: ID!) {
  contract(id: $id) {
    id
    type
    files {
      ...MediaModelParts
    }
  }
}
    ${MediaModelPartsFragmentDoc}`;

/**
 * __useContractForCreateExpenseQuery__
 *
 * To run a query within a React component, call `useContractForCreateExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractForCreateExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractForCreateExpenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractForCreateExpenseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables> & ({ variables: ContractForCreateExpenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>(ContractForCreateExpenseDocument, options);
      }
export function useContractForCreateExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>(ContractForCreateExpenseDocument, options);
        }
export function useContractForCreateExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>(ContractForCreateExpenseDocument, options);
        }
export type ContractForCreateExpenseQueryHookResult = ReturnType<typeof useContractForCreateExpenseQuery>;
export type ContractForCreateExpenseLazyQueryHookResult = ReturnType<typeof useContractForCreateExpenseLazyQuery>;
export type ContractForCreateExpenseSuspenseQueryHookResult = ReturnType<typeof useContractForCreateExpenseSuspenseQuery>;
export type ContractForCreateExpenseQueryResult = ApolloReactCommon.QueryResult<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>;
export const ContractorForCreateExpenseDocument = gql`
    query ContractorForCreateExpense($id: ID!) {
  contractor(id: $id) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;

/**
 * __useContractorForCreateExpenseQuery__
 *
 * To run a query within a React component, call `useContractorForCreateExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorForCreateExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorForCreateExpenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractorForCreateExpenseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables> & ({ variables: ContractorForCreateExpenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>(ContractorForCreateExpenseDocument, options);
      }
export function useContractorForCreateExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>(ContractorForCreateExpenseDocument, options);
        }
export function useContractorForCreateExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>(ContractorForCreateExpenseDocument, options);
        }
export type ContractorForCreateExpenseQueryHookResult = ReturnType<typeof useContractorForCreateExpenseQuery>;
export type ContractorForCreateExpenseLazyQueryHookResult = ReturnType<typeof useContractorForCreateExpenseLazyQuery>;
export type ContractorForCreateExpenseSuspenseQueryHookResult = ReturnType<typeof useContractorForCreateExpenseSuspenseQuery>;
export type ContractorForCreateExpenseQueryResult = ApolloReactCommon.QueryResult<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>;
export const DependenciesForCreateExpenseDocument = gql`
    query DependenciesForCreateExpense {
  currencies {
    ...CurrencyOptionParts
  }
  vatRates {
    ...VatRateOptionParts
    deleted
    type
  }
  fondContractorsSimpleMap {
    id
    legal_name
  }
  accountingAccountsSimpleMap {
    ...AccountingAccountOptionParts
  }
  paymentTypes {
    id
    name
    system_name
  }
  clientsSimpleMap {
    id
    brands {
      ...BrandSimpleOptionParts
    }
  }
  accountingCentres {
    ...CostCenter
  }
  expenseItemDescriptions {
    ...ExpenseItemDescription
  }
}
    ${CurrencyOptionPartsFragmentDoc}
${VatRateOptionPartsFragmentDoc}
${AccountingAccountOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}
${CostCenterFragmentDoc}
${ExpenseItemDescriptionFragmentDoc}`;

/**
 * __useDependenciesForCreateExpenseQuery__
 *
 * To run a query within a React component, call `useDependenciesForCreateExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useDependenciesForCreateExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDependenciesForCreateExpenseQuery({
 *   variables: {
 *   },
 * });
 */
export function useDependenciesForCreateExpenseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>(DependenciesForCreateExpenseDocument, options);
      }
export function useDependenciesForCreateExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>(DependenciesForCreateExpenseDocument, options);
        }
export function useDependenciesForCreateExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>(DependenciesForCreateExpenseDocument, options);
        }
export type DependenciesForCreateExpenseQueryHookResult = ReturnType<typeof useDependenciesForCreateExpenseQuery>;
export type DependenciesForCreateExpenseLazyQueryHookResult = ReturnType<typeof useDependenciesForCreateExpenseLazyQuery>;
export type DependenciesForCreateExpenseSuspenseQueryHookResult = ReturnType<typeof useDependenciesForCreateExpenseSuspenseQuery>;
export type DependenciesForCreateExpenseQueryResult = ApolloReactCommon.QueryResult<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>;
export const ExpenseForCreateExpenseDocument = gql`
    query ExpenseForCreateExpense($id: ID!) {
  expense(id: $id) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;

/**
 * __useExpenseForCreateExpenseQuery__
 *
 * To run a query within a React component, call `useExpenseForCreateExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseForCreateExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseForCreateExpenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpenseForCreateExpenseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables> & ({ variables: ExpenseForCreateExpenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>(ExpenseForCreateExpenseDocument, options);
      }
export function useExpenseForCreateExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>(ExpenseForCreateExpenseDocument, options);
        }
export function useExpenseForCreateExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>(ExpenseForCreateExpenseDocument, options);
        }
export type ExpenseForCreateExpenseQueryHookResult = ReturnType<typeof useExpenseForCreateExpenseQuery>;
export type ExpenseForCreateExpenseLazyQueryHookResult = ReturnType<typeof useExpenseForCreateExpenseLazyQuery>;
export type ExpenseForCreateExpenseSuspenseQueryHookResult = ReturnType<typeof useExpenseForCreateExpenseSuspenseQuery>;
export type ExpenseForCreateExpenseQueryResult = ApolloReactCommon.QueryResult<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>;
export const IsExpenseLockedDocument = gql`
    query IsExpenseLocked($id: ID!) {
  expense(id: $id) {
    lockedDocument {
      locked_to
      user {
        id
        full_name
      }
    }
  }
}
    `;

/**
 * __useIsExpenseLockedQuery__
 *
 * To run a query within a React component, call `useIsExpenseLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsExpenseLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsExpenseLockedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsExpenseLockedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsExpenseLockedQuery, IsExpenseLockedQueryVariables> & ({ variables: IsExpenseLockedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>(IsExpenseLockedDocument, options);
      }
export function useIsExpenseLockedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>(IsExpenseLockedDocument, options);
        }
export function useIsExpenseLockedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>(IsExpenseLockedDocument, options);
        }
export type IsExpenseLockedQueryHookResult = ReturnType<typeof useIsExpenseLockedQuery>;
export type IsExpenseLockedLazyQueryHookResult = ReturnType<typeof useIsExpenseLockedLazyQuery>;
export type IsExpenseLockedSuspenseQueryHookResult = ReturnType<typeof useIsExpenseLockedSuspenseQuery>;
export type IsExpenseLockedQueryResult = ApolloReactCommon.QueryResult<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>;
export const GetExpenseUpdatedAtDocument = gql`
    query GetExpenseUpdatedAt($id: ID!) {
  expense(id: $id) {
    updated_at
  }
}
    `;

/**
 * __useGetExpenseUpdatedAtQuery__
 *
 * To run a query within a React component, call `useGetExpenseUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseUpdatedAtQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExpenseUpdatedAtQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables> & ({ variables: GetExpenseUpdatedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>(GetExpenseUpdatedAtDocument, options);
      }
export function useGetExpenseUpdatedAtLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>(GetExpenseUpdatedAtDocument, options);
        }
export function useGetExpenseUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>(GetExpenseUpdatedAtDocument, options);
        }
export type GetExpenseUpdatedAtQueryHookResult = ReturnType<typeof useGetExpenseUpdatedAtQuery>;
export type GetExpenseUpdatedAtLazyQueryHookResult = ReturnType<typeof useGetExpenseUpdatedAtLazyQuery>;
export type GetExpenseUpdatedAtSuspenseQueryHookResult = ReturnType<typeof useGetExpenseUpdatedAtSuspenseQuery>;
export type GetExpenseUpdatedAtQueryResult = ApolloReactCommon.QueryResult<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>;
export const GetExpenseBudgetItemsByItemCodeDocument = gql`
    query GetExpenseBudgetItemsByItemCode($item_code: String!) {
  expenseBudgetItemsByItemCode(item_code: $item_code) {
    ...ExpenseBudgetItemByCode
  }
}
    ${ExpenseBudgetItemByCodeFragmentDoc}`;

/**
 * __useGetExpenseBudgetItemsByItemCodeQuery__
 *
 * To run a query within a React component, call `useGetExpenseBudgetItemsByItemCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseBudgetItemsByItemCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseBudgetItemsByItemCodeQuery({
 *   variables: {
 *      item_code: // value for 'item_code'
 *   },
 * });
 */
export function useGetExpenseBudgetItemsByItemCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables> & ({ variables: GetExpenseBudgetItemsByItemCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>(GetExpenseBudgetItemsByItemCodeDocument, options);
      }
export function useGetExpenseBudgetItemsByItemCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>(GetExpenseBudgetItemsByItemCodeDocument, options);
        }
export function useGetExpenseBudgetItemsByItemCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>(GetExpenseBudgetItemsByItemCodeDocument, options);
        }
export type GetExpenseBudgetItemsByItemCodeQueryHookResult = ReturnType<typeof useGetExpenseBudgetItemsByItemCodeQuery>;
export type GetExpenseBudgetItemsByItemCodeLazyQueryHookResult = ReturnType<typeof useGetExpenseBudgetItemsByItemCodeLazyQuery>;
export type GetExpenseBudgetItemsByItemCodeSuspenseQueryHookResult = ReturnType<typeof useGetExpenseBudgetItemsByItemCodeSuspenseQuery>;
export type GetExpenseBudgetItemsByItemCodeQueryResult = ApolloReactCommon.QueryResult<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>;
export const GetOurWorkBudgetItemsByItemCodeDocument = gql`
    query GetOurWorkBudgetItemsByItemCode($item_code: String!) {
  ourWorkBudgetItemsByItemCode(item_code: $item_code) {
    ...OurWorkBudgetItemByCode
  }
}
    ${OurWorkBudgetItemByCodeFragmentDoc}`;

/**
 * __useGetOurWorkBudgetItemsByItemCodeQuery__
 *
 * To run a query within a React component, call `useGetOurWorkBudgetItemsByItemCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOurWorkBudgetItemsByItemCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOurWorkBudgetItemsByItemCodeQuery({
 *   variables: {
 *      item_code: // value for 'item_code'
 *   },
 * });
 */
export function useGetOurWorkBudgetItemsByItemCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables> & ({ variables: GetOurWorkBudgetItemsByItemCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>(GetOurWorkBudgetItemsByItemCodeDocument, options);
      }
export function useGetOurWorkBudgetItemsByItemCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>(GetOurWorkBudgetItemsByItemCodeDocument, options);
        }
export function useGetOurWorkBudgetItemsByItemCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>(GetOurWorkBudgetItemsByItemCodeDocument, options);
        }
export type GetOurWorkBudgetItemsByItemCodeQueryHookResult = ReturnType<typeof useGetOurWorkBudgetItemsByItemCodeQuery>;
export type GetOurWorkBudgetItemsByItemCodeLazyQueryHookResult = ReturnType<typeof useGetOurWorkBudgetItemsByItemCodeLazyQuery>;
export type GetOurWorkBudgetItemsByItemCodeSuspenseQueryHookResult = ReturnType<typeof useGetOurWorkBudgetItemsByItemCodeSuspenseQuery>;
export type GetOurWorkBudgetItemsByItemCodeQueryResult = ApolloReactCommon.QueryResult<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>;
export const ProjectForCreateExpenseDocument = gql`
    query ProjectForCreateExpense($id: ID!) {
  projectForExpense(id: $id) {
    id
    title
    code
    finished_at
    brand {
      id
    }
    team {
      id
      expense_cost_centre_id
    }
    expenses {
      id
      title
      item_code
      payment_status
      type
      completed_at
      category {
        id
        name
      }
      stats {
        total_budget
        planned_expenses
        real_expenses
      }
    }
    ourWorkBudgetItems {
      id
      title
      item_code
      timeTrackingSettings {
        id
        tracking_enabled
        tracking_enabled_from
        tracking_enabled_to
      }
      stats {
        remaining_budget
      }
    }
  }
}
    `;

/**
 * __useProjectForCreateExpenseQuery__
 *
 * To run a query within a React component, call `useProjectForCreateExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectForCreateExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectForCreateExpenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectForCreateExpenseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables> & ({ variables: ProjectForCreateExpenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>(ProjectForCreateExpenseDocument, options);
      }
export function useProjectForCreateExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>(ProjectForCreateExpenseDocument, options);
        }
export function useProjectForCreateExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>(ProjectForCreateExpenseDocument, options);
        }
export type ProjectForCreateExpenseQueryHookResult = ReturnType<typeof useProjectForCreateExpenseQuery>;
export type ProjectForCreateExpenseLazyQueryHookResult = ReturnType<typeof useProjectForCreateExpenseLazyQuery>;
export type ProjectForCreateExpenseSuspenseQueryHookResult = ReturnType<typeof useProjectForCreateExpenseSuspenseQuery>;
export type ProjectForCreateExpenseQueryResult = ApolloReactCommon.QueryResult<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>;
export const ContractorSelectOptionsDocument = gql`
    query ContractorSelectOptions($page: Int, $first: Int, $filters: ContractorQueryArgs) {
  contractors(page: $page, first: $first, filters: $filters) {
    data {
      id
      legal_name
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useContractorSelectOptionsQuery__
 *
 * To run a query within a React component, call `useContractorSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorSelectOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useContractorSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>(ContractorSelectOptionsDocument, options);
      }
export function useContractorSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>(ContractorSelectOptionsDocument, options);
        }
export function useContractorSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>(ContractorSelectOptionsDocument, options);
        }
export type ContractorSelectOptionsQueryHookResult = ReturnType<typeof useContractorSelectOptionsQuery>;
export type ContractorSelectOptionsLazyQueryHookResult = ReturnType<typeof useContractorSelectOptionsLazyQuery>;
export type ContractorSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useContractorSelectOptionsSuspenseQuery>;
export type ContractorSelectOptionsQueryResult = ApolloReactCommon.QueryResult<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>;
export const BillingEntitySelectOptionsDocument = gql`
    query BillingEntitySelectOptions($page: Int, $first: Int, $filters: BillingEntityQueryArgs) {
  billingEntities(page: $page, first: $first, filters: $filters) {
    data {
      id
      internal_name
      street
      city
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useBillingEntitySelectOptionsQuery__
 *
 * To run a query within a React component, call `useBillingEntitySelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingEntitySelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingEntitySelectOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBillingEntitySelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>(BillingEntitySelectOptionsDocument, options);
      }
export function useBillingEntitySelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>(BillingEntitySelectOptionsDocument, options);
        }
export function useBillingEntitySelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>(BillingEntitySelectOptionsDocument, options);
        }
export type BillingEntitySelectOptionsQueryHookResult = ReturnType<typeof useBillingEntitySelectOptionsQuery>;
export type BillingEntitySelectOptionsLazyQueryHookResult = ReturnType<typeof useBillingEntitySelectOptionsLazyQuery>;
export type BillingEntitySelectOptionsSuspenseQueryHookResult = ReturnType<typeof useBillingEntitySelectOptionsSuspenseQuery>;
export type BillingEntitySelectOptionsQueryResult = ApolloReactCommon.QueryResult<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>;
export const GetExpensePredictionDocument = gql`
    query GetExpensePrediction($file: Upload!) {
  fetchOCRExpenseData(file: $file) {
    document_number
    for_approval
    type
    variable_symbol
    constant_symbol
    specific_symbol
    document_number
    total_amount_includes_vat
    total_amount_with_vat_in_currency
    issue_date
    date_of_supply
    due_date
    currency_id
    contractor_id
    legal_name
    street
    city
    zip
    country_id
    registration_no
    tax_no
    vat_no
    business_form
    iban
    swift
    bank_account
    bank_account_code
    expense_items {
      amount
      approved
      description
      vat_rate
    }
  }
}
    `;

/**
 * __useGetExpensePredictionQuery__
 *
 * To run a query within a React component, call `useGetExpensePredictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensePredictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensePredictionQuery({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useGetExpensePredictionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetExpensePredictionQuery, GetExpensePredictionQueryVariables> & ({ variables: GetExpensePredictionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>(GetExpensePredictionDocument, options);
      }
export function useGetExpensePredictionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>(GetExpensePredictionDocument, options);
        }
export function useGetExpensePredictionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>(GetExpensePredictionDocument, options);
        }
export type GetExpensePredictionQueryHookResult = ReturnType<typeof useGetExpensePredictionQuery>;
export type GetExpensePredictionLazyQueryHookResult = ReturnType<typeof useGetExpensePredictionLazyQuery>;
export type GetExpensePredictionSuspenseQueryHookResult = ReturnType<typeof useGetExpensePredictionSuspenseQuery>;
export type GetExpensePredictionQueryResult = ApolloReactCommon.QueryResult<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>;
export const TaskPositionsForExpenseDocument = gql`
    query TaskPositionsForExpense($id: ID!) {
  task(id: $id) {
    id
    positions {
      id
      timeTrackingWorkType {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useTaskPositionsForExpenseQuery__
 *
 * To run a query within a React component, call `useTaskPositionsForExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskPositionsForExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskPositionsForExpenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskPositionsForExpenseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables> & ({ variables: TaskPositionsForExpenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>(TaskPositionsForExpenseDocument, options);
      }
export function useTaskPositionsForExpenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>(TaskPositionsForExpenseDocument, options);
        }
export function useTaskPositionsForExpenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>(TaskPositionsForExpenseDocument, options);
        }
export type TaskPositionsForExpenseQueryHookResult = ReturnType<typeof useTaskPositionsForExpenseQuery>;
export type TaskPositionsForExpenseLazyQueryHookResult = ReturnType<typeof useTaskPositionsForExpenseLazyQuery>;
export type TaskPositionsForExpenseSuspenseQueryHookResult = ReturnType<typeof useTaskPositionsForExpenseSuspenseQuery>;
export type TaskPositionsForExpenseQueryResult = ApolloReactCommon.QueryResult<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>;
export const ExpenseItemsListingDocument = gql`
    query ExpenseItemsListing($filters: ExpenseItemsTimeBillingQueryArgs, $first: Int, $page: Int) {
  expenseItemsForTimeBilling(filters: $filters, first: $first, page: $page) {
    data {
      ...ExpenseItemsListItem
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ExpenseItemsListItemFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useExpenseItemsListingQuery__
 *
 * To run a query within a React component, call `useExpenseItemsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseItemsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseItemsListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useExpenseItemsListingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>(ExpenseItemsListingDocument, options);
      }
export function useExpenseItemsListingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>(ExpenseItemsListingDocument, options);
        }
export function useExpenseItemsListingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>(ExpenseItemsListingDocument, options);
        }
export type ExpenseItemsListingQueryHookResult = ReturnType<typeof useExpenseItemsListingQuery>;
export type ExpenseItemsListingLazyQueryHookResult = ReturnType<typeof useExpenseItemsListingLazyQuery>;
export type ExpenseItemsListingSuspenseQueryHookResult = ReturnType<typeof useExpenseItemsListingSuspenseQuery>;
export type ExpenseItemsListingQueryResult = ApolloReactCommon.QueryResult<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>;
export const ExpenseItemsListingSummaryDocument = gql`
    query ExpenseItemsListingSummary($filters: ExpenseItemsTimeBillingQueryArgs) {
  expenseItemsForTimeBillingSummary(filters: $filters) {
    allIds
    count
    amount
  }
}
    `;

/**
 * __useExpenseItemsListingSummaryQuery__
 *
 * To run a query within a React component, call `useExpenseItemsListingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseItemsListingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseItemsListingSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExpenseItemsListingSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>(ExpenseItemsListingSummaryDocument, options);
      }
export function useExpenseItemsListingSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>(ExpenseItemsListingSummaryDocument, options);
        }
export function useExpenseItemsListingSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>(ExpenseItemsListingSummaryDocument, options);
        }
export type ExpenseItemsListingSummaryQueryHookResult = ReturnType<typeof useExpenseItemsListingSummaryQuery>;
export type ExpenseItemsListingSummaryLazyQueryHookResult = ReturnType<typeof useExpenseItemsListingSummaryLazyQuery>;
export type ExpenseItemsListingSummarySuspenseQueryHookResult = ReturnType<typeof useExpenseItemsListingSummarySuspenseQuery>;
export type ExpenseItemsListingSummaryQueryResult = ApolloReactCommon.QueryResult<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>;
export const ExpenseItemsListingFilterOptionsDocument = gql`
    query ExpenseItemsListingFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    title
    code
  }
  userSimpleMap {
    id
    full_name
  }
  accountingCentres {
    id
    title
  }
}
    `;

/**
 * __useExpenseItemsListingFilterOptionsQuery__
 *
 * To run a query within a React component, call `useExpenseItemsListingFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseItemsListingFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseItemsListingFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseItemsListingFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>(ExpenseItemsListingFilterOptionsDocument, options);
      }
export function useExpenseItemsListingFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>(ExpenseItemsListingFilterOptionsDocument, options);
        }
export function useExpenseItemsListingFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>(ExpenseItemsListingFilterOptionsDocument, options);
        }
export type ExpenseItemsListingFilterOptionsQueryHookResult = ReturnType<typeof useExpenseItemsListingFilterOptionsQuery>;
export type ExpenseItemsListingFilterOptionsLazyQueryHookResult = ReturnType<typeof useExpenseItemsListingFilterOptionsLazyQuery>;
export type ExpenseItemsListingFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useExpenseItemsListingFilterOptionsSuspenseQuery>;
export type ExpenseItemsListingFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>;
export const DeleteExpenseDocument = gql`
    mutation DeleteExpense($id: ID!) {
  deleteExpense(id: $id) {
    id
  }
}
    `;
export type DeleteExpenseMutationFn = ApolloReactCommon.MutationFunction<DeleteExpenseMutation, DeleteExpenseMutationVariables>;

/**
 * __useDeleteExpenseMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpenseMutation, { data, loading, error }] = useDeleteExpenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteExpenseMutation, DeleteExpenseMutationVariables>(DeleteExpenseDocument, options);
      }
export type DeleteExpenseMutationHookResult = ReturnType<typeof useDeleteExpenseMutation>;
export type DeleteExpenseMutationResult = ApolloReactCommon.MutationResult<DeleteExpenseMutation>;
export type DeleteExpenseMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>;
export const MarkExpenseAsPaidDocument = gql`
    mutation MarkExpenseAsPaid($id: ID!, $date: Date) {
  markExpenseAsPaid(id: $id, date: $date) {
    id
    paid_at
  }
}
    `;
export type MarkExpenseAsPaidMutationFn = ApolloReactCommon.MutationFunction<MarkExpenseAsPaidMutation, MarkExpenseAsPaidMutationVariables>;

/**
 * __useMarkExpenseAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkExpenseAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkExpenseAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markExpenseAsPaidMutation, { data, loading, error }] = useMarkExpenseAsPaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useMarkExpenseAsPaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkExpenseAsPaidMutation, MarkExpenseAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkExpenseAsPaidMutation, MarkExpenseAsPaidMutationVariables>(MarkExpenseAsPaidDocument, options);
      }
export type MarkExpenseAsPaidMutationHookResult = ReturnType<typeof useMarkExpenseAsPaidMutation>;
export type MarkExpenseAsPaidMutationResult = ApolloReactCommon.MutationResult<MarkExpenseAsPaidMutation>;
export type MarkExpenseAsPaidMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkExpenseAsPaidMutation, MarkExpenseAsPaidMutationVariables>;
export const MarkExpenseAsUnpaidDocument = gql`
    mutation MarkExpenseAsUnpaid($id: ID!, $remove_matched_payments: Boolean! = false) {
  markExpenseAsUnpaid(id: $id, remove_matched_payments: $remove_matched_payments) {
    id
    paid_at
  }
}
    `;
export type MarkExpenseAsUnpaidMutationFn = ApolloReactCommon.MutationFunction<MarkExpenseAsUnpaidMutation, MarkExpenseAsUnpaidMutationVariables>;

/**
 * __useMarkExpenseAsUnpaidMutation__
 *
 * To run a mutation, you first call `useMarkExpenseAsUnpaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkExpenseAsUnpaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markExpenseAsUnpaidMutation, { data, loading, error }] = useMarkExpenseAsUnpaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      remove_matched_payments: // value for 'remove_matched_payments'
 *   },
 * });
 */
export function useMarkExpenseAsUnpaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkExpenseAsUnpaidMutation, MarkExpenseAsUnpaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkExpenseAsUnpaidMutation, MarkExpenseAsUnpaidMutationVariables>(MarkExpenseAsUnpaidDocument, options);
      }
export type MarkExpenseAsUnpaidMutationHookResult = ReturnType<typeof useMarkExpenseAsUnpaidMutation>;
export type MarkExpenseAsUnpaidMutationResult = ApolloReactCommon.MutationResult<MarkExpenseAsUnpaidMutation>;
export type MarkExpenseAsUnpaidMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkExpenseAsUnpaidMutation, MarkExpenseAsUnpaidMutationVariables>;
export const MarkExpenseAsPaidBulkDocument = gql`
    mutation MarkExpenseAsPaidBulk($id: [ID!]!, $date: Date) {
  markExpenseAsPaidBulk(id: $id, date: $date) {
    total
    successful
    failed
  }
}
    `;
export type MarkExpenseAsPaidBulkMutationFn = ApolloReactCommon.MutationFunction<MarkExpenseAsPaidBulkMutation, MarkExpenseAsPaidBulkMutationVariables>;

/**
 * __useMarkExpenseAsPaidBulkMutation__
 *
 * To run a mutation, you first call `useMarkExpenseAsPaidBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkExpenseAsPaidBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markExpenseAsPaidBulkMutation, { data, loading, error }] = useMarkExpenseAsPaidBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useMarkExpenseAsPaidBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkExpenseAsPaidBulkMutation, MarkExpenseAsPaidBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkExpenseAsPaidBulkMutation, MarkExpenseAsPaidBulkMutationVariables>(MarkExpenseAsPaidBulkDocument, options);
      }
export type MarkExpenseAsPaidBulkMutationHookResult = ReturnType<typeof useMarkExpenseAsPaidBulkMutation>;
export type MarkExpenseAsPaidBulkMutationResult = ApolloReactCommon.MutationResult<MarkExpenseAsPaidBulkMutation>;
export type MarkExpenseAsPaidBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkExpenseAsPaidBulkMutation, MarkExpenseAsPaidBulkMutationVariables>;
export const CloneExpenseDocument = gql`
    mutation CloneExpense($id: ID!) {
  cloneExpense(id: $id) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;
export type CloneExpenseMutationFn = ApolloReactCommon.MutationFunction<CloneExpenseMutation, CloneExpenseMutationVariables>;

/**
 * __useCloneExpenseMutation__
 *
 * To run a mutation, you first call `useCloneExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneExpenseMutation, { data, loading, error }] = useCloneExpenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneExpenseMutation, CloneExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneExpenseMutation, CloneExpenseMutationVariables>(CloneExpenseDocument, options);
      }
export type CloneExpenseMutationHookResult = ReturnType<typeof useCloneExpenseMutation>;
export type CloneExpenseMutationResult = ApolloReactCommon.MutationResult<CloneExpenseMutation>;
export type CloneExpenseMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneExpenseMutation, CloneExpenseMutationVariables>;
export const BulkDeleteExpensesDocument = gql`
    mutation BulkDeleteExpenses($ids: [ID!]!) {
  bulkDeleteExpenses(ids: $ids) {
    total
    successful
    failed
  }
}
    `;
export type BulkDeleteExpensesMutationFn = ApolloReactCommon.MutationFunction<BulkDeleteExpensesMutation, BulkDeleteExpensesMutationVariables>;

/**
 * __useBulkDeleteExpensesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteExpensesMutation, { data, loading, error }] = useBulkDeleteExpensesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDeleteExpensesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkDeleteExpensesMutation, BulkDeleteExpensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkDeleteExpensesMutation, BulkDeleteExpensesMutationVariables>(BulkDeleteExpensesDocument, options);
      }
export type BulkDeleteExpensesMutationHookResult = ReturnType<typeof useBulkDeleteExpensesMutation>;
export type BulkDeleteExpensesMutationResult = ApolloReactCommon.MutationResult<BulkDeleteExpensesMutation>;
export type BulkDeleteExpensesMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkDeleteExpensesMutation, BulkDeleteExpensesMutationVariables>;
export const GetExpensesDocument = gql`
    query GetExpenses($page: Int, $first: Int, $filters: ExpenseQueryArgs) {
  expenses(page: $page, first: $first, filters: $filters) {
    data {
      id
      invoice_status
      status
      type
      abraflexi_exported
      xero_exported
      documentExports {
        ...DocumentExport
      }
      contractor {
        id
        legal_name
      }
      projects {
        id
        code
        title
      }
      variable_symbol
      has_master_agreement
      workspace_company_id
      iban
      stats {
        total_amount
        total_amount_without_vat_in_currency
        total_amount_with_vat_in_currency
      }
      currency {
        id
        code
        denomination
      }
      date_of_supply
      due_date
      paid_at
      user_created_date
      is_draft
      expense_no
      exchange_rate
      expenseItems {
        mandatory_id
        approved
      }
      expense_documents {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
      note
      internal_note
      emailData {
        text
      }
      workspace_bank_account_id
      accountMoves {
        id
        amount
        amount_in_move_currency
        exchange_rate
        bank_account_move_id
        bankAccountMove {
          ...AccountMove
        }
      }
      projectTimeBilling {
        id
        is_locked
      }
      modelLock {
        ...ModelLock
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${DocumentExportFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGetExpensesQuery__
 *
 * To run a query within a React component, call `useGetExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetExpensesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExpensesQuery, GetExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, options);
      }
export function useGetExpensesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpensesQuery, GetExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, options);
        }
export function useGetExpensesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExpensesQuery, GetExpensesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, options);
        }
export type GetExpensesQueryHookResult = ReturnType<typeof useGetExpensesQuery>;
export type GetExpensesLazyQueryHookResult = ReturnType<typeof useGetExpensesLazyQuery>;
export type GetExpensesSuspenseQueryHookResult = ReturnType<typeof useGetExpensesSuspenseQuery>;
export type GetExpensesQueryResult = ApolloReactCommon.QueryResult<GetExpensesQuery, GetExpensesQueryVariables>;
export const ExpensesTableSummaryDocument = gql`
    query ExpensesTableSummary($filters: ExpenseQueryArgs) {
  expensesSummary(filters: $filters) {
    expenseIds
    expenses
    total_amount
    total_vat
    total_amount_with_vat
    payments_due
    payments_due_vat
    payments_due_without_vat
    overdue_by_less_than_30_days
    overdue_by_less_than_30_days_vat
    overdue_by_less_than_30_days_without_vat
    overdue_by_31_to_90_days
    overdue_by_31_to_90_days_vat
    overdue_by_31_to_90_days_without_vat
    overdue_by_91_to_365_days
    overdue_by_91_to_365_days_vat
    overdue_by_91_to_365_days_without_vat
    overdue_by_more_than_365_days
    overdue_by_more_than_365_days_vat
    overdue_by_more_than_365_days_without_vat
  }
}
    `;

/**
 * __useExpensesTableSummaryQuery__
 *
 * To run a query within a React component, call `useExpensesTableSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesTableSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesTableSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExpensesTableSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>(ExpensesTableSummaryDocument, options);
      }
export function useExpensesTableSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>(ExpensesTableSummaryDocument, options);
        }
export function useExpensesTableSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>(ExpensesTableSummaryDocument, options);
        }
export type ExpensesTableSummaryQueryHookResult = ReturnType<typeof useExpensesTableSummaryQuery>;
export type ExpensesTableSummaryLazyQueryHookResult = ReturnType<typeof useExpensesTableSummaryLazyQuery>;
export type ExpensesTableSummarySuspenseQueryHookResult = ReturnType<typeof useExpensesTableSummarySuspenseQuery>;
export type ExpensesTableSummaryQueryResult = ApolloReactCommon.QueryResult<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>;
export const ExpensesTableSelectedSummaryDocument = gql`
    query ExpensesTableSelectedSummary($filters: ExpenseQueryArgs) {
  expensesSummary(filters: $filters) {
    total_amount
    total_amount_with_vat
  }
}
    `;

/**
 * __useExpensesTableSelectedSummaryQuery__
 *
 * To run a query within a React component, call `useExpensesTableSelectedSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesTableSelectedSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesTableSelectedSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExpensesTableSelectedSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>(ExpensesTableSelectedSummaryDocument, options);
      }
export function useExpensesTableSelectedSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>(ExpensesTableSelectedSummaryDocument, options);
        }
export function useExpensesTableSelectedSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>(ExpensesTableSelectedSummaryDocument, options);
        }
export type ExpensesTableSelectedSummaryQueryHookResult = ReturnType<typeof useExpensesTableSelectedSummaryQuery>;
export type ExpensesTableSelectedSummaryLazyQueryHookResult = ReturnType<typeof useExpensesTableSelectedSummaryLazyQuery>;
export type ExpensesTableSelectedSummarySuspenseQueryHookResult = ReturnType<typeof useExpensesTableSelectedSummarySuspenseQuery>;
export type ExpensesTableSelectedSummaryQueryResult = ApolloReactCommon.QueryResult<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>;
export const GetExpenseTimeBillingsDocument = gql`
    query GetExpenseTimeBillings($id: ID!) {
  expense(id: $id) {
    id
    expenseItems {
      id
      timeBillings {
        id
        is_locked
      }
    }
  }
}
    `;

/**
 * __useGetExpenseTimeBillingsQuery__
 *
 * To run a query within a React component, call `useGetExpenseTimeBillingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseTimeBillingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseTimeBillingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExpenseTimeBillingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables> & ({ variables: GetExpenseTimeBillingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>(GetExpenseTimeBillingsDocument, options);
      }
export function useGetExpenseTimeBillingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>(GetExpenseTimeBillingsDocument, options);
        }
export function useGetExpenseTimeBillingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>(GetExpenseTimeBillingsDocument, options);
        }
export type GetExpenseTimeBillingsQueryHookResult = ReturnType<typeof useGetExpenseTimeBillingsQuery>;
export type GetExpenseTimeBillingsLazyQueryHookResult = ReturnType<typeof useGetExpenseTimeBillingsLazyQuery>;
export type GetExpenseTimeBillingsSuspenseQueryHookResult = ReturnType<typeof useGetExpenseTimeBillingsSuspenseQuery>;
export type GetExpenseTimeBillingsQueryResult = ApolloReactCommon.QueryResult<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>;
export const ExportExpensesSummaryDocument = gql`
    query ExportExpensesSummary($ids: [ID!]!) {
  expenseSummaryExportBulk(id: $ids)
}
    `;

/**
 * __useExportExpensesSummaryQuery__
 *
 * To run a query within a React component, call `useExportExpensesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExpensesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExpensesSummaryQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExportExpensesSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables> & ({ variables: ExportExpensesSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>(ExportExpensesSummaryDocument, options);
      }
export function useExportExpensesSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>(ExportExpensesSummaryDocument, options);
        }
export function useExportExpensesSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>(ExportExpensesSummaryDocument, options);
        }
export type ExportExpensesSummaryQueryHookResult = ReturnType<typeof useExportExpensesSummaryQuery>;
export type ExportExpensesSummaryLazyQueryHookResult = ReturnType<typeof useExportExpensesSummaryLazyQuery>;
export type ExportExpensesSummarySuspenseQueryHookResult = ReturnType<typeof useExportExpensesSummarySuspenseQuery>;
export type ExportExpensesSummaryQueryResult = ApolloReactCommon.QueryResult<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>;
export const GenerateExpensePaymentOrderDocument = gql`
    query GenerateExpensePaymentOrder($ids: [ID!]!, $date: Date!, $type: ExpensePaymentOrderExportType!, $payment_type_id: ID!) {
  generateExpensePaymentOrder(
    expense_ids: $ids
    date: $date
    type: $type
    payment_type_id: $payment_type_id
  ) {
    url
    unprocessable_expense_ids
  }
}
    `;

/**
 * __useGenerateExpensePaymentOrderQuery__
 *
 * To run a query within a React component, call `useGenerateExpensePaymentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateExpensePaymentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateExpensePaymentOrderQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      date: // value for 'date'
 *      type: // value for 'type'
 *      payment_type_id: // value for 'payment_type_id'
 *   },
 * });
 */
export function useGenerateExpensePaymentOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables> & ({ variables: GenerateExpensePaymentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>(GenerateExpensePaymentOrderDocument, options);
      }
export function useGenerateExpensePaymentOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>(GenerateExpensePaymentOrderDocument, options);
        }
export function useGenerateExpensePaymentOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>(GenerateExpensePaymentOrderDocument, options);
        }
export type GenerateExpensePaymentOrderQueryHookResult = ReturnType<typeof useGenerateExpensePaymentOrderQuery>;
export type GenerateExpensePaymentOrderLazyQueryHookResult = ReturnType<typeof useGenerateExpensePaymentOrderLazyQuery>;
export type GenerateExpensePaymentOrderSuspenseQueryHookResult = ReturnType<typeof useGenerateExpensePaymentOrderSuspenseQuery>;
export type GenerateExpensePaymentOrderQueryResult = ApolloReactCommon.QueryResult<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>;
export const ExpenseExportDocument = gql`
    query ExpenseExport($filters: ExpenseQueryArgs, $from: Date, $to: Date) {
  expenseExport(filters: $filters, from: $from, to: $to)
}
    `;

/**
 * __useExpenseExportQuery__
 *
 * To run a query within a React component, call `useExpenseExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExpenseExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseExportQuery, ExpenseExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseExportQuery, ExpenseExportQueryVariables>(ExpenseExportDocument, options);
      }
export function useExpenseExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseExportQuery, ExpenseExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseExportQuery, ExpenseExportQueryVariables>(ExpenseExportDocument, options);
        }
export function useExpenseExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseExportQuery, ExpenseExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseExportQuery, ExpenseExportQueryVariables>(ExpenseExportDocument, options);
        }
export type ExpenseExportQueryHookResult = ReturnType<typeof useExpenseExportQuery>;
export type ExpenseExportLazyQueryHookResult = ReturnType<typeof useExpenseExportLazyQuery>;
export type ExpenseExportSuspenseQueryHookResult = ReturnType<typeof useExpenseExportSuspenseQuery>;
export type ExpenseExportQueryResult = ApolloReactCommon.QueryResult<ExpenseExportQuery, ExpenseExportQueryVariables>;
export const ExpenseXmlExportDocument = gql`
    query ExpenseXMLExport($filters: ExpenseQueryArgs, $from: Date, $to: Date) {
  expenseXMLExport(filters: $filters, from: $from, to: $to)
}
    `;

/**
 * __useExpenseXmlExportQuery__
 *
 * To run a query within a React component, call `useExpenseXmlExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseXmlExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseXmlExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExpenseXmlExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>(ExpenseXmlExportDocument, options);
      }
export function useExpenseXmlExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>(ExpenseXmlExportDocument, options);
        }
export function useExpenseXmlExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>(ExpenseXmlExportDocument, options);
        }
export type ExpenseXmlExportQueryHookResult = ReturnType<typeof useExpenseXmlExportQuery>;
export type ExpenseXmlExportLazyQueryHookResult = ReturnType<typeof useExpenseXmlExportLazyQuery>;
export type ExpenseXmlExportSuspenseQueryHookResult = ReturnType<typeof useExpenseXmlExportSuspenseQuery>;
export type ExpenseXmlExportQueryResult = ApolloReactCommon.QueryResult<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>;
export const ExpenseOmegaExportDocument = gql`
    query ExpenseOmegaExport($ids: [ID!]!) {
  omegaExpenseExport(expense_ids: $ids)
}
    `;

/**
 * __useExpenseOmegaExportQuery__
 *
 * To run a query within a React component, call `useExpenseOmegaExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseOmegaExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseOmegaExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExpenseOmegaExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables> & ({ variables: ExpenseOmegaExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>(ExpenseOmegaExportDocument, options);
      }
export function useExpenseOmegaExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>(ExpenseOmegaExportDocument, options);
        }
export function useExpenseOmegaExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>(ExpenseOmegaExportDocument, options);
        }
export type ExpenseOmegaExportQueryHookResult = ReturnType<typeof useExpenseOmegaExportQuery>;
export type ExpenseOmegaExportLazyQueryHookResult = ReturnType<typeof useExpenseOmegaExportLazyQuery>;
export type ExpenseOmegaExportSuspenseQueryHookResult = ReturnType<typeof useExpenseOmegaExportSuspenseQuery>;
export type ExpenseOmegaExportQueryResult = ApolloReactCommon.QueryResult<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>;
export const ExpenseAbraFlexiSelectedExportDocument = gql`
    query ExpenseAbraFlexiSelectedExport($expense_ids: [ID!]!) {
  expenseAbraFlexiExport(expense_ids: $expense_ids)
}
    `;

/**
 * __useExpenseAbraFlexiSelectedExportQuery__
 *
 * To run a query within a React component, call `useExpenseAbraFlexiSelectedExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseAbraFlexiSelectedExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseAbraFlexiSelectedExportQuery({
 *   variables: {
 *      expense_ids: // value for 'expense_ids'
 *   },
 * });
 */
export function useExpenseAbraFlexiSelectedExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables> & ({ variables: ExpenseAbraFlexiSelectedExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>(ExpenseAbraFlexiSelectedExportDocument, options);
      }
export function useExpenseAbraFlexiSelectedExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>(ExpenseAbraFlexiSelectedExportDocument, options);
        }
export function useExpenseAbraFlexiSelectedExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>(ExpenseAbraFlexiSelectedExportDocument, options);
        }
export type ExpenseAbraFlexiSelectedExportQueryHookResult = ReturnType<typeof useExpenseAbraFlexiSelectedExportQuery>;
export type ExpenseAbraFlexiSelectedExportLazyQueryHookResult = ReturnType<typeof useExpenseAbraFlexiSelectedExportLazyQuery>;
export type ExpenseAbraFlexiSelectedExportSuspenseQueryHookResult = ReturnType<typeof useExpenseAbraFlexiSelectedExportSuspenseQuery>;
export type ExpenseAbraFlexiSelectedExportQueryResult = ApolloReactCommon.QueryResult<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>;
export const ExpensePremierExportDocument = gql`
    query ExpensePremierExport($expense_ids: [ID!]!) {
  expensePremierExport(expense_ids: $expense_ids)
}
    `;

/**
 * __useExpensePremierExportQuery__
 *
 * To run a query within a React component, call `useExpensePremierExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensePremierExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensePremierExportQuery({
 *   variables: {
 *      expense_ids: // value for 'expense_ids'
 *   },
 * });
 */
export function useExpensePremierExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpensePremierExportQuery, ExpensePremierExportQueryVariables> & ({ variables: ExpensePremierExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>(ExpensePremierExportDocument, options);
      }
export function useExpensePremierExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>(ExpensePremierExportDocument, options);
        }
export function useExpensePremierExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>(ExpensePremierExportDocument, options);
        }
export type ExpensePremierExportQueryHookResult = ReturnType<typeof useExpensePremierExportQuery>;
export type ExpensePremierExportLazyQueryHookResult = ReturnType<typeof useExpensePremierExportLazyQuery>;
export type ExpensePremierExportSuspenseQueryHookResult = ReturnType<typeof useExpensePremierExportSuspenseQuery>;
export type ExpensePremierExportQueryResult = ApolloReactCommon.QueryResult<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>;
export const ExpenseFilterOptionsDocument = gql`
    query ExpenseFilterOptions {
  projectsSimpleMap {
    id
    code
    title
  }
  userSimpleMap {
    id
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  paymentTypes {
    id
    name
    system_name
  }
}
    `;

/**
 * __useExpenseFilterOptionsQuery__
 *
 * To run a query within a React component, call `useExpenseFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>(ExpenseFilterOptionsDocument, options);
      }
export function useExpenseFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>(ExpenseFilterOptionsDocument, options);
        }
export function useExpenseFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>(ExpenseFilterOptionsDocument, options);
        }
export type ExpenseFilterOptionsQueryHookResult = ReturnType<typeof useExpenseFilterOptionsQuery>;
export type ExpenseFilterOptionsLazyQueryHookResult = ReturnType<typeof useExpenseFilterOptionsLazyQuery>;
export type ExpenseFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useExpenseFilterOptionsSuspenseQuery>;
export type ExpenseFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>;
export const PohodaExpenseExportDocument = gql`
    query PohodaExpenseExport($expense_ids: [ID!]!) {
  pohodaExpenseExport(expense_ids: $expense_ids)
}
    `;

/**
 * __usePohodaExpenseExportQuery__
 *
 * To run a query within a React component, call `usePohodaExpenseExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePohodaExpenseExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePohodaExpenseExportQuery({
 *   variables: {
 *      expense_ids: // value for 'expense_ids'
 *   },
 * });
 */
export function usePohodaExpenseExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables> & ({ variables: PohodaExpenseExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>(PohodaExpenseExportDocument, options);
      }
export function usePohodaExpenseExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>(PohodaExpenseExportDocument, options);
        }
export function usePohodaExpenseExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>(PohodaExpenseExportDocument, options);
        }
export type PohodaExpenseExportQueryHookResult = ReturnType<typeof usePohodaExpenseExportQuery>;
export type PohodaExpenseExportLazyQueryHookResult = ReturnType<typeof usePohodaExpenseExportLazyQuery>;
export type PohodaExpenseExportSuspenseQueryHookResult = ReturnType<typeof usePohodaExpenseExportSuspenseQuery>;
export type PohodaExpenseExportQueryResult = ApolloReactCommon.QueryResult<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>;
export const ExpenseAttachmentsExportBulkDocument = gql`
    query ExpenseAttachmentsExportBulk($selectedIds: [ID!]!) {
  ExpenseAttachmentsExport(expense_ids: $selectedIds)
}
    `;

/**
 * __useExpenseAttachmentsExportBulkQuery__
 *
 * To run a query within a React component, call `useExpenseAttachmentsExportBulkQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseAttachmentsExportBulkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseAttachmentsExportBulkQuery({
 *   variables: {
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useExpenseAttachmentsExportBulkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables> & ({ variables: ExpenseAttachmentsExportBulkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>(ExpenseAttachmentsExportBulkDocument, options);
      }
export function useExpenseAttachmentsExportBulkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>(ExpenseAttachmentsExportBulkDocument, options);
        }
export function useExpenseAttachmentsExportBulkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>(ExpenseAttachmentsExportBulkDocument, options);
        }
export type ExpenseAttachmentsExportBulkQueryHookResult = ReturnType<typeof useExpenseAttachmentsExportBulkQuery>;
export type ExpenseAttachmentsExportBulkLazyQueryHookResult = ReturnType<typeof useExpenseAttachmentsExportBulkLazyQuery>;
export type ExpenseAttachmentsExportBulkSuspenseQueryHookResult = ReturnType<typeof useExpenseAttachmentsExportBulkSuspenseQuery>;
export type ExpenseAttachmentsExportBulkQueryResult = ApolloReactCommon.QueryResult<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>;
export const VarioExpenseExportDocument = gql`
    query VarioExpenseExport($expense_ids: [ID!]!) {
  varioExpenseExport(expense_ids: $expense_ids)
}
    `;

/**
 * __useVarioExpenseExportQuery__
 *
 * To run a query within a React component, call `useVarioExpenseExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVarioExpenseExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVarioExpenseExportQuery({
 *   variables: {
 *      expense_ids: // value for 'expense_ids'
 *   },
 * });
 */
export function useVarioExpenseExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VarioExpenseExportQuery, VarioExpenseExportQueryVariables> & ({ variables: VarioExpenseExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>(VarioExpenseExportDocument, options);
      }
export function useVarioExpenseExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>(VarioExpenseExportDocument, options);
        }
export function useVarioExpenseExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>(VarioExpenseExportDocument, options);
        }
export type VarioExpenseExportQueryHookResult = ReturnType<typeof useVarioExpenseExportQuery>;
export type VarioExpenseExportLazyQueryHookResult = ReturnType<typeof useVarioExpenseExportLazyQuery>;
export type VarioExpenseExportSuspenseQueryHookResult = ReturnType<typeof useVarioExpenseExportSuspenseQuery>;
export type VarioExpenseExportQueryResult = ApolloReactCommon.QueryResult<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>;
export const TransakcioExpenseExportDocument = gql`
    query TransakcioExpenseExport($expense_ids: [ID!]!) {
  transakcioExpenseExport(expense_ids: $expense_ids)
}
    `;

/**
 * __useTransakcioExpenseExportQuery__
 *
 * To run a query within a React component, call `useTransakcioExpenseExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransakcioExpenseExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransakcioExpenseExportQuery({
 *   variables: {
 *      expense_ids: // value for 'expense_ids'
 *   },
 * });
 */
export function useTransakcioExpenseExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables> & ({ variables: TransakcioExpenseExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>(TransakcioExpenseExportDocument, options);
      }
export function useTransakcioExpenseExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>(TransakcioExpenseExportDocument, options);
        }
export function useTransakcioExpenseExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>(TransakcioExpenseExportDocument, options);
        }
export type TransakcioExpenseExportQueryHookResult = ReturnType<typeof useTransakcioExpenseExportQuery>;
export type TransakcioExpenseExportLazyQueryHookResult = ReturnType<typeof useTransakcioExpenseExportLazyQuery>;
export type TransakcioExpenseExportSuspenseQueryHookResult = ReturnType<typeof useTransakcioExpenseExportSuspenseQuery>;
export type TransakcioExpenseExportQueryResult = ApolloReactCommon.QueryResult<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>;
export const IsDateBeforeLastPlanningUpdateDocument = gql`
    mutation IsDateBeforeLastPlanningUpdate($date: DateTime) {
  isDateBeforeLastPlanningUpdate(date: $date)
}
    `;
export type IsDateBeforeLastPlanningUpdateMutationFn = ApolloReactCommon.MutationFunction<IsDateBeforeLastPlanningUpdateMutation, IsDateBeforeLastPlanningUpdateMutationVariables>;

/**
 * __useIsDateBeforeLastPlanningUpdateMutation__
 *
 * To run a mutation, you first call `useIsDateBeforeLastPlanningUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsDateBeforeLastPlanningUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isDateBeforeLastPlanningUpdateMutation, { data, loading, error }] = useIsDateBeforeLastPlanningUpdateMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useIsDateBeforeLastPlanningUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IsDateBeforeLastPlanningUpdateMutation, IsDateBeforeLastPlanningUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IsDateBeforeLastPlanningUpdateMutation, IsDateBeforeLastPlanningUpdateMutationVariables>(IsDateBeforeLastPlanningUpdateDocument, options);
      }
export type IsDateBeforeLastPlanningUpdateMutationHookResult = ReturnType<typeof useIsDateBeforeLastPlanningUpdateMutation>;
export type IsDateBeforeLastPlanningUpdateMutationResult = ApolloReactCommon.MutationResult<IsDateBeforeLastPlanningUpdateMutation>;
export type IsDateBeforeLastPlanningUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<IsDateBeforeLastPlanningUpdateMutation, IsDateBeforeLastPlanningUpdateMutationVariables>;
export const StopTimerForCapacityAllocationItemDocument = gql`
    mutation StopTimerForCapacityAllocationItem($input: stopTimerForCapacityAllocationItemInput!) {
  stopTimerForCapacityAllocationItem(input: $input) {
    id
  }
}
    `;
export type StopTimerForCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<StopTimerForCapacityAllocationItemMutation, StopTimerForCapacityAllocationItemMutationVariables>;

/**
 * __useStopTimerForCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useStopTimerForCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTimerForCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTimerForCapacityAllocationItemMutation, { data, loading, error }] = useStopTimerForCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopTimerForCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopTimerForCapacityAllocationItemMutation, StopTimerForCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopTimerForCapacityAllocationItemMutation, StopTimerForCapacityAllocationItemMutationVariables>(StopTimerForCapacityAllocationItemDocument, options);
      }
export type StopTimerForCapacityAllocationItemMutationHookResult = ReturnType<typeof useStopTimerForCapacityAllocationItemMutation>;
export type StopTimerForCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<StopTimerForCapacityAllocationItemMutation>;
export type StopTimerForCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<StopTimerForCapacityAllocationItemMutation, StopTimerForCapacityAllocationItemMutationVariables>;
export const UpdateAllocationItemDurationDocument = gql`
    mutation UpdateAllocationItemDuration($id: ID!, $total_time: BigInt!, $to_time: Time, $user_id: ID!) {
  updateCapacityAllocationItem(
    input: {id: $id, total_time: $total_time, to_time: $to_time, user_id: $user_id}
  ) {
    id
    total_time
    to_time
  }
}
    `;
export type UpdateAllocationItemDurationMutationFn = ApolloReactCommon.MutationFunction<UpdateAllocationItemDurationMutation, UpdateAllocationItemDurationMutationVariables>;

/**
 * __useUpdateAllocationItemDurationMutation__
 *
 * To run a mutation, you first call `useUpdateAllocationItemDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocationItemDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocationItemDurationMutation, { data, loading, error }] = useUpdateAllocationItemDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      total_time: // value for 'total_time'
 *      to_time: // value for 'to_time'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUpdateAllocationItemDurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAllocationItemDurationMutation, UpdateAllocationItemDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAllocationItemDurationMutation, UpdateAllocationItemDurationMutationVariables>(UpdateAllocationItemDurationDocument, options);
      }
export type UpdateAllocationItemDurationMutationHookResult = ReturnType<typeof useUpdateAllocationItemDurationMutation>;
export type UpdateAllocationItemDurationMutationResult = ApolloReactCommon.MutationResult<UpdateAllocationItemDurationMutation>;
export type UpdateAllocationItemDurationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAllocationItemDurationMutation, UpdateAllocationItemDurationMutationVariables>;
export const UpdateAllocationDurationDocument = gql`
    mutation UpdateAllocationDuration($id: ID!, $total_time: BigInt!, $to_time: Time, $create_task_positions: Boolean!) {
  updateCapacityAllocation(
    input: {id: $id, total_time: $total_time, total_time_per_day: $total_time, to_time: $to_time, create_task_positions: $create_task_positions}
  ) {
    id
    total_time
    to_time
  }
}
    `;
export type UpdateAllocationDurationMutationFn = ApolloReactCommon.MutationFunction<UpdateAllocationDurationMutation, UpdateAllocationDurationMutationVariables>;

/**
 * __useUpdateAllocationDurationMutation__
 *
 * To run a mutation, you first call `useUpdateAllocationDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocationDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocationDurationMutation, { data, loading, error }] = useUpdateAllocationDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      total_time: // value for 'total_time'
 *      to_time: // value for 'to_time'
 *      create_task_positions: // value for 'create_task_positions'
 *   },
 * });
 */
export function useUpdateAllocationDurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAllocationDurationMutation, UpdateAllocationDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAllocationDurationMutation, UpdateAllocationDurationMutationVariables>(UpdateAllocationDurationDocument, options);
      }
export type UpdateAllocationDurationMutationHookResult = ReturnType<typeof useUpdateAllocationDurationMutation>;
export type UpdateAllocationDurationMutationResult = ApolloReactCommon.MutationResult<UpdateAllocationDurationMutation>;
export type UpdateAllocationDurationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAllocationDurationMutation, UpdateAllocationDurationMutationVariables>;
export const CapacityAllocationItemTimeTrackingItemsDocument = gql`
    query CapacityAllocationItemTimeTrackingItems($id: ID!, $user_id: ID!, $task_id: ID!) {
  capacityAllocationItemTimeTrackingItems(id: $id, user_id: $user_id) {
    id
    tracked_time
    note
    is_locked
    billable
    timeTrackingWorkType {
      id
      title
    }
  }
  task(id: $task_id) {
    billable
    ourWorkBudgetItem {
      project {
        availableTimeTrackingWorkTypes {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useCapacityAllocationItemTimeTrackingItemsQuery__
 *
 * To run a query within a React component, call `useCapacityAllocationItemTimeTrackingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityAllocationItemTimeTrackingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityAllocationItemTimeTrackingItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      user_id: // value for 'user_id'
 *      task_id: // value for 'task_id'
 *   },
 * });
 */
export function useCapacityAllocationItemTimeTrackingItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables> & ({ variables: CapacityAllocationItemTimeTrackingItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>(CapacityAllocationItemTimeTrackingItemsDocument, options);
      }
export function useCapacityAllocationItemTimeTrackingItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>(CapacityAllocationItemTimeTrackingItemsDocument, options);
        }
export function useCapacityAllocationItemTimeTrackingItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>(CapacityAllocationItemTimeTrackingItemsDocument, options);
        }
export type CapacityAllocationItemTimeTrackingItemsQueryHookResult = ReturnType<typeof useCapacityAllocationItemTimeTrackingItemsQuery>;
export type CapacityAllocationItemTimeTrackingItemsLazyQueryHookResult = ReturnType<typeof useCapacityAllocationItemTimeTrackingItemsLazyQuery>;
export type CapacityAllocationItemTimeTrackingItemsSuspenseQueryHookResult = ReturnType<typeof useCapacityAllocationItemTimeTrackingItemsSuspenseQuery>;
export type CapacityAllocationItemTimeTrackingItemsQueryResult = ApolloReactCommon.QueryResult<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>;
export const ContractsSimpleDocument = gql`
    query ContractsSimple($contractorId: ID) {
  contractsSimpleMap(contractor_id: $contractorId) {
    id
    title
  }
}
    `;

/**
 * __useContractsSimpleQuery__
 *
 * To run a query within a React component, call `useContractsSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsSimpleQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useContractsSimpleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContractsSimpleQuery, ContractsSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractsSimpleQuery, ContractsSimpleQueryVariables>(ContractsSimpleDocument, options);
      }
export function useContractsSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractsSimpleQuery, ContractsSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractsSimpleQuery, ContractsSimpleQueryVariables>(ContractsSimpleDocument, options);
        }
export function useContractsSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractsSimpleQuery, ContractsSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractsSimpleQuery, ContractsSimpleQueryVariables>(ContractsSimpleDocument, options);
        }
export type ContractsSimpleQueryHookResult = ReturnType<typeof useContractsSimpleQuery>;
export type ContractsSimpleLazyQueryHookResult = ReturnType<typeof useContractsSimpleLazyQuery>;
export type ContractsSimpleSuspenseQueryHookResult = ReturnType<typeof useContractsSimpleSuspenseQuery>;
export type ContractsSimpleQueryResult = ApolloReactCommon.QueryResult<ContractsSimpleQuery, ContractsSimpleQueryVariables>;
export const ConvertAmountDocument = gql`
    query ConvertAmount($clientId: ID, $projectId: ID, $workspaceCompanyId: ID, $amount: BigInt!, $currencyId: ID!, $exchangeRate: BigInt, $date: Date!, $type: ExchangeRateSource!) {
  convertAmountToWorkspaceCurrencyUsingExchangeRate(
    client_id: $clientId
    project_id: $projectId
    workspace_company_id: $workspaceCompanyId
    amount_in_currency: $amount
    currency_id: $currencyId
    exchange_rate: $exchangeRate
    date: $date
    type: $type
  ) {
    amount
  }
}
    `;

/**
 * __useConvertAmountQuery__
 *
 * To run a query within a React component, call `useConvertAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertAmountQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      projectId: // value for 'projectId'
 *      workspaceCompanyId: // value for 'workspaceCompanyId'
 *      amount: // value for 'amount'
 *      currencyId: // value for 'currencyId'
 *      exchangeRate: // value for 'exchangeRate'
 *      date: // value for 'date'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useConvertAmountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConvertAmountQuery, ConvertAmountQueryVariables> & ({ variables: ConvertAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConvertAmountQuery, ConvertAmountQueryVariables>(ConvertAmountDocument, options);
      }
export function useConvertAmountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConvertAmountQuery, ConvertAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConvertAmountQuery, ConvertAmountQueryVariables>(ConvertAmountDocument, options);
        }
export function useConvertAmountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConvertAmountQuery, ConvertAmountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConvertAmountQuery, ConvertAmountQueryVariables>(ConvertAmountDocument, options);
        }
export type ConvertAmountQueryHookResult = ReturnType<typeof useConvertAmountQuery>;
export type ConvertAmountLazyQueryHookResult = ReturnType<typeof useConvertAmountLazyQuery>;
export type ConvertAmountSuspenseQueryHookResult = ReturnType<typeof useConvertAmountSuspenseQuery>;
export type ConvertAmountQueryResult = ApolloReactCommon.QueryResult<ConvertAmountQuery, ConvertAmountQueryVariables>;
export const GetExchangeRateDocument = gql`
    query GetExchangeRate($clientId: ID, $projectId: ID, $workspaceCompanyId: ID, $currencyId: ID!, $exchangeRate: BigInt, $date: Date!, $type: ExchangeRateSource!) {
  convertAmountToWorkspaceCurrencyUsingExchangeRate(
    client_id: $clientId
    project_id: $projectId
    workspace_company_id: $workspaceCompanyId
    amount_in_currency: 1000
    currency_id: $currencyId
    exchange_rate: $exchangeRate
    date: $date
    type: $type
  ) {
    exchange_rate
  }
}
    `;

/**
 * __useGetExchangeRateQuery__
 *
 * To run a query within a React component, call `useGetExchangeRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeRateQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      projectId: // value for 'projectId'
 *      workspaceCompanyId: // value for 'workspaceCompanyId'
 *      currencyId: // value for 'currencyId'
 *      exchangeRate: // value for 'exchangeRate'
 *      date: // value for 'date'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetExchangeRateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables> & ({ variables: GetExchangeRateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>(GetExchangeRateDocument, options);
      }
export function useGetExchangeRateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>(GetExchangeRateDocument, options);
        }
export function useGetExchangeRateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>(GetExchangeRateDocument, options);
        }
export type GetExchangeRateQueryHookResult = ReturnType<typeof useGetExchangeRateQuery>;
export type GetExchangeRateLazyQueryHookResult = ReturnType<typeof useGetExchangeRateLazyQuery>;
export type GetExchangeRateSuspenseQueryHookResult = ReturnType<typeof useGetExchangeRateSuspenseQuery>;
export type GetExchangeRateQueryResult = ApolloReactCommon.QueryResult<GetExchangeRateQuery, GetExchangeRateQueryVariables>;
export const GetDuplicateExpensesIDsDocument = gql`
    query GetDuplicateExpensesIDs($contractorId: ID!, $variableSymbol: String!, $excludeExpenseId: ID, $documentNumber: String!) {
  getDuplicateExpensesIDs(
    contractor_id: $contractorId
    variable_symbol: $variableSymbol
    exclude_expense_id: $excludeExpenseId
    document_number: $documentNumber
  )
}
    `;

/**
 * __useGetDuplicateExpensesIDsQuery__
 *
 * To run a query within a React component, call `useGetDuplicateExpensesIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateExpensesIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateExpensesIDsQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      variableSymbol: // value for 'variableSymbol'
 *      excludeExpenseId: // value for 'excludeExpenseId'
 *      documentNumber: // value for 'documentNumber'
 *   },
 * });
 */
export function useGetDuplicateExpensesIDsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables> & ({ variables: GetDuplicateExpensesIDsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>(GetDuplicateExpensesIDsDocument, options);
      }
export function useGetDuplicateExpensesIDsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>(GetDuplicateExpensesIDsDocument, options);
        }
export function useGetDuplicateExpensesIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>(GetDuplicateExpensesIDsDocument, options);
        }
export type GetDuplicateExpensesIDsQueryHookResult = ReturnType<typeof useGetDuplicateExpensesIDsQuery>;
export type GetDuplicateExpensesIDsLazyQueryHookResult = ReturnType<typeof useGetDuplicateExpensesIDsLazyQuery>;
export type GetDuplicateExpensesIDsSuspenseQueryHookResult = ReturnType<typeof useGetDuplicateExpensesIDsSuspenseQuery>;
export type GetDuplicateExpensesIDsQueryResult = ApolloReactCommon.QueryResult<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>;
export const LatestExpenseInternalNumberDocument = gql`
    query LatestExpenseInternalNumber {
  getLatestExpenseInternalNumberPerType {
    type
    internal_number
  }
}
    `;

/**
 * __useLatestExpenseInternalNumberQuery__
 *
 * To run a query within a React component, call `useLatestExpenseInternalNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestExpenseInternalNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestExpenseInternalNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestExpenseInternalNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>(LatestExpenseInternalNumberDocument, options);
      }
export function useLatestExpenseInternalNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>(LatestExpenseInternalNumberDocument, options);
        }
export function useLatestExpenseInternalNumberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>(LatestExpenseInternalNumberDocument, options);
        }
export type LatestExpenseInternalNumberQueryHookResult = ReturnType<typeof useLatestExpenseInternalNumberQuery>;
export type LatestExpenseInternalNumberLazyQueryHookResult = ReturnType<typeof useLatestExpenseInternalNumberLazyQuery>;
export type LatestExpenseInternalNumberSuspenseQueryHookResult = ReturnType<typeof useLatestExpenseInternalNumberSuspenseQuery>;
export type LatestExpenseInternalNumberQueryResult = ApolloReactCommon.QueryResult<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>;
export const PlanningDailyViewPeopleDocument = gql`
    query PlanningDailyViewPeople($dailyViewFilters: PlanningDailyViewFilters!) {
  planningDailyViewPeople(filters: $dailyViewFilters) {
    last_updated_at
    data {
      user {
        ...AllocationsColumnHeader_User
      }
      items {
        capacity
        workStatus
        date
        holiday
        total_tracked_for_date
        items {
          id
          completed
          type
          total_time
          from_time
          to_time
          date
          note
          global
          teams {
            team {
              id
            }
          }
          createdBy {
            id
            full_name
            profile {
              hex_color
            }
          }
          time_tracking_work_type_id
          userStats {
            tracked_time_for_item
            has_running_timer
          }
          stats {
            ...CapacityAllocationItemStats
          }
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${AllocationsColumnHeader_UserFragmentDoc}
${CapacityAllocationItemStatsFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __usePlanningDailyViewPeopleQuery__
 *
 * To run a query within a React component, call `usePlanningDailyViewPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningDailyViewPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningDailyViewPeopleQuery({
 *   variables: {
 *      dailyViewFilters: // value for 'dailyViewFilters'
 *   },
 * });
 */
export function usePlanningDailyViewPeopleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables> & ({ variables: PlanningDailyViewPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>(PlanningDailyViewPeopleDocument, options);
      }
export function usePlanningDailyViewPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>(PlanningDailyViewPeopleDocument, options);
        }
export function usePlanningDailyViewPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>(PlanningDailyViewPeopleDocument, options);
        }
export type PlanningDailyViewPeopleQueryHookResult = ReturnType<typeof usePlanningDailyViewPeopleQuery>;
export type PlanningDailyViewPeopleLazyQueryHookResult = ReturnType<typeof usePlanningDailyViewPeopleLazyQuery>;
export type PlanningDailyViewPeopleSuspenseQueryHookResult = ReturnType<typeof usePlanningDailyViewPeopleSuspenseQuery>;
export type PlanningDailyViewPeopleQueryResult = ApolloReactCommon.QueryResult<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>;
export const ProjectsSimpleDocument = gql`
    query ProjectsSimple($clientId: ID, $brandId: ID, $orIdIn: [ID!], $withProBono: Boolean, $withArchived: Boolean, $my_projects: Boolean) {
  projectsSimpleMap(
    client_id: $clientId
    brand_id: $brandId
    orIdIn: $orIdIn
    withProBono: $withProBono
    withArchived: $withArchived
    my_projects: $my_projects
  ) {
    id
    code
    team_id
    title
    brand_id
    billable
    type
    project_manager_id
  }
}
    `;

/**
 * __useProjectsSimpleQuery__
 *
 * To run a query within a React component, call `useProjectsSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsSimpleQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      brandId: // value for 'brandId'
 *      orIdIn: // value for 'orIdIn'
 *      withProBono: // value for 'withProBono'
 *      withArchived: // value for 'withArchived'
 *      my_projects: // value for 'my_projects'
 *   },
 * });
 */
export function useProjectsSimpleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>(ProjectsSimpleDocument, options);
      }
export function useProjectsSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>(ProjectsSimpleDocument, options);
        }
export function useProjectsSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>(ProjectsSimpleDocument, options);
        }
export type ProjectsSimpleQueryHookResult = ReturnType<typeof useProjectsSimpleQuery>;
export type ProjectsSimpleLazyQueryHookResult = ReturnType<typeof useProjectsSimpleLazyQuery>;
export type ProjectsSimpleSuspenseQueryHookResult = ReturnType<typeof useProjectsSimpleSuspenseQuery>;
export type ProjectsSimpleQueryResult = ApolloReactCommon.QueryResult<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>;
export const TrackedForDayDocument = gql`
    query TrackedForDay($user_id: ID!, $date: Date!) {
  timeTrackingItems(user_id: $user_id, from: $date, to: $date) {
    ...TimeTrackingEntry
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

/**
 * __useTrackedForDayQuery__
 *
 * To run a query within a React component, call `useTrackedForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackedForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackedForDayQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTrackedForDayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrackedForDayQuery, TrackedForDayQueryVariables> & ({ variables: TrackedForDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrackedForDayQuery, TrackedForDayQueryVariables>(TrackedForDayDocument, options);
      }
export function useTrackedForDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrackedForDayQuery, TrackedForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrackedForDayQuery, TrackedForDayQueryVariables>(TrackedForDayDocument, options);
        }
export function useTrackedForDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrackedForDayQuery, TrackedForDayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrackedForDayQuery, TrackedForDayQueryVariables>(TrackedForDayDocument, options);
        }
export type TrackedForDayQueryHookResult = ReturnType<typeof useTrackedForDayQuery>;
export type TrackedForDayLazyQueryHookResult = ReturnType<typeof useTrackedForDayLazyQuery>;
export type TrackedForDaySuspenseQueryHookResult = ReturnType<typeof useTrackedForDaySuspenseQuery>;
export type TrackedForDayQueryResult = ApolloReactCommon.QueryResult<TrackedForDayQuery, TrackedForDayQueryVariables>;
export const UtilizationReportExportDocument = gql`
    query UtilizationReportExport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportExport(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  )
}
    `;

/**
 * __useUtilizationReportExportQuery__
 *
 * To run a query within a React component, call `useUtilizationReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilizationReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilizationReportExportQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUtilizationReportExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UtilizationReportExportQuery, UtilizationReportExportQueryVariables> & ({ variables: UtilizationReportExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>(UtilizationReportExportDocument, options);
      }
export function useUtilizationReportExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>(UtilizationReportExportDocument, options);
        }
export function useUtilizationReportExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>(UtilizationReportExportDocument, options);
        }
export type UtilizationReportExportQueryHookResult = ReturnType<typeof useUtilizationReportExportQuery>;
export type UtilizationReportExportLazyQueryHookResult = ReturnType<typeof useUtilizationReportExportLazyQuery>;
export type UtilizationReportExportSuspenseQueryHookResult = ReturnType<typeof useUtilizationReportExportSuspenseQuery>;
export type UtilizationReportExportQueryResult = ApolloReactCommon.QueryResult<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>;
export const UtilizationReportDocument = gql`
    query UtilizationReport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!]) {
  utilizationReport(
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
  ) {
    data {
      user {
        id
        full_name
        profile {
          hex_color
          utilization_range_from
          utilization_range_to
          defaultWorktype {
            title
          }
        }
        team {
          name
        }
        image {
          urls {
            thumbnail
          }
        }
      }
      report {
        total_time
        available_time
        remaining_time
        time_off
        overtime
        combined_time
        combined_time_billable
        budgeted_time
        budgeted_time_billable
        allocated_time
        allocated_time_billable
        tracked_time
        tracked_time_billable
        utilization_percentage
        utilization_percentage_billable
        combined_amount_billable
        budgeted_amount_billable
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useUtilizationReportQuery__
 *
 * To run a query within a React component, call `useUtilizationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilizationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilizationReportQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUtilizationReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UtilizationReportQuery, UtilizationReportQueryVariables> & ({ variables: UtilizationReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UtilizationReportQuery, UtilizationReportQueryVariables>(UtilizationReportDocument, options);
      }
export function useUtilizationReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UtilizationReportQuery, UtilizationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UtilizationReportQuery, UtilizationReportQueryVariables>(UtilizationReportDocument, options);
        }
export function useUtilizationReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UtilizationReportQuery, UtilizationReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UtilizationReportQuery, UtilizationReportQueryVariables>(UtilizationReportDocument, options);
        }
export type UtilizationReportQueryHookResult = ReturnType<typeof useUtilizationReportQuery>;
export type UtilizationReportLazyQueryHookResult = ReturnType<typeof useUtilizationReportLazyQuery>;
export type UtilizationReportSuspenseQueryHookResult = ReturnType<typeof useUtilizationReportSuspenseQuery>;
export type UtilizationReportQueryResult = ApolloReactCommon.QueryResult<UtilizationReportQuery, UtilizationReportQueryVariables>;
export const UtilizationReportFilterOptionsDocument = gql`
    query UtilizationReportFilterOptions {
  teamSimpleMap {
    id
    name
  }
  userSimpleMap {
    id
    full_name
    codename
  }
  timeTrackingWorkTypes {
    id
    title
  }
}
    `;

/**
 * __useUtilizationReportFilterOptionsQuery__
 *
 * To run a query within a React component, call `useUtilizationReportFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilizationReportFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilizationReportFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUtilizationReportFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>(UtilizationReportFilterOptionsDocument, options);
      }
export function useUtilizationReportFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>(UtilizationReportFilterOptionsDocument, options);
        }
export function useUtilizationReportFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>(UtilizationReportFilterOptionsDocument, options);
        }
export type UtilizationReportFilterOptionsQueryHookResult = ReturnType<typeof useUtilizationReportFilterOptionsQuery>;
export type UtilizationReportFilterOptionsLazyQueryHookResult = ReturnType<typeof useUtilizationReportFilterOptionsLazyQuery>;
export type UtilizationReportFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useUtilizationReportFilterOptionsSuspenseQuery>;
export type UtilizationReportFilterOptionsQueryResult = ApolloReactCommon.QueryResult<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>;
export const UtilizationReportGroupedByDocument = gql`
    query UtilizationReportGroupedBy($groupBy: UtilizationReportGroupBy!, $dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!], $groupOrderBy: [UtilizationReportGroupOrderByClause!]) {
  utilizationReportGroups(
    groupBy: $groupBy
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
    groupOrderBy: $groupOrderBy
  ) {
    data {
      group_title
      report {
        total_time
        available_time
        remaining_time
        time_off
        overtime
        combined_time
        combined_time_billable
        budgeted_time
        budgeted_time_billable
        allocated_time
        allocated_time_billable
        tracked_time
        tracked_time_billable
        utilization_percentage
        utilization_percentage_billable
        combined_amount_billable
        budgeted_amount_billable
      }
      items {
        user {
          id
          full_name
          profile {
            hex_color
            utilization_range_from
            utilization_range_to
            defaultWorktype {
              title
            }
          }
          team {
            name
          }
          image {
            urls {
              thumbnail
            }
          }
        }
        report {
          total_time
          available_time
          remaining_time
          time_off
          overtime
          combined_time
          combined_time_billable
          budgeted_time
          budgeted_time_billable
          allocated_time
          allocated_time_billable
          tracked_time
          tracked_time_billable
          utilization_percentage
          utilization_percentage_billable
          combined_amount_billable
          budgeted_amount_billable
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useUtilizationReportGroupedByQuery__
 *
 * To run a query within a React component, call `useUtilizationReportGroupedByQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilizationReportGroupedByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilizationReportGroupedByQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      orderBy: // value for 'orderBy'
 *      groupOrderBy: // value for 'groupOrderBy'
 *   },
 * });
 */
export function useUtilizationReportGroupedByQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables> & ({ variables: UtilizationReportGroupedByQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>(UtilizationReportGroupedByDocument, options);
      }
export function useUtilizationReportGroupedByLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>(UtilizationReportGroupedByDocument, options);
        }
export function useUtilizationReportGroupedBySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>(UtilizationReportGroupedByDocument, options);
        }
export type UtilizationReportGroupedByQueryHookResult = ReturnType<typeof useUtilizationReportGroupedByQuery>;
export type UtilizationReportGroupedByLazyQueryHookResult = ReturnType<typeof useUtilizationReportGroupedByLazyQuery>;
export type UtilizationReportGroupedBySuspenseQueryHookResult = ReturnType<typeof useUtilizationReportGroupedBySuspenseQuery>;
export type UtilizationReportGroupedByQueryResult = ApolloReactCommon.QueryResult<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>;
export const UtilizationReportStatsDocument = gql`
    query UtilizationReportStats($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportSummary(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  ) {
    total_time
    available_time
    remaining_time
    time_off
    overtime
    combined_time
    combined_time_billable
    budgeted_time
    budgeted_time_billable
    allocated_time
    allocated_time_billable
    tracked_time
    tracked_time_billable
    utilization_percentage
    utilization_percentage_billable
  }
}
    `;

/**
 * __useUtilizationReportStatsQuery__
 *
 * To run a query within a React component, call `useUtilizationReportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilizationReportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilizationReportStatsQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUtilizationReportStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables> & ({ variables: UtilizationReportStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>(UtilizationReportStatsDocument, options);
      }
export function useUtilizationReportStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>(UtilizationReportStatsDocument, options);
        }
export function useUtilizationReportStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>(UtilizationReportStatsDocument, options);
        }
export type UtilizationReportStatsQueryHookResult = ReturnType<typeof useUtilizationReportStatsQuery>;
export type UtilizationReportStatsLazyQueryHookResult = ReturnType<typeof useUtilizationReportStatsLazyQuery>;
export type UtilizationReportStatsSuspenseQueryHookResult = ReturnType<typeof useUtilizationReportStatsSuspenseQuery>;
export type UtilizationReportStatsQueryResult = ApolloReactCommon.QueryResult<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>;
export const UtilizationUserReportDataDocument = gql`
    query UtilizationUserReportData($dataSource: UtilizationReportDataSource!, $userId: ID!, $from: Date!, $to: Date!) {
  utilizationUserReport(
    dataSource: $dataSource
    userId: $userId
    from: $from
    to: $to
  ) {
    user {
      id
      full_name
      profile {
        hex_color
        utilization_range_from
        utilization_range_to
        defaultWorktype {
          title
        }
      }
      team {
        name
      }
      image {
        urls {
          thumbnail
        }
      }
    }
    report {
      total_time
      available_time
      remaining_time
      time_off
      overtime
      combined_time
      combined_time_billable
      budgeted_time
      budgeted_time_billable
      allocated_time
      allocated_time_billable
      tracked_time
      tracked_time_billable
      utilization_percentage
      utilization_percentage_billable
    }
  }
  utilizationTaskReport(
    dataSource: $dataSource
    userId: $userId
    from: $from
    to: $to
  ) {
    task {
      id
      name
      status {
        name
        foreground_color
        background_color
      }
      ourWorkBudgetItem {
        title
        project {
          title
          id
          code
        }
      }
    }
    budgeted_time
    budgeted_time_in_range
    remaining_amount
    remaining_time
    remaining_time_in_range
    remaining_time_in_percent
    tracked_amount
    tracked_in_range_amount
    tracked_time
    tracked_time_percent
    tracked_time_in_range
    tracked_time_in_range_percent
    allocated_amount
    allocated_in_range_amount
    allocated_time
    allocated_time_percent
    allocated_time_in_range
    allocated_time_in_range_percent
    over_budget_amount
    over_budget_time
    over_budget_time_in_percent
    total_task_budget_amount
    total_task_budget_in_range
  }
}
    `;

/**
 * __useUtilizationUserReportDataQuery__
 *
 * To run a query within a React component, call `useUtilizationUserReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilizationUserReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilizationUserReportDataQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      userId: // value for 'userId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUtilizationUserReportDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables> & ({ variables: UtilizationUserReportDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>(UtilizationUserReportDataDocument, options);
      }
export function useUtilizationUserReportDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>(UtilizationUserReportDataDocument, options);
        }
export function useUtilizationUserReportDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>(UtilizationUserReportDataDocument, options);
        }
export type UtilizationUserReportDataQueryHookResult = ReturnType<typeof useUtilizationUserReportDataQuery>;
export type UtilizationUserReportDataLazyQueryHookResult = ReturnType<typeof useUtilizationUserReportDataLazyQuery>;
export type UtilizationUserReportDataSuspenseQueryHookResult = ReturnType<typeof useUtilizationUserReportDataSuspenseQuery>;
export type UtilizationUserReportDataQueryResult = ApolloReactCommon.QueryResult<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>;
export const TimeAndMaterialsInvoiceDataDocument = gql`
    query TimeAndMaterialsInvoiceData($project_id: ID!, $groupBy: TimeMaterialsInvoiceDataGroupByEnum!, $from: Date!, $to: Date!, $filters: timeMaterialsQueryArgs, $outgoing_invoice_id: ID) {
  timeMaterialsInvoiceData(
    project_id: $project_id
    groupBy: $groupBy
    from: $from
    to: $to
    filters: $filters
    outgoing_invoice_id: $outgoing_invoice_id
  ) {
    project {
      id
      title
    }
    ourWorkBudgetItems {
      ...TimeMaterialsBudgetItemFragment
    }
    expenseBudgetItems {
      ...TimeMaterialsBudgetItemFragment
    }
  }
}
    ${TimeMaterialsBudgetItemFragmentFragmentDoc}`;

/**
 * __useTimeAndMaterialsInvoiceDataQuery__
 *
 * To run a query within a React component, call `useTimeAndMaterialsInvoiceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeAndMaterialsInvoiceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeAndMaterialsInvoiceDataQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      groupBy: // value for 'groupBy'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filters: // value for 'filters'
 *      outgoing_invoice_id: // value for 'outgoing_invoice_id'
 *   },
 * });
 */
export function useTimeAndMaterialsInvoiceDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables> & ({ variables: TimeAndMaterialsInvoiceDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>(TimeAndMaterialsInvoiceDataDocument, options);
      }
export function useTimeAndMaterialsInvoiceDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>(TimeAndMaterialsInvoiceDataDocument, options);
        }
export function useTimeAndMaterialsInvoiceDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>(TimeAndMaterialsInvoiceDataDocument, options);
        }
export type TimeAndMaterialsInvoiceDataQueryHookResult = ReturnType<typeof useTimeAndMaterialsInvoiceDataQuery>;
export type TimeAndMaterialsInvoiceDataLazyQueryHookResult = ReturnType<typeof useTimeAndMaterialsInvoiceDataLazyQuery>;
export type TimeAndMaterialsInvoiceDataSuspenseQueryHookResult = ReturnType<typeof useTimeAndMaterialsInvoiceDataSuspenseQuery>;
export type TimeAndMaterialsInvoiceDataQueryResult = ApolloReactCommon.QueryResult<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>;
export const TimeAndMaterialsFilterOptionsDocument = gql`
    query TimeAndMaterialsFilterOptions($projectId: [ID!]) {
  userSimpleMap {
    id
    full_name
  }
  ourWorkBudgetItemsSimpleMap(project_id: $projectId) {
    id
    title
    category {
      name
    }
  }
  timeTrackingWorkTypes {
    id
    title
  }
}
    `;

/**
 * __useTimeAndMaterialsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTimeAndMaterialsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeAndMaterialsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeAndMaterialsFilterOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTimeAndMaterialsFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>(TimeAndMaterialsFilterOptionsDocument, options);
      }
export function useTimeAndMaterialsFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>(TimeAndMaterialsFilterOptionsDocument, options);
        }
export function useTimeAndMaterialsFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>(TimeAndMaterialsFilterOptionsDocument, options);
        }
export type TimeAndMaterialsFilterOptionsQueryHookResult = ReturnType<typeof useTimeAndMaterialsFilterOptionsQuery>;
export type TimeAndMaterialsFilterOptionsLazyQueryHookResult = ReturnType<typeof useTimeAndMaterialsFilterOptionsLazyQuery>;
export type TimeAndMaterialsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useTimeAndMaterialsFilterOptionsSuspenseQuery>;
export type TimeAndMaterialsFilterOptionsQueryResult = ApolloReactCommon.QueryResult<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>;
export const CreateOutgoingInvoiceDocument = gql`
    mutation CreateOutgoingInvoice($request_for_invoicing_id: ID!, $invoice_no: String, $invoice_order_sequence_id: ID!, $skip_date_validations: Boolean!) {
  createOutgoingInvoice(
    request_for_invoicing_id: $request_for_invoicing_id
    invoice_no: $invoice_no
    invoice_order_sequence_id: $invoice_order_sequence_id
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;
export type CreateOutgoingInvoiceMutationFn = ApolloReactCommon.MutationFunction<CreateOutgoingInvoiceMutation, CreateOutgoingInvoiceMutationVariables>;

/**
 * __useCreateOutgoingInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateOutgoingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutgoingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutgoingInvoiceMutation, { data, loading, error }] = useCreateOutgoingInvoiceMutation({
 *   variables: {
 *      request_for_invoicing_id: // value for 'request_for_invoicing_id'
 *      invoice_no: // value for 'invoice_no'
 *      invoice_order_sequence_id: // value for 'invoice_order_sequence_id'
 *      skip_date_validations: // value for 'skip_date_validations'
 *   },
 * });
 */
export function useCreateOutgoingInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOutgoingInvoiceMutation, CreateOutgoingInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOutgoingInvoiceMutation, CreateOutgoingInvoiceMutationVariables>(CreateOutgoingInvoiceDocument, options);
      }
export type CreateOutgoingInvoiceMutationHookResult = ReturnType<typeof useCreateOutgoingInvoiceMutation>;
export type CreateOutgoingInvoiceMutationResult = ApolloReactCommon.MutationResult<CreateOutgoingInvoiceMutation>;
export type CreateOutgoingInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOutgoingInvoiceMutation, CreateOutgoingInvoiceMutationVariables>;
export const UpdateOutgoingInvoiceDocument = gql`
    mutation UpdateOutgoingInvoice($input: UpdateOutgoingInvoiceInput!, $skip_date_validations: Boolean!) {
  updateOutgoingInvoice(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;
export type UpdateOutgoingInvoiceMutationFn = ApolloReactCommon.MutationFunction<UpdateOutgoingInvoiceMutation, UpdateOutgoingInvoiceMutationVariables>;

/**
 * __useUpdateOutgoingInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateOutgoingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutgoingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutgoingInvoiceMutation, { data, loading, error }] = useUpdateOutgoingInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      skip_date_validations: // value for 'skip_date_validations'
 *   },
 * });
 */
export function useUpdateOutgoingInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOutgoingInvoiceMutation, UpdateOutgoingInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOutgoingInvoiceMutation, UpdateOutgoingInvoiceMutationVariables>(UpdateOutgoingInvoiceDocument, options);
      }
export type UpdateOutgoingInvoiceMutationHookResult = ReturnType<typeof useUpdateOutgoingInvoiceMutation>;
export type UpdateOutgoingInvoiceMutationResult = ApolloReactCommon.MutationResult<UpdateOutgoingInvoiceMutation>;
export type UpdateOutgoingInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOutgoingInvoiceMutation, UpdateOutgoingInvoiceMutationVariables>;
export const CreateProformaInvoiceDocument = gql`
    mutation CreateProformaInvoice($request_for_invoicing_id: ID!, $invoice_no: ID!, $invoice_order_sequence_id: ID!, $skip_date_validations: Boolean!) {
  createOutgoingProformaInvoice(
    request_for_invoicing_id: $request_for_invoicing_id
    invoice_no: $invoice_no
    invoice_order_sequence_id: $invoice_order_sequence_id
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;
export type CreateProformaInvoiceMutationFn = ApolloReactCommon.MutationFunction<CreateProformaInvoiceMutation, CreateProformaInvoiceMutationVariables>;

/**
 * __useCreateProformaInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateProformaInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProformaInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProformaInvoiceMutation, { data, loading, error }] = useCreateProformaInvoiceMutation({
 *   variables: {
 *      request_for_invoicing_id: // value for 'request_for_invoicing_id'
 *      invoice_no: // value for 'invoice_no'
 *      invoice_order_sequence_id: // value for 'invoice_order_sequence_id'
 *      skip_date_validations: // value for 'skip_date_validations'
 *   },
 * });
 */
export function useCreateProformaInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProformaInvoiceMutation, CreateProformaInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProformaInvoiceMutation, CreateProformaInvoiceMutationVariables>(CreateProformaInvoiceDocument, options);
      }
export type CreateProformaInvoiceMutationHookResult = ReturnType<typeof useCreateProformaInvoiceMutation>;
export type CreateProformaInvoiceMutationResult = ApolloReactCommon.MutationResult<CreateProformaInvoiceMutation>;
export type CreateProformaInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProformaInvoiceMutation, CreateProformaInvoiceMutationVariables>;
export const UpdateProformaInvoiceDocument = gql`
    mutation UpdateProformaInvoice($input: UpdateOutgoingProformaInvoiceInput!, $skip_date_validations: Boolean!) {
  updateOutgoingProformaInvoice(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;
export type UpdateProformaInvoiceMutationFn = ApolloReactCommon.MutationFunction<UpdateProformaInvoiceMutation, UpdateProformaInvoiceMutationVariables>;

/**
 * __useUpdateProformaInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateProformaInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProformaInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProformaInvoiceMutation, { data, loading, error }] = useUpdateProformaInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      skip_date_validations: // value for 'skip_date_validations'
 *   },
 * });
 */
export function useUpdateProformaInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProformaInvoiceMutation, UpdateProformaInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProformaInvoiceMutation, UpdateProformaInvoiceMutationVariables>(UpdateProformaInvoiceDocument, options);
      }
export type UpdateProformaInvoiceMutationHookResult = ReturnType<typeof useUpdateProformaInvoiceMutation>;
export type UpdateProformaInvoiceMutationResult = ApolloReactCommon.MutationResult<UpdateProformaInvoiceMutation>;
export type UpdateProformaInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProformaInvoiceMutation, UpdateProformaInvoiceMutationVariables>;
export const CreateRequestForInvoicingDocument = gql`
    mutation CreateRequestForInvoicing($input: CreateRequestForInvoicingInput!, $skip_date_validations: Boolean!) {
  createRequestForInvoicing(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
    workspace_bank_account_id
  }
}
    `;
export type CreateRequestForInvoicingMutationFn = ApolloReactCommon.MutationFunction<CreateRequestForInvoicingMutation, CreateRequestForInvoicingMutationVariables>;

/**
 * __useCreateRequestForInvoicingMutation__
 *
 * To run a mutation, you first call `useCreateRequestForInvoicingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestForInvoicingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestForInvoicingMutation, { data, loading, error }] = useCreateRequestForInvoicingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      skip_date_validations: // value for 'skip_date_validations'
 *   },
 * });
 */
export function useCreateRequestForInvoicingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRequestForInvoicingMutation, CreateRequestForInvoicingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRequestForInvoicingMutation, CreateRequestForInvoicingMutationVariables>(CreateRequestForInvoicingDocument, options);
      }
export type CreateRequestForInvoicingMutationHookResult = ReturnType<typeof useCreateRequestForInvoicingMutation>;
export type CreateRequestForInvoicingMutationResult = ApolloReactCommon.MutationResult<CreateRequestForInvoicingMutation>;
export type CreateRequestForInvoicingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRequestForInvoicingMutation, CreateRequestForInvoicingMutationVariables>;
export const UpdateRequestForInvoicingDocument = gql`
    mutation UpdateRequestForInvoicing($input: UpdateRequestForInvoicingInput!, $skip_date_validations: Boolean!) {
  updateRequestForInvoicing(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
    workspace_bank_account_id
  }
}
    `;
export type UpdateRequestForInvoicingMutationFn = ApolloReactCommon.MutationFunction<UpdateRequestForInvoicingMutation, UpdateRequestForInvoicingMutationVariables>;

/**
 * __useUpdateRequestForInvoicingMutation__
 *
 * To run a mutation, you first call `useUpdateRequestForInvoicingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestForInvoicingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestForInvoicingMutation, { data, loading, error }] = useUpdateRequestForInvoicingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      skip_date_validations: // value for 'skip_date_validations'
 *   },
 * });
 */
export function useUpdateRequestForInvoicingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRequestForInvoicingMutation, UpdateRequestForInvoicingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRequestForInvoicingMutation, UpdateRequestForInvoicingMutationVariables>(UpdateRequestForInvoicingDocument, options);
      }
export type UpdateRequestForInvoicingMutationHookResult = ReturnType<typeof useUpdateRequestForInvoicingMutation>;
export type UpdateRequestForInvoicingMutationResult = ApolloReactCommon.MutationResult<UpdateRequestForInvoicingMutation>;
export type UpdateRequestForInvoicingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRequestForInvoicingMutation, UpdateRequestForInvoicingMutationVariables>;
export const BasicDataDocument = gql`
    query BasicData($type: ACCOUNTING_ACCOUNT_TYPE) {
  clientsSimpleMap {
    ...ClientSimpleOptionParts
    brands {
      ...BrandSimpleOptionParts
    }
  }
  userSimpleMap {
    ...UserSimpleOptionParts
  }
  vatRates {
    ...VatRateOptionParts
    deleted
  }
  teamSimpleMap {
    id
    name
  }
  accountingAccountsSimpleMap(type: $type) {
    id
    title
    account_number
  }
  accountingCentres(type: INVOICE) {
    ...CostCenter
  }
  invoicePaymentMethods {
    ...InvoicePaymentMethod
  }
}
    ${ClientSimpleOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}
${UserSimpleOptionPartsFragmentDoc}
${VatRateOptionPartsFragmentDoc}
${CostCenterFragmentDoc}
${InvoicePaymentMethodFragmentDoc}`;

/**
 * __useBasicDataQuery__
 *
 * To run a query within a React component, call `useBasicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicDataQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBasicDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicDataQuery, BasicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BasicDataQuery, BasicDataQueryVariables>(BasicDataDocument, options);
      }
export function useBasicDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicDataQuery, BasicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BasicDataQuery, BasicDataQueryVariables>(BasicDataDocument, options);
        }
export function useBasicDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BasicDataQuery, BasicDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BasicDataQuery, BasicDataQueryVariables>(BasicDataDocument, options);
        }
export type BasicDataQueryHookResult = ReturnType<typeof useBasicDataQuery>;
export type BasicDataLazyQueryHookResult = ReturnType<typeof useBasicDataLazyQuery>;
export type BasicDataSuspenseQueryHookResult = ReturnType<typeof useBasicDataSuspenseQuery>;
export type BasicDataQueryResult = ApolloReactCommon.QueryResult<BasicDataQuery, BasicDataQueryVariables>;
export const GetTotalInWordsDocument = gql`
    query GetTotalInWords($amount: BigInt!, $language: String!) {
  getTotalInWords(amount: $amount, language: $language)
}
    `;

/**
 * __useGetTotalInWordsQuery__
 *
 * To run a query within a React component, call `useGetTotalInWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalInWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalInWordsQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetTotalInWordsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTotalInWordsQuery, GetTotalInWordsQueryVariables> & ({ variables: GetTotalInWordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>(GetTotalInWordsDocument, options);
      }
export function useGetTotalInWordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>(GetTotalInWordsDocument, options);
        }
export function useGetTotalInWordsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>(GetTotalInWordsDocument, options);
        }
export type GetTotalInWordsQueryHookResult = ReturnType<typeof useGetTotalInWordsQuery>;
export type GetTotalInWordsLazyQueryHookResult = ReturnType<typeof useGetTotalInWordsLazyQuery>;
export type GetTotalInWordsSuspenseQueryHookResult = ReturnType<typeof useGetTotalInWordsSuspenseQuery>;
export type GetTotalInWordsQueryResult = ApolloReactCommon.QueryResult<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>;
export const BillingEntitiesDataDocument = gql`
    query BillingEntitiesData($client_id: ID!) {
  client(id: $client_id) {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
}
    ${BillingEntityOptionPartsFragmentDoc}`;

/**
 * __useBillingEntitiesDataQuery__
 *
 * To run a query within a React component, call `useBillingEntitiesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingEntitiesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingEntitiesDataQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useBillingEntitiesDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables> & ({ variables: BillingEntitiesDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>(BillingEntitiesDataDocument, options);
      }
export function useBillingEntitiesDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>(BillingEntitiesDataDocument, options);
        }
export function useBillingEntitiesDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>(BillingEntitiesDataDocument, options);
        }
export type BillingEntitiesDataQueryHookResult = ReturnType<typeof useBillingEntitiesDataQuery>;
export type BillingEntitiesDataLazyQueryHookResult = ReturnType<typeof useBillingEntitiesDataLazyQuery>;
export type BillingEntitiesDataSuspenseQueryHookResult = ReturnType<typeof useBillingEntitiesDataSuspenseQuery>;
export type BillingEntitiesDataQueryResult = ApolloReactCommon.QueryResult<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>;
export const BrandsDataDocument = gql`
    query BrandsData($brand_ids: Mixed!, $brandCount: Int!) {
  brands(
    filters: {where: {column: ID, operator: IN, value: $brand_ids}}
    first: $brandCount
  ) {
    data {
      id
      name
      defaultBillingEntity {
        id
      }
      client {
        id
        name
        workspaceCompany {
          ...WorkspaceCompany
          vat_no
          invoicePdfSettings {
            text_on_invoice
          }
        }
      }
      contacts {
        ...ContactOptionParts
      }
      creditAccounts {
        ...BrandCreditAccountOptionParts
        stats {
          id
          total_debit
          remaining_credit
        }
      }
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}
${ContactOptionPartsFragmentDoc}
${BrandCreditAccountOptionPartsFragmentDoc}`;

/**
 * __useBrandsDataQuery__
 *
 * To run a query within a React component, call `useBrandsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsDataQuery({
 *   variables: {
 *      brand_ids: // value for 'brand_ids'
 *      brandCount: // value for 'brandCount'
 *   },
 * });
 */
export function useBrandsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandsDataQuery, BrandsDataQueryVariables> & ({ variables: BrandsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandsDataQuery, BrandsDataQueryVariables>(BrandsDataDocument, options);
      }
export function useBrandsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandsDataQuery, BrandsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandsDataQuery, BrandsDataQueryVariables>(BrandsDataDocument, options);
        }
export function useBrandsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandsDataQuery, BrandsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandsDataQuery, BrandsDataQueryVariables>(BrandsDataDocument, options);
        }
export type BrandsDataQueryHookResult = ReturnType<typeof useBrandsDataQuery>;
export type BrandsDataLazyQueryHookResult = ReturnType<typeof useBrandsDataLazyQuery>;
export type BrandsDataSuspenseQueryHookResult = ReturnType<typeof useBrandsDataSuspenseQuery>;
export type BrandsDataQueryResult = ApolloReactCommon.QueryResult<BrandsDataQuery, BrandsDataQueryVariables>;
export const BulkConvertAmountDocument = gql`
    query BulkConvertAmount($items: [AmountToConvert!]!, $currency_id: ID!, $exchange_rate: BigInt!, $workspace_company_id: ID) {
  bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates(
    items: $items
    currency_id: $currency_id
    exchange_rate: $exchange_rate
    workspace_company_id: $workspace_company_id
  ) {
    amount
    unit_price
    identifier
  }
}
    `;

/**
 * __useBulkConvertAmountQuery__
 *
 * To run a query within a React component, call `useBulkConvertAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkConvertAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkConvertAmountQuery({
 *   variables: {
 *      items: // value for 'items'
 *      currency_id: // value for 'currency_id'
 *      exchange_rate: // value for 'exchange_rate'
 *      workspace_company_id: // value for 'workspace_company_id'
 *   },
 * });
 */
export function useBulkConvertAmountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkConvertAmountQuery, BulkConvertAmountQueryVariables> & ({ variables: BulkConvertAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>(BulkConvertAmountDocument, options);
      }
export function useBulkConvertAmountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>(BulkConvertAmountDocument, options);
        }
export function useBulkConvertAmountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>(BulkConvertAmountDocument, options);
        }
export type BulkConvertAmountQueryHookResult = ReturnType<typeof useBulkConvertAmountQuery>;
export type BulkConvertAmountLazyQueryHookResult = ReturnType<typeof useBulkConvertAmountLazyQuery>;
export type BulkConvertAmountSuspenseQueryHookResult = ReturnType<typeof useBulkConvertAmountSuspenseQuery>;
export type BulkConvertAmountQueryResult = ApolloReactCommon.QueryResult<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>;
export const DocumentsDataDocument = gql`
    query DocumentsData($project_ids: [ID!], $brand_ids: [ID!]!) {
  otherDocumentsWithPdf(brand_ids: $brand_ids, project_ids: $project_ids) {
    id
    brands {
      id
    }
    projects {
      id
    }
    pdfFiles {
      ...PdfFile
    }
  }
  ordersWithPdf(brand_ids: $brand_ids, project_ids: $project_ids) {
    id
    brand {
      id
    }
    projects {
      id
    }
    pdfFiles {
      ...PdfFile
    }
  }
}
    ${PdfFileFragmentDoc}`;

/**
 * __useDocumentsDataQuery__
 *
 * To run a query within a React component, call `useDocumentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsDataQuery({
 *   variables: {
 *      project_ids: // value for 'project_ids'
 *      brand_ids: // value for 'brand_ids'
 *   },
 * });
 */
export function useDocumentsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsDataQuery, DocumentsDataQueryVariables> & ({ variables: DocumentsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentsDataQuery, DocumentsDataQueryVariables>(DocumentsDataDocument, options);
      }
export function useDocumentsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsDataQuery, DocumentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentsDataQuery, DocumentsDataQueryVariables>(DocumentsDataDocument, options);
        }
export function useDocumentsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsDataQuery, DocumentsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentsDataQuery, DocumentsDataQueryVariables>(DocumentsDataDocument, options);
        }
export type DocumentsDataQueryHookResult = ReturnType<typeof useDocumentsDataQuery>;
export type DocumentsDataLazyQueryHookResult = ReturnType<typeof useDocumentsDataLazyQuery>;
export type DocumentsDataSuspenseQueryHookResult = ReturnType<typeof useDocumentsDataSuspenseQuery>;
export type DocumentsDataQueryResult = ApolloReactCommon.QueryResult<DocumentsDataQuery, DocumentsDataQueryVariables>;
export const OutgoingInvoiceDocument = gql`
    query OutgoingInvoice($id: ID!) {
  outgoingInvoice(id: $id) {
    ...OutgoingInvoiceFormParts
  }
}
    ${OutgoingInvoiceFormPartsFragmentDoc}`;

/**
 * __useOutgoingInvoiceQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOutgoingInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables> & ({ variables: OutgoingInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>(OutgoingInvoiceDocument, options);
      }
export function useOutgoingInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>(OutgoingInvoiceDocument, options);
        }
export function useOutgoingInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>(OutgoingInvoiceDocument, options);
        }
export type OutgoingInvoiceQueryHookResult = ReturnType<typeof useOutgoingInvoiceQuery>;
export type OutgoingInvoiceLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceLazyQuery>;
export type OutgoingInvoiceSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceSuspenseQuery>;
export type OutgoingInvoiceQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>;
export const ProformaInvoiceDocument = gql`
    query ProformaInvoice($id: ID!) {
  outgoingProformaInvoice(id: $id) {
    ...ProformaInvoiceFormParts
  }
}
    ${ProformaInvoiceFormPartsFragmentDoc}`;

/**
 * __useProformaInvoiceQuery__
 *
 * To run a query within a React component, call `useProformaInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProformaInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProformaInvoiceQuery, ProformaInvoiceQueryVariables> & ({ variables: ProformaInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>(ProformaInvoiceDocument, options);
      }
export function useProformaInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>(ProformaInvoiceDocument, options);
        }
export function useProformaInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>(ProformaInvoiceDocument, options);
        }
export type ProformaInvoiceQueryHookResult = ReturnType<typeof useProformaInvoiceQuery>;
export type ProformaInvoiceLazyQueryHookResult = ReturnType<typeof useProformaInvoiceLazyQuery>;
export type ProformaInvoiceSuspenseQueryHookResult = ReturnType<typeof useProformaInvoiceSuspenseQuery>;
export type ProformaInvoiceQueryResult = ApolloReactCommon.QueryResult<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>;
export const ProjectsDataDocument = gql`
    query ProjectsData($project_ids: Mixed!, $projectsCount: Int!) {
  projects(
    filters: {where: {column: ID, operator: IN, value: $project_ids}}
    first: $projectsCount
  ) {
    data {
      id
      title
      code
      start_date
      finished_at
      archived_at
      billable
      status
      type
      projectManager {
        id
      }
      contact {
        id
      }
      team {
        id
        name
      }
      brand {
        id
      }
      stats: statsCached {
        id
        credit
        uninvoiced
      }
      lastInvoice {
        outgoing_invoice_date
        outgoingInvoice {
          id
          invoice_no
          type
        }
      }
      ourWorkStructured {
        id
        name
        total_budget
        budget_category_id
        budgetItems {
          id
          title
          completed_at
          requested_for_deletion_at
          vat_percent_informative
          creditAccount {
            id
          }
          stats {
            total_budget
            credit
            uninvoiced
          }
          budget_positions {
            ...BudgetPosition
          }
          tasks {
            id
            name
            positionsSpent {
              spent
              timeTrackingWorkType {
                title
              }
            }
            ourWorkBudgetItem {
              stats {
                spent_budget
              }
            }
          }
        }
      }
      expensesWithoutOtherStructured {
        id
        name
        total_budget
        budget_category_id
        budgetItems {
          id
          title
          completed_at
          requested_for_deletion_at
          vat_percent_informative
          stats {
            total_budget
            credit
            uninvoiced
            real_expenses
            real_commission
            real_commission_relative
            planned_expenses
            planned_commission
            planned_commission_relative_computed
          }
        }
      }
      ordersSimpleMap {
        id
        purchase_order_no
      }
    }
  }
}
    ${BudgetPositionFragmentDoc}`;

/**
 * __useProjectsDataQuery__
 *
 * To run a query within a React component, call `useProjectsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsDataQuery({
 *   variables: {
 *      project_ids: // value for 'project_ids'
 *      projectsCount: // value for 'projectsCount'
 *   },
 * });
 */
export function useProjectsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsDataQuery, ProjectsDataQueryVariables> & ({ variables: ProjectsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsDataQuery, ProjectsDataQueryVariables>(ProjectsDataDocument, options);
      }
export function useProjectsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsDataQuery, ProjectsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsDataQuery, ProjectsDataQueryVariables>(ProjectsDataDocument, options);
        }
export function useProjectsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsDataQuery, ProjectsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsDataQuery, ProjectsDataQueryVariables>(ProjectsDataDocument, options);
        }
export type ProjectsDataQueryHookResult = ReturnType<typeof useProjectsDataQuery>;
export type ProjectsDataLazyQueryHookResult = ReturnType<typeof useProjectsDataLazyQuery>;
export type ProjectsDataSuspenseQueryHookResult = ReturnType<typeof useProjectsDataSuspenseQuery>;
export type ProjectsDataQueryResult = ApolloReactCommon.QueryResult<ProjectsDataQuery, ProjectsDataQueryVariables>;
export const RequestForInvoicingDocument = gql`
    query RequestForInvoicing($id: ID!) {
  requestForInvoicing(id: $id) {
    ...RFIFormParts
  }
}
    ${RfiFormPartsFragmentDoc}`;

/**
 * __useRequestForInvoicingQuery__
 *
 * To run a query within a React component, call `useRequestForInvoicingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestForInvoicingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestForInvoicingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestForInvoicingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RequestForInvoicingQuery, RequestForInvoicingQueryVariables> & ({ variables: RequestForInvoicingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>(RequestForInvoicingDocument, options);
      }
export function useRequestForInvoicingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>(RequestForInvoicingDocument, options);
        }
export function useRequestForInvoicingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>(RequestForInvoicingDocument, options);
        }
export type RequestForInvoicingQueryHookResult = ReturnType<typeof useRequestForInvoicingQuery>;
export type RequestForInvoicingLazyQueryHookResult = ReturnType<typeof useRequestForInvoicingLazyQuery>;
export type RequestForInvoicingSuspenseQueryHookResult = ReturnType<typeof useRequestForInvoicingSuspenseQuery>;
export type RequestForInvoicingQueryResult = ApolloReactCommon.QueryResult<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>;
export const UnusedPaidProformaInvoicesDocument = gql`
    query UnusedPaidProformaInvoices($project_ids: [ID!]!) {
  unusedPaidOutgoingProformaInvoices(project_ids: $project_ids) {
    ...ProformaInvoiceOptions
  }
}
    ${ProformaInvoiceOptionsFragmentDoc}`;

/**
 * __useUnusedPaidProformaInvoicesQuery__
 *
 * To run a query within a React component, call `useUnusedPaidProformaInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnusedPaidProformaInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnusedPaidProformaInvoicesQuery({
 *   variables: {
 *      project_ids: // value for 'project_ids'
 *   },
 * });
 */
export function useUnusedPaidProformaInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables> & ({ variables: UnusedPaidProformaInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>(UnusedPaidProformaInvoicesDocument, options);
      }
export function useUnusedPaidProformaInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>(UnusedPaidProformaInvoicesDocument, options);
        }
export function useUnusedPaidProformaInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>(UnusedPaidProformaInvoicesDocument, options);
        }
export type UnusedPaidProformaInvoicesQueryHookResult = ReturnType<typeof useUnusedPaidProformaInvoicesQuery>;
export type UnusedPaidProformaInvoicesLazyQueryHookResult = ReturnType<typeof useUnusedPaidProformaInvoicesLazyQuery>;
export type UnusedPaidProformaInvoicesSuspenseQueryHookResult = ReturnType<typeof useUnusedPaidProformaInvoicesSuspenseQuery>;
export type UnusedPaidProformaInvoicesQueryResult = ApolloReactCommon.QueryResult<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>;
export const OrdersDocument = gql`
    query Orders($filters: OrderQueryArgs, $first: Int, $page: Int) {
  orders(filters: $filters, first: $first, page: $page) {
    data {
      id
      purchase_order_no
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export function useOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersSuspenseQueryHookResult = ReturnType<typeof useOrdersSuspenseQuery>;
export type OrdersQueryResult = ApolloReactCommon.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const OutgoingInvoiceDetailDocument = gql`
    query OutgoingInvoiceDetail($id: ID!) {
  outgoingInvoice(id: $id) {
    id
    ...OutgoingInvoiceCoreParts
    ...OutgoingInvoiceNoteParts
    paid_at
    exchange_rate
    accountMoves {
      id
      bank_account_move_id
      amount
      exchange_rate
      date
      document_currency {
        code
        denomination
      }
      bankAccountMove {
        ...AccountMove
      }
    }
    teams {
      name
    }
    brands {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
      creditAccounts {
        ...BrandCreditAccountOptionParts
      }
    }
    billingEntity {
      city
      legal_name
      street
      zip
      invoice_email
      country {
        id
        name
      }
      registration_no
      tax_no
      vat_no
    }
    contact {
      first_name
      last_name
      image {
        urls {
          thumbnail
        }
      }
    }
    currency {
      id
      code
      denomination
    }
    invoiceItems {
      id
      description
      amount_in_currency
      vat_percent_informative
    }
    orders {
      id
      purchase_order_no
      urls {
        preview
      }
    }
    proformaInvoicesPivot {
      invoice {
        id
        invoice_no
      }
      amount_in_currency
    }
    relatesToOutgoingProformaInvoice {
      id
      invoice_no
    }
    stats {
      total_amount_in_currency
      total_amount_with_vat_in_currency
      total_vat_in_currency
      vat_percent_informative
      total_amount_with_vat_in_currency_to_pay
      total_amount_with_vat_in_currency_to_pay_from_proforma_payments
    }
    ourWorkBudgetSplits {
      our_work_budget_item_id
      amount
      amount_in_percent
    }
    expenseBudgetSplits {
      expense_budget_item_id
      amount
    }
    prepaymentSplits {
      brand_credit_account_id
      amount
    }
    projects {
      id
      code
      title
      team {
        id
        name
      }
      ourWorkStructured {
        id
        name
        budgetItems {
          id
          title
          stats {
            total_budget
            credit
            uninvoiced
          }
        }
      }
      expensesStructured {
        id
        name
        budgetItems {
          id
          title
          completed_at
          stats {
            total_budget
            real_expenses
            planned_expenses
            credit
            real_commission
            real_commission_relative
            planned_commission
            planned_commission_relative_computed
          }
        }
      }
    }
    filesToAttach {
      public_id
      filename
      urls {
        original
      }
    }
    invoicePdf {
      preview
      download
    }
    invoiceProofOfPayments {
      invoice {
        id
        invoice_no
      }
    }
    projectTimeBilling {
      id
      date_from
      date_to
      project {
        id
        title
        code
        numeric_code
      }
    }
    modelLock {
      ...ModelLock
    }
    invoicePaymentMethod {
      ...InvoicePaymentMethod
    }
  }
}
    ${OutgoingInvoiceCorePartsFragmentDoc}
${OutgoingInvoiceNotePartsFragmentDoc}
${AccountMoveFragmentDoc}
${BrandCreditAccountOptionPartsFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}`;

/**
 * __useOutgoingInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOutgoingInvoiceDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables> & ({ variables: OutgoingInvoiceDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>(OutgoingInvoiceDetailDocument, options);
      }
export function useOutgoingInvoiceDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>(OutgoingInvoiceDetailDocument, options);
        }
export function useOutgoingInvoiceDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>(OutgoingInvoiceDetailDocument, options);
        }
export type OutgoingInvoiceDetailQueryHookResult = ReturnType<typeof useOutgoingInvoiceDetailQuery>;
export type OutgoingInvoiceDetailLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceDetailLazyQuery>;
export type OutgoingInvoiceDetailSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceDetailSuspenseQuery>;
export type OutgoingInvoiceDetailQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>;
export const ProformaInvoiceDetailDocument = gql`
    query ProformaInvoiceDetail($id: ID!) {
  outgoingProformaInvoice(id: $id) {
    id
    ...ProformaInvoiceCoreParts
    ...ProformaInvoiceNoteParts
    paid_at
    exchange_rate
    accountMoves {
      id
      bank_account_move_id
      amount
      exchange_rate
      date
      document_currency {
        code
        denomination
      }
      bankAccountMove {
        ...AccountMove
      }
    }
    teams {
      name
    }
    brands {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
      creditAccounts {
        id
        title
      }
    }
    billingEntity {
      city
      legal_name
      street
      zip
      invoice_email
      country {
        id
        name
      }
      registration_no
      tax_no
      vat_no
    }
    contact {
      first_name
      last_name
      image {
        urls {
          thumbnail
        }
      }
    }
    currency {
      id
      code
      denomination
    }
    invoiceItems {
      id
      description
      amount_in_currency
      vat_percent_informative
    }
    stats {
      total_amount_in_currency
      total_amount_with_vat_in_currency
      total_vat_in_currency
      vat_percent_informative
      unused_amount_in_currency
      unused_amount
    }
    projects {
      id
      code
      title
      team {
        id
        name
      }
      ourWorkStructured {
        id
        name
        budgetItems {
          id
          title
          stats {
            total_budget
            credit
            uninvoiced
          }
        }
      }
      expensesStructured {
        id
        name
        budgetItems {
          id
          title
          completed_at
          stats {
            total_budget
            real_expenses
            planned_expenses
            credit
            real_commission
            real_commission_relative
            planned_commission
            planned_commission_relative_computed
          }
        }
      }
    }
    filesToAttach {
      public_id
      filename
      urls {
        original
      }
    }
    invoicePdf {
      preview
      download
    }
    proofOfPayments {
      id
      invoice_no
    }
    modelLock {
      ...ModelLock
    }
    invoicePaymentMethod {
      ...InvoicePaymentMethod
    }
  }
}
    ${ProformaInvoiceCorePartsFragmentDoc}
${ProformaInvoiceNotePartsFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}`;

/**
 * __useProformaInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useProformaInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProformaInvoiceDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables> & ({ variables: ProformaInvoiceDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>(ProformaInvoiceDetailDocument, options);
      }
export function useProformaInvoiceDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>(ProformaInvoiceDetailDocument, options);
        }
export function useProformaInvoiceDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>(ProformaInvoiceDetailDocument, options);
        }
export type ProformaInvoiceDetailQueryHookResult = ReturnType<typeof useProformaInvoiceDetailQuery>;
export type ProformaInvoiceDetailLazyQueryHookResult = ReturnType<typeof useProformaInvoiceDetailLazyQuery>;
export type ProformaInvoiceDetailSuspenseQueryHookResult = ReturnType<typeof useProformaInvoiceDetailSuspenseQuery>;
export type ProformaInvoiceDetailQueryResult = ApolloReactCommon.QueryResult<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>;
export const DeleteOutgoingProformaInvoiceDocument = gql`
    mutation DeleteOutgoingProformaInvoice($id: ID!) {
  deleteOutgoingProformaInvoice(id: $id)
}
    `;
export type DeleteOutgoingProformaInvoiceMutationFn = ApolloReactCommon.MutationFunction<DeleteOutgoingProformaInvoiceMutation, DeleteOutgoingProformaInvoiceMutationVariables>;

/**
 * __useDeleteOutgoingProformaInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteOutgoingProformaInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOutgoingProformaInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOutgoingProformaInvoiceMutation, { data, loading, error }] = useDeleteOutgoingProformaInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOutgoingProformaInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOutgoingProformaInvoiceMutation, DeleteOutgoingProformaInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOutgoingProformaInvoiceMutation, DeleteOutgoingProformaInvoiceMutationVariables>(DeleteOutgoingProformaInvoiceDocument, options);
      }
export type DeleteOutgoingProformaInvoiceMutationHookResult = ReturnType<typeof useDeleteOutgoingProformaInvoiceMutation>;
export type DeleteOutgoingProformaInvoiceMutationResult = ApolloReactCommon.MutationResult<DeleteOutgoingProformaInvoiceMutation>;
export type DeleteOutgoingProformaInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOutgoingProformaInvoiceMutation, DeleteOutgoingProformaInvoiceMutationVariables>;
export const MarkProformaAsPaidDocument = gql`
    mutation MarkProformaAsPaid($id: ID!, $date: Date, $create_summary_invoice: Boolean) {
  markOutgoingProformaInvoiceAsPaid(
    id: $id
    date: $date
    create_summary_invoice: $create_summary_invoice
  ) {
    id
  }
}
    `;
export type MarkProformaAsPaidMutationFn = ApolloReactCommon.MutationFunction<MarkProformaAsPaidMutation, MarkProformaAsPaidMutationVariables>;

/**
 * __useMarkProformaAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkProformaAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProformaAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProformaAsPaidMutation, { data, loading, error }] = useMarkProformaAsPaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      create_summary_invoice: // value for 'create_summary_invoice'
 *   },
 * });
 */
export function useMarkProformaAsPaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkProformaAsPaidMutation, MarkProformaAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkProformaAsPaidMutation, MarkProformaAsPaidMutationVariables>(MarkProformaAsPaidDocument, options);
      }
export type MarkProformaAsPaidMutationHookResult = ReturnType<typeof useMarkProformaAsPaidMutation>;
export type MarkProformaAsPaidMutationResult = ApolloReactCommon.MutationResult<MarkProformaAsPaidMutation>;
export type MarkProformaAsPaidMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkProformaAsPaidMutation, MarkProformaAsPaidMutationVariables>;
export const MarkProformaAsUnpaidDocument = gql`
    mutation MarkProformaAsUnpaid($id: ID!, $remove_matched_payments: Boolean! = false) {
  markOutgoingProformaInvoiceAsUnpaid(
    id: $id
    remove_matched_payments: $remove_matched_payments
  ) {
    id
    paid_at
  }
}
    `;
export type MarkProformaAsUnpaidMutationFn = ApolloReactCommon.MutationFunction<MarkProformaAsUnpaidMutation, MarkProformaAsUnpaidMutationVariables>;

/**
 * __useMarkProformaAsUnpaidMutation__
 *
 * To run a mutation, you first call `useMarkProformaAsUnpaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProformaAsUnpaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProformaAsUnpaidMutation, { data, loading, error }] = useMarkProformaAsUnpaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      remove_matched_payments: // value for 'remove_matched_payments'
 *   },
 * });
 */
export function useMarkProformaAsUnpaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkProformaAsUnpaidMutation, MarkProformaAsUnpaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkProformaAsUnpaidMutation, MarkProformaAsUnpaidMutationVariables>(MarkProformaAsUnpaidDocument, options);
      }
export type MarkProformaAsUnpaidMutationHookResult = ReturnType<typeof useMarkProformaAsUnpaidMutation>;
export type MarkProformaAsUnpaidMutationResult = ApolloReactCommon.MutationResult<MarkProformaAsUnpaidMutation>;
export type MarkProformaAsUnpaidMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkProformaAsUnpaidMutation, MarkProformaAsUnpaidMutationVariables>;
export const SendProformaDocument = gql`
    mutation SendProforma($id: ID!) {
  sendOutgoingProformaInvoice(id: $id)
}
    `;
export type SendProformaMutationFn = ApolloReactCommon.MutationFunction<SendProformaMutation, SendProformaMutationVariables>;

/**
 * __useSendProformaMutation__
 *
 * To run a mutation, you first call `useSendProformaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProformaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProformaMutation, { data, loading, error }] = useSendProformaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendProformaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendProformaMutation, SendProformaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendProformaMutation, SendProformaMutationVariables>(SendProformaDocument, options);
      }
export type SendProformaMutationHookResult = ReturnType<typeof useSendProformaMutation>;
export type SendProformaMutationResult = ApolloReactCommon.MutationResult<SendProformaMutation>;
export type SendProformaMutationOptions = ApolloReactCommon.BaseMutationOptions<SendProformaMutation, SendProformaMutationVariables>;
export const SendProformaBulkDocument = gql`
    mutation SendProformaBulk($ids: [ID!]!) {
  sendOutgoingProformaInvoiceBulk(id: $ids)
}
    `;
export type SendProformaBulkMutationFn = ApolloReactCommon.MutationFunction<SendProformaBulkMutation, SendProformaBulkMutationVariables>;

/**
 * __useSendProformaBulkMutation__
 *
 * To run a mutation, you first call `useSendProformaBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProformaBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProformaBulkMutation, { data, loading, error }] = useSendProformaBulkMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSendProformaBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendProformaBulkMutation, SendProformaBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendProformaBulkMutation, SendProformaBulkMutationVariables>(SendProformaBulkDocument, options);
      }
export type SendProformaBulkMutationHookResult = ReturnType<typeof useSendProformaBulkMutation>;
export type SendProformaBulkMutationResult = ApolloReactCommon.MutationResult<SendProformaBulkMutation>;
export type SendProformaBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<SendProformaBulkMutation, SendProformaBulkMutationVariables>;
export const SendOutgoingProformaDocument = gql`
    mutation SendOutgoingProforma($id: ID!, $recipients: [String], $subject: String, $content: String, $attachments: [ID]) {
  sendOutgoingProformaInvoice(
    id: $id
    recipients: $recipients
    subject: $subject
    content: $content
    attachments: $attachments
  )
}
    `;
export type SendOutgoingProformaMutationFn = ApolloReactCommon.MutationFunction<SendOutgoingProformaMutation, SendOutgoingProformaMutationVariables>;

/**
 * __useSendOutgoingProformaMutation__
 *
 * To run a mutation, you first call `useSendOutgoingProformaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOutgoingProformaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOutgoingProformaMutation, { data, loading, error }] = useSendOutgoingProformaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      recipients: // value for 'recipients'
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendOutgoingProformaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendOutgoingProformaMutation, SendOutgoingProformaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendOutgoingProformaMutation, SendOutgoingProformaMutationVariables>(SendOutgoingProformaDocument, options);
      }
export type SendOutgoingProformaMutationHookResult = ReturnType<typeof useSendOutgoingProformaMutation>;
export type SendOutgoingProformaMutationResult = ApolloReactCommon.MutationResult<SendOutgoingProformaMutation>;
export type SendOutgoingProformaMutationOptions = ApolloReactCommon.BaseMutationOptions<SendOutgoingProformaMutation, SendOutgoingProformaMutationVariables>;
export const BulkDownloadProformaInvoicesDocument = gql`
    query BulkDownloadProformaInvoices($ids: [ID!]!) {
  bulkDownloadOutgoingProformaInvoices(ids: $ids)
}
    `;

/**
 * __useBulkDownloadProformaInvoicesQuery__
 *
 * To run a query within a React component, call `useBulkDownloadProformaInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkDownloadProformaInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDownloadProformaInvoicesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDownloadProformaInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables> & ({ variables: BulkDownloadProformaInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>(BulkDownloadProformaInvoicesDocument, options);
      }
export function useBulkDownloadProformaInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>(BulkDownloadProformaInvoicesDocument, options);
        }
export function useBulkDownloadProformaInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>(BulkDownloadProformaInvoicesDocument, options);
        }
export type BulkDownloadProformaInvoicesQueryHookResult = ReturnType<typeof useBulkDownloadProformaInvoicesQuery>;
export type BulkDownloadProformaInvoicesLazyQueryHookResult = ReturnType<typeof useBulkDownloadProformaInvoicesLazyQuery>;
export type BulkDownloadProformaInvoicesSuspenseQueryHookResult = ReturnType<typeof useBulkDownloadProformaInvoicesSuspenseQuery>;
export type BulkDownloadProformaInvoicesQueryResult = ApolloReactCommon.QueryResult<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>;
export const GetProformaEmailDataDocument = gql`
    query GetProformaEmailData($proforma_invoice_id: ID!) {
  getProformaInvoiceEmailData(outgoing_proforma_invoice_id: $proforma_invoice_id) {
    ...EmailData
  }
}
    ${EmailDataFragmentDoc}`;

/**
 * __useGetProformaEmailDataQuery__
 *
 * To run a query within a React component, call `useGetProformaEmailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProformaEmailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProformaEmailDataQuery({
 *   variables: {
 *      proforma_invoice_id: // value for 'proforma_invoice_id'
 *   },
 * });
 */
export function useGetProformaEmailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables> & ({ variables: GetProformaEmailDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>(GetProformaEmailDataDocument, options);
      }
export function useGetProformaEmailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>(GetProformaEmailDataDocument, options);
        }
export function useGetProformaEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>(GetProformaEmailDataDocument, options);
        }
export type GetProformaEmailDataQueryHookResult = ReturnType<typeof useGetProformaEmailDataQuery>;
export type GetProformaEmailDataLazyQueryHookResult = ReturnType<typeof useGetProformaEmailDataLazyQuery>;
export type GetProformaEmailDataSuspenseQueryHookResult = ReturnType<typeof useGetProformaEmailDataSuspenseQuery>;
export type GetProformaEmailDataQueryResult = ApolloReactCommon.QueryResult<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>;
export const ProformaInvoicesOptionsDocument = gql`
    query ProformaInvoicesOptions {
  clientsSimpleMap {
    ...ClientSimpleOptionParts
    brands {
      ...BrandSimpleOptionParts
    }
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
}
    ${ClientSimpleOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}`;

/**
 * __useProformaInvoicesOptionsQuery__
 *
 * To run a query within a React component, call `useProformaInvoicesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoicesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaInvoicesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProformaInvoicesOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>(ProformaInvoicesOptionsDocument, options);
      }
export function useProformaInvoicesOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>(ProformaInvoicesOptionsDocument, options);
        }
export function useProformaInvoicesOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>(ProformaInvoicesOptionsDocument, options);
        }
export type ProformaInvoicesOptionsQueryHookResult = ReturnType<typeof useProformaInvoicesOptionsQuery>;
export type ProformaInvoicesOptionsLazyQueryHookResult = ReturnType<typeof useProformaInvoicesOptionsLazyQuery>;
export type ProformaInvoicesOptionsSuspenseQueryHookResult = ReturnType<typeof useProformaInvoicesOptionsSuspenseQuery>;
export type ProformaInvoicesOptionsQueryResult = ApolloReactCommon.QueryResult<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>;
export const ProformaInvoicesTableDataDocument = gql`
    query ProformaInvoicesTableData($filters: OIProformaQueryArgs, $first: Int, $page: Int) {
  outgoingProformaInvoices(filters: $filters, first: $first, page: $page) {
    data {
      id
      ...ProformaInvoiceCoreParts
      abraflexi_exported
      documentExports {
        ...DocumentExport
      }
      paid_at
      note
      internal_note
      workspace_company_id
      exchange_rate
      summaryInvoices {
        id
        invoice_no
      }
      invoicePdf {
        preview
        download
      }
      proofOfPayments {
        id
        invoice_no
        invoicePdf {
          preview
          download
        }
      }
      currency {
        id
        code
        denomination
      }
      owner {
        id
      }
      brands {
        id
        name
      }
      projects {
        id
        title
        code
      }
      emailLogs {
        ...EmailLog
      }
      stats {
        total_amount_in_currency
        total_amount_with_vat_in_currency
        unused_amount_in_currency
      }
      accountMoves {
        id
        amount
        amount_in_move_currency
        bank_account_move_id
        exchange_rate
        bankAccountMove {
          ...AccountMove
        }
      }
      modelLock {
        ...ModelLock
      }
      invoicePaymentMethod {
        ...InvoicePaymentMethod
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProformaInvoiceCorePartsFragmentDoc}
${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProformaInvoicesTableDataQuery__
 *
 * To run a query within a React component, call `useProformaInvoicesTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoicesTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaInvoicesTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProformaInvoicesTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>(ProformaInvoicesTableDataDocument, options);
      }
export function useProformaInvoicesTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>(ProformaInvoicesTableDataDocument, options);
        }
export function useProformaInvoicesTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>(ProformaInvoicesTableDataDocument, options);
        }
export type ProformaInvoicesTableDataQueryHookResult = ReturnType<typeof useProformaInvoicesTableDataQuery>;
export type ProformaInvoicesTableDataLazyQueryHookResult = ReturnType<typeof useProformaInvoicesTableDataLazyQuery>;
export type ProformaInvoicesTableDataSuspenseQueryHookResult = ReturnType<typeof useProformaInvoicesTableDataSuspenseQuery>;
export type ProformaInvoicesTableDataQueryResult = ApolloReactCommon.QueryResult<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>;
export const ProformaInvoicesTableSummaryDocument = gql`
    query ProformaInvoicesTableSummary($filters: OIProformaQueryArgs) {
  outgoingProformaInvoicesSummary(filters: $filters) {
    outgoingInvoiceIds
    invoices
    total_amount
    total_amount_with_vat
    payments_due
    overdue_by_less_than_30_days
    overdue_by_31_to_90_days
    overdue_by_91_to_365_days
    overdue_by_more_than_365_days
  }
}
    `;

/**
 * __useProformaInvoicesTableSummaryQuery__
 *
 * To run a query within a React component, call `useProformaInvoicesTableSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoicesTableSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaInvoicesTableSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProformaInvoicesTableSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>(ProformaInvoicesTableSummaryDocument, options);
      }
export function useProformaInvoicesTableSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>(ProformaInvoicesTableSummaryDocument, options);
        }
export function useProformaInvoicesTableSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>(ProformaInvoicesTableSummaryDocument, options);
        }
export type ProformaInvoicesTableSummaryQueryHookResult = ReturnType<typeof useProformaInvoicesTableSummaryQuery>;
export type ProformaInvoicesTableSummaryLazyQueryHookResult = ReturnType<typeof useProformaInvoicesTableSummaryLazyQuery>;
export type ProformaInvoicesTableSummarySuspenseQueryHookResult = ReturnType<typeof useProformaInvoicesTableSummarySuspenseQuery>;
export type ProformaInvoicesTableSummaryQueryResult = ApolloReactCommon.QueryResult<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>;
export const ProformaOmegaExportDocument = gql`
    query ProformaOmegaExport($ids: [ID!]!) {
  omegaProformaExport(outgoing_proforma_invoice_ids: $ids)
}
    `;

/**
 * __useProformaOmegaExportQuery__
 *
 * To run a query within a React component, call `useProformaOmegaExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaOmegaExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaOmegaExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProformaOmegaExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables> & ({ variables: ProformaOmegaExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>(ProformaOmegaExportDocument, options);
      }
export function useProformaOmegaExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>(ProformaOmegaExportDocument, options);
        }
export function useProformaOmegaExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>(ProformaOmegaExportDocument, options);
        }
export type ProformaOmegaExportQueryHookResult = ReturnType<typeof useProformaOmegaExportQuery>;
export type ProformaOmegaExportLazyQueryHookResult = ReturnType<typeof useProformaOmegaExportLazyQuery>;
export type ProformaOmegaExportSuspenseQueryHookResult = ReturnType<typeof useProformaOmegaExportSuspenseQuery>;
export type ProformaOmegaExportQueryResult = ApolloReactCommon.QueryResult<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>;
export const ProformaPohodaExportDocument = gql`
    query ProformaPohodaExport($outgoingProformaInvoiceIds: [ID!]!) {
  pohodaOPIExport(outgoing_proforma_invoice_ids: $outgoingProformaInvoiceIds)
}
    `;

/**
 * __useProformaPohodaExportQuery__
 *
 * To run a query within a React component, call `useProformaPohodaExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaPohodaExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaPohodaExportQuery({
 *   variables: {
 *      outgoingProformaInvoiceIds: // value for 'outgoingProformaInvoiceIds'
 *   },
 * });
 */
export function useProformaPohodaExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables> & ({ variables: ProformaPohodaExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>(ProformaPohodaExportDocument, options);
      }
export function useProformaPohodaExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>(ProformaPohodaExportDocument, options);
        }
export function useProformaPohodaExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>(ProformaPohodaExportDocument, options);
        }
export type ProformaPohodaExportQueryHookResult = ReturnType<typeof useProformaPohodaExportQuery>;
export type ProformaPohodaExportLazyQueryHookResult = ReturnType<typeof useProformaPohodaExportLazyQuery>;
export type ProformaPohodaExportSuspenseQueryHookResult = ReturnType<typeof useProformaPohodaExportSuspenseQuery>;
export type ProformaPohodaExportQueryResult = ApolloReactCommon.QueryResult<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>;
export const ProformaPremierExportDocument = gql`
    query ProformaPremierExport($outgoing_proforma_invoice_ids: [ID!]!) {
  premierProformaOIExport(
    outgoing_proforma_invoice_ids: $outgoing_proforma_invoice_ids
  )
}
    `;

/**
 * __useProformaPremierExportQuery__
 *
 * To run a query within a React component, call `useProformaPremierExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaPremierExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaPremierExportQuery({
 *   variables: {
 *      outgoing_proforma_invoice_ids: // value for 'outgoing_proforma_invoice_ids'
 *   },
 * });
 */
export function useProformaPremierExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProformaPremierExportQuery, ProformaPremierExportQueryVariables> & ({ variables: ProformaPremierExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>(ProformaPremierExportDocument, options);
      }
export function useProformaPremierExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>(ProformaPremierExportDocument, options);
        }
export function useProformaPremierExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>(ProformaPremierExportDocument, options);
        }
export type ProformaPremierExportQueryHookResult = ReturnType<typeof useProformaPremierExportQuery>;
export type ProformaPremierExportLazyQueryHookResult = ReturnType<typeof useProformaPremierExportLazyQuery>;
export type ProformaPremierExportSuspenseQueryHookResult = ReturnType<typeof useProformaPremierExportSuspenseQuery>;
export type ProformaPremierExportQueryResult = ApolloReactCommon.QueryResult<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>;
export const DeleteRequestForInvoicingDocument = gql`
    mutation DeleteRequestForInvoicing($id: ID!) {
  deleteRequestForInvoicing(id: $id) {
    id
  }
}
    `;
export type DeleteRequestForInvoicingMutationFn = ApolloReactCommon.MutationFunction<DeleteRequestForInvoicingMutation, DeleteRequestForInvoicingMutationVariables>;

/**
 * __useDeleteRequestForInvoicingMutation__
 *
 * To run a mutation, you first call `useDeleteRequestForInvoicingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestForInvoicingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestForInvoicingMutation, { data, loading, error }] = useDeleteRequestForInvoicingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequestForInvoicingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRequestForInvoicingMutation, DeleteRequestForInvoicingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRequestForInvoicingMutation, DeleteRequestForInvoicingMutationVariables>(DeleteRequestForInvoicingDocument, options);
      }
export type DeleteRequestForInvoicingMutationHookResult = ReturnType<typeof useDeleteRequestForInvoicingMutation>;
export type DeleteRequestForInvoicingMutationResult = ApolloReactCommon.MutationResult<DeleteRequestForInvoicingMutation>;
export type DeleteRequestForInvoicingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRequestForInvoicingMutation, DeleteRequestForInvoicingMutationVariables>;
export const SubmitRequestForInvoicingDocument = gql`
    mutation SubmitRequestForInvoicing($id: ID!) {
  submitRequestForInvoicing(id: $id) {
    id
  }
}
    `;
export type SubmitRequestForInvoicingMutationFn = ApolloReactCommon.MutationFunction<SubmitRequestForInvoicingMutation, SubmitRequestForInvoicingMutationVariables>;

/**
 * __useSubmitRequestForInvoicingMutation__
 *
 * To run a mutation, you first call `useSubmitRequestForInvoicingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRequestForInvoicingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRequestForInvoicingMutation, { data, loading, error }] = useSubmitRequestForInvoicingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitRequestForInvoicingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitRequestForInvoicingMutation, SubmitRequestForInvoicingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitRequestForInvoicingMutation, SubmitRequestForInvoicingMutationVariables>(SubmitRequestForInvoicingDocument, options);
      }
export type SubmitRequestForInvoicingMutationHookResult = ReturnType<typeof useSubmitRequestForInvoicingMutation>;
export type SubmitRequestForInvoicingMutationResult = ApolloReactCommon.MutationResult<SubmitRequestForInvoicingMutation>;
export type SubmitRequestForInvoicingMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitRequestForInvoicingMutation, SubmitRequestForInvoicingMutationVariables>;
export const DeleteRequestsForInvoicingBulkDocument = gql`
    mutation DeleteRequestsForInvoicingBulk($id: [ID!]!) {
  deleteRequestsForInvoicingBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type DeleteRequestsForInvoicingBulkMutationFn = ApolloReactCommon.MutationFunction<DeleteRequestsForInvoicingBulkMutation, DeleteRequestsForInvoicingBulkMutationVariables>;

/**
 * __useDeleteRequestsForInvoicingBulkMutation__
 *
 * To run a mutation, you first call `useDeleteRequestsForInvoicingBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestsForInvoicingBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestsForInvoicingBulkMutation, { data, loading, error }] = useDeleteRequestsForInvoicingBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequestsForInvoicingBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRequestsForInvoicingBulkMutation, DeleteRequestsForInvoicingBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRequestsForInvoicingBulkMutation, DeleteRequestsForInvoicingBulkMutationVariables>(DeleteRequestsForInvoicingBulkDocument, options);
      }
export type DeleteRequestsForInvoicingBulkMutationHookResult = ReturnType<typeof useDeleteRequestsForInvoicingBulkMutation>;
export type DeleteRequestsForInvoicingBulkMutationResult = ApolloReactCommon.MutationResult<DeleteRequestsForInvoicingBulkMutation>;
export type DeleteRequestsForInvoicingBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRequestsForInvoicingBulkMutation, DeleteRequestsForInvoicingBulkMutationVariables>;
export const SubmitRequestsForInvoicingBulkDocument = gql`
    mutation SubmitRequestsForInvoicingBulk($id: [ID!]!) {
  submitRequestsForInvoicingBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type SubmitRequestsForInvoicingBulkMutationFn = ApolloReactCommon.MutationFunction<SubmitRequestsForInvoicingBulkMutation, SubmitRequestsForInvoicingBulkMutationVariables>;

/**
 * __useSubmitRequestsForInvoicingBulkMutation__
 *
 * To run a mutation, you first call `useSubmitRequestsForInvoicingBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRequestsForInvoicingBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRequestsForInvoicingBulkMutation, { data, loading, error }] = useSubmitRequestsForInvoicingBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitRequestsForInvoicingBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitRequestsForInvoicingBulkMutation, SubmitRequestsForInvoicingBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitRequestsForInvoicingBulkMutation, SubmitRequestsForInvoicingBulkMutationVariables>(SubmitRequestsForInvoicingBulkDocument, options);
      }
export type SubmitRequestsForInvoicingBulkMutationHookResult = ReturnType<typeof useSubmitRequestsForInvoicingBulkMutation>;
export type SubmitRequestsForInvoicingBulkMutationResult = ApolloReactCommon.MutationResult<SubmitRequestsForInvoicingBulkMutation>;
export type SubmitRequestsForInvoicingBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitRequestsForInvoicingBulkMutation, SubmitRequestsForInvoicingBulkMutationVariables>;
export const GetRequestsForInvoicingDocument = gql`
    query GetRequestsForInvoicing($page: Int, $first: Int, $filters: RequestForInvoicingQueryArgs) {
  requestsForInvoicingSummary(filters: $filters) {
    requestForInvoicingIds
  }
  requestsForInvoicing(page: $page, first: $first, filters: $filters) {
    data {
      id
      type
      status
      date_of_supply
      created_at
      submit_date
      note
      internal_note
      brands {
        id
        name
      }
      stats {
        total_amount
        total_amount_with_vat
      }
      projects {
        id
        title
        code
      }
      owner {
        id
      }
      invoicePaymentMethod {
        ...InvoicePaymentMethod
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${InvoicePaymentMethodFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGetRequestsForInvoicingQuery__
 *
 * To run a query within a React component, call `useGetRequestsForInvoicingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsForInvoicingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsForInvoicingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRequestsForInvoicingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>(GetRequestsForInvoicingDocument, options);
      }
export function useGetRequestsForInvoicingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>(GetRequestsForInvoicingDocument, options);
        }
export function useGetRequestsForInvoicingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>(GetRequestsForInvoicingDocument, options);
        }
export type GetRequestsForInvoicingQueryHookResult = ReturnType<typeof useGetRequestsForInvoicingQuery>;
export type GetRequestsForInvoicingLazyQueryHookResult = ReturnType<typeof useGetRequestsForInvoicingLazyQuery>;
export type GetRequestsForInvoicingSuspenseQueryHookResult = ReturnType<typeof useGetRequestsForInvoicingSuspenseQuery>;
export type GetRequestsForInvoicingQueryResult = ApolloReactCommon.QueryResult<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>;
export const GetRequestsForInvoicingSummaryDocument = gql`
    query GetRequestsForInvoicingSummary($filters: RequestForInvoicingQueryArgs) {
  requestsForInvoicingSummary(filters: $filters) {
    requestForInvoicingIds
  }
}
    `;

/**
 * __useGetRequestsForInvoicingSummaryQuery__
 *
 * To run a query within a React component, call `useGetRequestsForInvoicingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsForInvoicingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsForInvoicingSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRequestsForInvoicingSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>(GetRequestsForInvoicingSummaryDocument, options);
      }
export function useGetRequestsForInvoicingSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>(GetRequestsForInvoicingSummaryDocument, options);
        }
export function useGetRequestsForInvoicingSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>(GetRequestsForInvoicingSummaryDocument, options);
        }
export type GetRequestsForInvoicingSummaryQueryHookResult = ReturnType<typeof useGetRequestsForInvoicingSummaryQuery>;
export type GetRequestsForInvoicingSummaryLazyQueryHookResult = ReturnType<typeof useGetRequestsForInvoicingSummaryLazyQuery>;
export type GetRequestsForInvoicingSummarySuspenseQueryHookResult = ReturnType<typeof useGetRequestsForInvoicingSummarySuspenseQuery>;
export type GetRequestsForInvoicingSummaryQueryResult = ApolloReactCommon.QueryResult<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>;
export const RequestsForInvoicingFiltersDocument = gql`
    query RequestsForInvoicingFilters {
  clientsSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  brandsSimpleMap: clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

/**
 * __useRequestsForInvoicingFiltersQuery__
 *
 * To run a query within a React component, call `useRequestsForInvoicingFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsForInvoicingFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsForInvoicingFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestsForInvoicingFiltersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>(RequestsForInvoicingFiltersDocument, options);
      }
export function useRequestsForInvoicingFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>(RequestsForInvoicingFiltersDocument, options);
        }
export function useRequestsForInvoicingFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>(RequestsForInvoicingFiltersDocument, options);
        }
export type RequestsForInvoicingFiltersQueryHookResult = ReturnType<typeof useRequestsForInvoicingFiltersQuery>;
export type RequestsForInvoicingFiltersLazyQueryHookResult = ReturnType<typeof useRequestsForInvoicingFiltersLazyQuery>;
export type RequestsForInvoicingFiltersSuspenseQueryHookResult = ReturnType<typeof useRequestsForInvoicingFiltersSuspenseQuery>;
export type RequestsForInvoicingFiltersQueryResult = ApolloReactCommon.QueryResult<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>;
export const OutgoingInvoiceItemsListingDocument = gql`
    query OutgoingInvoiceItemsListing($filters: OIBudgetItemsTimeBillingQueryArgs) {
  oiBudgetItemsForTimeBilling(filters: $filters) {
    data {
      ...InvoiceBudgetItemListItem
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${InvoiceBudgetItemListItemFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useOutgoingInvoiceItemsListingQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceItemsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceItemsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceItemsListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOutgoingInvoiceItemsListingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>(OutgoingInvoiceItemsListingDocument, options);
      }
export function useOutgoingInvoiceItemsListingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>(OutgoingInvoiceItemsListingDocument, options);
        }
export function useOutgoingInvoiceItemsListingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>(OutgoingInvoiceItemsListingDocument, options);
        }
export type OutgoingInvoiceItemsListingQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingQuery>;
export type OutgoingInvoiceItemsListingLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingLazyQuery>;
export type OutgoingInvoiceItemsListingSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingSuspenseQuery>;
export type OutgoingInvoiceItemsListingQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>;
export const OutgoingInvoiceItemsListingSummaryDocument = gql`
    query OutgoingInvoiceItemsListingSummary($filters: OIBudgetItemsTimeBillingQueryArgs) {
  oiBudgetItemsForTimeBillingSummary(filters: $filters) {
    count
    amount
  }
}
    `;

/**
 * __useOutgoingInvoiceItemsListingSummaryQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceItemsListingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceItemsListingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceItemsListingSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOutgoingInvoiceItemsListingSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>(OutgoingInvoiceItemsListingSummaryDocument, options);
      }
export function useOutgoingInvoiceItemsListingSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>(OutgoingInvoiceItemsListingSummaryDocument, options);
        }
export function useOutgoingInvoiceItemsListingSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>(OutgoingInvoiceItemsListingSummaryDocument, options);
        }
export type OutgoingInvoiceItemsListingSummaryQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingSummaryQuery>;
export type OutgoingInvoiceItemsListingSummaryLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingSummaryLazyQuery>;
export type OutgoingInvoiceItemsListingSummarySuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingSummarySuspenseQuery>;
export type OutgoingInvoiceItemsListingSummaryQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>;
export const OutgoingInvoiceItemsListingFilterOptionsDocument = gql`
    query OutgoingInvoiceItemsListingFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    title
    code
  }
  projectManagerSimpleMap {
    id
    full_name
  }
  projectCategories {
    id
    name
  }
}
    `;

/**
 * __useOutgoingInvoiceItemsListingFilterOptionsQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceItemsListingFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceItemsListingFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceItemsListingFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutgoingInvoiceItemsListingFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>(OutgoingInvoiceItemsListingFilterOptionsDocument, options);
      }
export function useOutgoingInvoiceItemsListingFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>(OutgoingInvoiceItemsListingFilterOptionsDocument, options);
        }
export function useOutgoingInvoiceItemsListingFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>(OutgoingInvoiceItemsListingFilterOptionsDocument, options);
        }
export type OutgoingInvoiceItemsListingFilterOptionsQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingFilterOptionsQuery>;
export type OutgoingInvoiceItemsListingFilterOptionsLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingFilterOptionsLazyQuery>;
export type OutgoingInvoiceItemsListingFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingFilterOptionsSuspenseQuery>;
export type OutgoingInvoiceItemsListingFilterOptionsQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>;
export const OutgoingInvoiceItemsListingBudgetItemFilterOptionsDocument = gql`
    query OutgoingInvoiceItemsListingBudgetItemFilterOptions($projectId: ID!) {
  ourWorkBudgetItemsSimpleMap(project_id: [$projectId]) {
    id
    title
    category {
      name
    }
  }
  expenseBudgetItemsSimpleMap(project_id: $projectId) {
    id
    title
    category {
      name
    }
  }
}
    `;

/**
 * __useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables> & ({ variables: OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>(OutgoingInvoiceItemsListingBudgetItemFilterOptionsDocument, options);
      }
export function useOutgoingInvoiceItemsListingBudgetItemFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>(OutgoingInvoiceItemsListingBudgetItemFilterOptionsDocument, options);
        }
export function useOutgoingInvoiceItemsListingBudgetItemFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>(OutgoingInvoiceItemsListingBudgetItemFilterOptionsDocument, options);
        }
export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery>;
export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingBudgetItemFilterOptionsLazyQuery>;
export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceItemsListingBudgetItemFilterOptionsSuspenseQuery>;
export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>;
export const MarkOutgoingInvoiceAsPaidDocument = gql`
    mutation MarkOutgoingInvoiceAsPaid($id: ID!, $date: Date) {
  markOutgoingInvoiceAsPaid(id: $id, date: $date) {
    id
  }
}
    `;
export type MarkOutgoingInvoiceAsPaidMutationFn = ApolloReactCommon.MutationFunction<MarkOutgoingInvoiceAsPaidMutation, MarkOutgoingInvoiceAsPaidMutationVariables>;

/**
 * __useMarkOutgoingInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkOutgoingInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOutgoingInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOutgoingInvoiceAsPaidMutation, { data, loading, error }] = useMarkOutgoingInvoiceAsPaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useMarkOutgoingInvoiceAsPaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkOutgoingInvoiceAsPaidMutation, MarkOutgoingInvoiceAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkOutgoingInvoiceAsPaidMutation, MarkOutgoingInvoiceAsPaidMutationVariables>(MarkOutgoingInvoiceAsPaidDocument, options);
      }
export type MarkOutgoingInvoiceAsPaidMutationHookResult = ReturnType<typeof useMarkOutgoingInvoiceAsPaidMutation>;
export type MarkOutgoingInvoiceAsPaidMutationResult = ApolloReactCommon.MutationResult<MarkOutgoingInvoiceAsPaidMutation>;
export type MarkOutgoingInvoiceAsPaidMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkOutgoingInvoiceAsPaidMutation, MarkOutgoingInvoiceAsPaidMutationVariables>;
export const MarkOutgoingInvoiceAsUnpaidDocument = gql`
    mutation MarkOutgoingInvoiceAsUnpaid($id: ID!, $remove_matched_payments: Boolean! = false) {
  markOutgoingInvoiceAsUnpaid(
    id: $id
    remove_matched_payments: $remove_matched_payments
  ) {
    id
    paid_at
  }
}
    `;
export type MarkOutgoingInvoiceAsUnpaidMutationFn = ApolloReactCommon.MutationFunction<MarkOutgoingInvoiceAsUnpaidMutation, MarkOutgoingInvoiceAsUnpaidMutationVariables>;

/**
 * __useMarkOutgoingInvoiceAsUnpaidMutation__
 *
 * To run a mutation, you first call `useMarkOutgoingInvoiceAsUnpaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOutgoingInvoiceAsUnpaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOutgoingInvoiceAsUnpaidMutation, { data, loading, error }] = useMarkOutgoingInvoiceAsUnpaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      remove_matched_payments: // value for 'remove_matched_payments'
 *   },
 * });
 */
export function useMarkOutgoingInvoiceAsUnpaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkOutgoingInvoiceAsUnpaidMutation, MarkOutgoingInvoiceAsUnpaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkOutgoingInvoiceAsUnpaidMutation, MarkOutgoingInvoiceAsUnpaidMutationVariables>(MarkOutgoingInvoiceAsUnpaidDocument, options);
      }
export type MarkOutgoingInvoiceAsUnpaidMutationHookResult = ReturnType<typeof useMarkOutgoingInvoiceAsUnpaidMutation>;
export type MarkOutgoingInvoiceAsUnpaidMutationResult = ApolloReactCommon.MutationResult<MarkOutgoingInvoiceAsUnpaidMutation>;
export type MarkOutgoingInvoiceAsUnpaidMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkOutgoingInvoiceAsUnpaidMutation, MarkOutgoingInvoiceAsUnpaidMutationVariables>;
export const MarkOutgoingInvoiceAsPaidBulkDocument = gql`
    mutation MarkOutgoingInvoiceAsPaidBulk($id: [ID!]!, $date: Date) {
  markOutgoingInvoiceAsPaidBulk(id: $id, date: $date) {
    total
    successful
    failed
  }
}
    `;
export type MarkOutgoingInvoiceAsPaidBulkMutationFn = ApolloReactCommon.MutationFunction<MarkOutgoingInvoiceAsPaidBulkMutation, MarkOutgoingInvoiceAsPaidBulkMutationVariables>;

/**
 * __useMarkOutgoingInvoiceAsPaidBulkMutation__
 *
 * To run a mutation, you first call `useMarkOutgoingInvoiceAsPaidBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOutgoingInvoiceAsPaidBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOutgoingInvoiceAsPaidBulkMutation, { data, loading, error }] = useMarkOutgoingInvoiceAsPaidBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useMarkOutgoingInvoiceAsPaidBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkOutgoingInvoiceAsPaidBulkMutation, MarkOutgoingInvoiceAsPaidBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkOutgoingInvoiceAsPaidBulkMutation, MarkOutgoingInvoiceAsPaidBulkMutationVariables>(MarkOutgoingInvoiceAsPaidBulkDocument, options);
      }
export type MarkOutgoingInvoiceAsPaidBulkMutationHookResult = ReturnType<typeof useMarkOutgoingInvoiceAsPaidBulkMutation>;
export type MarkOutgoingInvoiceAsPaidBulkMutationResult = ApolloReactCommon.MutationResult<MarkOutgoingInvoiceAsPaidBulkMutation>;
export type MarkOutgoingInvoiceAsPaidBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkOutgoingInvoiceAsPaidBulkMutation, MarkOutgoingInvoiceAsPaidBulkMutationVariables>;
export const SendOutgoingInvoiceDocument = gql`
    mutation SendOutgoingInvoice($id: ID!, $recipients: [String], $subject: String, $content: String, $attachments: [ID]) {
  sendOutgoingInvoice(
    id: $id
    recipients: $recipients
    subject: $subject
    content: $content
    attachments: $attachments
  )
}
    `;
export type SendOutgoingInvoiceMutationFn = ApolloReactCommon.MutationFunction<SendOutgoingInvoiceMutation, SendOutgoingInvoiceMutationVariables>;

/**
 * __useSendOutgoingInvoiceMutation__
 *
 * To run a mutation, you first call `useSendOutgoingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOutgoingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOutgoingInvoiceMutation, { data, loading, error }] = useSendOutgoingInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      recipients: // value for 'recipients'
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendOutgoingInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendOutgoingInvoiceMutation, SendOutgoingInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendOutgoingInvoiceMutation, SendOutgoingInvoiceMutationVariables>(SendOutgoingInvoiceDocument, options);
      }
export type SendOutgoingInvoiceMutationHookResult = ReturnType<typeof useSendOutgoingInvoiceMutation>;
export type SendOutgoingInvoiceMutationResult = ApolloReactCommon.MutationResult<SendOutgoingInvoiceMutation>;
export type SendOutgoingInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<SendOutgoingInvoiceMutation, SendOutgoingInvoiceMutationVariables>;
export const SendOutgoingInvoiceBulkDocument = gql`
    mutation SendOutgoingInvoiceBulk($ids: [ID!]!) {
  sendOutgoingInvoiceBulk(id: $ids)
}
    `;
export type SendOutgoingInvoiceBulkMutationFn = ApolloReactCommon.MutationFunction<SendOutgoingInvoiceBulkMutation, SendOutgoingInvoiceBulkMutationVariables>;

/**
 * __useSendOutgoingInvoiceBulkMutation__
 *
 * To run a mutation, you first call `useSendOutgoingInvoiceBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOutgoingInvoiceBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOutgoingInvoiceBulkMutation, { data, loading, error }] = useSendOutgoingInvoiceBulkMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSendOutgoingInvoiceBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendOutgoingInvoiceBulkMutation, SendOutgoingInvoiceBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendOutgoingInvoiceBulkMutation, SendOutgoingInvoiceBulkMutationVariables>(SendOutgoingInvoiceBulkDocument, options);
      }
export type SendOutgoingInvoiceBulkMutationHookResult = ReturnType<typeof useSendOutgoingInvoiceBulkMutation>;
export type SendOutgoingInvoiceBulkMutationResult = ApolloReactCommon.MutationResult<SendOutgoingInvoiceBulkMutation>;
export type SendOutgoingInvoiceBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<SendOutgoingInvoiceBulkMutation, SendOutgoingInvoiceBulkMutationVariables>;
export const UpdateOutgoingInvoiceNumberDocument = gql`
    mutation UpdateOutgoingInvoiceNumber($input: UpdateOutgoingInvoiceNumberInput) {
  updateOutgoingInvoiceNumber(input: $input, force: true) {
    id
  }
}
    `;
export type UpdateOutgoingInvoiceNumberMutationFn = ApolloReactCommon.MutationFunction<UpdateOutgoingInvoiceNumberMutation, UpdateOutgoingInvoiceNumberMutationVariables>;

/**
 * __useUpdateOutgoingInvoiceNumberMutation__
 *
 * To run a mutation, you first call `useUpdateOutgoingInvoiceNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutgoingInvoiceNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutgoingInvoiceNumberMutation, { data, loading, error }] = useUpdateOutgoingInvoiceNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOutgoingInvoiceNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOutgoingInvoiceNumberMutation, UpdateOutgoingInvoiceNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOutgoingInvoiceNumberMutation, UpdateOutgoingInvoiceNumberMutationVariables>(UpdateOutgoingInvoiceNumberDocument, options);
      }
export type UpdateOutgoingInvoiceNumberMutationHookResult = ReturnType<typeof useUpdateOutgoingInvoiceNumberMutation>;
export type UpdateOutgoingInvoiceNumberMutationResult = ApolloReactCommon.MutationResult<UpdateOutgoingInvoiceNumberMutation>;
export type UpdateOutgoingInvoiceNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOutgoingInvoiceNumberMutation, UpdateOutgoingInvoiceNumberMutationVariables>;
export const DeleteOutgoingInvoiceDocument = gql`
    mutation DeleteOutgoingInvoice($id: ID!) {
  deleteOutgoingInvoice(id: $id)
}
    `;
export type DeleteOutgoingInvoiceMutationFn = ApolloReactCommon.MutationFunction<DeleteOutgoingInvoiceMutation, DeleteOutgoingInvoiceMutationVariables>;

/**
 * __useDeleteOutgoingInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteOutgoingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOutgoingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOutgoingInvoiceMutation, { data, loading, error }] = useDeleteOutgoingInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOutgoingInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOutgoingInvoiceMutation, DeleteOutgoingInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOutgoingInvoiceMutation, DeleteOutgoingInvoiceMutationVariables>(DeleteOutgoingInvoiceDocument, options);
      }
export type DeleteOutgoingInvoiceMutationHookResult = ReturnType<typeof useDeleteOutgoingInvoiceMutation>;
export type DeleteOutgoingInvoiceMutationResult = ApolloReactCommon.MutationResult<DeleteOutgoingInvoiceMutation>;
export type DeleteOutgoingInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOutgoingInvoiceMutation, DeleteOutgoingInvoiceMutationVariables>;
export const GetOutgoingInvoicesFilterOptionsDocument = gql`
    query GetOutgoingInvoicesFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  projectCategories {
    id
    name
  }
  projectsSimpleMap {
    id
    code
    title
  }
}
    `;

/**
 * __useGetOutgoingInvoicesFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetOutgoingInvoicesFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutgoingInvoicesFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutgoingInvoicesFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOutgoingInvoicesFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>(GetOutgoingInvoicesFilterOptionsDocument, options);
      }
export function useGetOutgoingInvoicesFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>(GetOutgoingInvoicesFilterOptionsDocument, options);
        }
export function useGetOutgoingInvoicesFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>(GetOutgoingInvoicesFilterOptionsDocument, options);
        }
export type GetOutgoingInvoicesFilterOptionsQueryHookResult = ReturnType<typeof useGetOutgoingInvoicesFilterOptionsQuery>;
export type GetOutgoingInvoicesFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetOutgoingInvoicesFilterOptionsLazyQuery>;
export type GetOutgoingInvoicesFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetOutgoingInvoicesFilterOptionsSuspenseQuery>;
export type GetOutgoingInvoicesFilterOptionsQueryResult = ApolloReactCommon.QueryResult<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>;
export const GetInvoiceEmailDataDocument = gql`
    query GetInvoiceEmailData($outgoing_invoice_id: ID!) {
  getInvoiceEmailData(outgoing_invoice_id: $outgoing_invoice_id) {
    ...EmailData
  }
}
    ${EmailDataFragmentDoc}`;

/**
 * __useGetInvoiceEmailDataQuery__
 *
 * To run a query within a React component, call `useGetInvoiceEmailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceEmailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceEmailDataQuery({
 *   variables: {
 *      outgoing_invoice_id: // value for 'outgoing_invoice_id'
 *   },
 * });
 */
export function useGetInvoiceEmailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables> & ({ variables: GetInvoiceEmailDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>(GetInvoiceEmailDataDocument, options);
      }
export function useGetInvoiceEmailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>(GetInvoiceEmailDataDocument, options);
        }
export function useGetInvoiceEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>(GetInvoiceEmailDataDocument, options);
        }
export type GetInvoiceEmailDataQueryHookResult = ReturnType<typeof useGetInvoiceEmailDataQuery>;
export type GetInvoiceEmailDataLazyQueryHookResult = ReturnType<typeof useGetInvoiceEmailDataLazyQuery>;
export type GetInvoiceEmailDataSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceEmailDataSuspenseQuery>;
export type GetInvoiceEmailDataQueryResult = ApolloReactCommon.QueryResult<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>;
export const GetOutgoingInvoiceSuggestedNumberDocument = gql`
    query GetOutgoingInvoiceSuggestedNumber($id: ID) {
  outgoingInvoice(id: $id) {
    sequence {
      next_invoice_no
    }
  }
}
    `;

/**
 * __useGetOutgoingInvoiceSuggestedNumberQuery__
 *
 * To run a query within a React component, call `useGetOutgoingInvoiceSuggestedNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutgoingInvoiceSuggestedNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutgoingInvoiceSuggestedNumberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOutgoingInvoiceSuggestedNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>(GetOutgoingInvoiceSuggestedNumberDocument, options);
      }
export function useGetOutgoingInvoiceSuggestedNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>(GetOutgoingInvoiceSuggestedNumberDocument, options);
        }
export function useGetOutgoingInvoiceSuggestedNumberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>(GetOutgoingInvoiceSuggestedNumberDocument, options);
        }
export type GetOutgoingInvoiceSuggestedNumberQueryHookResult = ReturnType<typeof useGetOutgoingInvoiceSuggestedNumberQuery>;
export type GetOutgoingInvoiceSuggestedNumberLazyQueryHookResult = ReturnType<typeof useGetOutgoingInvoiceSuggestedNumberLazyQuery>;
export type GetOutgoingInvoiceSuggestedNumberSuspenseQueryHookResult = ReturnType<typeof useGetOutgoingInvoiceSuggestedNumberSuspenseQuery>;
export type GetOutgoingInvoiceSuggestedNumberQueryResult = ApolloReactCommon.QueryResult<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>;
export const GetOutgoingInvoicesDocument = gql`
    query GetOutgoingInvoices($page: Int, $first: Int, $filters: OIQueryArgs) {
  outgoingInvoices(page: $page, first: $first, filters: $filters) {
    data {
      id
      ...OutgoingInvoiceCoreParts
      paid_at
      note
      internal_note
      abraflexi_exported
      xero_exported
      documentExports {
        ...DocumentExport
      }
      workspace_company_id
      exchange_rate
      invoicePdf {
        preview
        download
      }
      has_proforma_payments
      proformaInvoicesPivot {
        invoice {
          id
          invoice_no
        }
      }
      relatesToOutgoingProformaInvoice {
        id
        invoicePdf {
          preview
          download
        }
      }
      owner {
        id
        email
      }
      contact {
        email
      }
      brands {
        id
        name
      }
      billingEntity {
        invoice_email
        internal_name
        street
        city
      }
      projects {
        id
        title
        code
      }
      emailLogs {
        ...EmailLog
      }
      stats {
        total_amount
        total_amount_with_vat
        total_amount_in_currency
        total_amount_with_vat_in_currency
        billing_amount
        billing_amount_with_vat
      }
      accountMoves {
        id
        bank_account_move_id
        amount
        amount_in_move_currency
        exchange_rate
        bankAccountMove {
          ...AccountMove
        }
      }
      projectTimeBilling {
        id
        is_locked
      }
      modelLock {
        ...ModelLock
      }
      invoicePaymentMethod {
        ...InvoicePaymentMethod
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${OutgoingInvoiceCorePartsFragmentDoc}
${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useGetOutgoingInvoicesQuery__
 *
 * To run a query within a React component, call `useGetOutgoingInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutgoingInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutgoingInvoicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOutgoingInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>(GetOutgoingInvoicesDocument, options);
      }
export function useGetOutgoingInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>(GetOutgoingInvoicesDocument, options);
        }
export function useGetOutgoingInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>(GetOutgoingInvoicesDocument, options);
        }
export type GetOutgoingInvoicesQueryHookResult = ReturnType<typeof useGetOutgoingInvoicesQuery>;
export type GetOutgoingInvoicesLazyQueryHookResult = ReturnType<typeof useGetOutgoingInvoicesLazyQuery>;
export type GetOutgoingInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetOutgoingInvoicesSuspenseQuery>;
export type GetOutgoingInvoicesQueryResult = ApolloReactCommon.QueryResult<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>;
export const GetOutgoingInvoicePrepaymentSplitsDocument = gql`
    query GetOutgoingInvoicePrepaymentSplits($id: ID!) {
  outgoingInvoice(id: $id) {
    prepaymentSplits {
      id
      brandCreditAccount {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetOutgoingInvoicePrepaymentSplitsQuery__
 *
 * To run a query within a React component, call `useGetOutgoingInvoicePrepaymentSplitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutgoingInvoicePrepaymentSplitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutgoingInvoicePrepaymentSplitsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOutgoingInvoicePrepaymentSplitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables> & ({ variables: GetOutgoingInvoicePrepaymentSplitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>(GetOutgoingInvoicePrepaymentSplitsDocument, options);
      }
export function useGetOutgoingInvoicePrepaymentSplitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>(GetOutgoingInvoicePrepaymentSplitsDocument, options);
        }
export function useGetOutgoingInvoicePrepaymentSplitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>(GetOutgoingInvoicePrepaymentSplitsDocument, options);
        }
export type GetOutgoingInvoicePrepaymentSplitsQueryHookResult = ReturnType<typeof useGetOutgoingInvoicePrepaymentSplitsQuery>;
export type GetOutgoingInvoicePrepaymentSplitsLazyQueryHookResult = ReturnType<typeof useGetOutgoingInvoicePrepaymentSplitsLazyQuery>;
export type GetOutgoingInvoicePrepaymentSplitsSuspenseQueryHookResult = ReturnType<typeof useGetOutgoingInvoicePrepaymentSplitsSuspenseQuery>;
export type GetOutgoingInvoicePrepaymentSplitsQueryResult = ApolloReactCommon.QueryResult<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>;
export const CfExportDocument = gql`
    query cfExport($from: Date, $to: Date) {
  cfExport(from: $from, to: $to)
}
    `;

/**
 * __useCfExportQuery__
 *
 * To run a query within a React component, call `useCfExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCfExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCfExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCfExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CfExportQuery, CfExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CfExportQuery, CfExportQueryVariables>(CfExportDocument, options);
      }
export function useCfExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CfExportQuery, CfExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CfExportQuery, CfExportQueryVariables>(CfExportDocument, options);
        }
export function useCfExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CfExportQuery, CfExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CfExportQuery, CfExportQueryVariables>(CfExportDocument, options);
        }
export type CfExportQueryHookResult = ReturnType<typeof useCfExportQuery>;
export type CfExportLazyQueryHookResult = ReturnType<typeof useCfExportLazyQuery>;
export type CfExportSuspenseQueryHookResult = ReturnType<typeof useCfExportSuspenseQuery>;
export type CfExportQueryResult = ApolloReactCommon.QueryResult<CfExportQuery, CfExportQueryVariables>;
export const NotPaidOiExportDocument = gql`
    query notPaidOIExport($filters: OIQueryArgs, $date: Date) {
  notPaidOIExport(filters: $filters, date: $date)
}
    `;

/**
 * __useNotPaidOiExportQuery__
 *
 * To run a query within a React component, call `useNotPaidOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotPaidOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotPaidOiExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useNotPaidOiExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>(NotPaidOiExportDocument, options);
      }
export function useNotPaidOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>(NotPaidOiExportDocument, options);
        }
export function useNotPaidOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>(NotPaidOiExportDocument, options);
        }
export type NotPaidOiExportQueryHookResult = ReturnType<typeof useNotPaidOiExportQuery>;
export type NotPaidOiExportLazyQueryHookResult = ReturnType<typeof useNotPaidOiExportLazyQuery>;
export type NotPaidOiExportSuspenseQueryHookResult = ReturnType<typeof useNotPaidOiExportSuspenseQuery>;
export type NotPaidOiExportQueryResult = ApolloReactCommon.QueryResult<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>;
export const ClientOiExportDocument = gql`
    query clientOIExport($filters: OIQueryArgs, $from: Date, $to: Date) {
  clientOIExport(filters: $filters, from: $from, to: $to)
}
    `;

/**
 * __useClientOiExportQuery__
 *
 * To run a query within a React component, call `useClientOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOiExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useClientOiExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientOiExportQuery, ClientOiExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientOiExportQuery, ClientOiExportQueryVariables>(ClientOiExportDocument, options);
      }
export function useClientOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientOiExportQuery, ClientOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientOiExportQuery, ClientOiExportQueryVariables>(ClientOiExportDocument, options);
        }
export function useClientOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientOiExportQuery, ClientOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientOiExportQuery, ClientOiExportQueryVariables>(ClientOiExportDocument, options);
        }
export type ClientOiExportQueryHookResult = ReturnType<typeof useClientOiExportQuery>;
export type ClientOiExportLazyQueryHookResult = ReturnType<typeof useClientOiExportLazyQuery>;
export type ClientOiExportSuspenseQueryHookResult = ReturnType<typeof useClientOiExportSuspenseQuery>;
export type ClientOiExportQueryResult = ApolloReactCommon.QueryResult<ClientOiExportQuery, ClientOiExportQueryVariables>;
export const MrpOiExportDocument = gql`
    query mrpOIExport($from: Date!, $to: Date!) {
  mrpOIExport(from: $from, to: $to)
}
    `;

/**
 * __useMrpOiExportQuery__
 *
 * To run a query within a React component, call `useMrpOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMrpOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMrpOiExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMrpOiExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MrpOiExportQuery, MrpOiExportQueryVariables> & ({ variables: MrpOiExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MrpOiExportQuery, MrpOiExportQueryVariables>(MrpOiExportDocument, options);
      }
export function useMrpOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MrpOiExportQuery, MrpOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MrpOiExportQuery, MrpOiExportQueryVariables>(MrpOiExportDocument, options);
        }
export function useMrpOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MrpOiExportQuery, MrpOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MrpOiExportQuery, MrpOiExportQueryVariables>(MrpOiExportDocument, options);
        }
export type MrpOiExportQueryHookResult = ReturnType<typeof useMrpOiExportQuery>;
export type MrpOiExportLazyQueryHookResult = ReturnType<typeof useMrpOiExportLazyQuery>;
export type MrpOiExportSuspenseQueryHookResult = ReturnType<typeof useMrpOiExportSuspenseQuery>;
export type MrpOiExportQueryResult = ApolloReactCommon.QueryResult<MrpOiExportQuery, MrpOiExportQueryVariables>;
export const PohodaOiExportDocument = gql`
    query pohodaOIExport($ids: [ID!]!) {
  pohodaOIExport(outgoing_invoice_ids: $ids)
}
    `;

/**
 * __usePohodaOiExportQuery__
 *
 * To run a query within a React component, call `usePohodaOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePohodaOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePohodaOiExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePohodaOiExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PohodaOiExportQuery, PohodaOiExportQueryVariables> & ({ variables: PohodaOiExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PohodaOiExportQuery, PohodaOiExportQueryVariables>(PohodaOiExportDocument, options);
      }
export function usePohodaOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PohodaOiExportQuery, PohodaOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PohodaOiExportQuery, PohodaOiExportQueryVariables>(PohodaOiExportDocument, options);
        }
export function usePohodaOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PohodaOiExportQuery, PohodaOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PohodaOiExportQuery, PohodaOiExportQueryVariables>(PohodaOiExportDocument, options);
        }
export type PohodaOiExportQueryHookResult = ReturnType<typeof usePohodaOiExportQuery>;
export type PohodaOiExportLazyQueryHookResult = ReturnType<typeof usePohodaOiExportLazyQuery>;
export type PohodaOiExportSuspenseQueryHookResult = ReturnType<typeof usePohodaOiExportSuspenseQuery>;
export type PohodaOiExportQueryResult = ApolloReactCommon.QueryResult<PohodaOiExportQuery, PohodaOiExportQueryVariables>;
export const PremierOiExportDocument = gql`
    query PremierOIExport($outgoing_invoice_ids: [ID!]!) {
  premierOIExport(outgoing_invoice_ids: $outgoing_invoice_ids)
}
    `;

/**
 * __usePremierOiExportQuery__
 *
 * To run a query within a React component, call `usePremierOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremierOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremierOiExportQuery({
 *   variables: {
 *      outgoing_invoice_ids: // value for 'outgoing_invoice_ids'
 *   },
 * });
 */
export function usePremierOiExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PremierOiExportQuery, PremierOiExportQueryVariables> & ({ variables: PremierOiExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PremierOiExportQuery, PremierOiExportQueryVariables>(PremierOiExportDocument, options);
      }
export function usePremierOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PremierOiExportQuery, PremierOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PremierOiExportQuery, PremierOiExportQueryVariables>(PremierOiExportDocument, options);
        }
export function usePremierOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PremierOiExportQuery, PremierOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PremierOiExportQuery, PremierOiExportQueryVariables>(PremierOiExportDocument, options);
        }
export type PremierOiExportQueryHookResult = ReturnType<typeof usePremierOiExportQuery>;
export type PremierOiExportLazyQueryHookResult = ReturnType<typeof usePremierOiExportLazyQuery>;
export type PremierOiExportSuspenseQueryHookResult = ReturnType<typeof usePremierOiExportSuspenseQuery>;
export type PremierOiExportQueryResult = ApolloReactCommon.QueryResult<PremierOiExportQuery, PremierOiExportQueryVariables>;
export const ProlucOiExportDocument = gql`
    query prolucOIExport($from: Date!, $to: Date!) {
  prolucOIExport(from: $from, to: $to)
}
    `;

/**
 * __useProlucOiExportQuery__
 *
 * To run a query within a React component, call `useProlucOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProlucOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProlucOiExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useProlucOiExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProlucOiExportQuery, ProlucOiExportQueryVariables> & ({ variables: ProlucOiExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProlucOiExportQuery, ProlucOiExportQueryVariables>(ProlucOiExportDocument, options);
      }
export function useProlucOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProlucOiExportQuery, ProlucOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProlucOiExportQuery, ProlucOiExportQueryVariables>(ProlucOiExportDocument, options);
        }
export function useProlucOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProlucOiExportQuery, ProlucOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProlucOiExportQuery, ProlucOiExportQueryVariables>(ProlucOiExportDocument, options);
        }
export type ProlucOiExportQueryHookResult = ReturnType<typeof useProlucOiExportQuery>;
export type ProlucOiExportLazyQueryHookResult = ReturnType<typeof useProlucOiExportLazyQuery>;
export type ProlucOiExportSuspenseQueryHookResult = ReturnType<typeof useProlucOiExportSuspenseQuery>;
export type ProlucOiExportQueryResult = ApolloReactCommon.QueryResult<ProlucOiExportQuery, ProlucOiExportQueryVariables>;
export const BulkDownloadOutgoingInvoicesDocument = gql`
    query bulkDownloadOutgoingInvoices($ids: [ID!]!) {
  bulkDownloadOutgoingInvoices(ids: $ids)
}
    `;

/**
 * __useBulkDownloadOutgoingInvoicesQuery__
 *
 * To run a query within a React component, call `useBulkDownloadOutgoingInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkDownloadOutgoingInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDownloadOutgoingInvoicesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDownloadOutgoingInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables> & ({ variables: BulkDownloadOutgoingInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>(BulkDownloadOutgoingInvoicesDocument, options);
      }
export function useBulkDownloadOutgoingInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>(BulkDownloadOutgoingInvoicesDocument, options);
        }
export function useBulkDownloadOutgoingInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>(BulkDownloadOutgoingInvoicesDocument, options);
        }
export type BulkDownloadOutgoingInvoicesQueryHookResult = ReturnType<typeof useBulkDownloadOutgoingInvoicesQuery>;
export type BulkDownloadOutgoingInvoicesLazyQueryHookResult = ReturnType<typeof useBulkDownloadOutgoingInvoicesLazyQuery>;
export type BulkDownloadOutgoingInvoicesSuspenseQueryHookResult = ReturnType<typeof useBulkDownloadOutgoingInvoicesSuspenseQuery>;
export type BulkDownloadOutgoingInvoicesQueryResult = ApolloReactCommon.QueryResult<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>;
export const VarioOiExportDocument = gql`
    query varioOIExport($ids: [ID!]!) {
  varioOIExport(outgoing_invoice_ids: $ids)
}
    `;

/**
 * __useVarioOiExportQuery__
 *
 * To run a query within a React component, call `useVarioOiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVarioOiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVarioOiExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVarioOiExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VarioOiExportQuery, VarioOiExportQueryVariables> & ({ variables: VarioOiExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VarioOiExportQuery, VarioOiExportQueryVariables>(VarioOiExportDocument, options);
      }
export function useVarioOiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VarioOiExportQuery, VarioOiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VarioOiExportQuery, VarioOiExportQueryVariables>(VarioOiExportDocument, options);
        }
export function useVarioOiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VarioOiExportQuery, VarioOiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VarioOiExportQuery, VarioOiExportQueryVariables>(VarioOiExportDocument, options);
        }
export type VarioOiExportQueryHookResult = ReturnType<typeof useVarioOiExportQuery>;
export type VarioOiExportLazyQueryHookResult = ReturnType<typeof useVarioOiExportLazyQuery>;
export type VarioOiExportSuspenseQueryHookResult = ReturnType<typeof useVarioOiExportSuspenseQuery>;
export type VarioOiExportQueryResult = ApolloReactCommon.QueryResult<VarioOiExportQuery, VarioOiExportQueryVariables>;
export const OutgoingInvoiceOmegaExportDocument = gql`
    query OutgoingInvoiceOmegaExport($ids: [ID!]!) {
  omegaExport(outgoing_invoice_ids: $ids)
}
    `;

/**
 * __useOutgoingInvoiceOmegaExportQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceOmegaExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceOmegaExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceOmegaExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOutgoingInvoiceOmegaExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables> & ({ variables: OutgoingInvoiceOmegaExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>(OutgoingInvoiceOmegaExportDocument, options);
      }
export function useOutgoingInvoiceOmegaExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>(OutgoingInvoiceOmegaExportDocument, options);
        }
export function useOutgoingInvoiceOmegaExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>(OutgoingInvoiceOmegaExportDocument, options);
        }
export type OutgoingInvoiceOmegaExportQueryHookResult = ReturnType<typeof useOutgoingInvoiceOmegaExportQuery>;
export type OutgoingInvoiceOmegaExportLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceOmegaExportLazyQuery>;
export type OutgoingInvoiceOmegaExportSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceOmegaExportSuspenseQuery>;
export type OutgoingInvoiceOmegaExportQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>;
export const OutgoingInvoiceAbraFlexiExportDocument = gql`
    query OutgoingInvoiceAbraFlexiExport($ids: [ID!]!) {
  abraFlexiOIExport(outgoing_invoice_ids: $ids)
}
    `;

/**
 * __useOutgoingInvoiceAbraFlexiExportQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceAbraFlexiExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceAbraFlexiExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceAbraFlexiExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOutgoingInvoiceAbraFlexiExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables> & ({ variables: OutgoingInvoiceAbraFlexiExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>(OutgoingInvoiceAbraFlexiExportDocument, options);
      }
export function useOutgoingInvoiceAbraFlexiExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>(OutgoingInvoiceAbraFlexiExportDocument, options);
        }
export function useOutgoingInvoiceAbraFlexiExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>(OutgoingInvoiceAbraFlexiExportDocument, options);
        }
export type OutgoingInvoiceAbraFlexiExportQueryHookResult = ReturnType<typeof useOutgoingInvoiceAbraFlexiExportQuery>;
export type OutgoingInvoiceAbraFlexiExportLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceAbraFlexiExportLazyQuery>;
export type OutgoingInvoiceAbraFlexiExportSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceAbraFlexiExportSuspenseQuery>;
export type OutgoingInvoiceAbraFlexiExportQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>;
export const OutgoingInvoicesTableSummaryDocument = gql`
    query OutgoingInvoicesTableSummary($filters: OIQueryArgs) {
  outgoingInvoicesSummary(filters: $filters) {
    outgoingInvoiceIds
    total_amount
    total_vat
    total_amount_with_vat
    billing_amount
    billing_amount_vat
    billing_amount_with_vat
    paid_amount
    unpaid_amount
    payments_due_without_vat
    payments_due_vat
    payments_due
    overdue
    overdue_vat
    overdue_without_vat
    overdue_by_less_than_30_days_without_vat
    overdue_by_less_than_30_days_vat
    overdue_by_less_than_30_days
    overdue_by_31_to_90_days_without_vat
    overdue_by_31_to_90_days_vat
    overdue_by_31_to_90_days
    overdue_by_91_to_365_days_without_vat
    overdue_by_91_to_365_days_vat
    overdue_by_91_to_365_days
    overdue_by_more_than_365_days_without_vat
    overdue_by_more_than_365_days_vat
    overdue_by_more_than_365_days
    invoices
  }
}
    `;

/**
 * __useOutgoingInvoicesTableSummaryQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoicesTableSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoicesTableSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoicesTableSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOutgoingInvoicesTableSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>(OutgoingInvoicesTableSummaryDocument, options);
      }
export function useOutgoingInvoicesTableSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>(OutgoingInvoicesTableSummaryDocument, options);
        }
export function useOutgoingInvoicesTableSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>(OutgoingInvoicesTableSummaryDocument, options);
        }
export type OutgoingInvoicesTableSummaryQueryHookResult = ReturnType<typeof useOutgoingInvoicesTableSummaryQuery>;
export type OutgoingInvoicesTableSummaryLazyQueryHookResult = ReturnType<typeof useOutgoingInvoicesTableSummaryLazyQuery>;
export type OutgoingInvoicesTableSummarySuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoicesTableSummarySuspenseQuery>;
export type OutgoingInvoicesTableSummaryQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>;
export const ChangeOutgoingInvoiceDatesDocument = gql`
    mutation ChangeOutgoingInvoiceDates($id: ID!, $issue_date: Date!, $date_of_supply: Date!, $due_date: Date!, $paid_at: Date) {
  changeOutgoingInvoiceDates(
    id: $id
    issue_date: $issue_date
    date_of_supply: $date_of_supply
    due_date: $due_date
    paid_at: $paid_at
  )
}
    `;
export type ChangeOutgoingInvoiceDatesMutationFn = ApolloReactCommon.MutationFunction<ChangeOutgoingInvoiceDatesMutation, ChangeOutgoingInvoiceDatesMutationVariables>;

/**
 * __useChangeOutgoingInvoiceDatesMutation__
 *
 * To run a mutation, you first call `useChangeOutgoingInvoiceDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOutgoingInvoiceDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOutgoingInvoiceDatesMutation, { data, loading, error }] = useChangeOutgoingInvoiceDatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      issue_date: // value for 'issue_date'
 *      date_of_supply: // value for 'date_of_supply'
 *      due_date: // value for 'due_date'
 *      paid_at: // value for 'paid_at'
 *   },
 * });
 */
export function useChangeOutgoingInvoiceDatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeOutgoingInvoiceDatesMutation, ChangeOutgoingInvoiceDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeOutgoingInvoiceDatesMutation, ChangeOutgoingInvoiceDatesMutationVariables>(ChangeOutgoingInvoiceDatesDocument, options);
      }
export type ChangeOutgoingInvoiceDatesMutationHookResult = ReturnType<typeof useChangeOutgoingInvoiceDatesMutation>;
export type ChangeOutgoingInvoiceDatesMutationResult = ApolloReactCommon.MutationResult<ChangeOutgoingInvoiceDatesMutation>;
export type ChangeOutgoingInvoiceDatesMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeOutgoingInvoiceDatesMutation, ChangeOutgoingInvoiceDatesMutationVariables>;
export const ChangeOutgoingProformaInvoiceDatesDocument = gql`
    mutation ChangeOutgoingProformaInvoiceDates($id: ID!, $issue_date: Date!, $due_date: Date!, $paid_at: Date) {
  changeOutgoingProformaInvoiceDates(
    id: $id
    issue_date: $issue_date
    due_date: $due_date
    paid_at: $paid_at
  )
}
    `;
export type ChangeOutgoingProformaInvoiceDatesMutationFn = ApolloReactCommon.MutationFunction<ChangeOutgoingProformaInvoiceDatesMutation, ChangeOutgoingProformaInvoiceDatesMutationVariables>;

/**
 * __useChangeOutgoingProformaInvoiceDatesMutation__
 *
 * To run a mutation, you first call `useChangeOutgoingProformaInvoiceDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOutgoingProformaInvoiceDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOutgoingProformaInvoiceDatesMutation, { data, loading, error }] = useChangeOutgoingProformaInvoiceDatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      issue_date: // value for 'issue_date'
 *      due_date: // value for 'due_date'
 *      paid_at: // value for 'paid_at'
 *   },
 * });
 */
export function useChangeOutgoingProformaInvoiceDatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeOutgoingProformaInvoiceDatesMutation, ChangeOutgoingProformaInvoiceDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeOutgoingProformaInvoiceDatesMutation, ChangeOutgoingProformaInvoiceDatesMutationVariables>(ChangeOutgoingProformaInvoiceDatesDocument, options);
      }
export type ChangeOutgoingProformaInvoiceDatesMutationHookResult = ReturnType<typeof useChangeOutgoingProformaInvoiceDatesMutation>;
export type ChangeOutgoingProformaInvoiceDatesMutationResult = ApolloReactCommon.MutationResult<ChangeOutgoingProformaInvoiceDatesMutation>;
export type ChangeOutgoingProformaInvoiceDatesMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeOutgoingProformaInvoiceDatesMutation, ChangeOutgoingProformaInvoiceDatesMutationVariables>;
export const ProjectBillingsListDocument = gql`
    query ProjectBillingsList($filters: ProjectBillingsQueryArgs, $first: Int, $page: Int) {
  projectBillings(filters: $filters, first: $first, page: $page) {
    data {
      ...ProjectBillingRow
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectBillingRowFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectBillingsListQuery__
 *
 * To run a query within a React component, call `useProjectBillingsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBillingsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBillingsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProjectBillingsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>(ProjectBillingsListDocument, options);
      }
export function useProjectBillingsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>(ProjectBillingsListDocument, options);
        }
export function useProjectBillingsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>(ProjectBillingsListDocument, options);
        }
export type ProjectBillingsListQueryHookResult = ReturnType<typeof useProjectBillingsListQuery>;
export type ProjectBillingsListLazyQueryHookResult = ReturnType<typeof useProjectBillingsListLazyQuery>;
export type ProjectBillingsListSuspenseQueryHookResult = ReturnType<typeof useProjectBillingsListSuspenseQuery>;
export type ProjectBillingsListQueryResult = ApolloReactCommon.QueryResult<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>;
export const ProjectBillingsSummaryDocument = gql`
    query ProjectBillingsSummary($filters: ProjectBillingsQueryArgs) {
  projectBillingsSummary(filters: $filters) {
    ...ProjectBillingsSummaryFragment
  }
}
    ${ProjectBillingsSummaryFragmentFragmentDoc}`;

/**
 * __useProjectBillingsSummaryQuery__
 *
 * To run a query within a React component, call `useProjectBillingsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBillingsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBillingsSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectBillingsSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>(ProjectBillingsSummaryDocument, options);
      }
export function useProjectBillingsSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>(ProjectBillingsSummaryDocument, options);
        }
export function useProjectBillingsSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>(ProjectBillingsSummaryDocument, options);
        }
export type ProjectBillingsSummaryQueryHookResult = ReturnType<typeof useProjectBillingsSummaryQuery>;
export type ProjectBillingsSummaryLazyQueryHookResult = ReturnType<typeof useProjectBillingsSummaryLazyQuery>;
export type ProjectBillingsSummarySuspenseQueryHookResult = ReturnType<typeof useProjectBillingsSummarySuspenseQuery>;
export type ProjectBillingsSummaryQueryResult = ApolloReactCommon.QueryResult<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>;
export const ProjectBillingsFilterOptionsDocument = gql`
    query ProjectBillingsFilterOptions {
  projectsSimpleMap {
    id
    code
    title
  }
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  expenseBudgetCategories {
    id
    name
  }
  projectCategories {
    id
    name
  }
}
    `;

/**
 * __useProjectBillingsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProjectBillingsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBillingsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBillingsFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectBillingsFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>(ProjectBillingsFilterOptionsDocument, options);
      }
export function useProjectBillingsFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>(ProjectBillingsFilterOptionsDocument, options);
        }
export function useProjectBillingsFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>(ProjectBillingsFilterOptionsDocument, options);
        }
export type ProjectBillingsFilterOptionsQueryHookResult = ReturnType<typeof useProjectBillingsFilterOptionsQuery>;
export type ProjectBillingsFilterOptionsLazyQueryHookResult = ReturnType<typeof useProjectBillingsFilterOptionsLazyQuery>;
export type ProjectBillingsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectBillingsFilterOptionsSuspenseQuery>;
export type ProjectBillingsFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>;
export const InvoicingPlanExportBasicDocument = gql`
    query InvoicingPlanExportBasic($month: BigInt!, $year: BigInt!) {
  exportBillingPlan(month: $month, year: $year)
}
    `;

/**
 * __useInvoicingPlanExportBasicQuery__
 *
 * To run a query within a React component, call `useInvoicingPlanExportBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPlanExportBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPlanExportBasicQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useInvoicingPlanExportBasicQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables> & ({ variables: InvoicingPlanExportBasicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>(InvoicingPlanExportBasicDocument, options);
      }
export function useInvoicingPlanExportBasicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>(InvoicingPlanExportBasicDocument, options);
        }
export function useInvoicingPlanExportBasicSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>(InvoicingPlanExportBasicDocument, options);
        }
export type InvoicingPlanExportBasicQueryHookResult = ReturnType<typeof useInvoicingPlanExportBasicQuery>;
export type InvoicingPlanExportBasicLazyQueryHookResult = ReturnType<typeof useInvoicingPlanExportBasicLazyQuery>;
export type InvoicingPlanExportBasicSuspenseQueryHookResult = ReturnType<typeof useInvoicingPlanExportBasicSuspenseQuery>;
export type InvoicingPlanExportBasicQueryResult = ApolloReactCommon.QueryResult<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>;
export const InvoicingPlanExportDetailedDocument = gql`
    query InvoicingPlanExportDetailed($filters: ProjectBillingsQueryArgs) {
  projectBillingsExport(filters: $filters)
}
    `;

/**
 * __useInvoicingPlanExportDetailedQuery__
 *
 * To run a query within a React component, call `useInvoicingPlanExportDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPlanExportDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPlanExportDetailedQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInvoicingPlanExportDetailedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>(InvoicingPlanExportDetailedDocument, options);
      }
export function useInvoicingPlanExportDetailedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>(InvoicingPlanExportDetailedDocument, options);
        }
export function useInvoicingPlanExportDetailedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>(InvoicingPlanExportDetailedDocument, options);
        }
export type InvoicingPlanExportDetailedQueryHookResult = ReturnType<typeof useInvoicingPlanExportDetailedQuery>;
export type InvoicingPlanExportDetailedLazyQueryHookResult = ReturnType<typeof useInvoicingPlanExportDetailedLazyQuery>;
export type InvoicingPlanExportDetailedSuspenseQueryHookResult = ReturnType<typeof useInvoicingPlanExportDetailedSuspenseQuery>;
export type InvoicingPlanExportDetailedQueryResult = ApolloReactCommon.QueryResult<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>;
export const CreateBillingPlanDocument = gql`
    mutation CreateBillingPlan($projectId: ID!) {
  createBillingPlan(project_id: $projectId) {
    id
  }
}
    `;
export type CreateBillingPlanMutationFn = ApolloReactCommon.MutationFunction<CreateBillingPlanMutation, CreateBillingPlanMutationVariables>;

/**
 * __useCreateBillingPlanMutation__
 *
 * To run a mutation, you first call `useCreateBillingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingPlanMutation, { data, loading, error }] = useCreateBillingPlanMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateBillingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBillingPlanMutation, CreateBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBillingPlanMutation, CreateBillingPlanMutationVariables>(CreateBillingPlanDocument, options);
      }
export type CreateBillingPlanMutationHookResult = ReturnType<typeof useCreateBillingPlanMutation>;
export type CreateBillingPlanMutationResult = ApolloReactCommon.MutationResult<CreateBillingPlanMutation>;
export type CreateBillingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBillingPlanMutation, CreateBillingPlanMutationVariables>;
export const UpdateBillingPlanDocument = gql`
    mutation UpdateBillingPlan($input: UpdateBillingPlanInput!) {
  updateBillingPlan(input: $input) {
    id
  }
}
    `;
export type UpdateBillingPlanMutationFn = ApolloReactCommon.MutationFunction<UpdateBillingPlanMutation, UpdateBillingPlanMutationVariables>;

/**
 * __useUpdateBillingPlanMutation__
 *
 * To run a mutation, you first call `useUpdateBillingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingPlanMutation, { data, loading, error }] = useUpdateBillingPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBillingPlanMutation, UpdateBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBillingPlanMutation, UpdateBillingPlanMutationVariables>(UpdateBillingPlanDocument, options);
      }
export type UpdateBillingPlanMutationHookResult = ReturnType<typeof useUpdateBillingPlanMutation>;
export type UpdateBillingPlanMutationResult = ApolloReactCommon.MutationResult<UpdateBillingPlanMutation>;
export type UpdateBillingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBillingPlanMutation, UpdateBillingPlanMutationVariables>;
export const ProjectBillingPlanDataDocument = gql`
    query ProjectBillingPlanData($projectId: ID!) {
  project(id: $projectId) {
    id
    start_date
    expected_end_date
    stats {
      id
      total_budget
    }
    billingPlanByMonths {
      id
      period
      invoiced_amount
      items {
        id
        amount
        date
      }
    }
  }
}
    `;

/**
 * __useProjectBillingPlanDataQuery__
 *
 * To run a query within a React component, call `useProjectBillingPlanDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBillingPlanDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBillingPlanDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectBillingPlanDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables> & ({ variables: ProjectBillingPlanDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>(ProjectBillingPlanDataDocument, options);
      }
export function useProjectBillingPlanDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>(ProjectBillingPlanDataDocument, options);
        }
export function useProjectBillingPlanDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>(ProjectBillingPlanDataDocument, options);
        }
export type ProjectBillingPlanDataQueryHookResult = ReturnType<typeof useProjectBillingPlanDataQuery>;
export type ProjectBillingPlanDataLazyQueryHookResult = ReturnType<typeof useProjectBillingPlanDataLazyQuery>;
export type ProjectBillingPlanDataSuspenseQueryHookResult = ReturnType<typeof useProjectBillingPlanDataSuspenseQuery>;
export type ProjectBillingPlanDataQueryResult = ApolloReactCommon.QueryResult<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>;
export const CreateInvoiceFromBillingPlanDocument = gql`
    mutation CreateInvoiceFromBillingPlan($input: CreateInvoiceFromBillingPlanInput) {
  createInvoiceFromBillingPlan(input: $input) {
    id
  }
}
    `;
export type CreateInvoiceFromBillingPlanMutationFn = ApolloReactCommon.MutationFunction<CreateInvoiceFromBillingPlanMutation, CreateInvoiceFromBillingPlanMutationVariables>;

/**
 * __useCreateInvoiceFromBillingPlanMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceFromBillingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceFromBillingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceFromBillingPlanMutation, { data, loading, error }] = useCreateInvoiceFromBillingPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceFromBillingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoiceFromBillingPlanMutation, CreateInvoiceFromBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInvoiceFromBillingPlanMutation, CreateInvoiceFromBillingPlanMutationVariables>(CreateInvoiceFromBillingPlanDocument, options);
      }
export type CreateInvoiceFromBillingPlanMutationHookResult = ReturnType<typeof useCreateInvoiceFromBillingPlanMutation>;
export type CreateInvoiceFromBillingPlanMutationResult = ApolloReactCommon.MutationResult<CreateInvoiceFromBillingPlanMutation>;
export type CreateInvoiceFromBillingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoiceFromBillingPlanMutation, CreateInvoiceFromBillingPlanMutationVariables>;
export const InvoicingPlanFutureListDocument = gql`
    query InvoicingPlanFutureList($filters: BillingPlanCacheOverviewQueryArgs!, $first: Int, $page: Int) {
  billingPlanCacheOverview(filters: $filters, first: $first, page: $page) {
    data {
      ...InvoicingPlanAdvancedList
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${InvoicingPlanAdvancedListFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useInvoicingPlanFutureListQuery__
 *
 * To run a query within a React component, call `useInvoicingPlanFutureListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPlanFutureListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPlanFutureListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useInvoicingPlanFutureListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables> & ({ variables: InvoicingPlanFutureListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>(InvoicingPlanFutureListDocument, options);
      }
export function useInvoicingPlanFutureListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>(InvoicingPlanFutureListDocument, options);
        }
export function useInvoicingPlanFutureListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>(InvoicingPlanFutureListDocument, options);
        }
export type InvoicingPlanFutureListQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListQuery>;
export type InvoicingPlanFutureListLazyQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListLazyQuery>;
export type InvoicingPlanFutureListSuspenseQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListSuspenseQuery>;
export type InvoicingPlanFutureListQueryResult = ApolloReactCommon.QueryResult<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>;
export const InvoicingPlanFutureListSummaryDocument = gql`
    query InvoicingPlanFutureListSummary($filters: BillingPlanCacheOverviewQueryArgs!) {
  billingPlanCacheOverviewSummary(filters: $filters) {
    projects
    planned_amount
    invoiced_amount
    uninvoiced_amount
  }
}
    `;

/**
 * __useInvoicingPlanFutureListSummaryQuery__
 *
 * To run a query within a React component, call `useInvoicingPlanFutureListSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPlanFutureListSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPlanFutureListSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInvoicingPlanFutureListSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables> & ({ variables: InvoicingPlanFutureListSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>(InvoicingPlanFutureListSummaryDocument, options);
      }
export function useInvoicingPlanFutureListSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>(InvoicingPlanFutureListSummaryDocument, options);
        }
export function useInvoicingPlanFutureListSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>(InvoicingPlanFutureListSummaryDocument, options);
        }
export type InvoicingPlanFutureListSummaryQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListSummaryQuery>;
export type InvoicingPlanFutureListSummaryLazyQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListSummaryLazyQuery>;
export type InvoicingPlanFutureListSummarySuspenseQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListSummarySuspenseQuery>;
export type InvoicingPlanFutureListSummaryQueryResult = ApolloReactCommon.QueryResult<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>;
export const InvoicingPlanFutureListFilterOptionsDocument = gql`
    query InvoicingPlanFutureListFilterOptions {
  projectsSimpleMap {
    id
    code
    title
  }
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

/**
 * __useInvoicingPlanFutureListFilterOptionsQuery__
 *
 * To run a query within a React component, call `useInvoicingPlanFutureListFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPlanFutureListFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPlanFutureListFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicingPlanFutureListFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>(InvoicingPlanFutureListFilterOptionsDocument, options);
      }
export function useInvoicingPlanFutureListFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>(InvoicingPlanFutureListFilterOptionsDocument, options);
        }
export function useInvoicingPlanFutureListFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>(InvoicingPlanFutureListFilterOptionsDocument, options);
        }
export type InvoicingPlanFutureListFilterOptionsQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListFilterOptionsQuery>;
export type InvoicingPlanFutureListFilterOptionsLazyQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListFilterOptionsLazyQuery>;
export type InvoicingPlanFutureListFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useInvoicingPlanFutureListFilterOptionsSuspenseQuery>;
export type InvoicingPlanFutureListFilterOptionsQueryResult = ApolloReactCommon.QueryResult<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: ID!) {
  markNotificationAsRead(id: $id) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type MarkNotificationAsReadMutationFn = ApolloReactCommon.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = ApolloReactCommon.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkNotificationAsUnreadDocument = gql`
    mutation MarkNotificationAsUnread($id: ID!) {
  markNotificationAsUnread(id: $id) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type MarkNotificationAsUnreadMutationFn = ApolloReactCommon.MutationFunction<MarkNotificationAsUnreadMutation, MarkNotificationAsUnreadMutationVariables>;

/**
 * __useMarkNotificationAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsUnreadMutation, { data, loading, error }] = useMarkNotificationAsUnreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsUnreadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkNotificationAsUnreadMutation, MarkNotificationAsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkNotificationAsUnreadMutation, MarkNotificationAsUnreadMutationVariables>(MarkNotificationAsUnreadDocument, options);
      }
export type MarkNotificationAsUnreadMutationHookResult = ReturnType<typeof useMarkNotificationAsUnreadMutation>;
export type MarkNotificationAsUnreadMutationResult = ApolloReactCommon.MutationResult<MarkNotificationAsUnreadMutation>;
export type MarkNotificationAsUnreadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkNotificationAsUnreadMutation, MarkNotificationAsUnreadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead($groups: [NotificationGroup]) {
  markAllNotificationsAsRead(groups: $groups)
}
    `;
export type MarkAllNotificationsAsReadMutationFn = ApolloReactCommon.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = ApolloReactCommon.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const NotificationsDocument = gql`
    query Notifications($page: Int, $first: Int, $groups: [NotificationGroup], $type: NotificationType, $read: Boolean) {
  notifications(
    page: $page
    first: $first
    groups: $groups
    type: $type
    read: $read
  ) {
    data {
      ...Notification
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${NotificationFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      groups: // value for 'groups'
 *      type: // value for 'type'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = ApolloReactCommon.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const UnreadNotificationsCountDocument = gql`
    query UnreadNotificationsCount($groups: [NotificationGroup]) {
  unreadNotificationsCount(groups: $groups)
}
    `;

/**
 * __useUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCountQuery({
 *   variables: {
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useUnreadNotificationsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
      }
export function useUnreadNotificationsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
        }
export function useUnreadNotificationsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
        }
export type UnreadNotificationsCountQueryHookResult = ReturnType<typeof useUnreadNotificationsCountQuery>;
export type UnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useUnreadNotificationsCountLazyQuery>;
export type UnreadNotificationsCountSuspenseQueryHookResult = ReturnType<typeof useUnreadNotificationsCountSuspenseQuery>;
export type UnreadNotificationsCountQueryResult = ApolloReactCommon.QueryResult<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>;
export const TaskNotificationsDocument = gql`
    query TaskNotifications($page: Int, $first: Int, $read: Boolean) {
  taskAndCommunicationNotifications(page: $page, first: $first, read: $read) {
    data {
      task {
        ...SimpleTask
      }
      notifications {
        ...TaskNotificationsNotification
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${SimpleTaskFragmentDoc}
${TaskNotificationsNotificationFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useTaskNotificationsQuery__
 *
 * To run a query within a React component, call `useTaskNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useTaskNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskNotificationsQuery, TaskNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>(TaskNotificationsDocument, options);
      }
export function useTaskNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskNotificationsQuery, TaskNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>(TaskNotificationsDocument, options);
        }
export function useTaskNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskNotificationsQuery, TaskNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>(TaskNotificationsDocument, options);
        }
export type TaskNotificationsQueryHookResult = ReturnType<typeof useTaskNotificationsQuery>;
export type TaskNotificationsLazyQueryHookResult = ReturnType<typeof useTaskNotificationsLazyQuery>;
export type TaskNotificationsSuspenseQueryHookResult = ReturnType<typeof useTaskNotificationsSuspenseQuery>;
export type TaskNotificationsQueryResult = ApolloReactCommon.QueryResult<TaskNotificationsQuery, TaskNotificationsQueryVariables>;
export const TaskNotificationsForScopedUserDocument = gql`
    query TaskNotificationsForScopedUser($page: Int, $first: Int, $read: Boolean) {
  taskAndCommunicationNotifications(page: $page, first: $first, read: $read) {
    data {
      task {
        ...SimpleTaskForClient
      }
      notifications {
        ...TaskNotificationsNotification
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}
${TaskNotificationsNotificationFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useTaskNotificationsForScopedUserQuery__
 *
 * To run a query within a React component, call `useTaskNotificationsForScopedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskNotificationsForScopedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskNotificationsForScopedUserQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useTaskNotificationsForScopedUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>(TaskNotificationsForScopedUserDocument, options);
      }
export function useTaskNotificationsForScopedUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>(TaskNotificationsForScopedUserDocument, options);
        }
export function useTaskNotificationsForScopedUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>(TaskNotificationsForScopedUserDocument, options);
        }
export type TaskNotificationsForScopedUserQueryHookResult = ReturnType<typeof useTaskNotificationsForScopedUserQuery>;
export type TaskNotificationsForScopedUserLazyQueryHookResult = ReturnType<typeof useTaskNotificationsForScopedUserLazyQuery>;
export type TaskNotificationsForScopedUserSuspenseQueryHookResult = ReturnType<typeof useTaskNotificationsForScopedUserSuspenseQuery>;
export type TaskNotificationsForScopedUserQueryResult = ApolloReactCommon.QueryResult<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>;
export const UpdateProjectBillingPlanDocument = gql`
    mutation UpdateProjectBillingPlan($input: updateProjectBillingPlanBudgetInput) {
  updateProjectBillingPlanBudget(input: $input) {
    ...BillingPlan
  }
}
    ${BillingPlanFragmentDoc}`;
export type UpdateProjectBillingPlanMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectBillingPlanMutation, UpdateProjectBillingPlanMutationVariables>;

/**
 * __useUpdateProjectBillingPlanMutation__
 *
 * To run a mutation, you first call `useUpdateProjectBillingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectBillingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectBillingPlanMutation, { data, loading, error }] = useUpdateProjectBillingPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectBillingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectBillingPlanMutation, UpdateProjectBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectBillingPlanMutation, UpdateProjectBillingPlanMutationVariables>(UpdateProjectBillingPlanDocument, options);
      }
export type UpdateProjectBillingPlanMutationHookResult = ReturnType<typeof useUpdateProjectBillingPlanMutation>;
export type UpdateProjectBillingPlanMutationResult = ApolloReactCommon.MutationResult<UpdateProjectBillingPlanMutation>;
export type UpdateProjectBillingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectBillingPlanMutation, UpdateProjectBillingPlanMutationVariables>;
export const UpdateProjectBillingPlanSettingsDocument = gql`
    mutation UpdateProjectBillingPlanSettings($input: updateProjectBillingPlanSettingsInput) {
  updateProjectBillingPlanSettings(input: $input) {
    ...BillingPlanSettingsProject
  }
}
    ${BillingPlanSettingsProjectFragmentDoc}`;
export type UpdateProjectBillingPlanSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectBillingPlanSettingsMutation, UpdateProjectBillingPlanSettingsMutationVariables>;

/**
 * __useUpdateProjectBillingPlanSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectBillingPlanSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectBillingPlanSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectBillingPlanSettingsMutation, { data, loading, error }] = useUpdateProjectBillingPlanSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectBillingPlanSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectBillingPlanSettingsMutation, UpdateProjectBillingPlanSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectBillingPlanSettingsMutation, UpdateProjectBillingPlanSettingsMutationVariables>(UpdateProjectBillingPlanSettingsDocument, options);
      }
export type UpdateProjectBillingPlanSettingsMutationHookResult = ReturnType<typeof useUpdateProjectBillingPlanSettingsMutation>;
export type UpdateProjectBillingPlanSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateProjectBillingPlanSettingsMutation>;
export type UpdateProjectBillingPlanSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectBillingPlanSettingsMutation, UpdateProjectBillingPlanSettingsMutationVariables>;
export const LockProjectBillingPlanDocument = gql`
    mutation LockProjectBillingPlan($projectId: ID!) {
  lockBillingPlanForProject(project_id: $projectId) {
    billingPlanSetting {
      locked_at
      lockedByUser {
        id
        full_name
      }
    }
  }
}
    `;
export type LockProjectBillingPlanMutationFn = ApolloReactCommon.MutationFunction<LockProjectBillingPlanMutation, LockProjectBillingPlanMutationVariables>;

/**
 * __useLockProjectBillingPlanMutation__
 *
 * To run a mutation, you first call `useLockProjectBillingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockProjectBillingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockProjectBillingPlanMutation, { data, loading, error }] = useLockProjectBillingPlanMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLockProjectBillingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LockProjectBillingPlanMutation, LockProjectBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LockProjectBillingPlanMutation, LockProjectBillingPlanMutationVariables>(LockProjectBillingPlanDocument, options);
      }
export type LockProjectBillingPlanMutationHookResult = ReturnType<typeof useLockProjectBillingPlanMutation>;
export type LockProjectBillingPlanMutationResult = ApolloReactCommon.MutationResult<LockProjectBillingPlanMutation>;
export type LockProjectBillingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<LockProjectBillingPlanMutation, LockProjectBillingPlanMutationVariables>;
export const BillingPlanDocument = gql`
    query BillingPlan($projectId: ID!, $billingItemType: BillingItemTypEnum!) {
  billingPlanBudget(project_id: $projectId, billing_item_type: $billingItemType) {
    ...BillingPlan
  }
}
    ${BillingPlanFragmentDoc}`;

/**
 * __useBillingPlanQuery__
 *
 * To run a query within a React component, call `useBillingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPlanQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      billingItemType: // value for 'billingItemType'
 *   },
 * });
 */
export function useBillingPlanQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingPlanQuery, BillingPlanQueryVariables> & ({ variables: BillingPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingPlanQuery, BillingPlanQueryVariables>(BillingPlanDocument, options);
      }
export function useBillingPlanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingPlanQuery, BillingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingPlanQuery, BillingPlanQueryVariables>(BillingPlanDocument, options);
        }
export function useBillingPlanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPlanQuery, BillingPlanQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingPlanQuery, BillingPlanQueryVariables>(BillingPlanDocument, options);
        }
export type BillingPlanQueryHookResult = ReturnType<typeof useBillingPlanQuery>;
export type BillingPlanLazyQueryHookResult = ReturnType<typeof useBillingPlanLazyQuery>;
export type BillingPlanSuspenseQueryHookResult = ReturnType<typeof useBillingPlanSuspenseQuery>;
export type BillingPlanQueryResult = ApolloReactCommon.QueryResult<BillingPlanQuery, BillingPlanQueryVariables>;
export const BillingPlanOptionsDocument = gql`
    query BillingPlanOptions($accountingCentreType: ACCOUNTING_CENTRE_TYPE!) {
  accountingCentres(type: $accountingCentreType) {
    ...CostCenter
  }
}
    ${CostCenterFragmentDoc}`;

/**
 * __useBillingPlanOptionsQuery__
 *
 * To run a query within a React component, call `useBillingPlanOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPlanOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPlanOptionsQuery({
 *   variables: {
 *      accountingCentreType: // value for 'accountingCentreType'
 *   },
 * });
 */
export function useBillingPlanOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables> & ({ variables: BillingPlanOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>(BillingPlanOptionsDocument, options);
      }
export function useBillingPlanOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>(BillingPlanOptionsDocument, options);
        }
export function useBillingPlanOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>(BillingPlanOptionsDocument, options);
        }
export type BillingPlanOptionsQueryHookResult = ReturnType<typeof useBillingPlanOptionsQuery>;
export type BillingPlanOptionsLazyQueryHookResult = ReturnType<typeof useBillingPlanOptionsLazyQuery>;
export type BillingPlanOptionsSuspenseQueryHookResult = ReturnType<typeof useBillingPlanOptionsSuspenseQuery>;
export type BillingPlanOptionsQueryResult = ApolloReactCommon.QueryResult<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>;
export const BillingPlanSettingsDocument = gql`
    query BillingPlanSettings($projectId: ID!) {
  project(id: $projectId) {
    ...BillingPlanSettingsProject
  }
  EmailTemplates {
    id
    type
    subject
    content
  }
  vatRates {
    id
    amount
    deleted
    default
  }
}
    ${BillingPlanSettingsProjectFragmentDoc}`;

/**
 * __useBillingPlanSettingsQuery__
 *
 * To run a query within a React component, call `useBillingPlanSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPlanSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPlanSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useBillingPlanSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables> & ({ variables: BillingPlanSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>(BillingPlanSettingsDocument, options);
      }
export function useBillingPlanSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>(BillingPlanSettingsDocument, options);
        }
export function useBillingPlanSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>(BillingPlanSettingsDocument, options);
        }
export type BillingPlanSettingsQueryHookResult = ReturnType<typeof useBillingPlanSettingsQuery>;
export type BillingPlanSettingsLazyQueryHookResult = ReturnType<typeof useBillingPlanSettingsLazyQuery>;
export type BillingPlanSettingsSuspenseQueryHookResult = ReturnType<typeof useBillingPlanSettingsSuspenseQuery>;
export type BillingPlanSettingsQueryResult = ApolloReactCommon.QueryResult<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>;
export const BillingPlanIssueInvoicesOptionsDocument = gql`
    query BillingPlanIssueInvoicesOptions($projectId: ID!) {
  vatRates {
    id
    amount
    default
  }
  project(id: $projectId) {
    brand {
      contacts {
        id
        first_name
        last_name
        email
      }
      client {
        billingEntities {
          id
          street
          city
          internal_name
          applies_vat
          invoice_email
          defaultCurrency {
            id
            code
          }
        }
        currencyExchangeRates(onlyActive: true) {
          id
          exchange_rate
          currency {
            id
            code
          }
        }
      }
    }
    ordersSimpleMap {
      id
      purchase_order_no
    }
  }
}
    `;

/**
 * __useBillingPlanIssueInvoicesOptionsQuery__
 *
 * To run a query within a React component, call `useBillingPlanIssueInvoicesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPlanIssueInvoicesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPlanIssueInvoicesOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useBillingPlanIssueInvoicesOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables> & ({ variables: BillingPlanIssueInvoicesOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>(BillingPlanIssueInvoicesOptionsDocument, options);
      }
export function useBillingPlanIssueInvoicesOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>(BillingPlanIssueInvoicesOptionsDocument, options);
        }
export function useBillingPlanIssueInvoicesOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>(BillingPlanIssueInvoicesOptionsDocument, options);
        }
export type BillingPlanIssueInvoicesOptionsQueryHookResult = ReturnType<typeof useBillingPlanIssueInvoicesOptionsQuery>;
export type BillingPlanIssueInvoicesOptionsLazyQueryHookResult = ReturnType<typeof useBillingPlanIssueInvoicesOptionsLazyQuery>;
export type BillingPlanIssueInvoicesOptionsSuspenseQueryHookResult = ReturnType<typeof useBillingPlanIssueInvoicesOptionsSuspenseQuery>;
export type BillingPlanIssueInvoicesOptionsQueryResult = ApolloReactCommon.QueryResult<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>;
export const IsBillingPlanLockedDocument = gql`
    query IsBillingPlanLocked($projectId: ID!) {
  project(id: $projectId) {
    billingPlanSetting {
      locked_at
      lockedByUser {
        id
        full_name
      }
    }
  }
}
    `;

/**
 * __useIsBillingPlanLockedQuery__
 *
 * To run a query within a React component, call `useIsBillingPlanLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsBillingPlanLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsBillingPlanLockedQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIsBillingPlanLockedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables> & ({ variables: IsBillingPlanLockedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>(IsBillingPlanLockedDocument, options);
      }
export function useIsBillingPlanLockedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>(IsBillingPlanLockedDocument, options);
        }
export function useIsBillingPlanLockedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>(IsBillingPlanLockedDocument, options);
        }
export type IsBillingPlanLockedQueryHookResult = ReturnType<typeof useIsBillingPlanLockedQuery>;
export type IsBillingPlanLockedLazyQueryHookResult = ReturnType<typeof useIsBillingPlanLockedLazyQuery>;
export type IsBillingPlanLockedSuspenseQueryHookResult = ReturnType<typeof useIsBillingPlanLockedSuspenseQuery>;
export type IsBillingPlanLockedQueryResult = ApolloReactCommon.QueryResult<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>;
export const GetBudgetExceededDocument = gql`
    query GetBudgetExceeded($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projects(page: $page, first: $first, filters: $filters) {
    paginatorInfo {
      hasMorePages
      currentPage
      perPage
      total
      count
      firstItem
      lastItem
      lastPage
    }
    data {
      id
      title
      code
      billable
      type
      brand {
        id
        name
        client {
          image {
            urls {
              thumbnail
            }
          }
        }
      }
      projectManager {
        codename
        full_name
        id
        image {
          urls {
            thumbnail
          }
        }
        profile {
          hex_color
          defaultWorktype {
            id
            title
          }
        }
        team {
          id
          name
        }
      }
      expenses(hasBudgetExceeded: true) {
        title
        id
        stats {
          planned_expenses
          real_expenses
          planned_commission
          credit
          total_budget
          budget_exceeded
          real_expenses_percent
          credit
          real_expenses_percent
          real_commission
          real_commission_relative
          planned_commission_relative_computed
          planned_profit
        }
      }
      ourWork(hasBudgetExceeded: true) {
        id
        title
        stats {
          credit
          total_budget
          spent_budget
          budget_exceeded
          spent_budget_percent
          spent_time
          invoiced_percent
          remaining_budget
          remaining_time
        }
      }
      stats {
        budget_exceeded
      }
    }
  }
}
    `;

/**
 * __useGetBudgetExceededQuery__
 *
 * To run a query within a React component, call `useGetBudgetExceededQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetExceededQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetExceededQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBudgetExceededQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBudgetExceededQuery, GetBudgetExceededQueryVariables> & ({ variables: GetBudgetExceededQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>(GetBudgetExceededDocument, options);
      }
export function useGetBudgetExceededLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>(GetBudgetExceededDocument, options);
        }
export function useGetBudgetExceededSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>(GetBudgetExceededDocument, options);
        }
export type GetBudgetExceededQueryHookResult = ReturnType<typeof useGetBudgetExceededQuery>;
export type GetBudgetExceededLazyQueryHookResult = ReturnType<typeof useGetBudgetExceededLazyQuery>;
export type GetBudgetExceededSuspenseQueryHookResult = ReturnType<typeof useGetBudgetExceededSuspenseQuery>;
export type GetBudgetExceededQueryResult = ApolloReactCommon.QueryResult<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>;
export const UpdateProjectBudgetDocument = gql`
    mutation UpdateProjectBudget($input: UpdateProjectBudgetInput!) {
  updateProjectBudget(input: $input) {
    id
    title
    code
    billable
    uses_budgetovac
    finished_at
    type
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    budgetovacBudget {
      budget_id
      newer_final_version_available
    }
    ourWorkStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        stats {
          credit
          total_budget
        }
      }
      total_budget
      credit
    }
    expensesWithoutOtherStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        type
        completed_at
        stats {
          real_expenses
          credit
          total_budget
          planned_commission
          planned_expenses
        }
      }
      total_budget
      credit
      real_expenses
      real_expenses_without_other
    }
    stats {
      total_budget
      credit
      planned_commission
      ourWork {
        total_budget
      }
      expenses {
        planned_expenses
      }
    }
  }
}
    `;
export type UpdateProjectBudgetMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectBudgetMutation, UpdateProjectBudgetMutationVariables>;

/**
 * __useUpdateProjectBudgetMutation__
 *
 * To run a mutation, you first call `useUpdateProjectBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectBudgetMutation, { data, loading, error }] = useUpdateProjectBudgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectBudgetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectBudgetMutation, UpdateProjectBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectBudgetMutation, UpdateProjectBudgetMutationVariables>(UpdateProjectBudgetDocument, options);
      }
export type UpdateProjectBudgetMutationHookResult = ReturnType<typeof useUpdateProjectBudgetMutation>;
export type UpdateProjectBudgetMutationResult = ApolloReactCommon.MutationResult<UpdateProjectBudgetMutation>;
export type UpdateProjectBudgetMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectBudgetMutation, UpdateProjectBudgetMutationVariables>;
export const ProjectForBudgetDocument = gql`
    query ProjectForBudget($id: ID!) {
  expenseBudgetCategories {
    id
    name
  }
  ourWorkBudgetCategories {
    id
    name
  }
  project(id: $id) {
    id
    title
    code
    billable
    uses_budgetovac
    finished_at
    type
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    budgetovacBudget {
      budget_id
      newer_final_version_available
    }
    ourWorkStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        stats {
          credit
          total_budget
        }
      }
      total_budget
      credit
    }
    expensesWithoutOtherStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        type
        completed_at
        stats {
          real_expenses
          credit
          total_budget
          planned_commission
          planned_expenses
        }
      }
      total_budget
      credit
      real_expenses
      real_expenses_without_other
    }
    stats {
      total_budget
      credit
      planned_commission
      ourWork {
        total_budget
      }
      expenses {
        planned_expenses
      }
    }
  }
  projectDatesForBudgetChange(project_id: $id) {
    lowestPossibleDateForBudgetChange
    defaultDateForBudgetChange
  }
}
    `;

/**
 * __useProjectForBudgetQuery__
 *
 * To run a query within a React component, call `useProjectForBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectForBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectForBudgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectForBudgetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectForBudgetQuery, ProjectForBudgetQueryVariables> & ({ variables: ProjectForBudgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>(ProjectForBudgetDocument, options);
      }
export function useProjectForBudgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>(ProjectForBudgetDocument, options);
        }
export function useProjectForBudgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>(ProjectForBudgetDocument, options);
        }
export type ProjectForBudgetQueryHookResult = ReturnType<typeof useProjectForBudgetQuery>;
export type ProjectForBudgetLazyQueryHookResult = ReturnType<typeof useProjectForBudgetLazyQuery>;
export type ProjectForBudgetSuspenseQueryHookResult = ReturnType<typeof useProjectForBudgetSuspenseQuery>;
export type ProjectForBudgetQueryResult = ApolloReactCommon.QueryResult<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>;
export const ProjectForBudgetsDocument = gql`
    query ProjectForBudgets($id: ID!) {
  project(id: $id) {
    id
    finished_at
    uses_budgetovac
    budgetovacBudget {
      budget_id
    }
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

/**
 * __useProjectForBudgetsQuery__
 *
 * To run a query within a React component, call `useProjectForBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectForBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectForBudgetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectForBudgetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables> & ({ variables: ProjectForBudgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>(ProjectForBudgetsDocument, options);
      }
export function useProjectForBudgetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>(ProjectForBudgetsDocument, options);
        }
export function useProjectForBudgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>(ProjectForBudgetsDocument, options);
        }
export type ProjectForBudgetsQueryHookResult = ReturnType<typeof useProjectForBudgetsQuery>;
export type ProjectForBudgetsLazyQueryHookResult = ReturnType<typeof useProjectForBudgetsLazyQuery>;
export type ProjectForBudgetsSuspenseQueryHookResult = ReturnType<typeof useProjectForBudgetsSuspenseQuery>;
export type ProjectForBudgetsQueryResult = ApolloReactCommon.QueryResult<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>;
export const BudgetInternalApproveDocument = gql`
    mutation BudgetInternalApprove($id: ID!) {
  budgetInternalApprove(id: $id) {
    id
  }
}
    `;
export type BudgetInternalApproveMutationFn = ApolloReactCommon.MutationFunction<BudgetInternalApproveMutation, BudgetInternalApproveMutationVariables>;

/**
 * __useBudgetInternalApproveMutation__
 *
 * To run a mutation, you first call `useBudgetInternalApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBudgetInternalApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [budgetInternalApproveMutation, { data, loading, error }] = useBudgetInternalApproveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBudgetInternalApproveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BudgetInternalApproveMutation, BudgetInternalApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BudgetInternalApproveMutation, BudgetInternalApproveMutationVariables>(BudgetInternalApproveDocument, options);
      }
export type BudgetInternalApproveMutationHookResult = ReturnType<typeof useBudgetInternalApproveMutation>;
export type BudgetInternalApproveMutationResult = ApolloReactCommon.MutationResult<BudgetInternalApproveMutation>;
export type BudgetInternalApproveMutationOptions = ApolloReactCommon.BaseMutationOptions<BudgetInternalApproveMutation, BudgetInternalApproveMutationVariables>;
export const ChangeBudgetAssignedAtDocument = gql`
    mutation ChangeBudgetAssignedAt($id: ID!, $date: Date!) {
  changeBudgetAssignedAt(id: $id, date: $date) {
    id
    assignment_date
  }
}
    `;
export type ChangeBudgetAssignedAtMutationFn = ApolloReactCommon.MutationFunction<ChangeBudgetAssignedAtMutation, ChangeBudgetAssignedAtMutationVariables>;

/**
 * __useChangeBudgetAssignedAtMutation__
 *
 * To run a mutation, you first call `useChangeBudgetAssignedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBudgetAssignedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBudgetAssignedAtMutation, { data, loading, error }] = useChangeBudgetAssignedAtMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useChangeBudgetAssignedAtMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeBudgetAssignedAtMutation, ChangeBudgetAssignedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeBudgetAssignedAtMutation, ChangeBudgetAssignedAtMutationVariables>(ChangeBudgetAssignedAtDocument, options);
      }
export type ChangeBudgetAssignedAtMutationHookResult = ReturnType<typeof useChangeBudgetAssignedAtMutation>;
export type ChangeBudgetAssignedAtMutationResult = ApolloReactCommon.MutationResult<ChangeBudgetAssignedAtMutation>;
export type ChangeBudgetAssignedAtMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeBudgetAssignedAtMutation, ChangeBudgetAssignedAtMutationVariables>;
export const BudgetGroupsForProjectsDocument = gql`
    query BudgetGroupsForProjects($projectId: ID!) {
  budgetsForProject(project_id: $projectId) {
    ...BudgetGroup
  }
}
    ${BudgetGroupFragmentDoc}`;

/**
 * __useBudgetGroupsForProjectsQuery__
 *
 * To run a query within a React component, call `useBudgetGroupsForProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetGroupsForProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetGroupsForProjectsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useBudgetGroupsForProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables> & ({ variables: BudgetGroupsForProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>(BudgetGroupsForProjectsDocument, options);
      }
export function useBudgetGroupsForProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>(BudgetGroupsForProjectsDocument, options);
        }
export function useBudgetGroupsForProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>(BudgetGroupsForProjectsDocument, options);
        }
export type BudgetGroupsForProjectsQueryHookResult = ReturnType<typeof useBudgetGroupsForProjectsQuery>;
export type BudgetGroupsForProjectsLazyQueryHookResult = ReturnType<typeof useBudgetGroupsForProjectsLazyQuery>;
export type BudgetGroupsForProjectsSuspenseQueryHookResult = ReturnType<typeof useBudgetGroupsForProjectsSuspenseQuery>;
export type BudgetGroupsForProjectsQueryResult = ApolloReactCommon.QueryResult<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>;
export const ProjectTitleDocument = gql`
    query ProjectTitle($projectId: ID!) {
  project(id: $projectId) {
    ...ProjectTitle
    lowestPossibleDateForStartDateChange
  }
}
    ${ProjectTitleFragmentDoc}`;

/**
 * __useProjectTitleQuery__
 *
 * To run a query within a React component, call `useProjectTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTitleQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectTitleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTitleQuery, ProjectTitleQueryVariables> & ({ variables: ProjectTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTitleQuery, ProjectTitleQueryVariables>(ProjectTitleDocument, options);
      }
export function useProjectTitleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTitleQuery, ProjectTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTitleQuery, ProjectTitleQueryVariables>(ProjectTitleDocument, options);
        }
export function useProjectTitleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTitleQuery, ProjectTitleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTitleQuery, ProjectTitleQueryVariables>(ProjectTitleDocument, options);
        }
export type ProjectTitleQueryHookResult = ReturnType<typeof useProjectTitleQuery>;
export type ProjectTitleLazyQueryHookResult = ReturnType<typeof useProjectTitleLazyQuery>;
export type ProjectTitleSuspenseQueryHookResult = ReturnType<typeof useProjectTitleSuspenseQuery>;
export type ProjectTitleQueryResult = ApolloReactCommon.QueryResult<ProjectTitleQuery, ProjectTitleQueryVariables>;
export const GetProjectBudgetExceededCountDocument = gql`
    query GetProjectBudgetExceededCount {
  getActiveProjectBudgetExceededCount
}
    `;

/**
 * __useGetProjectBudgetExceededCountQuery__
 *
 * To run a query within a React component, call `useGetProjectBudgetExceededCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectBudgetExceededCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectBudgetExceededCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectBudgetExceededCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>(GetProjectBudgetExceededCountDocument, options);
      }
export function useGetProjectBudgetExceededCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>(GetProjectBudgetExceededCountDocument, options);
        }
export function useGetProjectBudgetExceededCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>(GetProjectBudgetExceededCountDocument, options);
        }
export type GetProjectBudgetExceededCountQueryHookResult = ReturnType<typeof useGetProjectBudgetExceededCountQuery>;
export type GetProjectBudgetExceededCountLazyQueryHookResult = ReturnType<typeof useGetProjectBudgetExceededCountLazyQuery>;
export type GetProjectBudgetExceededCountSuspenseQueryHookResult = ReturnType<typeof useGetProjectBudgetExceededCountSuspenseQuery>;
export type GetProjectBudgetExceededCountQueryResult = ApolloReactCommon.QueryResult<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>;
export const GetProjectUsesBudgetovacDocument = gql`
    query GetProjectUsesBudgetovac($id: ID!) {
  project(id: $id) {
    id
    uses_budgetovac
    finished_at
  }
}
    `;

/**
 * __useGetProjectUsesBudgetovacQuery__
 *
 * To run a query within a React component, call `useGetProjectUsesBudgetovacQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectUsesBudgetovacQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectUsesBudgetovacQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectUsesBudgetovacQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables> & ({ variables: GetProjectUsesBudgetovacQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>(GetProjectUsesBudgetovacDocument, options);
      }
export function useGetProjectUsesBudgetovacLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>(GetProjectUsesBudgetovacDocument, options);
        }
export function useGetProjectUsesBudgetovacSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>(GetProjectUsesBudgetovacDocument, options);
        }
export type GetProjectUsesBudgetovacQueryHookResult = ReturnType<typeof useGetProjectUsesBudgetovacQuery>;
export type GetProjectUsesBudgetovacLazyQueryHookResult = ReturnType<typeof useGetProjectUsesBudgetovacLazyQuery>;
export type GetProjectUsesBudgetovacSuspenseQueryHookResult = ReturnType<typeof useGetProjectUsesBudgetovacSuspenseQuery>;
export type GetProjectUsesBudgetovacQueryResult = ApolloReactCommon.QueryResult<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>;
export const CreateProjectFromTemplateDocument = gql`
    mutation CreateProjectFromTemplate($input: CreateProjectFromTemplateInput!) {
  createProjectFromTemplate(input: $input) {
    id
  }
}
    `;
export type CreateProjectFromTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>;

/**
 * __useCreateProjectFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateProjectFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFromTemplateMutation, { data, loading, error }] = useCreateProjectFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>(CreateProjectFromTemplateDocument, options);
      }
export type CreateProjectFromTemplateMutationHookResult = ReturnType<typeof useCreateProjectFromTemplateMutation>;
export type CreateProjectFromTemplateMutationResult = ApolloReactCommon.MutationResult<CreateProjectFromTemplateMutation>;
export type CreateProjectFromTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>;
export const GetBrandContactsDocument = gql`
    query GetBrandContacts($id: ID!) {
  brand(id: $id) {
    id
    name
    code
    contacts {
      id
      first_name
      last_name
      image {
        urls {
          thumbnail
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandContactsQuery__
 *
 * To run a query within a React component, call `useGetBrandContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBrandContactsQuery, GetBrandContactsQueryVariables> & ({ variables: GetBrandContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrandContactsQuery, GetBrandContactsQueryVariables>(GetBrandContactsDocument, options);
      }
export function useGetBrandContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrandContactsQuery, GetBrandContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrandContactsQuery, GetBrandContactsQueryVariables>(GetBrandContactsDocument, options);
        }
export function useGetBrandContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBrandContactsQuery, GetBrandContactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBrandContactsQuery, GetBrandContactsQueryVariables>(GetBrandContactsDocument, options);
        }
export type GetBrandContactsQueryHookResult = ReturnType<typeof useGetBrandContactsQuery>;
export type GetBrandContactsLazyQueryHookResult = ReturnType<typeof useGetBrandContactsLazyQuery>;
export type GetBrandContactsSuspenseQueryHookResult = ReturnType<typeof useGetBrandContactsSuspenseQuery>;
export type GetBrandContactsQueryResult = ApolloReactCommon.QueryResult<GetBrandContactsQuery, GetBrandContactsQueryVariables>;
export const GetPmDocument = gql`
    query GetPM($id: ID!) {
  user(id: $id) {
    team {
      id
    }
  }
}
    `;

/**
 * __useGetPmQuery__
 *
 * To run a query within a React component, call `useGetPmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPmQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPmQuery, GetPmQueryVariables> & ({ variables: GetPmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPmQuery, GetPmQueryVariables>(GetPmDocument, options);
      }
export function useGetPmLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPmQuery, GetPmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPmQuery, GetPmQueryVariables>(GetPmDocument, options);
        }
export function useGetPmSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPmQuery, GetPmQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPmQuery, GetPmQueryVariables>(GetPmDocument, options);
        }
export type GetPmQueryHookResult = ReturnType<typeof useGetPmQuery>;
export type GetPmLazyQueryHookResult = ReturnType<typeof useGetPmLazyQuery>;
export type GetPmSuspenseQueryHookResult = ReturnType<typeof useGetPmSuspenseQuery>;
export type GetPmQueryResult = ApolloReactCommon.QueryResult<GetPmQuery, GetPmQueryVariables>;
export const RateCardsDocument = gql`
    query RateCards($brandId: ID) {
  projectRateCard(brand_id: $brandId) {
    id
    name
    currency_iso
  }
}
    `;

/**
 * __useRateCardsQuery__
 *
 * To run a query within a React component, call `useRateCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRateCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRateCardsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useRateCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RateCardsQuery, RateCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RateCardsQuery, RateCardsQueryVariables>(RateCardsDocument, options);
      }
export function useRateCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RateCardsQuery, RateCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RateCardsQuery, RateCardsQueryVariables>(RateCardsDocument, options);
        }
export function useRateCardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RateCardsQuery, RateCardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RateCardsQuery, RateCardsQueryVariables>(RateCardsDocument, options);
        }
export type RateCardsQueryHookResult = ReturnType<typeof useRateCardsQuery>;
export type RateCardsLazyQueryHookResult = ReturnType<typeof useRateCardsLazyQuery>;
export type RateCardsSuspenseQueryHookResult = ReturnType<typeof useRateCardsSuspenseQuery>;
export type RateCardsQueryResult = ApolloReactCommon.QueryResult<RateCardsQuery, RateCardsQueryVariables>;
export const GetProjectFromTemplateDocument = gql`
    query GetProjectFromTemplate($projectId: ID) {
  project(id: $projectId) {
    title
    type
    start_date
    billable
    note
    rate_card_id
    categories {
      id
    }
    brand {
      id
    }
    contact {
      id
    }
    team {
      id
    }
    projectManager {
      id
    }
    otherProjectManagers {
      id
    }
  }
}
    `;

/**
 * __useGetProjectFromTemplateQuery__
 *
 * To run a query within a React component, call `useGetProjectFromTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFromTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFromTemplateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectFromTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>(GetProjectFromTemplateDocument, options);
      }
export function useGetProjectFromTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>(GetProjectFromTemplateDocument, options);
        }
export function useGetProjectFromTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>(GetProjectFromTemplateDocument, options);
        }
export type GetProjectFromTemplateQueryHookResult = ReturnType<typeof useGetProjectFromTemplateQuery>;
export type GetProjectFromTemplateLazyQueryHookResult = ReturnType<typeof useGetProjectFromTemplateLazyQuery>;
export type GetProjectFromTemplateSuspenseQueryHookResult = ReturnType<typeof useGetProjectFromTemplateSuspenseQuery>;
export type GetProjectFromTemplateQueryResult = ApolloReactCommon.QueryResult<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
  }
}
    `;
export type CreateProjectMutationFn = ApolloReactCommon.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = ApolloReactCommon.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const GetProjectCreateDataDocument = gql`
    query GetProjectCreateData {
  teamSimpleMap {
    id
    name
  }
  lowestDateWithOpenProgress
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectManagerSimpleMap {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    codename
    full_name
  }
}
    `;

/**
 * __useGetProjectCreateDataQuery__
 *
 * To run a query within a React component, call `useGetProjectCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCreateDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectCreateDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>(GetProjectCreateDataDocument, options);
      }
export function useGetProjectCreateDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>(GetProjectCreateDataDocument, options);
        }
export function useGetProjectCreateDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>(GetProjectCreateDataDocument, options);
        }
export type GetProjectCreateDataQueryHookResult = ReturnType<typeof useGetProjectCreateDataQuery>;
export type GetProjectCreateDataLazyQueryHookResult = ReturnType<typeof useGetProjectCreateDataLazyQuery>;
export type GetProjectCreateDataSuspenseQueryHookResult = ReturnType<typeof useGetProjectCreateDataSuspenseQuery>;
export type GetProjectCreateDataQueryResult = ApolloReactCommon.QueryResult<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>;
export const ProjectDetailForClientDocument = gql`
    query ProjectDetailForClient($id: ID!) {
  project(id: $id) {
    id
    title
    code
    note
    status
    finished_at
    archived_at
    cloudUrl
    driveCloudUrl
    type
    start_date
    expected_end_date
    externalLinks {
      ...ExternalLinkFragment
    }
    finishedBy {
      id
      full_name
    }
    archivedBy {
      id
      full_name
    }
    otherProjectManagers {
      id
      profile {
        hex_color
      }
      image {
        urls {
          thumbnail
        }
      }
      full_name
    }
    contact {
      id
      phone
      image {
        urls {
          thumbnail
        }
      }
      email
      first_name
      last_name
    }
    projectManager {
      id
      full_name
      profile {
        hex_color
      }
      team {
        name
      }
      image {
        urls {
          thumbnail
        }
      }
    }
    team {
      name
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useProjectDetailForClientQuery__
 *
 * To run a query within a React component, call `useProjectDetailForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailForClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectDetailForClientQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables> & ({ variables: ProjectDetailForClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>(ProjectDetailForClientDocument, options);
      }
export function useProjectDetailForClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>(ProjectDetailForClientDocument, options);
        }
export function useProjectDetailForClientSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>(ProjectDetailForClientDocument, options);
        }
export type ProjectDetailForClientQueryHookResult = ReturnType<typeof useProjectDetailForClientQuery>;
export type ProjectDetailForClientLazyQueryHookResult = ReturnType<typeof useProjectDetailForClientLazyQuery>;
export type ProjectDetailForClientSuspenseQueryHookResult = ReturnType<typeof useProjectDetailForClientSuspenseQuery>;
export type ProjectDetailForClientQueryResult = ApolloReactCommon.QueryResult<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>;
export const TasksForClientDocument = gql`
    query TasksForClient($filters: TaskQueryArgs) {
  tasks(filters: $filters, first: 1000) {
    data {
      ...SimpleTaskForClient
      subtasks {
        ...SimpleTaskForClient
      }
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}`;

/**
 * __useTasksForClientQuery__
 *
 * To run a query within a React component, call `useTasksForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksForClientQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTasksForClientQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TasksForClientQuery, TasksForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksForClientQuery, TasksForClientQueryVariables>(TasksForClientDocument, options);
      }
export function useTasksForClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksForClientQuery, TasksForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksForClientQuery, TasksForClientQueryVariables>(TasksForClientDocument, options);
        }
export function useTasksForClientSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksForClientQuery, TasksForClientQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TasksForClientQuery, TasksForClientQueryVariables>(TasksForClientDocument, options);
        }
export type TasksForClientQueryHookResult = ReturnType<typeof useTasksForClientQuery>;
export type TasksForClientLazyQueryHookResult = ReturnType<typeof useTasksForClientLazyQuery>;
export type TasksForClientSuspenseQueryHookResult = ReturnType<typeof useTasksForClientSuspenseQuery>;
export type TasksForClientQueryResult = ApolloReactCommon.QueryResult<TasksForClientQuery, TasksForClientQueryVariables>;
export const ProjectDetailCreateBudgetItemPlannedExpensesDocument = gql`
    mutation ProjectDetailCreateBudgetItemPlannedExpenses($input: CreateBudgetItemPlannedExpensesInput!) {
  createBudgetItemPlannedExpenses(input: $input) {
    ...ProjectDetailPlannedExpenseFields
  }
}
    ${ProjectDetailPlannedExpenseFieldsFragmentDoc}`;
export type ProjectDetailCreateBudgetItemPlannedExpensesMutationFn = ApolloReactCommon.MutationFunction<ProjectDetailCreateBudgetItemPlannedExpensesMutation, ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables>;

/**
 * __useProjectDetailCreateBudgetItemPlannedExpensesMutation__
 *
 * To run a mutation, you first call `useProjectDetailCreateBudgetItemPlannedExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailCreateBudgetItemPlannedExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDetailCreateBudgetItemPlannedExpensesMutation, { data, loading, error }] = useProjectDetailCreateBudgetItemPlannedExpensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectDetailCreateBudgetItemPlannedExpensesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDetailCreateBudgetItemPlannedExpensesMutation, ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDetailCreateBudgetItemPlannedExpensesMutation, ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables>(ProjectDetailCreateBudgetItemPlannedExpensesDocument, options);
      }
export type ProjectDetailCreateBudgetItemPlannedExpensesMutationHookResult = ReturnType<typeof useProjectDetailCreateBudgetItemPlannedExpensesMutation>;
export type ProjectDetailCreateBudgetItemPlannedExpensesMutationResult = ApolloReactCommon.MutationResult<ProjectDetailCreateBudgetItemPlannedExpensesMutation>;
export type ProjectDetailCreateBudgetItemPlannedExpensesMutationOptions = ApolloReactCommon.BaseMutationOptions<ProjectDetailCreateBudgetItemPlannedExpensesMutation, ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables>;
export const ProjectDetailCreateBudgetItemPlannedExpensesBulkDocument = gql`
    mutation ProjectDetailCreateBudgetItemPlannedExpensesBulk($items: [CreateBudgetItemPlannedExpensesInput!]!) {
  createBudgetItemPlannedExpensesBulk(items: $items) {
    ...ProjectDetailPlannedExpenseFields
  }
}
    ${ProjectDetailPlannedExpenseFieldsFragmentDoc}`;
export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationFn = ApolloReactCommon.MutationFunction<ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation, ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables>;

/**
 * __useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation__
 *
 * To run a mutation, you first call `useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDetailCreateBudgetItemPlannedExpensesBulkMutation, { data, loading, error }] = useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation, ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation, ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables>(ProjectDetailCreateBudgetItemPlannedExpensesBulkDocument, options);
      }
export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationHookResult = ReturnType<typeof useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation>;
export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationResult = ApolloReactCommon.MutationResult<ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation>;
export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation, ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables>;
export const InvoiceProjectByCurrentMonthBillingPlanDocument = gql`
    mutation InvoiceProjectByCurrentMonthBillingPlan($projectId: ID!, $type: RequestForInvoicingTypeEnum!) {
  invoiceProjectByCurrentMonthBillingPlan(id: $projectId, invoice_type: $type) {
    id
  }
}
    `;
export type InvoiceProjectByCurrentMonthBillingPlanMutationFn = ApolloReactCommon.MutationFunction<InvoiceProjectByCurrentMonthBillingPlanMutation, InvoiceProjectByCurrentMonthBillingPlanMutationVariables>;

/**
 * __useInvoiceProjectByCurrentMonthBillingPlanMutation__
 *
 * To run a mutation, you first call `useInvoiceProjectByCurrentMonthBillingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceProjectByCurrentMonthBillingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceProjectByCurrentMonthBillingPlanMutation, { data, loading, error }] = useInvoiceProjectByCurrentMonthBillingPlanMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useInvoiceProjectByCurrentMonthBillingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceProjectByCurrentMonthBillingPlanMutation, InvoiceProjectByCurrentMonthBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoiceProjectByCurrentMonthBillingPlanMutation, InvoiceProjectByCurrentMonthBillingPlanMutationVariables>(InvoiceProjectByCurrentMonthBillingPlanDocument, options);
      }
export type InvoiceProjectByCurrentMonthBillingPlanMutationHookResult = ReturnType<typeof useInvoiceProjectByCurrentMonthBillingPlanMutation>;
export type InvoiceProjectByCurrentMonthBillingPlanMutationResult = ApolloReactCommon.MutationResult<InvoiceProjectByCurrentMonthBillingPlanMutation>;
export type InvoiceProjectByCurrentMonthBillingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<InvoiceProjectByCurrentMonthBillingPlanMutation, InvoiceProjectByCurrentMonthBillingPlanMutationVariables>;
export const ResetBillingPlanNotificationsDocument = gql`
    mutation ResetBillingPlanNotifications($projectId: ID!, $type: BillingPlanNotificationTypeEnum!) {
  resetBillingPlanNotifications(project_id: $projectId, types: [$type]) {
    id
    billingPlanNotifications {
      project_budget_changed
      project_dates_changed
    }
  }
}
    `;
export type ResetBillingPlanNotificationsMutationFn = ApolloReactCommon.MutationFunction<ResetBillingPlanNotificationsMutation, ResetBillingPlanNotificationsMutationVariables>;

/**
 * __useResetBillingPlanNotificationsMutation__
 *
 * To run a mutation, you first call `useResetBillingPlanNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetBillingPlanNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetBillingPlanNotificationsMutation, { data, loading, error }] = useResetBillingPlanNotificationsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useResetBillingPlanNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetBillingPlanNotificationsMutation, ResetBillingPlanNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetBillingPlanNotificationsMutation, ResetBillingPlanNotificationsMutationVariables>(ResetBillingPlanNotificationsDocument, options);
      }
export type ResetBillingPlanNotificationsMutationHookResult = ReturnType<typeof useResetBillingPlanNotificationsMutation>;
export type ResetBillingPlanNotificationsMutationResult = ApolloReactCommon.MutationResult<ResetBillingPlanNotificationsMutation>;
export type ResetBillingPlanNotificationsMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetBillingPlanNotificationsMutation, ResetBillingPlanNotificationsMutationVariables>;
export const UpdateOurWorkBudgetItemsDocument = gql`
    mutation UpdateOurWorkBudgetItems($budgetItems: [UpdateBudgetItem!]!) {
  updateOurWorkBudgetItems(budget_items: $budgetItems) {
    id
  }
}
    `;
export type UpdateOurWorkBudgetItemsMutationFn = ApolloReactCommon.MutationFunction<UpdateOurWorkBudgetItemsMutation, UpdateOurWorkBudgetItemsMutationVariables>;

/**
 * __useUpdateOurWorkBudgetItemsMutation__
 *
 * To run a mutation, you first call `useUpdateOurWorkBudgetItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOurWorkBudgetItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOurWorkBudgetItemsMutation, { data, loading, error }] = useUpdateOurWorkBudgetItemsMutation({
 *   variables: {
 *      budgetItems: // value for 'budgetItems'
 *   },
 * });
 */
export function useUpdateOurWorkBudgetItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOurWorkBudgetItemsMutation, UpdateOurWorkBudgetItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOurWorkBudgetItemsMutation, UpdateOurWorkBudgetItemsMutationVariables>(UpdateOurWorkBudgetItemsDocument, options);
      }
export type UpdateOurWorkBudgetItemsMutationHookResult = ReturnType<typeof useUpdateOurWorkBudgetItemsMutation>;
export type UpdateOurWorkBudgetItemsMutationResult = ApolloReactCommon.MutationResult<UpdateOurWorkBudgetItemsMutation>;
export type UpdateOurWorkBudgetItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOurWorkBudgetItemsMutation, UpdateOurWorkBudgetItemsMutationVariables>;
export const CreateExpenseBudgetItemDocument = gql`
    mutation CreateExpenseBudgetItem($projectId: ID!, $title: String!, $expenseBudgetCategoryId: ID!) {
  createExpenseBudgetItem(
    project_id: $projectId
    title: $title
    expense_budget_category_id: $expenseBudgetCategoryId
  ) {
    ...ExpenseStructuredBudgetItemFragment
  }
}
    ${ExpenseStructuredBudgetItemFragmentFragmentDoc}`;
export type CreateExpenseBudgetItemMutationFn = ApolloReactCommon.MutationFunction<CreateExpenseBudgetItemMutation, CreateExpenseBudgetItemMutationVariables>;

/**
 * __useCreateExpenseBudgetItemMutation__
 *
 * To run a mutation, you first call `useCreateExpenseBudgetItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseBudgetItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseBudgetItemMutation, { data, loading, error }] = useCreateExpenseBudgetItemMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      title: // value for 'title'
 *      expenseBudgetCategoryId: // value for 'expenseBudgetCategoryId'
 *   },
 * });
 */
export function useCreateExpenseBudgetItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExpenseBudgetItemMutation, CreateExpenseBudgetItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExpenseBudgetItemMutation, CreateExpenseBudgetItemMutationVariables>(CreateExpenseBudgetItemDocument, options);
      }
export type CreateExpenseBudgetItemMutationHookResult = ReturnType<typeof useCreateExpenseBudgetItemMutation>;
export type CreateExpenseBudgetItemMutationResult = ApolloReactCommon.MutationResult<CreateExpenseBudgetItemMutation>;
export type CreateExpenseBudgetItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExpenseBudgetItemMutation, CreateExpenseBudgetItemMutationVariables>;
export const CreateOurWorkBudgetItemDocument = gql`
    mutation CreateOurWorkBudgetItem($projectId: ID!, $title: String!) {
  createOurWorkBudgetItem(project_id: $projectId, title: $title) {
    ...OurWorkBudgetItemOverviewFragment
  }
}
    ${OurWorkBudgetItemOverviewFragmentFragmentDoc}`;
export type CreateOurWorkBudgetItemMutationFn = ApolloReactCommon.MutationFunction<CreateOurWorkBudgetItemMutation, CreateOurWorkBudgetItemMutationVariables>;

/**
 * __useCreateOurWorkBudgetItemMutation__
 *
 * To run a mutation, you first call `useCreateOurWorkBudgetItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOurWorkBudgetItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOurWorkBudgetItemMutation, { data, loading, error }] = useCreateOurWorkBudgetItemMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateOurWorkBudgetItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOurWorkBudgetItemMutation, CreateOurWorkBudgetItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOurWorkBudgetItemMutation, CreateOurWorkBudgetItemMutationVariables>(CreateOurWorkBudgetItemDocument, options);
      }
export type CreateOurWorkBudgetItemMutationHookResult = ReturnType<typeof useCreateOurWorkBudgetItemMutation>;
export type CreateOurWorkBudgetItemMutationResult = ApolloReactCommon.MutationResult<CreateOurWorkBudgetItemMutation>;
export type CreateOurWorkBudgetItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOurWorkBudgetItemMutation, CreateOurWorkBudgetItemMutationVariables>;
export const CreateTasksFromTemplateGroupDocument = gql`
    mutation CreateTasksFromTemplateGroup($ourWorkBudgetItemIds: [ID!]!, $taskTemplateGroupId: ID!) {
  createTasksFromTaskTemplateGroup(
    our_work_budget_item_ids: $ourWorkBudgetItemIds
    task_template_group_id: $taskTemplateGroupId
  )
}
    `;
export type CreateTasksFromTemplateGroupMutationFn = ApolloReactCommon.MutationFunction<CreateTasksFromTemplateGroupMutation, CreateTasksFromTemplateGroupMutationVariables>;

/**
 * __useCreateTasksFromTemplateGroupMutation__
 *
 * To run a mutation, you first call `useCreateTasksFromTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTasksFromTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTasksFromTemplateGroupMutation, { data, loading, error }] = useCreateTasksFromTemplateGroupMutation({
 *   variables: {
 *      ourWorkBudgetItemIds: // value for 'ourWorkBudgetItemIds'
 *      taskTemplateGroupId: // value for 'taskTemplateGroupId'
 *   },
 * });
 */
export function useCreateTasksFromTemplateGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTasksFromTemplateGroupMutation, CreateTasksFromTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTasksFromTemplateGroupMutation, CreateTasksFromTemplateGroupMutationVariables>(CreateTasksFromTemplateGroupDocument, options);
      }
export type CreateTasksFromTemplateGroupMutationHookResult = ReturnType<typeof useCreateTasksFromTemplateGroupMutation>;
export type CreateTasksFromTemplateGroupMutationResult = ApolloReactCommon.MutationResult<CreateTasksFromTemplateGroupMutation>;
export type CreateTasksFromTemplateGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTasksFromTemplateGroupMutation, CreateTasksFromTemplateGroupMutationVariables>;
export const OurWorkOverviewForProjectDocument = gql`
    query OurWorkOverviewForProject($projectId: ID!) {
  project(id: $projectId) {
    ourWorkOverview(withDoneTasks: false) {
      ...OurWorkOverview
    }
  }
}
    ${OurWorkOverviewFragmentDoc}`;

/**
 * __useOurWorkOverviewForProjectQuery__
 *
 * To run a query within a React component, call `useOurWorkOverviewForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useOurWorkOverviewForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOurWorkOverviewForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useOurWorkOverviewForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables> & ({ variables: OurWorkOverviewForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>(OurWorkOverviewForProjectDocument, options);
      }
export function useOurWorkOverviewForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>(OurWorkOverviewForProjectDocument, options);
        }
export function useOurWorkOverviewForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>(OurWorkOverviewForProjectDocument, options);
        }
export type OurWorkOverviewForProjectQueryHookResult = ReturnType<typeof useOurWorkOverviewForProjectQuery>;
export type OurWorkOverviewForProjectLazyQueryHookResult = ReturnType<typeof useOurWorkOverviewForProjectLazyQuery>;
export type OurWorkOverviewForProjectSuspenseQueryHookResult = ReturnType<typeof useOurWorkOverviewForProjectSuspenseQuery>;
export type OurWorkOverviewForProjectQueryResult = ApolloReactCommon.QueryResult<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>;
export const OurWorkOverviewDoneTasksForProjectDocument = gql`
    query OurWorkOverviewDoneTasksForProject($projectId: ID!, $budgetItemId: ID) {
  project(id: $projectId) {
    ourWorkOverview(withDoneTasks: true, budgetItemId: $budgetItemId) {
      budgetItems {
        id
        ...OurWorkBudgetItemOverviewTasksFragment
      }
    }
  }
}
    ${OurWorkBudgetItemOverviewTasksFragmentFragmentDoc}`;

/**
 * __useOurWorkOverviewDoneTasksForProjectQuery__
 *
 * To run a query within a React component, call `useOurWorkOverviewDoneTasksForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useOurWorkOverviewDoneTasksForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOurWorkOverviewDoneTasksForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      budgetItemId: // value for 'budgetItemId'
 *   },
 * });
 */
export function useOurWorkOverviewDoneTasksForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables> & ({ variables: OurWorkOverviewDoneTasksForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>(OurWorkOverviewDoneTasksForProjectDocument, options);
      }
export function useOurWorkOverviewDoneTasksForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>(OurWorkOverviewDoneTasksForProjectDocument, options);
        }
export function useOurWorkOverviewDoneTasksForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>(OurWorkOverviewDoneTasksForProjectDocument, options);
        }
export type OurWorkOverviewDoneTasksForProjectQueryHookResult = ReturnType<typeof useOurWorkOverviewDoneTasksForProjectQuery>;
export type OurWorkOverviewDoneTasksForProjectLazyQueryHookResult = ReturnType<typeof useOurWorkOverviewDoneTasksForProjectLazyQuery>;
export type OurWorkOverviewDoneTasksForProjectSuspenseQueryHookResult = ReturnType<typeof useOurWorkOverviewDoneTasksForProjectSuspenseQuery>;
export type OurWorkOverviewDoneTasksForProjectQueryResult = ApolloReactCommon.QueryResult<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>;
export const ProjectDetailDocument = gql`
    query ProjectDetail($id: ID!) {
  project(id: $id) {
    id
    title
    code
    numeric_code
    note
    status
    billable
    is_pinned
    is_starred
    uses_budgetovac
    finished_at
    archived_at
    cloudUrl
    driveCloudUrl
    billingPlanIsMissing
    type
    start_date
    expected_end_date
    is_template
    externalLinks {
      ...ExternalLinkFragment
    }
    categories {
      id
      name
    }
    billingPlanNotifications {
      project_dates_changed
      project_budget_changed
    }
    finishedBy {
      id
      full_name
    }
    archivedBy {
      id
      full_name
    }
    budgetovacBudget {
      budget_id
      internally_approved
      newer_final_version_available
    }
    budgetovacBudgets {
      id
      internally_approved
      is_active
    }
    lastWorkInProgressProjectStat {
      progress_percent
    }
    orders {
      data {
        id
        purchase_order_no
      }
    }
    projectManager {
      ...UserToolTip_UserFragment
    }
    otherProjectManagers {
      ...UserToolTip_UserFragment
    }
    contact {
      id
      phone
      image {
        urls {
          thumbnail
        }
      }
      email
      first_name
      last_name
    }
    team {
      id
      name
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    currentMonthBillingPlanOutgoingInvoice
    currentMonthBillingPlanOutgoingProformaInvoice
    statsCached {
      total_budget
      invoiceable
      uninvoiced
      credit
      credit_balance
      credit_direct
      credit_from_prepayments
      unused_sum_from_proformas
      over_invoiced
      net_profit
      net_margin_percent
      gross_income
      outgoing_invoice_amount
      outgoing_invoice_paid
      outgoing_proforma_invoice_amount
      outgoing_proforma_invoice_paid
      outgoing_proforma_invoice_settled
      outgoing_proforma_invoice_unsettled
      credit_from_unused_prepayments
      ourWork {
        spent_time
        remaining_time
        total_time
        total_budget
        spent_budget
        spent_budget_percent
        remaining_budget
        credit
        invoiced_percent
        invoiceable
        uninvoiced
        all_items_completed
        net_profit
        net_margin_percent
        efficiency_percent
      }
      expenses {
        total_budget
        planned_expenses
        planned_commission
        planned_profit
        planned_commission_relative_computed
        real_expenses
        real_commission
        real_expenses_percent
        real_commission_relative
        credit
        credit_balance
        invoiced_percent
        invoiceable
        uninvoiced
        all_items_completed
      }
    }
    expensesStructured {
      id
      budget_category_id
      name
      total_budget
      credit
      budgetItems {
        ...ExpenseStructuredBudgetItemFragment
      }
    }
    invoiceStats {
      id
    }
    proformaInvoices {
      id
    }
    prepaymentStats {
      id
    }
    currentMonthBillingPlanStats {
      current_month_planned
      show_invoice_date_approaching_warning
    }
    billingPlanSetting {
      project_id
    }
    billingPlanByMonths {
      id
    }
    project_stage {
      ...ProjectStage
    }
    pipedriveCustomFieldValues {
      ...PipedriveCustomField
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}
${UserToolTip_UserFragmentFragmentDoc}
${ExpenseStructuredBudgetItemFragmentFragmentDoc}
${ProjectStageFragmentDoc}
${PipedriveCustomFieldFragmentDoc}`;

/**
 * __useProjectDetailQuery__
 *
 * To run a query within a React component, call `useProjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables> & ({ variables: ProjectDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
      }
export function useProjectDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
        }
export function useProjectDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
        }
export type ProjectDetailQueryHookResult = ReturnType<typeof useProjectDetailQuery>;
export type ProjectDetailLazyQueryHookResult = ReturnType<typeof useProjectDetailLazyQuery>;
export type ProjectDetailSuspenseQueryHookResult = ReturnType<typeof useProjectDetailSuspenseQuery>;
export type ProjectDetailQueryResult = ApolloReactCommon.QueryResult<ProjectDetailQuery, ProjectDetailQueryVariables>;
export const ProjectGraphDocument = gql`
    query ProjectGraph($projectId: ID!, $ourWorkBudgetItemIds: [ID!]) {
  projectGraph(
    project_id: $projectId
    our_work_budget_item_ids: $ourWorkBudgetItemIds
  ) {
    totalBudgetData {
      date
      amount
    }
    spentBudgetData {
      date
      amount
    }
  }
}
    `;

/**
 * __useProjectGraphQuery__
 *
 * To run a query within a React component, call `useProjectGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGraphQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      ourWorkBudgetItemIds: // value for 'ourWorkBudgetItemIds'
 *   },
 * });
 */
export function useProjectGraphQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectGraphQuery, ProjectGraphQueryVariables> & ({ variables: ProjectGraphQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectGraphQuery, ProjectGraphQueryVariables>(ProjectGraphDocument, options);
      }
export function useProjectGraphLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectGraphQuery, ProjectGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectGraphQuery, ProjectGraphQueryVariables>(ProjectGraphDocument, options);
        }
export function useProjectGraphSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectGraphQuery, ProjectGraphQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectGraphQuery, ProjectGraphQueryVariables>(ProjectGraphDocument, options);
        }
export type ProjectGraphQueryHookResult = ReturnType<typeof useProjectGraphQuery>;
export type ProjectGraphLazyQueryHookResult = ReturnType<typeof useProjectGraphLazyQuery>;
export type ProjectGraphSuspenseQueryHookResult = ReturnType<typeof useProjectGraphSuspenseQuery>;
export type ProjectGraphQueryResult = ApolloReactCommon.QueryResult<ProjectGraphQuery, ProjectGraphQueryVariables>;
export const ProjectDetailBudgetItemPlannedExpensesDocument = gql`
    query ProjectDetailBudgetItemPlannedExpenses($budgetItemId: ID!, $budgetItemType: ExpenseBudgetItemTypeEnum!) {
  budgetItemPlannedExpenses(
    budget_item_id: $budgetItemId
    budget_item_type: $budgetItemType
  ) {
    ...ProjectDetailPlannedExpenseFields
  }
}
    ${ProjectDetailPlannedExpenseFieldsFragmentDoc}`;

/**
 * __useProjectDetailBudgetItemPlannedExpensesQuery__
 *
 * To run a query within a React component, call `useProjectDetailBudgetItemPlannedExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailBudgetItemPlannedExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailBudgetItemPlannedExpensesQuery({
 *   variables: {
 *      budgetItemId: // value for 'budgetItemId'
 *      budgetItemType: // value for 'budgetItemType'
 *   },
 * });
 */
export function useProjectDetailBudgetItemPlannedExpensesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables> & ({ variables: ProjectDetailBudgetItemPlannedExpensesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>(ProjectDetailBudgetItemPlannedExpensesDocument, options);
      }
export function useProjectDetailBudgetItemPlannedExpensesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>(ProjectDetailBudgetItemPlannedExpensesDocument, options);
        }
export function useProjectDetailBudgetItemPlannedExpensesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>(ProjectDetailBudgetItemPlannedExpensesDocument, options);
        }
export type ProjectDetailBudgetItemPlannedExpensesQueryHookResult = ReturnType<typeof useProjectDetailBudgetItemPlannedExpensesQuery>;
export type ProjectDetailBudgetItemPlannedExpensesLazyQueryHookResult = ReturnType<typeof useProjectDetailBudgetItemPlannedExpensesLazyQuery>;
export type ProjectDetailBudgetItemPlannedExpensesSuspenseQueryHookResult = ReturnType<typeof useProjectDetailBudgetItemPlannedExpensesSuspenseQuery>;
export type ProjectDetailBudgetItemPlannedExpensesQueryResult = ApolloReactCommon.QueryResult<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>;
export const ProjectDocumentsDocument = gql`
    query ProjectDocuments($id: ID!) {
  project(id: $id) {
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

/**
 * __useProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectDocumentsQuery, ProjectDocumentsQueryVariables> & ({ variables: ProjectDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>(ProjectDocumentsDocument, options);
      }
export function useProjectDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>(ProjectDocumentsDocument, options);
        }
export function useProjectDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>(ProjectDocumentsDocument, options);
        }
export type ProjectDocumentsQueryHookResult = ReturnType<typeof useProjectDocumentsQuery>;
export type ProjectDocumentsLazyQueryHookResult = ReturnType<typeof useProjectDocumentsLazyQuery>;
export type ProjectDocumentsSuspenseQueryHookResult = ReturnType<typeof useProjectDocumentsSuspenseQuery>;
export type ProjectDocumentsQueryResult = ApolloReactCommon.QueryResult<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($input: UpdateProjectInput!, $propagate_billable: Boolean!) {
  updateProject(input: $input, propagate_billable: $propagate_billable) {
    id
  }
}
    `;
export type UpdateProjectMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *      propagate_billable: // value for 'propagate_billable'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = ApolloReactCommon.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const GetProjectEditDataDocument = gql`
    query GetProjectEditData($id: ID!) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  lowestDateWithOpenProgress
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
    codename
    name
  }
  project(id: $id) {
    title
    code
    note
    start_date
    expected_end_date
    billable
    type
    finished_at
    uses_budgetovac
    lowestPossibleDateForStartDateChange
    rate_card_id
    is_template
    users {
      id
    }
    categories {
      id
      name
    }
    team {
      id
      name
    }
    brand {
      id
      name
    }
    contact {
      id
    }
    projectManager {
      id
    }
    otherProjectManagers {
      id
    }
    ourWorkStructured {
      budgetItems {
        id
        tasks {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectEditDataQuery__
 *
 * To run a query within a React component, call `useGetProjectEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectEditDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectEditDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectEditDataQuery, GetProjectEditDataQueryVariables> & ({ variables: GetProjectEditDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>(GetProjectEditDataDocument, options);
      }
export function useGetProjectEditDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>(GetProjectEditDataDocument, options);
        }
export function useGetProjectEditDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>(GetProjectEditDataDocument, options);
        }
export type GetProjectEditDataQueryHookResult = ReturnType<typeof useGetProjectEditDataQuery>;
export type GetProjectEditDataLazyQueryHookResult = ReturnType<typeof useGetProjectEditDataLazyQuery>;
export type GetProjectEditDataSuspenseQueryHookResult = ReturnType<typeof useGetProjectEditDataSuspenseQuery>;
export type GetProjectEditDataQueryResult = ApolloReactCommon.QueryResult<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>;
export const ClientsProjectListTableDataDocument = gql`
    query ClientsProjectListTableData($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      brand {
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      users {
        full_name
        scope {
          value
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      stats {
        invoiced_percent
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useClientsProjectListTableDataQuery__
 *
 * To run a query within a React component, call `useClientsProjectListTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsProjectListTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsProjectListTableDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useClientsProjectListTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables> & ({ variables: ClientsProjectListTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>(ClientsProjectListTableDataDocument, options);
      }
export function useClientsProjectListTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>(ClientsProjectListTableDataDocument, options);
        }
export function useClientsProjectListTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>(ClientsProjectListTableDataDocument, options);
        }
export type ClientsProjectListTableDataQueryHookResult = ReturnType<typeof useClientsProjectListTableDataQuery>;
export type ClientsProjectListTableDataLazyQueryHookResult = ReturnType<typeof useClientsProjectListTableDataLazyQuery>;
export type ClientsProjectListTableDataSuspenseQueryHookResult = ReturnType<typeof useClientsProjectListTableDataSuspenseQuery>;
export type ClientsProjectListTableDataQueryResult = ApolloReactCommon.QueryResult<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>;
export const ClientsProjectListFilterOptionsDocument = gql`
    query ClientsProjectListFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    name
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

/**
 * __useClientsProjectListFilterOptionsQuery__
 *
 * To run a query within a React component, call `useClientsProjectListFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsProjectListFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsProjectListFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientsProjectListFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>(ClientsProjectListFilterOptionsDocument, options);
      }
export function useClientsProjectListFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>(ClientsProjectListFilterOptionsDocument, options);
        }
export function useClientsProjectListFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>(ClientsProjectListFilterOptionsDocument, options);
        }
export type ClientsProjectListFilterOptionsQueryHookResult = ReturnType<typeof useClientsProjectListFilterOptionsQuery>;
export type ClientsProjectListFilterOptionsLazyQueryHookResult = ReturnType<typeof useClientsProjectListFilterOptionsLazyQuery>;
export type ClientsProjectListFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useClientsProjectListFilterOptionsSuspenseQuery>;
export type ClientsProjectListFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>;
export const CloseWipDocument = gql`
    mutation CloseWip($id: ID!) {
  closeWip(id: $id) {
    is_closed
  }
}
    `;
export type CloseWipMutationFn = ApolloReactCommon.MutationFunction<CloseWipMutation, CloseWipMutationVariables>;

/**
 * __useCloseWipMutation__
 *
 * To run a mutation, you first call `useCloseWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeWipMutation, { data, loading, error }] = useCloseWipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseWipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloseWipMutation, CloseWipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloseWipMutation, CloseWipMutationVariables>(CloseWipDocument, options);
      }
export type CloseWipMutationHookResult = ReturnType<typeof useCloseWipMutation>;
export type CloseWipMutationResult = ApolloReactCommon.MutationResult<CloseWipMutation>;
export type CloseWipMutationOptions = ApolloReactCommon.BaseMutationOptions<CloseWipMutation, CloseWipMutationVariables>;
export const CloseWipBulkDocument = gql`
    mutation CloseWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  closeWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;
export type CloseWipBulkMutationFn = ApolloReactCommon.MutationFunction<CloseWipBulkMutation, CloseWipBulkMutationVariables>;

/**
 * __useCloseWipBulkMutation__
 *
 * To run a mutation, you first call `useCloseWipBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseWipBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeWipBulkMutation, { data, loading, error }] = useCloseWipBulkMutation({
 *   variables: {
 *      periodId: // value for 'periodId'
 *      projectId: // value for 'projectId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCloseWipBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloseWipBulkMutation, CloseWipBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloseWipBulkMutation, CloseWipBulkMutationVariables>(CloseWipBulkDocument, options);
      }
export type CloseWipBulkMutationHookResult = ReturnType<typeof useCloseWipBulkMutation>;
export type CloseWipBulkMutationResult = ApolloReactCommon.MutationResult<CloseWipBulkMutation>;
export type CloseWipBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<CloseWipBulkMutation, CloseWipBulkMutationVariables>;
export const LockWipDocument = gql`
    mutation LockWip($id: ID!) {
  lockWip(id: $id) {
    is_locked
  }
}
    `;
export type LockWipMutationFn = ApolloReactCommon.MutationFunction<LockWipMutation, LockWipMutationVariables>;

/**
 * __useLockWipMutation__
 *
 * To run a mutation, you first call `useLockWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockWipMutation, { data, loading, error }] = useLockWipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLockWipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LockWipMutation, LockWipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LockWipMutation, LockWipMutationVariables>(LockWipDocument, options);
      }
export type LockWipMutationHookResult = ReturnType<typeof useLockWipMutation>;
export type LockWipMutationResult = ApolloReactCommon.MutationResult<LockWipMutation>;
export type LockWipMutationOptions = ApolloReactCommon.BaseMutationOptions<LockWipMutation, LockWipMutationVariables>;
export const LockWipBulkDocument = gql`
    mutation LockWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  lockWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;
export type LockWipBulkMutationFn = ApolloReactCommon.MutationFunction<LockWipBulkMutation, LockWipBulkMutationVariables>;

/**
 * __useLockWipBulkMutation__
 *
 * To run a mutation, you first call `useLockWipBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockWipBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockWipBulkMutation, { data, loading, error }] = useLockWipBulkMutation({
 *   variables: {
 *      periodId: // value for 'periodId'
 *      projectId: // value for 'projectId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLockWipBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LockWipBulkMutation, LockWipBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LockWipBulkMutation, LockWipBulkMutationVariables>(LockWipBulkDocument, options);
      }
export type LockWipBulkMutationHookResult = ReturnType<typeof useLockWipBulkMutation>;
export type LockWipBulkMutationResult = ApolloReactCommon.MutationResult<LockWipBulkMutation>;
export type LockWipBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<LockWipBulkMutation, LockWipBulkMutationVariables>;
export const OpenWipDocument = gql`
    mutation OpenWip($id: ID!) {
  openWip(id: $id) {
    is_closed
  }
}
    `;
export type OpenWipMutationFn = ApolloReactCommon.MutationFunction<OpenWipMutation, OpenWipMutationVariables>;

/**
 * __useOpenWipMutation__
 *
 * To run a mutation, you first call `useOpenWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openWipMutation, { data, loading, error }] = useOpenWipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenWipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenWipMutation, OpenWipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenWipMutation, OpenWipMutationVariables>(OpenWipDocument, options);
      }
export type OpenWipMutationHookResult = ReturnType<typeof useOpenWipMutation>;
export type OpenWipMutationResult = ApolloReactCommon.MutationResult<OpenWipMutation>;
export type OpenWipMutationOptions = ApolloReactCommon.BaseMutationOptions<OpenWipMutation, OpenWipMutationVariables>;
export const OpenWipBulkDocument = gql`
    mutation OpenWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  openWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;
export type OpenWipBulkMutationFn = ApolloReactCommon.MutationFunction<OpenWipBulkMutation, OpenWipBulkMutationVariables>;

/**
 * __useOpenWipBulkMutation__
 *
 * To run a mutation, you first call `useOpenWipBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenWipBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openWipBulkMutation, { data, loading, error }] = useOpenWipBulkMutation({
 *   variables: {
 *      periodId: // value for 'periodId'
 *      projectId: // value for 'projectId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOpenWipBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenWipBulkMutation, OpenWipBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenWipBulkMutation, OpenWipBulkMutationVariables>(OpenWipBulkDocument, options);
      }
export type OpenWipBulkMutationHookResult = ReturnType<typeof useOpenWipBulkMutation>;
export type OpenWipBulkMutationResult = ApolloReactCommon.MutationResult<OpenWipBulkMutation>;
export type OpenWipBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<OpenWipBulkMutation, OpenWipBulkMutationVariables>;
export const SubmitProgressDocument = gql`
    mutation SubmitProgress($input: SubmitProgressInput!) {
  submitProgress(input: $input) {
    changedWorkInProgressItemStats {
      our_work_budget_item_id
      work_in_progress_id
      ...WipItemStatAffectedValues
    }
    lastWorkInProgressProjectStat {
      progress
      progress_percent
      progress_change
      progress_change_percent
      spent_time_estimate
    }
  }
}
    ${WipItemStatAffectedValuesFragmentDoc}`;
export type SubmitProgressMutationFn = ApolloReactCommon.MutationFunction<SubmitProgressMutation, SubmitProgressMutationVariables>;

/**
 * __useSubmitProgressMutation__
 *
 * To run a mutation, you first call `useSubmitProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProgressMutation, { data, loading, error }] = useSubmitProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitProgressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitProgressMutation, SubmitProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitProgressMutation, SubmitProgressMutationVariables>(SubmitProgressDocument, options);
      }
export type SubmitProgressMutationHookResult = ReturnType<typeof useSubmitProgressMutation>;
export type SubmitProgressMutationResult = ApolloReactCommon.MutationResult<SubmitProgressMutation>;
export type SubmitProgressMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitProgressMutation, SubmitProgressMutationVariables>;
export const SubmitProgressBulkDocument = gql`
    mutation SubmitProgressBulk($ids: [ID!]!, $progress: BigInt!) {
  submitProgressBulk(input: {ids: $ids, progress: $progress}) {
    id
    lastWorkInProgressItemStat {
      id
      work_in_progress_id
      ...WipItemStatAffectedValues
    }
  }
}
    ${WipItemStatAffectedValuesFragmentDoc}`;
export type SubmitProgressBulkMutationFn = ApolloReactCommon.MutationFunction<SubmitProgressBulkMutation, SubmitProgressBulkMutationVariables>;

/**
 * __useSubmitProgressBulkMutation__
 *
 * To run a mutation, you first call `useSubmitProgressBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProgressBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProgressBulkMutation, { data, loading, error }] = useSubmitProgressBulkMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      progress: // value for 'progress'
 *   },
 * });
 */
export function useSubmitProgressBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitProgressBulkMutation, SubmitProgressBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitProgressBulkMutation, SubmitProgressBulkMutationVariables>(SubmitProgressBulkDocument, options);
      }
export type SubmitProgressBulkMutationHookResult = ReturnType<typeof useSubmitProgressBulkMutation>;
export type SubmitProgressBulkMutationResult = ApolloReactCommon.MutationResult<SubmitProgressBulkMutation>;
export type SubmitProgressBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitProgressBulkMutation, SubmitProgressBulkMutationVariables>;
export const UnlockWipDocument = gql`
    mutation UnlockWip($id: ID!) {
  unlockWip(id: $id) {
    is_locked
  }
}
    `;
export type UnlockWipMutationFn = ApolloReactCommon.MutationFunction<UnlockWipMutation, UnlockWipMutationVariables>;

/**
 * __useUnlockWipMutation__
 *
 * To run a mutation, you first call `useUnlockWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockWipMutation, { data, loading, error }] = useUnlockWipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlockWipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlockWipMutation, UnlockWipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlockWipMutation, UnlockWipMutationVariables>(UnlockWipDocument, options);
      }
export type UnlockWipMutationHookResult = ReturnType<typeof useUnlockWipMutation>;
export type UnlockWipMutationResult = ApolloReactCommon.MutationResult<UnlockWipMutation>;
export type UnlockWipMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlockWipMutation, UnlockWipMutationVariables>;
export const UnlockWipBulkDocument = gql`
    mutation UnlockWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  unlockWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;
export type UnlockWipBulkMutationFn = ApolloReactCommon.MutationFunction<UnlockWipBulkMutation, UnlockWipBulkMutationVariables>;

/**
 * __useUnlockWipBulkMutation__
 *
 * To run a mutation, you first call `useUnlockWipBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockWipBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockWipBulkMutation, { data, loading, error }] = useUnlockWipBulkMutation({
 *   variables: {
 *      periodId: // value for 'periodId'
 *      projectId: // value for 'projectId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUnlockWipBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlockWipBulkMutation, UnlockWipBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlockWipBulkMutation, UnlockWipBulkMutationVariables>(UnlockWipBulkDocument, options);
      }
export type UnlockWipBulkMutationHookResult = ReturnType<typeof useUnlockWipBulkMutation>;
export type UnlockWipBulkMutationResult = ApolloReactCommon.MutationResult<UnlockWipBulkMutation>;
export type UnlockWipBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlockWipBulkMutation, UnlockWipBulkMutationVariables>;
export const ProjectProgressStatisticsExportDocument = gql`
    query ProjectProgressStatisticsExport($from: Date, $to: Date, $wip_period_ids: [ID!]) {
  projectProgressStatisticsExport(
    from: $from
    to: $to
    wip_period_ids: $wip_period_ids
  )
}
    `;

/**
 * __useProjectProgressStatisticsExportQuery__
 *
 * To run a query within a React component, call `useProjectProgressStatisticsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProgressStatisticsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProgressStatisticsExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      wip_period_ids: // value for 'wip_period_ids'
 *   },
 * });
 */
export function useProjectProgressStatisticsExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>(ProjectProgressStatisticsExportDocument, options);
      }
export function useProjectProgressStatisticsExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>(ProjectProgressStatisticsExportDocument, options);
        }
export function useProjectProgressStatisticsExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>(ProjectProgressStatisticsExportDocument, options);
        }
export type ProjectProgressStatisticsExportQueryHookResult = ReturnType<typeof useProjectProgressStatisticsExportQuery>;
export type ProjectProgressStatisticsExportLazyQueryHookResult = ReturnType<typeof useProjectProgressStatisticsExportLazyQuery>;
export type ProjectProgressStatisticsExportSuspenseQueryHookResult = ReturnType<typeof useProjectProgressStatisticsExportSuspenseQuery>;
export type ProjectProgressStatisticsExportQueryResult = ApolloReactCommon.QueryResult<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>;
export const ProjectWipExportDocument = gql`
    query ProjectWipExport($period_id: ID!) {
  projectWipExport(period_id: $period_id)
}
    `;

/**
 * __useProjectWipExportQuery__
 *
 * To run a query within a React component, call `useProjectWipExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectWipExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectWipExportQuery({
 *   variables: {
 *      period_id: // value for 'period_id'
 *   },
 * });
 */
export function useProjectWipExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectWipExportQuery, ProjectWipExportQueryVariables> & ({ variables: ProjectWipExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectWipExportQuery, ProjectWipExportQueryVariables>(ProjectWipExportDocument, options);
      }
export function useProjectWipExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectWipExportQuery, ProjectWipExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectWipExportQuery, ProjectWipExportQueryVariables>(ProjectWipExportDocument, options);
        }
export function useProjectWipExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectWipExportQuery, ProjectWipExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectWipExportQuery, ProjectWipExportQueryVariables>(ProjectWipExportDocument, options);
        }
export type ProjectWipExportQueryHookResult = ReturnType<typeof useProjectWipExportQuery>;
export type ProjectWipExportLazyQueryHookResult = ReturnType<typeof useProjectWipExportLazyQuery>;
export type ProjectWipExportSuspenseQueryHookResult = ReturnType<typeof useProjectWipExportSuspenseQuery>;
export type ProjectWipExportQueryResult = ApolloReactCommon.QueryResult<ProjectWipExportQuery, ProjectWipExportQueryVariables>;
export const ProjectsCommissionExportDocument = gql`
    query ProjectsCommissionExport($from: Date, $to: Date) {
  projectsCommissionExport(from: $from, to: $to)
}
    `;

/**
 * __useProjectsCommissionExportQuery__
 *
 * To run a query within a React component, call `useProjectsCommissionExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsCommissionExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsCommissionExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useProjectsCommissionExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>(ProjectsCommissionExportDocument, options);
      }
export function useProjectsCommissionExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>(ProjectsCommissionExportDocument, options);
        }
export function useProjectsCommissionExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>(ProjectsCommissionExportDocument, options);
        }
export type ProjectsCommissionExportQueryHookResult = ReturnType<typeof useProjectsCommissionExportQuery>;
export type ProjectsCommissionExportLazyQueryHookResult = ReturnType<typeof useProjectsCommissionExportLazyQuery>;
export type ProjectsCommissionExportSuspenseQueryHookResult = ReturnType<typeof useProjectsCommissionExportSuspenseQuery>;
export type ProjectsCommissionExportQueryResult = ApolloReactCommon.QueryResult<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>;
export const ProjectsWipFilterOptionsDocument = gql`
    query ProjectsWIPFilterOptions {
  teamSimpleMap {
    id
    name
  }
  roles {
    id
    name
  }
  clientsSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  wipPeriodsMap {
    id
    title
    starts_at
    ends_at
    is_current
  }
}
    `;

/**
 * __useProjectsWipFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProjectsWipFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWipFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWipFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsWipFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>(ProjectsWipFilterOptionsDocument, options);
      }
export function useProjectsWipFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>(ProjectsWipFilterOptionsDocument, options);
        }
export function useProjectsWipFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>(ProjectsWipFilterOptionsDocument, options);
        }
export type ProjectsWipFilterOptionsQueryHookResult = ReturnType<typeof useProjectsWipFilterOptionsQuery>;
export type ProjectsWipFilterOptionsLazyQueryHookResult = ReturnType<typeof useProjectsWipFilterOptionsLazyQuery>;
export type ProjectsWipFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectsWipFilterOptionsSuspenseQuery>;
export type ProjectsWipFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>;
export const ProjectsWipSummaryDocument = gql`
    query ProjectsWIPSummary($filters: WipQueryArgs) {
  wipProjectsPeriodSummary(filters: $filters) {
    progress_change
    progress_change_billable
    profit_estimate
    is_period_closed
    is_period_locked
    is_previous_period_closed
  }
}
    `;

/**
 * __useProjectsWipSummaryQuery__
 *
 * To run a query within a React component, call `useProjectsWipSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWipSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWipSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectsWipSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>(ProjectsWipSummaryDocument, options);
      }
export function useProjectsWipSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>(ProjectsWipSummaryDocument, options);
        }
export function useProjectsWipSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>(ProjectsWipSummaryDocument, options);
        }
export type ProjectsWipSummaryQueryHookResult = ReturnType<typeof useProjectsWipSummaryQuery>;
export type ProjectsWipSummaryLazyQueryHookResult = ReturnType<typeof useProjectsWipSummaryLazyQuery>;
export type ProjectsWipSummarySuspenseQueryHookResult = ReturnType<typeof useProjectsWipSummarySuspenseQuery>;
export type ProjectsWipSummaryQueryResult = ApolloReactCommon.QueryResult<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>;
export const ProjectsWipTableDataDocument = gql`
    query ProjectsWIPTableData($page: Int!, $first: Int, $filters: WipQueryArgs) {
  projectsWithPeriods(first: $first, page: $page, filters: $filters) {
    data {
      id
      total_budget
      total_budget_change
      spent_budget
      spent_budget_percent
      spent_time
      remaining_budget
      remaining_time
      progress_percent
      progress_change
      progress_change_percent
      profit_estimate
      profit_estimate_percent
      is_locked
      is_closed
      project {
        id
        title
        code
        billable
        projectManager {
          ...UserToolTip_UserFragment
        }
        otherProjectManagers {
          id
        }
        brand {
          id
          name
          image {
            urls {
              thumbnail
            }
          }
        }
        categories {
          name
        }
      }
      budgetItemsStats {
        our_work_budget_item_id
        work_in_progress_id
        title
        total_budget
        spent_budget
        spent_budget_percent
        spent_time
        remaining_budget
        remaining_time
        progress_percent
        progress_change
        progress_change_percent
        profit_estimate
        profit_estimate_percent
        total_budget_change
        is_locked
        is_closed
        deleted
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectsWipTableDataQuery__
 *
 * To run a query within a React component, call `useProjectsWipTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWipTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWipTableDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectsWipTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables> & ({ variables: ProjectsWipTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>(ProjectsWipTableDataDocument, options);
      }
export function useProjectsWipTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>(ProjectsWipTableDataDocument, options);
        }
export function useProjectsWipTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>(ProjectsWipTableDataDocument, options);
        }
export type ProjectsWipTableDataQueryHookResult = ReturnType<typeof useProjectsWipTableDataQuery>;
export type ProjectsWipTableDataLazyQueryHookResult = ReturnType<typeof useProjectsWipTableDataLazyQuery>;
export type ProjectsWipTableDataSuspenseQueryHookResult = ReturnType<typeof useProjectsWipTableDataSuspenseQuery>;
export type ProjectsWipTableDataQueryResult = ApolloReactCommon.QueryResult<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>;
export const ProjectsEffectivenessExportDocument = gql`
    query ProjectsEffectivenessExport($filters: ProjectQueryArgs, $startDate: DateRange, $finishedAt: DateRange, $dateOfSupply: DateRange) {
  projectsEffectivenessExport(
    filters: $filters
    startDate: $startDate
    finishedAt: $finishedAt
    dateOfSupply: $dateOfSupply
  )
}
    `;

/**
 * __useProjectsEffectivenessExportQuery__
 *
 * To run a query within a React component, call `useProjectsEffectivenessExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsEffectivenessExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsEffectivenessExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      finishedAt: // value for 'finishedAt'
 *      dateOfSupply: // value for 'dateOfSupply'
 *   },
 * });
 */
export function useProjectsEffectivenessExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>(ProjectsEffectivenessExportDocument, options);
      }
export function useProjectsEffectivenessExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>(ProjectsEffectivenessExportDocument, options);
        }
export function useProjectsEffectivenessExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>(ProjectsEffectivenessExportDocument, options);
        }
export type ProjectsEffectivenessExportQueryHookResult = ReturnType<typeof useProjectsEffectivenessExportQuery>;
export type ProjectsEffectivenessExportLazyQueryHookResult = ReturnType<typeof useProjectsEffectivenessExportLazyQuery>;
export type ProjectsEffectivenessExportSuspenseQueryHookResult = ReturnType<typeof useProjectsEffectivenessExportSuspenseQuery>;
export type ProjectsEffectivenessExportQueryResult = ApolloReactCommon.QueryResult<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>;
export const MlggkProjectsEffectivenessExportDocument = gql`
    query MlggkProjectsEffectivenessExport($filters: ProjectQueryArgs, $startDate: DateRange, $finishedAt: DateRange, $dateOfSupply: DateRange) {
  mlggkProjectsEffectivenessExport(
    filters: $filters
    startDate: $startDate
    finishedAt: $finishedAt
    dateOfSupply: $dateOfSupply
  )
}
    `;

/**
 * __useMlggkProjectsEffectivenessExportQuery__
 *
 * To run a query within a React component, call `useMlggkProjectsEffectivenessExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMlggkProjectsEffectivenessExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMlggkProjectsEffectivenessExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      finishedAt: // value for 'finishedAt'
 *      dateOfSupply: // value for 'dateOfSupply'
 *   },
 * });
 */
export function useMlggkProjectsEffectivenessExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>(MlggkProjectsEffectivenessExportDocument, options);
      }
export function useMlggkProjectsEffectivenessExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>(MlggkProjectsEffectivenessExportDocument, options);
        }
export function useMlggkProjectsEffectivenessExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>(MlggkProjectsEffectivenessExportDocument, options);
        }
export type MlggkProjectsEffectivenessExportQueryHookResult = ReturnType<typeof useMlggkProjectsEffectivenessExportQuery>;
export type MlggkProjectsEffectivenessExportLazyQueryHookResult = ReturnType<typeof useMlggkProjectsEffectivenessExportLazyQuery>;
export type MlggkProjectsEffectivenessExportSuspenseQueryHookResult = ReturnType<typeof useMlggkProjectsEffectivenessExportSuspenseQuery>;
export type MlggkProjectsEffectivenessExportQueryResult = ApolloReactCommon.QueryResult<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>;
export const TriadProjectsEffectivenessExportDocument = gql`
    query TriadProjectsEffectivenessExport($filters: ProjectQueryArgs, $from: Date, $to: Date) {
  triadProjectsEffectivenessExport(filters: $filters, from: $from, to: $to)
}
    `;

/**
 * __useTriadProjectsEffectivenessExportQuery__
 *
 * To run a query within a React component, call `useTriadProjectsEffectivenessExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriadProjectsEffectivenessExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriadProjectsEffectivenessExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTriadProjectsEffectivenessExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>(TriadProjectsEffectivenessExportDocument, options);
      }
export function useTriadProjectsEffectivenessExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>(TriadProjectsEffectivenessExportDocument, options);
        }
export function useTriadProjectsEffectivenessExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>(TriadProjectsEffectivenessExportDocument, options);
        }
export type TriadProjectsEffectivenessExportQueryHookResult = ReturnType<typeof useTriadProjectsEffectivenessExportQuery>;
export type TriadProjectsEffectivenessExportLazyQueryHookResult = ReturnType<typeof useTriadProjectsEffectivenessExportLazyQuery>;
export type TriadProjectsEffectivenessExportSuspenseQueryHookResult = ReturnType<typeof useTriadProjectsEffectivenessExportSuspenseQuery>;
export type TriadProjectsEffectivenessExportQueryResult = ApolloReactCommon.QueryResult<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>;
export const StarProjectDocument = gql`
    mutation StarProject($project_id: ID!, $options: ProjectStarOptions) {
  starProject(project_id: $project_id, options: $options) {
    ...Star
  }
}
    ${StarFragmentDoc}`;
export type StarProjectMutationFn = ApolloReactCommon.MutationFunction<StarProjectMutation, StarProjectMutationVariables>;

/**
 * __useStarProjectMutation__
 *
 * To run a mutation, you first call `useStarProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starProjectMutation, { data, loading, error }] = useStarProjectMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useStarProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarProjectMutation, StarProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarProjectMutation, StarProjectMutationVariables>(StarProjectDocument, options);
      }
export type StarProjectMutationHookResult = ReturnType<typeof useStarProjectMutation>;
export type StarProjectMutationResult = ApolloReactCommon.MutationResult<StarProjectMutation>;
export type StarProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<StarProjectMutation, StarProjectMutationVariables>;
export const UnstarProjectDocument = gql`
    mutation UnstarProject($project_id: ID!, $options: ProjectStarOptions) {
  unstarProject(project_id: $project_id, options: $options)
}
    `;
export type UnstarProjectMutationFn = ApolloReactCommon.MutationFunction<UnstarProjectMutation, UnstarProjectMutationVariables>;

/**
 * __useUnstarProjectMutation__
 *
 * To run a mutation, you first call `useUnstarProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarProjectMutation, { data, loading, error }] = useUnstarProjectMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUnstarProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarProjectMutation, UnstarProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarProjectMutation, UnstarProjectMutationVariables>(UnstarProjectDocument, options);
      }
export type UnstarProjectMutationHookResult = ReturnType<typeof useUnstarProjectMutation>;
export type UnstarProjectMutationResult = ApolloReactCommon.MutationResult<UnstarProjectMutation>;
export type UnstarProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarProjectMutation, UnstarProjectMutationVariables>;
export const BulkStarProjectsDocument = gql`
    mutation BulkStarProjects($project_ids: [ID!]!, $options: ProjectStarOptions) {
  bulkStarProjects(project_ids: $project_ids, options: $options) {
    total
    successful
    failed
  }
}
    `;
export type BulkStarProjectsMutationFn = ApolloReactCommon.MutationFunction<BulkStarProjectsMutation, BulkStarProjectsMutationVariables>;

/**
 * __useBulkStarProjectsMutation__
 *
 * To run a mutation, you first call `useBulkStarProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStarProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStarProjectsMutation, { data, loading, error }] = useBulkStarProjectsMutation({
 *   variables: {
 *      project_ids: // value for 'project_ids'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useBulkStarProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkStarProjectsMutation, BulkStarProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkStarProjectsMutation, BulkStarProjectsMutationVariables>(BulkStarProjectsDocument, options);
      }
export type BulkStarProjectsMutationHookResult = ReturnType<typeof useBulkStarProjectsMutation>;
export type BulkStarProjectsMutationResult = ApolloReactCommon.MutationResult<BulkStarProjectsMutation>;
export type BulkStarProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkStarProjectsMutation, BulkStarProjectsMutationVariables>;
export const BulkUnstarProjectsDocument = gql`
    mutation BulkUnstarProjects($project_ids: [ID!]!, $options: ProjectStarOptions) {
  bulkUnstarProjects(project_ids: $project_ids, options: $options) {
    total
    successful
    failed
  }
}
    `;
export type BulkUnstarProjectsMutationFn = ApolloReactCommon.MutationFunction<BulkUnstarProjectsMutation, BulkUnstarProjectsMutationVariables>;

/**
 * __useBulkUnstarProjectsMutation__
 *
 * To run a mutation, you first call `useBulkUnstarProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnstarProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnstarProjectsMutation, { data, loading, error }] = useBulkUnstarProjectsMutation({
 *   variables: {
 *      project_ids: // value for 'project_ids'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useBulkUnstarProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUnstarProjectsMutation, BulkUnstarProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUnstarProjectsMutation, BulkUnstarProjectsMutationVariables>(BulkUnstarProjectsDocument, options);
      }
export type BulkUnstarProjectsMutationHookResult = ReturnType<typeof useBulkUnstarProjectsMutation>;
export type BulkUnstarProjectsMutationResult = ApolloReactCommon.MutationResult<BulkUnstarProjectsMutation>;
export type BulkUnstarProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUnstarProjectsMutation, BulkUnstarProjectsMutationVariables>;
export const FinishedProjectListTableDataSimpleDocument = gql`
    query FinishedProjectListTableDataSimple($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      is_pinned
      is_starred
      billable
      is_template
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useFinishedProjectListTableDataSimpleQuery__
 *
 * To run a query within a React component, call `useFinishedProjectListTableDataSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishedProjectListTableDataSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishedProjectListTableDataSimpleQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFinishedProjectListTableDataSimpleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables> & ({ variables: FinishedProjectListTableDataSimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>(FinishedProjectListTableDataSimpleDocument, options);
      }
export function useFinishedProjectListTableDataSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>(FinishedProjectListTableDataSimpleDocument, options);
        }
export function useFinishedProjectListTableDataSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>(FinishedProjectListTableDataSimpleDocument, options);
        }
export type FinishedProjectListTableDataSimpleQueryHookResult = ReturnType<typeof useFinishedProjectListTableDataSimpleQuery>;
export type FinishedProjectListTableDataSimpleLazyQueryHookResult = ReturnType<typeof useFinishedProjectListTableDataSimpleLazyQuery>;
export type FinishedProjectListTableDataSimpleSuspenseQueryHookResult = ReturnType<typeof useFinishedProjectListTableDataSimpleSuspenseQuery>;
export type FinishedProjectListTableDataSimpleQueryResult = ApolloReactCommon.QueryResult<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>;
export const FinishedProjectListTableDataDocument = gql`
    query FinishedProjectListTableData($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      note
      billable
      is_pinned
      is_starred
      type
      finished_at
      archived_at
      cloudUrl
      driveCloudUrl
      is_template
      scopes {
        value
      }
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      otherProjectManagers {
        id
      }
      categories {
        id
        name
      }
      ourWork {
        id
        title
        category {
          name
        }
        stats {
          invoiced_percent
          efficiency_percent
          remaining_budget
          net_margin_percent
          net_profit
        }
      }
      expenses {
        id
        title
        category {
          name
        }
        stats {
          profit
          profit_percent
          invoiced_percent
        }
      }
      statsCached {
        id
        profit
        credit
        unused_sum_from_proformas
        net_profit
        net_margin_percent
        invoiced_percent
        ourWork {
          id
          efficiency_percent
          remaining_budget
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useFinishedProjectListTableDataQuery__
 *
 * To run a query within a React component, call `useFinishedProjectListTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishedProjectListTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishedProjectListTableDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFinishedProjectListTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables> & ({ variables: FinishedProjectListTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>(FinishedProjectListTableDataDocument, options);
      }
export function useFinishedProjectListTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>(FinishedProjectListTableDataDocument, options);
        }
export function useFinishedProjectListTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>(FinishedProjectListTableDataDocument, options);
        }
export type FinishedProjectListTableDataQueryHookResult = ReturnType<typeof useFinishedProjectListTableDataQuery>;
export type FinishedProjectListTableDataLazyQueryHookResult = ReturnType<typeof useFinishedProjectListTableDataLazyQuery>;
export type FinishedProjectListTableDataSuspenseQueryHookResult = ReturnType<typeof useFinishedProjectListTableDataSuspenseQuery>;
export type FinishedProjectListTableDataQueryResult = ApolloReactCommon.QueryResult<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>;
export const ProjectListFilterOptionsDocument = gql`
    query ProjectListFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    name
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectListFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProjectListFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectListFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>(ProjectListFilterOptionsDocument, options);
      }
export function useProjectListFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>(ProjectListFilterOptionsDocument, options);
        }
export function useProjectListFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>(ProjectListFilterOptionsDocument, options);
        }
export type ProjectListFilterOptionsQueryHookResult = ReturnType<typeof useProjectListFilterOptionsQuery>;
export type ProjectListFilterOptionsLazyQueryHookResult = ReturnType<typeof useProjectListFilterOptionsLazyQuery>;
export type ProjectListFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectListFilterOptionsSuspenseQuery>;
export type ProjectListFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>;
export const ProjectListTableDataSimpleDocument = gql`
    query ProjectListTableDataSimple($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      numeric_code
      is_pinned
      is_starred
      billable
      is_template
      project_stage {
        ...ProjectStage
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      ourWork {
        id
      }
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectStageFragmentDoc}
${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectListTableDataSimpleQuery__
 *
 * To run a query within a React component, call `useProjectListTableDataSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListTableDataSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListTableDataSimpleQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectListTableDataSimpleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables> & ({ variables: ProjectListTableDataSimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>(ProjectListTableDataSimpleDocument, options);
      }
export function useProjectListTableDataSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>(ProjectListTableDataSimpleDocument, options);
        }
export function useProjectListTableDataSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>(ProjectListTableDataSimpleDocument, options);
        }
export type ProjectListTableDataSimpleQueryHookResult = ReturnType<typeof useProjectListTableDataSimpleQuery>;
export type ProjectListTableDataSimpleLazyQueryHookResult = ReturnType<typeof useProjectListTableDataSimpleLazyQuery>;
export type ProjectListTableDataSimpleSuspenseQueryHookResult = ReturnType<typeof useProjectListTableDataSimpleSuspenseQuery>;
export type ProjectListTableDataSimpleQueryResult = ApolloReactCommon.QueryResult<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>;
export const ProjectSubrowsDocument = gql`
    query ProjectSubrows($id: ID!) {
  project(id: $id) {
    id
    ourWork {
      id
      title
      category {
        name
      }
      lastWorkInProgressItemStat {
        work_in_progress_id
        progress_percent
        progress
        spent_time_estimate
      }
      stats {
        id
        total_budget
        spent_budget_percent
        spent_budget
        spent_time
        budget_exceeded
        credit_balance
        invoiced_percent
      }
    }
  }
}
    `;

/**
 * __useProjectSubrowsQuery__
 *
 * To run a query within a React component, call `useProjectSubrowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSubrowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSubrowsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectSubrowsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectSubrowsQuery, ProjectSubrowsQueryVariables> & ({ variables: ProjectSubrowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>(ProjectSubrowsDocument, options);
      }
export function useProjectSubrowsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>(ProjectSubrowsDocument, options);
        }
export function useProjectSubrowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>(ProjectSubrowsDocument, options);
        }
export type ProjectSubrowsQueryHookResult = ReturnType<typeof useProjectSubrowsQuery>;
export type ProjectSubrowsLazyQueryHookResult = ReturnType<typeof useProjectSubrowsLazyQuery>;
export type ProjectSubrowsSuspenseQueryHookResult = ReturnType<typeof useProjectSubrowsSuspenseQuery>;
export type ProjectSubrowsQueryResult = ApolloReactCommon.QueryResult<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>;
export const ProjectsSubrowsForPageDocument = gql`
    query ProjectsSubrowsForPage($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      ourWork {
        id
        title
        category {
          name
        }
        lastWorkInProgressItemStat {
          work_in_progress_id
          progress_percent
          progress
          spent_time_estimate
        }
        stats {
          id
          total_budget
          spent_budget_percent
          spent_budget
          spent_time
          budget_exceeded
          credit_balance
          invoiced_percent
        }
      }
    }
  }
}
    `;

/**
 * __useProjectsSubrowsForPageQuery__
 *
 * To run a query within a React component, call `useProjectsSubrowsForPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsSubrowsForPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsSubrowsForPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectsSubrowsForPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables> & ({ variables: ProjectsSubrowsForPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>(ProjectsSubrowsForPageDocument, options);
      }
export function useProjectsSubrowsForPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>(ProjectsSubrowsForPageDocument, options);
        }
export function useProjectsSubrowsForPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>(ProjectsSubrowsForPageDocument, options);
        }
export type ProjectsSubrowsForPageQueryHookResult = ReturnType<typeof useProjectsSubrowsForPageQuery>;
export type ProjectsSubrowsForPageLazyQueryHookResult = ReturnType<typeof useProjectsSubrowsForPageLazyQuery>;
export type ProjectsSubrowsForPageSuspenseQueryHookResult = ReturnType<typeof useProjectsSubrowsForPageSuspenseQuery>;
export type ProjectsSubrowsForPageQueryResult = ApolloReactCommon.QueryResult<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>;
export const ProjectListTableDataDocument = gql`
    query ProjectListTableData($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      numeric_code
      note
      billable
      is_pinned
      is_starred
      type
      finished_at
      archived_at
      billingPlanIsMissing
      cloudUrl
      driveCloudUrl
      is_template
      scopes {
        value
      }
      project_stage {
        ...ProjectStage
      }
      lastWorkInProgressProjectStat {
        progress_percent
        progress
        spent_time_estimate
      }
      budgetovacBudget {
        budget_id
        internally_approved
        newer_final_version_available
      }
      budgetovacBudgets {
        id
        internally_approved
        is_active
      }
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      otherProjectManagers {
        id
      }
      categories {
        id
        name
      }
      ourWork {
        id
      }
      ourWorkOverview {
        id
        name
        budget_exceeded
      }
      expensesStructured {
        id
        name
        budget_exceeded
      }
      statsCached {
        id
        budget_exceeded
        credit_balance
        invoiced_percent
        total_budget
        ourWork {
          id
          total_budget
          spent_budget
          spent_time
          spent_budget_percent
        }
        expenses {
          id
          all_items_completed
          planned_expenses
          planned_commission
          planned_commission_relative_computed
          real_expenses
          real_commission
          real_commission_relative
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectStageFragmentDoc}
${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectListTableDataQuery__
 *
 * To run a query within a React component, call `useProjectListTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListTableDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectListTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectListTableDataQuery, ProjectListTableDataQueryVariables> & ({ variables: ProjectListTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>(ProjectListTableDataDocument, options);
      }
export function useProjectListTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>(ProjectListTableDataDocument, options);
        }
export function useProjectListTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>(ProjectListTableDataDocument, options);
        }
export type ProjectListTableDataQueryHookResult = ReturnType<typeof useProjectListTableDataQuery>;
export type ProjectListTableDataLazyQueryHookResult = ReturnType<typeof useProjectListTableDataLazyQuery>;
export type ProjectListTableDataSuspenseQueryHookResult = ReturnType<typeof useProjectListTableDataSuspenseQuery>;
export type ProjectListTableDataQueryResult = ApolloReactCommon.QueryResult<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>;
export const ProjectListTableSummaryDocument = gql`
    query ProjectListTableSummary($filters: ProjectQueryArgs) {
  projectsSummary(filters: $filters) {
    total_budget
    our_work_total_budget
    our_work_spent_budget
    our_work_credit_balance
    our_work_credit_proforma_balance
    expenses_credit_balance
    expenses_credit_proforma_balance
    uninvoiced
    proforma_uninvoiced
    projectIds
    real_expenses
  }
}
    `;

/**
 * __useProjectListTableSummaryQuery__
 *
 * To run a query within a React component, call `useProjectListTableSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListTableSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListTableSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectListTableSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>(ProjectListTableSummaryDocument, options);
      }
export function useProjectListTableSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>(ProjectListTableSummaryDocument, options);
        }
export function useProjectListTableSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>(ProjectListTableSummaryDocument, options);
        }
export type ProjectListTableSummaryQueryHookResult = ReturnType<typeof useProjectListTableSummaryQuery>;
export type ProjectListTableSummaryLazyQueryHookResult = ReturnType<typeof useProjectListTableSummaryLazyQuery>;
export type ProjectListTableSummarySuspenseQueryHookResult = ReturnType<typeof useProjectListTableSummarySuspenseQuery>;
export type ProjectListTableSummaryQueryResult = ApolloReactCommon.QueryResult<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>;
export const FinishedProjectListTableSummaryDocument = gql`
    query FinishedProjectListTableSummary($filters: ProjectQueryArgs) {
  projectsSummary(filters: $filters) {
    projectIds
    profit
    net_profit
    gross_income
    net_margin_percent
    our_work_efficiency
    credit
  }
}
    `;

/**
 * __useFinishedProjectListTableSummaryQuery__
 *
 * To run a query within a React component, call `useFinishedProjectListTableSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishedProjectListTableSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishedProjectListTableSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFinishedProjectListTableSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>(FinishedProjectListTableSummaryDocument, options);
      }
export function useFinishedProjectListTableSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>(FinishedProjectListTableSummaryDocument, options);
        }
export function useFinishedProjectListTableSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>(FinishedProjectListTableSummaryDocument, options);
        }
export type FinishedProjectListTableSummaryQueryHookResult = ReturnType<typeof useFinishedProjectListTableSummaryQuery>;
export type FinishedProjectListTableSummaryLazyQueryHookResult = ReturnType<typeof useFinishedProjectListTableSummaryLazyQuery>;
export type FinishedProjectListTableSummarySuspenseQueryHookResult = ReturnType<typeof useFinishedProjectListTableSummarySuspenseQuery>;
export type FinishedProjectListTableSummaryQueryResult = ApolloReactCommon.QueryResult<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>;
export const PlannedExpensesOverviewDocument = gql`
    query PlannedExpensesOverview($page: Int, $first: Int, $filters: PlannedExpensesQueryArgs) {
  plannedExpensesOverview(page: $page, first: $first, filters: $filters) {
    data {
      ...PlannedExpensesProject
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PlannedExpensesProjectFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __usePlannedExpensesOverviewQuery__
 *
 * To run a query within a React component, call `usePlannedExpensesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannedExpensesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannedExpensesOverviewQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePlannedExpensesOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>(PlannedExpensesOverviewDocument, options);
      }
export function usePlannedExpensesOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>(PlannedExpensesOverviewDocument, options);
        }
export function usePlannedExpensesOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>(PlannedExpensesOverviewDocument, options);
        }
export type PlannedExpensesOverviewQueryHookResult = ReturnType<typeof usePlannedExpensesOverviewQuery>;
export type PlannedExpensesOverviewLazyQueryHookResult = ReturnType<typeof usePlannedExpensesOverviewLazyQuery>;
export type PlannedExpensesOverviewSuspenseQueryHookResult = ReturnType<typeof usePlannedExpensesOverviewSuspenseQuery>;
export type PlannedExpensesOverviewQueryResult = ApolloReactCommon.QueryResult<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>;
export const PlannedExpensesOverviewSummaryDocument = gql`
    query PlannedExpensesOverviewSummary($filters: PlannedExpensesQueryArgs) {
  plannedExpensesOverviewSummary(filters: $filters) {
    ...PlannedExpensesSummary
  }
}
    ${PlannedExpensesSummaryFragmentDoc}`;

/**
 * __usePlannedExpensesOverviewSummaryQuery__
 *
 * To run a query within a React component, call `usePlannedExpensesOverviewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannedExpensesOverviewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannedExpensesOverviewSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePlannedExpensesOverviewSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>(PlannedExpensesOverviewSummaryDocument, options);
      }
export function usePlannedExpensesOverviewSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>(PlannedExpensesOverviewSummaryDocument, options);
        }
export function usePlannedExpensesOverviewSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>(PlannedExpensesOverviewSummaryDocument, options);
        }
export type PlannedExpensesOverviewSummaryQueryHookResult = ReturnType<typeof usePlannedExpensesOverviewSummaryQuery>;
export type PlannedExpensesOverviewSummaryLazyQueryHookResult = ReturnType<typeof usePlannedExpensesOverviewSummaryLazyQuery>;
export type PlannedExpensesOverviewSummarySuspenseQueryHookResult = ReturnType<typeof usePlannedExpensesOverviewSummarySuspenseQuery>;
export type PlannedExpensesOverviewSummaryQueryResult = ApolloReactCommon.QueryResult<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>;
export const PlannedExpensesFilterOptionsDocument = gql`
    query PlannedExpensesFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectCategories {
    id
    name
  }
  projectStages {
    id
    name
  }
  projectsSimpleMap {
    id
    code
    title
  }
}
    `;

/**
 * __usePlannedExpensesFilterOptionsQuery__
 *
 * To run a query within a React component, call `usePlannedExpensesFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannedExpensesFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannedExpensesFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlannedExpensesFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>(PlannedExpensesFilterOptionsDocument, options);
      }
export function usePlannedExpensesFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>(PlannedExpensesFilterOptionsDocument, options);
        }
export function usePlannedExpensesFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>(PlannedExpensesFilterOptionsDocument, options);
        }
export type PlannedExpensesFilterOptionsQueryHookResult = ReturnType<typeof usePlannedExpensesFilterOptionsQuery>;
export type PlannedExpensesFilterOptionsLazyQueryHookResult = ReturnType<typeof usePlannedExpensesFilterOptionsLazyQuery>;
export type PlannedExpensesFilterOptionsSuspenseQueryHookResult = ReturnType<typeof usePlannedExpensesFilterOptionsSuspenseQuery>;
export type PlannedExpensesFilterOptionsQueryResult = ApolloReactCommon.QueryResult<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>;
export const GetProjectSettingsDocument = gql`
    query GetProjectSettings($id: ID!) {
  project(id: $id) {
    id
    uses_budgetovac
    finished_at
    average_time_tracking_rate
    calculated_average_time_tracking_rate
    rate_card_id
    rate_card_exchange_rate
    type
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
    ourWork {
      id
      title
      category {
        name
      }
      timeTrackingSettings {
        id
        tracking_enabled_from
        tracking_enabled_to
        tracking_enabled
      }
    }
    budgetovacBudget {
      budget_id
    }
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

/**
 * __useGetProjectSettingsQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables> & ({ variables: GetProjectSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
      }
export function useGetProjectSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
export function useGetProjectSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
export type GetProjectSettingsQueryHookResult = ReturnType<typeof useGetProjectSettingsQuery>;
export type GetProjectSettingsLazyQueryHookResult = ReturnType<typeof useGetProjectSettingsLazyQuery>;
export type GetProjectSettingsSuspenseQueryHookResult = ReturnType<typeof useGetProjectSettingsSuspenseQuery>;
export type GetProjectSettingsQueryResult = ApolloReactCommon.QueryResult<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export const UpdateTimeTrackingSettingsForProjectDocument = gql`
    mutation UpdateTimeTrackingSettingsForProject($input: UpdateTimeTrackingSettingsInput!) {
  updateTimeTrackingSettingsForProject(input: $input) {
    ourWork {
      id
      title
      timeTrackingSettings {
        id
        tracking_enabled_from
        tracking_enabled_to
        tracking_enabled
      }
    }
  }
}
    `;
export type UpdateTimeTrackingSettingsForProjectMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeTrackingSettingsForProjectMutation, UpdateTimeTrackingSettingsForProjectMutationVariables>;

/**
 * __useUpdateTimeTrackingSettingsForProjectMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingSettingsForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingSettingsForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingSettingsForProjectMutation, { data, loading, error }] = useUpdateTimeTrackingSettingsForProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeTrackingSettingsForProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeTrackingSettingsForProjectMutation, UpdateTimeTrackingSettingsForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeTrackingSettingsForProjectMutation, UpdateTimeTrackingSettingsForProjectMutationVariables>(UpdateTimeTrackingSettingsForProjectDocument, options);
      }
export type UpdateTimeTrackingSettingsForProjectMutationHookResult = ReturnType<typeof useUpdateTimeTrackingSettingsForProjectMutation>;
export type UpdateTimeTrackingSettingsForProjectMutationResult = ApolloReactCommon.MutationResult<UpdateTimeTrackingSettingsForProjectMutation>;
export type UpdateTimeTrackingSettingsForProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeTrackingSettingsForProjectMutation, UpdateTimeTrackingSettingsForProjectMutationVariables>;
export const UpdateTimeTrackingRatesForProjectDocument = gql`
    mutation UpdateTimeTrackingRatesForProject($input: UpdateTimeTrackingRatesForProjectInput!) {
  updateTimeTrackingRatesForProject(input: $input) {
    average_time_tracking_rate
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
  }
}
    `;
export type UpdateTimeTrackingRatesForProjectMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeTrackingRatesForProjectMutation, UpdateTimeTrackingRatesForProjectMutationVariables>;

/**
 * __useUpdateTimeTrackingRatesForProjectMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingRatesForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingRatesForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingRatesForProjectMutation, { data, loading, error }] = useUpdateTimeTrackingRatesForProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeTrackingRatesForProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeTrackingRatesForProjectMutation, UpdateTimeTrackingRatesForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeTrackingRatesForProjectMutation, UpdateTimeTrackingRatesForProjectMutationVariables>(UpdateTimeTrackingRatesForProjectDocument, options);
      }
export type UpdateTimeTrackingRatesForProjectMutationHookResult = ReturnType<typeof useUpdateTimeTrackingRatesForProjectMutation>;
export type UpdateTimeTrackingRatesForProjectMutationResult = ApolloReactCommon.MutationResult<UpdateTimeTrackingRatesForProjectMutation>;
export type UpdateTimeTrackingRatesForProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeTrackingRatesForProjectMutation, UpdateTimeTrackingRatesForProjectMutationVariables>;
export const ChangeRateCardOnProjectDocument = gql`
    mutation ChangeRateCardOnProject($projectId: ID!, $rateCardId: ID!, $exchangeRate: BigInt) {
  changeRateCardOnProject(
    project_id: $projectId
    rate_card_id: $rateCardId
    exchange_rate: $exchangeRate
  ) {
    rate_card_id
  }
}
    `;
export type ChangeRateCardOnProjectMutationFn = ApolloReactCommon.MutationFunction<ChangeRateCardOnProjectMutation, ChangeRateCardOnProjectMutationVariables>;

/**
 * __useChangeRateCardOnProjectMutation__
 *
 * To run a mutation, you first call `useChangeRateCardOnProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRateCardOnProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRateCardOnProjectMutation, { data, loading, error }] = useChangeRateCardOnProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      rateCardId: // value for 'rateCardId'
 *      exchangeRate: // value for 'exchangeRate'
 *   },
 * });
 */
export function useChangeRateCardOnProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeRateCardOnProjectMutation, ChangeRateCardOnProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeRateCardOnProjectMutation, ChangeRateCardOnProjectMutationVariables>(ChangeRateCardOnProjectDocument, options);
      }
export type ChangeRateCardOnProjectMutationHookResult = ReturnType<typeof useChangeRateCardOnProjectMutation>;
export type ChangeRateCardOnProjectMutationResult = ApolloReactCommon.MutationResult<ChangeRateCardOnProjectMutation>;
export type ChangeRateCardOnProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeRateCardOnProjectMutation, ChangeRateCardOnProjectMutationVariables>;
export const DistributionModalTableDataDocument = gql`
    query DistributionModalTableData($first: BigInt!, $page: BigInt, $from: Date!, $to: Date!, $where: TimeTrackingReportsWhereConditions, $orderBy: [TimeTrackingItemOrderByClause!]) {
  getTimeTrackingItems(
    first: $first
    page: $page
    from: $from
    to: $to
    where: $where
    orderBy: $orderBy
  ) {
    data {
      ...DistributionModalTableItem
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${DistributionModalTableItemFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useDistributionModalTableDataQuery__
 *
 * To run a query within a React component, call `useDistributionModalTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionModalTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionModalTableDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDistributionModalTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables> & ({ variables: DistributionModalTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>(DistributionModalTableDataDocument, options);
      }
export function useDistributionModalTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>(DistributionModalTableDataDocument, options);
        }
export function useDistributionModalTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>(DistributionModalTableDataDocument, options);
        }
export type DistributionModalTableDataQueryHookResult = ReturnType<typeof useDistributionModalTableDataQuery>;
export type DistributionModalTableDataLazyQueryHookResult = ReturnType<typeof useDistributionModalTableDataLazyQuery>;
export type DistributionModalTableDataSuspenseQueryHookResult = ReturnType<typeof useDistributionModalTableDataSuspenseQuery>;
export type DistributionModalTableDataQueryResult = ApolloReactCommon.QueryResult<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>;
export const DistributionModalFilterOptionsDocument = gql`
    query DistributionModalFilterOptions($projectId: ID!, $userSimpleWhere: UsersWhereConditions) {
  ourWorkBudgetItemsSimpleMap(project_id: [$projectId]) {
    id
    title
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
  userSimpleMap(where: $userSimpleWhere) {
    id
    name
    full_name
    image {
      urls {
        thumbnail
      }
    }
    codename
  }
}
    `;

/**
 * __useDistributionModalFilterOptionsQuery__
 *
 * To run a query within a React component, call `useDistributionModalFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionModalFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionModalFilterOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userSimpleWhere: // value for 'userSimpleWhere'
 *   },
 * });
 */
export function useDistributionModalFilterOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables> & ({ variables: DistributionModalFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>(DistributionModalFilterOptionsDocument, options);
      }
export function useDistributionModalFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>(DistributionModalFilterOptionsDocument, options);
        }
export function useDistributionModalFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>(DistributionModalFilterOptionsDocument, options);
        }
export type DistributionModalFilterOptionsQueryHookResult = ReturnType<typeof useDistributionModalFilterOptionsQuery>;
export type DistributionModalFilterOptionsLazyQueryHookResult = ReturnType<typeof useDistributionModalFilterOptionsLazyQuery>;
export type DistributionModalFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useDistributionModalFilterOptionsSuspenseQuery>;
export type DistributionModalFilterOptionsQueryResult = ApolloReactCommon.QueryResult<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>;
export const TimeBillingExpenseItemsForModalDocument = gql`
    query TimeBillingExpenseItemsForModal($filters: ExpenseItemsTimeBillingQueryArgs, $first: Int, $page: Int) {
  expenseItemsForTimeBilling(filters: $filters, first: $first, page: $page) {
    data {
      id
      amount
      description {
        title
      }
      expense {
        id
        expense_no
        document_number
        date_of_supply
        contractor {
          legal_name
        }
      }
      budget_item_type
      budgetItem {
        id
        title
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useTimeBillingExpenseItemsForModalQuery__
 *
 * To run a query within a React component, call `useTimeBillingExpenseItemsForModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeBillingExpenseItemsForModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeBillingExpenseItemsForModalQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTimeBillingExpenseItemsForModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>(TimeBillingExpenseItemsForModalDocument, options);
      }
export function useTimeBillingExpenseItemsForModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>(TimeBillingExpenseItemsForModalDocument, options);
        }
export function useTimeBillingExpenseItemsForModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>(TimeBillingExpenseItemsForModalDocument, options);
        }
export type TimeBillingExpenseItemsForModalQueryHookResult = ReturnType<typeof useTimeBillingExpenseItemsForModalQuery>;
export type TimeBillingExpenseItemsForModalLazyQueryHookResult = ReturnType<typeof useTimeBillingExpenseItemsForModalLazyQuery>;
export type TimeBillingExpenseItemsForModalSuspenseQueryHookResult = ReturnType<typeof useTimeBillingExpenseItemsForModalSuspenseQuery>;
export type TimeBillingExpenseItemsForModalQueryResult = ApolloReactCommon.QueryResult<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>;
export const TimeBillingOiBudgetItemsForModalDocument = gql`
    query TimeBillingOiBudgetItemsForModal($filters: OIBudgetItemsTimeBillingQueryArgs) {
  oiBudgetItemsForTimeBilling(filters: $filters) {
    data {
      outgoing_invoice_id
      budget_item_id
      budget_item_type
      amount
      outgoingInvoice {
        id
        invoice_no
        issue_date
        billingEntity {
          internal_name
          street
          city
        }
      }
      budgetItem {
        id
        title
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useTimeBillingOiBudgetItemsForModalQuery__
 *
 * To run a query within a React component, call `useTimeBillingOiBudgetItemsForModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeBillingOiBudgetItemsForModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeBillingOiBudgetItemsForModalQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTimeBillingOiBudgetItemsForModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>(TimeBillingOiBudgetItemsForModalDocument, options);
      }
export function useTimeBillingOiBudgetItemsForModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>(TimeBillingOiBudgetItemsForModalDocument, options);
        }
export function useTimeBillingOiBudgetItemsForModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>(TimeBillingOiBudgetItemsForModalDocument, options);
        }
export type TimeBillingOiBudgetItemsForModalQueryHookResult = ReturnType<typeof useTimeBillingOiBudgetItemsForModalQuery>;
export type TimeBillingOiBudgetItemsForModalLazyQueryHookResult = ReturnType<typeof useTimeBillingOiBudgetItemsForModalLazyQuery>;
export type TimeBillingOiBudgetItemsForModalSuspenseQueryHookResult = ReturnType<typeof useTimeBillingOiBudgetItemsForModalSuspenseQuery>;
export type TimeBillingOiBudgetItemsForModalQueryResult = ApolloReactCommon.QueryResult<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>;
export const TimeBillingSourcesEditModalFilterOptionsDocument = gql`
    query TimeBillingSourcesEditModalFilterOptions($projectId: ID!) {
  ourWorkBudgetItemsSimpleMap(project_id: [$projectId]) {
    id
    title
    category {
      name
    }
  }
  expenseBudgetItemsSimpleMap(project_id: $projectId) {
    id
    title
    category {
      name
    }
  }
}
    `;

/**
 * __useTimeBillingSourcesEditModalFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTimeBillingSourcesEditModalFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeBillingSourcesEditModalFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeBillingSourcesEditModalFilterOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTimeBillingSourcesEditModalFilterOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables> & ({ variables: TimeBillingSourcesEditModalFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>(TimeBillingSourcesEditModalFilterOptionsDocument, options);
      }
export function useTimeBillingSourcesEditModalFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>(TimeBillingSourcesEditModalFilterOptionsDocument, options);
        }
export function useTimeBillingSourcesEditModalFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>(TimeBillingSourcesEditModalFilterOptionsDocument, options);
        }
export type TimeBillingSourcesEditModalFilterOptionsQueryHookResult = ReturnType<typeof useTimeBillingSourcesEditModalFilterOptionsQuery>;
export type TimeBillingSourcesEditModalFilterOptionsLazyQueryHookResult = ReturnType<typeof useTimeBillingSourcesEditModalFilterOptionsLazyQuery>;
export type TimeBillingSourcesEditModalFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useTimeBillingSourcesEditModalFilterOptionsSuspenseQuery>;
export type TimeBillingSourcesEditModalFilterOptionsQueryResult = ApolloReactCommon.QueryResult<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>;
export const CreateProjectTimeBillingDocument = gql`
    mutation CreateProjectTimeBilling($input: CreateProjectTimeBillingInput!) {
  createProjectTimeBilling(input: $input) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;
export type CreateProjectTimeBillingMutationFn = ApolloReactCommon.MutationFunction<CreateProjectTimeBillingMutation, CreateProjectTimeBillingMutationVariables>;

/**
 * __useCreateProjectTimeBillingMutation__
 *
 * To run a mutation, you first call `useCreateProjectTimeBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectTimeBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectTimeBillingMutation, { data, loading, error }] = useCreateProjectTimeBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectTimeBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectTimeBillingMutation, CreateProjectTimeBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectTimeBillingMutation, CreateProjectTimeBillingMutationVariables>(CreateProjectTimeBillingDocument, options);
      }
export type CreateProjectTimeBillingMutationHookResult = ReturnType<typeof useCreateProjectTimeBillingMutation>;
export type CreateProjectTimeBillingMutationResult = ApolloReactCommon.MutationResult<CreateProjectTimeBillingMutation>;
export type CreateProjectTimeBillingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectTimeBillingMutation, CreateProjectTimeBillingMutationVariables>;
export const UpdateProjectTimeBillingDocument = gql`
    mutation UpdateProjectTimeBilling($input: UpdateProjectTimeBillingInput!) {
  updateProjectTimeBilling(input: $input) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;
export type UpdateProjectTimeBillingMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectTimeBillingMutation, UpdateProjectTimeBillingMutationVariables>;

/**
 * __useUpdateProjectTimeBillingMutation__
 *
 * To run a mutation, you first call `useUpdateProjectTimeBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectTimeBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectTimeBillingMutation, { data, loading, error }] = useUpdateProjectTimeBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectTimeBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectTimeBillingMutation, UpdateProjectTimeBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectTimeBillingMutation, UpdateProjectTimeBillingMutationVariables>(UpdateProjectTimeBillingDocument, options);
      }
export type UpdateProjectTimeBillingMutationHookResult = ReturnType<typeof useUpdateProjectTimeBillingMutation>;
export type UpdateProjectTimeBillingMutationResult = ApolloReactCommon.MutationResult<UpdateProjectTimeBillingMutation>;
export type UpdateProjectTimeBillingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectTimeBillingMutation, UpdateProjectTimeBillingMutationVariables>;
export const LockProjectTimeBillingDocument = gql`
    mutation LockProjectTimeBilling($id: ID!) {
  lockProjectTimeBilling(id: $id) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;
export type LockProjectTimeBillingMutationFn = ApolloReactCommon.MutationFunction<LockProjectTimeBillingMutation, LockProjectTimeBillingMutationVariables>;

/**
 * __useLockProjectTimeBillingMutation__
 *
 * To run a mutation, you first call `useLockProjectTimeBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockProjectTimeBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockProjectTimeBillingMutation, { data, loading, error }] = useLockProjectTimeBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLockProjectTimeBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LockProjectTimeBillingMutation, LockProjectTimeBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LockProjectTimeBillingMutation, LockProjectTimeBillingMutationVariables>(LockProjectTimeBillingDocument, options);
      }
export type LockProjectTimeBillingMutationHookResult = ReturnType<typeof useLockProjectTimeBillingMutation>;
export type LockProjectTimeBillingMutationResult = ApolloReactCommon.MutationResult<LockProjectTimeBillingMutation>;
export type LockProjectTimeBillingMutationOptions = ApolloReactCommon.BaseMutationOptions<LockProjectTimeBillingMutation, LockProjectTimeBillingMutationVariables>;
export const UnlockProjectTimeBillingDocument = gql`
    mutation UnlockProjectTimeBilling($id: ID!) {
  unlockProjectTimeBilling(id: $id) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;
export type UnlockProjectTimeBillingMutationFn = ApolloReactCommon.MutationFunction<UnlockProjectTimeBillingMutation, UnlockProjectTimeBillingMutationVariables>;

/**
 * __useUnlockProjectTimeBillingMutation__
 *
 * To run a mutation, you first call `useUnlockProjectTimeBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockProjectTimeBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockProjectTimeBillingMutation, { data, loading, error }] = useUnlockProjectTimeBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlockProjectTimeBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlockProjectTimeBillingMutation, UnlockProjectTimeBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlockProjectTimeBillingMutation, UnlockProjectTimeBillingMutationVariables>(UnlockProjectTimeBillingDocument, options);
      }
export type UnlockProjectTimeBillingMutationHookResult = ReturnType<typeof useUnlockProjectTimeBillingMutation>;
export type UnlockProjectTimeBillingMutationResult = ApolloReactCommon.MutationResult<UnlockProjectTimeBillingMutation>;
export type UnlockProjectTimeBillingMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlockProjectTimeBillingMutation, UnlockProjectTimeBillingMutationVariables>;
export const DeleteProjectTimeBillingDocument = gql`
    mutation DeleteProjectTimeBilling($id: ID!) {
  deleteProjectTimeBilling(id: $id)
}
    `;
export type DeleteProjectTimeBillingMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectTimeBillingMutation, DeleteProjectTimeBillingMutationVariables>;

/**
 * __useDeleteProjectTimeBillingMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTimeBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTimeBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectTimeBillingMutation, { data, loading, error }] = useDeleteProjectTimeBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectTimeBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectTimeBillingMutation, DeleteProjectTimeBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectTimeBillingMutation, DeleteProjectTimeBillingMutationVariables>(DeleteProjectTimeBillingDocument, options);
      }
export type DeleteProjectTimeBillingMutationHookResult = ReturnType<typeof useDeleteProjectTimeBillingMutation>;
export type DeleteProjectTimeBillingMutationResult = ApolloReactCommon.MutationResult<DeleteProjectTimeBillingMutation>;
export type DeleteProjectTimeBillingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectTimeBillingMutation, DeleteProjectTimeBillingMutationVariables>;
export const CreateDataForProjectTimeBillingDocument = gql`
    query CreateDataForProjectTimeBilling($projectId: ID!, $dateFrom: Date!, $dateTo: Date!) {
  createDataForProjectTimeBilling(
    project_id: $projectId
    date_from: $dateFrom
    date_to: $dateTo
  ) {
    ...ProjectTimeBillingComputed
  }
}
    ${ProjectTimeBillingComputedFragmentDoc}`;

/**
 * __useCreateDataForProjectTimeBillingQuery__
 *
 * To run a query within a React component, call `useCreateDataForProjectTimeBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateDataForProjectTimeBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateDataForProjectTimeBillingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useCreateDataForProjectTimeBillingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables> & ({ variables: CreateDataForProjectTimeBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>(CreateDataForProjectTimeBillingDocument, options);
      }
export function useCreateDataForProjectTimeBillingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>(CreateDataForProjectTimeBillingDocument, options);
        }
export function useCreateDataForProjectTimeBillingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>(CreateDataForProjectTimeBillingDocument, options);
        }
export type CreateDataForProjectTimeBillingQueryHookResult = ReturnType<typeof useCreateDataForProjectTimeBillingQuery>;
export type CreateDataForProjectTimeBillingLazyQueryHookResult = ReturnType<typeof useCreateDataForProjectTimeBillingLazyQuery>;
export type CreateDataForProjectTimeBillingSuspenseQueryHookResult = ReturnType<typeof useCreateDataForProjectTimeBillingSuspenseQuery>;
export type CreateDataForProjectTimeBillingQueryResult = ApolloReactCommon.QueryResult<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>;
export const ProjectTimeBillingsDocument = gql`
    query ProjectTimeBillings($projectId: ID!, $first: Int!, $page: Int, $orderBy: [QueryProjectTimeBillingsOrderByOrderByClause!]) {
  projectTimeBillings(
    project_id: $projectId
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      ...ProjectTimeBillingListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      total
      hasMorePages
    }
  }
}
    ${ProjectTimeBillingListItemFragmentDoc}`;

/**
 * __useProjectTimeBillingsQuery__
 *
 * To run a query within a React component, call `useProjectTimeBillingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTimeBillingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTimeBillingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useProjectTimeBillingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables> & ({ variables: ProjectTimeBillingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>(ProjectTimeBillingsDocument, options);
      }
export function useProjectTimeBillingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>(ProjectTimeBillingsDocument, options);
        }
export function useProjectTimeBillingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>(ProjectTimeBillingsDocument, options);
        }
export type ProjectTimeBillingsQueryHookResult = ReturnType<typeof useProjectTimeBillingsQuery>;
export type ProjectTimeBillingsLazyQueryHookResult = ReturnType<typeof useProjectTimeBillingsLazyQuery>;
export type ProjectTimeBillingsSuspenseQueryHookResult = ReturnType<typeof useProjectTimeBillingsSuspenseQuery>;
export type ProjectTimeBillingsQueryResult = ApolloReactCommon.QueryResult<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>;
export const ProjectTimeBillingDetailDocument = gql`
    query ProjectTimeBillingDetail($id: ID!) {
  projectTimeBilling(id: $id) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;

/**
 * __useProjectTimeBillingDetailQuery__
 *
 * To run a query within a React component, call `useProjectTimeBillingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTimeBillingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTimeBillingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectTimeBillingDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables> & ({ variables: ProjectTimeBillingDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>(ProjectTimeBillingDetailDocument, options);
      }
export function useProjectTimeBillingDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>(ProjectTimeBillingDetailDocument, options);
        }
export function useProjectTimeBillingDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>(ProjectTimeBillingDetailDocument, options);
        }
export type ProjectTimeBillingDetailQueryHookResult = ReturnType<typeof useProjectTimeBillingDetailQuery>;
export type ProjectTimeBillingDetailLazyQueryHookResult = ReturnType<typeof useProjectTimeBillingDetailLazyQuery>;
export type ProjectTimeBillingDetailSuspenseQueryHookResult = ReturnType<typeof useProjectTimeBillingDetailSuspenseQuery>;
export type ProjectTimeBillingDetailQueryResult = ApolloReactCommon.QueryResult<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>;
export const PreviewProjectTimeBillingDocument = gql`
    query PreviewProjectTimeBilling($input: PreviewProjectTimeBillingInput!) {
  previewProjectTimeBilling(input: $input) {
    ...ProjectTimeBillingComputed
  }
}
    ${ProjectTimeBillingComputedFragmentDoc}`;

/**
 * __usePreviewProjectTimeBillingQuery__
 *
 * To run a query within a React component, call `usePreviewProjectTimeBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewProjectTimeBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewProjectTimeBillingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewProjectTimeBillingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables> & ({ variables: PreviewProjectTimeBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>(PreviewProjectTimeBillingDocument, options);
      }
export function usePreviewProjectTimeBillingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>(PreviewProjectTimeBillingDocument, options);
        }
export function usePreviewProjectTimeBillingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>(PreviewProjectTimeBillingDocument, options);
        }
export type PreviewProjectTimeBillingQueryHookResult = ReturnType<typeof usePreviewProjectTimeBillingQuery>;
export type PreviewProjectTimeBillingLazyQueryHookResult = ReturnType<typeof usePreviewProjectTimeBillingLazyQuery>;
export type PreviewProjectTimeBillingSuspenseQueryHookResult = ReturnType<typeof usePreviewProjectTimeBillingSuspenseQuery>;
export type PreviewProjectTimeBillingQueryResult = ApolloReactCommon.QueryResult<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>;
export const UpdateProjectTimeBreakdownItemDocument = gql`
    mutation UpdateProjectTimeBreakdownItem($id: ID!, $budgeted: Int!, $dateFrom: Date, $dateTo: Date) {
  updateProjectTimeBreakdown(
    id: $id
    budgeted: $budgeted
    date_from: $dateFrom
    date_to: $dateTo
  ) {
    id
  }
}
    `;
export type UpdateProjectTimeBreakdownItemMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectTimeBreakdownItemMutation, UpdateProjectTimeBreakdownItemMutationVariables>;

/**
 * __useUpdateProjectTimeBreakdownItemMutation__
 *
 * To run a mutation, you first call `useUpdateProjectTimeBreakdownItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectTimeBreakdownItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectTimeBreakdownItemMutation, { data, loading, error }] = useUpdateProjectTimeBreakdownItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      budgeted: // value for 'budgeted'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useUpdateProjectTimeBreakdownItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectTimeBreakdownItemMutation, UpdateProjectTimeBreakdownItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectTimeBreakdownItemMutation, UpdateProjectTimeBreakdownItemMutationVariables>(UpdateProjectTimeBreakdownItemDocument, options);
      }
export type UpdateProjectTimeBreakdownItemMutationHookResult = ReturnType<typeof useUpdateProjectTimeBreakdownItemMutation>;
export type UpdateProjectTimeBreakdownItemMutationResult = ApolloReactCommon.MutationResult<UpdateProjectTimeBreakdownItemMutation>;
export type UpdateProjectTimeBreakdownItemMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectTimeBreakdownItemMutation, UpdateProjectTimeBreakdownItemMutationVariables>;
export const TimeTrackingProjectReportDocument = gql`
    query TimeTrackingProjectReport($filters: TimeTrackingProjectReportQueryArgs) {
  timeTrackingProjectReport(filters: $filters) {
    user_id
    team_id
    user_full_name
    tracked_time
    amount
    invoiced_amount
    time_tracking_work_type_title
    group_tracked_time
    group_amount
    our_work_budget_item_title
    hourly_rate
    internal_hourly_rate
    image
    time_tracking_work_type_id
    our_work_budget_item_id
    personal_expense
    personal_profitability
    invoiced_personal_profitability
    billable_all
    invoiced_seconds
    overserviced_seconds
    uninvoiced_seconds
  }
}
    `;

/**
 * __useTimeTrackingProjectReportQuery__
 *
 * To run a query within a React component, call `useTimeTrackingProjectReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingProjectReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingProjectReportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTimeTrackingProjectReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>(TimeTrackingProjectReportDocument, options);
      }
export function useTimeTrackingProjectReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>(TimeTrackingProjectReportDocument, options);
        }
export function useTimeTrackingProjectReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>(TimeTrackingProjectReportDocument, options);
        }
export type TimeTrackingProjectReportQueryHookResult = ReturnType<typeof useTimeTrackingProjectReportQuery>;
export type TimeTrackingProjectReportLazyQueryHookResult = ReturnType<typeof useTimeTrackingProjectReportLazyQuery>;
export type TimeTrackingProjectReportSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingProjectReportSuspenseQuery>;
export type TimeTrackingProjectReportQueryResult = ApolloReactCommon.QueryResult<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>;
export const ProjectOurWorkItemsDocument = gql`
    query ProjectOurWorkItems($id: ID!) {
  project(id: $id) {
    uses_budgetovac
    start_date
    finished_at
    expected_end_date
    brand {
      id
    }
    ourWork {
      id
      title
    }
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

/**
 * __useProjectOurWorkItemsQuery__
 *
 * To run a query within a React component, call `useProjectOurWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOurWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOurWorkItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectOurWorkItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables> & ({ variables: ProjectOurWorkItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>(ProjectOurWorkItemsDocument, options);
      }
export function useProjectOurWorkItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>(ProjectOurWorkItemsDocument, options);
        }
export function useProjectOurWorkItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>(ProjectOurWorkItemsDocument, options);
        }
export type ProjectOurWorkItemsQueryHookResult = ReturnType<typeof useProjectOurWorkItemsQuery>;
export type ProjectOurWorkItemsLazyQueryHookResult = ReturnType<typeof useProjectOurWorkItemsLazyQuery>;
export type ProjectOurWorkItemsSuspenseQueryHookResult = ReturnType<typeof useProjectOurWorkItemsSuspenseQuery>;
export type ProjectOurWorkItemsQueryResult = ApolloReactCommon.QueryResult<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>;
export const ProjectTimeBreakdownDocument = gql`
    query ProjectTimeBreakdown($projectId: ID!) {
  projectTimeBreakdowns(project_id: $projectId) {
    id
    title
    tracked_time
    tracked_amount
    budgeted
    budgeted_time
    personal_expenses
    profit
    time_breakdown {
      id
      date_from
      date_to
      tracked_time
      tracked_amount
      budgeted
      budgeted_time
      personal_expenses
      profit
    }
  }
}
    `;

/**
 * __useProjectTimeBreakdownQuery__
 *
 * To run a query within a React component, call `useProjectTimeBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTimeBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTimeBreakdownQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectTimeBreakdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables> & ({ variables: ProjectTimeBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>(ProjectTimeBreakdownDocument, options);
      }
export function useProjectTimeBreakdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>(ProjectTimeBreakdownDocument, options);
        }
export function useProjectTimeBreakdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>(ProjectTimeBreakdownDocument, options);
        }
export type ProjectTimeBreakdownQueryHookResult = ReturnType<typeof useProjectTimeBreakdownQuery>;
export type ProjectTimeBreakdownLazyQueryHookResult = ReturnType<typeof useProjectTimeBreakdownLazyQuery>;
export type ProjectTimeBreakdownSuspenseQueryHookResult = ReturnType<typeof useProjectTimeBreakdownSuspenseQuery>;
export type ProjectTimeBreakdownQueryResult = ApolloReactCommon.QueryResult<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>;
export const BrandReportOptionsDocument = gql`
    query BrandReportOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    title
    code
  }
}
    `;

/**
 * __useBrandReportOptionsQuery__
 *
 * To run a query within a React component, call `useBrandReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandReportOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandReportOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>(BrandReportOptionsDocument, options);
      }
export function useBrandReportOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>(BrandReportOptionsDocument, options);
        }
export function useBrandReportOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>(BrandReportOptionsDocument, options);
        }
export type BrandReportOptionsQueryHookResult = ReturnType<typeof useBrandReportOptionsQuery>;
export type BrandReportOptionsLazyQueryHookResult = ReturnType<typeof useBrandReportOptionsLazyQuery>;
export type BrandReportOptionsSuspenseQueryHookResult = ReturnType<typeof useBrandReportOptionsSuspenseQuery>;
export type BrandReportOptionsQueryResult = ApolloReactCommon.QueryResult<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>;
export const BrandProfitAndRevenueSummaryDocument = gql`
    query BrandProfitAndRevenueSummary($filters: BrandRevenueQueryArgs) {
  brandRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_billings_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
  }
}
    `;

/**
 * __useBrandProfitAndRevenueSummaryQuery__
 *
 * To run a query within a React component, call `useBrandProfitAndRevenueSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProfitAndRevenueSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProfitAndRevenueSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandProfitAndRevenueSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>(BrandProfitAndRevenueSummaryDocument, options);
      }
export function useBrandProfitAndRevenueSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>(BrandProfitAndRevenueSummaryDocument, options);
        }
export function useBrandProfitAndRevenueSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>(BrandProfitAndRevenueSummaryDocument, options);
        }
export type BrandProfitAndRevenueSummaryQueryHookResult = ReturnType<typeof useBrandProfitAndRevenueSummaryQuery>;
export type BrandProfitAndRevenueSummaryLazyQueryHookResult = ReturnType<typeof useBrandProfitAndRevenueSummaryLazyQuery>;
export type BrandProfitAndRevenueSummarySuspenseQueryHookResult = ReturnType<typeof useBrandProfitAndRevenueSummarySuspenseQuery>;
export type BrandProfitAndRevenueSummaryQueryResult = ApolloReactCommon.QueryResult<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>;
export const BrandProfitAndRevenueTableDataDocument = gql`
    query BrandProfitAndRevenueTableData($filters: BrandRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  brandRevenue(filters: $filters) {
    result {
      ...BrandTableData
      gross_profit_for_date_range
      our_work_revenue_for_date_range
      filtered_profit_share
      total_profit_share
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
      total_invoiced
      our_work_billings_for_date_range
      filtered_revenue_share
      total_revenue_share
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
      brands {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
        gross_income_for_date_range
        gross_profit_for_date_range
        our_work_revenue_for_date_range
        filtered_profit_share
        total_profit_share
        expenses_profit_for_date_range {
          expense_budget_category_id
          profit
        }
        total_invoiced
        our_work_billings_for_date_range
        filtered_revenue_share
        total_revenue_share
        expenses_billings_for_date_range {
          expense_budget_category_id
          billings
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BrandTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useBrandProfitAndRevenueTableDataQuery__
 *
 * To run a query within a React component, call `useBrandProfitAndRevenueTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProfitAndRevenueTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProfitAndRevenueTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandProfitAndRevenueTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>(BrandProfitAndRevenueTableDataDocument, options);
      }
export function useBrandProfitAndRevenueTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>(BrandProfitAndRevenueTableDataDocument, options);
        }
export function useBrandProfitAndRevenueTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>(BrandProfitAndRevenueTableDataDocument, options);
        }
export type BrandProfitAndRevenueTableDataQueryHookResult = ReturnType<typeof useBrandProfitAndRevenueTableDataQuery>;
export type BrandProfitAndRevenueTableDataLazyQueryHookResult = ReturnType<typeof useBrandProfitAndRevenueTableDataLazyQuery>;
export type BrandProfitAndRevenueTableDataSuspenseQueryHookResult = ReturnType<typeof useBrandProfitAndRevenueTableDataSuspenseQuery>;
export type BrandProfitAndRevenueTableDataQueryResult = ApolloReactCommon.QueryResult<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>;
export const BrandProfitSummaryDocument = gql`
    query BrandProfitSummary($filters: BrandRevenueQueryArgs) {
  brandRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    profit_top_clients {
      name
      total_value
      brands {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useBrandProfitSummaryQuery__
 *
 * To run a query within a React component, call `useBrandProfitSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProfitSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProfitSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandProfitSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>(BrandProfitSummaryDocument, options);
      }
export function useBrandProfitSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>(BrandProfitSummaryDocument, options);
        }
export function useBrandProfitSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>(BrandProfitSummaryDocument, options);
        }
export type BrandProfitSummaryQueryHookResult = ReturnType<typeof useBrandProfitSummaryQuery>;
export type BrandProfitSummaryLazyQueryHookResult = ReturnType<typeof useBrandProfitSummaryLazyQuery>;
export type BrandProfitSummarySuspenseQueryHookResult = ReturnType<typeof useBrandProfitSummarySuspenseQuery>;
export type BrandProfitSummaryQueryResult = ApolloReactCommon.QueryResult<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>;
export const BrandProfitTableDataDocument = gql`
    query BrandProfitTableData($filters: BrandRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  brandRevenue(filters: $filters) {
    result {
      ...BrandTableData
      gross_profit_for_date_range
      our_work_revenue_for_date_range
      filtered_profit_share
      total_profit_share
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
      brands {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
        gross_income_for_date_range
        gross_profit_for_date_range
        our_work_revenue_for_date_range
        filtered_profit_share
        total_profit_share
        expenses_profit_for_date_range {
          expense_budget_category_id
          profit
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BrandTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useBrandProfitTableDataQuery__
 *
 * To run a query within a React component, call `useBrandProfitTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProfitTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProfitTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandProfitTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>(BrandProfitTableDataDocument, options);
      }
export function useBrandProfitTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>(BrandProfitTableDataDocument, options);
        }
export function useBrandProfitTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>(BrandProfitTableDataDocument, options);
        }
export type BrandProfitTableDataQueryHookResult = ReturnType<typeof useBrandProfitTableDataQuery>;
export type BrandProfitTableDataLazyQueryHookResult = ReturnType<typeof useBrandProfitTableDataLazyQuery>;
export type BrandProfitTableDataSuspenseQueryHookResult = ReturnType<typeof useBrandProfitTableDataSuspenseQuery>;
export type BrandProfitTableDataQueryResult = ApolloReactCommon.QueryResult<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>;
export const BrandRevenueSummaryDocument = gql`
    query BrandRevenueSummary($filters: BrandRevenueQueryArgs) {
  brandRevenueSummary(filters: $filters) {
    our_work_billings_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      billings
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
    revenue_top_clients {
      name
      total_value
      brands {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useBrandRevenueSummaryQuery__
 *
 * To run a query within a React component, call `useBrandRevenueSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandRevenueSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandRevenueSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandRevenueSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>(BrandRevenueSummaryDocument, options);
      }
export function useBrandRevenueSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>(BrandRevenueSummaryDocument, options);
        }
export function useBrandRevenueSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>(BrandRevenueSummaryDocument, options);
        }
export type BrandRevenueSummaryQueryHookResult = ReturnType<typeof useBrandRevenueSummaryQuery>;
export type BrandRevenueSummaryLazyQueryHookResult = ReturnType<typeof useBrandRevenueSummaryLazyQuery>;
export type BrandRevenueSummarySuspenseQueryHookResult = ReturnType<typeof useBrandRevenueSummarySuspenseQuery>;
export type BrandRevenueSummaryQueryResult = ApolloReactCommon.QueryResult<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>;
export const BrandRevenueTableDataDocument = gql`
    query BrandRevenueTableData($filters: BrandRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  brandRevenue(filters: $filters) {
    result {
      ...BrandTableData
      total_invoiced
      our_work_billings_for_date_range
      filtered_revenue_share
      total_revenue_share
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
      brands {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
        gross_income_for_date_range
        total_invoiced
        our_work_billings_for_date_range
        filtered_revenue_share
        total_revenue_share
        expenses_billings_for_date_range {
          expense_budget_category_id
          billings
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BrandTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useBrandRevenueTableDataQuery__
 *
 * To run a query within a React component, call `useBrandRevenueTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandRevenueTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandRevenueTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandRevenueTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>(BrandRevenueTableDataDocument, options);
      }
export function useBrandRevenueTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>(BrandRevenueTableDataDocument, options);
        }
export function useBrandRevenueTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>(BrandRevenueTableDataDocument, options);
        }
export type BrandRevenueTableDataQueryHookResult = ReturnType<typeof useBrandRevenueTableDataQuery>;
export type BrandRevenueTableDataLazyQueryHookResult = ReturnType<typeof useBrandRevenueTableDataLazyQuery>;
export type BrandRevenueTableDataSuspenseQueryHookResult = ReturnType<typeof useBrandRevenueTableDataSuspenseQuery>;
export type BrandRevenueTableDataQueryResult = ApolloReactCommon.QueryResult<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>;
export const ProfitAndLossReportDocument = gql`
    query ProfitAndLossReport($where: ProfitLossReportWhereConditions, $from: Date!, $to: Date!, $rows: ProfitLossReportRows!, $columns: ProfitLossReportColumns, $page: BigInt!, $first: BigInt!, $includeDraftExpenses: Boolean) {
  profitLossReport(
    where: $where
    from: $from
    to: $to
    rows: $rows
    columns: $columns
    page: $page
    first: $first
    include_draft_expenses: $includeDraftExpenses
  ) {
    data {
      id
      title
      columns {
        ...ProfitAndLossReportColumn
      }
      items {
        id
        title
        columns {
          ...ProfitAndLossReportColumn
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProfitAndLossReportColumnFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProfitAndLossReportQuery__
 *
 * To run a query within a React component, call `useProfitAndLossReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfitAndLossReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfitAndLossReportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      rows: // value for 'rows'
 *      columns: // value for 'columns'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      includeDraftExpenses: // value for 'includeDraftExpenses'
 *   },
 * });
 */
export function useProfitAndLossReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables> & ({ variables: ProfitAndLossReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>(ProfitAndLossReportDocument, options);
      }
export function useProfitAndLossReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>(ProfitAndLossReportDocument, options);
        }
export function useProfitAndLossReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>(ProfitAndLossReportDocument, options);
        }
export type ProfitAndLossReportQueryHookResult = ReturnType<typeof useProfitAndLossReportQuery>;
export type ProfitAndLossReportLazyQueryHookResult = ReturnType<typeof useProfitAndLossReportLazyQuery>;
export type ProfitAndLossReportSuspenseQueryHookResult = ReturnType<typeof useProfitAndLossReportSuspenseQuery>;
export type ProfitAndLossReportQueryResult = ApolloReactCommon.QueryResult<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>;
export const ProfitAndLossReportSummaryDocument = gql`
    query ProfitAndLossReportSummary($where: ProfitLossReportWhereConditions, $from: Date!, $to: Date!, $columns: ProfitLossReportColumns, $includeDraftExpenses: Boolean) {
  profitLossReportSummary(
    where: $where
    from: $from
    to: $to
    columns: $columns
    include_draft_expenses: $includeDraftExpenses
  ) {
    data {
      ...ProfitAndLossReportColumn
    }
  }
}
    ${ProfitAndLossReportColumnFragmentDoc}`;

/**
 * __useProfitAndLossReportSummaryQuery__
 *
 * To run a query within a React component, call `useProfitAndLossReportSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfitAndLossReportSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfitAndLossReportSummaryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      columns: // value for 'columns'
 *      includeDraftExpenses: // value for 'includeDraftExpenses'
 *   },
 * });
 */
export function useProfitAndLossReportSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables> & ({ variables: ProfitAndLossReportSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>(ProfitAndLossReportSummaryDocument, options);
      }
export function useProfitAndLossReportSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>(ProfitAndLossReportSummaryDocument, options);
        }
export function useProfitAndLossReportSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>(ProfitAndLossReportSummaryDocument, options);
        }
export type ProfitAndLossReportSummaryQueryHookResult = ReturnType<typeof useProfitAndLossReportSummaryQuery>;
export type ProfitAndLossReportSummaryLazyQueryHookResult = ReturnType<typeof useProfitAndLossReportSummaryLazyQuery>;
export type ProfitAndLossReportSummarySuspenseQueryHookResult = ReturnType<typeof useProfitAndLossReportSummarySuspenseQuery>;
export type ProfitAndLossReportSummaryQueryResult = ApolloReactCommon.QueryResult<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>;
export const ProfitAndLossFilterOptionsDocument = gql`
    query ProfitAndLossFilterOptions {
  clientsSimpleMap {
    ...ClientSimpleOptionParts
    brands {
      ...BrandSimpleOptionParts
    }
  }
  projectManagerSimpleMap {
    ...UserSimpleOptionParts
  }
  projectCategories {
    id
    name
  }
  teamSimpleMap {
    id
    name
  }
  projectsSimpleMap {
    id
    title
    code
  }
}
    ${ClientSimpleOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}
${UserSimpleOptionPartsFragmentDoc}`;

/**
 * __useProfitAndLossFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProfitAndLossFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfitAndLossFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfitAndLossFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfitAndLossFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>(ProfitAndLossFilterOptionsDocument, options);
      }
export function useProfitAndLossFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>(ProfitAndLossFilterOptionsDocument, options);
        }
export function useProfitAndLossFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>(ProfitAndLossFilterOptionsDocument, options);
        }
export type ProfitAndLossFilterOptionsQueryHookResult = ReturnType<typeof useProfitAndLossFilterOptionsQuery>;
export type ProfitAndLossFilterOptionsLazyQueryHookResult = ReturnType<typeof useProfitAndLossFilterOptionsLazyQuery>;
export type ProfitAndLossFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProfitAndLossFilterOptionsSuspenseQuery>;
export type ProfitAndLossFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>;
export const UpdateProjectNoteDocument = gql`
    mutation UpdateProjectNote($id: ID!, $note: String, $isTemplate: Boolean!) {
  updateProject(input: {id: $id, note: $note, is_template: $isTemplate}) {
    id
    note
  }
}
    `;
export type UpdateProjectNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>;

/**
 * __useUpdateProjectNoteMutation__
 *
 * To run a mutation, you first call `useUpdateProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectNoteMutation, { data, loading, error }] = useUpdateProjectNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *      isTemplate: // value for 'isTemplate'
 *   },
 * });
 */
export function useUpdateProjectNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>(UpdateProjectNoteDocument, options);
      }
export type UpdateProjectNoteMutationHookResult = ReturnType<typeof useUpdateProjectNoteMutation>;
export type UpdateProjectNoteMutationResult = ApolloReactCommon.MutationResult<UpdateProjectNoteMutation>;
export type UpdateProjectNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>;
export const UpdateOwbiNoteDocument = gql`
    mutation UpdateOWBINote($id: ID!, $note: String) {
  updateOurWorkBudgetItemNote(our_work_budget_item_id: $id, note: $note) {
    id
    note
  }
}
    `;
export type UpdateOwbiNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateOwbiNoteMutation, UpdateOwbiNoteMutationVariables>;

/**
 * __useUpdateOwbiNoteMutation__
 *
 * To run a mutation, you first call `useUpdateOwbiNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwbiNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwbiNoteMutation, { data, loading, error }] = useUpdateOwbiNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateOwbiNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOwbiNoteMutation, UpdateOwbiNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOwbiNoteMutation, UpdateOwbiNoteMutationVariables>(UpdateOwbiNoteDocument, options);
      }
export type UpdateOwbiNoteMutationHookResult = ReturnType<typeof useUpdateOwbiNoteMutation>;
export type UpdateOwbiNoteMutationResult = ApolloReactCommon.MutationResult<UpdateOwbiNoteMutation>;
export type UpdateOwbiNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOwbiNoteMutation, UpdateOwbiNoteMutationVariables>;
export const UpdateExbiNoteDocument = gql`
    mutation UpdateEXBINote($id: ID!, $note: String) {
  updateExpenseBudgetItemNote(expense_budget_item_id: $id, note: $note) {
    id
    note
  }
}
    `;
export type UpdateExbiNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateExbiNoteMutation, UpdateExbiNoteMutationVariables>;

/**
 * __useUpdateExbiNoteMutation__
 *
 * To run a mutation, you first call `useUpdateExbiNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExbiNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExbiNoteMutation, { data, loading, error }] = useUpdateExbiNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateExbiNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExbiNoteMutation, UpdateExbiNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExbiNoteMutation, UpdateExbiNoteMutationVariables>(UpdateExbiNoteDocument, options);
      }
export type UpdateExbiNoteMutationHookResult = ReturnType<typeof useUpdateExbiNoteMutation>;
export type UpdateExbiNoteMutationResult = ApolloReactCommon.MutationResult<UpdateExbiNoteMutation>;
export type UpdateExbiNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExbiNoteMutation, UpdateExbiNoteMutationVariables>;
export const ProjectReportOptionsDocument = gql`
    query ProjectReportOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  teamSimpleMap {
    id
    name
  }
}
    `;

/**
 * __useProjectReportOptionsQuery__
 *
 * To run a query within a React component, call `useProjectReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectReportOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>(ProjectReportOptionsDocument, options);
      }
export function useProjectReportOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>(ProjectReportOptionsDocument, options);
        }
export function useProjectReportOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>(ProjectReportOptionsDocument, options);
        }
export type ProjectReportOptionsQueryHookResult = ReturnType<typeof useProjectReportOptionsQuery>;
export type ProjectReportOptionsLazyQueryHookResult = ReturnType<typeof useProjectReportOptionsLazyQuery>;
export type ProjectReportOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectReportOptionsSuspenseQuery>;
export type ProjectReportOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>;
export const ProjectRevenueDetailDocument = gql`
    query ProjectRevenueDetail($projectId: ID!, $from: Date!, $to: Date!) {
  projectRevenueDetail(project_id: $projectId, from: $from, to: $to) {
    ourWork {
      billings_for_date_range
      revenue_for_date_range
      ourWorkBudgetItem {
        id
        title
        note
        stats {
          net_profit
          net_margin_percent
        }
      }
    }
    expensesStructured {
      expenseBudgetCategory {
        id
        name
      }
      budgetItems {
        billings_for_date_range
        profit_for_date_range
        expenseBudgetItem {
          completed_at
          category {
            name
          }
          id
          type
          title
          note
          stats {
            credit
            profit
            profit_percent
            real_expenses
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectRevenueDetailQuery__
 *
 * To run a query within a React component, call `useProjectRevenueDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRevenueDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRevenueDetailQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useProjectRevenueDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables> & ({ variables: ProjectRevenueDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>(ProjectRevenueDetailDocument, options);
      }
export function useProjectRevenueDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>(ProjectRevenueDetailDocument, options);
        }
export function useProjectRevenueDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>(ProjectRevenueDetailDocument, options);
        }
export type ProjectRevenueDetailQueryHookResult = ReturnType<typeof useProjectRevenueDetailQuery>;
export type ProjectRevenueDetailLazyQueryHookResult = ReturnType<typeof useProjectRevenueDetailLazyQuery>;
export type ProjectRevenueDetailSuspenseQueryHookResult = ReturnType<typeof useProjectRevenueDetailSuspenseQuery>;
export type ProjectRevenueDetailQueryResult = ApolloReactCommon.QueryResult<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>;
export const ProjectsReportExportDocument = gql`
    query ProjectsReportExport($from: Date!, $to: Date!) {
  projectsProfitExport(from: $from, to: $to)
}
    `;

/**
 * __useProjectsReportExportQuery__
 *
 * To run a query within a React component, call `useProjectsReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsReportExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useProjectsReportExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsReportExportQuery, ProjectsReportExportQueryVariables> & ({ variables: ProjectsReportExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>(ProjectsReportExportDocument, options);
      }
export function useProjectsReportExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>(ProjectsReportExportDocument, options);
        }
export function useProjectsReportExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>(ProjectsReportExportDocument, options);
        }
export type ProjectsReportExportQueryHookResult = ReturnType<typeof useProjectsReportExportQuery>;
export type ProjectsReportExportLazyQueryHookResult = ReturnType<typeof useProjectsReportExportLazyQuery>;
export type ProjectsReportExportSuspenseQueryHookResult = ReturnType<typeof useProjectsReportExportSuspenseQuery>;
export type ProjectsReportExportQueryResult = ApolloReactCommon.QueryResult<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>;
export const ProjectProfitAndRevenueSummaryDocument = gql`
    query ProjectProfitAndRevenueSummary($filters: ProjectRevenueQueryArgs) {
  projectRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_billings_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
  }
}
    `;

/**
 * __useProjectProfitAndRevenueSummaryQuery__
 *
 * To run a query within a React component, call `useProjectProfitAndRevenueSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProfitAndRevenueSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProfitAndRevenueSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectProfitAndRevenueSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>(ProjectProfitAndRevenueSummaryDocument, options);
      }
export function useProjectProfitAndRevenueSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>(ProjectProfitAndRevenueSummaryDocument, options);
        }
export function useProjectProfitAndRevenueSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>(ProjectProfitAndRevenueSummaryDocument, options);
        }
export type ProjectProfitAndRevenueSummaryQueryHookResult = ReturnType<typeof useProjectProfitAndRevenueSummaryQuery>;
export type ProjectProfitAndRevenueSummaryLazyQueryHookResult = ReturnType<typeof useProjectProfitAndRevenueSummaryLazyQuery>;
export type ProjectProfitAndRevenueSummarySuspenseQueryHookResult = ReturnType<typeof useProjectProfitAndRevenueSummarySuspenseQuery>;
export type ProjectProfitAndRevenueSummaryQueryResult = ApolloReactCommon.QueryResult<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>;
export const ProjectProfitAndRevenueTableDataDocument = gql`
    query ProjectProfitAndRevenueTableData($filters: ProjectRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  projectRevenue(filters: $filters) {
    projects {
      ...ProjectTableData
      gross_profit_for_date_range
      filtered_profit_share
      total_profit_share
      our_work_revenue_for_date_range
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
      total_invoiced
      our_work_billings_for_date_range
      total_revenue_share
      filtered_revenue_share
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectProfitAndRevenueTableDataQuery__
 *
 * To run a query within a React component, call `useProjectProfitAndRevenueTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProfitAndRevenueTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProfitAndRevenueTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectProfitAndRevenueTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>(ProjectProfitAndRevenueTableDataDocument, options);
      }
export function useProjectProfitAndRevenueTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>(ProjectProfitAndRevenueTableDataDocument, options);
        }
export function useProjectProfitAndRevenueTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>(ProjectProfitAndRevenueTableDataDocument, options);
        }
export type ProjectProfitAndRevenueTableDataQueryHookResult = ReturnType<typeof useProjectProfitAndRevenueTableDataQuery>;
export type ProjectProfitAndRevenueTableDataLazyQueryHookResult = ReturnType<typeof useProjectProfitAndRevenueTableDataLazyQuery>;
export type ProjectProfitAndRevenueTableDataSuspenseQueryHookResult = ReturnType<typeof useProjectProfitAndRevenueTableDataSuspenseQuery>;
export type ProjectProfitAndRevenueTableDataQueryResult = ApolloReactCommon.QueryResult<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>;
export const ProjectProfitSummaryDocument = gql`
    query ProjectProfitSummary($filters: ProjectRevenueQueryArgs) {
  projectRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    profit_top_projects {
      title
      total_value
      our_work {
        value
      }
      expense_budget_categories {
        value
        expense_budget_item_id
      }
    }
  }
}
    `;

/**
 * __useProjectProfitSummaryQuery__
 *
 * To run a query within a React component, call `useProjectProfitSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProfitSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProfitSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectProfitSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>(ProjectProfitSummaryDocument, options);
      }
export function useProjectProfitSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>(ProjectProfitSummaryDocument, options);
        }
export function useProjectProfitSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>(ProjectProfitSummaryDocument, options);
        }
export type ProjectProfitSummaryQueryHookResult = ReturnType<typeof useProjectProfitSummaryQuery>;
export type ProjectProfitSummaryLazyQueryHookResult = ReturnType<typeof useProjectProfitSummaryLazyQuery>;
export type ProjectProfitSummarySuspenseQueryHookResult = ReturnType<typeof useProjectProfitSummarySuspenseQuery>;
export type ProjectProfitSummaryQueryResult = ApolloReactCommon.QueryResult<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>;
export const ProjectProfitTableDataDocument = gql`
    query ProjectProfitTableData($filters: ProjectRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  projectRevenue(filters: $filters) {
    projects {
      ...ProjectTableData
      gross_profit_for_date_range
      filtered_profit_share
      total_profit_share
      our_work_revenue_for_date_range
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectProfitTableDataQuery__
 *
 * To run a query within a React component, call `useProjectProfitTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProfitTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProfitTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectProfitTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>(ProjectProfitTableDataDocument, options);
      }
export function useProjectProfitTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>(ProjectProfitTableDataDocument, options);
        }
export function useProjectProfitTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>(ProjectProfitTableDataDocument, options);
        }
export type ProjectProfitTableDataQueryHookResult = ReturnType<typeof useProjectProfitTableDataQuery>;
export type ProjectProfitTableDataLazyQueryHookResult = ReturnType<typeof useProjectProfitTableDataLazyQuery>;
export type ProjectProfitTableDataSuspenseQueryHookResult = ReturnType<typeof useProjectProfitTableDataSuspenseQuery>;
export type ProjectProfitTableDataQueryResult = ApolloReactCommon.QueryResult<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>;
export const ProjectRevenueSummaryDocument = gql`
    query ProjectRevenueSummary($filters: ProjectRevenueQueryArgs) {
  projectRevenueSummary(filters: $filters) {
    our_work_billings_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      billings
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
    revenue_top_projects {
      title
      total_value
      our_work {
        value
      }
      expense_budget_categories {
        value
        expense_budget_item_id
      }
    }
  }
}
    `;

/**
 * __useProjectRevenueSummaryQuery__
 *
 * To run a query within a React component, call `useProjectRevenueSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRevenueSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRevenueSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectRevenueSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>(ProjectRevenueSummaryDocument, options);
      }
export function useProjectRevenueSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>(ProjectRevenueSummaryDocument, options);
        }
export function useProjectRevenueSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>(ProjectRevenueSummaryDocument, options);
        }
export type ProjectRevenueSummaryQueryHookResult = ReturnType<typeof useProjectRevenueSummaryQuery>;
export type ProjectRevenueSummaryLazyQueryHookResult = ReturnType<typeof useProjectRevenueSummaryLazyQuery>;
export type ProjectRevenueSummarySuspenseQueryHookResult = ReturnType<typeof useProjectRevenueSummarySuspenseQuery>;
export type ProjectRevenueSummaryQueryResult = ApolloReactCommon.QueryResult<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>;
export const ProjectRevenueTableDataDocument = gql`
    query ProjectRevenueTableData($filters: ProjectRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  projectRevenue(filters: $filters) {
    projects {
      ...ProjectTableData
      total_invoiced
      total_revenue_share
      filtered_revenue_share
      our_work_billings_for_date_range
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectRevenueTableDataQuery__
 *
 * To run a query within a React component, call `useProjectRevenueTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRevenueTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRevenueTableDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectRevenueTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>(ProjectRevenueTableDataDocument, options);
      }
export function useProjectRevenueTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>(ProjectRevenueTableDataDocument, options);
        }
export function useProjectRevenueTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>(ProjectRevenueTableDataDocument, options);
        }
export type ProjectRevenueTableDataQueryHookResult = ReturnType<typeof useProjectRevenueTableDataQuery>;
export type ProjectRevenueTableDataLazyQueryHookResult = ReturnType<typeof useProjectRevenueTableDataLazyQuery>;
export type ProjectRevenueTableDataSuspenseQueryHookResult = ReturnType<typeof useProjectRevenueTableDataSuspenseQuery>;
export type ProjectRevenueTableDataQueryResult = ApolloReactCommon.QueryResult<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>;
export const ProjectsAllDocument = gql`
    query ProjectsAll($filters: ProjectAllQueryArgs, $first: Int, $page: Int) {
  projectsAll(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      id
      code
      title
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectsAllQuery__
 *
 * To run a query within a React component, call `useProjectsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsAllQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProjectsAllQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsAllQuery, ProjectsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsAllQuery, ProjectsAllQueryVariables>(ProjectsAllDocument, options);
      }
export function useProjectsAllLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsAllQuery, ProjectsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsAllQuery, ProjectsAllQueryVariables>(ProjectsAllDocument, options);
        }
export function useProjectsAllSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsAllQuery, ProjectsAllQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsAllQuery, ProjectsAllQueryVariables>(ProjectsAllDocument, options);
        }
export type ProjectsAllQueryHookResult = ReturnType<typeof useProjectsAllQuery>;
export type ProjectsAllLazyQueryHookResult = ReturnType<typeof useProjectsAllLazyQuery>;
export type ProjectsAllSuspenseQueryHookResult = ReturnType<typeof useProjectsAllSuspenseQuery>;
export type ProjectsAllQueryResult = ApolloReactCommon.QueryResult<ProjectsAllQuery, ProjectsAllQueryVariables>;
export const UserMonthlyReportDataDocument = gql`
    query UserMonthlyReportData($month: BigInt!, $year: BigInt!, $first: BigInt, $page: BigInt, $orderBy: UserMonthlyReportOrderByClause) {
  userMonthlyReport(
    month: $month
    year: $year
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    teams {
      id
      name
      is_default
      user_count
    }
    paginatorInfo {
      count
      currentPage
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      user_full_name
      user_image
      total_tracked_time
      tracked_time_per_team {
        team_id
        tracked_time
        tracked_time_percentage
      }
    }
  }
}
    `;

/**
 * __useUserMonthlyReportDataQuery__
 *
 * To run a query within a React component, call `useUserMonthlyReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMonthlyReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMonthlyReportDataQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserMonthlyReportDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables> & ({ variables: UserMonthlyReportDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>(UserMonthlyReportDataDocument, options);
      }
export function useUserMonthlyReportDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>(UserMonthlyReportDataDocument, options);
        }
export function useUserMonthlyReportDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>(UserMonthlyReportDataDocument, options);
        }
export type UserMonthlyReportDataQueryHookResult = ReturnType<typeof useUserMonthlyReportDataQuery>;
export type UserMonthlyReportDataLazyQueryHookResult = ReturnType<typeof useUserMonthlyReportDataLazyQuery>;
export type UserMonthlyReportDataSuspenseQueryHookResult = ReturnType<typeof useUserMonthlyReportDataSuspenseQuery>;
export type UserMonthlyReportDataQueryResult = ApolloReactCommon.QueryResult<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>;
export const UserMonthlyReportExportDocument = gql`
    query userMonthlyReportExport($month: BigInt!, $year: BigInt!) {
  userMonthlyReportExport(month: $month, year: $year)
}
    `;

/**
 * __useUserMonthlyReportExportQuery__
 *
 * To run a query within a React component, call `useUserMonthlyReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMonthlyReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMonthlyReportExportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUserMonthlyReportExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables> & ({ variables: UserMonthlyReportExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>(UserMonthlyReportExportDocument, options);
      }
export function useUserMonthlyReportExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>(UserMonthlyReportExportDocument, options);
        }
export function useUserMonthlyReportExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>(UserMonthlyReportExportDocument, options);
        }
export type UserMonthlyReportExportQueryHookResult = ReturnType<typeof useUserMonthlyReportExportQuery>;
export type UserMonthlyReportExportLazyQueryHookResult = ReturnType<typeof useUserMonthlyReportExportLazyQuery>;
export type UserMonthlyReportExportSuspenseQueryHookResult = ReturnType<typeof useUserMonthlyReportExportSuspenseQuery>;
export type UserMonthlyReportExportQueryResult = ApolloReactCommon.QueryResult<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>;
export const UserProfitReportDocument = gql`
    query UserProfitReport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!]) {
  utilizationReport(
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
  ) {
    data {
      user {
        ...UserProfitUser
      }
      report {
        ...UserProfitReport
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserProfitUserFragmentDoc}
${UserProfitReportFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useUserProfitReportQuery__
 *
 * To run a query within a React component, call `useUserProfitReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfitReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfitReportQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserProfitReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfitReportQuery, UserProfitReportQueryVariables> & ({ variables: UserProfitReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfitReportQuery, UserProfitReportQueryVariables>(UserProfitReportDocument, options);
      }
export function useUserProfitReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfitReportQuery, UserProfitReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfitReportQuery, UserProfitReportQueryVariables>(UserProfitReportDocument, options);
        }
export function useUserProfitReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfitReportQuery, UserProfitReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfitReportQuery, UserProfitReportQueryVariables>(UserProfitReportDocument, options);
        }
export type UserProfitReportQueryHookResult = ReturnType<typeof useUserProfitReportQuery>;
export type UserProfitReportLazyQueryHookResult = ReturnType<typeof useUserProfitReportLazyQuery>;
export type UserProfitReportSuspenseQueryHookResult = ReturnType<typeof useUserProfitReportSuspenseQuery>;
export type UserProfitReportQueryResult = ApolloReactCommon.QueryResult<UserProfitReportQuery, UserProfitReportQueryVariables>;
export const UserProfitReportGroupedByDocument = gql`
    query UserProfitReportGroupedBy($groupBy: UtilizationReportGroupBy!, $dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!], $groupOrderBy: [UtilizationReportGroupOrderByClause!]) {
  utilizationReportGroups(
    groupBy: $groupBy
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
    groupOrderBy: $groupOrderBy
  ) {
    data {
      group_title
      report {
        ...UserProfitReport
      }
      items {
        user {
          ...UserProfitUser
        }
        report {
          ...UserProfitReport
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserProfitReportFragmentDoc}
${UserProfitUserFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useUserProfitReportGroupedByQuery__
 *
 * To run a query within a React component, call `useUserProfitReportGroupedByQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfitReportGroupedByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfitReportGroupedByQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      orderBy: // value for 'orderBy'
 *      groupOrderBy: // value for 'groupOrderBy'
 *   },
 * });
 */
export function useUserProfitReportGroupedByQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables> & ({ variables: UserProfitReportGroupedByQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>(UserProfitReportGroupedByDocument, options);
      }
export function useUserProfitReportGroupedByLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>(UserProfitReportGroupedByDocument, options);
        }
export function useUserProfitReportGroupedBySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>(UserProfitReportGroupedByDocument, options);
        }
export type UserProfitReportGroupedByQueryHookResult = ReturnType<typeof useUserProfitReportGroupedByQuery>;
export type UserProfitReportGroupedByLazyQueryHookResult = ReturnType<typeof useUserProfitReportGroupedByLazyQuery>;
export type UserProfitReportGroupedBySuspenseQueryHookResult = ReturnType<typeof useUserProfitReportGroupedBySuspenseQuery>;
export type UserProfitReportGroupedByQueryResult = ApolloReactCommon.QueryResult<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>;
export const UserProfitReportStatsDocument = gql`
    query UserProfitReportStats($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportSummary(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  ) {
    ...UserProfitReport
  }
}
    ${UserProfitReportFragmentDoc}`;

/**
 * __useUserProfitReportStatsQuery__
 *
 * To run a query within a React component, call `useUserProfitReportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfitReportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfitReportStatsQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUserProfitReportStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables> & ({ variables: UserProfitReportStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>(UserProfitReportStatsDocument, options);
      }
export function useUserProfitReportStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>(UserProfitReportStatsDocument, options);
        }
export function useUserProfitReportStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>(UserProfitReportStatsDocument, options);
        }
export type UserProfitReportStatsQueryHookResult = ReturnType<typeof useUserProfitReportStatsQuery>;
export type UserProfitReportStatsLazyQueryHookResult = ReturnType<typeof useUserProfitReportStatsLazyQuery>;
export type UserProfitReportStatsSuspenseQueryHookResult = ReturnType<typeof useUserProfitReportStatsSuspenseQuery>;
export type UserProfitReportStatsQueryResult = ApolloReactCommon.QueryResult<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>;
export const UserProfitReportExportDocument = gql`
    query UserProfitReportExport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportExport(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  )
}
    `;

/**
 * __useUserProfitReportExportQuery__
 *
 * To run a query within a React component, call `useUserProfitReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfitReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfitReportExportQuery({
 *   variables: {
 *      dataSource: // value for 'dataSource'
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUserProfitReportExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfitReportExportQuery, UserProfitReportExportQueryVariables> & ({ variables: UserProfitReportExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>(UserProfitReportExportDocument, options);
      }
export function useUserProfitReportExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>(UserProfitReportExportDocument, options);
        }
export function useUserProfitReportExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>(UserProfitReportExportDocument, options);
        }
export type UserProfitReportExportQueryHookResult = ReturnType<typeof useUserProfitReportExportQuery>;
export type UserProfitReportExportLazyQueryHookResult = ReturnType<typeof useUserProfitReportExportLazyQuery>;
export type UserProfitReportExportSuspenseQueryHookResult = ReturnType<typeof useUserProfitReportExportSuspenseQuery>;
export type UserProfitReportExportQueryResult = ApolloReactCommon.QueryResult<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>;
export const UpdateTaskCurrentAssigneeDocument = gql`
    mutation UpdateTaskCurrentAssignee($taskId: ID!, $userId: ID) {
  updateTaskCurrentAssignee(task_id: $taskId, current_assignee_user_id: $userId) {
    id
    currentAssignee {
      ...TaskUser
    }
    positions {
      ...TaskPositionUser
    }
    users {
      ...TaskUser
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;
export type UpdateTaskCurrentAssigneeMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskCurrentAssigneeMutation, UpdateTaskCurrentAssigneeMutationVariables>;

/**
 * __useUpdateTaskCurrentAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskCurrentAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskCurrentAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskCurrentAssigneeMutation, { data, loading, error }] = useUpdateTaskCurrentAssigneeMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateTaskCurrentAssigneeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskCurrentAssigneeMutation, UpdateTaskCurrentAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskCurrentAssigneeMutation, UpdateTaskCurrentAssigneeMutationVariables>(UpdateTaskCurrentAssigneeDocument, options);
      }
export type UpdateTaskCurrentAssigneeMutationHookResult = ReturnType<typeof useUpdateTaskCurrentAssigneeMutation>;
export type UpdateTaskCurrentAssigneeMutationResult = ApolloReactCommon.MutationResult<UpdateTaskCurrentAssigneeMutation>;
export type UpdateTaskCurrentAssigneeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskCurrentAssigneeMutation, UpdateTaskCurrentAssigneeMutationVariables>;
export const UpdateTaskAssigneesDocument = gql`
    mutation UpdateTaskAssignees($taskId: ID!, $positions: [TaskPositionInput!]!) {
  updateTaskAssignees(task_id: $taskId, positions: $positions) {
    id
    currentAssignee {
      ...TaskUser
    }
    positions {
      ...TaskPositionUser
    }
    users {
      ...TaskUser
    }
    stats {
      planned_time
      spent_time
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;
export type UpdateTaskAssigneesMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskAssigneesMutation, UpdateTaskAssigneesMutationVariables>;

/**
 * __useUpdateTaskAssigneesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskAssigneesMutation, { data, loading, error }] = useUpdateTaskAssigneesMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useUpdateTaskAssigneesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskAssigneesMutation, UpdateTaskAssigneesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskAssigneesMutation, UpdateTaskAssigneesMutationVariables>(UpdateTaskAssigneesDocument, options);
      }
export type UpdateTaskAssigneesMutationHookResult = ReturnType<typeof useUpdateTaskAssigneesMutation>;
export type UpdateTaskAssigneesMutationResult = ApolloReactCommon.MutationResult<UpdateTaskAssigneesMutation>;
export type UpdateTaskAssigneesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskAssigneesMutation, UpdateTaskAssigneesMutationVariables>;
export const UpdateTaskDeadlineDocument = gql`
    mutation UpdateTaskDeadline($taskId: ID!, $deadline: DateTime) {
  updateTaskDeadline(task_id: $taskId, deadline: $deadline) {
    ...TaskSchedule
  }
}
    ${TaskScheduleFragmentDoc}`;
export type UpdateTaskDeadlineMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskDeadlineMutation, UpdateTaskDeadlineMutationVariables>;

/**
 * __useUpdateTaskDeadlineMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDeadlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDeadlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDeadlineMutation, { data, loading, error }] = useUpdateTaskDeadlineMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      deadline: // value for 'deadline'
 *   },
 * });
 */
export function useUpdateTaskDeadlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskDeadlineMutation, UpdateTaskDeadlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskDeadlineMutation, UpdateTaskDeadlineMutationVariables>(UpdateTaskDeadlineDocument, options);
      }
export type UpdateTaskDeadlineMutationHookResult = ReturnType<typeof useUpdateTaskDeadlineMutation>;
export type UpdateTaskDeadlineMutationResult = ApolloReactCommon.MutationResult<UpdateTaskDeadlineMutation>;
export type UpdateTaskDeadlineMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskDeadlineMutation, UpdateTaskDeadlineMutationVariables>;
export const UpdateTaskDurationDocument = gql`
    mutation UpdateTaskDuration($taskId: ID!, $from: Date, $to: Date) {
  updateTaskDuration(task_id: $taskId, from: $from, to: $to) {
    ...TaskSchedule
  }
}
    ${TaskScheduleFragmentDoc}`;
export type UpdateTaskDurationMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskDurationMutation, UpdateTaskDurationMutationVariables>;

/**
 * __useUpdateTaskDurationMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDurationMutation, { data, loading, error }] = useUpdateTaskDurationMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUpdateTaskDurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskDurationMutation, UpdateTaskDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskDurationMutation, UpdateTaskDurationMutationVariables>(UpdateTaskDurationDocument, options);
      }
export type UpdateTaskDurationMutationHookResult = ReturnType<typeof useUpdateTaskDurationMutation>;
export type UpdateTaskDurationMutationResult = ApolloReactCommon.MutationResult<UpdateTaskDurationMutation>;
export type UpdateTaskDurationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskDurationMutation, UpdateTaskDurationMutationVariables>;
export const UpdateTaskBillableDocument = gql`
    mutation UpdateTaskBillable($taskId: ID!, $billable: Boolean!, $propagateBillable: Boolean!) {
  updateTaskBillable(
    task_id: $taskId
    billable: $billable
    propagate_billable: $propagateBillable
  ) {
    id
    billable
  }
}
    `;
export type UpdateTaskBillableMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskBillableMutation, UpdateTaskBillableMutationVariables>;

/**
 * __useUpdateTaskBillableMutation__
 *
 * To run a mutation, you first call `useUpdateTaskBillableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskBillableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskBillableMutation, { data, loading, error }] = useUpdateTaskBillableMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      billable: // value for 'billable'
 *      propagateBillable: // value for 'propagateBillable'
 *   },
 * });
 */
export function useUpdateTaskBillableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskBillableMutation, UpdateTaskBillableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskBillableMutation, UpdateTaskBillableMutationVariables>(UpdateTaskBillableDocument, options);
      }
export type UpdateTaskBillableMutationHookResult = ReturnType<typeof useUpdateTaskBillableMutation>;
export type UpdateTaskBillableMutationResult = ApolloReactCommon.MutationResult<UpdateTaskBillableMutation>;
export type UpdateTaskBillableMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskBillableMutation, UpdateTaskBillableMutationVariables>;
export const AddTaskAssigneeDocument = gql`
    mutation AddTaskAssignee($taskId: ID!, $position: TaskPositionInput!) {
  addTaskAssignee(task_id: $taskId, position: $position) {
    id
    currentAssignee {
      ...TaskUser
    }
    positions {
      ...TaskPositionUser
    }
    users {
      ...TaskUser
    }
    stats {
      planned_time
      spent_time
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;
export type AddTaskAssigneeMutationFn = ApolloReactCommon.MutationFunction<AddTaskAssigneeMutation, AddTaskAssigneeMutationVariables>;

/**
 * __useAddTaskAssigneeMutation__
 *
 * To run a mutation, you first call `useAddTaskAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskAssigneeMutation, { data, loading, error }] = useAddTaskAssigneeMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useAddTaskAssigneeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTaskAssigneeMutation, AddTaskAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTaskAssigneeMutation, AddTaskAssigneeMutationVariables>(AddTaskAssigneeDocument, options);
      }
export type AddTaskAssigneeMutationHookResult = ReturnType<typeof useAddTaskAssigneeMutation>;
export type AddTaskAssigneeMutationResult = ApolloReactCommon.MutationResult<AddTaskAssigneeMutation>;
export type AddTaskAssigneeMutationOptions = ApolloReactCommon.BaseMutationOptions<AddTaskAssigneeMutation, AddTaskAssigneeMutationVariables>;
export const UpdateTaskBoardSettingsDocument = gql`
    mutation UpdateTaskBoardSettings($input: UpdateTaskBoardSettingsInput!) {
  updateTaskBoardSettings(input: $input) {
    ...BoardSettings
  }
}
    ${BoardSettingsFragmentDoc}`;
export type UpdateTaskBoardSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskBoardSettingsMutation, UpdateTaskBoardSettingsMutationVariables>;

/**
 * __useUpdateTaskBoardSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTaskBoardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskBoardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskBoardSettingsMutation, { data, loading, error }] = useUpdateTaskBoardSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskBoardSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskBoardSettingsMutation, UpdateTaskBoardSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskBoardSettingsMutation, UpdateTaskBoardSettingsMutationVariables>(UpdateTaskBoardSettingsDocument, options);
      }
export type UpdateTaskBoardSettingsMutationHookResult = ReturnType<typeof useUpdateTaskBoardSettingsMutation>;
export type UpdateTaskBoardSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateTaskBoardSettingsMutation>;
export type UpdateTaskBoardSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskBoardSettingsMutation, UpdateTaskBoardSettingsMutationVariables>;
export const MoveTaskOnBoardDocument = gql`
    mutation MoveTaskOnBoard($input: MoveTaskOnBoardInput!) {
  moveTaskOnBoard(input: $input) {
    ...TaskBase
  }
}
    ${TaskBaseFragmentDoc}`;
export type MoveTaskOnBoardMutationFn = ApolloReactCommon.MutationFunction<MoveTaskOnBoardMutation, MoveTaskOnBoardMutationVariables>;

/**
 * __useMoveTaskOnBoardMutation__
 *
 * To run a mutation, you first call `useMoveTaskOnBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTaskOnBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTaskOnBoardMutation, { data, loading, error }] = useMoveTaskOnBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTaskOnBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveTaskOnBoardMutation, MoveTaskOnBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveTaskOnBoardMutation, MoveTaskOnBoardMutationVariables>(MoveTaskOnBoardDocument, options);
      }
export type MoveTaskOnBoardMutationHookResult = ReturnType<typeof useMoveTaskOnBoardMutation>;
export type MoveTaskOnBoardMutationResult = ApolloReactCommon.MutationResult<MoveTaskOnBoardMutation>;
export type MoveTaskOnBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveTaskOnBoardMutation, MoveTaskOnBoardMutationVariables>;
export const TaskBoardColumnCountsDocument = gql`
    query TaskBoardColumnCounts($filters: TaskQueryArgs!, $groupBy: TaskBoardGroupByEnum!, $groupValues: [ID!], $includeComplete: Boolean, $first: Int, $page: Int) {
  taskBoardColumnCounts(
    filters: $filters
    group_by: $groupBy
    group_values: $groupValues
    include_complete: $includeComplete
    first: $first
    page: $page
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      group_value
      group_label
      total
      spent_time
      planned_time
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useTaskBoardColumnCountsQuery__
 *
 * To run a query within a React component, call `useTaskBoardColumnCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBoardColumnCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBoardColumnCountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      groupBy: // value for 'groupBy'
 *      groupValues: // value for 'groupValues'
 *      includeComplete: // value for 'includeComplete'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTaskBoardColumnCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables> & ({ variables: TaskBoardColumnCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>(TaskBoardColumnCountsDocument, options);
      }
export function useTaskBoardColumnCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>(TaskBoardColumnCountsDocument, options);
        }
export function useTaskBoardColumnCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>(TaskBoardColumnCountsDocument, options);
        }
export type TaskBoardColumnCountsQueryHookResult = ReturnType<typeof useTaskBoardColumnCountsQuery>;
export type TaskBoardColumnCountsLazyQueryHookResult = ReturnType<typeof useTaskBoardColumnCountsLazyQuery>;
export type TaskBoardColumnCountsSuspenseQueryHookResult = ReturnType<typeof useTaskBoardColumnCountsSuspenseQuery>;
export type TaskBoardColumnCountsQueryResult = ApolloReactCommon.QueryResult<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>;
export const TaskBoardColumnTasksDocument = gql`
    query TaskBoardColumnTasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TaskBase
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TaskBaseFragmentDoc}`;

/**
 * __useTaskBoardColumnTasksQuery__
 *
 * To run a query within a React component, call `useTaskBoardColumnTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBoardColumnTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBoardColumnTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTaskBoardColumnTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables> & ({ variables: TaskBoardColumnTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>(TaskBoardColumnTasksDocument, options);
      }
export function useTaskBoardColumnTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>(TaskBoardColumnTasksDocument, options);
        }
export function useTaskBoardColumnTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>(TaskBoardColumnTasksDocument, options);
        }
export type TaskBoardColumnTasksQueryHookResult = ReturnType<typeof useTaskBoardColumnTasksQuery>;
export type TaskBoardColumnTasksLazyQueryHookResult = ReturnType<typeof useTaskBoardColumnTasksLazyQuery>;
export type TaskBoardColumnTasksSuspenseQueryHookResult = ReturnType<typeof useTaskBoardColumnTasksSuspenseQuery>;
export type TaskBoardColumnTasksQueryResult = ApolloReactCommon.QueryResult<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>;
export const TaskBoardSettingsDocument = gql`
    query TaskBoardSettings($boardKey: String!) {
  taskBoardSettings(board_key: $boardKey) {
    ...BoardSettings
  }
}
    ${BoardSettingsFragmentDoc}`;

/**
 * __useTaskBoardSettingsQuery__
 *
 * To run a query within a React component, call `useTaskBoardSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBoardSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBoardSettingsQuery({
 *   variables: {
 *      boardKey: // value for 'boardKey'
 *   },
 * });
 */
export function useTaskBoardSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables> & ({ variables: TaskBoardSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>(TaskBoardSettingsDocument, options);
      }
export function useTaskBoardSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>(TaskBoardSettingsDocument, options);
        }
export function useTaskBoardSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>(TaskBoardSettingsDocument, options);
        }
export type TaskBoardSettingsQueryHookResult = ReturnType<typeof useTaskBoardSettingsQuery>;
export type TaskBoardSettingsLazyQueryHookResult = ReturnType<typeof useTaskBoardSettingsLazyQuery>;
export type TaskBoardSettingsSuspenseQueryHookResult = ReturnType<typeof useTaskBoardSettingsSuspenseQuery>;
export type TaskBoardSettingsQueryResult = ApolloReactCommon.QueryResult<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>;
export const BulkTasksDeleteDocument = gql`
    mutation BulkTasksDelete($taskIds: [ID!]!) {
  bulkDeleteTasks(task_ids: $taskIds)
}
    `;
export type BulkTasksDeleteMutationFn = ApolloReactCommon.MutationFunction<BulkTasksDeleteMutation, BulkTasksDeleteMutationVariables>;

/**
 * __useBulkTasksDeleteMutation__
 *
 * To run a mutation, you first call `useBulkTasksDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkTasksDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkTasksDeleteMutation, { data, loading, error }] = useBulkTasksDeleteMutation({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function useBulkTasksDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkTasksDeleteMutation, BulkTasksDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkTasksDeleteMutation, BulkTasksDeleteMutationVariables>(BulkTasksDeleteDocument, options);
      }
export type BulkTasksDeleteMutationHookResult = ReturnType<typeof useBulkTasksDeleteMutation>;
export type BulkTasksDeleteMutationResult = ApolloReactCommon.MutationResult<BulkTasksDeleteMutation>;
export type BulkTasksDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkTasksDeleteMutation, BulkTasksDeleteMutationVariables>;
export const BulkTasksEditDocument = gql`
    mutation BulkTasksEdit($taskIds: [ID!]!, $duplicateTasks: Boolean!, $data: BulkEditTaskInput!) {
  bulkEditTasks(task_ids: $taskIds, duplicate_task: $duplicateTasks, data: $data)
}
    `;
export type BulkTasksEditMutationFn = ApolloReactCommon.MutationFunction<BulkTasksEditMutation, BulkTasksEditMutationVariables>;

/**
 * __useBulkTasksEditMutation__
 *
 * To run a mutation, you first call `useBulkTasksEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkTasksEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkTasksEditMutation, { data, loading, error }] = useBulkTasksEditMutation({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      duplicateTasks: // value for 'duplicateTasks'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkTasksEditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkTasksEditMutation, BulkTasksEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkTasksEditMutation, BulkTasksEditMutationVariables>(BulkTasksEditDocument, options);
      }
export type BulkTasksEditMutationHookResult = ReturnType<typeof useBulkTasksEditMutation>;
export type BulkTasksEditMutationResult = ApolloReactCommon.MutationResult<BulkTasksEditMutation>;
export type BulkTasksEditMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkTasksEditMutation, BulkTasksEditMutationVariables>;
export const ListingClientTasksDocument = gql`
    query ListingClientTasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...ListingClientTask
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${ListingClientTaskFragmentDoc}`;

/**
 * __useListingClientTasksQuery__
 *
 * To run a query within a React component, call `useListingClientTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingClientTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingClientTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useListingClientTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListingClientTasksQuery, ListingClientTasksQueryVariables> & ({ variables: ListingClientTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListingClientTasksQuery, ListingClientTasksQueryVariables>(ListingClientTasksDocument, options);
      }
export function useListingClientTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListingClientTasksQuery, ListingClientTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListingClientTasksQuery, ListingClientTasksQueryVariables>(ListingClientTasksDocument, options);
        }
export function useListingClientTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListingClientTasksQuery, ListingClientTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListingClientTasksQuery, ListingClientTasksQueryVariables>(ListingClientTasksDocument, options);
        }
export type ListingClientTasksQueryHookResult = ReturnType<typeof useListingClientTasksQuery>;
export type ListingClientTasksLazyQueryHookResult = ReturnType<typeof useListingClientTasksLazyQuery>;
export type ListingClientTasksSuspenseQueryHookResult = ReturnType<typeof useListingClientTasksSuspenseQuery>;
export type ListingClientTasksQueryResult = ApolloReactCommon.QueryResult<ListingClientTasksQuery, ListingClientTasksQueryVariables>;
export const ListingInternalTasksDocument = gql`
    query ListingInternalTasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...ListingInternalTask
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${ListingInternalTaskFragmentDoc}`;

/**
 * __useListingInternalTasksQuery__
 *
 * To run a query within a React component, call `useListingInternalTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingInternalTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingInternalTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useListingInternalTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListingInternalTasksQuery, ListingInternalTasksQueryVariables> & ({ variables: ListingInternalTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>(ListingInternalTasksDocument, options);
      }
export function useListingInternalTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>(ListingInternalTasksDocument, options);
        }
export function useListingInternalTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>(ListingInternalTasksDocument, options);
        }
export type ListingInternalTasksQueryHookResult = ReturnType<typeof useListingInternalTasksQuery>;
export type ListingInternalTasksLazyQueryHookResult = ReturnType<typeof useListingInternalTasksLazyQuery>;
export type ListingInternalTasksSuspenseQueryHookResult = ReturnType<typeof useListingInternalTasksSuspenseQuery>;
export type ListingInternalTasksQueryResult = ApolloReactCommon.QueryResult<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>;
export const AllTaskIdsDocument = gql`
    query AllTaskIds($filters: TaskQueryArgs!) {
  taskIds(filters: $filters)
}
    `;

/**
 * __useAllTaskIdsQuery__
 *
 * To run a query within a React component, call `useAllTaskIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTaskIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTaskIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAllTaskIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllTaskIdsQuery, AllTaskIdsQueryVariables> & ({ variables: AllTaskIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTaskIdsQuery, AllTaskIdsQueryVariables>(AllTaskIdsDocument, options);
      }
export function useAllTaskIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTaskIdsQuery, AllTaskIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTaskIdsQuery, AllTaskIdsQueryVariables>(AllTaskIdsDocument, options);
        }
export function useAllTaskIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllTaskIdsQuery, AllTaskIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllTaskIdsQuery, AllTaskIdsQueryVariables>(AllTaskIdsDocument, options);
        }
export type AllTaskIdsQueryHookResult = ReturnType<typeof useAllTaskIdsQuery>;
export type AllTaskIdsLazyQueryHookResult = ReturnType<typeof useAllTaskIdsLazyQuery>;
export type AllTaskIdsSuspenseQueryHookResult = ReturnType<typeof useAllTaskIdsSuspenseQuery>;
export type AllTaskIdsQueryResult = ApolloReactCommon.QueryResult<AllTaskIdsQuery, AllTaskIdsQueryVariables>;
export const PrepareTaskDataForBulkActionsDocument = gql`
    query PrepareTaskDataForBulkActions($taskIds: [ID!]!, $destinationBudgetItemId: ID!) {
  prepareTaskDataForBulkActions(
    task_ids: $taskIds
    destination_budget_item_id: $destinationBudgetItemId
  ) {
    has_subtasks
    available_positions {
      id
      title
    }
    unavailable_positions {
      id
      title
    }
  }
}
    `;

/**
 * __usePrepareTaskDataForBulkActionsQuery__
 *
 * To run a query within a React component, call `usePrepareTaskDataForBulkActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepareTaskDataForBulkActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepareTaskDataForBulkActionsQuery({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      destinationBudgetItemId: // value for 'destinationBudgetItemId'
 *   },
 * });
 */
export function usePrepareTaskDataForBulkActionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables> & ({ variables: PrepareTaskDataForBulkActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>(PrepareTaskDataForBulkActionsDocument, options);
      }
export function usePrepareTaskDataForBulkActionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>(PrepareTaskDataForBulkActionsDocument, options);
        }
export function usePrepareTaskDataForBulkActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>(PrepareTaskDataForBulkActionsDocument, options);
        }
export type PrepareTaskDataForBulkActionsQueryHookResult = ReturnType<typeof usePrepareTaskDataForBulkActionsQuery>;
export type PrepareTaskDataForBulkActionsLazyQueryHookResult = ReturnType<typeof usePrepareTaskDataForBulkActionsLazyQuery>;
export type PrepareTaskDataForBulkActionsSuspenseQueryHookResult = ReturnType<typeof usePrepareTaskDataForBulkActionsSuspenseQuery>;
export type PrepareTaskDataForBulkActionsQueryResult = ApolloReactCommon.QueryResult<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>;
export const BulkTasksOptionsDocument = gql`
    query BulkTasksOptions {
  taskStatuses {
    name
    id
  }
}
    `;

/**
 * __useBulkTasksOptionsQuery__
 *
 * To run a query within a React component, call `useBulkTasksOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkTasksOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkTasksOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBulkTasksOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>(BulkTasksOptionsDocument, options);
      }
export function useBulkTasksOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>(BulkTasksOptionsDocument, options);
        }
export function useBulkTasksOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>(BulkTasksOptionsDocument, options);
        }
export type BulkTasksOptionsQueryHookResult = ReturnType<typeof useBulkTasksOptionsQuery>;
export type BulkTasksOptionsLazyQueryHookResult = ReturnType<typeof useBulkTasksOptionsLazyQuery>;
export type BulkTasksOptionsSuspenseQueryHookResult = ReturnType<typeof useBulkTasksOptionsSuspenseQuery>;
export type BulkTasksOptionsQueryResult = ApolloReactCommon.QueryResult<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>;
export const TasksDocument = gql`
    query Tasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TaskBasicInfo
      ...TaskExtendedInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TaskBasicInfoFragmentDoc}
${TaskExtendedInfoFragmentDoc}`;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksQuery, TasksQueryVariables> & ({ variables: TasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export function useTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksSuspenseQueryHookResult = ReturnType<typeof useTasksSuspenseQuery>;
export type TasksQueryResult = ApolloReactCommon.QueryResult<TasksQuery, TasksQueryVariables>;
export const TasksForScopedUsersDocument = gql`
    query TasksForScopedUsers($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TaskBasicInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TaskBasicInfoFragmentDoc}`;

/**
 * __useTasksForScopedUsersQuery__
 *
 * To run a query within a React component, call `useTasksForScopedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksForScopedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksForScopedUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTasksForScopedUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables> & ({ variables: TasksForScopedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>(TasksForScopedUsersDocument, options);
      }
export function useTasksForScopedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>(TasksForScopedUsersDocument, options);
        }
export function useTasksForScopedUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>(TasksForScopedUsersDocument, options);
        }
export type TasksForScopedUsersQueryHookResult = ReturnType<typeof useTasksForScopedUsersQuery>;
export type TasksForScopedUsersLazyQueryHookResult = ReturnType<typeof useTasksForScopedUsersLazyQuery>;
export type TasksForScopedUsersSuspenseQueryHookResult = ReturnType<typeof useTasksForScopedUsersSuspenseQuery>;
export type TasksForScopedUsersQueryResult = ApolloReactCommon.QueryResult<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>;
export const TasksFilterOptionsDocument = gql`
    query TasksFilterOptions {
  teamSimpleMap {
    id
    name
  }
  userSimpleMap {
    id
    full_name
    codename
  }
  taskStatuses {
    id
    name
    background_color
    foreground_color
    system_status
  }
  taskPriorities {
    name
    id
  }
  timeTrackingWorkTypes {
    id
    title
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    code
    title
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  userSimpleMap {
    id
    full_name
  }
}
    `;

/**
 * __useTasksFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTasksFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTasksFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>(TasksFilterOptionsDocument, options);
      }
export function useTasksFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>(TasksFilterOptionsDocument, options);
        }
export function useTasksFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>(TasksFilterOptionsDocument, options);
        }
export type TasksFilterOptionsQueryHookResult = ReturnType<typeof useTasksFilterOptionsQuery>;
export type TasksFilterOptionsLazyQueryHookResult = ReturnType<typeof useTasksFilterOptionsLazyQuery>;
export type TasksFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useTasksFilterOptionsSuspenseQuery>;
export type TasksFilterOptionsQueryResult = ApolloReactCommon.QueryResult<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>;
export const BudgetItemsFilterOptionsDocument = gql`
    query BudgetItemsFilterOptions($project_id: [ID!]) {
  ourWorkBudgetItemsSimpleMap(project_id: $project_id) {
    id
    title
    item_code
  }
}
    `;

/**
 * __useBudgetItemsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useBudgetItemsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetItemsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetItemsFilterOptionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useBudgetItemsFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>(BudgetItemsFilterOptionsDocument, options);
      }
export function useBudgetItemsFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>(BudgetItemsFilterOptionsDocument, options);
        }
export function useBudgetItemsFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>(BudgetItemsFilterOptionsDocument, options);
        }
export type BudgetItemsFilterOptionsQueryHookResult = ReturnType<typeof useBudgetItemsFilterOptionsQuery>;
export type BudgetItemsFilterOptionsLazyQueryHookResult = ReturnType<typeof useBudgetItemsFilterOptionsLazyQuery>;
export type BudgetItemsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useBudgetItemsFilterOptionsSuspenseQuery>;
export type BudgetItemsFilterOptionsQueryResult = ApolloReactCommon.QueryResult<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>;
export const CreateCapacityAllocationDocument = gql`
    mutation CreateCapacityAllocation($input: CreateCapacityAllocationInput!) {
  createCapacityAllocation(input: $input) {
    id
  }
}
    `;
export type CreateCapacityAllocationMutationFn = ApolloReactCommon.MutationFunction<CreateCapacityAllocationMutation, CreateCapacityAllocationMutationVariables>;

/**
 * __useCreateCapacityAllocationMutation__
 *
 * To run a mutation, you first call `useCreateCapacityAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapacityAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapacityAllocationMutation, { data, loading, error }] = useCreateCapacityAllocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCapacityAllocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCapacityAllocationMutation, CreateCapacityAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCapacityAllocationMutation, CreateCapacityAllocationMutationVariables>(CreateCapacityAllocationDocument, options);
      }
export type CreateCapacityAllocationMutationHookResult = ReturnType<typeof useCreateCapacityAllocationMutation>;
export type CreateCapacityAllocationMutationResult = ApolloReactCommon.MutationResult<CreateCapacityAllocationMutation>;
export type CreateCapacityAllocationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCapacityAllocationMutation, CreateCapacityAllocationMutationVariables>;
export const UpdateCapacityAllocationDocument = gql`
    mutation UpdateCapacityAllocation($input: UpdateCapacityAllocationInput!) {
  updateCapacityAllocation(input: $input) {
    id
  }
}
    `;
export type UpdateCapacityAllocationMutationFn = ApolloReactCommon.MutationFunction<UpdateCapacityAllocationMutation, UpdateCapacityAllocationMutationVariables>;

/**
 * __useUpdateCapacityAllocationMutation__
 *
 * To run a mutation, you first call `useUpdateCapacityAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapacityAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapacityAllocationMutation, { data, loading, error }] = useUpdateCapacityAllocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapacityAllocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCapacityAllocationMutation, UpdateCapacityAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCapacityAllocationMutation, UpdateCapacityAllocationMutationVariables>(UpdateCapacityAllocationDocument, options);
      }
export type UpdateCapacityAllocationMutationHookResult = ReturnType<typeof useUpdateCapacityAllocationMutation>;
export type UpdateCapacityAllocationMutationResult = ApolloReactCommon.MutationResult<UpdateCapacityAllocationMutation>;
export type UpdateCapacityAllocationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCapacityAllocationMutation, UpdateCapacityAllocationMutationVariables>;
export const UpdateCapacityAllocationForDayDocument = gql`
    mutation UpdateCapacityAllocationForDay($input: UpdateCapacityAllocationForDayInput!) {
  UpdateCapacityAllocationForDay(input: $input) {
    id
  }
}
    `;
export type UpdateCapacityAllocationForDayMutationFn = ApolloReactCommon.MutationFunction<UpdateCapacityAllocationForDayMutation, UpdateCapacityAllocationForDayMutationVariables>;

/**
 * __useUpdateCapacityAllocationForDayMutation__
 *
 * To run a mutation, you first call `useUpdateCapacityAllocationForDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapacityAllocationForDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapacityAllocationForDayMutation, { data, loading, error }] = useUpdateCapacityAllocationForDayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapacityAllocationForDayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCapacityAllocationForDayMutation, UpdateCapacityAllocationForDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCapacityAllocationForDayMutation, UpdateCapacityAllocationForDayMutationVariables>(UpdateCapacityAllocationForDayDocument, options);
      }
export type UpdateCapacityAllocationForDayMutationHookResult = ReturnType<typeof useUpdateCapacityAllocationForDayMutation>;
export type UpdateCapacityAllocationForDayMutationResult = ApolloReactCommon.MutationResult<UpdateCapacityAllocationForDayMutation>;
export type UpdateCapacityAllocationForDayMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCapacityAllocationForDayMutation, UpdateCapacityAllocationForDayMutationVariables>;
export const UpdateCapacityAllocationItemDocument = gql`
    mutation UpdateCapacityAllocationItem($input: UpdateCapacityAllocationItemInput!) {
  updateCapacityAllocationItem(input: $input) {
    id
  }
}
    `;
export type UpdateCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<UpdateCapacityAllocationItemMutation, UpdateCapacityAllocationItemMutationVariables>;

/**
 * __useUpdateCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useUpdateCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapacityAllocationItemMutation, { data, loading, error }] = useUpdateCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCapacityAllocationItemMutation, UpdateCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCapacityAllocationItemMutation, UpdateCapacityAllocationItemMutationVariables>(UpdateCapacityAllocationItemDocument, options);
      }
export type UpdateCapacityAllocationItemMutationHookResult = ReturnType<typeof useUpdateCapacityAllocationItemMutation>;
export type UpdateCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<UpdateCapacityAllocationItemMutation>;
export type UpdateCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCapacityAllocationItemMutation, UpdateCapacityAllocationItemMutationVariables>;
export const CopyCapacityAllocationItemDocument = gql`
    mutation CopyCapacityAllocationItem($input: MoveCapacityAllocationItemInput!) {
  copyCapacityAllocationItem(input: $input) {
    ...CapacityAllocationItem
    stats {
      ...CapacityAllocationItemStats
    }
    userItems {
      capacityAllocation {
        id
      }
      ...CapacityAllocationItem
      stats {
        ...CapacityAllocationItemStats
      }
    }
  }
}
    ${CapacityAllocationItemFragmentDoc}
${CapacityAllocationItemStatsFragmentDoc}`;
export type CopyCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<CopyCapacityAllocationItemMutation, CopyCapacityAllocationItemMutationVariables>;

/**
 * __useCopyCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useCopyCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCapacityAllocationItemMutation, { data, loading, error }] = useCopyCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCapacityAllocationItemMutation, CopyCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCapacityAllocationItemMutation, CopyCapacityAllocationItemMutationVariables>(CopyCapacityAllocationItemDocument, options);
      }
export type CopyCapacityAllocationItemMutationHookResult = ReturnType<typeof useCopyCapacityAllocationItemMutation>;
export type CopyCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<CopyCapacityAllocationItemMutation>;
export type CopyCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CopyCapacityAllocationItemMutation, CopyCapacityAllocationItemMutationVariables>;
export const MoveCapacityAllocationItemDocument = gql`
    mutation MoveCapacityAllocationItem($input: MoveCapacityAllocationItemInput!) {
  moveCapacityAllocationItem(input: $input) {
    id
    userItems {
      capacityAllocation {
        id
      }
      ...CapacityAllocationItem
      stats {
        ...CapacityAllocationItemStats
      }
    }
    id
    timeTrackingWorkType {
      id
      title
    }
    completed
    user {
      id
      full_name
      profile {
        hex_color
      }
      image {
        urls {
          thumbnail
        }
      }
    }
  }
}
    ${CapacityAllocationItemFragmentDoc}
${CapacityAllocationItemStatsFragmentDoc}`;
export type MoveCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<MoveCapacityAllocationItemMutation, MoveCapacityAllocationItemMutationVariables>;

/**
 * __useMoveCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useMoveCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCapacityAllocationItemMutation, { data, loading, error }] = useMoveCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveCapacityAllocationItemMutation, MoveCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveCapacityAllocationItemMutation, MoveCapacityAllocationItemMutationVariables>(MoveCapacityAllocationItemDocument, options);
      }
export type MoveCapacityAllocationItemMutationHookResult = ReturnType<typeof useMoveCapacityAllocationItemMutation>;
export type MoveCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<MoveCapacityAllocationItemMutation>;
export type MoveCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveCapacityAllocationItemMutation, MoveCapacityAllocationItemMutationVariables>;
export const ReorderCapacityAllocationUserItemsDocument = gql`
    mutation ReorderCapacityAllocationUserItems($ids: [ID!]!) {
  reorderCapacityAllocationItems(ids: $ids) {
    id
  }
}
    `;
export type ReorderCapacityAllocationUserItemsMutationFn = ApolloReactCommon.MutationFunction<ReorderCapacityAllocationUserItemsMutation, ReorderCapacityAllocationUserItemsMutationVariables>;

/**
 * __useReorderCapacityAllocationUserItemsMutation__
 *
 * To run a mutation, you first call `useReorderCapacityAllocationUserItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCapacityAllocationUserItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCapacityAllocationUserItemsMutation, { data, loading, error }] = useReorderCapacityAllocationUserItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReorderCapacityAllocationUserItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderCapacityAllocationUserItemsMutation, ReorderCapacityAllocationUserItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderCapacityAllocationUserItemsMutation, ReorderCapacityAllocationUserItemsMutationVariables>(ReorderCapacityAllocationUserItemsDocument, options);
      }
export type ReorderCapacityAllocationUserItemsMutationHookResult = ReturnType<typeof useReorderCapacityAllocationUserItemsMutation>;
export type ReorderCapacityAllocationUserItemsMutationResult = ApolloReactCommon.MutationResult<ReorderCapacityAllocationUserItemsMutation>;
export type ReorderCapacityAllocationUserItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReorderCapacityAllocationUserItemsMutation, ReorderCapacityAllocationUserItemsMutationVariables>;
export const ValidateCreateTimeTrackingItemDocument = gql`
    mutation ValidateCreateTimeTrackingItem($user_id: ID, $task_id: ID!, $time_tracking_work_type_id: ID!, $capacity_allocation_item_id: ID) {
  validateCreateTimeTrackingItem(
    user_id: $user_id
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    capacity_allocation_item_id: $capacity_allocation_item_id
  )
}
    `;
export type ValidateCreateTimeTrackingItemMutationFn = ApolloReactCommon.MutationFunction<ValidateCreateTimeTrackingItemMutation, ValidateCreateTimeTrackingItemMutationVariables>;

/**
 * __useValidateCreateTimeTrackingItemMutation__
 *
 * To run a mutation, you first call `useValidateCreateTimeTrackingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCreateTimeTrackingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCreateTimeTrackingItemMutation, { data, loading, error }] = useValidateCreateTimeTrackingItemMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      task_id: // value for 'task_id'
 *      time_tracking_work_type_id: // value for 'time_tracking_work_type_id'
 *      capacity_allocation_item_id: // value for 'capacity_allocation_item_id'
 *   },
 * });
 */
export function useValidateCreateTimeTrackingItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateCreateTimeTrackingItemMutation, ValidateCreateTimeTrackingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidateCreateTimeTrackingItemMutation, ValidateCreateTimeTrackingItemMutationVariables>(ValidateCreateTimeTrackingItemDocument, options);
      }
export type ValidateCreateTimeTrackingItemMutationHookResult = ReturnType<typeof useValidateCreateTimeTrackingItemMutation>;
export type ValidateCreateTimeTrackingItemMutationResult = ApolloReactCommon.MutationResult<ValidateCreateTimeTrackingItemMutation>;
export type ValidateCreateTimeTrackingItemMutationOptions = ApolloReactCommon.BaseMutationOptions<ValidateCreateTimeTrackingItemMutation, ValidateCreateTimeTrackingItemMutationVariables>;
export const UpdateTimeTrackingWorkTypeInTrackingDocument = gql`
    mutation UpdateTimeTrackingWorkTypeInTracking($user_id: ID, $task_id: ID!, $old_time_tracking_work_type_id: ID!, $new_time_tracking_work_type_id: ID!, $capacity_allocation_item_id: ID) {
  updateTimeTrackingWorkTypeInTracking(
    user_id: $user_id
    task_id: $task_id
    old_time_tracking_work_type_id: $old_time_tracking_work_type_id
    new_time_tracking_work_type_id: $new_time_tracking_work_type_id
    capacity_allocation_item_id: $capacity_allocation_item_id
  )
}
    `;
export type UpdateTimeTrackingWorkTypeInTrackingMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeTrackingWorkTypeInTrackingMutation, UpdateTimeTrackingWorkTypeInTrackingMutationVariables>;

/**
 * __useUpdateTimeTrackingWorkTypeInTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingWorkTypeInTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingWorkTypeInTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingWorkTypeInTrackingMutation, { data, loading, error }] = useUpdateTimeTrackingWorkTypeInTrackingMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      task_id: // value for 'task_id'
 *      old_time_tracking_work_type_id: // value for 'old_time_tracking_work_type_id'
 *      new_time_tracking_work_type_id: // value for 'new_time_tracking_work_type_id'
 *      capacity_allocation_item_id: // value for 'capacity_allocation_item_id'
 *   },
 * });
 */
export function useUpdateTimeTrackingWorkTypeInTrackingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeTrackingWorkTypeInTrackingMutation, UpdateTimeTrackingWorkTypeInTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeTrackingWorkTypeInTrackingMutation, UpdateTimeTrackingWorkTypeInTrackingMutationVariables>(UpdateTimeTrackingWorkTypeInTrackingDocument, options);
      }
export type UpdateTimeTrackingWorkTypeInTrackingMutationHookResult = ReturnType<typeof useUpdateTimeTrackingWorkTypeInTrackingMutation>;
export type UpdateTimeTrackingWorkTypeInTrackingMutationResult = ApolloReactCommon.MutationResult<UpdateTimeTrackingWorkTypeInTrackingMutation>;
export type UpdateTimeTrackingWorkTypeInTrackingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeTrackingWorkTypeInTrackingMutation, UpdateTimeTrackingWorkTypeInTrackingMutationVariables>;
export const UpdatePlanningUsersOrderDocument = gql`
    mutation UpdatePlanningUsersOrder($user_ids: [ID!]!, $type: PlanningOrderTypeEnum!, $model_id: ID) {
  updatePlanningUsersOrder(user_ids: $user_ids, type: $type, model_id: $model_id)
}
    `;
export type UpdatePlanningUsersOrderMutationFn = ApolloReactCommon.MutationFunction<UpdatePlanningUsersOrderMutation, UpdatePlanningUsersOrderMutationVariables>;

/**
 * __useUpdatePlanningUsersOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePlanningUsersOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanningUsersOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanningUsersOrderMutation, { data, loading, error }] = useUpdatePlanningUsersOrderMutation({
 *   variables: {
 *      user_ids: // value for 'user_ids'
 *      type: // value for 'type'
 *      model_id: // value for 'model_id'
 *   },
 * });
 */
export function useUpdatePlanningUsersOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePlanningUsersOrderMutation, UpdatePlanningUsersOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlanningUsersOrderMutation, UpdatePlanningUsersOrderMutationVariables>(UpdatePlanningUsersOrderDocument, options);
      }
export type UpdatePlanningUsersOrderMutationHookResult = ReturnType<typeof useUpdatePlanningUsersOrderMutation>;
export type UpdatePlanningUsersOrderMutationResult = ApolloReactCommon.MutationResult<UpdatePlanningUsersOrderMutation>;
export type UpdatePlanningUsersOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePlanningUsersOrderMutation, UpdatePlanningUsersOrderMutationVariables>;
export const GetAllocationModalOptionsDocument = gql`
    query GetAllocationModalOptions($where: UsersWhereConditions) {
  userSimpleMap(where: $where) {
    id
    full_name
    codename
    team_id
    profile {
      plannable
    }
  }
}
    `;

/**
 * __useGetAllocationModalOptionsQuery__
 *
 * To run a query within a React component, call `useGetAllocationModalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationModalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationModalOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllocationModalOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>(GetAllocationModalOptionsDocument, options);
      }
export function useGetAllocationModalOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>(GetAllocationModalOptionsDocument, options);
        }
export function useGetAllocationModalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>(GetAllocationModalOptionsDocument, options);
        }
export type GetAllocationModalOptionsQueryHookResult = ReturnType<typeof useGetAllocationModalOptionsQuery>;
export type GetAllocationModalOptionsLazyQueryHookResult = ReturnType<typeof useGetAllocationModalOptionsLazyQuery>;
export type GetAllocationModalOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAllocationModalOptionsSuspenseQuery>;
export type GetAllocationModalOptionsQueryResult = ApolloReactCommon.QueryResult<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>;
export const GetTaskPositionsDocument = gql`
    query GetTaskPositions($task_id: ID!) {
  task(id: $task_id) {
    ourWorkBudgetItem {
      project {
        availableTimeTrackingWorkTypes {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetTaskPositionsQuery__
 *
 * To run a query within a React component, call `useGetTaskPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskPositionsQuery({
 *   variables: {
 *      task_id: // value for 'task_id'
 *   },
 * });
 */
export function useGetTaskPositionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTaskPositionsQuery, GetTaskPositionsQueryVariables> & ({ variables: GetTaskPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>(GetTaskPositionsDocument, options);
      }
export function useGetTaskPositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>(GetTaskPositionsDocument, options);
        }
export function useGetTaskPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>(GetTaskPositionsDocument, options);
        }
export type GetTaskPositionsQueryHookResult = ReturnType<typeof useGetTaskPositionsQuery>;
export type GetTaskPositionsLazyQueryHookResult = ReturnType<typeof useGetTaskPositionsLazyQuery>;
export type GetTaskPositionsSuspenseQueryHookResult = ReturnType<typeof useGetTaskPositionsSuspenseQuery>;
export type GetTaskPositionsQueryResult = ApolloReactCommon.QueryResult<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>;
export const IsUserInTaskDocument = gql`
    query IsUserInTask($taskId: ID!, $userId: ID!) {
  isUserInTask(task_id: $taskId, user_id: $userId)
}
    `;

/**
 * __useIsUserInTaskQuery__
 *
 * To run a query within a React component, call `useIsUserInTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserInTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserInTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useIsUserInTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsUserInTaskQuery, IsUserInTaskQueryVariables> & ({ variables: IsUserInTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsUserInTaskQuery, IsUserInTaskQueryVariables>(IsUserInTaskDocument, options);
      }
export function useIsUserInTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsUserInTaskQuery, IsUserInTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsUserInTaskQuery, IsUserInTaskQueryVariables>(IsUserInTaskDocument, options);
        }
export function useIsUserInTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsUserInTaskQuery, IsUserInTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsUserInTaskQuery, IsUserInTaskQueryVariables>(IsUserInTaskDocument, options);
        }
export type IsUserInTaskQueryHookResult = ReturnType<typeof useIsUserInTaskQuery>;
export type IsUserInTaskLazyQueryHookResult = ReturnType<typeof useIsUserInTaskLazyQuery>;
export type IsUserInTaskSuspenseQueryHookResult = ReturnType<typeof useIsUserInTaskSuspenseQuery>;
export type IsUserInTaskQueryResult = ApolloReactCommon.QueryResult<IsUserInTaskQuery, IsUserInTaskQueryVariables>;
export const ModalCapacityAllocationTaskOptionsDocument = gql`
    query ModalCapacityAllocationTaskOptions($taskId: ID!) {
  task(id: $taskId) {
    from
    to
    planned_time
    deadline
    stats {
      planned_time
      history_spent_time
      allocated_time
      left_to_allocate
    }
    positions {
      timeTrackingWorkType {
        id
        title
      }
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useModalCapacityAllocationTaskOptionsQuery__
 *
 * To run a query within a React component, call `useModalCapacityAllocationTaskOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCapacityAllocationTaskOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCapacityAllocationTaskOptionsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useModalCapacityAllocationTaskOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables> & ({ variables: ModalCapacityAllocationTaskOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>(ModalCapacityAllocationTaskOptionsDocument, options);
      }
export function useModalCapacityAllocationTaskOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>(ModalCapacityAllocationTaskOptionsDocument, options);
        }
export function useModalCapacityAllocationTaskOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>(ModalCapacityAllocationTaskOptionsDocument, options);
        }
export type ModalCapacityAllocationTaskOptionsQueryHookResult = ReturnType<typeof useModalCapacityAllocationTaskOptionsQuery>;
export type ModalCapacityAllocationTaskOptionsLazyQueryHookResult = ReturnType<typeof useModalCapacityAllocationTaskOptionsLazyQuery>;
export type ModalCapacityAllocationTaskOptionsSuspenseQueryHookResult = ReturnType<typeof useModalCapacityAllocationTaskOptionsSuspenseQuery>;
export type ModalCapacityAllocationTaskOptionsQueryResult = ApolloReactCommon.QueryResult<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>;
export const ModalCapacityAllocationProjectOptionsDocument = gql`
    query ModalCapacityAllocationProjectOptions($projectId: ID!) {
  projectForTask(id: $projectId) {
    id
    availableTimeTrackingWorkTypes {
      id
      title
    }
  }
}
    `;

/**
 * __useModalCapacityAllocationProjectOptionsQuery__
 *
 * To run a query within a React component, call `useModalCapacityAllocationProjectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCapacityAllocationProjectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCapacityAllocationProjectOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useModalCapacityAllocationProjectOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables> & ({ variables: ModalCapacityAllocationProjectOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>(ModalCapacityAllocationProjectOptionsDocument, options);
      }
export function useModalCapacityAllocationProjectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>(ModalCapacityAllocationProjectOptionsDocument, options);
        }
export function useModalCapacityAllocationProjectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>(ModalCapacityAllocationProjectOptionsDocument, options);
        }
export type ModalCapacityAllocationProjectOptionsQueryHookResult = ReturnType<typeof useModalCapacityAllocationProjectOptionsQuery>;
export type ModalCapacityAllocationProjectOptionsLazyQueryHookResult = ReturnType<typeof useModalCapacityAllocationProjectOptionsLazyQuery>;
export type ModalCapacityAllocationProjectOptionsSuspenseQueryHookResult = ReturnType<typeof useModalCapacityAllocationProjectOptionsSuspenseQuery>;
export type ModalCapacityAllocationProjectOptionsQueryResult = ApolloReactCommon.QueryResult<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>;
export const PlanningFilterOptionsDocument = gql`
    query PlanningFilterOptions {
  taskStatuses {
    id
    name
  }
  taskPriorities {
    id
    name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  userSimpleMap {
    id
    full_name
    codename
  }
  timeTrackingWorkTypes {
    id
    title
  }
  teamSimpleMap {
    id
    name
  }
}
    `;

/**
 * __usePlanningFilterOptionsQuery__
 *
 * To run a query within a React component, call `usePlanningFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanningFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>(PlanningFilterOptionsDocument, options);
      }
export function usePlanningFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>(PlanningFilterOptionsDocument, options);
        }
export function usePlanningFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>(PlanningFilterOptionsDocument, options);
        }
export type PlanningFilterOptionsQueryHookResult = ReturnType<typeof usePlanningFilterOptionsQuery>;
export type PlanningFilterOptionsLazyQueryHookResult = ReturnType<typeof usePlanningFilterOptionsLazyQuery>;
export type PlanningFilterOptionsSuspenseQueryHookResult = ReturnType<typeof usePlanningFilterOptionsSuspenseQuery>;
export type PlanningFilterOptionsQueryResult = ApolloReactCommon.QueryResult<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>;
export const ProjectTemplatesDocument = gql`
    query ProjectTemplates($filters: ProjectQueryArgs, $first: Int, $page: Int) {
  projects(filters: $filters, first: $first, page: $page) {
    data {
      ...ProjectTemplate
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTemplateFragmentDoc}
${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectTemplatesQuery__
 *
 * To run a query within a React component, call `useProjectTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProjectTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
      }
export function useProjectTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
        }
export function useProjectTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
        }
export type ProjectTemplatesQueryHookResult = ReturnType<typeof useProjectTemplatesQuery>;
export type ProjectTemplatesLazyQueryHookResult = ReturnType<typeof useProjectTemplatesLazyQuery>;
export type ProjectTemplatesSuspenseQueryHookResult = ReturnType<typeof useProjectTemplatesSuspenseQuery>;
export type ProjectTemplatesQueryResult = ApolloReactCommon.QueryResult<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>;
export const ProjectTemplatesFilterOptionsDocument = gql`
    query ProjectTemplatesFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    name
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectTemplatesFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProjectTemplatesFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplatesFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemplatesFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectTemplatesFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>(ProjectTemplatesFilterOptionsDocument, options);
      }
export function useProjectTemplatesFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>(ProjectTemplatesFilterOptionsDocument, options);
        }
export function useProjectTemplatesFilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>(ProjectTemplatesFilterOptionsDocument, options);
        }
export type ProjectTemplatesFilterOptionsQueryHookResult = ReturnType<typeof useProjectTemplatesFilterOptionsQuery>;
export type ProjectTemplatesFilterOptionsLazyQueryHookResult = ReturnType<typeof useProjectTemplatesFilterOptionsLazyQuery>;
export type ProjectTemplatesFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectTemplatesFilterOptionsSuspenseQuery>;
export type ProjectTemplatesFilterOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>;
export const CreateTaskGroupTemplateDocument = gql`
    mutation CreateTaskGroupTemplate($name: String!) {
  createTaskTemplateGroup(name: $name) {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;
export type CreateTaskGroupTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateTaskGroupTemplateMutation, CreateTaskGroupTemplateMutationVariables>;

/**
 * __useCreateTaskGroupTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTaskGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskGroupTemplateMutation, { data, loading, error }] = useCreateTaskGroupTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTaskGroupTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskGroupTemplateMutation, CreateTaskGroupTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTaskGroupTemplateMutation, CreateTaskGroupTemplateMutationVariables>(CreateTaskGroupTemplateDocument, options);
      }
export type CreateTaskGroupTemplateMutationHookResult = ReturnType<typeof useCreateTaskGroupTemplateMutation>;
export type CreateTaskGroupTemplateMutationResult = ApolloReactCommon.MutationResult<CreateTaskGroupTemplateMutation>;
export type CreateTaskGroupTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskGroupTemplateMutation, CreateTaskGroupTemplateMutationVariables>;
export const UpdateTaskGroupTemplateDocument = gql`
    mutation UpdateTaskGroupTemplate($id: ID!, $name: String!) {
  updateTaskTemplateGroup(id: $id, name: $name) {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;
export type UpdateTaskGroupTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskGroupTemplateMutation, UpdateTaskGroupTemplateMutationVariables>;

/**
 * __useUpdateTaskGroupTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTaskGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskGroupTemplateMutation, { data, loading, error }] = useUpdateTaskGroupTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTaskGroupTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskGroupTemplateMutation, UpdateTaskGroupTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskGroupTemplateMutation, UpdateTaskGroupTemplateMutationVariables>(UpdateTaskGroupTemplateDocument, options);
      }
export type UpdateTaskGroupTemplateMutationHookResult = ReturnType<typeof useUpdateTaskGroupTemplateMutation>;
export type UpdateTaskGroupTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateTaskGroupTemplateMutation>;
export type UpdateTaskGroupTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskGroupTemplateMutation, UpdateTaskGroupTemplateMutationVariables>;
export const DeleteTaskGroupTemplateDocument = gql`
    mutation DeleteTaskGroupTemplate($id: ID!) {
  deleteTaskTemplateGroup(id: $id)
}
    `;
export type DeleteTaskGroupTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteTaskGroupTemplateMutation, DeleteTaskGroupTemplateMutationVariables>;

/**
 * __useDeleteTaskGroupTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTaskGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskGroupTemplateMutation, { data, loading, error }] = useDeleteTaskGroupTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskGroupTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTaskGroupTemplateMutation, DeleteTaskGroupTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTaskGroupTemplateMutation, DeleteTaskGroupTemplateMutationVariables>(DeleteTaskGroupTemplateDocument, options);
      }
export type DeleteTaskGroupTemplateMutationHookResult = ReturnType<typeof useDeleteTaskGroupTemplateMutation>;
export type DeleteTaskGroupTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteTaskGroupTemplateMutation>;
export type DeleteTaskGroupTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTaskGroupTemplateMutation, DeleteTaskGroupTemplateMutationVariables>;
export const TaskGroupTemplatesDocument = gql`
    query TaskGroupTemplates {
  taskTemplateGroups {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;

/**
 * __useTaskGroupTemplatesQuery__
 *
 * To run a query within a React component, call `useTaskGroupTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskGroupTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>(TaskGroupTemplatesDocument, options);
      }
export function useTaskGroupTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>(TaskGroupTemplatesDocument, options);
        }
export function useTaskGroupTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>(TaskGroupTemplatesDocument, options);
        }
export type TaskGroupTemplatesQueryHookResult = ReturnType<typeof useTaskGroupTemplatesQuery>;
export type TaskGroupTemplatesLazyQueryHookResult = ReturnType<typeof useTaskGroupTemplatesLazyQuery>;
export type TaskGroupTemplatesSuspenseQueryHookResult = ReturnType<typeof useTaskGroupTemplatesSuspenseQuery>;
export type TaskGroupTemplatesQueryResult = ApolloReactCommon.QueryResult<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>;
export const TaskGroupTemplatesSimpleDocument = gql`
    query TaskGroupTemplatesSimple {
  taskTemplateGroups {
    id
    name
  }
}
    `;

/**
 * __useTaskGroupTemplatesSimpleQuery__
 *
 * To run a query within a React component, call `useTaskGroupTemplatesSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupTemplatesSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupTemplatesSimpleQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskGroupTemplatesSimpleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>(TaskGroupTemplatesSimpleDocument, options);
      }
export function useTaskGroupTemplatesSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>(TaskGroupTemplatesSimpleDocument, options);
        }
export function useTaskGroupTemplatesSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>(TaskGroupTemplatesSimpleDocument, options);
        }
export type TaskGroupTemplatesSimpleQueryHookResult = ReturnType<typeof useTaskGroupTemplatesSimpleQuery>;
export type TaskGroupTemplatesSimpleLazyQueryHookResult = ReturnType<typeof useTaskGroupTemplatesSimpleLazyQuery>;
export type TaskGroupTemplatesSimpleSuspenseQueryHookResult = ReturnType<typeof useTaskGroupTemplatesSimpleSuspenseQuery>;
export type TaskGroupTemplatesSimpleQueryResult = ApolloReactCommon.QueryResult<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>;
export const TaskGroupTemplateDocument = gql`
    query TaskGroupTemplate($id: ID!) {
  taskTemplateGroup(id: $id) {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;

/**
 * __useTaskGroupTemplateQuery__
 *
 * To run a query within a React component, call `useTaskGroupTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskGroupTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables> & ({ variables: TaskGroupTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>(TaskGroupTemplateDocument, options);
      }
export function useTaskGroupTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>(TaskGroupTemplateDocument, options);
        }
export function useTaskGroupTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>(TaskGroupTemplateDocument, options);
        }
export type TaskGroupTemplateQueryHookResult = ReturnType<typeof useTaskGroupTemplateQuery>;
export type TaskGroupTemplateLazyQueryHookResult = ReturnType<typeof useTaskGroupTemplateLazyQuery>;
export type TaskGroupTemplateSuspenseQueryHookResult = ReturnType<typeof useTaskGroupTemplateSuspenseQuery>;
export type TaskGroupTemplateQueryResult = ApolloReactCommon.QueryResult<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>;
export const MoveTimeTrackingItemsToWorkTypeDocument = gql`
    mutation MoveTimeTrackingItemsToWorkType($item_ids: [ID!]!, $work_type_id: ID!) {
  moveTimeTrackingItemsToWorkType(
    time_tracking_item_ids: $item_ids
    time_tracking_work_type_id: $work_type_id
  ) {
    total
    successful
    failed
  }
}
    `;
export type MoveTimeTrackingItemsToWorkTypeMutationFn = ApolloReactCommon.MutationFunction<MoveTimeTrackingItemsToWorkTypeMutation, MoveTimeTrackingItemsToWorkTypeMutationVariables>;

/**
 * __useMoveTimeTrackingItemsToWorkTypeMutation__
 *
 * To run a mutation, you first call `useMoveTimeTrackingItemsToWorkTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTimeTrackingItemsToWorkTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTimeTrackingItemsToWorkTypeMutation, { data, loading, error }] = useMoveTimeTrackingItemsToWorkTypeMutation({
 *   variables: {
 *      item_ids: // value for 'item_ids'
 *      work_type_id: // value for 'work_type_id'
 *   },
 * });
 */
export function useMoveTimeTrackingItemsToWorkTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveTimeTrackingItemsToWorkTypeMutation, MoveTimeTrackingItemsToWorkTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveTimeTrackingItemsToWorkTypeMutation, MoveTimeTrackingItemsToWorkTypeMutationVariables>(MoveTimeTrackingItemsToWorkTypeDocument, options);
      }
export type MoveTimeTrackingItemsToWorkTypeMutationHookResult = ReturnType<typeof useMoveTimeTrackingItemsToWorkTypeMutation>;
export type MoveTimeTrackingItemsToWorkTypeMutationResult = ApolloReactCommon.MutationResult<MoveTimeTrackingItemsToWorkTypeMutation>;
export type MoveTimeTrackingItemsToWorkTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveTimeTrackingItemsToWorkTypeMutation, MoveTimeTrackingItemsToWorkTypeMutationVariables>;
export const MoveTimeTrackingItemsToTaskDocument = gql`
    mutation MoveTimeTrackingItemsToTask($item_ids: [ID!]!, $task_id: ID!, $time_tracking_work_type_mapping: [TimeTrackingWorkTypeMapping!]!) {
  moveTimeTrackingItemsToTask(
    task_id: $task_id
    time_tracking_item_ids: $item_ids
    time_tracking_work_type_mapping: $time_tracking_work_type_mapping
  ) {
    total
    successful
    failed
  }
}
    `;
export type MoveTimeTrackingItemsToTaskMutationFn = ApolloReactCommon.MutationFunction<MoveTimeTrackingItemsToTaskMutation, MoveTimeTrackingItemsToTaskMutationVariables>;

/**
 * __useMoveTimeTrackingItemsToTaskMutation__
 *
 * To run a mutation, you first call `useMoveTimeTrackingItemsToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTimeTrackingItemsToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTimeTrackingItemsToTaskMutation, { data, loading, error }] = useMoveTimeTrackingItemsToTaskMutation({
 *   variables: {
 *      item_ids: // value for 'item_ids'
 *      task_id: // value for 'task_id'
 *      time_tracking_work_type_mapping: // value for 'time_tracking_work_type_mapping'
 *   },
 * });
 */
export function useMoveTimeTrackingItemsToTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveTimeTrackingItemsToTaskMutation, MoveTimeTrackingItemsToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveTimeTrackingItemsToTaskMutation, MoveTimeTrackingItemsToTaskMutationVariables>(MoveTimeTrackingItemsToTaskDocument, options);
      }
export type MoveTimeTrackingItemsToTaskMutationHookResult = ReturnType<typeof useMoveTimeTrackingItemsToTaskMutation>;
export type MoveTimeTrackingItemsToTaskMutationResult = ApolloReactCommon.MutationResult<MoveTimeTrackingItemsToTaskMutation>;
export type MoveTimeTrackingItemsToTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveTimeTrackingItemsToTaskMutation, MoveTimeTrackingItemsToTaskMutationVariables>;
export const UnlockTimeTrackingItemsDocument = gql`
    mutation UnlockTimeTrackingItems($ids: [ID!]!) {
  unlockTimeTrackingItems(ids: $ids) {
    total
    failed
    successful
  }
}
    `;
export type UnlockTimeTrackingItemsMutationFn = ApolloReactCommon.MutationFunction<UnlockTimeTrackingItemsMutation, UnlockTimeTrackingItemsMutationVariables>;

/**
 * __useUnlockTimeTrackingItemsMutation__
 *
 * To run a mutation, you first call `useUnlockTimeTrackingItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockTimeTrackingItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockTimeTrackingItemsMutation, { data, loading, error }] = useUnlockTimeTrackingItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnlockTimeTrackingItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlockTimeTrackingItemsMutation, UnlockTimeTrackingItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlockTimeTrackingItemsMutation, UnlockTimeTrackingItemsMutationVariables>(UnlockTimeTrackingItemsDocument, options);
      }
export type UnlockTimeTrackingItemsMutationHookResult = ReturnType<typeof useUnlockTimeTrackingItemsMutation>;
export type UnlockTimeTrackingItemsMutationResult = ApolloReactCommon.MutationResult<UnlockTimeTrackingItemsMutation>;
export type UnlockTimeTrackingItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlockTimeTrackingItemsMutation, UnlockTimeTrackingItemsMutationVariables>;
export const BulkDeleteTimeTrackingItemsDocument = gql`
    mutation BulkDeleteTimeTrackingItems($ids: [ID!]!) {
  bulkDeleteTimeTrackingItems(ids: $ids) {
    total
    successful
    failed
  }
}
    `;
export type BulkDeleteTimeTrackingItemsMutationFn = ApolloReactCommon.MutationFunction<BulkDeleteTimeTrackingItemsMutation, BulkDeleteTimeTrackingItemsMutationVariables>;

/**
 * __useBulkDeleteTimeTrackingItemsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteTimeTrackingItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteTimeTrackingItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteTimeTrackingItemsMutation, { data, loading, error }] = useBulkDeleteTimeTrackingItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDeleteTimeTrackingItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkDeleteTimeTrackingItemsMutation, BulkDeleteTimeTrackingItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkDeleteTimeTrackingItemsMutation, BulkDeleteTimeTrackingItemsMutationVariables>(BulkDeleteTimeTrackingItemsDocument, options);
      }
export type BulkDeleteTimeTrackingItemsMutationHookResult = ReturnType<typeof useBulkDeleteTimeTrackingItemsMutation>;
export type BulkDeleteTimeTrackingItemsMutationResult = ApolloReactCommon.MutationResult<BulkDeleteTimeTrackingItemsMutation>;
export type BulkDeleteTimeTrackingItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkDeleteTimeTrackingItemsMutation, BulkDeleteTimeTrackingItemsMutationVariables>;
export const UpdateTimeTrackingItemsBillableDocument = gql`
    mutation UpdateTimeTrackingItemsBillable($timeTrackingItemIds: [ID!]!, $billable: Boolean!) {
  updateTimeTrackingItemsBillable(
    time_tracking_item_ids: $timeTrackingItemIds
    billable: $billable
  ) {
    total
    successful
    failed
  }
}
    `;
export type UpdateTimeTrackingItemsBillableMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeTrackingItemsBillableMutation, UpdateTimeTrackingItemsBillableMutationVariables>;

/**
 * __useUpdateTimeTrackingItemsBillableMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingItemsBillableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingItemsBillableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingItemsBillableMutation, { data, loading, error }] = useUpdateTimeTrackingItemsBillableMutation({
 *   variables: {
 *      timeTrackingItemIds: // value for 'timeTrackingItemIds'
 *      billable: // value for 'billable'
 *   },
 * });
 */
export function useUpdateTimeTrackingItemsBillableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeTrackingItemsBillableMutation, UpdateTimeTrackingItemsBillableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeTrackingItemsBillableMutation, UpdateTimeTrackingItemsBillableMutationVariables>(UpdateTimeTrackingItemsBillableDocument, options);
      }
export type UpdateTimeTrackingItemsBillableMutationHookResult = ReturnType<typeof useUpdateTimeTrackingItemsBillableMutation>;
export type UpdateTimeTrackingItemsBillableMutationResult = ApolloReactCommon.MutationResult<UpdateTimeTrackingItemsBillableMutation>;
export type UpdateTimeTrackingItemsBillableMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeTrackingItemsBillableMutation, UpdateTimeTrackingItemsBillableMutationVariables>;
export const TimeTrackingReportSummaryDocument = gql`
    query TimeTrackingReportSummary($where: TimeTrackingReportsWhereConditions, $from: Date!, $to: Date!) {
  getTimeTrackingItemsSummary(from: $from, to: $to, where: $where) {
    ids
    tracked_time
  }
}
    `;

/**
 * __useTimeTrackingReportSummaryQuery__
 *
 * To run a query within a React component, call `useTimeTrackingReportSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingReportSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingReportSummaryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTimeTrackingReportSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables> & ({ variables: TimeTrackingReportSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>(TimeTrackingReportSummaryDocument, options);
      }
export function useTimeTrackingReportSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>(TimeTrackingReportSummaryDocument, options);
        }
export function useTimeTrackingReportSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>(TimeTrackingReportSummaryDocument, options);
        }
export type TimeTrackingReportSummaryQueryHookResult = ReturnType<typeof useTimeTrackingReportSummaryQuery>;
export type TimeTrackingReportSummaryLazyQueryHookResult = ReturnType<typeof useTimeTrackingReportSummaryLazyQuery>;
export type TimeTrackingReportSummarySuspenseQueryHookResult = ReturnType<typeof useTimeTrackingReportSummarySuspenseQuery>;
export type TimeTrackingReportSummaryQueryResult = ApolloReactCommon.QueryResult<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>;
export const TimeTrackingReportSelectedSummaryDocument = gql`
    query TimeTrackingReportSelectedSummary($where: TimeTrackingReportsWhereConditions, $from: Date!, $to: Date!) {
  getTimeTrackingItemsSummary(from: $from, to: $to, where: $where) {
    tracked_time
    invoiced_seconds
    overserviced_seconds
    uninvoiced_seconds
    amount
    invoiced_amount
    overserviced_amount
    uninvoiced_amount
  }
}
    `;

/**
 * __useTimeTrackingReportSelectedSummaryQuery__
 *
 * To run a query within a React component, call `useTimeTrackingReportSelectedSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingReportSelectedSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingReportSelectedSummaryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTimeTrackingReportSelectedSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables> & ({ variables: TimeTrackingReportSelectedSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>(TimeTrackingReportSelectedSummaryDocument, options);
      }
export function useTimeTrackingReportSelectedSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>(TimeTrackingReportSelectedSummaryDocument, options);
        }
export function useTimeTrackingReportSelectedSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>(TimeTrackingReportSelectedSummaryDocument, options);
        }
export type TimeTrackingReportSelectedSummaryQueryHookResult = ReturnType<typeof useTimeTrackingReportSelectedSummaryQuery>;
export type TimeTrackingReportSelectedSummaryLazyQueryHookResult = ReturnType<typeof useTimeTrackingReportSelectedSummaryLazyQuery>;
export type TimeTrackingReportSelectedSummarySuspenseQueryHookResult = ReturnType<typeof useTimeTrackingReportSelectedSummarySuspenseQuery>;
export type TimeTrackingReportSelectedSummaryQueryResult = ApolloReactCommon.QueryResult<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>;
export const TimeTrackingReportGroupedByDocument = gql`
    query TimeTrackingReportGroupedBy($groupBy: TimeTrackingReportGroupBy, $where: TimeTrackingReportsWhereConditions, $first: BigInt, $page: BigInt, $orderBy: [TimeTrackingItemOrderByClause!]) {
  timeTrackingReport(
    groupBy: $groupBy
    where: $where
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      groupBy
      trackedTime
      items {
        ...TimeTrackingReportItem
      }
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TimeTrackingReportItemFragmentDoc}`;

/**
 * __useTimeTrackingReportGroupedByQuery__
 *
 * To run a query within a React component, call `useTimeTrackingReportGroupedByQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingReportGroupedByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingReportGroupedByQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTimeTrackingReportGroupedByQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>(TimeTrackingReportGroupedByDocument, options);
      }
export function useTimeTrackingReportGroupedByLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>(TimeTrackingReportGroupedByDocument, options);
        }
export function useTimeTrackingReportGroupedBySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>(TimeTrackingReportGroupedByDocument, options);
        }
export type TimeTrackingReportGroupedByQueryHookResult = ReturnType<typeof useTimeTrackingReportGroupedByQuery>;
export type TimeTrackingReportGroupedByLazyQueryHookResult = ReturnType<typeof useTimeTrackingReportGroupedByLazyQuery>;
export type TimeTrackingReportGroupedBySuspenseQueryHookResult = ReturnType<typeof useTimeTrackingReportGroupedBySuspenseQuery>;
export type TimeTrackingReportGroupedByQueryResult = ApolloReactCommon.QueryResult<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>;
export const TimeTrackingUngroupedItemsDocument = gql`
    query TimeTrackingUngroupedItems($where: TimeTrackingReportsWhereConditions, $first: BigInt, $page: BigInt, $from: Date!, $to: Date!, $orderBy: [TimeTrackingItemOrderByClause!]) {
  getTimeTrackingItems(
    where: $where
    first: $first
    page: $page
    from: $from
    to: $to
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TimeTrackingReportItem
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TimeTrackingReportItemFragmentDoc}`;

/**
 * __useTimeTrackingUngroupedItemsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingUngroupedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingUngroupedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingUngroupedItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTimeTrackingUngroupedItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables> & ({ variables: TimeTrackingUngroupedItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>(TimeTrackingUngroupedItemsDocument, options);
      }
export function useTimeTrackingUngroupedItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>(TimeTrackingUngroupedItemsDocument, options);
        }
export function useTimeTrackingUngroupedItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>(TimeTrackingUngroupedItemsDocument, options);
        }
export type TimeTrackingUngroupedItemsQueryHookResult = ReturnType<typeof useTimeTrackingUngroupedItemsQuery>;
export type TimeTrackingUngroupedItemsLazyQueryHookResult = ReturnType<typeof useTimeTrackingUngroupedItemsLazyQuery>;
export type TimeTrackingUngroupedItemsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingUngroupedItemsSuspenseQuery>;
export type TimeTrackingUngroupedItemsQueryResult = ApolloReactCommon.QueryResult<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>;
export const TimeTrackingReportExportDocument = gql`
    query TimeTrackingReportExport($where: TimeTrackingReportsWhereConditions) {
  timeTrackingReportExport(where: $where)
}
    `;

/**
 * __useTimeTrackingReportExportQuery__
 *
 * To run a query within a React component, call `useTimeTrackingReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingReportExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTimeTrackingReportExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>(TimeTrackingReportExportDocument, options);
      }
export function useTimeTrackingReportExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>(TimeTrackingReportExportDocument, options);
        }
export function useTimeTrackingReportExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>(TimeTrackingReportExportDocument, options);
        }
export type TimeTrackingReportExportQueryHookResult = ReturnType<typeof useTimeTrackingReportExportQuery>;
export type TimeTrackingReportExportLazyQueryHookResult = ReturnType<typeof useTimeTrackingReportExportLazyQuery>;
export type TimeTrackingReportExportSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingReportExportSuspenseQuery>;
export type TimeTrackingReportExportQueryResult = ApolloReactCommon.QueryResult<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>;
export const TimeTrackingEffectivenessReportExportDocument = gql`
    query TimeTrackingEffectivenessReportExport($where: TimeTrackingReportsWhereConditions) {
  userEffectivenessReportExport(where: $where)
}
    `;

/**
 * __useTimeTrackingEffectivenessReportExportQuery__
 *
 * To run a query within a React component, call `useTimeTrackingEffectivenessReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingEffectivenessReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingEffectivenessReportExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTimeTrackingEffectivenessReportExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>(TimeTrackingEffectivenessReportExportDocument, options);
      }
export function useTimeTrackingEffectivenessReportExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>(TimeTrackingEffectivenessReportExportDocument, options);
        }
export function useTimeTrackingEffectivenessReportExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>(TimeTrackingEffectivenessReportExportDocument, options);
        }
export type TimeTrackingEffectivenessReportExportQueryHookResult = ReturnType<typeof useTimeTrackingEffectivenessReportExportQuery>;
export type TimeTrackingEffectivenessReportExportLazyQueryHookResult = ReturnType<typeof useTimeTrackingEffectivenessReportExportLazyQuery>;
export type TimeTrackingEffectivenessReportExportSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingEffectivenessReportExportSuspenseQuery>;
export type TimeTrackingEffectivenessReportExportQueryResult = ApolloReactCommon.QueryResult<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>;
export const TimeTrackingTimeOffsExportDocument = gql`
    query TimeTrackingTimeOffsExport($from: Date!, $to: Date!) {
  timeOffsExport(from: $from, to: $to)
}
    `;

/**
 * __useTimeTrackingTimeOffsExportQuery__
 *
 * To run a query within a React component, call `useTimeTrackingTimeOffsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingTimeOffsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingTimeOffsExportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTimeTrackingTimeOffsExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables> & ({ variables: TimeTrackingTimeOffsExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>(TimeTrackingTimeOffsExportDocument, options);
      }
export function useTimeTrackingTimeOffsExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>(TimeTrackingTimeOffsExportDocument, options);
        }
export function useTimeTrackingTimeOffsExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>(TimeTrackingTimeOffsExportDocument, options);
        }
export type TimeTrackingTimeOffsExportQueryHookResult = ReturnType<typeof useTimeTrackingTimeOffsExportQuery>;
export type TimeTrackingTimeOffsExportLazyQueryHookResult = ReturnType<typeof useTimeTrackingTimeOffsExportLazyQuery>;
export type TimeTrackingTimeOffsExportSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingTimeOffsExportSuspenseQuery>;
export type TimeTrackingTimeOffsExportQueryResult = ApolloReactCommon.QueryResult<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>;
export const TimeTrackingReportExportPdfDocument = gql`
    query TimeTrackingReportExportPdf($where: TimeTrackingReportsWhereConditions, $from: Date!, $to: Date!, $type: TimeTrackingReportExportType!) {
  timeTrackingReportExportPdf(
    where: $where
    date_from: $from
    date_to: $to
    report_type: $type
  )
}
    `;

/**
 * __useTimeTrackingReportExportPdfQuery__
 *
 * To run a query within a React component, call `useTimeTrackingReportExportPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingReportExportPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingReportExportPdfQuery({
 *   variables: {
 *      where: // value for 'where'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTimeTrackingReportExportPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables> & ({ variables: TimeTrackingReportExportPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>(TimeTrackingReportExportPdfDocument, options);
      }
export function useTimeTrackingReportExportPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>(TimeTrackingReportExportPdfDocument, options);
        }
export function useTimeTrackingReportExportPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>(TimeTrackingReportExportPdfDocument, options);
        }
export type TimeTrackingReportExportPdfQueryHookResult = ReturnType<typeof useTimeTrackingReportExportPdfQuery>;
export type TimeTrackingReportExportPdfLazyQueryHookResult = ReturnType<typeof useTimeTrackingReportExportPdfLazyQuery>;
export type TimeTrackingReportExportPdfSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingReportExportPdfSuspenseQuery>;
export type TimeTrackingReportExportPdfQueryResult = ApolloReactCommon.QueryResult<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>;
export const GetTasksSimpleMapOptionsDocument = gql`
    query GetTasksSimpleMapOptions($our_work_budget_item_id: [ID!], $parent_ids: [ID!]) {
  tasksSimpleMap(
    our_work_budget_item_id: $our_work_budget_item_id
    parent_ids: $parent_ids
  ) {
    id
    name
    parent {
      id
    }
  }
}
    `;

/**
 * __useGetTasksSimpleMapOptionsQuery__
 *
 * To run a query within a React component, call `useGetTasksSimpleMapOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksSimpleMapOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksSimpleMapOptionsQuery({
 *   variables: {
 *      our_work_budget_item_id: // value for 'our_work_budget_item_id'
 *      parent_ids: // value for 'parent_ids'
 *   },
 * });
 */
export function useGetTasksSimpleMapOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>(GetTasksSimpleMapOptionsDocument, options);
      }
export function useGetTasksSimpleMapOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>(GetTasksSimpleMapOptionsDocument, options);
        }
export function useGetTasksSimpleMapOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>(GetTasksSimpleMapOptionsDocument, options);
        }
export type GetTasksSimpleMapOptionsQueryHookResult = ReturnType<typeof useGetTasksSimpleMapOptionsQuery>;
export type GetTasksSimpleMapOptionsLazyQueryHookResult = ReturnType<typeof useGetTasksSimpleMapOptionsLazyQuery>;
export type GetTasksSimpleMapOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTasksSimpleMapOptionsSuspenseQuery>;
export type GetTasksSimpleMapOptionsQueryResult = ApolloReactCommon.QueryResult<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>;
export const GetOurWorkBudgetItemsSimpleMapOptionsDocument = gql`
    query GetOurWorkBudgetItemsSimpleMapOptions($project_id: [ID!]!) {
  ourWorkBudgetItemsSimpleMap(project_id: $project_id) {
    id
    title
    project {
      id
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    `;

/**
 * __useGetOurWorkBudgetItemsSimpleMapOptionsQuery__
 *
 * To run a query within a React component, call `useGetOurWorkBudgetItemsSimpleMapOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOurWorkBudgetItemsSimpleMapOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOurWorkBudgetItemsSimpleMapOptionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetOurWorkBudgetItemsSimpleMapOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables> & ({ variables: GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>(GetOurWorkBudgetItemsSimpleMapOptionsDocument, options);
      }
export function useGetOurWorkBudgetItemsSimpleMapOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>(GetOurWorkBudgetItemsSimpleMapOptionsDocument, options);
        }
export function useGetOurWorkBudgetItemsSimpleMapOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>(GetOurWorkBudgetItemsSimpleMapOptionsDocument, options);
        }
export type GetOurWorkBudgetItemsSimpleMapOptionsQueryHookResult = ReturnType<typeof useGetOurWorkBudgetItemsSimpleMapOptionsQuery>;
export type GetOurWorkBudgetItemsSimpleMapOptionsLazyQueryHookResult = ReturnType<typeof useGetOurWorkBudgetItemsSimpleMapOptionsLazyQuery>;
export type GetOurWorkBudgetItemsSimpleMapOptionsSuspenseQueryHookResult = ReturnType<typeof useGetOurWorkBudgetItemsSimpleMapOptionsSuspenseQuery>;
export type GetOurWorkBudgetItemsSimpleMapOptionsQueryResult = ApolloReactCommon.QueryResult<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>;
export const TimeTrackingReportOptionsDocument = gql`
    query TimeTrackingReportOptions($userSimpleWhere: UsersWhereConditions) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
  teamSimpleMap {
    id
    name
  }
  projectsSimpleMap(withArchived: true, withFinished: true) {
    id
    title
    code
    brand_id
    archived_at
    finished_at
  }
  userSimpleMap(withArchived: true, where: $userSimpleWhere) {
    id
    name
    full_name
    image {
      urls {
        thumbnail
      }
    }
    team_id
    codename
    archived_at
  }
  projectCategories {
    id
    name
  }
}
    `;

/**
 * __useTimeTrackingReportOptionsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingReportOptionsQuery({
 *   variables: {
 *      userSimpleWhere: // value for 'userSimpleWhere'
 *   },
 * });
 */
export function useTimeTrackingReportOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>(TimeTrackingReportOptionsDocument, options);
      }
export function useTimeTrackingReportOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>(TimeTrackingReportOptionsDocument, options);
        }
export function useTimeTrackingReportOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>(TimeTrackingReportOptionsDocument, options);
        }
export type TimeTrackingReportOptionsQueryHookResult = ReturnType<typeof useTimeTrackingReportOptionsQuery>;
export type TimeTrackingReportOptionsLazyQueryHookResult = ReturnType<typeof useTimeTrackingReportOptionsLazyQuery>;
export type TimeTrackingReportOptionsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingReportOptionsSuspenseQuery>;
export type TimeTrackingReportOptionsQueryResult = ApolloReactCommon.QueryResult<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>;
export const GetProjectsWithPositionsDocument = gql`
    query GetProjectsWithPositions($brandId: ID) {
  brand(id: $brandId) {
    projects {
      id
      code
      title
      availableTimeTrackingWorkTypes {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetProjectsWithPositionsQuery__
 *
 * To run a query within a React component, call `useGetProjectsWithPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsWithPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsWithPositionsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetProjectsWithPositionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>(GetProjectsWithPositionsDocument, options);
      }
export function useGetProjectsWithPositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>(GetProjectsWithPositionsDocument, options);
        }
export function useGetProjectsWithPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>(GetProjectsWithPositionsDocument, options);
        }
export type GetProjectsWithPositionsQueryHookResult = ReturnType<typeof useGetProjectsWithPositionsQuery>;
export type GetProjectsWithPositionsLazyQueryHookResult = ReturnType<typeof useGetProjectsWithPositionsLazyQuery>;
export type GetProjectsWithPositionsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsWithPositionsSuspenseQuery>;
export type GetProjectsWithPositionsQueryResult = ApolloReactCommon.QueryResult<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>;
export const AvailableWorkTypesForBulkMovingTimeTrackingItemsDocument = gql`
    query AvailableWorkTypesForBulkMovingTimeTrackingItems($itemIds: [ID!]!) {
  getAvailableWorkTypesForBulkMovingTimeTrackingItems(
    time_tracking_item_ids: $itemIds
  ) {
    id
    title
  }
}
    `;

/**
 * __useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery__
 *
 * To run a query within a React component, call `useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables> & ({ variables: AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>(AvailableWorkTypesForBulkMovingTimeTrackingItemsDocument, options);
      }
export function useAvailableWorkTypesForBulkMovingTimeTrackingItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>(AvailableWorkTypesForBulkMovingTimeTrackingItemsDocument, options);
        }
export function useAvailableWorkTypesForBulkMovingTimeTrackingItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>(AvailableWorkTypesForBulkMovingTimeTrackingItemsDocument, options);
        }
export type AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryHookResult = ReturnType<typeof useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery>;
export type AvailableWorkTypesForBulkMovingTimeTrackingItemsLazyQueryHookResult = ReturnType<typeof useAvailableWorkTypesForBulkMovingTimeTrackingItemsLazyQuery>;
export type AvailableWorkTypesForBulkMovingTimeTrackingItemsSuspenseQueryHookResult = ReturnType<typeof useAvailableWorkTypesForBulkMovingTimeTrackingItemsSuspenseQuery>;
export type AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryResult = ApolloReactCommon.QueryResult<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>;
export const TimeTrackingItemsWorkTypesDocument = gql`
    query TimeTrackingItemsWorkTypes($itemIds: [ID!]!) {
  timeTrackingItemsWorkTypes(time_tracking_item_ids: $itemIds) {
    id
    title
  }
}
    `;

/**
 * __useTimeTrackingItemsWorkTypesQuery__
 *
 * To run a query within a React component, call `useTimeTrackingItemsWorkTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingItemsWorkTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingItemsWorkTypesQuery({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useTimeTrackingItemsWorkTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables> & ({ variables: TimeTrackingItemsWorkTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>(TimeTrackingItemsWorkTypesDocument, options);
      }
export function useTimeTrackingItemsWorkTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>(TimeTrackingItemsWorkTypesDocument, options);
        }
export function useTimeTrackingItemsWorkTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>(TimeTrackingItemsWorkTypesDocument, options);
        }
export type TimeTrackingItemsWorkTypesQueryHookResult = ReturnType<typeof useTimeTrackingItemsWorkTypesQuery>;
export type TimeTrackingItemsWorkTypesLazyQueryHookResult = ReturnType<typeof useTimeTrackingItemsWorkTypesLazyQuery>;
export type TimeTrackingItemsWorkTypesSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingItemsWorkTypesSuspenseQuery>;
export type TimeTrackingItemsWorkTypesQueryResult = ApolloReactCommon.QueryResult<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>;
export const CheckTimeTrackingItemsLockedDocument = gql`
    query CheckTimeTrackingItemsLocked($itemIds: [ID!]!) {
  checkTimeTrackingItemsLocked(ids: $itemIds)
}
    `;

/**
 * __useCheckTimeTrackingItemsLockedQuery__
 *
 * To run a query within a React component, call `useCheckTimeTrackingItemsLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTimeTrackingItemsLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTimeTrackingItemsLockedQuery({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useCheckTimeTrackingItemsLockedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables> & ({ variables: CheckTimeTrackingItemsLockedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>(CheckTimeTrackingItemsLockedDocument, options);
      }
export function useCheckTimeTrackingItemsLockedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>(CheckTimeTrackingItemsLockedDocument, options);
        }
export function useCheckTimeTrackingItemsLockedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>(CheckTimeTrackingItemsLockedDocument, options);
        }
export type CheckTimeTrackingItemsLockedQueryHookResult = ReturnType<typeof useCheckTimeTrackingItemsLockedQuery>;
export type CheckTimeTrackingItemsLockedLazyQueryHookResult = ReturnType<typeof useCheckTimeTrackingItemsLockedLazyQuery>;
export type CheckTimeTrackingItemsLockedSuspenseQueryHookResult = ReturnType<typeof useCheckTimeTrackingItemsLockedSuspenseQuery>;
export type CheckTimeTrackingItemsLockedQueryResult = ApolloReactCommon.QueryResult<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>;
export const AddRowToWeekTimeReportDocument = gql`
    mutation AddRowToWeekTimeReport($task_id: ID!, $time_tracking_work_type_id: ID!, $user_id: ID) {
  addRowToWeekTimeReport(
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    user_id: $user_id
  ) {
    task {
      id
    }
  }
}
    `;
export type AddRowToWeekTimeReportMutationFn = ApolloReactCommon.MutationFunction<AddRowToWeekTimeReportMutation, AddRowToWeekTimeReportMutationVariables>;

/**
 * __useAddRowToWeekTimeReportMutation__
 *
 * To run a mutation, you first call `useAddRowToWeekTimeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRowToWeekTimeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRowToWeekTimeReportMutation, { data, loading, error }] = useAddRowToWeekTimeReportMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      time_tracking_work_type_id: // value for 'time_tracking_work_type_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAddRowToWeekTimeReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRowToWeekTimeReportMutation, AddRowToWeekTimeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddRowToWeekTimeReportMutation, AddRowToWeekTimeReportMutationVariables>(AddRowToWeekTimeReportDocument, options);
      }
export type AddRowToWeekTimeReportMutationHookResult = ReturnType<typeof useAddRowToWeekTimeReportMutation>;
export type AddRowToWeekTimeReportMutationResult = ApolloReactCommon.MutationResult<AddRowToWeekTimeReportMutation>;
export type AddRowToWeekTimeReportMutationOptions = ApolloReactCommon.BaseMutationOptions<AddRowToWeekTimeReportMutation, AddRowToWeekTimeReportMutationVariables>;
export const CreateOrUpdateTrackedTimeForDayDocument = gql`
    mutation CreateOrUpdateTrackedTimeForDay($task_id: ID!, $time_tracking_work_type_id: ID!, $user_id: ID, $tracked_for_date: Date!, $tracked_time: BigInt!) {
  createOrUpdateTrackedTimeForDay(
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    user_id: $user_id
    tracked_for_date: $tracked_for_date
    tracked_time: $tracked_time
  )
}
    `;
export type CreateOrUpdateTrackedTimeForDayMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateTrackedTimeForDayMutation, CreateOrUpdateTrackedTimeForDayMutationVariables>;

/**
 * __useCreateOrUpdateTrackedTimeForDayMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateTrackedTimeForDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateTrackedTimeForDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateTrackedTimeForDayMutation, { data, loading, error }] = useCreateOrUpdateTrackedTimeForDayMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      time_tracking_work_type_id: // value for 'time_tracking_work_type_id'
 *      user_id: // value for 'user_id'
 *      tracked_for_date: // value for 'tracked_for_date'
 *      tracked_time: // value for 'tracked_time'
 *   },
 * });
 */
export function useCreateOrUpdateTrackedTimeForDayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateTrackedTimeForDayMutation, CreateOrUpdateTrackedTimeForDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrUpdateTrackedTimeForDayMutation, CreateOrUpdateTrackedTimeForDayMutationVariables>(CreateOrUpdateTrackedTimeForDayDocument, options);
      }
export type CreateOrUpdateTrackedTimeForDayMutationHookResult = ReturnType<typeof useCreateOrUpdateTrackedTimeForDayMutation>;
export type CreateOrUpdateTrackedTimeForDayMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateTrackedTimeForDayMutation>;
export type CreateOrUpdateTrackedTimeForDayMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateTrackedTimeForDayMutation, CreateOrUpdateTrackedTimeForDayMutationVariables>;
export const CreateTimeTrackingItemDocument = gql`
    mutation CreateTimeTrackingItem($user_id: ID, $task_id: ID!, $tracked_for_date: Date!, $time_tracking_work_type_id: ID!, $tracked_time: BigInt, $capacity_allocation_item_id: ID, $note: String, $billable: Boolean, $specificTimeFrom: Time, $specificTimeTo: Time) {
  createTimeTrackingItem(
    user_id: $user_id
    task_id: $task_id
    tracked_for_date: $tracked_for_date
    time_tracking_work_type_id: $time_tracking_work_type_id
    tracked_time: $tracked_time
    capacity_allocation_item_id: $capacity_allocation_item_id
    note: $note
    billable: $billable
    specific_time_from: $specificTimeFrom
    specific_time_to: $specificTimeTo
  ) {
    id
  }
}
    `;
export type CreateTimeTrackingItemMutationFn = ApolloReactCommon.MutationFunction<CreateTimeTrackingItemMutation, CreateTimeTrackingItemMutationVariables>;

/**
 * __useCreateTimeTrackingItemMutation__
 *
 * To run a mutation, you first call `useCreateTimeTrackingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeTrackingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeTrackingItemMutation, { data, loading, error }] = useCreateTimeTrackingItemMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      task_id: // value for 'task_id'
 *      tracked_for_date: // value for 'tracked_for_date'
 *      time_tracking_work_type_id: // value for 'time_tracking_work_type_id'
 *      tracked_time: // value for 'tracked_time'
 *      capacity_allocation_item_id: // value for 'capacity_allocation_item_id'
 *      note: // value for 'note'
 *      billable: // value for 'billable'
 *      specificTimeFrom: // value for 'specificTimeFrom'
 *      specificTimeTo: // value for 'specificTimeTo'
 *   },
 * });
 */
export function useCreateTimeTrackingItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTimeTrackingItemMutation, CreateTimeTrackingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTimeTrackingItemMutation, CreateTimeTrackingItemMutationVariables>(CreateTimeTrackingItemDocument, options);
      }
export type CreateTimeTrackingItemMutationHookResult = ReturnType<typeof useCreateTimeTrackingItemMutation>;
export type CreateTimeTrackingItemMutationResult = ApolloReactCommon.MutationResult<CreateTimeTrackingItemMutation>;
export type CreateTimeTrackingItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTimeTrackingItemMutation, CreateTimeTrackingItemMutationVariables>;
export const DeleteTimeTrackingItemDocument = gql`
    mutation DeleteTimeTrackingItem($id: ID!) {
  deleteTimeTrackingItem(id: $id) {
    id
  }
}
    `;
export type DeleteTimeTrackingItemMutationFn = ApolloReactCommon.MutationFunction<DeleteTimeTrackingItemMutation, DeleteTimeTrackingItemMutationVariables>;

/**
 * __useDeleteTimeTrackingItemMutation__
 *
 * To run a mutation, you first call `useDeleteTimeTrackingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeTrackingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeTrackingItemMutation, { data, loading, error }] = useDeleteTimeTrackingItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeTrackingItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTimeTrackingItemMutation, DeleteTimeTrackingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTimeTrackingItemMutation, DeleteTimeTrackingItemMutationVariables>(DeleteTimeTrackingItemDocument, options);
      }
export type DeleteTimeTrackingItemMutationHookResult = ReturnType<typeof useDeleteTimeTrackingItemMutation>;
export type DeleteTimeTrackingItemMutationResult = ApolloReactCommon.MutationResult<DeleteTimeTrackingItemMutation>;
export type DeleteTimeTrackingItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTimeTrackingItemMutation, DeleteTimeTrackingItemMutationVariables>;
export const RemoveRowFromWeekTimeReportDocument = gql`
    mutation RemoveRowFromWeekTimeReport($task_id: ID!, $time_tracking_work_type_id: ID!, $user_id: ID, $first_date_of_week: Date!) {
  removeRowFromWeekTimeReport(
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    user_id: $user_id
    first_date_of_week: $first_date_of_week
  ) {
    task {
      id
    }
  }
}
    `;
export type RemoveRowFromWeekTimeReportMutationFn = ApolloReactCommon.MutationFunction<RemoveRowFromWeekTimeReportMutation, RemoveRowFromWeekTimeReportMutationVariables>;

/**
 * __useRemoveRowFromWeekTimeReportMutation__
 *
 * To run a mutation, you first call `useRemoveRowFromWeekTimeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRowFromWeekTimeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRowFromWeekTimeReportMutation, { data, loading, error }] = useRemoveRowFromWeekTimeReportMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      time_tracking_work_type_id: // value for 'time_tracking_work_type_id'
 *      user_id: // value for 'user_id'
 *      first_date_of_week: // value for 'first_date_of_week'
 *   },
 * });
 */
export function useRemoveRowFromWeekTimeReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveRowFromWeekTimeReportMutation, RemoveRowFromWeekTimeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveRowFromWeekTimeReportMutation, RemoveRowFromWeekTimeReportMutationVariables>(RemoveRowFromWeekTimeReportDocument, options);
      }
export type RemoveRowFromWeekTimeReportMutationHookResult = ReturnType<typeof useRemoveRowFromWeekTimeReportMutation>;
export type RemoveRowFromWeekTimeReportMutationResult = ApolloReactCommon.MutationResult<RemoveRowFromWeekTimeReportMutation>;
export type RemoveRowFromWeekTimeReportMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveRowFromWeekTimeReportMutation, RemoveRowFromWeekTimeReportMutationVariables>;
export const StartTimerDocument = gql`
    mutation StartTimer($time_tracking_item_id: ID!) {
  startTimer(time_tracking_item_id: $time_tracking_item_id)
}
    `;
export type StartTimerMutationFn = ApolloReactCommon.MutationFunction<StartTimerMutation, StartTimerMutationVariables>;

/**
 * __useStartTimerMutation__
 *
 * To run a mutation, you first call `useStartTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTimerMutation, { data, loading, error }] = useStartTimerMutation({
 *   variables: {
 *      time_tracking_item_id: // value for 'time_tracking_item_id'
 *   },
 * });
 */
export function useStartTimerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartTimerMutation, StartTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartTimerMutation, StartTimerMutationVariables>(StartTimerDocument, options);
      }
export type StartTimerMutationHookResult = ReturnType<typeof useStartTimerMutation>;
export type StartTimerMutationResult = ApolloReactCommon.MutationResult<StartTimerMutation>;
export type StartTimerMutationOptions = ApolloReactCommon.BaseMutationOptions<StartTimerMutation, StartTimerMutationVariables>;
export const StopTimerDocument = gql`
    mutation StopTimer($time_tracking_item_id: ID!) {
  stopTimer(time_tracking_item_id: $time_tracking_item_id)
}
    `;
export type StopTimerMutationFn = ApolloReactCommon.MutationFunction<StopTimerMutation, StopTimerMutationVariables>;

/**
 * __useStopTimerMutation__
 *
 * To run a mutation, you first call `useStopTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTimerMutation, { data, loading, error }] = useStopTimerMutation({
 *   variables: {
 *      time_tracking_item_id: // value for 'time_tracking_item_id'
 *   },
 * });
 */
export function useStopTimerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopTimerMutation, StopTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopTimerMutation, StopTimerMutationVariables>(StopTimerDocument, options);
      }
export type StopTimerMutationHookResult = ReturnType<typeof useStopTimerMutation>;
export type StopTimerMutationResult = ApolloReactCommon.MutationResult<StopTimerMutation>;
export type StopTimerMutationOptions = ApolloReactCommon.BaseMutationOptions<StopTimerMutation, StopTimerMutationVariables>;
export const UpdateTimeTrackingItemDocument = gql`
    mutation UpdateTimeTrackingItem($id: ID!, $task_id: ID!, $tracked_for_date: Date!, $time_tracking_work_type_id: ID!, $tracked_time: BigInt, $specificTimeFrom: Time, $specificTimeTo: Time, $note: String, $capacity_allocation_item_id: ID, $billable: Boolean) {
  updateTimeTrackingItem(
    id: $id
    task_id: $task_id
    tracked_for_date: $tracked_for_date
    time_tracking_work_type_id: $time_tracking_work_type_id
    tracked_time: $tracked_time
    specific_time_from: $specificTimeFrom
    specific_time_to: $specificTimeTo
    note: $note
    capacity_allocation_item_id: $capacity_allocation_item_id
    billable: $billable
  ) {
    id
  }
}
    `;
export type UpdateTimeTrackingItemMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeTrackingItemMutation, UpdateTimeTrackingItemMutationVariables>;

/**
 * __useUpdateTimeTrackingItemMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingItemMutation, { data, loading, error }] = useUpdateTimeTrackingItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      task_id: // value for 'task_id'
 *      tracked_for_date: // value for 'tracked_for_date'
 *      time_tracking_work_type_id: // value for 'time_tracking_work_type_id'
 *      tracked_time: // value for 'tracked_time'
 *      specificTimeFrom: // value for 'specificTimeFrom'
 *      specificTimeTo: // value for 'specificTimeTo'
 *      note: // value for 'note'
 *      capacity_allocation_item_id: // value for 'capacity_allocation_item_id'
 *      billable: // value for 'billable'
 *   },
 * });
 */
export function useUpdateTimeTrackingItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeTrackingItemMutation, UpdateTimeTrackingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeTrackingItemMutation, UpdateTimeTrackingItemMutationVariables>(UpdateTimeTrackingItemDocument, options);
      }
export type UpdateTimeTrackingItemMutationHookResult = ReturnType<typeof useUpdateTimeTrackingItemMutation>;
export type UpdateTimeTrackingItemMutationResult = ApolloReactCommon.MutationResult<UpdateTimeTrackingItemMutation>;
export type UpdateTimeTrackingItemMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeTrackingItemMutation, UpdateTimeTrackingItemMutationVariables>;
export const TimeTrackingBrandsDocument = gql`
    query TimeTrackingBrands {
  clientsSimpleMap {
    brands {
      ...BrandSimpleOptionParts
    }
  }
}
    ${BrandSimpleOptionPartsFragmentDoc}`;

/**
 * __useTimeTrackingBrandsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeTrackingBrandsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>(TimeTrackingBrandsDocument, options);
      }
export function useTimeTrackingBrandsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>(TimeTrackingBrandsDocument, options);
        }
export function useTimeTrackingBrandsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>(TimeTrackingBrandsDocument, options);
        }
export type TimeTrackingBrandsQueryHookResult = ReturnType<typeof useTimeTrackingBrandsQuery>;
export type TimeTrackingBrandsLazyQueryHookResult = ReturnType<typeof useTimeTrackingBrandsLazyQuery>;
export type TimeTrackingBrandsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingBrandsSuspenseQuery>;
export type TimeTrackingBrandsQueryResult = ApolloReactCommon.QueryResult<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>;
export const TimeTrackingItemDocument = gql`
    query TimeTrackingItem($id: ID!) {
  timeTrackingItem(id: $id) {
    ...TimeTrackingEntry
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

/**
 * __useTimeTrackingItemQuery__
 *
 * To run a query within a React component, call `useTimeTrackingItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeTrackingItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingItemQuery, TimeTrackingItemQueryVariables> & ({ variables: TimeTrackingItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>(TimeTrackingItemDocument, options);
      }
export function useTimeTrackingItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>(TimeTrackingItemDocument, options);
        }
export function useTimeTrackingItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>(TimeTrackingItemDocument, options);
        }
export type TimeTrackingItemQueryHookResult = ReturnType<typeof useTimeTrackingItemQuery>;
export type TimeTrackingItemLazyQueryHookResult = ReturnType<typeof useTimeTrackingItemLazyQuery>;
export type TimeTrackingItemSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingItemSuspenseQuery>;
export type TimeTrackingItemQueryResult = ApolloReactCommon.QueryResult<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>;
export const TimeTrackingItemsDocument = gql`
    query TimeTrackingItems($user_id: ID!, $from: Date!, $to: Date!) {
  timeTrackingSummaryPerDay(user_id: $user_id, from: $from, to: $to) {
    date
    tracked_time
    auto_stopped
  }
  timeTrackingItems(user_id: $user_id, from: $from, to: $to) {
    ...TimeTrackingEntry
  }
  runningTimer(user_id: $user_id) {
    id
    timeTrackingItem {
      id
      tracked_for_date
    }
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

/**
 * __useTimeTrackingItemsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingItemsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTimeTrackingItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables> & ({ variables: TimeTrackingItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>(TimeTrackingItemsDocument, options);
      }
export function useTimeTrackingItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>(TimeTrackingItemsDocument, options);
        }
export function useTimeTrackingItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>(TimeTrackingItemsDocument, options);
        }
export type TimeTrackingItemsQueryHookResult = ReturnType<typeof useTimeTrackingItemsQuery>;
export type TimeTrackingItemsLazyQueryHookResult = ReturnType<typeof useTimeTrackingItemsLazyQuery>;
export type TimeTrackingItemsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingItemsSuspenseQuery>;
export type TimeTrackingItemsQueryResult = ApolloReactCommon.QueryResult<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>;
export const TimeTrackingOptionsForProjectDocument = gql`
    query TimeTrackingOptionsForProject($id: ID!, $date: Date!) {
  timeTrackingOptionsForProject(project_id: $id, date: $date) {
    ourWork {
      id
      title
      timeTrackingSettings {
        id
        tracking_enabled
        tracking_enabled_from
        tracking_enabled_to
      }
      category {
        name
      }
      tasks {
        id
        name
        positions {
          timeTrackingWorkType {
            id
          }
          user {
            id
          }
        }
      }
    }
    availableTimeTrackingWorkTypes {
      id
      title
    }
  }
}
    `;

/**
 * __useTimeTrackingOptionsForProjectQuery__
 *
 * To run a query within a React component, call `useTimeTrackingOptionsForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingOptionsForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingOptionsForProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTimeTrackingOptionsForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables> & ({ variables: TimeTrackingOptionsForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>(TimeTrackingOptionsForProjectDocument, options);
      }
export function useTimeTrackingOptionsForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>(TimeTrackingOptionsForProjectDocument, options);
        }
export function useTimeTrackingOptionsForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>(TimeTrackingOptionsForProjectDocument, options);
        }
export type TimeTrackingOptionsForProjectQueryHookResult = ReturnType<typeof useTimeTrackingOptionsForProjectQuery>;
export type TimeTrackingOptionsForProjectLazyQueryHookResult = ReturnType<typeof useTimeTrackingOptionsForProjectLazyQuery>;
export type TimeTrackingOptionsForProjectSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingOptionsForProjectSuspenseQuery>;
export type TimeTrackingOptionsForProjectQueryResult = ApolloReactCommon.QueryResult<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>;
export const TimeTrackingProjectsDocument = gql`
    query TimeTrackingProjects($brandId: ID) {
  projectsSimpleMap(brand_id: $brandId) {
    ...ProjectSimpleOptionParts
    billable
  }
}
    ${ProjectSimpleOptionPartsFragmentDoc}`;

/**
 * __useTimeTrackingProjectsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingProjectsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useTimeTrackingProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>(TimeTrackingProjectsDocument, options);
      }
export function useTimeTrackingProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>(TimeTrackingProjectsDocument, options);
        }
export function useTimeTrackingProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>(TimeTrackingProjectsDocument, options);
        }
export type TimeTrackingProjectsQueryHookResult = ReturnType<typeof useTimeTrackingProjectsQuery>;
export type TimeTrackingProjectsLazyQueryHookResult = ReturnType<typeof useTimeTrackingProjectsLazyQuery>;
export type TimeTrackingProjectsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingProjectsSuspenseQuery>;
export type TimeTrackingProjectsQueryResult = ApolloReactCommon.QueryResult<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>;
export const TimeTrackingUsersDocument = gql`
    query TimeTrackingUsers {
  userSimpleMap {
    id
    codename
    image {
      urls {
        thumbnail
      }
    }
    full_name
    team_id
  }
}
    `;

/**
 * __useTimeTrackingUsersQuery__
 *
 * To run a query within a React component, call `useTimeTrackingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeTrackingUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>(TimeTrackingUsersDocument, options);
      }
export function useTimeTrackingUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>(TimeTrackingUsersDocument, options);
        }
export function useTimeTrackingUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>(TimeTrackingUsersDocument, options);
        }
export type TimeTrackingUsersQueryHookResult = ReturnType<typeof useTimeTrackingUsersQuery>;
export type TimeTrackingUsersLazyQueryHookResult = ReturnType<typeof useTimeTrackingUsersLazyQuery>;
export type TimeTrackingUsersSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingUsersSuspenseQuery>;
export type TimeTrackingUsersQueryResult = ApolloReactCommon.QueryResult<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>;
export const WeekTimeReportDocument = gql`
    query WeekTimeReport($user_id: ID!, $from: Date!) {
  weekTimeReport(user_id: $user_id, from: $from) {
    rows {
      task {
        id
        name
        billable
        ourWorkBudgetItem {
          id
          title
          project {
            id
            title
            code
            brand {
              id
              name
            }
          }
        }
      }
      timeTrackingWorkType {
        id
        title
      }
      trackedTime {
        date
        tracked_time
      }
    }
    dailyTotals {
      date
      total_tracked_time
    }
  }
}
    `;

/**
 * __useWeekTimeReportQuery__
 *
 * To run a query within a React component, call `useWeekTimeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeekTimeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeekTimeReportQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useWeekTimeReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeekTimeReportQuery, WeekTimeReportQueryVariables> & ({ variables: WeekTimeReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeekTimeReportQuery, WeekTimeReportQueryVariables>(WeekTimeReportDocument, options);
      }
export function useWeekTimeReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeekTimeReportQuery, WeekTimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeekTimeReportQuery, WeekTimeReportQueryVariables>(WeekTimeReportDocument, options);
        }
export function useWeekTimeReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeekTimeReportQuery, WeekTimeReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeekTimeReportQuery, WeekTimeReportQueryVariables>(WeekTimeReportDocument, options);
        }
export type WeekTimeReportQueryHookResult = ReturnType<typeof useWeekTimeReportQuery>;
export type WeekTimeReportLazyQueryHookResult = ReturnType<typeof useWeekTimeReportLazyQuery>;
export type WeekTimeReportSuspenseQueryHookResult = ReturnType<typeof useWeekTimeReportSuspenseQuery>;
export type WeekTimeReportQueryResult = ApolloReactCommon.QueryResult<WeekTimeReportQuery, WeekTimeReportQueryVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    id
  }
}
    `;
export type UpdatePasswordMutationFn = ApolloReactCommon.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = ApolloReactCommon.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($page: Int, $first: Int, $filters: UserQueryArgs) {
  roles {
    id
    name
  }
  teamSimpleMap {
    id
    name
  }
  brandsSimpleMap {
    id
    name
  }
  usersSummary(filters: $filters) {
    userIds
  }
  users(page: $page, first: $first, filters: $filters) {
    data {
      id
      scope {
        value
      }
      first_name
      last_name
      full_name
      codename
      image {
        urls {
          thumbnail
        }
      }
      brands {
        id
        name
      }
      email
      phone
      note
      archived_at
      PMActiveProjectsCount
      enabled_two_factor_authentication
      team {
        id
        name
      }
      roles {
        id
        name
      }
      profile {
        hex_color
        plannable
        defaultWorktype {
          id
          default_rate
          title
        }
      }
      permissions {
        user_haveProjectsAssigned
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = ApolloReactCommon.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const ProjectManagerOptionsForUsersDocument = gql`
    query ProjectManagerOptionsForUsers {
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
}
    `;

/**
 * __useProjectManagerOptionsForUsersQuery__
 *
 * To run a query within a React component, call `useProjectManagerOptionsForUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectManagerOptionsForUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectManagerOptionsForUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectManagerOptionsForUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>(ProjectManagerOptionsForUsersDocument, options);
      }
export function useProjectManagerOptionsForUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>(ProjectManagerOptionsForUsersDocument, options);
        }
export function useProjectManagerOptionsForUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>(ProjectManagerOptionsForUsersDocument, options);
        }
export type ProjectManagerOptionsForUsersQueryHookResult = ReturnType<typeof useProjectManagerOptionsForUsersQuery>;
export type ProjectManagerOptionsForUsersLazyQueryHookResult = ReturnType<typeof useProjectManagerOptionsForUsersLazyQuery>;
export type ProjectManagerOptionsForUsersSuspenseQueryHookResult = ReturnType<typeof useProjectManagerOptionsForUsersSuspenseQuery>;
export type ProjectManagerOptionsForUsersQueryResult = ApolloReactCommon.QueryResult<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    id
  }
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ScheduleUserArchivalDocument = gql`
    mutation ScheduleUserArchival($id: ID!, $date: Date, $project_manager_id: ID) {
  scheduleUserArchival(
    id: $id
    date: $date
    project_manager_id: $project_manager_id
  ) {
    id
  }
}
    `;
export type ScheduleUserArchivalMutationFn = ApolloReactCommon.MutationFunction<ScheduleUserArchivalMutation, ScheduleUserArchivalMutationVariables>;

/**
 * __useScheduleUserArchivalMutation__
 *
 * To run a mutation, you first call `useScheduleUserArchivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleUserArchivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleUserArchivalMutation, { data, loading, error }] = useScheduleUserArchivalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      project_manager_id: // value for 'project_manager_id'
 *   },
 * });
 */
export function useScheduleUserArchivalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleUserArchivalMutation, ScheduleUserArchivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleUserArchivalMutation, ScheduleUserArchivalMutationVariables>(ScheduleUserArchivalDocument, options);
      }
export type ScheduleUserArchivalMutationHookResult = ReturnType<typeof useScheduleUserArchivalMutation>;
export type ScheduleUserArchivalMutationResult = ApolloReactCommon.MutationResult<ScheduleUserArchivalMutation>;
export type ScheduleUserArchivalMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleUserArchivalMutation, ScheduleUserArchivalMutationVariables>;
export const ScheduleUserActivationDocument = gql`
    mutation ScheduleUserActivation($id: ID!, $date: Date) {
  scheduleUserActivation(id: $id, date: $date) {
    id
  }
}
    `;
export type ScheduleUserActivationMutationFn = ApolloReactCommon.MutationFunction<ScheduleUserActivationMutation, ScheduleUserActivationMutationVariables>;

/**
 * __useScheduleUserActivationMutation__
 *
 * To run a mutation, you first call `useScheduleUserActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleUserActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleUserActivationMutation, { data, loading, error }] = useScheduleUserActivationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useScheduleUserActivationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleUserActivationMutation, ScheduleUserActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleUserActivationMutation, ScheduleUserActivationMutationVariables>(ScheduleUserActivationDocument, options);
      }
export type ScheduleUserActivationMutationHookResult = ReturnType<typeof useScheduleUserActivationMutation>;
export type ScheduleUserActivationMutationResult = ApolloReactCommon.MutationResult<ScheduleUserActivationMutation>;
export type ScheduleUserActivationMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleUserActivationMutation, ScheduleUserActivationMutationVariables>;
export const ReassignActiveProjectsAndOwnedInvoicesDocument = gql`
    mutation ReassignActiveProjectsAndOwnedInvoices($fromUser: ID!, $toUser: ID!) {
  reassignActiveProjectsAndOwnedInvoices(
    from_user_id: $fromUser
    to_user_id: $toUser
  )
}
    `;
export type ReassignActiveProjectsAndOwnedInvoicesMutationFn = ApolloReactCommon.MutationFunction<ReassignActiveProjectsAndOwnedInvoicesMutation, ReassignActiveProjectsAndOwnedInvoicesMutationVariables>;

/**
 * __useReassignActiveProjectsAndOwnedInvoicesMutation__
 *
 * To run a mutation, you first call `useReassignActiveProjectsAndOwnedInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignActiveProjectsAndOwnedInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignActiveProjectsAndOwnedInvoicesMutation, { data, loading, error }] = useReassignActiveProjectsAndOwnedInvoicesMutation({
 *   variables: {
 *      fromUser: // value for 'fromUser'
 *      toUser: // value for 'toUser'
 *   },
 * });
 */
export function useReassignActiveProjectsAndOwnedInvoicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReassignActiveProjectsAndOwnedInvoicesMutation, ReassignActiveProjectsAndOwnedInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReassignActiveProjectsAndOwnedInvoicesMutation, ReassignActiveProjectsAndOwnedInvoicesMutationVariables>(ReassignActiveProjectsAndOwnedInvoicesDocument, options);
      }
export type ReassignActiveProjectsAndOwnedInvoicesMutationHookResult = ReturnType<typeof useReassignActiveProjectsAndOwnedInvoicesMutation>;
export type ReassignActiveProjectsAndOwnedInvoicesMutationResult = ApolloReactCommon.MutationResult<ReassignActiveProjectsAndOwnedInvoicesMutation>;
export type ReassignActiveProjectsAndOwnedInvoicesMutationOptions = ApolloReactCommon.BaseMutationOptions<ReassignActiveProjectsAndOwnedInvoicesMutation, ReassignActiveProjectsAndOwnedInvoicesMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(input: $input) {
    id
  }
}
    `;
export type UpdateUserPasswordMutationFn = ApolloReactCommon.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = ApolloReactCommon.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const GetScopedUserForEditDocument = gql`
    query GetScopedUserForEdit($id: ID!) {
  user(id: $id) {
    ...UserForEditBasic
    scope_access
    projects {
      id
      title
      code
    }
    tasks {
      id
      name
      status {
        name
        system_status
      }
    }
  }
}
    ${UserForEditBasicFragmentDoc}`;

/**
 * __useGetScopedUserForEditQuery__
 *
 * To run a query within a React component, call `useGetScopedUserForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopedUserForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopedUserForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScopedUserForEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables> & ({ variables: GetScopedUserForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>(GetScopedUserForEditDocument, options);
      }
export function useGetScopedUserForEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>(GetScopedUserForEditDocument, options);
        }
export function useGetScopedUserForEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>(GetScopedUserForEditDocument, options);
        }
export type GetScopedUserForEditQueryHookResult = ReturnType<typeof useGetScopedUserForEditQuery>;
export type GetScopedUserForEditLazyQueryHookResult = ReturnType<typeof useGetScopedUserForEditLazyQuery>;
export type GetScopedUserForEditSuspenseQueryHookResult = ReturnType<typeof useGetScopedUserForEditSuspenseQuery>;
export type GetScopedUserForEditQueryResult = ApolloReactCommon.QueryResult<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>;
export const GetUserForEditDocument = gql`
    query GetUserForEdit($id: ID!) {
  user(id: $id) {
    ...UserForEditBasic
    profile {
      hex_color
      plannable
      rates {
        id
        valid_from
        valid_to
        rate
      }
      planningRanges {
        id
        type {
          value
        }
        valid_from
        valid_to
        utilising
        weekly_capacities {
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
        daily_capacity
      }
      defaultWorktype {
        id
        default_rate
        title
      }
    }
  }
}
    ${UserForEditBasicFragmentDoc}`;

/**
 * __useGetUserForEditQuery__
 *
 * To run a query within a React component, call `useGetUserForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables> & ({ variables: GetUserForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserForEditQuery, GetUserForEditQueryVariables>(GetUserForEditDocument, options);
      }
export function useGetUserForEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserForEditQuery, GetUserForEditQueryVariables>(GetUserForEditDocument, options);
        }
export function useGetUserForEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserForEditQuery, GetUserForEditQueryVariables>(GetUserForEditDocument, options);
        }
export type GetUserForEditQueryHookResult = ReturnType<typeof useGetUserForEditQuery>;
export type GetUserForEditLazyQueryHookResult = ReturnType<typeof useGetUserForEditLazyQuery>;
export type GetUserForEditSuspenseQueryHookResult = ReturnType<typeof useGetUserForEditSuspenseQuery>;
export type GetUserForEditQueryResult = ApolloReactCommon.QueryResult<GetUserForEditQuery, GetUserForEditQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateScopedUserDocument = gql`
    mutation CreateScopedUser($input: CreateScopedUserInput!) {
  createScopedUser(input: $input) {
    id
  }
}
    `;
export type CreateScopedUserMutationFn = ApolloReactCommon.MutationFunction<CreateScopedUserMutation, CreateScopedUserMutationVariables>;

/**
 * __useCreateScopedUserMutation__
 *
 * To run a mutation, you first call `useCreateScopedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScopedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScopedUserMutation, { data, loading, error }] = useCreateScopedUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScopedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateScopedUserMutation, CreateScopedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateScopedUserMutation, CreateScopedUserMutationVariables>(CreateScopedUserDocument, options);
      }
export type CreateScopedUserMutationHookResult = ReturnType<typeof useCreateScopedUserMutation>;
export type CreateScopedUserMutationResult = ApolloReactCommon.MutationResult<CreateScopedUserMutation>;
export type CreateScopedUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateScopedUserMutation, CreateScopedUserMutationVariables>;
export const DisableTwoFactorAuthenticationDocument = gql`
    mutation DisableTwoFactorAuthentication($id: ID!) {
  disableTwoFactorAuthentication(id: $id) {
    id
    enabled_two_factor_authentication
  }
}
    `;
export type DisableTwoFactorAuthenticationMutationFn = ApolloReactCommon.MutationFunction<DisableTwoFactorAuthenticationMutation, DisableTwoFactorAuthenticationMutationVariables>;

/**
 * __useDisableTwoFactorAuthenticationMutation__
 *
 * To run a mutation, you first call `useDisableTwoFactorAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTwoFactorAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTwoFactorAuthenticationMutation, { data, loading, error }] = useDisableTwoFactorAuthenticationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableTwoFactorAuthenticationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableTwoFactorAuthenticationMutation, DisableTwoFactorAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableTwoFactorAuthenticationMutation, DisableTwoFactorAuthenticationMutationVariables>(DisableTwoFactorAuthenticationDocument, options);
      }
export type DisableTwoFactorAuthenticationMutationHookResult = ReturnType<typeof useDisableTwoFactorAuthenticationMutation>;
export type DisableTwoFactorAuthenticationMutationResult = ApolloReactCommon.MutationResult<DisableTwoFactorAuthenticationMutation>;
export type DisableTwoFactorAuthenticationMutationOptions = ApolloReactCommon.BaseMutationOptions<DisableTwoFactorAuthenticationMutation, DisableTwoFactorAuthenticationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const SetUserProfileRatesDocument = gql`
    mutation SetUserProfileRates($user_id: ID!, $rates: [UserProfileRateInput!]!) {
  setUserProfileRates(user_id: $user_id, rates: $rates) {
    rates {
      id
    }
  }
}
    `;
export type SetUserProfileRatesMutationFn = ApolloReactCommon.MutationFunction<SetUserProfileRatesMutation, SetUserProfileRatesMutationVariables>;

/**
 * __useSetUserProfileRatesMutation__
 *
 * To run a mutation, you first call `useSetUserProfileRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserProfileRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserProfileRatesMutation, { data, loading, error }] = useSetUserProfileRatesMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useSetUserProfileRatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserProfileRatesMutation, SetUserProfileRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserProfileRatesMutation, SetUserProfileRatesMutationVariables>(SetUserProfileRatesDocument, options);
      }
export type SetUserProfileRatesMutationHookResult = ReturnType<typeof useSetUserProfileRatesMutation>;
export type SetUserProfileRatesMutationResult = ApolloReactCommon.MutationResult<SetUserProfileRatesMutation>;
export type SetUserProfileRatesMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserProfileRatesMutation, SetUserProfileRatesMutationVariables>;
export const ConnectToMcpDocument = gql`
    mutation ConnectToMcp($input: ConnectToMcpInput!) {
  connectToMcp(input: $input) {
    status
    message
  }
}
    `;
export type ConnectToMcpMutationFn = ApolloReactCommon.MutationFunction<ConnectToMcpMutation, ConnectToMcpMutationVariables>;

/**
 * __useConnectToMcpMutation__
 *
 * To run a mutation, you first call `useConnectToMcpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectToMcpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectToMcpMutation, { data, loading, error }] = useConnectToMcpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectToMcpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectToMcpMutation, ConnectToMcpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectToMcpMutation, ConnectToMcpMutationVariables>(ConnectToMcpDocument, options);
      }
export type ConnectToMcpMutationHookResult = ReturnType<typeof useConnectToMcpMutation>;
export type ConnectToMcpMutationResult = ApolloReactCommon.MutationResult<ConnectToMcpMutation>;
export type ConnectToMcpMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectToMcpMutation, ConnectToMcpMutationVariables>;
export const DisconnectFromMcpDocument = gql`
    mutation DisconnectFromMcp($input: DisconnectFromMcpInput!) {
  disconnectFromMcp(input: $input) {
    status
    message
  }
}
    `;
export type DisconnectFromMcpMutationFn = ApolloReactCommon.MutationFunction<DisconnectFromMcpMutation, DisconnectFromMcpMutationVariables>;

/**
 * __useDisconnectFromMcpMutation__
 *
 * To run a mutation, you first call `useDisconnectFromMcpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectFromMcpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectFromMcpMutation, { data, loading, error }] = useDisconnectFromMcpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectFromMcpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectFromMcpMutation, DisconnectFromMcpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectFromMcpMutation, DisconnectFromMcpMutationVariables>(DisconnectFromMcpDocument, options);
      }
export type DisconnectFromMcpMutationHookResult = ReturnType<typeof useDisconnectFromMcpMutation>;
export type DisconnectFromMcpMutationResult = ApolloReactCommon.MutationResult<DisconnectFromMcpMutation>;
export type DisconnectFromMcpMutationOptions = ApolloReactCommon.BaseMutationOptions<DisconnectFromMcpMutation, DisconnectFromMcpMutationVariables>;
export const SetUserProfilePlanningRangesDocument = gql`
    mutation SetUserProfilePlanningRanges($user_id: ID!, $planningRanges: [PlanningRangeInput!]!) {
  setUserProfilePlanningRanges(user_id: $user_id, planningRanges: $planningRanges) {
    planningRanges {
      id
    }
  }
}
    `;
export type SetUserProfilePlanningRangesMutationFn = ApolloReactCommon.MutationFunction<SetUserProfilePlanningRangesMutation, SetUserProfilePlanningRangesMutationVariables>;

/**
 * __useSetUserProfilePlanningRangesMutation__
 *
 * To run a mutation, you first call `useSetUserProfilePlanningRangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserProfilePlanningRangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserProfilePlanningRangesMutation, { data, loading, error }] = useSetUserProfilePlanningRangesMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      planningRanges: // value for 'planningRanges'
 *   },
 * });
 */
export function useSetUserProfilePlanningRangesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserProfilePlanningRangesMutation, SetUserProfilePlanningRangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserProfilePlanningRangesMutation, SetUserProfilePlanningRangesMutationVariables>(SetUserProfilePlanningRangesDocument, options);
      }
export type SetUserProfilePlanningRangesMutationHookResult = ReturnType<typeof useSetUserProfilePlanningRangesMutation>;
export type SetUserProfilePlanningRangesMutationResult = ApolloReactCommon.MutationResult<SetUserProfilePlanningRangesMutation>;
export type SetUserProfilePlanningRangesMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserProfilePlanningRangesMutation, SetUserProfilePlanningRangesMutationVariables>;
export const GetNewSequenceNumberDocument = gql`
    query GetNewSequenceNumber($invoice_type: SequenceTypesEnum, $date: Date!, $workspace_company_id: ID!, $documentId: ID) {
  getNewInvoiceNumber(
    invoice_type: $invoice_type
    date: $date
    workspace_company_id: $workspace_company_id
    document_id: $documentId
  ) {
    id
    document_no
  }
}
    `;

/**
 * __useGetNewSequenceNumberQuery__
 *
 * To run a query within a React component, call `useGetNewSequenceNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewSequenceNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewSequenceNumberQuery({
 *   variables: {
 *      invoice_type: // value for 'invoice_type'
 *      date: // value for 'date'
 *      workspace_company_id: // value for 'workspace_company_id'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetNewSequenceNumberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables> & ({ variables: GetNewSequenceNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>(GetNewSequenceNumberDocument, options);
      }
export function useGetNewSequenceNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>(GetNewSequenceNumberDocument, options);
        }
export function useGetNewSequenceNumberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>(GetNewSequenceNumberDocument, options);
        }
export type GetNewSequenceNumberQueryHookResult = ReturnType<typeof useGetNewSequenceNumberQuery>;
export type GetNewSequenceNumberLazyQueryHookResult = ReturnType<typeof useGetNewSequenceNumberLazyQuery>;
export type GetNewSequenceNumberSuspenseQueryHookResult = ReturnType<typeof useGetNewSequenceNumberSuspenseQuery>;
export type GetNewSequenceNumberQueryResult = ApolloReactCommon.QueryResult<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>;
export const CheckSequenceNumberExistDocument = gql`
    query CheckSequenceNumberExist($document_no: String, $invoice_type: SequenceTypesEnum, $date: Date!, $document_id: ID, $invoice_order_sequence_id: ID!, $workspace_company_id: ID!) {
  checkInvoiceNumberExist(
    document_no: $document_no
    invoice_type: $invoice_type
    date: $date
    document_id: $document_id
    invoice_order_sequence_id: $invoice_order_sequence_id
    workspace_company_id: $workspace_company_id
  )
}
    `;

/**
 * __useCheckSequenceNumberExistQuery__
 *
 * To run a query within a React component, call `useCheckSequenceNumberExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSequenceNumberExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSequenceNumberExistQuery({
 *   variables: {
 *      document_no: // value for 'document_no'
 *      invoice_type: // value for 'invoice_type'
 *      date: // value for 'date'
 *      document_id: // value for 'document_id'
 *      invoice_order_sequence_id: // value for 'invoice_order_sequence_id'
 *      workspace_company_id: // value for 'workspace_company_id'
 *   },
 * });
 */
export function useCheckSequenceNumberExistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables> & ({ variables: CheckSequenceNumberExistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>(CheckSequenceNumberExistDocument, options);
      }
export function useCheckSequenceNumberExistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>(CheckSequenceNumberExistDocument, options);
        }
export function useCheckSequenceNumberExistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>(CheckSequenceNumberExistDocument, options);
        }
export type CheckSequenceNumberExistQueryHookResult = ReturnType<typeof useCheckSequenceNumberExistQuery>;
export type CheckSequenceNumberExistLazyQueryHookResult = ReturnType<typeof useCheckSequenceNumberExistLazyQuery>;
export type CheckSequenceNumberExistSuspenseQueryHookResult = ReturnType<typeof useCheckSequenceNumberExistSuspenseQuery>;
export type CheckSequenceNumberExistQueryResult = ApolloReactCommon.QueryResult<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>;
export const UpdateProjectCategoryDocument = gql`
    mutation UpdateProjectCategory($id: ID!, $name: String) {
  updateProjectCategory(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type UpdateProjectCategoryMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>;

/**
 * __useUpdateProjectCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectCategoryMutation, { data, loading, error }] = useUpdateProjectCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProjectCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>(UpdateProjectCategoryDocument, options);
      }
export type UpdateProjectCategoryMutationHookResult = ReturnType<typeof useUpdateProjectCategoryMutation>;
export type UpdateProjectCategoryMutationResult = ApolloReactCommon.MutationResult<UpdateProjectCategoryMutation>;
export type UpdateProjectCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>;
export const DeleteProjectCategoryDocument = gql`
    mutation DeleteProjectCategory($id: ID!) {
  deleteProjectCategory(id: $id) {
    id
  }
}
    `;
export type DeleteProjectCategoryMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>;

/**
 * __useDeleteProjectCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCategoryMutation, { data, loading, error }] = useDeleteProjectCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>(DeleteProjectCategoryDocument, options);
      }
export type DeleteProjectCategoryMutationHookResult = ReturnType<typeof useDeleteProjectCategoryMutation>;
export type DeleteProjectCategoryMutationResult = ApolloReactCommon.MutationResult<DeleteProjectCategoryMutation>;
export type DeleteProjectCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>;
export const CreateProjectCategoryDocument = gql`
    mutation CreateProjectCategory($name: String!) {
  createProjectCategory(name: $name) {
    id
    name
  }
}
    `;
export type CreateProjectCategoryMutationFn = ApolloReactCommon.MutationFunction<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>;

/**
 * __useCreateProjectCategoryMutation__
 *
 * To run a mutation, you first call `useCreateProjectCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectCategoryMutation, { data, loading, error }] = useCreateProjectCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProjectCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>(CreateProjectCategoryDocument, options);
      }
export type CreateProjectCategoryMutationHookResult = ReturnType<typeof useCreateProjectCategoryMutation>;
export type CreateProjectCategoryMutationResult = ApolloReactCommon.MutationResult<CreateProjectCategoryMutation>;
export type CreateProjectCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>;
export const GetProjectCategoriesDocument = gql`
    query GetProjectCategories {
  projectCategories {
    id
    name
  }
}
    `;

/**
 * __useGetProjectCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProjectCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>(GetProjectCategoriesDocument, options);
      }
export function useGetProjectCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>(GetProjectCategoriesDocument, options);
        }
export function useGetProjectCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>(GetProjectCategoriesDocument, options);
        }
export type GetProjectCategoriesQueryHookResult = ReturnType<typeof useGetProjectCategoriesQuery>;
export type GetProjectCategoriesLazyQueryHookResult = ReturnType<typeof useGetProjectCategoriesLazyQuery>;
export type GetProjectCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetProjectCategoriesSuspenseQuery>;
export type GetProjectCategoriesQueryResult = ApolloReactCommon.QueryResult<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>;
export const MarkTaskNotificationsAsUnreadDocument = gql`
    mutation MarkTaskNotificationsAsUnread($task_id: ID!) {
  markTaskAndCommunicationNotificationAsUnread(task_id: $task_id)
}
    `;
export type MarkTaskNotificationsAsUnreadMutationFn = ApolloReactCommon.MutationFunction<MarkTaskNotificationsAsUnreadMutation, MarkTaskNotificationsAsUnreadMutationVariables>;

/**
 * __useMarkTaskNotificationsAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkTaskNotificationsAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTaskNotificationsAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTaskNotificationsAsUnreadMutation, { data, loading, error }] = useMarkTaskNotificationsAsUnreadMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *   },
 * });
 */
export function useMarkTaskNotificationsAsUnreadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkTaskNotificationsAsUnreadMutation, MarkTaskNotificationsAsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkTaskNotificationsAsUnreadMutation, MarkTaskNotificationsAsUnreadMutationVariables>(MarkTaskNotificationsAsUnreadDocument, options);
      }
export type MarkTaskNotificationsAsUnreadMutationHookResult = ReturnType<typeof useMarkTaskNotificationsAsUnreadMutation>;
export type MarkTaskNotificationsAsUnreadMutationResult = ApolloReactCommon.MutationResult<MarkTaskNotificationsAsUnreadMutation>;
export type MarkTaskNotificationsAsUnreadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkTaskNotificationsAsUnreadMutation, MarkTaskNotificationsAsUnreadMutationVariables>;
export const UpdateTaskScopesDocument = gql`
    mutation UpdateTaskScopes($input: UpdateTaskInput!) {
  updateTask(input: $input, propagate_billable: false) {
    id
  }
}
    `;
export type UpdateTaskScopesMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskScopesMutation, UpdateTaskScopesMutationVariables>;

/**
 * __useUpdateTaskScopesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskScopesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskScopesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskScopesMutation, { data, loading, error }] = useUpdateTaskScopesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskScopesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskScopesMutation, UpdateTaskScopesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskScopesMutation, UpdateTaskScopesMutationVariables>(UpdateTaskScopesDocument, options);
      }
export type UpdateTaskScopesMutationHookResult = ReturnType<typeof useUpdateTaskScopesMutation>;
export type UpdateTaskScopesMutationResult = ApolloReactCommon.MutationResult<UpdateTaskScopesMutation>;
export type UpdateTaskScopesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskScopesMutation, UpdateTaskScopesMutationVariables>;
export const UpdateProjectScopesDocument = gql`
    mutation UpdateProjectScopes($input: UpdateProjectInput!) {
  updateProject(input: $input, propagate_billable: false) {
    id
  }
}
    `;
export type UpdateProjectScopesMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectScopesMutation, UpdateProjectScopesMutationVariables>;

/**
 * __useUpdateProjectScopesMutation__
 *
 * To run a mutation, you first call `useUpdateProjectScopesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectScopesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectScopesMutation, { data, loading, error }] = useUpdateProjectScopesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectScopesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectScopesMutation, UpdateProjectScopesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectScopesMutation, UpdateProjectScopesMutationVariables>(UpdateProjectScopesDocument, options);
      }
export type UpdateProjectScopesMutationHookResult = ReturnType<typeof useUpdateProjectScopesMutation>;
export type UpdateProjectScopesMutationResult = ApolloReactCommon.MutationResult<UpdateProjectScopesMutation>;
export type UpdateProjectScopesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectScopesMutation, UpdateProjectScopesMutationVariables>;
export const CreateAssignableFileDocument = gql`
    mutation CreateAssignableFile($file: Upload!) {
  createAssignableFile(file: $file) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;
export type CreateAssignableFileMutationFn = ApolloReactCommon.MutationFunction<CreateAssignableFileMutation, CreateAssignableFileMutationVariables>;

/**
 * __useCreateAssignableFileMutation__
 *
 * To run a mutation, you first call `useCreateAssignableFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignableFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignableFileMutation, { data, loading, error }] = useCreateAssignableFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateAssignableFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAssignableFileMutation, CreateAssignableFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAssignableFileMutation, CreateAssignableFileMutationVariables>(CreateAssignableFileDocument, options);
      }
export type CreateAssignableFileMutationHookResult = ReturnType<typeof useCreateAssignableFileMutation>;
export type CreateAssignableFileMutationResult = ApolloReactCommon.MutationResult<CreateAssignableFileMutation>;
export type CreateAssignableFileMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAssignableFileMutation, CreateAssignableFileMutationVariables>;
export const UsersSimpleMapDocument = gql`
    query UsersSimpleMap($search: String, $allowedScopes: Mixed, $taskId: ID, $mentions: Boolean) {
  userSimpleMap(
    search: $search
    where: {column: SCOPE, value: $allowedScopes, operator: IN}
    task_id: $taskId
    mentions: $mentions
  ) {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;

/**
 * __useUsersSimpleMapQuery__
 *
 * To run a query within a React component, call `useUsersSimpleMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSimpleMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSimpleMapQuery({
 *   variables: {
 *      search: // value for 'search'
 *      allowedScopes: // value for 'allowedScopes'
 *      taskId: // value for 'taskId'
 *      mentions: // value for 'mentions'
 *   },
 * });
 */
export function useUsersSimpleMapQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>(UsersSimpleMapDocument, options);
      }
export function useUsersSimpleMapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>(UsersSimpleMapDocument, options);
        }
export function useUsersSimpleMapSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>(UsersSimpleMapDocument, options);
        }
export type UsersSimpleMapQueryHookResult = ReturnType<typeof useUsersSimpleMapQuery>;
export type UsersSimpleMapLazyQueryHookResult = ReturnType<typeof useUsersSimpleMapLazyQuery>;
export type UsersSimpleMapSuspenseQueryHookResult = ReturnType<typeof useUsersSimpleMapSuspenseQuery>;
export type UsersSimpleMapQueryResult = ApolloReactCommon.QueryResult<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>;
export const GetDefaultUserMentionsDocument = gql`
    query GetDefaultUserMentions($where: UsersWhereConditions, $taskId: ID) {
  userSimpleMap(where: $where, task_id: $taskId, mentions: true) {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;

/**
 * __useGetDefaultUserMentionsQuery__
 *
 * To run a query within a React component, call `useGetDefaultUserMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultUserMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultUserMentionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetDefaultUserMentionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>(GetDefaultUserMentionsDocument, options);
      }
export function useGetDefaultUserMentionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>(GetDefaultUserMentionsDocument, options);
        }
export function useGetDefaultUserMentionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>(GetDefaultUserMentionsDocument, options);
        }
export type GetDefaultUserMentionsQueryHookResult = ReturnType<typeof useGetDefaultUserMentionsQuery>;
export type GetDefaultUserMentionsLazyQueryHookResult = ReturnType<typeof useGetDefaultUserMentionsLazyQuery>;
export type GetDefaultUserMentionsSuspenseQueryHookResult = ReturnType<typeof useGetDefaultUserMentionsSuspenseQuery>;
export type GetDefaultUserMentionsQueryResult = ApolloReactCommon.QueryResult<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>;
export const UsersAllocatedTimeDocument = gql`
    query UsersAllocatedTime($from: Date!, $to: Date!, $types: [CapacityAllocationTypeEnum!]!, $user_ids: [ID!]!) {
  GetUsersAllocatedTime(from: $from, to: $to, types: $types, user_ids: $user_ids) {
    user_id
    dates {
      date
      planned_capacity
      data {
        from_time
        to_time
        type
        value
      }
    }
  }
}
    `;

/**
 * __useUsersAllocatedTimeQuery__
 *
 * To run a query within a React component, call `useUsersAllocatedTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersAllocatedTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersAllocatedTimeQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      types: // value for 'types'
 *      user_ids: // value for 'user_ids'
 *   },
 * });
 */
export function useUsersAllocatedTimeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables> & ({ variables: UsersAllocatedTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>(UsersAllocatedTimeDocument, options);
      }
export function useUsersAllocatedTimeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>(UsersAllocatedTimeDocument, options);
        }
export function useUsersAllocatedTimeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>(UsersAllocatedTimeDocument, options);
        }
export type UsersAllocatedTimeQueryHookResult = ReturnType<typeof useUsersAllocatedTimeQuery>;
export type UsersAllocatedTimeLazyQueryHookResult = ReturnType<typeof useUsersAllocatedTimeLazyQuery>;
export type UsersAllocatedTimeSuspenseQueryHookResult = ReturnType<typeof useUsersAllocatedTimeSuspenseQuery>;
export type UsersAllocatedTimeQueryResult = ApolloReactCommon.QueryResult<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>;
export const CheckForAllocationConflictsDocument = gql`
    query CheckForAllocationConflicts($from: Date!, $to: Date!, $user_ids: [ID!]!, $from_time: Time, $to_time: Time, $types: [CapacityAllocationTypeEnum!]!, $repetition_settings: [RepetitionSettingsDaysEnum]) {
  GetUsersAllocationConflicts(
    from: $from
    to: $to
    user_ids: $user_ids
    from_time: $from_time
    to_time: $to_time
    types: $types
    repetition_settings: $repetition_settings
  ) {
    user_id
    conflict
  }
}
    `;

/**
 * __useCheckForAllocationConflictsQuery__
 *
 * To run a query within a React component, call `useCheckForAllocationConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForAllocationConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForAllocationConflictsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      user_ids: // value for 'user_ids'
 *      from_time: // value for 'from_time'
 *      to_time: // value for 'to_time'
 *      types: // value for 'types'
 *      repetition_settings: // value for 'repetition_settings'
 *   },
 * });
 */
export function useCheckForAllocationConflictsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables> & ({ variables: CheckForAllocationConflictsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>(CheckForAllocationConflictsDocument, options);
      }
export function useCheckForAllocationConflictsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>(CheckForAllocationConflictsDocument, options);
        }
export function useCheckForAllocationConflictsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>(CheckForAllocationConflictsDocument, options);
        }
export type CheckForAllocationConflictsQueryHookResult = ReturnType<typeof useCheckForAllocationConflictsQuery>;
export type CheckForAllocationConflictsLazyQueryHookResult = ReturnType<typeof useCheckForAllocationConflictsLazyQuery>;
export type CheckForAllocationConflictsSuspenseQueryHookResult = ReturnType<typeof useCheckForAllocationConflictsSuspenseQuery>;
export type CheckForAllocationConflictsQueryResult = ApolloReactCommon.QueryResult<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>;
export const BrandForNavigationDocument = gql`
    query BrandForNavigation($id: ID!) {
  brand(id: $id) {
    id
    name
    code
  }
}
    `;

/**
 * __useBrandForNavigationQuery__
 *
 * To run a query within a React component, call `useBrandForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandForNavigationQuery, BrandForNavigationQueryVariables> & ({ variables: BrandForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandForNavigationQuery, BrandForNavigationQueryVariables>(BrandForNavigationDocument, options);
      }
export function useBrandForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandForNavigationQuery, BrandForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandForNavigationQuery, BrandForNavigationQueryVariables>(BrandForNavigationDocument, options);
        }
export function useBrandForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandForNavigationQuery, BrandForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandForNavigationQuery, BrandForNavigationQueryVariables>(BrandForNavigationDocument, options);
        }
export type BrandForNavigationQueryHookResult = ReturnType<typeof useBrandForNavigationQuery>;
export type BrandForNavigationLazyQueryHookResult = ReturnType<typeof useBrandForNavigationLazyQuery>;
export type BrandForNavigationSuspenseQueryHookResult = ReturnType<typeof useBrandForNavigationSuspenseQuery>;
export type BrandForNavigationQueryResult = ApolloReactCommon.QueryResult<BrandForNavigationQuery, BrandForNavigationQueryVariables>;
export const GetSubmittedRfiCountDocument = gql`
    query GetSubmittedRfiCount {
  getSubmittedRfiCount
}
    `;

/**
 * __useGetSubmittedRfiCountQuery__
 *
 * To run a query within a React component, call `useGetSubmittedRfiCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmittedRfiCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmittedRfiCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmittedRfiCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>(GetSubmittedRfiCountDocument, options);
      }
export function useGetSubmittedRfiCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>(GetSubmittedRfiCountDocument, options);
        }
export function useGetSubmittedRfiCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>(GetSubmittedRfiCountDocument, options);
        }
export type GetSubmittedRfiCountQueryHookResult = ReturnType<typeof useGetSubmittedRfiCountQuery>;
export type GetSubmittedRfiCountLazyQueryHookResult = ReturnType<typeof useGetSubmittedRfiCountLazyQuery>;
export type GetSubmittedRfiCountSuspenseQueryHookResult = ReturnType<typeof useGetSubmittedRfiCountSuspenseQuery>;
export type GetSubmittedRfiCountQueryResult = ApolloReactCommon.QueryResult<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>;
export const ProjectForNavigationDocument = gql`
    query ProjectForNavigation($id: ID!) {
  project(id: $id) {
    id
    title
    code
    finished_at
    uses_budgetovac
    type
    is_template
  }
}
    `;

/**
 * __useProjectForNavigationQuery__
 *
 * To run a query within a React component, call `useProjectForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectForNavigationQuery, ProjectForNavigationQueryVariables> & ({ variables: ProjectForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>(ProjectForNavigationDocument, options);
      }
export function useProjectForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>(ProjectForNavigationDocument, options);
        }
export function useProjectForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>(ProjectForNavigationDocument, options);
        }
export type ProjectForNavigationQueryHookResult = ReturnType<typeof useProjectForNavigationQuery>;
export type ProjectForNavigationLazyQueryHookResult = ReturnType<typeof useProjectForNavigationLazyQuery>;
export type ProjectForNavigationSuspenseQueryHookResult = ReturnType<typeof useProjectForNavigationSuspenseQuery>;
export type ProjectForNavigationQueryResult = ApolloReactCommon.QueryResult<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>;
export const ContractorForNavigationDocument = gql`
    query ContractorForNavigation($id: ID!) {
  contractor(id: $id) {
    id
    legal_name
  }
}
    `;

/**
 * __useContractorForNavigationQuery__
 *
 * To run a query within a React component, call `useContractorForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractorForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContractorForNavigationQuery, ContractorForNavigationQueryVariables> & ({ variables: ContractorForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>(ContractorForNavigationDocument, options);
      }
export function useContractorForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>(ContractorForNavigationDocument, options);
        }
export function useContractorForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>(ContractorForNavigationDocument, options);
        }
export type ContractorForNavigationQueryHookResult = ReturnType<typeof useContractorForNavigationQuery>;
export type ContractorForNavigationLazyQueryHookResult = ReturnType<typeof useContractorForNavigationLazyQuery>;
export type ContractorForNavigationSuspenseQueryHookResult = ReturnType<typeof useContractorForNavigationSuspenseQuery>;
export type ContractorForNavigationQueryResult = ApolloReactCommon.QueryResult<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>;
export const CreditAccountForNavigationDocument = gql`
    query CreditAccountForNavigation($id: ID!) {
  brandCreditAccount(id: $id) {
    id
    title
  }
}
    `;

/**
 * __useCreditAccountForNavigationQuery__
 *
 * To run a query within a React component, call `useCreditAccountForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditAccountForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditAccountForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditAccountForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables> & ({ variables: CreditAccountForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>(CreditAccountForNavigationDocument, options);
      }
export function useCreditAccountForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>(CreditAccountForNavigationDocument, options);
        }
export function useCreditAccountForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>(CreditAccountForNavigationDocument, options);
        }
export type CreditAccountForNavigationQueryHookResult = ReturnType<typeof useCreditAccountForNavigationQuery>;
export type CreditAccountForNavigationLazyQueryHookResult = ReturnType<typeof useCreditAccountForNavigationLazyQuery>;
export type CreditAccountForNavigationSuspenseQueryHookResult = ReturnType<typeof useCreditAccountForNavigationSuspenseQuery>;
export type CreditAccountForNavigationQueryResult = ApolloReactCommon.QueryResult<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>;
export const ExpenseForNavigationDocument = gql`
    query ExpenseForNavigation($id: ID!) {
  expense(id: $id) {
    id
    expense_no
    is_draft
  }
}
    `;

/**
 * __useExpenseForNavigationQuery__
 *
 * To run a query within a React component, call `useExpenseForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpenseForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables> & ({ variables: ExpenseForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>(ExpenseForNavigationDocument, options);
      }
export function useExpenseForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>(ExpenseForNavigationDocument, options);
        }
export function useExpenseForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>(ExpenseForNavigationDocument, options);
        }
export type ExpenseForNavigationQueryHookResult = ReturnType<typeof useExpenseForNavigationQuery>;
export type ExpenseForNavigationLazyQueryHookResult = ReturnType<typeof useExpenseForNavigationLazyQuery>;
export type ExpenseForNavigationSuspenseQueryHookResult = ReturnType<typeof useExpenseForNavigationSuspenseQuery>;
export type ExpenseForNavigationQueryResult = ApolloReactCommon.QueryResult<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>;
export const OutgoingInvoiceForNavigationDocument = gql`
    query OutgoingInvoiceForNavigation($id: ID!) {
  outgoingInvoice(id: $id) {
    id
    invoice_no
    type
  }
}
    `;

/**
 * __useOutgoingInvoiceForNavigationQuery__
 *
 * To run a query within a React component, call `useOutgoingInvoiceForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingInvoiceForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingInvoiceForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOutgoingInvoiceForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables> & ({ variables: OutgoingInvoiceForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>(OutgoingInvoiceForNavigationDocument, options);
      }
export function useOutgoingInvoiceForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>(OutgoingInvoiceForNavigationDocument, options);
        }
export function useOutgoingInvoiceForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>(OutgoingInvoiceForNavigationDocument, options);
        }
export type OutgoingInvoiceForNavigationQueryHookResult = ReturnType<typeof useOutgoingInvoiceForNavigationQuery>;
export type OutgoingInvoiceForNavigationLazyQueryHookResult = ReturnType<typeof useOutgoingInvoiceForNavigationLazyQuery>;
export type OutgoingInvoiceForNavigationSuspenseQueryHookResult = ReturnType<typeof useOutgoingInvoiceForNavigationSuspenseQuery>;
export type OutgoingInvoiceForNavigationQueryResult = ApolloReactCommon.QueryResult<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>;
export const ProformaInvoiceForNavigationDocument = gql`
    query ProformaInvoiceForNavigation($id: ID!) {
  outgoingProformaInvoice(id: $id) {
    id
    invoice_no
  }
}
    `;

/**
 * __useProformaInvoiceForNavigationQuery__
 *
 * To run a query within a React component, call `useProformaInvoiceForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoiceForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaInvoiceForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProformaInvoiceForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables> & ({ variables: ProformaInvoiceForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>(ProformaInvoiceForNavigationDocument, options);
      }
export function useProformaInvoiceForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>(ProformaInvoiceForNavigationDocument, options);
        }
export function useProformaInvoiceForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>(ProformaInvoiceForNavigationDocument, options);
        }
export type ProformaInvoiceForNavigationQueryHookResult = ReturnType<typeof useProformaInvoiceForNavigationQuery>;
export type ProformaInvoiceForNavigationLazyQueryHookResult = ReturnType<typeof useProformaInvoiceForNavigationLazyQuery>;
export type ProformaInvoiceForNavigationSuspenseQueryHookResult = ReturnType<typeof useProformaInvoiceForNavigationSuspenseQuery>;
export type ProformaInvoiceForNavigationQueryResult = ApolloReactCommon.QueryResult<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>;
export const GetRequestForInvoicingTypeDocument = gql`
    query GetRequestForInvoicingType($id: ID!) {
  requestForInvoicing(id: $id) {
    id
    type
  }
}
    `;

/**
 * __useGetRequestForInvoicingTypeQuery__
 *
 * To run a query within a React component, call `useGetRequestForInvoicingTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestForInvoicingTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestForInvoicingTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequestForInvoicingTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables> & ({ variables: GetRequestForInvoicingTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>(GetRequestForInvoicingTypeDocument, options);
      }
export function useGetRequestForInvoicingTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>(GetRequestForInvoicingTypeDocument, options);
        }
export function useGetRequestForInvoicingTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>(GetRequestForInvoicingTypeDocument, options);
        }
export type GetRequestForInvoicingTypeQueryHookResult = ReturnType<typeof useGetRequestForInvoicingTypeQuery>;
export type GetRequestForInvoicingTypeLazyQueryHookResult = ReturnType<typeof useGetRequestForInvoicingTypeLazyQuery>;
export type GetRequestForInvoicingTypeSuspenseQueryHookResult = ReturnType<typeof useGetRequestForInvoicingTypeSuspenseQuery>;
export type GetRequestForInvoicingTypeQueryResult = ApolloReactCommon.QueryResult<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>;
export const QuoteForNavigationDocument = gql`
    query QuoteForNavigation($id: ID!) {
  GetQuote(id: $id) {
    id
    number
  }
}
    `;

/**
 * __useQuoteForNavigationQuery__
 *
 * To run a query within a React component, call `useQuoteForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteForNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteForNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuoteForNavigationQuery, QuoteForNavigationQueryVariables> & ({ variables: QuoteForNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>(QuoteForNavigationDocument, options);
      }
export function useQuoteForNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>(QuoteForNavigationDocument, options);
        }
export function useQuoteForNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>(QuoteForNavigationDocument, options);
        }
export type QuoteForNavigationQueryHookResult = ReturnType<typeof useQuoteForNavigationQuery>;
export type QuoteForNavigationLazyQueryHookResult = ReturnType<typeof useQuoteForNavigationLazyQuery>;
export type QuoteForNavigationSuspenseQueryHookResult = ReturnType<typeof useQuoteForNavigationSuspenseQuery>;
export type QuoteForNavigationQueryResult = ApolloReactCommon.QueryResult<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>;
export const AccessTokenForBudgetovacDocument = gql`
    query AccessTokenForBudgetovac($appName: ThirdPartyEnum = BUDGETOVAC) {
  getAccessTokenForThirdParty(appName: $appName)
}
    `;

/**
 * __useAccessTokenForBudgetovacQuery__
 *
 * To run a query within a React component, call `useAccessTokenForBudgetovacQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessTokenForBudgetovacQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessTokenForBudgetovacQuery({
 *   variables: {
 *      appName: // value for 'appName'
 *   },
 * });
 */
export function useAccessTokenForBudgetovacQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>(AccessTokenForBudgetovacDocument, options);
      }
export function useAccessTokenForBudgetovacLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>(AccessTokenForBudgetovacDocument, options);
        }
export function useAccessTokenForBudgetovacSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>(AccessTokenForBudgetovacDocument, options);
        }
export type AccessTokenForBudgetovacQueryHookResult = ReturnType<typeof useAccessTokenForBudgetovacQuery>;
export type AccessTokenForBudgetovacLazyQueryHookResult = ReturnType<typeof useAccessTokenForBudgetovacLazyQuery>;
export type AccessTokenForBudgetovacSuspenseQueryHookResult = ReturnType<typeof useAccessTokenForBudgetovacSuspenseQuery>;
export type AccessTokenForBudgetovacQueryResult = ApolloReactCommon.QueryResult<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>;
export const RunningTimerDocument = gql`
    query RunningTimer($user_id: ID!) {
  runningTimer(user_id: $user_id) {
    id
    timeTrackingItem {
      ...TimeTrackingEntry
    }
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

/**
 * __useRunningTimerQuery__
 *
 * To run a query within a React component, call `useRunningTimerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunningTimerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunningTimerQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useRunningTimerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunningTimerQuery, RunningTimerQueryVariables> & ({ variables: RunningTimerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunningTimerQuery, RunningTimerQueryVariables>(RunningTimerDocument, options);
      }
export function useRunningTimerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunningTimerQuery, RunningTimerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunningTimerQuery, RunningTimerQueryVariables>(RunningTimerDocument, options);
        }
export function useRunningTimerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunningTimerQuery, RunningTimerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunningTimerQuery, RunningTimerQueryVariables>(RunningTimerDocument, options);
        }
export type RunningTimerQueryHookResult = ReturnType<typeof useRunningTimerQuery>;
export type RunningTimerLazyQueryHookResult = ReturnType<typeof useRunningTimerLazyQuery>;
export type RunningTimerSuspenseQueryHookResult = ReturnType<typeof useRunningTimerSuspenseQuery>;
export type RunningTimerQueryResult = ApolloReactCommon.QueryResult<RunningTimerQuery, RunningTimerQueryVariables>;
export const AddScopedUsersToTaskDocument = gql`
    mutation AddScopedUsersToTask($id: ID!, $user_ids: [ID!], $isTemplate: Boolean!) {
  updateTask(input: {id: $id, user_ids: $user_ids, is_template: $isTemplate}) {
    id
    users {
      id
      first_name
      last_name
      scope {
        value
      }
    }
  }
}
    `;
export type AddScopedUsersToTaskMutationFn = ApolloReactCommon.MutationFunction<AddScopedUsersToTaskMutation, AddScopedUsersToTaskMutationVariables>;

/**
 * __useAddScopedUsersToTaskMutation__
 *
 * To run a mutation, you first call `useAddScopedUsersToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScopedUsersToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScopedUsersToTaskMutation, { data, loading, error }] = useAddScopedUsersToTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user_ids: // value for 'user_ids'
 *      isTemplate: // value for 'isTemplate'
 *   },
 * });
 */
export function useAddScopedUsersToTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddScopedUsersToTaskMutation, AddScopedUsersToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddScopedUsersToTaskMutation, AddScopedUsersToTaskMutationVariables>(AddScopedUsersToTaskDocument, options);
      }
export type AddScopedUsersToTaskMutationHookResult = ReturnType<typeof useAddScopedUsersToTaskMutation>;
export type AddScopedUsersToTaskMutationResult = ApolloReactCommon.MutationResult<AddScopedUsersToTaskMutation>;
export type AddScopedUsersToTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<AddScopedUsersToTaskMutation, AddScopedUsersToTaskMutationVariables>;
export const CreateLinkTaskDocument = gql`
    mutation createLinkTask($task_id: ID!, $link_type_id: ID!, $linked_task_id: ID!) {
  addTaskLink(
    task_id: $task_id
    link_type_id: $link_type_id
    linked_task_id: $linked_task_id
  ) {
    id
    linked_task {
      id
      status {
        id
        name
        background_color
        foreground_color
        system_status
      }
      name
      commentCount
      priority {
        id
        name
        system_priority
        emoji
      }
      ourWorkBudgetItem {
        id
        title
        item_code
      }
    }
    link_type {
      id
      name
    }
  }
}
    `;
export type CreateLinkTaskMutationFn = ApolloReactCommon.MutationFunction<CreateLinkTaskMutation, CreateLinkTaskMutationVariables>;

/**
 * __useCreateLinkTaskMutation__
 *
 * To run a mutation, you first call `useCreateLinkTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkTaskMutation, { data, loading, error }] = useCreateLinkTaskMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      link_type_id: // value for 'link_type_id'
 *      linked_task_id: // value for 'linked_task_id'
 *   },
 * });
 */
export function useCreateLinkTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLinkTaskMutation, CreateLinkTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLinkTaskMutation, CreateLinkTaskMutationVariables>(CreateLinkTaskDocument, options);
      }
export type CreateLinkTaskMutationHookResult = ReturnType<typeof useCreateLinkTaskMutation>;
export type CreateLinkTaskMutationResult = ApolloReactCommon.MutationResult<CreateLinkTaskMutation>;
export type CreateLinkTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLinkTaskMutation, CreateLinkTaskMutationVariables>;
export const CreateTaskCommentDocument = gql`
    mutation createTaskComment($input: CreateTaskCommentInput!) {
  createTaskComment(input: $input) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type CreateTaskCommentMutationFn = ApolloReactCommon.MutationFunction<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>;

/**
 * __useCreateTaskCommentMutation__
 *
 * To run a mutation, you first call `useCreateTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskCommentMutation, { data, loading, error }] = useCreateTaskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>(CreateTaskCommentDocument, options);
      }
export type CreateTaskCommentMutationHookResult = ReturnType<typeof useCreateTaskCommentMutation>;
export type CreateTaskCommentMutationResult = ApolloReactCommon.MutationResult<CreateTaskCommentMutation>;
export type CreateTaskCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>;
export const DeleteAssignableFileDocument = gql`
    mutation deleteAssignableFile($publicId: String!) {
  deleteAssignableFile(public_id: $publicId) {
    result
  }
}
    `;
export type DeleteAssignableFileMutationFn = ApolloReactCommon.MutationFunction<DeleteAssignableFileMutation, DeleteAssignableFileMutationVariables>;

/**
 * __useDeleteAssignableFileMutation__
 *
 * To run a mutation, you first call `useDeleteAssignableFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignableFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignableFileMutation, { data, loading, error }] = useDeleteAssignableFileMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useDeleteAssignableFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAssignableFileMutation, DeleteAssignableFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAssignableFileMutation, DeleteAssignableFileMutationVariables>(DeleteAssignableFileDocument, options);
      }
export type DeleteAssignableFileMutationHookResult = ReturnType<typeof useDeleteAssignableFileMutation>;
export type DeleteAssignableFileMutationResult = ApolloReactCommon.MutationResult<DeleteAssignableFileMutation>;
export type DeleteAssignableFileMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAssignableFileMutation, DeleteAssignableFileMutationVariables>;
export const DeleteLinkTaskDocument = gql`
    mutation deleteLinkTask($task_link_id: ID!) {
  deleteTaskLink(task_link_id: $task_link_id) {
    id
  }
}
    `;
export type DeleteLinkTaskMutationFn = ApolloReactCommon.MutationFunction<DeleteLinkTaskMutation, DeleteLinkTaskMutationVariables>;

/**
 * __useDeleteLinkTaskMutation__
 *
 * To run a mutation, you first call `useDeleteLinkTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkTaskMutation, { data, loading, error }] = useDeleteLinkTaskMutation({
 *   variables: {
 *      task_link_id: // value for 'task_link_id'
 *   },
 * });
 */
export function useDeleteLinkTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLinkTaskMutation, DeleteLinkTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLinkTaskMutation, DeleteLinkTaskMutationVariables>(DeleteLinkTaskDocument, options);
      }
export type DeleteLinkTaskMutationHookResult = ReturnType<typeof useDeleteLinkTaskMutation>;
export type DeleteLinkTaskMutationResult = ApolloReactCommon.MutationResult<DeleteLinkTaskMutation>;
export type DeleteLinkTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteLinkTaskMutation, DeleteLinkTaskMutationVariables>;
export const DeleteTaskCommentDocument = gql`
    mutation deleteTaskComment($id: ID!) {
  deleteTaskComment(id: $id) {
    id
  }
}
    `;
export type DeleteTaskCommentMutationFn = ApolloReactCommon.MutationFunction<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>;

/**
 * __useDeleteTaskCommentMutation__
 *
 * To run a mutation, you first call `useDeleteTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskCommentMutation, { data, loading, error }] = useDeleteTaskCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>(DeleteTaskCommentDocument, options);
      }
export type DeleteTaskCommentMutationHookResult = ReturnType<typeof useDeleteTaskCommentMutation>;
export type DeleteTaskCommentMutationResult = ApolloReactCommon.MutationResult<DeleteTaskCommentMutation>;
export type DeleteTaskCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>;
export const DuplicateTaskDocument = gql`
    mutation duplicateTask($task_id: ID!, $task_input: CreateTaskInput, $with_attachments: Boolean, $with_links: Boolean, $with_comments: Boolean, $performed_by_user_id: ID) {
  duplicateTask(
    task_id: $task_id
    task_input: $task_input
    with_attachments: $with_attachments
    with_comments: $with_comments
    with_links: $with_links
    performed_by_user_id: $performed_by_user_id
  ) {
    ...TaskFragment
    ...SimpleTask
  }
}
    ${TaskFragmentFragmentDoc}
${SimpleTaskFragmentDoc}`;
export type DuplicateTaskMutationFn = ApolloReactCommon.MutationFunction<DuplicateTaskMutation, DuplicateTaskMutationVariables>;

/**
 * __useDuplicateTaskMutation__
 *
 * To run a mutation, you first call `useDuplicateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTaskMutation, { data, loading, error }] = useDuplicateTaskMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      task_input: // value for 'task_input'
 *      with_attachments: // value for 'with_attachments'
 *      with_links: // value for 'with_links'
 *      with_comments: // value for 'with_comments'
 *      performed_by_user_id: // value for 'performed_by_user_id'
 *   },
 * });
 */
export function useDuplicateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateTaskMutation, DuplicateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateTaskMutation, DuplicateTaskMutationVariables>(DuplicateTaskDocument, options);
      }
export type DuplicateTaskMutationHookResult = ReturnType<typeof useDuplicateTaskMutation>;
export type DuplicateTaskMutationResult = ApolloReactCommon.MutationResult<DuplicateTaskMutation>;
export type DuplicateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateTaskMutation, DuplicateTaskMutationVariables>;
export const EditTaskWatchersDocument = gql`
    mutation EditTaskWatchers($taskId: ID!, $userIds: [ID!]!) {
  editTaskWatchers(task_id: $taskId, user_ids: $userIds) {
    taskWatchers {
      user_id
    }
  }
}
    `;
export type EditTaskWatchersMutationFn = ApolloReactCommon.MutationFunction<EditTaskWatchersMutation, EditTaskWatchersMutationVariables>;

/**
 * __useEditTaskWatchersMutation__
 *
 * To run a mutation, you first call `useEditTaskWatchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskWatchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskWatchersMutation, { data, loading, error }] = useEditTaskWatchersMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useEditTaskWatchersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditTaskWatchersMutation, EditTaskWatchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditTaskWatchersMutation, EditTaskWatchersMutationVariables>(EditTaskWatchersDocument, options);
      }
export type EditTaskWatchersMutationHookResult = ReturnType<typeof useEditTaskWatchersMutation>;
export type EditTaskWatchersMutationResult = ApolloReactCommon.MutationResult<EditTaskWatchersMutation>;
export type EditTaskWatchersMutationOptions = ApolloReactCommon.BaseMutationOptions<EditTaskWatchersMutation, EditTaskWatchersMutationVariables>;
export const LastSeenCommentDocument = gql`
    mutation LastSeenComment($comment_id: ID!) {
  lastSeen(task_comment_id: $comment_id) {
    id
  }
}
    `;
export type LastSeenCommentMutationFn = ApolloReactCommon.MutationFunction<LastSeenCommentMutation, LastSeenCommentMutationVariables>;

/**
 * __useLastSeenCommentMutation__
 *
 * To run a mutation, you first call `useLastSeenCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLastSeenCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lastSeenCommentMutation, { data, loading, error }] = useLastSeenCommentMutation({
 *   variables: {
 *      comment_id: // value for 'comment_id'
 *   },
 * });
 */
export function useLastSeenCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LastSeenCommentMutation, LastSeenCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LastSeenCommentMutation, LastSeenCommentMutationVariables>(LastSeenCommentDocument, options);
      }
export type LastSeenCommentMutationHookResult = ReturnType<typeof useLastSeenCommentMutation>;
export type LastSeenCommentMutationResult = ApolloReactCommon.MutationResult<LastSeenCommentMutation>;
export type LastSeenCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<LastSeenCommentMutation, LastSeenCommentMutationVariables>;
export const MarkTaskNotificationsAsReadDocument = gql`
    mutation MarkTaskNotificationsAsRead($task_id: ID!) {
  markTaskAndCommunicationNotificationAsRead(task_id: $task_id)
}
    `;
export type MarkTaskNotificationsAsReadMutationFn = ApolloReactCommon.MutationFunction<MarkTaskNotificationsAsReadMutation, MarkTaskNotificationsAsReadMutationVariables>;

/**
 * __useMarkTaskNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkTaskNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTaskNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTaskNotificationsAsReadMutation, { data, loading, error }] = useMarkTaskNotificationsAsReadMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *   },
 * });
 */
export function useMarkTaskNotificationsAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkTaskNotificationsAsReadMutation, MarkTaskNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkTaskNotificationsAsReadMutation, MarkTaskNotificationsAsReadMutationVariables>(MarkTaskNotificationsAsReadDocument, options);
      }
export type MarkTaskNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkTaskNotificationsAsReadMutation>;
export type MarkTaskNotificationsAsReadMutationResult = ApolloReactCommon.MutationResult<MarkTaskNotificationsAsReadMutation>;
export type MarkTaskNotificationsAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkTaskNotificationsAsReadMutation, MarkTaskNotificationsAsReadMutationVariables>;
export const ToggleTaskCommentReactionDocument = gql`
    mutation ToggleTaskCommentReaction($input: ToggleTaskCommentReactionInput!) {
  toggleTaskCommentReaction(input: $input) {
    id
    user {
      id
      full_name
    }
    emoji_id
  }
}
    `;
export type ToggleTaskCommentReactionMutationFn = ApolloReactCommon.MutationFunction<ToggleTaskCommentReactionMutation, ToggleTaskCommentReactionMutationVariables>;

/**
 * __useToggleTaskCommentReactionMutation__
 *
 * To run a mutation, you first call `useToggleTaskCommentReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTaskCommentReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTaskCommentReactionMutation, { data, loading, error }] = useToggleTaskCommentReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleTaskCommentReactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleTaskCommentReactionMutation, ToggleTaskCommentReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleTaskCommentReactionMutation, ToggleTaskCommentReactionMutationVariables>(ToggleTaskCommentReactionDocument, options);
      }
export type ToggleTaskCommentReactionMutationHookResult = ReturnType<typeof useToggleTaskCommentReactionMutation>;
export type ToggleTaskCommentReactionMutationResult = ApolloReactCommon.MutationResult<ToggleTaskCommentReactionMutation>;
export type ToggleTaskCommentReactionMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleTaskCommentReactionMutation, ToggleTaskCommentReactionMutationVariables>;
export const UpdateTaskCommentDocument = gql`
    mutation updateTaskComment($input: UpdateTaskCommentInput!) {
  updateTaskComment(input: $input) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateTaskCommentMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>;

/**
 * __useUpdateTaskCommentMutation__
 *
 * To run a mutation, you first call `useUpdateTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskCommentMutation, { data, loading, error }] = useUpdateTaskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>(UpdateTaskCommentDocument, options);
      }
export type UpdateTaskCommentMutationHookResult = ReturnType<typeof useUpdateTaskCommentMutation>;
export type UpdateTaskCommentMutationResult = ApolloReactCommon.MutationResult<UpdateTaskCommentMutation>;
export type UpdateTaskCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>;
export const UpdateTaskDescriptionDocument = gql`
    mutation updateTaskDescription($input: UpdateTaskDescriptionInput!) {
  updateTaskDescription(input: $input) {
    id
    description {
      body
      mentioned_user_ids
      mentioned_team_ids
      mentioned_assignees
    }
    revision
  }
}
    `;
export type UpdateTaskDescriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskDescriptionMutation, UpdateTaskDescriptionMutationVariables>;

/**
 * __useUpdateTaskDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDescriptionMutation, { data, loading, error }] = useUpdateTaskDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskDescriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskDescriptionMutation, UpdateTaskDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskDescriptionMutation, UpdateTaskDescriptionMutationVariables>(UpdateTaskDescriptionDocument, options);
      }
export type UpdateTaskDescriptionMutationHookResult = ReturnType<typeof useUpdateTaskDescriptionMutation>;
export type UpdateTaskDescriptionMutationResult = ApolloReactCommon.MutationResult<UpdateTaskDescriptionMutation>;
export type UpdateTaskDescriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskDescriptionMutation, UpdateTaskDescriptionMutationVariables>;
export const UpdateTaskFilesDocument = gql`
    mutation updateTaskFiles($task_id: ID!, $files: [String!]!) {
  addTaskFiles(task_id: $task_id, files: $files) {
    id
    files {
      ...Attachment
      created_at
    }
  }
}
    ${AttachmentFragmentDoc}`;
export type UpdateTaskFilesMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>;

/**
 * __useUpdateTaskFilesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskFilesMutation, { data, loading, error }] = useUpdateTaskFilesMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUpdateTaskFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>(UpdateTaskFilesDocument, options);
      }
export type UpdateTaskFilesMutationHookResult = ReturnType<typeof useUpdateTaskFilesMutation>;
export type UpdateTaskFilesMutationResult = ApolloReactCommon.MutationResult<UpdateTaskFilesMutation>;
export type UpdateTaskFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>;
export const UpdateTaskPriorityDocument = gql`
    mutation updateTaskPriority($task_id: ID!, $priority_id: ID!) {
  updateTaskPriority(task_id: $task_id, priority_id: $priority_id) {
    id
    priority {
      id
      name
      system_priority
      emoji
    }
  }
}
    `;
export type UpdateTaskPriorityMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>;

/**
 * __useUpdateTaskPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateTaskPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskPriorityMutation, { data, loading, error }] = useUpdateTaskPriorityMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      priority_id: // value for 'priority_id'
 *   },
 * });
 */
export function useUpdateTaskPriorityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>(UpdateTaskPriorityDocument, options);
      }
export type UpdateTaskPriorityMutationHookResult = ReturnType<typeof useUpdateTaskPriorityMutation>;
export type UpdateTaskPriorityMutationResult = ApolloReactCommon.MutationResult<UpdateTaskPriorityMutation>;
export type UpdateTaskPriorityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>;
export const UpdateTaskStatusDocument = gql`
    mutation updateTaskStatus($task_id: ID!, $status_id: ID!) {
  updateTaskStatus(task_id: $task_id, status_id: $status_id) {
    id
    status {
      id
      name
      background_color
      foreground_color
      system_status
    }
  }
}
    `;
export type UpdateTaskStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>;

/**
 * __useUpdateTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatusMutation, { data, loading, error }] = useUpdateTaskStatusMutation({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      status_id: // value for 'status_id'
 *   },
 * });
 */
export function useUpdateTaskStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument, options);
      }
export type UpdateTaskStatusMutationHookResult = ReturnType<typeof useUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationResult = ApolloReactCommon.MutationResult<UpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>;
export const CheckTaskRevisionDocument = gql`
    query CheckTaskRevision($id: ID!) {
  task(id: $id) {
    id
    revision
  }
}
    `;

/**
 * __useCheckTaskRevisionQuery__
 *
 * To run a query within a React component, call `useCheckTaskRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTaskRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTaskRevisionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckTaskRevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables> & ({ variables: CheckTaskRevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>(CheckTaskRevisionDocument, options);
      }
export function useCheckTaskRevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>(CheckTaskRevisionDocument, options);
        }
export function useCheckTaskRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>(CheckTaskRevisionDocument, options);
        }
export type CheckTaskRevisionQueryHookResult = ReturnType<typeof useCheckTaskRevisionQuery>;
export type CheckTaskRevisionLazyQueryHookResult = ReturnType<typeof useCheckTaskRevisionLazyQuery>;
export type CheckTaskRevisionSuspenseQueryHookResult = ReturnType<typeof useCheckTaskRevisionSuspenseQuery>;
export type CheckTaskRevisionQueryResult = ApolloReactCommon.QueryResult<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>;
export const GetTaskCommunicationFilesDocument = gql`
    query GetTaskCommunicationFiles($task_id: ID!, $scope: UserScopeEnum) {
  taskCommentFiles(task_id: $task_id, scope: $scope) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;

/**
 * __useGetTaskCommunicationFilesQuery__
 *
 * To run a query within a React component, call `useGetTaskCommunicationFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommunicationFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommunicationFilesQuery({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetTaskCommunicationFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables> & ({ variables: GetTaskCommunicationFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>(GetTaskCommunicationFilesDocument, options);
      }
export function useGetTaskCommunicationFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>(GetTaskCommunicationFilesDocument, options);
        }
export function useGetTaskCommunicationFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>(GetTaskCommunicationFilesDocument, options);
        }
export type GetTaskCommunicationFilesQueryHookResult = ReturnType<typeof useGetTaskCommunicationFilesQuery>;
export type GetTaskCommunicationFilesLazyQueryHookResult = ReturnType<typeof useGetTaskCommunicationFilesLazyQuery>;
export type GetTaskCommunicationFilesSuspenseQueryHookResult = ReturnType<typeof useGetTaskCommunicationFilesSuspenseQuery>;
export type GetTaskCommunicationFilesQueryResult = ApolloReactCommon.QueryResult<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>;
export const GetTaskLinkTypesDocument = gql`
    query GetTaskLinkTypes {
  taskLinkTypes {
    id
    name
  }
}
    `;

/**
 * __useGetTaskLinkTypesQuery__
 *
 * To run a query within a React component, call `useGetTaskLinkTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskLinkTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskLinkTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskLinkTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>(GetTaskLinkTypesDocument, options);
      }
export function useGetTaskLinkTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>(GetTaskLinkTypesDocument, options);
        }
export function useGetTaskLinkTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>(GetTaskLinkTypesDocument, options);
        }
export type GetTaskLinkTypesQueryHookResult = ReturnType<typeof useGetTaskLinkTypesQuery>;
export type GetTaskLinkTypesLazyQueryHookResult = ReturnType<typeof useGetTaskLinkTypesLazyQuery>;
export type GetTaskLinkTypesSuspenseQueryHookResult = ReturnType<typeof useGetTaskLinkTypesSuspenseQuery>;
export type GetTaskLinkTypesQueryResult = ApolloReactCommon.QueryResult<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>;
export const GetTaskLinksDocument = gql`
    query GetTaskLinks($id: ID!) {
  task(id: $id) {
    linkedTasks {
      link_type {
        name
      }
      linked_task {
        status {
          id
          name
          background_color
          foreground_color
          system_status
        }
        name
        priority {
          id
          name
          system_priority
          emoji
        }
      }
    }
  }
}
    `;

/**
 * __useGetTaskLinksQuery__
 *
 * To run a query within a React component, call `useGetTaskLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTaskLinksQuery, GetTaskLinksQueryVariables> & ({ variables: GetTaskLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskLinksQuery, GetTaskLinksQueryVariables>(GetTaskLinksDocument, options);
      }
export function useGetTaskLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskLinksQuery, GetTaskLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskLinksQuery, GetTaskLinksQueryVariables>(GetTaskLinksDocument, options);
        }
export function useGetTaskLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskLinksQuery, GetTaskLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskLinksQuery, GetTaskLinksQueryVariables>(GetTaskLinksDocument, options);
        }
export type GetTaskLinksQueryHookResult = ReturnType<typeof useGetTaskLinksQuery>;
export type GetTaskLinksLazyQueryHookResult = ReturnType<typeof useGetTaskLinksLazyQuery>;
export type GetTaskLinksSuspenseQueryHookResult = ReturnType<typeof useGetTaskLinksSuspenseQuery>;
export type GetTaskLinksQueryResult = ApolloReactCommon.QueryResult<GetTaskLinksQuery, GetTaskLinksQueryVariables>;
export const TaskDocument = gql`
    query Task($id: ID!) {
  taskPositionStat(task_id: $id) {
    timeTrackingWorkType {
      id
      title
    }
    user {
      ...UserToolTip_UserFragment
      first_name
      last_name
      scope {
        value
      }
    }
    planned_time
    spent_time
  }
  task(id: $id) {
    ...TaskFragment
    subtasks {
      ...TaskFragment
    }
  }
  taskStatuses {
    id
    name
    background_color
    foreground_color
    system_status
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${TaskFragmentFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskQuery, TaskQueryVariables> & ({ variables: TaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export function useTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskSuspenseQueryHookResult = ReturnType<typeof useTaskSuspenseQuery>;
export type TaskQueryResult = ApolloReactCommon.QueryResult<TaskQuery, TaskQueryVariables>;
export const TaskForScopedUsersDocument = gql`
    query TaskForScopedUsers($id: ID!) {
  task(id: $id) {
    ...TaskFragmentForScopedUser
  }
  taskStatuses {
    id
    name
    background_color
    foreground_color
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;

/**
 * __useTaskForScopedUsersQuery__
 *
 * To run a query within a React component, call `useTaskForScopedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskForScopedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskForScopedUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskForScopedUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables> & ({ variables: TaskForScopedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>(TaskForScopedUsersDocument, options);
      }
export function useTaskForScopedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>(TaskForScopedUsersDocument, options);
        }
export function useTaskForScopedUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>(TaskForScopedUsersDocument, options);
        }
export type TaskForScopedUsersQueryHookResult = ReturnType<typeof useTaskForScopedUsersQuery>;
export type TaskForScopedUsersLazyQueryHookResult = ReturnType<typeof useTaskForScopedUsersLazyQuery>;
export type TaskForScopedUsersSuspenseQueryHookResult = ReturnType<typeof useTaskForScopedUsersSuspenseQuery>;
export type TaskForScopedUsersQueryResult = ApolloReactCommon.QueryResult<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>;
export const TaskCommentsDocument = gql`
    query TaskComments($id: ID!, $page: Int = 1, $first: Int = 10, $scope: UserScopeEnum, $lastCommentId: ID) {
  taskComments(
    task_id: $id
    page: $page
    first: $first
    scope: $scope
    last_comment_ID: $lastCommentId
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...Comment
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${CommentFragmentDoc}`;

/**
 * __useTaskCommentsQuery__
 *
 * To run a query within a React component, call `useTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      scope: // value for 'scope'
 *      lastCommentId: // value for 'lastCommentId'
 *   },
 * });
 */
export function useTaskCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCommentsQuery, TaskCommentsQueryVariables> & ({ variables: TaskCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCommentsQuery, TaskCommentsQueryVariables>(TaskCommentsDocument, options);
      }
export function useTaskCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCommentsQuery, TaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCommentsQuery, TaskCommentsQueryVariables>(TaskCommentsDocument, options);
        }
export function useTaskCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCommentsQuery, TaskCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCommentsQuery, TaskCommentsQueryVariables>(TaskCommentsDocument, options);
        }
export type TaskCommentsQueryHookResult = ReturnType<typeof useTaskCommentsQuery>;
export type TaskCommentsLazyQueryHookResult = ReturnType<typeof useTaskCommentsLazyQuery>;
export type TaskCommentsSuspenseQueryHookResult = ReturnType<typeof useTaskCommentsSuspenseQuery>;
export type TaskCommentsQueryResult = ApolloReactCommon.QueryResult<TaskCommentsQuery, TaskCommentsQueryVariables>;
export const TaskStatusesDocument = gql`
    query TaskStatuses {
  taskStatuses {
    id
    name
    background_color
    foreground_color
    system_status
  }
}
    `;

/**
 * __useTaskStatusesQuery__
 *
 * To run a query within a React component, call `useTaskStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskStatusesQuery, TaskStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskStatusesQuery, TaskStatusesQueryVariables>(TaskStatusesDocument, options);
      }
export function useTaskStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskStatusesQuery, TaskStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskStatusesQuery, TaskStatusesQueryVariables>(TaskStatusesDocument, options);
        }
export function useTaskStatusesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskStatusesQuery, TaskStatusesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskStatusesQuery, TaskStatusesQueryVariables>(TaskStatusesDocument, options);
        }
export type TaskStatusesQueryHookResult = ReturnType<typeof useTaskStatusesQuery>;
export type TaskStatusesLazyQueryHookResult = ReturnType<typeof useTaskStatusesLazyQuery>;
export type TaskStatusesSuspenseQueryHookResult = ReturnType<typeof useTaskStatusesSuspenseQuery>;
export type TaskStatusesQueryResult = ApolloReactCommon.QueryResult<TaskStatusesQuery, TaskStatusesQueryVariables>;
export const HasTaskPermissionDocument = gql`
    query HasTaskPermission($task_id: ID!, $type: TaskPermissionTypeEnum!) {
  hasTaskPermission(task_id: $task_id, type: $type)
}
    `;

/**
 * __useHasTaskPermissionQuery__
 *
 * To run a query within a React component, call `useHasTaskPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasTaskPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasTaskPermissionQuery({
 *   variables: {
 *      task_id: // value for 'task_id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useHasTaskPermissionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HasTaskPermissionQuery, HasTaskPermissionQueryVariables> & ({ variables: HasTaskPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>(HasTaskPermissionDocument, options);
      }
export function useHasTaskPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>(HasTaskPermissionDocument, options);
        }
export function useHasTaskPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>(HasTaskPermissionDocument, options);
        }
export type HasTaskPermissionQueryHookResult = ReturnType<typeof useHasTaskPermissionQuery>;
export type HasTaskPermissionLazyQueryHookResult = ReturnType<typeof useHasTaskPermissionLazyQuery>;
export type HasTaskPermissionSuspenseQueryHookResult = ReturnType<typeof useHasTaskPermissionSuspenseQuery>;
export type HasTaskPermissionQueryResult = ApolloReactCommon.QueryResult<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>;
export const CompleteExpenseBudgetItemDocument = gql`
    mutation CompleteExpenseBudgetItem($id: ID!, $completed_at: Date) {
  completeExpenseBudgetItem(id: $id, completed_at: $completed_at) {
    ...EbiCompleteData
  }
}
    ${EbiCompleteDataFragmentDoc}`;
export type CompleteExpenseBudgetItemMutationFn = ApolloReactCommon.MutationFunction<CompleteExpenseBudgetItemMutation, CompleteExpenseBudgetItemMutationVariables>;

/**
 * __useCompleteExpenseBudgetItemMutation__
 *
 * To run a mutation, you first call `useCompleteExpenseBudgetItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteExpenseBudgetItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeExpenseBudgetItemMutation, { data, loading, error }] = useCompleteExpenseBudgetItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      completed_at: // value for 'completed_at'
 *   },
 * });
 */
export function useCompleteExpenseBudgetItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteExpenseBudgetItemMutation, CompleteExpenseBudgetItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteExpenseBudgetItemMutation, CompleteExpenseBudgetItemMutationVariables>(CompleteExpenseBudgetItemDocument, options);
      }
export type CompleteExpenseBudgetItemMutationHookResult = ReturnType<typeof useCompleteExpenseBudgetItemMutation>;
export type CompleteExpenseBudgetItemMutationResult = ApolloReactCommon.MutationResult<CompleteExpenseBudgetItemMutation>;
export type CompleteExpenseBudgetItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteExpenseBudgetItemMutation, CompleteExpenseBudgetItemMutationVariables>;
export const ReopenExpenseBudgetItemDocument = gql`
    mutation ReopenExpenseBudgetItem($id: ID!) {
  reopenExpenseBudgetItem(id: $id) {
    ...EbiCompleteData
  }
}
    ${EbiCompleteDataFragmentDoc}`;
export type ReopenExpenseBudgetItemMutationFn = ApolloReactCommon.MutationFunction<ReopenExpenseBudgetItemMutation, ReopenExpenseBudgetItemMutationVariables>;

/**
 * __useReopenExpenseBudgetItemMutation__
 *
 * To run a mutation, you first call `useReopenExpenseBudgetItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenExpenseBudgetItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenExpenseBudgetItemMutation, { data, loading, error }] = useReopenExpenseBudgetItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenExpenseBudgetItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenExpenseBudgetItemMutation, ReopenExpenseBudgetItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenExpenseBudgetItemMutation, ReopenExpenseBudgetItemMutationVariables>(ReopenExpenseBudgetItemDocument, options);
      }
export type ReopenExpenseBudgetItemMutationHookResult = ReturnType<typeof useReopenExpenseBudgetItemMutation>;
export type ReopenExpenseBudgetItemMutationResult = ApolloReactCommon.MutationResult<ReopenExpenseBudgetItemMutation>;
export type ReopenExpenseBudgetItemMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenExpenseBudgetItemMutation, ReopenExpenseBudgetItemMutationVariables>;
export const ReturnGlobalCreditDocument = gql`
    mutation ReturnGlobalCredit($amount: BigInt!, $expense_budget_item_id: ID!, $global_credit_account_id: ID!, $credit_account_operation_id: ID!) {
  returnGlobalCreditFromExpenseItem(
    amount: $amount
    expense_budget_item_id: $expense_budget_item_id
    global_credit_account_id: $global_credit_account_id
    credit_account_operation_id: $credit_account_operation_id
  )
}
    `;
export type ReturnGlobalCreditMutationFn = ApolloReactCommon.MutationFunction<ReturnGlobalCreditMutation, ReturnGlobalCreditMutationVariables>;

/**
 * __useReturnGlobalCreditMutation__
 *
 * To run a mutation, you first call `useReturnGlobalCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnGlobalCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnGlobalCreditMutation, { data, loading, error }] = useReturnGlobalCreditMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      expense_budget_item_id: // value for 'expense_budget_item_id'
 *      global_credit_account_id: // value for 'global_credit_account_id'
 *      credit_account_operation_id: // value for 'credit_account_operation_id'
 *   },
 * });
 */
export function useReturnGlobalCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReturnGlobalCreditMutation, ReturnGlobalCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReturnGlobalCreditMutation, ReturnGlobalCreditMutationVariables>(ReturnGlobalCreditDocument, options);
      }
export type ReturnGlobalCreditMutationHookResult = ReturnType<typeof useReturnGlobalCreditMutation>;
export type ReturnGlobalCreditMutationResult = ApolloReactCommon.MutationResult<ReturnGlobalCreditMutation>;
export type ReturnGlobalCreditMutationOptions = ApolloReactCommon.BaseMutationOptions<ReturnGlobalCreditMutation, ReturnGlobalCreditMutationVariables>;
export const TransferGlobalCreditDocument = gql`
    mutation TransferGlobalCredit($amount: BigInt!, $fromCreditAccountId: ID!, $toCreditAccountId: ID!, $performedAt: DateTime) {
  transferGlobalCredit(
    amount: $amount
    from_credit_account_id: $fromCreditAccountId
    to_credit_account_id: $toCreditAccountId
    performed_at: $performedAt
  )
}
    `;
export type TransferGlobalCreditMutationFn = ApolloReactCommon.MutationFunction<TransferGlobalCreditMutation, TransferGlobalCreditMutationVariables>;

/**
 * __useTransferGlobalCreditMutation__
 *
 * To run a mutation, you first call `useTransferGlobalCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferGlobalCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferGlobalCreditMutation, { data, loading, error }] = useTransferGlobalCreditMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      fromCreditAccountId: // value for 'fromCreditAccountId'
 *      toCreditAccountId: // value for 'toCreditAccountId'
 *      performedAt: // value for 'performedAt'
 *   },
 * });
 */
export function useTransferGlobalCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferGlobalCreditMutation, TransferGlobalCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TransferGlobalCreditMutation, TransferGlobalCreditMutationVariables>(TransferGlobalCreditDocument, options);
      }
export type TransferGlobalCreditMutationHookResult = ReturnType<typeof useTransferGlobalCreditMutation>;
export type TransferGlobalCreditMutationResult = ApolloReactCommon.MutationResult<TransferGlobalCreditMutation>;
export type TransferGlobalCreditMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferGlobalCreditMutation, TransferGlobalCreditMutationVariables>;
export const ExpenseBudgetItemDocument = gql`
    query ExpenseBudgetItem($id: ID!) {
  expenseBudgetItem(id: $id) {
    id
    type
    title
    completed_at
    project {
      id
      billable
      brand {
        id
      }
    }
    expenseStats {
      id
      amount
      date
      expense {
        id
        status
      }
      contractor {
        id
        legal_name
      }
    }
    creditAccount {
      id
    }
    stats {
      real_expenses
      planned_commission
      planned_commission_relative_computed
      real_commission
      real_commission_relative
    }
    globalPrepaymentStats {
      id
      credit
      date
      credit_account_operation_id
      expenseBudgetItem {
        id
        title
      }
      globalCreditAccount {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useExpenseBudgetItemQuery__
 *
 * To run a query within a React component, call `useExpenseBudgetItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseBudgetItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseBudgetItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpenseBudgetItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables> & ({ variables: ExpenseBudgetItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>(ExpenseBudgetItemDocument, options);
      }
export function useExpenseBudgetItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>(ExpenseBudgetItemDocument, options);
        }
export function useExpenseBudgetItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>(ExpenseBudgetItemDocument, options);
        }
export type ExpenseBudgetItemQueryHookResult = ReturnType<typeof useExpenseBudgetItemQuery>;
export type ExpenseBudgetItemLazyQueryHookResult = ReturnType<typeof useExpenseBudgetItemLazyQuery>;
export type ExpenseBudgetItemSuspenseQueryHookResult = ReturnType<typeof useExpenseBudgetItemSuspenseQuery>;
export type ExpenseBudgetItemQueryResult = ApolloReactCommon.QueryResult<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export type CreateContactMutationFn = ApolloReactCommon.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = ApolloReactCommon.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export type UpdateContactMutationFn = ApolloReactCommon.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = ApolloReactCommon.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const CreateCurrencyExchangeRateForClientDocument = gql`
    mutation CreateCurrencyExchangeRateForClient($input: CreateCurrencyExchangeRateInput!) {
  createCurrencyExchangeRate(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;
export type CreateCurrencyExchangeRateForClientMutationFn = ApolloReactCommon.MutationFunction<CreateCurrencyExchangeRateForClientMutation, CreateCurrencyExchangeRateForClientMutationVariables>;

/**
 * __useCreateCurrencyExchangeRateForClientMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyExchangeRateForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyExchangeRateForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyExchangeRateForClientMutation, { data, loading, error }] = useCreateCurrencyExchangeRateForClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrencyExchangeRateForClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCurrencyExchangeRateForClientMutation, CreateCurrencyExchangeRateForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCurrencyExchangeRateForClientMutation, CreateCurrencyExchangeRateForClientMutationVariables>(CreateCurrencyExchangeRateForClientDocument, options);
      }
export type CreateCurrencyExchangeRateForClientMutationHookResult = ReturnType<typeof useCreateCurrencyExchangeRateForClientMutation>;
export type CreateCurrencyExchangeRateForClientMutationResult = ApolloReactCommon.MutationResult<CreateCurrencyExchangeRateForClientMutation>;
export type CreateCurrencyExchangeRateForClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCurrencyExchangeRateForClientMutation, CreateCurrencyExchangeRateForClientMutationVariables>;
export const UpdateCurrencyExchangeRateForClientDocument = gql`
    mutation UpdateCurrencyExchangeRateForClient($input: UpdateCurrencyExchangeRateInput!) {
  updateCurrencyExchangeRate(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;
export type UpdateCurrencyExchangeRateForClientMutationFn = ApolloReactCommon.MutationFunction<UpdateCurrencyExchangeRateForClientMutation, UpdateCurrencyExchangeRateForClientMutationVariables>;

/**
 * __useUpdateCurrencyExchangeRateForClientMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyExchangeRateForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyExchangeRateForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyExchangeRateForClientMutation, { data, loading, error }] = useUpdateCurrencyExchangeRateForClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrencyExchangeRateForClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCurrencyExchangeRateForClientMutation, UpdateCurrencyExchangeRateForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCurrencyExchangeRateForClientMutation, UpdateCurrencyExchangeRateForClientMutationVariables>(UpdateCurrencyExchangeRateForClientDocument, options);
      }
export type UpdateCurrencyExchangeRateForClientMutationHookResult = ReturnType<typeof useUpdateCurrencyExchangeRateForClientMutation>;
export type UpdateCurrencyExchangeRateForClientMutationResult = ApolloReactCommon.MutationResult<UpdateCurrencyExchangeRateForClientMutation>;
export type UpdateCurrencyExchangeRateForClientMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCurrencyExchangeRateForClientMutation, UpdateCurrencyExchangeRateForClientMutationVariables>;
export const CreateCurrencyExchangeRateForWorkspaceDocument = gql`
    mutation CreateCurrencyExchangeRateForWorkspace($input: CreateExchangeRateSettingsInput!) {
  createExchangeRateForWorkspace(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;
export type CreateCurrencyExchangeRateForWorkspaceMutationFn = ApolloReactCommon.MutationFunction<CreateCurrencyExchangeRateForWorkspaceMutation, CreateCurrencyExchangeRateForWorkspaceMutationVariables>;

/**
 * __useCreateCurrencyExchangeRateForWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyExchangeRateForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyExchangeRateForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyExchangeRateForWorkspaceMutation, { data, loading, error }] = useCreateCurrencyExchangeRateForWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrencyExchangeRateForWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCurrencyExchangeRateForWorkspaceMutation, CreateCurrencyExchangeRateForWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCurrencyExchangeRateForWorkspaceMutation, CreateCurrencyExchangeRateForWorkspaceMutationVariables>(CreateCurrencyExchangeRateForWorkspaceDocument, options);
      }
export type CreateCurrencyExchangeRateForWorkspaceMutationHookResult = ReturnType<typeof useCreateCurrencyExchangeRateForWorkspaceMutation>;
export type CreateCurrencyExchangeRateForWorkspaceMutationResult = ApolloReactCommon.MutationResult<CreateCurrencyExchangeRateForWorkspaceMutation>;
export type CreateCurrencyExchangeRateForWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCurrencyExchangeRateForWorkspaceMutation, CreateCurrencyExchangeRateForWorkspaceMutationVariables>;
export const UpdateCurrencyExchangeRateForWorkspaceDocument = gql`
    mutation UpdateCurrencyExchangeRateForWorkspace($input: UpdateExchangeRateSettingsInput!) {
  updateExchangeRateForWorkspace(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;
export type UpdateCurrencyExchangeRateForWorkspaceMutationFn = ApolloReactCommon.MutationFunction<UpdateCurrencyExchangeRateForWorkspaceMutation, UpdateCurrencyExchangeRateForWorkspaceMutationVariables>;

/**
 * __useUpdateCurrencyExchangeRateForWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyExchangeRateForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyExchangeRateForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyExchangeRateForWorkspaceMutation, { data, loading, error }] = useUpdateCurrencyExchangeRateForWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrencyExchangeRateForWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCurrencyExchangeRateForWorkspaceMutation, UpdateCurrencyExchangeRateForWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCurrencyExchangeRateForWorkspaceMutation, UpdateCurrencyExchangeRateForWorkspaceMutationVariables>(UpdateCurrencyExchangeRateForWorkspaceDocument, options);
      }
export type UpdateCurrencyExchangeRateForWorkspaceMutationHookResult = ReturnType<typeof useUpdateCurrencyExchangeRateForWorkspaceMutation>;
export type UpdateCurrencyExchangeRateForWorkspaceMutationResult = ApolloReactCommon.MutationResult<UpdateCurrencyExchangeRateForWorkspaceMutation>;
export type UpdateCurrencyExchangeRateForWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCurrencyExchangeRateForWorkspaceMutation, UpdateCurrencyExchangeRateForWorkspaceMutationVariables>;
export const CompleteExpenseBulkDocument = gql`
    mutation CompleteExpenseBulk($ids: [ID!]!, $completed_at: Date) {
  completeExpenseBudgetItemBulk(ids: $ids, completed_at: $completed_at) {
    ...CompleteExpenseBulkData
  }
}
    ${CompleteExpenseBulkDataFragmentDoc}`;
export type CompleteExpenseBulkMutationFn = ApolloReactCommon.MutationFunction<CompleteExpenseBulkMutation, CompleteExpenseBulkMutationVariables>;

/**
 * __useCompleteExpenseBulkMutation__
 *
 * To run a mutation, you first call `useCompleteExpenseBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteExpenseBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeExpenseBulkMutation, { data, loading, error }] = useCompleteExpenseBulkMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      completed_at: // value for 'completed_at'
 *   },
 * });
 */
export function useCompleteExpenseBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteExpenseBulkMutation, CompleteExpenseBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteExpenseBulkMutation, CompleteExpenseBulkMutationVariables>(CompleteExpenseBulkDocument, options);
      }
export type CompleteExpenseBulkMutationHookResult = ReturnType<typeof useCompleteExpenseBulkMutation>;
export type CompleteExpenseBulkMutationResult = ApolloReactCommon.MutationResult<CompleteExpenseBulkMutation>;
export type CompleteExpenseBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteExpenseBulkMutation, CompleteExpenseBulkMutationVariables>;
export const FinishProjectDocument = gql`
    mutation FinishProject($id: ID!) {
  finishProject(id: $id) {
    ...FinishedProjectData
  }
}
    ${FinishedProjectDataFragmentDoc}`;
export type FinishProjectMutationFn = ApolloReactCommon.MutationFunction<FinishProjectMutation, FinishProjectMutationVariables>;

/**
 * __useFinishProjectMutation__
 *
 * To run a mutation, you first call `useFinishProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishProjectMutation, { data, loading, error }] = useFinishProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FinishProjectMutation, FinishProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FinishProjectMutation, FinishProjectMutationVariables>(FinishProjectDocument, options);
      }
export type FinishProjectMutationHookResult = ReturnType<typeof useFinishProjectMutation>;
export type FinishProjectMutationResult = ApolloReactCommon.MutationResult<FinishProjectMutation>;
export type FinishProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<FinishProjectMutation, FinishProjectMutationVariables>;
export const RedistributeProjectCreditDocument = gql`
    mutation RedistributeProjectCredit($id: ID!) {
  redistributeProjectCredit(project_id: $id) {
    id
  }
}
    `;
export type RedistributeProjectCreditMutationFn = ApolloReactCommon.MutationFunction<RedistributeProjectCreditMutation, RedistributeProjectCreditMutationVariables>;

/**
 * __useRedistributeProjectCreditMutation__
 *
 * To run a mutation, you first call `useRedistributeProjectCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedistributeProjectCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redistributeProjectCreditMutation, { data, loading, error }] = useRedistributeProjectCreditMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRedistributeProjectCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RedistributeProjectCreditMutation, RedistributeProjectCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RedistributeProjectCreditMutation, RedistributeProjectCreditMutationVariables>(RedistributeProjectCreditDocument, options);
      }
export type RedistributeProjectCreditMutationHookResult = ReturnType<typeof useRedistributeProjectCreditMutation>;
export type RedistributeProjectCreditMutationResult = ApolloReactCommon.MutationResult<RedistributeProjectCreditMutation>;
export type RedistributeProjectCreditMutationOptions = ApolloReactCommon.BaseMutationOptions<RedistributeProjectCreditMutation, RedistributeProjectCreditMutationVariables>;
export const ModalFinishProjectDocument = gql`
    query ModalFinishProject($id: ID!) {
  project(id: $id) {
    id
    billable
  }
  getProjectCanBeFinishedSummary(id: $id) {
    id
    project_already_finished
    can_be_finished_without_further_changes
    can_redistribute_credit_automatically
    overinvoiced_for_project
    underinvoiced_for_project
    incomplete_expense_budget_items {
      id
      title
      stats {
        id
        real_expenses_percent
        real_expenses
        real_commission
        real_commission_relative
      }
    }
    incomplete_our_work_budget_items {
      id
      title
      stats {
        id
        spent_time
        spent_budget
      }
      lastWorkInProgressItemStat {
        work_in_progress_id
        progress_percent
      }
    }
    underinvoiced_our_work_budget_items {
      id
      title
      stats {
        id
        uninvoiced
        credit
        total_budget
      }
    }
    underinvoiced_expense_budget_items {
      id
      title
      stats {
        id
        uninvoiced
        credit
        total_budget
      }
    }
    overinvoiced_our_work_budget_items {
      id
      title
      stats {
        id
        credit
        total_budget
        over_invoiced
      }
    }
    overinvoiced_expense_budget_items {
      id
      title
      stats {
        id
        credit
        total_budget
        over_invoiced
      }
    }
  }
}
    `;

/**
 * __useModalFinishProjectQuery__
 *
 * To run a query within a React component, call `useModalFinishProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalFinishProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalFinishProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalFinishProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalFinishProjectQuery, ModalFinishProjectQueryVariables> & ({ variables: ModalFinishProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>(ModalFinishProjectDocument, options);
      }
export function useModalFinishProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>(ModalFinishProjectDocument, options);
        }
export function useModalFinishProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>(ModalFinishProjectDocument, options);
        }
export type ModalFinishProjectQueryHookResult = ReturnType<typeof useModalFinishProjectQuery>;
export type ModalFinishProjectLazyQueryHookResult = ReturnType<typeof useModalFinishProjectLazyQuery>;
export type ModalFinishProjectSuspenseQueryHookResult = ReturnType<typeof useModalFinishProjectSuspenseQuery>;
export type ModalFinishProjectQueryResult = ApolloReactCommon.QueryResult<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>;
export const ModalGetCreditDependenciesDocument = gql`
    query ModalGetCreditDependencies($id: ID!) {
  brand(id: $id) {
    id
    creditAccounts {
      id
      title
      creditAccount {
        id
      }
      stats {
        id
        remaining_credit
      }
    }
  }
}
    `;

/**
 * __useModalGetCreditDependenciesQuery__
 *
 * To run a query within a React component, call `useModalGetCreditDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalGetCreditDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalGetCreditDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalGetCreditDependenciesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables> & ({ variables: ModalGetCreditDependenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>(ModalGetCreditDependenciesDocument, options);
      }
export function useModalGetCreditDependenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>(ModalGetCreditDependenciesDocument, options);
        }
export function useModalGetCreditDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>(ModalGetCreditDependenciesDocument, options);
        }
export type ModalGetCreditDependenciesQueryHookResult = ReturnType<typeof useModalGetCreditDependenciesQuery>;
export type ModalGetCreditDependenciesLazyQueryHookResult = ReturnType<typeof useModalGetCreditDependenciesLazyQuery>;
export type ModalGetCreditDependenciesSuspenseQueryHookResult = ReturnType<typeof useModalGetCreditDependenciesSuspenseQuery>;
export type ModalGetCreditDependenciesQueryResult = ApolloReactCommon.QueryResult<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>;
export const InvoiceProjectDocument = gql`
    mutation InvoiceProject($id: ID!, $amount: BigInt, $expense_budget_item_id: ID, $our_work_budget_item_id: ID) {
  invoiceProject(
    id: $id
    amount: $amount
    expense_budget_item_id: $expense_budget_item_id
    our_work_budget_item_id: $our_work_budget_item_id
  ) {
    id
  }
}
    `;
export type InvoiceProjectMutationFn = ApolloReactCommon.MutationFunction<InvoiceProjectMutation, InvoiceProjectMutationVariables>;

/**
 * __useInvoiceProjectMutation__
 *
 * To run a mutation, you first call `useInvoiceProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceProjectMutation, { data, loading, error }] = useInvoiceProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *      expense_budget_item_id: // value for 'expense_budget_item_id'
 *      our_work_budget_item_id: // value for 'our_work_budget_item_id'
 *   },
 * });
 */
export function useInvoiceProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceProjectMutation, InvoiceProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoiceProjectMutation, InvoiceProjectMutationVariables>(InvoiceProjectDocument, options);
      }
export type InvoiceProjectMutationHookResult = ReturnType<typeof useInvoiceProjectMutation>;
export type InvoiceProjectMutationResult = ApolloReactCommon.MutationResult<InvoiceProjectMutation>;
export type InvoiceProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<InvoiceProjectMutation, InvoiceProjectMutationVariables>;
export const ModalInvoicesOurWorkBiDocument = gql`
    query ModalInvoicesOurWorkBI($id: ID!) {
  ourWorkBudgetItem(id: $id) {
    id
    title
    project {
      id
      billable
      brand {
        id
      }
    }
    creditAccount {
      id
    }
    invoiceStats {
      id
      credit
      outgoingInvoice {
        ...OutgoingInvoiceOfInvoiceStats
      }
    }
    outgoingProformaInvoiceStats {
      id
      amount
      invoice_no
      date
    }
    prepaymentStats {
      id
      date
      credit
      brandCreditAccount {
        id
        title
      }
      ourWorkBudgetItem {
        id
        title
      }
      credit_account_operation_id
    }
    stats {
      id
      credit
      credit_direct
      credit_from_prepayments
      uninvoiced
    }
  }
}
    ${OutgoingInvoiceOfInvoiceStatsFragmentDoc}`;

/**
 * __useModalInvoicesOurWorkBiQuery__
 *
 * To run a query within a React component, call `useModalInvoicesOurWorkBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalInvoicesOurWorkBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalInvoicesOurWorkBiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalInvoicesOurWorkBiQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables> & ({ variables: ModalInvoicesOurWorkBiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>(ModalInvoicesOurWorkBiDocument, options);
      }
export function useModalInvoicesOurWorkBiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>(ModalInvoicesOurWorkBiDocument, options);
        }
export function useModalInvoicesOurWorkBiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>(ModalInvoicesOurWorkBiDocument, options);
        }
export type ModalInvoicesOurWorkBiQueryHookResult = ReturnType<typeof useModalInvoicesOurWorkBiQuery>;
export type ModalInvoicesOurWorkBiLazyQueryHookResult = ReturnType<typeof useModalInvoicesOurWorkBiLazyQuery>;
export type ModalInvoicesOurWorkBiSuspenseQueryHookResult = ReturnType<typeof useModalInvoicesOurWorkBiSuspenseQuery>;
export type ModalInvoicesOurWorkBiQueryResult = ApolloReactCommon.QueryResult<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>;
export const ModalInvoicesExpenseBiDocument = gql`
    query ModalInvoicesExpenseBI($id: ID!) {
  expenseBudgetItem(id: $id) {
    id
    title
    project {
      id
      billable
      brand {
        id
      }
    }
    creditAccount {
      id
    }
    invoiceStats {
      id
      credit
      outgoingInvoice {
        ...OutgoingInvoiceOfInvoiceStats
      }
    }
    outgoingProformaInvoiceStats {
      id
      amount
      invoice_no
      date
    }
    prepaymentStats {
      id
      date
      credit
      brandCreditAccount {
        id
        title
      }
      expenseBudgetItem {
        id
        title
      }
      credit_account_operation_id
    }
    stats {
      id
      credit
      credit_direct
      credit_from_prepayments
      uninvoiced
    }
  }
}
    ${OutgoingInvoiceOfInvoiceStatsFragmentDoc}`;

/**
 * __useModalInvoicesExpenseBiQuery__
 *
 * To run a query within a React component, call `useModalInvoicesExpenseBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalInvoicesExpenseBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalInvoicesExpenseBiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalInvoicesExpenseBiQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables> & ({ variables: ModalInvoicesExpenseBiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>(ModalInvoicesExpenseBiDocument, options);
      }
export function useModalInvoicesExpenseBiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>(ModalInvoicesExpenseBiDocument, options);
        }
export function useModalInvoicesExpenseBiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>(ModalInvoicesExpenseBiDocument, options);
        }
export type ModalInvoicesExpenseBiQueryHookResult = ReturnType<typeof useModalInvoicesExpenseBiQuery>;
export type ModalInvoicesExpenseBiLazyQueryHookResult = ReturnType<typeof useModalInvoicesExpenseBiLazyQuery>;
export type ModalInvoicesExpenseBiSuspenseQueryHookResult = ReturnType<typeof useModalInvoicesExpenseBiSuspenseQuery>;
export type ModalInvoicesExpenseBiQueryResult = ApolloReactCommon.QueryResult<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>;
export const ModalInvoicesProjectDocument = gql`
    query ModalInvoicesProject($id: ID!) {
  project(id: $id) {
    id
    billable
    proformaInvoices {
      id
      invoice_no
      issue_date
      abraflexi_exported
      documentExports {
        ...DocumentExport
      }
      emailLogs {
        ...EmailLog
      }
      stats {
        total_amount
      }
    }
    invoiceStats {
      id
      credit
      outgoingInvoice {
        ...OutgoingInvoiceOfInvoiceStats
      }
    }
    prepaymentStats {
      id
      date
      credit
      brandCreditAccount {
        id
        title
      }
      ourWorkBudgetItem {
        id
        title
      }
      expenseBudgetItem {
        id
        title
      }
    }
    statsCached {
      id
      credit_direct
      credit_from_prepayments
      unused_sum_from_proformas
    }
  }
}
    ${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}
${OutgoingInvoiceOfInvoiceStatsFragmentDoc}`;

/**
 * __useModalInvoicesProjectQuery__
 *
 * To run a query within a React component, call `useModalInvoicesProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalInvoicesProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalInvoicesProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalInvoicesProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables> & ({ variables: ModalInvoicesProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>(ModalInvoicesProjectDocument, options);
      }
export function useModalInvoicesProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>(ModalInvoicesProjectDocument, options);
        }
export function useModalInvoicesProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>(ModalInvoicesProjectDocument, options);
        }
export type ModalInvoicesProjectQueryHookResult = ReturnType<typeof useModalInvoicesProjectQuery>;
export type ModalInvoicesProjectLazyQueryHookResult = ReturnType<typeof useModalInvoicesProjectLazyQuery>;
export type ModalInvoicesProjectSuspenseQueryHookResult = ReturnType<typeof useModalInvoicesProjectSuspenseQuery>;
export type ModalInvoicesProjectQueryResult = ApolloReactCommon.QueryResult<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    ...ModalOrderData
  }
}
    ${ModalOrderDataFragmentDoc}`;
export type CreateOrderMutationFn = ApolloReactCommon.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = ApolloReactCommon.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    ...ModalOrderData
  }
}
    ${ModalOrderDataFragmentDoc}`;
export type UpdateOrderMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = ApolloReactCommon.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const ModalCreateOrderBrandOptionsDocument = gql`
    query ModalCreateOrderBrandOptions {
  clientsSimpleMap {
    brands {
      ...BrandSimpleOptionParts
    }
  }
}
    ${BrandSimpleOptionPartsFragmentDoc}`;

/**
 * __useModalCreateOrderBrandOptionsQuery__
 *
 * To run a query within a React component, call `useModalCreateOrderBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCreateOrderBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCreateOrderBrandOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useModalCreateOrderBrandOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>(ModalCreateOrderBrandOptionsDocument, options);
      }
export function useModalCreateOrderBrandOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>(ModalCreateOrderBrandOptionsDocument, options);
        }
export function useModalCreateOrderBrandOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>(ModalCreateOrderBrandOptionsDocument, options);
        }
export type ModalCreateOrderBrandOptionsQueryHookResult = ReturnType<typeof useModalCreateOrderBrandOptionsQuery>;
export type ModalCreateOrderBrandOptionsLazyQueryHookResult = ReturnType<typeof useModalCreateOrderBrandOptionsLazyQuery>;
export type ModalCreateOrderBrandOptionsSuspenseQueryHookResult = ReturnType<typeof useModalCreateOrderBrandOptionsSuspenseQuery>;
export type ModalCreateOrderBrandOptionsQueryResult = ApolloReactCommon.QueryResult<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>;
export const ModalCreateOrderProjectOptionsDocument = gql`
    query ModalCreateOrderProjectOptions($brandId: ID!) {
  projectsSimpleMap(brand_id: $brandId) {
    ...ProjectSimpleOptionParts
  }
}
    ${ProjectSimpleOptionPartsFragmentDoc}`;

/**
 * __useModalCreateOrderProjectOptionsQuery__
 *
 * To run a query within a React component, call `useModalCreateOrderProjectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCreateOrderProjectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCreateOrderProjectOptionsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useModalCreateOrderProjectOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables> & ({ variables: ModalCreateOrderProjectOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>(ModalCreateOrderProjectOptionsDocument, options);
      }
export function useModalCreateOrderProjectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>(ModalCreateOrderProjectOptionsDocument, options);
        }
export function useModalCreateOrderProjectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>(ModalCreateOrderProjectOptionsDocument, options);
        }
export type ModalCreateOrderProjectOptionsQueryHookResult = ReturnType<typeof useModalCreateOrderProjectOptionsQuery>;
export type ModalCreateOrderProjectOptionsLazyQueryHookResult = ReturnType<typeof useModalCreateOrderProjectOptionsLazyQuery>;
export type ModalCreateOrderProjectOptionsSuspenseQueryHookResult = ReturnType<typeof useModalCreateOrderProjectOptionsSuspenseQuery>;
export type ModalCreateOrderProjectOptionsQueryResult = ApolloReactCommon.QueryResult<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>;
export const ReturnCreditFromOurWorkDocument = gql`
    mutation returnCreditFromOurWork($amount: BigInt!, $our_work_budget_item_id: ID!, $brand_credit_account_id: ID!, $credit_account_operation_id: ID!) {
  returnCreditFromOurWorkBudgetItem(
    amount: $amount
    our_work_budget_item_id: $our_work_budget_item_id
    brand_credit_account_id: $brand_credit_account_id
    credit_account_operation_id: $credit_account_operation_id
  )
}
    `;
export type ReturnCreditFromOurWorkMutationFn = ApolloReactCommon.MutationFunction<ReturnCreditFromOurWorkMutation, ReturnCreditFromOurWorkMutationVariables>;

/**
 * __useReturnCreditFromOurWorkMutation__
 *
 * To run a mutation, you first call `useReturnCreditFromOurWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnCreditFromOurWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnCreditFromOurWorkMutation, { data, loading, error }] = useReturnCreditFromOurWorkMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      our_work_budget_item_id: // value for 'our_work_budget_item_id'
 *      brand_credit_account_id: // value for 'brand_credit_account_id'
 *      credit_account_operation_id: // value for 'credit_account_operation_id'
 *   },
 * });
 */
export function useReturnCreditFromOurWorkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReturnCreditFromOurWorkMutation, ReturnCreditFromOurWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReturnCreditFromOurWorkMutation, ReturnCreditFromOurWorkMutationVariables>(ReturnCreditFromOurWorkDocument, options);
      }
export type ReturnCreditFromOurWorkMutationHookResult = ReturnType<typeof useReturnCreditFromOurWorkMutation>;
export type ReturnCreditFromOurWorkMutationResult = ApolloReactCommon.MutationResult<ReturnCreditFromOurWorkMutation>;
export type ReturnCreditFromOurWorkMutationOptions = ApolloReactCommon.BaseMutationOptions<ReturnCreditFromOurWorkMutation, ReturnCreditFromOurWorkMutationVariables>;
export const ReturnCreditFromExpenseDocument = gql`
    mutation returnCreditFromExpense($amount: BigInt!, $expense_budget_item_id: ID!, $brand_credit_account_id: ID!, $credit_account_operation_id: ID!) {
  returnCreditFromExpenseBudgetItem(
    amount: $amount
    expense_budget_item_id: $expense_budget_item_id
    brand_credit_account_id: $brand_credit_account_id
    credit_account_operation_id: $credit_account_operation_id
  )
}
    `;
export type ReturnCreditFromExpenseMutationFn = ApolloReactCommon.MutationFunction<ReturnCreditFromExpenseMutation, ReturnCreditFromExpenseMutationVariables>;

/**
 * __useReturnCreditFromExpenseMutation__
 *
 * To run a mutation, you first call `useReturnCreditFromExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnCreditFromExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnCreditFromExpenseMutation, { data, loading, error }] = useReturnCreditFromExpenseMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      expense_budget_item_id: // value for 'expense_budget_item_id'
 *      brand_credit_account_id: // value for 'brand_credit_account_id'
 *      credit_account_operation_id: // value for 'credit_account_operation_id'
 *   },
 * });
 */
export function useReturnCreditFromExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReturnCreditFromExpenseMutation, ReturnCreditFromExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReturnCreditFromExpenseMutation, ReturnCreditFromExpenseMutationVariables>(ReturnCreditFromExpenseDocument, options);
      }
export type ReturnCreditFromExpenseMutationHookResult = ReturnType<typeof useReturnCreditFromExpenseMutation>;
export type ReturnCreditFromExpenseMutationResult = ApolloReactCommon.MutationResult<ReturnCreditFromExpenseMutation>;
export type ReturnCreditFromExpenseMutationOptions = ApolloReactCommon.BaseMutationOptions<ReturnCreditFromExpenseMutation, ReturnCreditFromExpenseMutationVariables>;
export const SendQuoteDocument = gql`
    mutation SendQuote($input: quoteSendInput!) {
  sendQuote(input: $input) {
    id
  }
}
    `;
export type SendQuoteMutationFn = ApolloReactCommon.MutationFunction<SendQuoteMutation, SendQuoteMutationVariables>;

/**
 * __useSendQuoteMutation__
 *
 * To run a mutation, you first call `useSendQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuoteMutation, { data, loading, error }] = useSendQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendQuoteMutation, SendQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendQuoteMutation, SendQuoteMutationVariables>(SendQuoteDocument, options);
      }
export type SendQuoteMutationHookResult = ReturnType<typeof useSendQuoteMutation>;
export type SendQuoteMutationResult = ApolloReactCommon.MutationResult<SendQuoteMutation>;
export type SendQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SendQuoteMutation, SendQuoteMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    ...SimpleTask
  }
}
    ${SimpleTaskFragmentDoc}`;
export type CreateTaskMutationFn = ApolloReactCommon.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = ApolloReactCommon.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateScopedTaskDocument = gql`
    mutation CreateScopedTask($input: CreateScopedTaskInput!) {
  createScopedTask(input: $input) {
    ...TaskFragmentForScopedUser
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;
export type CreateScopedTaskMutationFn = ApolloReactCommon.MutationFunction<CreateScopedTaskMutation, CreateScopedTaskMutationVariables>;

/**
 * __useCreateScopedTaskMutation__
 *
 * To run a mutation, you first call `useCreateScopedTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScopedTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScopedTaskMutation, { data, loading, error }] = useCreateScopedTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScopedTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateScopedTaskMutation, CreateScopedTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateScopedTaskMutation, CreateScopedTaskMutationVariables>(CreateScopedTaskDocument, options);
      }
export type CreateScopedTaskMutationHookResult = ReturnType<typeof useCreateScopedTaskMutation>;
export type CreateScopedTaskMutationResult = ApolloReactCommon.MutationResult<CreateScopedTaskMutation>;
export type CreateScopedTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateScopedTaskMutation, CreateScopedTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: ID!) {
  deleteTask(id: $id) {
    id
  }
}
    `;
export type DeleteTaskMutationFn = ApolloReactCommon.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = ApolloReactCommon.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!, $propagate_billable: Boolean!) {
  updateTask(input: $input, propagate_billable: $propagate_billable) {
    ...SimpleTask
  }
}
    ${SimpleTaskFragmentDoc}`;
export type UpdateTaskMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *      propagate_billable: // value for 'propagate_billable'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = ApolloReactCommon.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateScopedTaskDocument = gql`
    mutation UpdateScopedTask($input: UpdateScopedTaskInput!) {
  updateScopedTask(input: $input) {
    ...TaskFragmentForScopedUser
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;
export type UpdateScopedTaskMutationFn = ApolloReactCommon.MutationFunction<UpdateScopedTaskMutation, UpdateScopedTaskMutationVariables>;

/**
 * __useUpdateScopedTaskMutation__
 *
 * To run a mutation, you first call `useUpdateScopedTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScopedTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScopedTaskMutation, { data, loading, error }] = useUpdateScopedTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScopedTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateScopedTaskMutation, UpdateScopedTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateScopedTaskMutation, UpdateScopedTaskMutationVariables>(UpdateScopedTaskDocument, options);
      }
export type UpdateScopedTaskMutationHookResult = ReturnType<typeof useUpdateScopedTaskMutation>;
export type UpdateScopedTaskMutationResult = ApolloReactCommon.MutationResult<UpdateScopedTaskMutation>;
export type UpdateScopedTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateScopedTaskMutation, UpdateScopedTaskMutationVariables>;
export const AvailableTaskPositionsHoursByOurWorkBudgetDocument = gql`
    query AvailableTaskPositionsHoursByOurWorkBudget($our_work_budget_item_id: ID!) {
  availableTaskPositionsHoursByOurWorkBudget(
    our_work_budget_item_id: $our_work_budget_item_id
  ) {
    time_tracking_work_type_id
    planned_time
  }
}
    `;

/**
 * __useAvailableTaskPositionsHoursByOurWorkBudgetQuery__
 *
 * To run a query within a React component, call `useAvailableTaskPositionsHoursByOurWorkBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTaskPositionsHoursByOurWorkBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTaskPositionsHoursByOurWorkBudgetQuery({
 *   variables: {
 *      our_work_budget_item_id: // value for 'our_work_budget_item_id'
 *   },
 * });
 */
export function useAvailableTaskPositionsHoursByOurWorkBudgetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables> & ({ variables: AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>(AvailableTaskPositionsHoursByOurWorkBudgetDocument, options);
      }
export function useAvailableTaskPositionsHoursByOurWorkBudgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>(AvailableTaskPositionsHoursByOurWorkBudgetDocument, options);
        }
export function useAvailableTaskPositionsHoursByOurWorkBudgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>(AvailableTaskPositionsHoursByOurWorkBudgetDocument, options);
        }
export type AvailableTaskPositionsHoursByOurWorkBudgetQueryHookResult = ReturnType<typeof useAvailableTaskPositionsHoursByOurWorkBudgetQuery>;
export type AvailableTaskPositionsHoursByOurWorkBudgetLazyQueryHookResult = ReturnType<typeof useAvailableTaskPositionsHoursByOurWorkBudgetLazyQuery>;
export type AvailableTaskPositionsHoursByOurWorkBudgetSuspenseQueryHookResult = ReturnType<typeof useAvailableTaskPositionsHoursByOurWorkBudgetSuspenseQuery>;
export type AvailableTaskPositionsHoursByOurWorkBudgetQueryResult = ApolloReactCommon.QueryResult<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>;
export const GetPrioritiesOptionsDocument = gql`
    query GetPrioritiesOptions {
  taskPriorities {
    name
    id
  }
}
    `;

/**
 * __useGetPrioritiesOptionsQuery__
 *
 * To run a query within a React component, call `useGetPrioritiesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrioritiesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrioritiesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrioritiesOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>(GetPrioritiesOptionsDocument, options);
      }
export function useGetPrioritiesOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>(GetPrioritiesOptionsDocument, options);
        }
export function useGetPrioritiesOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>(GetPrioritiesOptionsDocument, options);
        }
export type GetPrioritiesOptionsQueryHookResult = ReturnType<typeof useGetPrioritiesOptionsQuery>;
export type GetPrioritiesOptionsLazyQueryHookResult = ReturnType<typeof useGetPrioritiesOptionsLazyQuery>;
export type GetPrioritiesOptionsSuspenseQueryHookResult = ReturnType<typeof useGetPrioritiesOptionsSuspenseQuery>;
export type GetPrioritiesOptionsQueryResult = ApolloReactCommon.QueryResult<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>;
export const GetProjectBillableDocument = gql`
    query GetProjectBillable($projectId: ID) {
  projectsSimpleMap(project_ids: [$projectId]) {
    id
    billable
  }
}
    `;

/**
 * __useGetProjectBillableQuery__
 *
 * To run a query within a React component, call `useGetProjectBillableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectBillableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectBillableQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectBillableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectBillableQuery, GetProjectBillableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectBillableQuery, GetProjectBillableQueryVariables>(GetProjectBillableDocument, options);
      }
export function useGetProjectBillableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectBillableQuery, GetProjectBillableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectBillableQuery, GetProjectBillableQueryVariables>(GetProjectBillableDocument, options);
        }
export function useGetProjectBillableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectBillableQuery, GetProjectBillableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectBillableQuery, GetProjectBillableQueryVariables>(GetProjectBillableDocument, options);
        }
export type GetProjectBillableQueryHookResult = ReturnType<typeof useGetProjectBillableQuery>;
export type GetProjectBillableLazyQueryHookResult = ReturnType<typeof useGetProjectBillableLazyQuery>;
export type GetProjectBillableSuspenseQueryHookResult = ReturnType<typeof useGetProjectBillableSuspenseQuery>;
export type GetProjectBillableQueryResult = ApolloReactCommon.QueryResult<GetProjectBillableQuery, GetProjectBillableQueryVariables>;
export const GetProjectOptionsDocument = gql`
    query GetProjectOptions($withTemplates: Boolean) {
  projectsSimpleMap(with_templates: $withTemplates) {
    id
    title
    code
  }
}
    `;

/**
 * __useGetProjectOptionsQuery__
 *
 * To run a query within a React component, call `useGetProjectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectOptionsQuery({
 *   variables: {
 *      withTemplates: // value for 'withTemplates'
 *   },
 * });
 */
export function useGetProjectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>(GetProjectOptionsDocument, options);
      }
export function useGetProjectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>(GetProjectOptionsDocument, options);
        }
export function useGetProjectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>(GetProjectOptionsDocument, options);
        }
export type GetProjectOptionsQueryHookResult = ReturnType<typeof useGetProjectOptionsQuery>;
export type GetProjectOptionsLazyQueryHookResult = ReturnType<typeof useGetProjectOptionsLazyQuery>;
export type GetProjectOptionsSuspenseQueryHookResult = ReturnType<typeof useGetProjectOptionsSuspenseQuery>;
export type GetProjectOptionsQueryResult = ApolloReactCommon.QueryResult<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>;
export const GetStatusOptionsDocument = gql`
    query GetStatusOptions {
  taskStatuses {
    name
    id
  }
}
    `;

/**
 * __useGetStatusOptionsQuery__
 *
 * To run a query within a React component, call `useGetStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatusOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>(GetStatusOptionsDocument, options);
      }
export function useGetStatusOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>(GetStatusOptionsDocument, options);
        }
export function useGetStatusOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>(GetStatusOptionsDocument, options);
        }
export type GetStatusOptionsQueryHookResult = ReturnType<typeof useGetStatusOptionsQuery>;
export type GetStatusOptionsLazyQueryHookResult = ReturnType<typeof useGetStatusOptionsLazyQuery>;
export type GetStatusOptionsSuspenseQueryHookResult = ReturnType<typeof useGetStatusOptionsSuspenseQuery>;
export type GetStatusOptionsQueryResult = ApolloReactCommon.QueryResult<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>;
export const TimeTrackingWorkTypesDocument = gql`
    query TimeTrackingWorkTypes {
  timeTrackingWorkTypes {
    id
    title
  }
}
    `;

/**
 * __useTimeTrackingWorkTypesQuery__
 *
 * To run a query within a React component, call `useTimeTrackingWorkTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingWorkTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingWorkTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeTrackingWorkTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>(TimeTrackingWorkTypesDocument, options);
      }
export function useTimeTrackingWorkTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>(TimeTrackingWorkTypesDocument, options);
        }
export function useTimeTrackingWorkTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>(TimeTrackingWorkTypesDocument, options);
        }
export type TimeTrackingWorkTypesQueryHookResult = ReturnType<typeof useTimeTrackingWorkTypesQuery>;
export type TimeTrackingWorkTypesLazyQueryHookResult = ReturnType<typeof useTimeTrackingWorkTypesLazyQuery>;
export type TimeTrackingWorkTypesSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingWorkTypesSuspenseQuery>;
export type TimeTrackingWorkTypesQueryResult = ApolloReactCommon.QueryResult<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>;
export const GetUnmatchedWorkTypesForTaskMoveDocument = gql`
    query GetUnmatchedWorkTypesForTaskMove($taskIds: [ID!]!, $newProjectId: ID!) {
  getUnmatchedWorkTypesForTaskMove(
    task_ids: $taskIds
    new_project_id: $newProjectId
  ) {
    unmatched_work_types {
      id
      title
    }
    target_available_work_types {
      id
      title
    }
    has_time_tracking_entries
  }
}
    `;

/**
 * __useGetUnmatchedWorkTypesForTaskMoveQuery__
 *
 * To run a query within a React component, call `useGetUnmatchedWorkTypesForTaskMoveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnmatchedWorkTypesForTaskMoveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnmatchedWorkTypesForTaskMoveQuery({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      newProjectId: // value for 'newProjectId'
 *   },
 * });
 */
export function useGetUnmatchedWorkTypesForTaskMoveQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables> & ({ variables: GetUnmatchedWorkTypesForTaskMoveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>(GetUnmatchedWorkTypesForTaskMoveDocument, options);
      }
export function useGetUnmatchedWorkTypesForTaskMoveLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>(GetUnmatchedWorkTypesForTaskMoveDocument, options);
        }
export function useGetUnmatchedWorkTypesForTaskMoveSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>(GetUnmatchedWorkTypesForTaskMoveDocument, options);
        }
export type GetUnmatchedWorkTypesForTaskMoveQueryHookResult = ReturnType<typeof useGetUnmatchedWorkTypesForTaskMoveQuery>;
export type GetUnmatchedWorkTypesForTaskMoveLazyQueryHookResult = ReturnType<typeof useGetUnmatchedWorkTypesForTaskMoveLazyQuery>;
export type GetUnmatchedWorkTypesForTaskMoveSuspenseQueryHookResult = ReturnType<typeof useGetUnmatchedWorkTypesForTaskMoveSuspenseQuery>;
export type GetUnmatchedWorkTypesForTaskMoveQueryResult = ApolloReactCommon.QueryResult<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>;
export const ModalTaskDependenciesDocument = gql`
    query ModalTaskDependencies($projectId: ID!) {
  projectForTask(id: $projectId) {
    id
    code
    availableTimeTrackingWorkTypes {
      id
      title
    }
    ourWork {
      id
      title
      category {
        name
      }
      timeTrackingSettings {
        tracking_enabled
        tracking_enabled_from
        tracking_enabled_to
      }
    }
  }
}
    `;

/**
 * __useModalTaskDependenciesQuery__
 *
 * To run a query within a React component, call `useModalTaskDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalTaskDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalTaskDependenciesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useModalTaskDependenciesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables> & ({ variables: ModalTaskDependenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>(ModalTaskDependenciesDocument, options);
      }
export function useModalTaskDependenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>(ModalTaskDependenciesDocument, options);
        }
export function useModalTaskDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>(ModalTaskDependenciesDocument, options);
        }
export type ModalTaskDependenciesQueryHookResult = ReturnType<typeof useModalTaskDependenciesQuery>;
export type ModalTaskDependenciesLazyQueryHookResult = ReturnType<typeof useModalTaskDependenciesLazyQuery>;
export type ModalTaskDependenciesSuspenseQueryHookResult = ReturnType<typeof useModalTaskDependenciesSuspenseQuery>;
export type ModalTaskDependenciesQueryResult = ApolloReactCommon.QueryResult<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>;
export const TransferCreditDocument = gql`
    mutation transferCredit($amount: BigInt!, $from_credit_account_id: ID!, $to_credit_account_id: ID!, $outgoing_invoice_id: ID, $performed_at: DateTime) {
  transferCredit(
    amount: $amount
    from_credit_account_id: $from_credit_account_id
    to_credit_account_id: $to_credit_account_id
    outgoing_invoice_id: $outgoing_invoice_id
    performed_at: $performed_at
  )
}
    `;
export type TransferCreditMutationFn = ApolloReactCommon.MutationFunction<TransferCreditMutation, TransferCreditMutationVariables>;

/**
 * __useTransferCreditMutation__
 *
 * To run a mutation, you first call `useTransferCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferCreditMutation, { data, loading, error }] = useTransferCreditMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      from_credit_account_id: // value for 'from_credit_account_id'
 *      to_credit_account_id: // value for 'to_credit_account_id'
 *      outgoing_invoice_id: // value for 'outgoing_invoice_id'
 *      performed_at: // value for 'performed_at'
 *   },
 * });
 */
export function useTransferCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferCreditMutation, TransferCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TransferCreditMutation, TransferCreditMutationVariables>(TransferCreditDocument, options);
      }
export type TransferCreditMutationHookResult = ReturnType<typeof useTransferCreditMutation>;
export type TransferCreditMutationResult = ApolloReactCommon.MutationResult<TransferCreditMutation>;
export type TransferCreditMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferCreditMutation, TransferCreditMutationVariables>;
export const GetModalTransferCreditDependenciesDocument = gql`
    query GetModalTransferCreditDependencies($id: ID!) {
  brandCreditAccount(id: $id) {
    id
    creditAccount {
      id
    }
    stats {
      remaining_credit
    }
    ourWorkBudgetCategories {
      id
    }
    expenseBudgetCategories {
      id
    }
    brand {
      client {
        id
        brands {
          id
          name
          projects {
            id
            title
            code
            billable
            finished_at
          }
          creditAccounts {
            id
            title
            creditAccount {
              id
            }
            ourWorkBudgetCategories {
              id
            }
            expenseBudgetCategories {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetModalTransferCreditDependenciesQuery__
 *
 * To run a query within a React component, call `useGetModalTransferCreditDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModalTransferCreditDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModalTransferCreditDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModalTransferCreditDependenciesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables> & ({ variables: GetModalTransferCreditDependenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>(GetModalTransferCreditDependenciesDocument, options);
      }
export function useGetModalTransferCreditDependenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>(GetModalTransferCreditDependenciesDocument, options);
        }
export function useGetModalTransferCreditDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>(GetModalTransferCreditDependenciesDocument, options);
        }
export type GetModalTransferCreditDependenciesQueryHookResult = ReturnType<typeof useGetModalTransferCreditDependenciesQuery>;
export type GetModalTransferCreditDependenciesLazyQueryHookResult = ReturnType<typeof useGetModalTransferCreditDependenciesLazyQuery>;
export type GetModalTransferCreditDependenciesSuspenseQueryHookResult = ReturnType<typeof useGetModalTransferCreditDependenciesSuspenseQuery>;
export type GetModalTransferCreditDependenciesQueryResult = ApolloReactCommon.QueryResult<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>;
export const GetProjectBudgetItemsDocument = gql`
    query GetProjectBudgetItems($id: ID!) {
  project(id: $id) {
    ourWork {
      id
      title
      creditAccount {
        id
      }
      stats {
        uninvoiced
        credit
      }
      category {
        id
        name
      }
    }
    expenses {
      id
      title
      creditAccount {
        id
      }
      type
      stats {
        uninvoiced
        credit
      }
      category {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetProjectBudgetItemsQuery__
 *
 * To run a query within a React component, call `useGetProjectBudgetItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectBudgetItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectBudgetItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectBudgetItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables> & ({ variables: GetProjectBudgetItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>(GetProjectBudgetItemsDocument, options);
      }
export function useGetProjectBudgetItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>(GetProjectBudgetItemsDocument, options);
        }
export function useGetProjectBudgetItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>(GetProjectBudgetItemsDocument, options);
        }
export type GetProjectBudgetItemsQueryHookResult = ReturnType<typeof useGetProjectBudgetItemsQuery>;
export type GetProjectBudgetItemsLazyQueryHookResult = ReturnType<typeof useGetProjectBudgetItemsLazyQuery>;
export type GetProjectBudgetItemsSuspenseQueryHookResult = ReturnType<typeof useGetProjectBudgetItemsSuspenseQuery>;
export type GetProjectBudgetItemsQueryResult = ApolloReactCommon.QueryResult<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>;
export const CheckIfCreditAccountsBelongToTheSameTeamDocument = gql`
    query checkIfCreditAccountsBelongToTheSameTeam($credit_account_ids: [ID!]!) {
  checkIfCreditAccountsBelongToTheSameTeam(
    credit_account_ids: $credit_account_ids
  )
}
    `;

/**
 * __useCheckIfCreditAccountsBelongToTheSameTeamQuery__
 *
 * To run a query within a React component, call `useCheckIfCreditAccountsBelongToTheSameTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfCreditAccountsBelongToTheSameTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfCreditAccountsBelongToTheSameTeamQuery({
 *   variables: {
 *      credit_account_ids: // value for 'credit_account_ids'
 *   },
 * });
 */
export function useCheckIfCreditAccountsBelongToTheSameTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables> & ({ variables: CheckIfCreditAccountsBelongToTheSameTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>(CheckIfCreditAccountsBelongToTheSameTeamDocument, options);
      }
export function useCheckIfCreditAccountsBelongToTheSameTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>(CheckIfCreditAccountsBelongToTheSameTeamDocument, options);
        }
export function useCheckIfCreditAccountsBelongToTheSameTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>(CheckIfCreditAccountsBelongToTheSameTeamDocument, options);
        }
export type CheckIfCreditAccountsBelongToTheSameTeamQueryHookResult = ReturnType<typeof useCheckIfCreditAccountsBelongToTheSameTeamQuery>;
export type CheckIfCreditAccountsBelongToTheSameTeamLazyQueryHookResult = ReturnType<typeof useCheckIfCreditAccountsBelongToTheSameTeamLazyQuery>;
export type CheckIfCreditAccountsBelongToTheSameTeamSuspenseQueryHookResult = ReturnType<typeof useCheckIfCreditAccountsBelongToTheSameTeamSuspenseQuery>;
export type CheckIfCreditAccountsBelongToTheSameTeamQueryResult = ApolloReactCommon.QueryResult<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>;
export const WipForBudgetAndPeriodDocument = gql`
    query WipForBudgetAndPeriod($our_work_budget_item_id: ID!, $period_id: ID!) {
  wipForBudgetAndPeriod(
    our_work_budget_item_id: $our_work_budget_item_id
    period_id: $period_id
  ) {
    id
    progress_percent
    work_in_progress_id
    is_closed
    is_locked
  }
}
    `;

/**
 * __useWipForBudgetAndPeriodQuery__
 *
 * To run a query within a React component, call `useWipForBudgetAndPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useWipForBudgetAndPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWipForBudgetAndPeriodQuery({
 *   variables: {
 *      our_work_budget_item_id: // value for 'our_work_budget_item_id'
 *      period_id: // value for 'period_id'
 *   },
 * });
 */
export function useWipForBudgetAndPeriodQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables> & ({ variables: WipForBudgetAndPeriodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>(WipForBudgetAndPeriodDocument, options);
      }
export function useWipForBudgetAndPeriodLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>(WipForBudgetAndPeriodDocument, options);
        }
export function useWipForBudgetAndPeriodSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>(WipForBudgetAndPeriodDocument, options);
        }
export type WipForBudgetAndPeriodQueryHookResult = ReturnType<typeof useWipForBudgetAndPeriodQuery>;
export type WipForBudgetAndPeriodLazyQueryHookResult = ReturnType<typeof useWipForBudgetAndPeriodLazyQuery>;
export type WipForBudgetAndPeriodSuspenseQueryHookResult = ReturnType<typeof useWipForBudgetAndPeriodSuspenseQuery>;
export type WipForBudgetAndPeriodQueryResult = ApolloReactCommon.QueryResult<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>;
export const WipPeriodsDocument = gql`
    query WipPeriods($budgetItemId: ID) {
  wipPeriodsMap(budgetItemId: $budgetItemId) {
    id
    title
    starts_at
    ends_at
    is_current
  }
}
    `;

/**
 * __useWipPeriodsQuery__
 *
 * To run a query within a React component, call `useWipPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWipPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWipPeriodsQuery({
 *   variables: {
 *      budgetItemId: // value for 'budgetItemId'
 *   },
 * });
 */
export function useWipPeriodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WipPeriodsQuery, WipPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WipPeriodsQuery, WipPeriodsQueryVariables>(WipPeriodsDocument, options);
      }
export function useWipPeriodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WipPeriodsQuery, WipPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WipPeriodsQuery, WipPeriodsQueryVariables>(WipPeriodsDocument, options);
        }
export function useWipPeriodsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WipPeriodsQuery, WipPeriodsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WipPeriodsQuery, WipPeriodsQueryVariables>(WipPeriodsDocument, options);
        }
export type WipPeriodsQueryHookResult = ReturnType<typeof useWipPeriodsQuery>;
export type WipPeriodsLazyQueryHookResult = ReturnType<typeof useWipPeriodsLazyQuery>;
export type WipPeriodsSuspenseQueryHookResult = ReturnType<typeof useWipPeriodsSuspenseQuery>;
export type WipPeriodsQueryResult = ApolloReactCommon.QueryResult<WipPeriodsQuery, WipPeriodsQueryVariables>;
export const AccessTokenForPlanovacDocument = gql`
    query AccessTokenForPlanovac($appName: ThirdPartyEnum = PLANOVAC) {
  getAccessTokenForThirdParty(appName: $appName)
}
    `;

/**
 * __useAccessTokenForPlanovacQuery__
 *
 * To run a query within a React component, call `useAccessTokenForPlanovacQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessTokenForPlanovacQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessTokenForPlanovacQuery({
 *   variables: {
 *      appName: // value for 'appName'
 *   },
 * });
 */
export function useAccessTokenForPlanovacQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>(AccessTokenForPlanovacDocument, options);
      }
export function useAccessTokenForPlanovacLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>(AccessTokenForPlanovacDocument, options);
        }
export function useAccessTokenForPlanovacSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>(AccessTokenForPlanovacDocument, options);
        }
export type AccessTokenForPlanovacQueryHookResult = ReturnType<typeof useAccessTokenForPlanovacQuery>;
export type AccessTokenForPlanovacLazyQueryHookResult = ReturnType<typeof useAccessTokenForPlanovacLazyQuery>;
export type AccessTokenForPlanovacSuspenseQueryHookResult = ReturnType<typeof useAccessTokenForPlanovacSuspenseQuery>;
export type AccessTokenForPlanovacQueryResult = ApolloReactCommon.QueryResult<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>;
export const ArchiveProjectDocument = gql`
    mutation ArchiveProject($id: ID!) {
  archiveProject(id: $id) {
    ...ArchivedProjectData
  }
}
    ${ArchivedProjectDataFragmentDoc}`;
export type ArchiveProjectMutationFn = ApolloReactCommon.MutationFunction<ArchiveProjectMutation, ArchiveProjectMutationVariables>;

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument, options);
      }
export type ArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectMutation>;
export type ArchiveProjectMutationResult = ApolloReactCommon.MutationResult<ArchiveProjectMutation>;
export type ArchiveProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>;
export const ArchiveProjectsBulkDocument = gql`
    mutation ArchiveProjectsBulk($id: [ID!]!) {
  archiveProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type ArchiveProjectsBulkMutationFn = ApolloReactCommon.MutationFunction<ArchiveProjectsBulkMutation, ArchiveProjectsBulkMutationVariables>;

/**
 * __useArchiveProjectsBulkMutation__
 *
 * To run a mutation, you first call `useArchiveProjectsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectsBulkMutation, { data, loading, error }] = useArchiveProjectsBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProjectsBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveProjectsBulkMutation, ArchiveProjectsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveProjectsBulkMutation, ArchiveProjectsBulkMutationVariables>(ArchiveProjectsBulkDocument, options);
      }
export type ArchiveProjectsBulkMutationHookResult = ReturnType<typeof useArchiveProjectsBulkMutation>;
export type ArchiveProjectsBulkMutationResult = ApolloReactCommon.MutationResult<ArchiveProjectsBulkMutation>;
export type ArchiveProjectsBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveProjectsBulkMutation, ArchiveProjectsBulkMutationVariables>;
export const UnarchiveProjectDocument = gql`
    mutation UnarchiveProject($id: ID!) {
  unarchiveProject(id: $id) {
    ...ArchivedProjectData
  }
}
    ${ArchivedProjectDataFragmentDoc}`;
export type UnarchiveProjectMutationFn = ApolloReactCommon.MutationFunction<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>;

/**
 * __useUnarchiveProjectMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectMutation, { data, loading, error }] = useUnarchiveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>(UnarchiveProjectDocument, options);
      }
export type UnarchiveProjectMutationHookResult = ReturnType<typeof useUnarchiveProjectMutation>;
export type UnarchiveProjectMutationResult = ApolloReactCommon.MutationResult<UnarchiveProjectMutation>;
export type UnarchiveProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>;
export const UnarchiveProjectsBulkDocument = gql`
    mutation UnarchiveProjectsBulk($id: [ID!]!) {
  unarchiveProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type UnarchiveProjectsBulkMutationFn = ApolloReactCommon.MutationFunction<UnarchiveProjectsBulkMutation, UnarchiveProjectsBulkMutationVariables>;

/**
 * __useUnarchiveProjectsBulkMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectsBulkMutation, { data, loading, error }] = useUnarchiveProjectsBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveProjectsBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnarchiveProjectsBulkMutation, UnarchiveProjectsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnarchiveProjectsBulkMutation, UnarchiveProjectsBulkMutationVariables>(UnarchiveProjectsBulkDocument, options);
      }
export type UnarchiveProjectsBulkMutationHookResult = ReturnType<typeof useUnarchiveProjectsBulkMutation>;
export type UnarchiveProjectsBulkMutationResult = ApolloReactCommon.MutationResult<UnarchiveProjectsBulkMutation>;
export type UnarchiveProjectsBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<UnarchiveProjectsBulkMutation, UnarchiveProjectsBulkMutationVariables>;
export const BulkProjectUpdateDocument = gql`
    mutation BulkProjectUpdate($ids: [ID!]!, $input: BulkUpdateProjectsInput!) {
  bulkUpdateProjects(ids: $ids, input: $input) {
    total
    successful
    failed
  }
}
    `;
export type BulkProjectUpdateMutationFn = ApolloReactCommon.MutationFunction<BulkProjectUpdateMutation, BulkProjectUpdateMutationVariables>;

/**
 * __useBulkProjectUpdateMutation__
 *
 * To run a mutation, you first call `useBulkProjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkProjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkProjectUpdateMutation, { data, loading, error }] = useBulkProjectUpdateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkProjectUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkProjectUpdateMutation, BulkProjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkProjectUpdateMutation, BulkProjectUpdateMutationVariables>(BulkProjectUpdateDocument, options);
      }
export type BulkProjectUpdateMutationHookResult = ReturnType<typeof useBulkProjectUpdateMutation>;
export type BulkProjectUpdateMutationResult = ApolloReactCommon.MutationResult<BulkProjectUpdateMutation>;
export type BulkProjectUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkProjectUpdateMutation, BulkProjectUpdateMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    id
  }
}
    `;
export type DeleteProjectMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = ApolloReactCommon.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteProjectsBulkDocument = gql`
    mutation DeleteProjectsBulk($id: [ID!]!) {
  deleteProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type DeleteProjectsBulkMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectsBulkMutation, DeleteProjectsBulkMutationVariables>;

/**
 * __useDeleteProjectsBulkMutation__
 *
 * To run a mutation, you first call `useDeleteProjectsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectsBulkMutation, { data, loading, error }] = useDeleteProjectsBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectsBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectsBulkMutation, DeleteProjectsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectsBulkMutation, DeleteProjectsBulkMutationVariables>(DeleteProjectsBulkDocument, options);
      }
export type DeleteProjectsBulkMutationHookResult = ReturnType<typeof useDeleteProjectsBulkMutation>;
export type DeleteProjectsBulkMutationResult = ApolloReactCommon.MutationResult<DeleteProjectsBulkMutation>;
export type DeleteProjectsBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectsBulkMutation, DeleteProjectsBulkMutationVariables>;
export const InvoiceProjectByTypeDocument = gql`
    mutation InvoiceProjectByType($id: ID!, $invoice_type: RequestForInvoicingTypeEnum!) {
  invoiceProject(id: $id, invoice_type: $invoice_type) {
    id
  }
}
    `;
export type InvoiceProjectByTypeMutationFn = ApolloReactCommon.MutationFunction<InvoiceProjectByTypeMutation, InvoiceProjectByTypeMutationVariables>;

/**
 * __useInvoiceProjectByTypeMutation__
 *
 * To run a mutation, you first call `useInvoiceProjectByTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceProjectByTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceProjectByTypeMutation, { data, loading, error }] = useInvoiceProjectByTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      invoice_type: // value for 'invoice_type'
 *   },
 * });
 */
export function useInvoiceProjectByTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceProjectByTypeMutation, InvoiceProjectByTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoiceProjectByTypeMutation, InvoiceProjectByTypeMutationVariables>(InvoiceProjectByTypeDocument, options);
      }
export type InvoiceProjectByTypeMutationHookResult = ReturnType<typeof useInvoiceProjectByTypeMutation>;
export type InvoiceProjectByTypeMutationResult = ApolloReactCommon.MutationResult<InvoiceProjectByTypeMutation>;
export type InvoiceProjectByTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<InvoiceProjectByTypeMutation, InvoiceProjectByTypeMutationVariables>;
export const InvoiceProjectsByTypeBulkDocument = gql`
    mutation InvoiceProjectsByTypeBulk($id: [ID!]!, $invoice_type: RequestForInvoicingTypeEnum!) {
  invoiceProjectsBulk(id: $id, invoice_type: $invoice_type) {
    id
  }
}
    `;
export type InvoiceProjectsByTypeBulkMutationFn = ApolloReactCommon.MutationFunction<InvoiceProjectsByTypeBulkMutation, InvoiceProjectsByTypeBulkMutationVariables>;

/**
 * __useInvoiceProjectsByTypeBulkMutation__
 *
 * To run a mutation, you first call `useInvoiceProjectsByTypeBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceProjectsByTypeBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceProjectsByTypeBulkMutation, { data, loading, error }] = useInvoiceProjectsByTypeBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      invoice_type: // value for 'invoice_type'
 *   },
 * });
 */
export function useInvoiceProjectsByTypeBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceProjectsByTypeBulkMutation, InvoiceProjectsByTypeBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoiceProjectsByTypeBulkMutation, InvoiceProjectsByTypeBulkMutationVariables>(InvoiceProjectsByTypeBulkDocument, options);
      }
export type InvoiceProjectsByTypeBulkMutationHookResult = ReturnType<typeof useInvoiceProjectsByTypeBulkMutation>;
export type InvoiceProjectsByTypeBulkMutationResult = ApolloReactCommon.MutationResult<InvoiceProjectsByTypeBulkMutation>;
export type InvoiceProjectsByTypeBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<InvoiceProjectsByTypeBulkMutation, InvoiceProjectsByTypeBulkMutationVariables>;
export const PinProjectDocument = gql`
    mutation PinProject($id: ID!) {
  pinProject(id: $id) {
    id
    is_pinned
  }
}
    `;
export type PinProjectMutationFn = ApolloReactCommon.MutationFunction<PinProjectMutation, PinProjectMutationVariables>;

/**
 * __usePinProjectMutation__
 *
 * To run a mutation, you first call `usePinProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinProjectMutation, { data, loading, error }] = usePinProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePinProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PinProjectMutation, PinProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PinProjectMutation, PinProjectMutationVariables>(PinProjectDocument, options);
      }
export type PinProjectMutationHookResult = ReturnType<typeof usePinProjectMutation>;
export type PinProjectMutationResult = ApolloReactCommon.MutationResult<PinProjectMutation>;
export type PinProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<PinProjectMutation, PinProjectMutationVariables>;
export const PinProjectsBulkDocument = gql`
    mutation PinProjectsBulk($id: [ID!]!) {
  pinProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type PinProjectsBulkMutationFn = ApolloReactCommon.MutationFunction<PinProjectsBulkMutation, PinProjectsBulkMutationVariables>;

/**
 * __usePinProjectsBulkMutation__
 *
 * To run a mutation, you first call `usePinProjectsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinProjectsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinProjectsBulkMutation, { data, loading, error }] = usePinProjectsBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePinProjectsBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PinProjectsBulkMutation, PinProjectsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PinProjectsBulkMutation, PinProjectsBulkMutationVariables>(PinProjectsBulkDocument, options);
      }
export type PinProjectsBulkMutationHookResult = ReturnType<typeof usePinProjectsBulkMutation>;
export type PinProjectsBulkMutationResult = ApolloReactCommon.MutationResult<PinProjectsBulkMutation>;
export type PinProjectsBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<PinProjectsBulkMutation, PinProjectsBulkMutationVariables>;
export const UnpinProjectDocument = gql`
    mutation UnpinProject($id: ID!) {
  unpinProject(id: $id) {
    id
    is_pinned
  }
}
    `;
export type UnpinProjectMutationFn = ApolloReactCommon.MutationFunction<UnpinProjectMutation, UnpinProjectMutationVariables>;

/**
 * __useUnpinProjectMutation__
 *
 * To run a mutation, you first call `useUnpinProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinProjectMutation, { data, loading, error }] = useUnpinProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpinProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnpinProjectMutation, UnpinProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnpinProjectMutation, UnpinProjectMutationVariables>(UnpinProjectDocument, options);
      }
export type UnpinProjectMutationHookResult = ReturnType<typeof useUnpinProjectMutation>;
export type UnpinProjectMutationResult = ApolloReactCommon.MutationResult<UnpinProjectMutation>;
export type UnpinProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UnpinProjectMutation, UnpinProjectMutationVariables>;
export const UnpinProjectsBulkDocument = gql`
    mutation UnpinProjectsBulk($id: [ID!]!) {
  unpinProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;
export type UnpinProjectsBulkMutationFn = ApolloReactCommon.MutationFunction<UnpinProjectsBulkMutation, UnpinProjectsBulkMutationVariables>;

/**
 * __useUnpinProjectsBulkMutation__
 *
 * To run a mutation, you first call `useUnpinProjectsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinProjectsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinProjectsBulkMutation, { data, loading, error }] = useUnpinProjectsBulkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpinProjectsBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnpinProjectsBulkMutation, UnpinProjectsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnpinProjectsBulkMutation, UnpinProjectsBulkMutationVariables>(UnpinProjectsBulkDocument, options);
      }
export type UnpinProjectsBulkMutationHookResult = ReturnType<typeof useUnpinProjectsBulkMutation>;
export type UnpinProjectsBulkMutationResult = ApolloReactCommon.MutationResult<UnpinProjectsBulkMutation>;
export type UnpinProjectsBulkMutationOptions = ApolloReactCommon.BaseMutationOptions<UnpinProjectsBulkMutation, UnpinProjectsBulkMutationVariables>;
export const ProformaInvoiceProjectDocument = gql`
    mutation ProformaInvoiceProject($projectId: ID!) {
  proformaInvoiceProject(id: $projectId) {
    id
  }
}
    `;
export type ProformaInvoiceProjectMutationFn = ApolloReactCommon.MutationFunction<ProformaInvoiceProjectMutation, ProformaInvoiceProjectMutationVariables>;

/**
 * __useProformaInvoiceProjectMutation__
 *
 * To run a mutation, you first call `useProformaInvoiceProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProformaInvoiceProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proformaInvoiceProjectMutation, { data, loading, error }] = useProformaInvoiceProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProformaInvoiceProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProformaInvoiceProjectMutation, ProformaInvoiceProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProformaInvoiceProjectMutation, ProformaInvoiceProjectMutationVariables>(ProformaInvoiceProjectDocument, options);
      }
export type ProformaInvoiceProjectMutationHookResult = ReturnType<typeof useProformaInvoiceProjectMutation>;
export type ProformaInvoiceProjectMutationResult = ApolloReactCommon.MutationResult<ProformaInvoiceProjectMutation>;
export type ProformaInvoiceProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<ProformaInvoiceProjectMutation, ProformaInvoiceProjectMutationVariables>;
export const ReopenProjectDocument = gql`
    mutation ReopenProject($id: ID!) {
  reopenProject(id: $id) {
    ...FinishedProjectData
  }
}
    ${FinishedProjectDataFragmentDoc}`;
export type ReopenProjectMutationFn = ApolloReactCommon.MutationFunction<ReopenProjectMutation, ReopenProjectMutationVariables>;

/**
 * __useReopenProjectMutation__
 *
 * To run a mutation, you first call `useReopenProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenProjectMutation, { data, loading, error }] = useReopenProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenProjectMutation, ReopenProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenProjectMutation, ReopenProjectMutationVariables>(ReopenProjectDocument, options);
      }
export type ReopenProjectMutationHookResult = ReturnType<typeof useReopenProjectMutation>;
export type ReopenProjectMutationResult = ApolloReactCommon.MutationResult<ReopenProjectMutation>;
export type ReopenProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenProjectMutation, ReopenProjectMutationVariables>;
export const TimeTrackingPopoverItemsDocument = gql`
    query TimeTrackingPopoverItems($user_id: ID!, $from: Date!, $to: Date!) {
  timeTrackingItems(user_id: $user_id, from: $from, to: $to) {
    ...TimeTrackingEntry
  }
  runningTimer(user_id: $user_id) {
    id
    timeTrackingItem {
      ...TimeTrackingEntry
    }
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

/**
 * __useTimeTrackingPopoverItemsQuery__
 *
 * To run a query within a React component, call `useTimeTrackingPopoverItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackingPopoverItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeTrackingPopoverItemsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTimeTrackingPopoverItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables> & ({ variables: TimeTrackingPopoverItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>(TimeTrackingPopoverItemsDocument, options);
      }
export function useTimeTrackingPopoverItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>(TimeTrackingPopoverItemsDocument, options);
        }
export function useTimeTrackingPopoverItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>(TimeTrackingPopoverItemsDocument, options);
        }
export type TimeTrackingPopoverItemsQueryHookResult = ReturnType<typeof useTimeTrackingPopoverItemsQuery>;
export type TimeTrackingPopoverItemsLazyQueryHookResult = ReturnType<typeof useTimeTrackingPopoverItemsLazyQuery>;
export type TimeTrackingPopoverItemsSuspenseQueryHookResult = ReturnType<typeof useTimeTrackingPopoverItemsSuspenseQuery>;
export type TimeTrackingPopoverItemsQueryResult = ApolloReactCommon.QueryResult<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>;
export const AddAccountMovesToDocumentDocument = gql`
    mutation AddAccountMovesToDocument($documentId: ID!, $documentType: BankDocumentTypeEnum!, $date: Date!, $bankAccountMoves: [BankAccountMoveToDocumentInput!]!) {
  addBankAccountMovesToDocument(
    document_id: $documentId
    document_type: $documentType
    date: $date
    bank_account_moves: $bankAccountMoves
  )
}
    `;
export type AddAccountMovesToDocumentMutationFn = ApolloReactCommon.MutationFunction<AddAccountMovesToDocumentMutation, AddAccountMovesToDocumentMutationVariables>;

/**
 * __useAddAccountMovesToDocumentMutation__
 *
 * To run a mutation, you first call `useAddAccountMovesToDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountMovesToDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountMovesToDocumentMutation, { data, loading, error }] = useAddAccountMovesToDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentType: // value for 'documentType'
 *      date: // value for 'date'
 *      bankAccountMoves: // value for 'bankAccountMoves'
 *   },
 * });
 */
export function useAddAccountMovesToDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAccountMovesToDocumentMutation, AddAccountMovesToDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAccountMovesToDocumentMutation, AddAccountMovesToDocumentMutationVariables>(AddAccountMovesToDocumentDocument, options);
      }
export type AddAccountMovesToDocumentMutationHookResult = ReturnType<typeof useAddAccountMovesToDocumentMutation>;
export type AddAccountMovesToDocumentMutationResult = ApolloReactCommon.MutationResult<AddAccountMovesToDocumentMutation>;
export type AddAccountMovesToDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAccountMovesToDocumentMutation, AddAccountMovesToDocumentMutationVariables>;
export const CreateFilterTemplateDocument = gql`
    mutation CreateFilterTemplate($input: FilterTemplateInput!) {
  createFilterTemplate(input: $input) {
    ...FilterTemplateFragment
  }
}
    ${FilterTemplateFragmentFragmentDoc}`;
export type CreateFilterTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateFilterTemplateMutation, CreateFilterTemplateMutationVariables>;

/**
 * __useCreateFilterTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFilterTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilterTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilterTemplateMutation, { data, loading, error }] = useCreateFilterTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFilterTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFilterTemplateMutation, CreateFilterTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFilterTemplateMutation, CreateFilterTemplateMutationVariables>(CreateFilterTemplateDocument, options);
      }
export type CreateFilterTemplateMutationHookResult = ReturnType<typeof useCreateFilterTemplateMutation>;
export type CreateFilterTemplateMutationResult = ApolloReactCommon.MutationResult<CreateFilterTemplateMutation>;
export type CreateFilterTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFilterTemplateMutation, CreateFilterTemplateMutationVariables>;
export const DeleteFilterTemplateDocument = gql`
    mutation DeleteFilterTemplate($id: ID!) {
  deleteFilterTemplate(id: $id)
}
    `;
export type DeleteFilterTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteFilterTemplateMutation, DeleteFilterTemplateMutationVariables>;

/**
 * __useDeleteFilterTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteFilterTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilterTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilterTemplateMutation, { data, loading, error }] = useDeleteFilterTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFilterTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilterTemplateMutation, DeleteFilterTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilterTemplateMutation, DeleteFilterTemplateMutationVariables>(DeleteFilterTemplateDocument, options);
      }
export type DeleteFilterTemplateMutationHookResult = ReturnType<typeof useDeleteFilterTemplateMutation>;
export type DeleteFilterTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteFilterTemplateMutation>;
export type DeleteFilterTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFilterTemplateMutation, DeleteFilterTemplateMutationVariables>;
export const FilterTemplatesDocument = gql`
    query FilterTemplates($modelId: ID, $modelType: String!, $type: String) {
  filterTemplates(model_id: $modelId, model_type: $modelType, type: $type) {
    ...FilterTemplateFragment
  }
}
    ${FilterTemplateFragmentFragmentDoc}`;

/**
 * __useFilterTemplatesQuery__
 *
 * To run a query within a React component, call `useFilterTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTemplatesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      modelType: // value for 'modelType'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFilterTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FilterTemplatesQuery, FilterTemplatesQueryVariables> & ({ variables: FilterTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FilterTemplatesQuery, FilterTemplatesQueryVariables>(FilterTemplatesDocument, options);
      }
export function useFilterTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilterTemplatesQuery, FilterTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FilterTemplatesQuery, FilterTemplatesQueryVariables>(FilterTemplatesDocument, options);
        }
export function useFilterTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FilterTemplatesQuery, FilterTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FilterTemplatesQuery, FilterTemplatesQueryVariables>(FilterTemplatesDocument, options);
        }
export type FilterTemplatesQueryHookResult = ReturnType<typeof useFilterTemplatesQuery>;
export type FilterTemplatesLazyQueryHookResult = ReturnType<typeof useFilterTemplatesLazyQuery>;
export type FilterTemplatesSuspenseQueryHookResult = ReturnType<typeof useFilterTemplatesSuspenseQuery>;
export type FilterTemplatesQueryResult = ApolloReactCommon.QueryResult<FilterTemplatesQuery, FilterTemplatesQueryVariables>;
export const UpdateWorkspaceSettingsDocument = gql`
    mutation UpdateWorkspaceSettings($notifications: updateWorkspaceNotifications!, $tasks: InputWorkspaceTaskSettings!, $companies: InputWorkspaceCompanySetting!, $financial: InputWorkspaceFinancialSetting!, $accountingAccounts: InputUpdateWorkspaceAccountingAccountSettings!, $costCenters: InputUpdateWorkspaceAccountingCentreSettings!, $accountingVatClassifications: InputUpdateWorkspaceAccountingVatClassificationSettings!, $userManagement: InputWorkspaceUserManagementSetting!, $planningUtilization: InputWorkspacePlanningSetting!, $planningViewSettings: UpdatePlanningSettings!, $projects: InputUpdateWorkspaceProjectSettings!, $pipedrive: InputUpdateWorkspacePipedriveIntegration) {
  UpdateWorkspaceNotifications(input: $notifications) {
    id
  }
  updateWorkspaceTaskSettings(input: $tasks) {
    show_done_tasks
    use_current_assignee
  }
  updateWorkspaceCompanies(input: $companies) {
    id
  }
  updateWorkspaceFinancialSettings(input: $financial) {
    vat_rates {
      id
    }
  }
  updateWorkspaceAccountingAccountSettings(input: $accountingAccounts) {
    accounting_accounts {
      id
    }
  }
  updateWorkspaceAccountingCentreSettings(input: $costCenters) {
    accounting_centres {
      id
    }
  }
  updateWorkspaceAccountingVatClassificationSettings(
    input: $accountingVatClassifications
  ) {
    accounting_vat_classifications {
      id
    }
  }
  updateWorkspaceUserManagementSettings(input: $userManagement) {
    require_two_factor_authentication
  }
  updateWorkspacePlanningSettings(input: $planningUtilization) {
    specific_time_in_planning_enabled
  }
  updatePlanningSettings(input: $planningViewSettings) {
    title
  }
  updateWorkspaceProjectSettings(input: $projects) {
    project_code_with_year
  }
  updateWorkspacePipedriveIntegration(input: $pipedrive) {
    settings {
      pipedrive_stage_id
      project_stage_id
      project_billable
    }
  }
}
    `;
export type UpdateWorkspaceSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>;

/**
 * __useUpdateWorkspaceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceSettingsMutation, { data, loading, error }] = useUpdateWorkspaceSettingsMutation({
 *   variables: {
 *      notifications: // value for 'notifications'
 *      tasks: // value for 'tasks'
 *      companies: // value for 'companies'
 *      financial: // value for 'financial'
 *      accountingAccounts: // value for 'accountingAccounts'
 *      costCenters: // value for 'costCenters'
 *      accountingVatClassifications: // value for 'accountingVatClassifications'
 *      userManagement: // value for 'userManagement'
 *      planningUtilization: // value for 'planningUtilization'
 *      planningViewSettings: // value for 'planningViewSettings'
 *      projects: // value for 'projects'
 *      pipedrive: // value for 'pipedrive'
 *   },
 * });
 */
export function useUpdateWorkspaceSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>(UpdateWorkspaceSettingsDocument, options);
      }
export type UpdateWorkspaceSettingsMutationHookResult = ReturnType<typeof useUpdateWorkspaceSettingsMutation>;
export type UpdateWorkspaceSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceSettingsMutation>;
export type UpdateWorkspaceSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>;
export const TestImapConnectionDocument = gql`
    mutation TestImapConnection {
  testWorkspaceAutoExpenseEmail
}
    `;
export type TestImapConnectionMutationFn = ApolloReactCommon.MutationFunction<TestImapConnectionMutation, TestImapConnectionMutationVariables>;

/**
 * __useTestImapConnectionMutation__
 *
 * To run a mutation, you first call `useTestImapConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestImapConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testImapConnectionMutation, { data, loading, error }] = useTestImapConnectionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestImapConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestImapConnectionMutation, TestImapConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestImapConnectionMutation, TestImapConnectionMutationVariables>(TestImapConnectionDocument, options);
      }
export type TestImapConnectionMutationHookResult = ReturnType<typeof useTestImapConnectionMutation>;
export type TestImapConnectionMutationResult = ApolloReactCommon.MutationResult<TestImapConnectionMutation>;
export type TestImapConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestImapConnectionMutation, TestImapConnectionMutationVariables>;
export const CreateWorkspaceSmtpSettingsDocument = gql`
    mutation CreateWorkspaceSmtpSettings($input: CreateWorkspaceSmtpSettingsInput!) {
  createWorkspaceSmtpSettings(input: $input) {
    id
    active
    smtp_host
    smtp_port
    smtp_username
    smtp_encryption
    smtp_from_address
    smtp_from_name
  }
}
    `;
export type CreateWorkspaceSmtpSettingsMutationFn = ApolloReactCommon.MutationFunction<CreateWorkspaceSmtpSettingsMutation, CreateWorkspaceSmtpSettingsMutationVariables>;

/**
 * __useCreateWorkspaceSmtpSettingsMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceSmtpSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceSmtpSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceSmtpSettingsMutation, { data, loading, error }] = useCreateWorkspaceSmtpSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceSmtpSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWorkspaceSmtpSettingsMutation, CreateWorkspaceSmtpSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkspaceSmtpSettingsMutation, CreateWorkspaceSmtpSettingsMutationVariables>(CreateWorkspaceSmtpSettingsDocument, options);
      }
export type CreateWorkspaceSmtpSettingsMutationHookResult = ReturnType<typeof useCreateWorkspaceSmtpSettingsMutation>;
export type CreateWorkspaceSmtpSettingsMutationResult = ApolloReactCommon.MutationResult<CreateWorkspaceSmtpSettingsMutation>;
export type CreateWorkspaceSmtpSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWorkspaceSmtpSettingsMutation, CreateWorkspaceSmtpSettingsMutationVariables>;
export const UpdateWorkspaceSmtpSettingsDocument = gql`
    mutation UpdateWorkspaceSmtpSettings($id: ID!, $input: UpdateWorkspaceSmtpSettingsInput!) {
  updateWorkspaceSmtpSettings(id: $id, input: $input) {
    id
    active
    smtp_host
    smtp_port
    smtp_username
    smtp_encryption
    smtp_from_address
    smtp_from_name
  }
}
    `;
export type UpdateWorkspaceSmtpSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspaceSmtpSettingsMutation, UpdateWorkspaceSmtpSettingsMutationVariables>;

/**
 * __useUpdateWorkspaceSmtpSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceSmtpSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceSmtpSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceSmtpSettingsMutation, { data, loading, error }] = useUpdateWorkspaceSmtpSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceSmtpSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceSmtpSettingsMutation, UpdateWorkspaceSmtpSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceSmtpSettingsMutation, UpdateWorkspaceSmtpSettingsMutationVariables>(UpdateWorkspaceSmtpSettingsDocument, options);
      }
export type UpdateWorkspaceSmtpSettingsMutationHookResult = ReturnType<typeof useUpdateWorkspaceSmtpSettingsMutation>;
export type UpdateWorkspaceSmtpSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceSmtpSettingsMutation>;
export type UpdateWorkspaceSmtpSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspaceSmtpSettingsMutation, UpdateWorkspaceSmtpSettingsMutationVariables>;
export const TestSmtpConnectionDocument = gql`
    mutation TestSmtpConnection($input: TestSmtpConnectionInput!) {
  testSmtpConnection(input: $input) {
    error
    message
    success
  }
}
    `;
export type TestSmtpConnectionMutationFn = ApolloReactCommon.MutationFunction<TestSmtpConnectionMutation, TestSmtpConnectionMutationVariables>;

/**
 * __useTestSmtpConnectionMutation__
 *
 * To run a mutation, you first call `useTestSmtpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestSmtpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testSmtpConnectionMutation, { data, loading, error }] = useTestSmtpConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestSmtpConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestSmtpConnectionMutation, TestSmtpConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestSmtpConnectionMutation, TestSmtpConnectionMutationVariables>(TestSmtpConnectionDocument, options);
      }
export type TestSmtpConnectionMutationHookResult = ReturnType<typeof useTestSmtpConnectionMutation>;
export type TestSmtpConnectionMutationResult = ApolloReactCommon.MutationResult<TestSmtpConnectionMutation>;
export type TestSmtpConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestSmtpConnectionMutation, TestSmtpConnectionMutationVariables>;
export const SendTestEmailDocument = gql`
    mutation SendTestEmail($input: CreateWorkspaceSmtpSettingsInput!) {
  sendTestEmail(input: $input) {
    error
    message
    success
  }
}
    `;
export type SendTestEmailMutationFn = ApolloReactCommon.MutationFunction<SendTestEmailMutation, SendTestEmailMutationVariables>;

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestEmailMutation, SendTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendTestEmailMutation, SendTestEmailMutationVariables>(SendTestEmailDocument, options);
      }
export type SendTestEmailMutationHookResult = ReturnType<typeof useSendTestEmailMutation>;
export type SendTestEmailMutationResult = ApolloReactCommon.MutationResult<SendTestEmailMutation>;
export type SendTestEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendTestEmailMutation, SendTestEmailMutationVariables>;
export const GlobalWorkspaceSettingsDocument = gql`
    query GlobalWorkspaceSettings {
  currencies {
    id
    code
    denomination
  }
  teamSimpleMap {
    id
    name
    is_default
    user_count
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
  workspaceAccountingAccountSetting {
    ...WorkspaceAccountingAccountSettings
  }
  workspaceAccountingVatClassificationSetting {
    ...WorkspaceAccountingVatClassificationSetting
  }
  workspaceSettings {
    ...WorkspaceSettings
  }
}
    ${WorkspaceAccountingAccountSettingsFragmentDoc}
${WorkspaceAccountingVatClassificationSettingFragmentDoc}
${WorkspaceSettingsFragmentDoc}`;

/**
 * __useGlobalWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGlobalWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalWorkspaceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalWorkspaceSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>(GlobalWorkspaceSettingsDocument, options);
      }
export function useGlobalWorkspaceSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>(GlobalWorkspaceSettingsDocument, options);
        }
export function useGlobalWorkspaceSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>(GlobalWorkspaceSettingsDocument, options);
        }
export type GlobalWorkspaceSettingsQueryHookResult = ReturnType<typeof useGlobalWorkspaceSettingsQuery>;
export type GlobalWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGlobalWorkspaceSettingsLazyQuery>;
export type GlobalWorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useGlobalWorkspaceSettingsSuspenseQuery>;
export type GlobalWorkspaceSettingsQueryResult = ApolloReactCommon.QueryResult<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>;
export const TeamUsersDocument = gql`
    query TeamUsers($team_id: Mixed!) {
  userSimpleMap(where: {column: TEAM_ID, value: $team_id}) {
    id
    full_name
    profile {
      hex_color
    }
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;

/**
 * __useTeamUsersQuery__
 *
 * To run a query within a React component, call `useTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamUsersQuery({
 *   variables: {
 *      team_id: // value for 'team_id'
 *   },
 * });
 */
export function useTeamUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamUsersQuery, TeamUsersQueryVariables> & ({ variables: TeamUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamUsersQuery, TeamUsersQueryVariables>(TeamUsersDocument, options);
      }
export function useTeamUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamUsersQuery, TeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamUsersQuery, TeamUsersQueryVariables>(TeamUsersDocument, options);
        }
export function useTeamUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamUsersQuery, TeamUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamUsersQuery, TeamUsersQueryVariables>(TeamUsersDocument, options);
        }
export type TeamUsersQueryHookResult = ReturnType<typeof useTeamUsersQuery>;
export type TeamUsersLazyQueryHookResult = ReturnType<typeof useTeamUsersLazyQuery>;
export type TeamUsersSuspenseQueryHookResult = ReturnType<typeof useTeamUsersSuspenseQuery>;
export type TeamUsersQueryResult = ApolloReactCommon.QueryResult<TeamUsersQuery, TeamUsersQueryVariables>;
export const WorkspaceSettingsDocument = gql`
    query WorkspaceSettings {
  roles {
    name
  }
  workspaceSettings {
    bmail_activated
  }
  countrySimpleMap {
    id
    name
  }
  WorkspaceNotifications {
    database_enabled
    description
    id
    mail_enabled
    name
    roles_to_notify
    threshold
    threshold_type
    to_roles
  }
  workspaceTaskSettings {
    task_statuses {
      background_color
      default
      done
      foreground_color
      id
      name
      order
    }
    task_priorities {
      default
      id
      name
      order
      system_priority
      emoji
    }
    show_done_tasks
    use_current_assignee
  }
  workspaceCompaniesSettings {
    city
    country_id
    currency_id
    deleted
    id
    internal_name
    is_default
    name
    registration_no
    street
    tax_no
    vat_no
    zip
    bank_accounts {
      account_holder_name
      bank_account
      bank_code
      bank_name
      bic
      deleted
      iban
      id
    }
    sequences {
      id
      format
      next_number
      types
    }
    pdfSettings {
      logo_assignable_file {
        public_id
        urls {
          original
        }
      }
      stamp_assignable_file {
        public_id
        urls {
          original
        }
      }
    }
  }
  workspaceFinancialSettings {
    default_show_unit_price_on_invoices
    default_show_billing_accounting_on_invoices
    invoice_attachment_name_templates {
      outgoing_invoice
      outgoing_proforma
      payment_receipt
    }
    vat_rates {
      id
      amount
      deleted
      default
    }
    currencies {
      id
      code
      exchange_rate
      denomination
    }
  }
  defaultCurrencies {
    code
    symbol
  }
  workspaceAccountingAccountSetting {
    ...WorkspaceAccountingAccountSettings
  }
  ourWorkBudgetCategories {
    id
    name
  }
  expenseBudgetCategories {
    id
    name
  }
  workspaceAccountingCentreSetting {
    accounting_centres {
      ...CostCenter
    }
  }
  workspaceAccountingVatClassificationSetting {
    accounting_vat_classifications {
      id
      type
      vat_rate_id
      centre
      title
      deleted_at
    }
  }
  workspaceUserManagementSetting {
    teams {
      id
      name
      deleted_at
      is_default
      user_count
    }
    require_two_factor_authentication
  }
  updateWorkspacePlanningSettings {
    working_from
    working_to
    default_user_plannable_capacity
    specific_time_in_planning_enabled
    hide_planning_total_daily_capacity
    planning_alphabet_user_order
    disable_home_office_in_planning
    start_day_of_week
    default_utilization_range_from
    default_utilization_range_to
    planning_sort_prioritize_time_specific_items
  }
  workspaceProjectSettings {
    project_code_generator
    project_code_length
    project_code_with_year
    can_close_expense_budget_item_with_unapproved_expenses
    create_default_task_enabled
    create_default_task_only_to_our_work_category
    our_work_budget_categories_count
    project_count
    automate_invoicing_plan_approval
    enable_additional_brand_numeric_code
  }
  banksQuery {
    api_id
    name
    logo
    url
  }
  workspacePipedriveIntegration {
    initialization_url
    settings {
      pipedrive_stage_id
      project_stage_id
      project_billable
    }
  }
  workspaceAutoExpenseEmailSettings {
    imap_host
    imap_port
    imap_username
    imap_encryption
    is_active
  }
  workspaceSmtpSettings {
    id
    active
    is_google_connected
    is_microsoft_connected
    smtp_host
    smtp_port
    smtp_username
    smtp_encryption
    smtp_from_address
    smtp_from_name
  }
}
    ${WorkspaceAccountingAccountSettingsFragmentDoc}
${CostCenterFragmentDoc}`;

/**
 * __useWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>(WorkspaceSettingsDocument, options);
      }
export function useWorkspaceSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>(WorkspaceSettingsDocument, options);
        }
export function useWorkspaceSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>(WorkspaceSettingsDocument, options);
        }
export type WorkspaceSettingsQueryHookResult = ReturnType<typeof useWorkspaceSettingsQuery>;
export type WorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useWorkspaceSettingsLazyQuery>;
export type WorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSettingsSuspenseQuery>;
export type WorkspaceSettingsQueryResult = ApolloReactCommon.QueryResult<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>;
export const TaskStatsDocument = gql`
    query TaskStats($id: ID!) {
  task(id: $id) {
    stats {
      spent_time
      planned_time
    }
  }
}
    `;

/**
 * __useTaskStatsQuery__
 *
 * To run a query within a React component, call `useTaskStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskStatsQuery, TaskStatsQueryVariables> & ({ variables: TaskStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskStatsQuery, TaskStatsQueryVariables>(TaskStatsDocument, options);
      }
export function useTaskStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskStatsQuery, TaskStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskStatsQuery, TaskStatsQueryVariables>(TaskStatsDocument, options);
        }
export function useTaskStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskStatsQuery, TaskStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskStatsQuery, TaskStatsQueryVariables>(TaskStatsDocument, options);
        }
export type TaskStatsQueryHookResult = ReturnType<typeof useTaskStatsQuery>;
export type TaskStatsLazyQueryHookResult = ReturnType<typeof useTaskStatsLazyQuery>;
export type TaskStatsSuspenseQueryHookResult = ReturnType<typeof useTaskStatsSuspenseQuery>;
export type TaskStatsQueryResult = ApolloReactCommon.QueryResult<TaskStatsQuery, TaskStatsQueryVariables>;
export const LoginDocument = gql`
    query Login {
  currencies {
    id
    code
    denomination
    exchange_rate
  }
  me {
    ...Me
  }
  teamSimpleMap {
    id
    name
    is_default
    user_count
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
  workspaceAccountingAccountSetting {
    ...WorkspaceAccountingAccountSettings
  }
  workspaceSettings {
    ...WorkspaceSettings
  }
  workspaceAccountingVatClassificationSetting {
    ...WorkspaceAccountingVatClassificationSetting
  }
}
    ${MeFragmentDoc}
${WorkspaceAccountingAccountSettingsFragmentDoc}
${WorkspaceSettingsFragmentDoc}
${WorkspaceAccountingVatClassificationSettingFragmentDoc}`;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoginQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export function useLoginSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginSuspenseQueryHookResult = ReturnType<typeof useLoginSuspenseQuery>;
export type LoginQueryResult = ApolloReactCommon.QueryResult<LoginQuery, LoginQueryVariables>;
export const LockModelDocument = gql`
    mutation LockModel($lockable_id: ID!, $lockable_type: ModelLockLockableTypeEnum!) {
  lockModel(lockable_id: $lockable_id, lockable_type: $lockable_type) {
    ...ModelLock
  }
}
    ${ModelLockFragmentDoc}`;
export type LockModelMutationFn = ApolloReactCommon.MutationFunction<LockModelMutation, LockModelMutationVariables>;

/**
 * __useLockModelMutation__
 *
 * To run a mutation, you first call `useLockModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockModelMutation, { data, loading, error }] = useLockModelMutation({
 *   variables: {
 *      lockable_id: // value for 'lockable_id'
 *      lockable_type: // value for 'lockable_type'
 *   },
 * });
 */
export function useLockModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LockModelMutation, LockModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LockModelMutation, LockModelMutationVariables>(LockModelDocument, options);
      }
export type LockModelMutationHookResult = ReturnType<typeof useLockModelMutation>;
export type LockModelMutationResult = ApolloReactCommon.MutationResult<LockModelMutation>;
export type LockModelMutationOptions = ApolloReactCommon.BaseMutationOptions<LockModelMutation, LockModelMutationVariables>;
export const UnlockModelDocument = gql`
    mutation UnlockModel($lockable_id: ID!, $lockable_type: ModelLockLockableTypeEnum!) {
  unlockModel(lockable_id: $lockable_id, lockable_type: $lockable_type)
}
    `;
export type UnlockModelMutationFn = ApolloReactCommon.MutationFunction<UnlockModelMutation, UnlockModelMutationVariables>;

/**
 * __useUnlockModelMutation__
 *
 * To run a mutation, you first call `useUnlockModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockModelMutation, { data, loading, error }] = useUnlockModelMutation({
 *   variables: {
 *      lockable_id: // value for 'lockable_id'
 *      lockable_type: // value for 'lockable_type'
 *   },
 * });
 */
export function useUnlockModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlockModelMutation, UnlockModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlockModelMutation, UnlockModelMutationVariables>(UnlockModelDocument, options);
      }
export type UnlockModelMutationHookResult = ReturnType<typeof useUnlockModelMutation>;
export type UnlockModelMutationResult = ApolloReactCommon.MutationResult<UnlockModelMutation>;
export type UnlockModelMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlockModelMutation, UnlockModelMutationVariables>;
export const BulkLockModelDocument = gql`
    mutation BulkLockModel($lockable_ids: [ID!]!, $lockable_type: ModelLockLockableTypeEnum!) {
  bulkLockModel(lockable_ids: $lockable_ids, lockable_type: $lockable_type) {
    total
    failed
  }
}
    `;
export type BulkLockModelMutationFn = ApolloReactCommon.MutationFunction<BulkLockModelMutation, BulkLockModelMutationVariables>;

/**
 * __useBulkLockModelMutation__
 *
 * To run a mutation, you first call `useBulkLockModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkLockModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkLockModelMutation, { data, loading, error }] = useBulkLockModelMutation({
 *   variables: {
 *      lockable_ids: // value for 'lockable_ids'
 *      lockable_type: // value for 'lockable_type'
 *   },
 * });
 */
export function useBulkLockModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkLockModelMutation, BulkLockModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkLockModelMutation, BulkLockModelMutationVariables>(BulkLockModelDocument, options);
      }
export type BulkLockModelMutationHookResult = ReturnType<typeof useBulkLockModelMutation>;
export type BulkLockModelMutationResult = ApolloReactCommon.MutationResult<BulkLockModelMutation>;
export type BulkLockModelMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkLockModelMutation, BulkLockModelMutationVariables>;
export const BulkUnlockModelDocument = gql`
    mutation BulkUnlockModel($lockable_ids: [ID!]!, $lockable_type: ModelLockLockableTypeEnum!) {
  bulkUnlockModel(lockable_ids: $lockable_ids, lockable_type: $lockable_type) {
    total
    failed
  }
}
    `;
export type BulkUnlockModelMutationFn = ApolloReactCommon.MutationFunction<BulkUnlockModelMutation, BulkUnlockModelMutationVariables>;

/**
 * __useBulkUnlockModelMutation__
 *
 * To run a mutation, you first call `useBulkUnlockModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnlockModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnlockModelMutation, { data, loading, error }] = useBulkUnlockModelMutation({
 *   variables: {
 *      lockable_ids: // value for 'lockable_ids'
 *      lockable_type: // value for 'lockable_type'
 *   },
 * });
 */
export function useBulkUnlockModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUnlockModelMutation, BulkUnlockModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUnlockModelMutation, BulkUnlockModelMutationVariables>(BulkUnlockModelDocument, options);
      }
export type BulkUnlockModelMutationHookResult = ReturnType<typeof useBulkUnlockModelMutation>;
export type BulkUnlockModelMutationResult = ApolloReactCommon.MutationResult<BulkUnlockModelMutation>;
export type BulkUnlockModelMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUnlockModelMutation, BulkUnlockModelMutationVariables>;
export const GetModelLockDocument = gql`
    query GetModelLock($lockable_id: ID!, $lockable_type: ModelLockLockableTypeEnum!) {
  getModelLock(lockable_id: $lockable_id, lockable_type: $lockable_type) {
    ...ModelLock
  }
}
    ${ModelLockFragmentDoc}`;

/**
 * __useGetModelLockQuery__
 *
 * To run a query within a React component, call `useGetModelLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelLockQuery({
 *   variables: {
 *      lockable_id: // value for 'lockable_id'
 *      lockable_type: // value for 'lockable_type'
 *   },
 * });
 */
export function useGetModelLockQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetModelLockQuery, GetModelLockQueryVariables> & ({ variables: GetModelLockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetModelLockQuery, GetModelLockQueryVariables>(GetModelLockDocument, options);
      }
export function useGetModelLockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetModelLockQuery, GetModelLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetModelLockQuery, GetModelLockQueryVariables>(GetModelLockDocument, options);
        }
export function useGetModelLockSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetModelLockQuery, GetModelLockQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetModelLockQuery, GetModelLockQueryVariables>(GetModelLockDocument, options);
        }
export type GetModelLockQueryHookResult = ReturnType<typeof useGetModelLockQuery>;
export type GetModelLockLazyQueryHookResult = ReturnType<typeof useGetModelLockLazyQuery>;
export type GetModelLockSuspenseQueryHookResult = ReturnType<typeof useGetModelLockSuspenseQuery>;
export type GetModelLockQueryResult = ApolloReactCommon.QueryResult<GetModelLockQuery, GetModelLockQueryVariables>;
export const UpdateProjectStageDocument = gql`
    mutation UpdateProjectStage($projectId: ID!, $projectStageId: ID!) {
  updateProjectStage(project_id: $projectId, project_stage_id: $projectStageId) {
    id
    project_stage {
      ...ProjectStage
    }
  }
}
    ${ProjectStageFragmentDoc}`;
export type UpdateProjectStageMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectStageMutation, UpdateProjectStageMutationVariables>;

/**
 * __useUpdateProjectStageMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStageMutation, { data, loading, error }] = useUpdateProjectStageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      projectStageId: // value for 'projectStageId'
 *   },
 * });
 */
export function useUpdateProjectStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectStageMutation, UpdateProjectStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectStageMutation, UpdateProjectStageMutationVariables>(UpdateProjectStageDocument, options);
      }
export type UpdateProjectStageMutationHookResult = ReturnType<typeof useUpdateProjectStageMutation>;
export type UpdateProjectStageMutationResult = ApolloReactCommon.MutationResult<UpdateProjectStageMutation>;
export type UpdateProjectStageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectStageMutation, UpdateProjectStageMutationVariables>;
export const PipedriveDataDocument = gql`
    query PipedriveData {
  getPipedriveStages {
    pipedrive_stage_id
    name
  }
  projectStages {
    ...ProjectStage
  }
}
    ${ProjectStageFragmentDoc}`;

/**
 * __usePipedriveDataQuery__
 *
 * To run a query within a React component, call `usePipedriveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipedriveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipedriveDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePipedriveDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PipedriveDataQuery, PipedriveDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PipedriveDataQuery, PipedriveDataQueryVariables>(PipedriveDataDocument, options);
      }
export function usePipedriveDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PipedriveDataQuery, PipedriveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PipedriveDataQuery, PipedriveDataQueryVariables>(PipedriveDataDocument, options);
        }
export function usePipedriveDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PipedriveDataQuery, PipedriveDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PipedriveDataQuery, PipedriveDataQueryVariables>(PipedriveDataDocument, options);
        }
export type PipedriveDataQueryHookResult = ReturnType<typeof usePipedriveDataQuery>;
export type PipedriveDataLazyQueryHookResult = ReturnType<typeof usePipedriveDataLazyQuery>;
export type PipedriveDataSuspenseQueryHookResult = ReturnType<typeof usePipedriveDataSuspenseQuery>;
export type PipedriveDataQueryResult = ApolloReactCommon.QueryResult<PipedriveDataQuery, PipedriveDataQueryVariables>;
export const QuoteEmailDataDocument = gql`
    query QuoteEmailData($quoteId: ID!) {
  GetQuoteEmailData(id: $quoteId) {
    primary_recipient
    recipients
    subject
    content
    attachments {
      name
      link
    }
  }
}
    `;

/**
 * __useQuoteEmailDataQuery__
 *
 * To run a query within a React component, call `useQuoteEmailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteEmailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteEmailDataQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteEmailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuoteEmailDataQuery, QuoteEmailDataQueryVariables> & ({ variables: QuoteEmailDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>(QuoteEmailDataDocument, options);
      }
export function useQuoteEmailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>(QuoteEmailDataDocument, options);
        }
export function useQuoteEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>(QuoteEmailDataDocument, options);
        }
export type QuoteEmailDataQueryHookResult = ReturnType<typeof useQuoteEmailDataQuery>;
export type QuoteEmailDataLazyQueryHookResult = ReturnType<typeof useQuoteEmailDataLazyQuery>;
export type QuoteEmailDataSuspenseQueryHookResult = ReturnType<typeof useQuoteEmailDataSuspenseQuery>;
export type QuoteEmailDataQueryResult = ApolloReactCommon.QueryResult<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>;
export const StarDocument = gql`
    mutation Star($starable_id: ID!, $starable_type: StarsStarableTypeEnum!) {
  star(starable_id: $starable_id, starable_type: $starable_type) {
    ...Star
  }
}
    ${StarFragmentDoc}`;
export type StarMutationFn = ApolloReactCommon.MutationFunction<StarMutation, StarMutationVariables>;

/**
 * __useStarMutation__
 *
 * To run a mutation, you first call `useStarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starMutation, { data, loading, error }] = useStarMutation({
 *   variables: {
 *      starable_id: // value for 'starable_id'
 *      starable_type: // value for 'starable_type'
 *   },
 * });
 */
export function useStarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarMutation, StarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarMutation, StarMutationVariables>(StarDocument, options);
      }
export type StarMutationHookResult = ReturnType<typeof useStarMutation>;
export type StarMutationResult = ApolloReactCommon.MutationResult<StarMutation>;
export type StarMutationOptions = ApolloReactCommon.BaseMutationOptions<StarMutation, StarMutationVariables>;
export const UnstarDocument = gql`
    mutation Unstar($starable_id: ID!, $starable_type: StarsStarableTypeEnum!) {
  unstar(starable_id: $starable_id, starable_type: $starable_type)
}
    `;
export type UnstarMutationFn = ApolloReactCommon.MutationFunction<UnstarMutation, UnstarMutationVariables>;

/**
 * __useUnstarMutation__
 *
 * To run a mutation, you first call `useUnstarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarMutation, { data, loading, error }] = useUnstarMutation({
 *   variables: {
 *      starable_id: // value for 'starable_id'
 *      starable_type: // value for 'starable_type'
 *   },
 * });
 */
export function useUnstarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarMutation, UnstarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarMutation, UnstarMutationVariables>(UnstarDocument, options);
      }
export type UnstarMutationHookResult = ReturnType<typeof useUnstarMutation>;
export type UnstarMutationResult = ApolloReactCommon.MutationResult<UnstarMutation>;
export type UnstarMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarMutation, UnstarMutationVariables>;
export const BulkStarDocument = gql`
    mutation BulkStar($starable_ids: [ID!]!, $starable_type: StarsStarableTypeEnum!) {
  bulkStar(starable_ids: $starable_ids, starable_type: $starable_type) {
    total
    failed
  }
}
    `;
export type BulkStarMutationFn = ApolloReactCommon.MutationFunction<BulkStarMutation, BulkStarMutationVariables>;

/**
 * __useBulkStarMutation__
 *
 * To run a mutation, you first call `useBulkStarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStarMutation, { data, loading, error }] = useBulkStarMutation({
 *   variables: {
 *      starable_ids: // value for 'starable_ids'
 *      starable_type: // value for 'starable_type'
 *   },
 * });
 */
export function useBulkStarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkStarMutation, BulkStarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkStarMutation, BulkStarMutationVariables>(BulkStarDocument, options);
      }
export type BulkStarMutationHookResult = ReturnType<typeof useBulkStarMutation>;
export type BulkStarMutationResult = ApolloReactCommon.MutationResult<BulkStarMutation>;
export type BulkStarMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkStarMutation, BulkStarMutationVariables>;
export const BulkUnstarDocument = gql`
    mutation BulkUnstar($starable_ids: [ID!]!, $starable_type: StarsStarableTypeEnum!) {
  bulkUnstar(starable_ids: $starable_ids, starable_type: $starable_type) {
    total
    failed
  }
}
    `;
export type BulkUnstarMutationFn = ApolloReactCommon.MutationFunction<BulkUnstarMutation, BulkUnstarMutationVariables>;

/**
 * __useBulkUnstarMutation__
 *
 * To run a mutation, you first call `useBulkUnstarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnstarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnstarMutation, { data, loading, error }] = useBulkUnstarMutation({
 *   variables: {
 *      starable_ids: // value for 'starable_ids'
 *      starable_type: // value for 'starable_type'
 *   },
 * });
 */
export function useBulkUnstarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUnstarMutation, BulkUnstarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUnstarMutation, BulkUnstarMutationVariables>(BulkUnstarDocument, options);
      }
export type BulkUnstarMutationHookResult = ReturnType<typeof useBulkUnstarMutation>;
export type BulkUnstarMutationResult = ApolloReactCommon.MutationResult<BulkUnstarMutation>;
export type BulkUnstarMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUnstarMutation, BulkUnstarMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($title: String!) {
  createTag(title: $title) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type CreateTagMutationFn = ApolloReactCommon.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = ApolloReactCommon.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: ID!, $title: String!) {
  updateTag(id: $id, title: $title) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type UpdateTagMutationFn = ApolloReactCommon.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = ApolloReactCommon.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteTag(id: $id)
}
    `;
export type DeleteTagMutationFn = ApolloReactCommon.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = ApolloReactCommon.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  getTags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = ApolloReactCommon.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const AllocationItemsSelectOptionsDocument = gql`
    query AllocationItemsSelectOptions($user_id: ID!, $date: Date!, $task_id: ID) {
  capacityAllocationItemList(user_id: $user_id, date: $date, task_id: $task_id) {
    id
    capacityAllocation {
      task {
        name
      }
    }
    from_time
    to_time
    total_time
    note
  }
}
    `;

/**
 * __useAllocationItemsSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAllocationItemsSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocationItemsSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationItemsSelectOptionsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      date: // value for 'date'
 *      task_id: // value for 'task_id'
 *   },
 * });
 */
export function useAllocationItemsSelectOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables> & ({ variables: AllocationItemsSelectOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>(AllocationItemsSelectOptionsDocument, options);
      }
export function useAllocationItemsSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>(AllocationItemsSelectOptionsDocument, options);
        }
export function useAllocationItemsSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>(AllocationItemsSelectOptionsDocument, options);
        }
export type AllocationItemsSelectOptionsQueryHookResult = ReturnType<typeof useAllocationItemsSelectOptionsQuery>;
export type AllocationItemsSelectOptionsLazyQueryHookResult = ReturnType<typeof useAllocationItemsSelectOptionsLazyQuery>;
export type AllocationItemsSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useAllocationItemsSelectOptionsSuspenseQuery>;
export type AllocationItemsSelectOptionsQueryResult = ApolloReactCommon.QueryResult<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>;
export const CapacityAllocationUserItemDetailDocument = gql`
    query CapacityAllocationUserItemDetail($id: ID!, $today: Date!) {
  capacityAllocationItemDetailQuery(id: $id) {
    id
    completed
    seriesSummary(today: $today) {
      any_duration_changed
      future_open_total_time
      same_day_open_count
      same_day_open_total_time
      futureCompletedPerUser {
        user_id
        count
      }
    }
    user {
      id
      full_name
      profile {
        hex_color
      }
    }
    time_tracking_work_type_id
    duration_changed
    userStats {
      capacity_allocation_item_id
      tracked_time_for_item
      has_running_timer
    }
    ...CapacityAllocationItem
    teams {
      team {
        id
        name
      }
    }
    userItems {
      id
      time_tracking_work_type_id
      user {
        id
        full_name
      }
    }
    capacityAllocation {
      id
      deadline
      deadline_time
      location
      created_at
      create_task_positions
      from_time
      to_time
      total_time
      from_date
      to_date
      total_time_per_day
      note
      title
      repetition
      deleted_items
      repetition_settings {
        include_holidays
        days
        every
        startType
        toType
        end
      }
      task {
        id
        name
        billable
        status {
          id
          name
          background_color
          foreground_color
        }
        ourWorkBudgetItem {
          id
          title
          category {
            name
          }
          project {
            id
            title
            code
          }
        }
      }
      createdBy {
        id
      }
      calendarParticipants {
        id
        email
        display_name
      }
    }
    stats {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    ${CapacityAllocationItemFragmentDoc}`;

/**
 * __useCapacityAllocationUserItemDetailQuery__
 *
 * To run a query within a React component, call `useCapacityAllocationUserItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityAllocationUserItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityAllocationUserItemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      today: // value for 'today'
 *   },
 * });
 */
export function useCapacityAllocationUserItemDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables> & ({ variables: CapacityAllocationUserItemDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>(CapacityAllocationUserItemDetailDocument, options);
      }
export function useCapacityAllocationUserItemDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>(CapacityAllocationUserItemDetailDocument, options);
        }
export function useCapacityAllocationUserItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>(CapacityAllocationUserItemDetailDocument, options);
        }
export type CapacityAllocationUserItemDetailQueryHookResult = ReturnType<typeof useCapacityAllocationUserItemDetailQuery>;
export type CapacityAllocationUserItemDetailLazyQueryHookResult = ReturnType<typeof useCapacityAllocationUserItemDetailLazyQuery>;
export type CapacityAllocationUserItemDetailSuspenseQueryHookResult = ReturnType<typeof useCapacityAllocationUserItemDetailSuspenseQuery>;
export type CapacityAllocationUserItemDetailQueryResult = ApolloReactCommon.QueryResult<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>;
export const BrandSelectOptionsDocument = gql`
    query BrandSelectOptions {
  brandsSimpleMap {
    name
    id
  }
}
    `;

/**
 * __useBrandSelectOptionsQuery__
 *
 * To run a query within a React component, call `useBrandSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>(BrandSelectOptionsDocument, options);
      }
export function useBrandSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>(BrandSelectOptionsDocument, options);
        }
export function useBrandSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>(BrandSelectOptionsDocument, options);
        }
export type BrandSelectOptionsQueryHookResult = ReturnType<typeof useBrandSelectOptionsQuery>;
export type BrandSelectOptionsLazyQueryHookResult = ReturnType<typeof useBrandSelectOptionsLazyQuery>;
export type BrandSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useBrandSelectOptionsSuspenseQuery>;
export type BrandSelectOptionsQueryResult = ApolloReactCommon.QueryResult<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>;
export const CompleteCapacityAllocationItemDocument = gql`
    mutation CompleteCapacityAllocationItem($input: CompleteCapacityAllocationUserInput!) {
  completeCapacityAllocationItem(input: $input) {
    id
    user {
      id
    }
    completed
  }
}
    `;
export type CompleteCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<CompleteCapacityAllocationItemMutation, CompleteCapacityAllocationItemMutationVariables>;

/**
 * __useCompleteCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useCompleteCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCapacityAllocationItemMutation, { data, loading, error }] = useCompleteCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteCapacityAllocationItemMutation, CompleteCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteCapacityAllocationItemMutation, CompleteCapacityAllocationItemMutationVariables>(CompleteCapacityAllocationItemDocument, options);
      }
export type CompleteCapacityAllocationItemMutationHookResult = ReturnType<typeof useCompleteCapacityAllocationItemMutation>;
export type CompleteCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<CompleteCapacityAllocationItemMutation>;
export type CompleteCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteCapacityAllocationItemMutation, CompleteCapacityAllocationItemMutationVariables>;
export const ReopenCapacityAllocationItemDocument = gql`
    mutation ReopenCapacityAllocationItem($input: ReopenCapacityAllocationItemInput!) {
  reopenCapacityAllocationItem(input: $input) {
    id
    user {
      id
    }
    completed
  }
}
    `;
export type ReopenCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<ReopenCapacityAllocationItemMutation, ReopenCapacityAllocationItemMutationVariables>;

/**
 * __useReopenCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useReopenCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenCapacityAllocationItemMutation, { data, loading, error }] = useReopenCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenCapacityAllocationItemMutation, ReopenCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenCapacityAllocationItemMutation, ReopenCapacityAllocationItemMutationVariables>(ReopenCapacityAllocationItemDocument, options);
      }
export type ReopenCapacityAllocationItemMutationHookResult = ReturnType<typeof useReopenCapacityAllocationItemMutation>;
export type ReopenCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<ReopenCapacityAllocationItemMutation>;
export type ReopenCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenCapacityAllocationItemMutation, ReopenCapacityAllocationItemMutationVariables>;
export const DeleteCapacityAllocationDocument = gql`
    mutation DeleteCapacityAllocation($input: DeleteCapacityAllocationInput!) {
  deleteCapacityAllocation(input: $input) {
    id
  }
}
    `;
export type DeleteCapacityAllocationMutationFn = ApolloReactCommon.MutationFunction<DeleteCapacityAllocationMutation, DeleteCapacityAllocationMutationVariables>;

/**
 * __useDeleteCapacityAllocationMutation__
 *
 * To run a mutation, you first call `useDeleteCapacityAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCapacityAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCapacityAllocationMutation, { data, loading, error }] = useDeleteCapacityAllocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCapacityAllocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCapacityAllocationMutation, DeleteCapacityAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCapacityAllocationMutation, DeleteCapacityAllocationMutationVariables>(DeleteCapacityAllocationDocument, options);
      }
export type DeleteCapacityAllocationMutationHookResult = ReturnType<typeof useDeleteCapacityAllocationMutation>;
export type DeleteCapacityAllocationMutationResult = ApolloReactCommon.MutationResult<DeleteCapacityAllocationMutation>;
export type DeleteCapacityAllocationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCapacityAllocationMutation, DeleteCapacityAllocationMutationVariables>;
export const DeleteCapacityAllocationItemDocument = gql`
    mutation DeleteCapacityAllocationItem($input: DeleteCapacityAllocationItemInput!) {
  deleteCapacityAllocationItem(input: $input) {
    id
  }
}
    `;
export type DeleteCapacityAllocationItemMutationFn = ApolloReactCommon.MutationFunction<DeleteCapacityAllocationItemMutation, DeleteCapacityAllocationItemMutationVariables>;

/**
 * __useDeleteCapacityAllocationItemMutation__
 *
 * To run a mutation, you first call `useDeleteCapacityAllocationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCapacityAllocationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCapacityAllocationItemMutation, { data, loading, error }] = useDeleteCapacityAllocationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCapacityAllocationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCapacityAllocationItemMutation, DeleteCapacityAllocationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCapacityAllocationItemMutation, DeleteCapacityAllocationItemMutationVariables>(DeleteCapacityAllocationItemDocument, options);
      }
export type DeleteCapacityAllocationItemMutationHookResult = ReturnType<typeof useDeleteCapacityAllocationItemMutation>;
export type DeleteCapacityAllocationItemMutationResult = ApolloReactCommon.MutationResult<DeleteCapacityAllocationItemMutation>;
export type DeleteCapacityAllocationItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCapacityAllocationItemMutation, DeleteCapacityAllocationItemMutationVariables>;
export const DeleteCapacityAllocationForDayDocument = gql`
    mutation DeleteCapacityAllocationForDay($input: DeleteCapacityAllocationForDayInput!) {
  deleteCapacityAllocationForDay(input: $input) {
    id
  }
}
    `;
export type DeleteCapacityAllocationForDayMutationFn = ApolloReactCommon.MutationFunction<DeleteCapacityAllocationForDayMutation, DeleteCapacityAllocationForDayMutationVariables>;

/**
 * __useDeleteCapacityAllocationForDayMutation__
 *
 * To run a mutation, you first call `useDeleteCapacityAllocationForDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCapacityAllocationForDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCapacityAllocationForDayMutation, { data, loading, error }] = useDeleteCapacityAllocationForDayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCapacityAllocationForDayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCapacityAllocationForDayMutation, DeleteCapacityAllocationForDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCapacityAllocationForDayMutation, DeleteCapacityAllocationForDayMutationVariables>(DeleteCapacityAllocationForDayDocument, options);
      }
export type DeleteCapacityAllocationForDayMutationHookResult = ReturnType<typeof useDeleteCapacityAllocationForDayMutation>;
export type DeleteCapacityAllocationForDayMutationResult = ApolloReactCommon.MutationResult<DeleteCapacityAllocationForDayMutation>;
export type DeleteCapacityAllocationForDayMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCapacityAllocationForDayMutation, DeleteCapacityAllocationForDayMutationVariables>;
export const DuplicateProjectDocument = gql`
    mutation DuplicateProject($id: ID!, $with_tasks: Boolean!, $with_task_attachments: Boolean!) {
  duplicateProject(
    id: $id
    with_tasks: $with_tasks
    with_task_attachments: $with_task_attachments
  ) {
    id
  }
}
    `;
export type DuplicateProjectMutationFn = ApolloReactCommon.MutationFunction<DuplicateProjectMutation, DuplicateProjectMutationVariables>;

/**
 * __useDuplicateProjectMutation__
 *
 * To run a mutation, you first call `useDuplicateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProjectMutation, { data, loading, error }] = useDuplicateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      with_tasks: // value for 'with_tasks'
 *      with_task_attachments: // value for 'with_task_attachments'
 *   },
 * });
 */
export function useDuplicateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateProjectMutation, DuplicateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateProjectMutation, DuplicateProjectMutationVariables>(DuplicateProjectDocument, options);
      }
export type DuplicateProjectMutationHookResult = ReturnType<typeof useDuplicateProjectMutation>;
export type DuplicateProjectMutationResult = ApolloReactCommon.MutationResult<DuplicateProjectMutation>;
export type DuplicateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateProjectMutation, DuplicateProjectMutationVariables>;
export const GetWorkTypeOptionsDocument = gql`
    query GetWorkTypeOptions($taskId: ID!) {
  task(id: $taskId) {
    ourWorkBudgetItem {
      project {
        availableTimeTrackingWorkTypes {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkTypeOptionsQuery__
 *
 * To run a query within a React component, call `useGetWorkTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkTypeOptionsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetWorkTypeOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables> & ({ variables: GetWorkTypeOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>(GetWorkTypeOptionsDocument, options);
      }
export function useGetWorkTypeOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>(GetWorkTypeOptionsDocument, options);
        }
export function useGetWorkTypeOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>(GetWorkTypeOptionsDocument, options);
        }
export type GetWorkTypeOptionsQueryHookResult = ReturnType<typeof useGetWorkTypeOptionsQuery>;
export type GetWorkTypeOptionsLazyQueryHookResult = ReturnType<typeof useGetWorkTypeOptionsLazyQuery>;
export type GetWorkTypeOptionsSuspenseQueryHookResult = ReturnType<typeof useGetWorkTypeOptionsSuspenseQuery>;
export type GetWorkTypeOptionsQueryResult = ApolloReactCommon.QueryResult<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>;
export const UpdatePlanningSettingsDocument = gql`
    mutation UpdatePlanningSettings($input: UpdatePlanningSettings!) {
  updatePlanningSettings(input: $input) {
    ...WorkspaceSettings
  }
}
    ${WorkspaceSettingsFragmentDoc}`;
export type UpdatePlanningSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdatePlanningSettingsMutation, UpdatePlanningSettingsMutationVariables>;

/**
 * __useUpdatePlanningSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePlanningSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanningSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanningSettingsMutation, { data, loading, error }] = useUpdatePlanningSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanningSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePlanningSettingsMutation, UpdatePlanningSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlanningSettingsMutation, UpdatePlanningSettingsMutationVariables>(UpdatePlanningSettingsDocument, options);
      }
export type UpdatePlanningSettingsMutationHookResult = ReturnType<typeof useUpdatePlanningSettingsMutation>;
export type UpdatePlanningSettingsMutationResult = ApolloReactCommon.MutationResult<UpdatePlanningSettingsMutation>;
export type UpdatePlanningSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePlanningSettingsMutation, UpdatePlanningSettingsMutationVariables>;
export const PositionSelectOptionsDocument = gql`
    query PositionSelectOptions {
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
}
    `;

/**
 * __usePositionSelectOptionsQuery__
 *
 * To run a query within a React component, call `usePositionSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePositionSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>(PositionSelectOptionsDocument, options);
      }
export function usePositionSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>(PositionSelectOptionsDocument, options);
        }
export function usePositionSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>(PositionSelectOptionsDocument, options);
        }
export type PositionSelectOptionsQueryHookResult = ReturnType<typeof usePositionSelectOptionsQuery>;
export type PositionSelectOptionsLazyQueryHookResult = ReturnType<typeof usePositionSelectOptionsLazyQuery>;
export type PositionSelectOptionsSuspenseQueryHookResult = ReturnType<typeof usePositionSelectOptionsSuspenseQuery>;
export type PositionSelectOptionsQueryResult = ApolloReactCommon.QueryResult<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>;
export const PositionsForProjectDocument = gql`
    query PositionsForProject($projectId: ID!) {
  projectForTask(id: $projectId) {
    id
    availableTimeTrackingWorkTypes {
      id
      title
    }
  }
}
    `;

/**
 * __usePositionsForProjectQuery__
 *
 * To run a query within a React component, call `usePositionsForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionsForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionsForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePositionsForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionsForProjectQuery, PositionsForProjectQueryVariables> & ({ variables: PositionsForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionsForProjectQuery, PositionsForProjectQueryVariables>(PositionsForProjectDocument, options);
      }
export function usePositionsForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionsForProjectQuery, PositionsForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionsForProjectQuery, PositionsForProjectQueryVariables>(PositionsForProjectDocument, options);
        }
export function usePositionsForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionsForProjectQuery, PositionsForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionsForProjectQuery, PositionsForProjectQueryVariables>(PositionsForProjectDocument, options);
        }
export type PositionsForProjectQueryHookResult = ReturnType<typeof usePositionsForProjectQuery>;
export type PositionsForProjectLazyQueryHookResult = ReturnType<typeof usePositionsForProjectLazyQuery>;
export type PositionsForProjectSuspenseQueryHookResult = ReturnType<typeof usePositionsForProjectSuspenseQuery>;
export type PositionsForProjectQueryResult = ApolloReactCommon.QueryResult<PositionsForProjectQuery, PositionsForProjectQueryVariables>;
export const ProjectManagersSelectOptionsDocument = gql`
    query ProjectManagersSelectOptions {
  projectManagerSimpleMap {
    id
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
    }
    full_name
    codename
  }
}
    `;

/**
 * __useProjectManagersSelectOptionsQuery__
 *
 * To run a query within a React component, call `useProjectManagersSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectManagersSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectManagersSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectManagersSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>(ProjectManagersSelectOptionsDocument, options);
      }
export function useProjectManagersSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>(ProjectManagersSelectOptionsDocument, options);
        }
export function useProjectManagersSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>(ProjectManagersSelectOptionsDocument, options);
        }
export type ProjectManagersSelectOptionsQueryHookResult = ReturnType<typeof useProjectManagersSelectOptionsQuery>;
export type ProjectManagersSelectOptionsLazyQueryHookResult = ReturnType<typeof useProjectManagersSelectOptionsLazyQuery>;
export type ProjectManagersSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectManagersSelectOptionsSuspenseQuery>;
export type ProjectManagersSelectOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>;
export const ProjectSelectOptionsDocument = gql`
    query projectSelectOptions($page: Int, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      brand {
        id
        name
      }
      archived_at
      finished_at
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useProjectSelectOptionsQuery__
 *
 * To run a query within a React component, call `useProjectSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSelectOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>(ProjectSelectOptionsDocument, options);
      }
export function useProjectSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>(ProjectSelectOptionsDocument, options);
        }
export function useProjectSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>(ProjectSelectOptionsDocument, options);
        }
export type ProjectSelectOptionsQueryHookResult = ReturnType<typeof useProjectSelectOptionsQuery>;
export type ProjectSelectOptionsLazyQueryHookResult = ReturnType<typeof useProjectSelectOptionsLazyQuery>;
export type ProjectSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useProjectSelectOptionsSuspenseQuery>;
export type ProjectSelectOptionsQueryResult = ApolloReactCommon.QueryResult<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>;
export const RoleSelectOptionsDocument = gql`
    query RoleSelectOptions {
  roles {
    id
    name
  }
}
    `;

/**
 * __useRoleSelectOptionsQuery__
 *
 * To run a query within a React component, call `useRoleSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>(RoleSelectOptionsDocument, options);
      }
export function useRoleSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>(RoleSelectOptionsDocument, options);
        }
export function useRoleSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>(RoleSelectOptionsDocument, options);
        }
export type RoleSelectOptionsQueryHookResult = ReturnType<typeof useRoleSelectOptionsQuery>;
export type RoleSelectOptionsLazyQueryHookResult = ReturnType<typeof useRoleSelectOptionsLazyQuery>;
export type RoleSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useRoleSelectOptionsSuspenseQuery>;
export type RoleSelectOptionsQueryResult = ApolloReactCommon.QueryResult<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>;
export const TaskSelectOptionsDocument = gql`
    query taskSelectOptions($page: Int, $first: Int, $filters: TaskQueryArgs) {
  tasks(page: $page, first: $first, filters: $filters) {
    data {
      id
      name
      billable
      status {
        name
        system_status
      }
      ourWorkBudgetItem {
        id
        title
        project {
          id
          code
          title
        }
        category {
          name
        }
        timeTrackingSettings {
          tracking_enabled_from
          tracking_enabled_to
          tracking_enabled
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useTaskSelectOptionsQuery__
 *
 * To run a query within a React component, call `useTaskSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskSelectOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTaskSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>(TaskSelectOptionsDocument, options);
      }
export function useTaskSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>(TaskSelectOptionsDocument, options);
        }
export function useTaskSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>(TaskSelectOptionsDocument, options);
        }
export type TaskSelectOptionsQueryHookResult = ReturnType<typeof useTaskSelectOptionsQuery>;
export type TaskSelectOptionsLazyQueryHookResult = ReturnType<typeof useTaskSelectOptionsLazyQuery>;
export type TaskSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useTaskSelectOptionsSuspenseQuery>;
export type TaskSelectOptionsQueryResult = ApolloReactCommon.QueryResult<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>;
export const TeamSelectOptionsDocument = gql`
    query TeamSelectOptions {
  teamSimpleMap {
    id
    name
  }
}
    `;

/**
 * __useTeamSelectOptionsQuery__
 *
 * To run a query within a React component, call `useTeamSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>(TeamSelectOptionsDocument, options);
      }
export function useTeamSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>(TeamSelectOptionsDocument, options);
        }
export function useTeamSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>(TeamSelectOptionsDocument, options);
        }
export type TeamSelectOptionsQueryHookResult = ReturnType<typeof useTeamSelectOptionsQuery>;
export type TeamSelectOptionsLazyQueryHookResult = ReturnType<typeof useTeamSelectOptionsLazyQuery>;
export type TeamSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useTeamSelectOptionsSuspenseQuery>;
export type TeamSelectOptionsQueryResult = ApolloReactCommon.QueryResult<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>;
export const TimeOffTypeOptionsDocument = gql`
    query TimeOffTypeOptions {
  timeOffTypesQuery {
    id
    name
  }
}
    `;

/**
 * __useTimeOffTypeOptionsQuery__
 *
 * To run a query within a React component, call `useTimeOffTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeOffTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeOffTypeOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>(TimeOffTypeOptionsDocument, options);
      }
export function useTimeOffTypeOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>(TimeOffTypeOptionsDocument, options);
        }
export function useTimeOffTypeOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>(TimeOffTypeOptionsDocument, options);
        }
export type TimeOffTypeOptionsQueryHookResult = ReturnType<typeof useTimeOffTypeOptionsQuery>;
export type TimeOffTypeOptionsLazyQueryHookResult = ReturnType<typeof useTimeOffTypeOptionsLazyQuery>;
export type TimeOffTypeOptionsSuspenseQueryHookResult = ReturnType<typeof useTimeOffTypeOptionsSuspenseQuery>;
export type TimeOffTypeOptionsQueryResult = ApolloReactCommon.QueryResult<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>;
export const UsersSelectOptionsDocument = gql`
    query UsersSelectOptions($onlyPlannable: Boolean, $where: UsersWhereConditions, $taskId: ID, $projectId: ID) {
  userSimpleMap(
    onlyPlannable: $onlyPlannable
    where: $where
    task_id: $taskId
    project_id: $projectId
  ) {
    id
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
    }
    full_name
    codename
  }
}
    `;

/**
 * __useUsersSelectOptionsQuery__
 *
 * To run a query within a React component, call `useUsersSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSelectOptionsQuery({
 *   variables: {
 *      onlyPlannable: // value for 'onlyPlannable'
 *      where: // value for 'where'
 *      taskId: // value for 'taskId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUsersSelectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>(UsersSelectOptionsDocument, options);
      }
export function useUsersSelectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>(UsersSelectOptionsDocument, options);
        }
export function useUsersSelectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>(UsersSelectOptionsDocument, options);
        }
export type UsersSelectOptionsQueryHookResult = ReturnType<typeof useUsersSelectOptionsQuery>;
export type UsersSelectOptionsLazyQueryHookResult = ReturnType<typeof useUsersSelectOptionsLazyQuery>;
export type UsersSelectOptionsSuspenseQueryHookResult = ReturnType<typeof useUsersSelectOptionsSuspenseQuery>;
export type UsersSelectOptionsQueryResult = ApolloReactCommon.QueryResult<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>;
export const BudgetItemsForProjectDocument = gql`
    query BudgetItemsForProject($projectId: ID!) {
  project(id: $projectId) {
    id
    ourWorkStructured {
      budgetItems {
        id
        title
        category {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBudgetItemsForProjectQuery__
 *
 * To run a query within a React component, call `useBudgetItemsForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetItemsForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetItemsForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useBudgetItemsForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables> & ({ variables: BudgetItemsForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>(BudgetItemsForProjectDocument, options);
      }
export function useBudgetItemsForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>(BudgetItemsForProjectDocument, options);
        }
export function useBudgetItemsForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>(BudgetItemsForProjectDocument, options);
        }
export type BudgetItemsForProjectQueryHookResult = ReturnType<typeof useBudgetItemsForProjectQuery>;
export type BudgetItemsForProjectLazyQueryHookResult = ReturnType<typeof useBudgetItemsForProjectLazyQuery>;
export type BudgetItemsForProjectSuspenseQueryHookResult = ReturnType<typeof useBudgetItemsForProjectSuspenseQuery>;
export type BudgetItemsForProjectQueryResult = ApolloReactCommon.QueryResult<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>;